/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT
// Regenerate the file by running 'yarn compile:ajv'
'use strict';
import { fullFormats } from 'ajv-formats/dist/formats';
const formatWrapper = { ...fullFormats };
function ucs2length(str) {
    const len = str.length;
    let length = 0;
    let pos = 0;
    let value;
    while (pos < len) {
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xd800 && value <= 0xdbff && pos < len) {
            value = str.charCodeAt(pos);
            if ((value & 0xfc00) === 0xdc00)
                pos++;
        }
    }
    return length;
}
function ajvEqual(a, b) {
    if (a === b)
        return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor)
            return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length)
                return false;
            for (i = length; i-- !== 0;)
                if (!ajvEqual(a[i], b[i]))
                    return false;
            return true;
        }
        if (a.constructor === RegExp)
            return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf)
            return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString)
            return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length)
            return false;
        for (i = length; i-- !== 0;)
            if (!Object.prototype.hasOwnProperty.call(b, keys[i]))
                return false;
        for (i = length; i-- !== 0;) {
            var key = keys[i];
            if (!ajvEqual(a[key], b[key]))
                return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function padString(input) {
    var segmentLength = 4;
    var stringLength = input.length;
    var diff = stringLength % segmentLength;
    if (!diff) {
        return input;
    }
    var position = stringLength;
    var padLength = segmentLength - diff;
    var paddedStringLength = stringLength + padLength;
    var buffer = Buffer.alloc(paddedStringLength);
    buffer.write(input);
    while (padLength--) {
        buffer.write('=', position++);
    }
    return buffer.toString();
}
function toBase64(base64url) {
    base64url = base64url.toString();
    return padString(base64url).replace(/\-/g, '+').replace(/_/g, '/');
}
function base64urlToBuffer(base64url) {
    return Buffer.from(toBase64(base64url), 'base64');
}
function fromBase64(base64) {
    return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function base64urlEncode(input, encoding) {
    if (encoding === void 0) {
        encoding = 'utf8';
    }
    if (Buffer.isBuffer(input)) {
        return fromBase64(input.toString('base64'));
    }
    return fromBase64(Buffer.from(input, encoding).toString('base64'));
}
export const aggregateColumnSchemaValidation = validate12;
const schema29 = {
    $id: 'urn:wisepipe-base-pipe:AggregateColumn',
    type: 'object',
    properties: {
        column: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string' }] },
        operation: {
            oneOf: [
                { $ref: 'urn:wisepipe-base-pipe:EnumToolVariable' },
                {
                    type: 'string',
                    enum: ['MAX', 'MIN', 'COUNT', 'SUM', 'AVG', 'OR', 'AND', 'MEDIAN', 'DIFF', 'PCT', 'SHIFT', 'STDEV']
                }
            ]
        },
        alias: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:StringToolVariable' }, { type: 'string' }] }
    },
    required: ['operation', 'alias'],
    if: { not: { properties: { operation: { const: 'COUNT' } } } },
    then: { required: ['column'] }
};
const schema30 = { $id: 'urn:wisepipe-base-pipe:ColumnToolVariable', type: 'object', properties: {} };
const schema31 = {
    $id: 'urn:wisepipe-base-pipe:EnumToolVariable',
    type: 'object',
    properties: {
        toolEnumType: {
            type: 'string',
            enum: [
                'SortDirection',
                'AggregateColumnOperation',
                'DateFrequency',
                'DateAddType',
                'DateAddUnit',
                'DateUnitType',
                'DatePartType',
                'JoinOperator',
                'JoinPattern',
                'FilterStatementOp',
                'ColumnType',
                'PeriodAddType'
            ]
        }
    }
};
const schema32 = { $id: 'urn:wisepipe-base-pipe:StringToolVariable', type: 'object', properties: {} };
function validate12(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:AggregateColumn" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    const _errs3 = errors;
    const _errs4 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.operation !== undefined) {
            if ('COUNT' !== data.operation) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var valid1 = _errs4 === errors;
    if (valid1) {
        const err1 = {};
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    else {
        errors = _errs3;
        if (vErrors !== null) {
            if (_errs3) {
                vErrors.length = _errs3;
            }
            else {
                vErrors = null;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs6 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.column === undefined && (missing0 = 'column')) {
                validate12.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs6 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err2 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err2];
        }
        else {
            vErrors.push(err2);
        }
        errors++;
        validate12.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.operation === undefined && (missing1 = 'operation')) ||
                (data.alias === undefined && (missing1 = 'alias'))) {
                validate12.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.column !== undefined) {
                    let data1 = data.column;
                    const _errs7 = errors;
                    const _errs8 = errors;
                    let valid4 = false;
                    let passing0 = null;
                    const _errs9 = errors;
                    const _errs10 = errors;
                    if (errors === _errs10) {
                        if (!(data1 && typeof data1 == 'object' && !Array.isArray(data1))) {
                            const err3 = {
                                instancePath: instancePath + '/column',
                                schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            };
                            if (vErrors === null) {
                                vErrors = [err3];
                            }
                            else {
                                vErrors.push(err3);
                            }
                            errors++;
                        }
                    }
                    var _valid1 = _errs9 === errors;
                    if (_valid1) {
                        valid4 = true;
                        passing0 = 0;
                    }
                    const _errs12 = errors;
                    if (typeof data1 !== 'string') {
                        const err4 = {
                            instancePath: instancePath + '/column',
                            schemaPath: '#/properties/column/oneOf/1/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string'
                        };
                        if (vErrors === null) {
                            vErrors = [err4];
                        }
                        else {
                            vErrors.push(err4);
                        }
                        errors++;
                    }
                    var _valid1 = _errs12 === errors;
                    if (_valid1 && valid4) {
                        valid4 = false;
                        passing0 = [passing0, 1];
                    }
                    else {
                        if (_valid1) {
                            valid4 = true;
                            passing0 = 1;
                        }
                    }
                    if (!valid4) {
                        const err5 = {
                            instancePath: instancePath + '/column',
                            schemaPath: '#/properties/column/oneOf',
                            keyword: 'oneOf',
                            params: { passingSchemas: passing0 },
                            message: 'must match exactly one schema in oneOf'
                        };
                        if (vErrors === null) {
                            vErrors = [err5];
                        }
                        else {
                            vErrors.push(err5);
                        }
                        errors++;
                        validate12.errors = vErrors;
                        return false;
                    }
                    else {
                        errors = _errs8;
                        if (vErrors !== null) {
                            if (_errs8) {
                                vErrors.length = _errs8;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                    }
                    var valid3 = _errs7 === errors;
                }
                else {
                    var valid3 = true;
                }
                if (valid3) {
                    if (data.operation !== undefined) {
                        let data2 = data.operation;
                        const _errs14 = errors;
                        const _errs15 = errors;
                        let valid6 = false;
                        let passing1 = null;
                        const _errs16 = errors;
                        const _errs17 = errors;
                        if (errors === _errs17) {
                            if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                if (data2.toolEnumType !== undefined) {
                                    let data3 = data2.toolEnumType;
                                    if (typeof data3 !== 'string') {
                                        const err6 = {
                                            instancePath: instancePath + '/operation/toolEnumType',
                                            schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err6];
                                        }
                                        else {
                                            vErrors.push(err6);
                                        }
                                        errors++;
                                    }
                                    if (!(data3 === 'SortDirection' ||
                                        data3 === 'AggregateColumnOperation' ||
                                        data3 === 'DateFrequency' ||
                                        data3 === 'DateAddType' ||
                                        data3 === 'DateAddUnit' ||
                                        data3 === 'DateUnitType' ||
                                        data3 === 'DatePartType' ||
                                        data3 === 'JoinOperator' ||
                                        data3 === 'JoinPattern' ||
                                        data3 === 'FilterStatementOp' ||
                                        data3 === 'ColumnType' ||
                                        data3 === 'PeriodAddType')) {
                                        const err7 = {
                                            instancePath: instancePath + '/operation/toolEnumType',
                                            schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema31.properties.toolEnumType.enum },
                                            message: 'must be equal to one of the allowed values'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err7];
                                        }
                                        else {
                                            vErrors.push(err7);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            else {
                                const err8 = {
                                    instancePath: instancePath + '/operation',
                                    schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                };
                                if (vErrors === null) {
                                    vErrors = [err8];
                                }
                                else {
                                    vErrors.push(err8);
                                }
                                errors++;
                            }
                        }
                        var _valid2 = _errs16 === errors;
                        if (_valid2) {
                            valid6 = true;
                            passing1 = 0;
                        }
                        const _errs21 = errors;
                        if (typeof data2 !== 'string') {
                            const err9 = {
                                instancePath: instancePath + '/operation',
                                schemaPath: '#/properties/operation/oneOf/1/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            };
                            if (vErrors === null) {
                                vErrors = [err9];
                            }
                            else {
                                vErrors.push(err9);
                            }
                            errors++;
                        }
                        if (!(data2 === 'MAX' ||
                            data2 === 'MIN' ||
                            data2 === 'COUNT' ||
                            data2 === 'SUM' ||
                            data2 === 'AVG' ||
                            data2 === 'OR' ||
                            data2 === 'AND' ||
                            data2 === 'MEDIAN' ||
                            data2 === 'DIFF' ||
                            data2 === 'PCT' ||
                            data2 === 'SHIFT' ||
                            data2 === 'STDEV')) {
                            const err10 = {
                                instancePath: instancePath + '/operation',
                                schemaPath: '#/properties/operation/oneOf/1/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema29.properties.operation.oneOf[1].enum },
                                message: 'must be equal to one of the allowed values'
                            };
                            if (vErrors === null) {
                                vErrors = [err10];
                            }
                            else {
                                vErrors.push(err10);
                            }
                            errors++;
                        }
                        var _valid2 = _errs21 === errors;
                        if (_valid2 && valid6) {
                            valid6 = false;
                            passing1 = [passing1, 1];
                        }
                        else {
                            if (_valid2) {
                                valid6 = true;
                                passing1 = 1;
                            }
                        }
                        if (!valid6) {
                            const err11 = {
                                instancePath: instancePath + '/operation',
                                schemaPath: '#/properties/operation/oneOf',
                                keyword: 'oneOf',
                                params: { passingSchemas: passing1 },
                                message: 'must match exactly one schema in oneOf'
                            };
                            if (vErrors === null) {
                                vErrors = [err11];
                            }
                            else {
                                vErrors.push(err11);
                            }
                            errors++;
                            validate12.errors = vErrors;
                            return false;
                        }
                        else {
                            errors = _errs15;
                            if (vErrors !== null) {
                                if (_errs15) {
                                    vErrors.length = _errs15;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                        }
                        var valid3 = _errs14 === errors;
                    }
                    else {
                        var valid3 = true;
                    }
                    if (valid3) {
                        if (data.alias !== undefined) {
                            let data4 = data.alias;
                            const _errs23 = errors;
                            const _errs24 = errors;
                            let valid9 = false;
                            let passing2 = null;
                            const _errs25 = errors;
                            const _errs26 = errors;
                            if (errors === _errs26) {
                                if (!(data4 && typeof data4 == 'object' && !Array.isArray(data4))) {
                                    const err12 = {
                                        instancePath: instancePath + '/alias',
                                        schemaPath: 'urn:wisepipe-base-pipe:StringToolVariable/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err12];
                                    }
                                    else {
                                        vErrors.push(err12);
                                    }
                                    errors++;
                                }
                            }
                            var _valid3 = _errs25 === errors;
                            if (_valid3) {
                                valid9 = true;
                                passing2 = 0;
                            }
                            const _errs28 = errors;
                            if (typeof data4 !== 'string') {
                                const err13 = {
                                    instancePath: instancePath + '/alias',
                                    schemaPath: '#/properties/alias/oneOf/1/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                };
                                if (vErrors === null) {
                                    vErrors = [err13];
                                }
                                else {
                                    vErrors.push(err13);
                                }
                                errors++;
                            }
                            var _valid3 = _errs28 === errors;
                            if (_valid3 && valid9) {
                                valid9 = false;
                                passing2 = [passing2, 1];
                            }
                            else {
                                if (_valid3) {
                                    valid9 = true;
                                    passing2 = 1;
                                }
                            }
                            if (!valid9) {
                                const err14 = {
                                    instancePath: instancePath + '/alias',
                                    schemaPath: '#/properties/alias/oneOf',
                                    keyword: 'oneOf',
                                    params: { passingSchemas: passing2 },
                                    message: 'must match exactly one schema in oneOf'
                                };
                                if (vErrors === null) {
                                    vErrors = [err14];
                                }
                                else {
                                    vErrors.push(err14);
                                }
                                errors++;
                                validate12.errors = vErrors;
                                return false;
                            }
                            else {
                                errors = _errs24;
                                if (vErrors !== null) {
                                    if (_errs24) {
                                        vErrors.length = _errs24;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                            }
                            var valid3 = _errs23 === errors;
                        }
                        else {
                            var valid3 = true;
                        }
                    }
                }
            }
        }
        else {
            validate12.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate12.errors = vErrors;
    return errors === 0;
}
export const barChartDataSchemaValidation = validate13;
const schema33 = {
    $id: 'urn:wisepipe-common-computation:BarChartData',
    type: 'object',
    properties: {
        xAxisColumn: { type: 'string' },
        barValues: { type: 'array', items: { $ref: 'urn:wisepipe-common-computation:ValueCountPair' } }
    },
    required: ['xAxisColumn', 'barValues']
};
const schema34 = {
    $id: 'urn:wisepipe-common-computation:ValueCountPair',
    type: 'object',
    properties: { value: { oneOf: [{ type: 'string' }, { type: 'boolean' }] }, count: { type: 'number' } },
    required: ['value', 'count']
};
function validate13(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:BarChartData" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.xAxisColumn === undefined && (missing0 = 'xAxisColumn')) ||
                (data.barValues === undefined && (missing0 = 'barValues'))) {
                validate13.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.xAxisColumn !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.xAxisColumn !== 'string') {
                        validate13.errors = [
                            {
                                instancePath: instancePath + '/xAxisColumn',
                                schemaPath: '#/properties/xAxisColumn/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.barValues !== undefined) {
                        let data1 = data.barValues;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                var valid1 = true;
                                const len0 = data1.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data2 = data1[i0];
                                    const _errs5 = errors;
                                    const _errs6 = errors;
                                    if (errors === _errs6) {
                                        if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                            let missing1;
                                            if ((data2.value === undefined && (missing1 = 'value')) ||
                                                (data2.count === undefined && (missing1 = 'count'))) {
                                                validate13.errors = [
                                                    {
                                                        instancePath: instancePath + '/barValues/' + i0,
                                                        schemaPath: 'urn:wisepipe-common-computation:ValueCountPair/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing1 },
                                                        message: "must have required property '" + missing1 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data2.value !== undefined) {
                                                    let data3 = data2.value;
                                                    const _errs8 = errors;
                                                    const _errs9 = errors;
                                                    let valid4 = false;
                                                    let passing0 = null;
                                                    const _errs10 = errors;
                                                    if (typeof data3 !== 'string') {
                                                        const err0 = {
                                                            instancePath: instancePath + '/barValues/' + i0 + '/value',
                                                            schemaPath: 'urn:wisepipe-common-computation:ValueCountPair/properties/value/oneOf/0/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err0];
                                                        }
                                                        else {
                                                            vErrors.push(err0);
                                                        }
                                                        errors++;
                                                    }
                                                    var _valid0 = _errs10 === errors;
                                                    if (_valid0) {
                                                        valid4 = true;
                                                        passing0 = 0;
                                                    }
                                                    const _errs12 = errors;
                                                    if (typeof data3 !== 'boolean') {
                                                        const err1 = {
                                                            instancePath: instancePath + '/barValues/' + i0 + '/value',
                                                            schemaPath: 'urn:wisepipe-common-computation:ValueCountPair/properties/value/oneOf/1/type',
                                                            keyword: 'type',
                                                            params: { type: 'boolean' },
                                                            message: 'must be boolean'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err1];
                                                        }
                                                        else {
                                                            vErrors.push(err1);
                                                        }
                                                        errors++;
                                                    }
                                                    var _valid0 = _errs12 === errors;
                                                    if (_valid0 && valid4) {
                                                        valid4 = false;
                                                        passing0 = [passing0, 1];
                                                    }
                                                    else {
                                                        if (_valid0) {
                                                            valid4 = true;
                                                            passing0 = 1;
                                                        }
                                                    }
                                                    if (!valid4) {
                                                        const err2 = {
                                                            instancePath: instancePath + '/barValues/' + i0 + '/value',
                                                            schemaPath: 'urn:wisepipe-common-computation:ValueCountPair/properties/value/oneOf',
                                                            keyword: 'oneOf',
                                                            params: { passingSchemas: passing0 },
                                                            message: 'must match exactly one schema in oneOf'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err2];
                                                        }
                                                        else {
                                                            vErrors.push(err2);
                                                        }
                                                        errors++;
                                                        validate13.errors = vErrors;
                                                        return false;
                                                    }
                                                    else {
                                                        errors = _errs9;
                                                        if (vErrors !== null) {
                                                            if (_errs9) {
                                                                vErrors.length = _errs9;
                                                            }
                                                            else {
                                                                vErrors = null;
                                                            }
                                                        }
                                                    }
                                                    var valid3 = _errs8 === errors;
                                                }
                                                else {
                                                    var valid3 = true;
                                                }
                                                if (valid3) {
                                                    if (data2.count !== undefined) {
                                                        const _errs14 = errors;
                                                        if (!(typeof data2.count == 'number')) {
                                                            validate13.errors = [
                                                                {
                                                                    instancePath: instancePath + '/barValues/' + i0 + '/count',
                                                                    schemaPath: 'urn:wisepipe-common-computation:ValueCountPair/properties/count/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'number' },
                                                                    message: 'must be number'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid3 = _errs14 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate13.errors = [
                                                {
                                                    instancePath: instancePath + '/barValues/' + i0,
                                                    schemaPath: 'urn:wisepipe-common-computation:ValueCountPair/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs5 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate13.errors = [
                                    {
                                        instancePath: instancePath + '/barValues',
                                        schemaPath: '#/properties/barValues/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate13.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate13.errors = vErrors;
    return errors === 0;
}
export const baseCalculationRequestSchemaValidation = validate14;
const schema35 = {
    $id: 'urn:wisepipe-common-computation:BaseCalculationRequest',
    type: 'object',
    properties: { type: { type: 'string', enum: ['standard', 'transient_pipe', 'transient', 'locking'] } },
    required: ['type']
};
function validate14(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:BaseCalculationRequest" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.type === undefined && (missing0 = 'type')) {
                validate14.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.type !== undefined) {
                    let data0 = data.type;
                    if (typeof data0 !== 'string') {
                        validate14.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'standard' || data0 === 'transient_pipe' || data0 === 'transient' || data0 === 'locking')) {
                        validate14.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema35.properties.type.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate14.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate14.errors = vErrors;
    return errors === 0;
}
export const baseCalculationSchemaValidation = validate15;
const schema36 = {
    $id: 'urn:wisepipe-common-computation:BaseCalculation',
    type: 'object',
    properties: {
        type: { type: 'string', enum: ['standard', 'transient_pipe', 'transient', 'locking'] },
        status: { type: 'string', enum: ['running', 'failed', 'cancelled', 'completed'] },
        progress: { type: 'number', minimum: 0, maximum: 1 },
        start: { type: 'string', format: 'date-time' },
        end: { type: 'string', format: 'date-time' },
        error: { type: 'object' }
    },
    required: ['status', 'progress', 'start', 'type']
};
const formats0 = formatWrapper['date-time'];
function validate15(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:BaseCalculation" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.status === undefined && (missing0 = 'status')) ||
                (data.progress === undefined && (missing0 = 'progress')) ||
                (data.start === undefined && (missing0 = 'start')) ||
                (data.type === undefined && (missing0 = 'type'))) {
                validate15.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.type !== undefined) {
                    let data0 = data.type;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate15.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'standard' || data0 === 'transient_pipe' || data0 === 'transient' || data0 === 'locking')) {
                        validate15.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema36.properties.type.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.status !== undefined) {
                        let data1 = data.status;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate15.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'running' || data1 === 'failed' || data1 === 'cancelled' || data1 === 'completed')) {
                            validate15.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema36.properties.status.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.progress !== undefined) {
                            let data2 = data.progress;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 == 'number') {
                                    if (data2 > 1 || isNaN(data2)) {
                                        validate15.errors = [
                                            {
                                                instancePath: instancePath + '/progress',
                                                schemaPath: '#/properties/progress/maximum',
                                                keyword: 'maximum',
                                                params: { comparison: '<=', limit: 1 },
                                                message: 'must be <= 1'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (data2 < 0 || isNaN(data2)) {
                                            validate15.errors = [
                                                {
                                                    instancePath: instancePath + '/progress',
                                                    schemaPath: '#/properties/progress/minimum',
                                                    keyword: 'minimum',
                                                    params: { comparison: '>=', limit: 0 },
                                                    message: 'must be >= 0'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                else {
                                    validate15.errors = [
                                        {
                                            instancePath: instancePath + '/progress',
                                            schemaPath: '#/properties/progress/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.start !== undefined) {
                                let data3 = data.start;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (errors === _errs7) {
                                        if (typeof data3 === 'string') {
                                            if (!formats0.validate(data3)) {
                                                validate15.errors = [
                                                    {
                                                        instancePath: instancePath + '/start',
                                                        schemaPath: '#/properties/start/format',
                                                        keyword: 'format',
                                                        params: { format: 'date-time' },
                                                        message: 'must match format "' + 'date-time' + '"'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate15.errors = [
                                                {
                                                    instancePath: instancePath + '/start',
                                                    schemaPath: '#/properties/start/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.end !== undefined) {
                                    let data4 = data.end;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (errors === _errs9) {
                                            if (typeof data4 === 'string') {
                                                if (!formats0.validate(data4)) {
                                                    validate15.errors = [
                                                        {
                                                            instancePath: instancePath + '/end',
                                                            schemaPath: '#/properties/end/format',
                                                            keyword: 'format',
                                                            params: { format: 'date-time' },
                                                            message: 'must match format "' + 'date-time' + '"'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate15.errors = [
                                                    {
                                                        instancePath: instancePath + '/end',
                                                        schemaPath: '#/properties/end/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.error !== undefined) {
                                        let data5 = data.error;
                                        const _errs11 = errors;
                                        if (!(data5 && typeof data5 == 'object' && !Array.isArray(data5))) {
                                            validate15.errors = [
                                                {
                                                    instancePath: instancePath + '/error',
                                                    schemaPath: '#/properties/error/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate15.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate15.errors = vErrors;
    return errors === 0;
}
export const booleanColumnInfoSchemaValidation = validate16;
const schema37 = {
    $id: 'urn:wisepipe-common-computation:BooleanColumnInfo',
    type: 'object',
    properties: {
        missing: { type: 'number' },
        topValues: { type: 'array', items: { $ref: 'urn:wisepipe-common-computation:ValueCountPair' } }
    },
    required: ['missing']
};
function validate16(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:BooleanColumnInfo" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.missing === undefined && (missing0 = 'missing')) {
                validate16.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.missing !== undefined) {
                    const _errs1 = errors;
                    if (!(typeof data.missing == 'number')) {
                        validate16.errors = [
                            {
                                instancePath: instancePath + '/missing',
                                schemaPath: '#/properties/missing/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.topValues !== undefined) {
                        let data1 = data.topValues;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                var valid1 = true;
                                const len0 = data1.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data2 = data1[i0];
                                    const _errs5 = errors;
                                    const _errs6 = errors;
                                    if (errors === _errs6) {
                                        if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                            let missing1;
                                            if ((data2.value === undefined && (missing1 = 'value')) ||
                                                (data2.count === undefined && (missing1 = 'count'))) {
                                                validate16.errors = [
                                                    {
                                                        instancePath: instancePath + '/topValues/' + i0,
                                                        schemaPath: 'urn:wisepipe-common-computation:ValueCountPair/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing1 },
                                                        message: "must have required property '" + missing1 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data2.value !== undefined) {
                                                    let data3 = data2.value;
                                                    const _errs8 = errors;
                                                    const _errs9 = errors;
                                                    let valid4 = false;
                                                    let passing0 = null;
                                                    const _errs10 = errors;
                                                    if (typeof data3 !== 'string') {
                                                        const err0 = {
                                                            instancePath: instancePath + '/topValues/' + i0 + '/value',
                                                            schemaPath: 'urn:wisepipe-common-computation:ValueCountPair/properties/value/oneOf/0/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err0];
                                                        }
                                                        else {
                                                            vErrors.push(err0);
                                                        }
                                                        errors++;
                                                    }
                                                    var _valid0 = _errs10 === errors;
                                                    if (_valid0) {
                                                        valid4 = true;
                                                        passing0 = 0;
                                                    }
                                                    const _errs12 = errors;
                                                    if (typeof data3 !== 'boolean') {
                                                        const err1 = {
                                                            instancePath: instancePath + '/topValues/' + i0 + '/value',
                                                            schemaPath: 'urn:wisepipe-common-computation:ValueCountPair/properties/value/oneOf/1/type',
                                                            keyword: 'type',
                                                            params: { type: 'boolean' },
                                                            message: 'must be boolean'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err1];
                                                        }
                                                        else {
                                                            vErrors.push(err1);
                                                        }
                                                        errors++;
                                                    }
                                                    var _valid0 = _errs12 === errors;
                                                    if (_valid0 && valid4) {
                                                        valid4 = false;
                                                        passing0 = [passing0, 1];
                                                    }
                                                    else {
                                                        if (_valid0) {
                                                            valid4 = true;
                                                            passing0 = 1;
                                                        }
                                                    }
                                                    if (!valid4) {
                                                        const err2 = {
                                                            instancePath: instancePath + '/topValues/' + i0 + '/value',
                                                            schemaPath: 'urn:wisepipe-common-computation:ValueCountPair/properties/value/oneOf',
                                                            keyword: 'oneOf',
                                                            params: { passingSchemas: passing0 },
                                                            message: 'must match exactly one schema in oneOf'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err2];
                                                        }
                                                        else {
                                                            vErrors.push(err2);
                                                        }
                                                        errors++;
                                                        validate16.errors = vErrors;
                                                        return false;
                                                    }
                                                    else {
                                                        errors = _errs9;
                                                        if (vErrors !== null) {
                                                            if (_errs9) {
                                                                vErrors.length = _errs9;
                                                            }
                                                            else {
                                                                vErrors = null;
                                                            }
                                                        }
                                                    }
                                                    var valid3 = _errs8 === errors;
                                                }
                                                else {
                                                    var valid3 = true;
                                                }
                                                if (valid3) {
                                                    if (data2.count !== undefined) {
                                                        const _errs14 = errors;
                                                        if (!(typeof data2.count == 'number')) {
                                                            validate16.errors = [
                                                                {
                                                                    instancePath: instancePath + '/topValues/' + i0 + '/count',
                                                                    schemaPath: 'urn:wisepipe-common-computation:ValueCountPair/properties/count/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'number' },
                                                                    message: 'must be number'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid3 = _errs14 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate16.errors = [
                                                {
                                                    instancePath: instancePath + '/topValues/' + i0,
                                                    schemaPath: 'urn:wisepipe-common-computation:ValueCountPair/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs5 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate16.errors = [
                                    {
                                        instancePath: instancePath + '/topValues',
                                        schemaPath: '#/properties/topValues/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate16.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate16.errors = vErrors;
    return errors === 0;
}
export const booleanFilterSchemaValidation = validate17;
const schema39 = {
    $id: 'urn:wisepipe-common-computation:BooleanFilter',
    type: 'object',
    properties: { values: { type: 'array', items: { type: ['boolean', 'null'] } } }
};
function validate17(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:BooleanFilter" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.values !== undefined) {
                let data0 = data.values;
                const _errs1 = errors;
                if (errors === _errs1) {
                    if (Array.isArray(data0)) {
                        var valid1 = true;
                        const len0 = data0.length;
                        for (let i0 = 0; i0 < len0; i0++) {
                            let data1 = data0[i0];
                            const _errs3 = errors;
                            if (typeof data1 !== 'boolean' && data1 !== null) {
                                validate17.errors = [
                                    {
                                        instancePath: instancePath + '/values/' + i0,
                                        schemaPath: '#/properties/values/items/type',
                                        keyword: 'type',
                                        params: { type: schema39.properties.values.items.type },
                                        message: 'must be boolean,null'
                                    }
                                ];
                                return false;
                            }
                            var valid1 = _errs3 === errors;
                            if (!valid1) {
                                break;
                            }
                        }
                    }
                    else {
                        validate17.errors = [
                            {
                                instancePath: instancePath + '/values',
                                schemaPath: '#/properties/values/type',
                                keyword: 'type',
                                params: { type: 'array' },
                                message: 'must be array'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate17.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate17.errors = vErrors;
    return errors === 0;
}
export const boxPlotDataSchemaValidation = validate18;
const schema40 = {
    $id: 'urn:wisepipe-common-computation:BoxPlotData',
    type: 'object',
    properties: {
        q1: { type: ['number', 'null'] },
        q3: { type: ['number', 'null'] },
        median: { type: ['number', 'null'] },
        min: { type: ['number', 'null'] },
        max: { type: ['number', 'null'] }
    },
    required: ['q1', 'q3', 'median', 'min', 'max']
};
function validate18(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:BoxPlotData" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.q1 === undefined && (missing0 = 'q1')) ||
                (data.q3 === undefined && (missing0 = 'q3')) ||
                (data.median === undefined && (missing0 = 'median')) ||
                (data.min === undefined && (missing0 = 'min')) ||
                (data.max === undefined && (missing0 = 'max'))) {
                validate18.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.q1 !== undefined) {
                    let data0 = data.q1;
                    const _errs1 = errors;
                    if (!(typeof data0 == 'number') && data0 !== null) {
                        validate18.errors = [
                            {
                                instancePath: instancePath + '/q1',
                                schemaPath: '#/properties/q1/type',
                                keyword: 'type',
                                params: { type: schema40.properties.q1.type },
                                message: 'must be number,null'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.q3 !== undefined) {
                        let data1 = data.q3;
                        const _errs3 = errors;
                        if (!(typeof data1 == 'number') && data1 !== null) {
                            validate18.errors = [
                                {
                                    instancePath: instancePath + '/q3',
                                    schemaPath: '#/properties/q3/type',
                                    keyword: 'type',
                                    params: { type: schema40.properties.q3.type },
                                    message: 'must be number,null'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.median !== undefined) {
                            let data2 = data.median;
                            const _errs5 = errors;
                            if (!(typeof data2 == 'number') && data2 !== null) {
                                validate18.errors = [
                                    {
                                        instancePath: instancePath + '/median',
                                        schemaPath: '#/properties/median/type',
                                        keyword: 'type',
                                        params: { type: schema40.properties.median.type },
                                        message: 'must be number,null'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.min !== undefined) {
                                let data3 = data.min;
                                const _errs7 = errors;
                                if (!(typeof data3 == 'number') && data3 !== null) {
                                    validate18.errors = [
                                        {
                                            instancePath: instancePath + '/min',
                                            schemaPath: '#/properties/min/type',
                                            keyword: 'type',
                                            params: { type: schema40.properties.min.type },
                                            message: 'must be number,null'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.max !== undefined) {
                                    let data4 = data.max;
                                    const _errs9 = errors;
                                    if (!(typeof data4 == 'number') && data4 !== null) {
                                        validate18.errors = [
                                            {
                                                instancePath: instancePath + '/max',
                                                schemaPath: '#/properties/max/type',
                                                keyword: 'type',
                                                params: { type: schema40.properties.max.type },
                                                message: 'must be number,null'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate18.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate18.errors = vErrors;
    return errors === 0;
}
export const boxplotVisualParamsSchemaValidation = validate19;
const schema41 = {
    $id: 'urn:wisepipe-common-computation:BoxplotVisualParams',
    type: 'object',
    properties: {
        yAxis: { type: 'string', minLength: 1 },
        partition: { type: 'string', minLength: 1 },
        min: { type: 'string', minLength: 1 },
        lower: { type: 'string', minLength: 1 },
        median: { type: 'string', minLength: 1 },
        upper: { type: 'string', minLength: 1 },
        max: { type: 'string', minLength: 1 }
    },
    required: ['yAxis', 'min', 'lower', 'median', 'upper', 'max']
};
const func2 = ucs2length;
function validate19(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:BoxplotVisualParams" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.yAxis === undefined && (missing0 = 'yAxis')) ||
                (data.min === undefined && (missing0 = 'min')) ||
                (data.lower === undefined && (missing0 = 'lower')) ||
                (data.median === undefined && (missing0 = 'median')) ||
                (data.upper === undefined && (missing0 = 'upper')) ||
                (data.max === undefined && (missing0 = 'max'))) {
                validate19.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.yAxis !== undefined) {
                    let data0 = data.yAxis;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate19.errors = [
                                    {
                                        instancePath: instancePath + '/yAxis',
                                        schemaPath: '#/properties/yAxis/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate19.errors = [
                                {
                                    instancePath: instancePath + '/yAxis',
                                    schemaPath: '#/properties/yAxis/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.partition !== undefined) {
                        let data1 = data.partition;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate19.errors = [
                                        {
                                            instancePath: instancePath + '/partition',
                                            schemaPath: '#/properties/partition/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate19.errors = [
                                    {
                                        instancePath: instancePath + '/partition',
                                        schemaPath: '#/properties/partition/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.min !== undefined) {
                            let data2 = data.min;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate19.errors = [
                                            {
                                                instancePath: instancePath + '/min',
                                                schemaPath: '#/properties/min/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate19.errors = [
                                        {
                                            instancePath: instancePath + '/min',
                                            schemaPath: '#/properties/min/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.lower !== undefined) {
                                let data3 = data.lower;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) < 1) {
                                            validate19.errors = [
                                                {
                                                    instancePath: instancePath + '/lower',
                                                    schemaPath: '#/properties/lower/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate19.errors = [
                                            {
                                                instancePath: instancePath + '/lower',
                                                schemaPath: '#/properties/lower/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.median !== undefined) {
                                    let data4 = data.median;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (typeof data4 === 'string') {
                                            if (func2(data4) < 1) {
                                                validate19.errors = [
                                                    {
                                                        instancePath: instancePath + '/median',
                                                        schemaPath: '#/properties/median/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate19.errors = [
                                                {
                                                    instancePath: instancePath + '/median',
                                                    schemaPath: '#/properties/median/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.upper !== undefined) {
                                        let data5 = data.upper;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (typeof data5 === 'string') {
                                                if (func2(data5) < 1) {
                                                    validate19.errors = [
                                                        {
                                                            instancePath: instancePath + '/upper',
                                                            schemaPath: '#/properties/upper/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate19.errors = [
                                                    {
                                                        instancePath: instancePath + '/upper',
                                                        schemaPath: '#/properties/upper/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.max !== undefined) {
                                            let data6 = data.max;
                                            const _errs13 = errors;
                                            if (errors === _errs13) {
                                                if (typeof data6 === 'string') {
                                                    if (func2(data6) < 1) {
                                                        validate19.errors = [
                                                            {
                                                                instancePath: instancePath + '/max',
                                                                schemaPath: '#/properties/max/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate19.errors = [
                                                        {
                                                            instancePath: instancePath + '/max',
                                                            schemaPath: '#/properties/max/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate19.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate19.errors = vErrors;
    return errors === 0;
}
export const bubbleSingleAxisVisualParamsSchemaValidation = validate20;
const schema42 = {
    $id: 'urn:wisepipe-common-computation:BubbleSingleAxisVisualParams',
    type: 'object',
    properties: {
        xAxis: { type: 'string', minLength: 1 },
        yAxis: { type: 'string', minLength: 1 },
        size: { type: 'string', minLength: 1 },
        descriptions: { type: 'array', items: { type: 'string', minLength: 1 }, uniqueItems: true },
        bottomSpacingBetweenAxis: { type: 'number' },
        gradient: { type: 'boolean' },
        shadow: { type: 'boolean' }
    },
    required: ['xAxis', 'yAxis']
};
function validate20(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:BubbleSingleAxisVisualParams" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.xAxis === undefined && (missing0 = 'xAxis')) || (data.yAxis === undefined && (missing0 = 'yAxis'))) {
                validate20.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.xAxis !== undefined) {
                    let data0 = data.xAxis;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate20.errors = [
                                    {
                                        instancePath: instancePath + '/xAxis',
                                        schemaPath: '#/properties/xAxis/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate20.errors = [
                                {
                                    instancePath: instancePath + '/xAxis',
                                    schemaPath: '#/properties/xAxis/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.yAxis !== undefined) {
                        let data1 = data.yAxis;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate20.errors = [
                                        {
                                            instancePath: instancePath + '/yAxis',
                                            schemaPath: '#/properties/yAxis/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate20.errors = [
                                    {
                                        instancePath: instancePath + '/yAxis',
                                        schemaPath: '#/properties/yAxis/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.size !== undefined) {
                            let data2 = data.size;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate20.errors = [
                                            {
                                                instancePath: instancePath + '/size',
                                                schemaPath: '#/properties/size/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate20.errors = [
                                        {
                                            instancePath: instancePath + '/size',
                                            schemaPath: '#/properties/size/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.descriptions !== undefined) {
                                let data3 = data.descriptions;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (Array.isArray(data3)) {
                                        var valid1 = true;
                                        const len0 = data3.length;
                                        for (let i0 = 0; i0 < len0; i0++) {
                                            let data4 = data3[i0];
                                            const _errs9 = errors;
                                            if (errors === _errs9) {
                                                if (typeof data4 === 'string') {
                                                    if (func2(data4) < 1) {
                                                        validate20.errors = [
                                                            {
                                                                instancePath: instancePath + '/descriptions/' + i0,
                                                                schemaPath: '#/properties/descriptions/items/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate20.errors = [
                                                        {
                                                            instancePath: instancePath + '/descriptions/' + i0,
                                                            schemaPath: '#/properties/descriptions/items/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid1 = _errs9 === errors;
                                            if (!valid1) {
                                                break;
                                            }
                                        }
                                        if (valid1) {
                                            let i1 = data3.length;
                                            let j0;
                                            if (i1 > 1) {
                                                const indices0 = {};
                                                for (; i1--;) {
                                                    let item0 = data3[i1];
                                                    if (typeof item0 !== 'string') {
                                                        continue;
                                                    }
                                                    if (typeof indices0[item0] == 'number') {
                                                        j0 = indices0[item0];
                                                        validate20.errors = [
                                                            {
                                                                instancePath: instancePath + '/descriptions',
                                                                schemaPath: '#/properties/descriptions/uniqueItems',
                                                                keyword: 'uniqueItems',
                                                                params: { i: i1, j: j0 },
                                                                message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                            }
                                                        ];
                                                        return false;
                                                        break;
                                                    }
                                                    indices0[item0] = i1;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate20.errors = [
                                            {
                                                instancePath: instancePath + '/descriptions',
                                                schemaPath: '#/properties/descriptions/type',
                                                keyword: 'type',
                                                params: { type: 'array' },
                                                message: 'must be array'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.bottomSpacingBetweenAxis !== undefined) {
                                    const _errs11 = errors;
                                    if (!(typeof data.bottomSpacingBetweenAxis == 'number')) {
                                        validate20.errors = [
                                            {
                                                instancePath: instancePath + '/bottomSpacingBetweenAxis',
                                                schemaPath: '#/properties/bottomSpacingBetweenAxis/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs11 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.gradient !== undefined) {
                                        const _errs13 = errors;
                                        if (typeof data.gradient !== 'boolean') {
                                            validate20.errors = [
                                                {
                                                    instancePath: instancePath + '/gradient',
                                                    schemaPath: '#/properties/gradient/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs13 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.shadow !== undefined) {
                                            const _errs15 = errors;
                                            if (typeof data.shadow !== 'boolean') {
                                                validate20.errors = [
                                                    {
                                                        instancePath: instancePath + '/shadow',
                                                        schemaPath: '#/properties/shadow/type',
                                                        keyword: 'type',
                                                        params: { type: 'boolean' },
                                                        message: 'must be boolean'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs15 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate20.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate20.errors = vErrors;
    return errors === 0;
}
export const bubbleVisualParamsSchemaValidation = validate21;
const schema43 = {
    $id: 'urn:wisepipe-common-computation:BubbleVisualParams',
    type: 'object',
    properties: {
        xAxis: { type: 'string', minLength: 1 },
        yAxis: { type: 'string', minLength: 1 },
        series: { type: 'string', minLength: 1 },
        size: { type: 'string', minLength: 1 },
        gradient: { type: 'boolean' },
        shadow: { type: 'boolean' }
    },
    required: ['xAxis', 'yAxis', 'series']
};
function validate21(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:BubbleVisualParams" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.xAxis === undefined && (missing0 = 'xAxis')) ||
                (data.yAxis === undefined && (missing0 = 'yAxis')) ||
                (data.series === undefined && (missing0 = 'series'))) {
                validate21.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.xAxis !== undefined) {
                    let data0 = data.xAxis;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate21.errors = [
                                    {
                                        instancePath: instancePath + '/xAxis',
                                        schemaPath: '#/properties/xAxis/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate21.errors = [
                                {
                                    instancePath: instancePath + '/xAxis',
                                    schemaPath: '#/properties/xAxis/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.yAxis !== undefined) {
                        let data1 = data.yAxis;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate21.errors = [
                                        {
                                            instancePath: instancePath + '/yAxis',
                                            schemaPath: '#/properties/yAxis/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate21.errors = [
                                    {
                                        instancePath: instancePath + '/yAxis',
                                        schemaPath: '#/properties/yAxis/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.series !== undefined) {
                            let data2 = data.series;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate21.errors = [
                                            {
                                                instancePath: instancePath + '/series',
                                                schemaPath: '#/properties/series/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate21.errors = [
                                        {
                                            instancePath: instancePath + '/series',
                                            schemaPath: '#/properties/series/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.size !== undefined) {
                                let data3 = data.size;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) < 1) {
                                            validate21.errors = [
                                                {
                                                    instancePath: instancePath + '/size',
                                                    schemaPath: '#/properties/size/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate21.errors = [
                                            {
                                                instancePath: instancePath + '/size',
                                                schemaPath: '#/properties/size/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.gradient !== undefined) {
                                    const _errs9 = errors;
                                    if (typeof data.gradient !== 'boolean') {
                                        validate21.errors = [
                                            {
                                                instancePath: instancePath + '/gradient',
                                                schemaPath: '#/properties/gradient/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.shadow !== undefined) {
                                        const _errs11 = errors;
                                        if (typeof data.shadow !== 'boolean') {
                                            validate21.errors = [
                                                {
                                                    instancePath: instancePath + '/shadow',
                                                    schemaPath: '#/properties/shadow/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate21.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate21.errors = vErrors;
    return errors === 0;
}
export const calcDataProfileRequestSchemaValidation = validate22;
const schema44 = {
    $id: 'urn:wisepipe-common-computation:CalcDataProfileRequest',
    type: 'object',
    properties: {
        pipeID: { type: 'string', uid: 10 },
        elementID: { type: 'string', uid: 10 },
        port: { type: 'string', minLength: 1 },
        reusableLogicParentNodeIDPath: { type: 'string', minLength: 1 },
        isNodeRLInput: { type: 'boolean' }
    },
    required: ['pipeID', 'elementID', 'port'],
    if: { required: ['isNodeRLInput'] },
    then: { required: ['reusableLogicParentNodeIDPath'] }
};
const func17 = ucs2length;
const func18 = base64urlToBuffer;
const func19 = base64urlEncode;
const func20 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func21 = ucs2length;
const func22 = base64urlToBuffer;
const func23 = base64urlEncode;
const func24 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate22(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:CalcDataProfileRequest" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if (data.isNodeRLInput === undefined && (missing0 = 'isNodeRLInput')) {
            const err0 = {};
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs3 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if (data.reusableLogicParentNodeIDPath === undefined && (missing1 = 'reusableLogicParentNodeIDPath')) {
                validate22.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs3 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err1 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate22.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if ((data.pipeID === undefined && (missing2 = 'pipeID')) ||
                (data.elementID === undefined && (missing2 = 'elementID')) ||
                (data.port === undefined && (missing2 = 'port'))) {
                validate22.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing2 },
                        message: "must have required property '" + missing2 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pipeID !== undefined) {
                    let data0 = data.pipeID;
                    const _errs4 = errors;
                    if (errors === _errs4) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func17(data0) < b64min0 || func17(data0) > b64max0) {
                                validate22.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func17(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func17(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func18(data0);
                                if (decoded0.length !== 10) {
                                    validate22.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func19(decoded0);
                                    if (func20(encoded0) !== func20(data0)) {
                                        validate22.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate22.errors = [
                                {
                                    instancePath: instancePath + '/pipeID',
                                    schemaPath: '#/properties/pipeID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid1 = _errs4 === errors;
                }
                else {
                    var valid1 = true;
                }
                if (valid1) {
                    if (data.elementID !== undefined) {
                        let data1 = data.elementID;
                        const _errs6 = errors;
                        if (errors === _errs6) {
                            if (typeof data1 === 'string') {
                                const b64min1 = Math.ceil((4 * 10) / 3);
                                const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                if (func21(data1) < b64min1 || func21(data1) > b64max1) {
                                    validate22.errors = [
                                        {
                                            instancePath: instancePath + '/elementID',
                                            schemaPath: '#/properties/elementID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func21(data1) },
                                            message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func21(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded1 = func22(data1);
                                    if (decoded1.length !== 10) {
                                        validate22.errors = [
                                            {
                                                instancePath: instancePath + '/elementID',
                                                schemaPath: '#/properties/elementID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 10 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded1 = func23(decoded1);
                                        if (func24(encoded1) !== func24(data1)) {
                                            validate22.errors = [
                                                {
                                                    instancePath: instancePath + '/elementID',
                                                    schemaPath: '#/properties/elementID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate22.errors = [
                                    {
                                        instancePath: instancePath + '/elementID',
                                        schemaPath: '#/properties/elementID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid1 = _errs6 === errors;
                    }
                    else {
                        var valid1 = true;
                    }
                    if (valid1) {
                        if (data.port !== undefined) {
                            let data2 = data.port;
                            const _errs8 = errors;
                            if (errors === _errs8) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate22.errors = [
                                            {
                                                instancePath: instancePath + '/port',
                                                schemaPath: '#/properties/port/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate22.errors = [
                                        {
                                            instancePath: instancePath + '/port',
                                            schemaPath: '#/properties/port/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid1 = _errs8 === errors;
                        }
                        else {
                            var valid1 = true;
                        }
                        if (valid1) {
                            if (data.reusableLogicParentNodeIDPath !== undefined) {
                                let data3 = data.reusableLogicParentNodeIDPath;
                                const _errs10 = errors;
                                if (errors === _errs10) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) < 1) {
                                            validate22.errors = [
                                                {
                                                    instancePath: instancePath + '/reusableLogicParentNodeIDPath',
                                                    schemaPath: '#/properties/reusableLogicParentNodeIDPath/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate22.errors = [
                                            {
                                                instancePath: instancePath + '/reusableLogicParentNodeIDPath',
                                                schemaPath: '#/properties/reusableLogicParentNodeIDPath/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid1 = _errs10 === errors;
                            }
                            else {
                                var valid1 = true;
                            }
                            if (valid1) {
                                if (data.isNodeRLInput !== undefined) {
                                    const _errs12 = errors;
                                    if (typeof data.isNodeRLInput !== 'boolean') {
                                        validate22.errors = [
                                            {
                                                instancePath: instancePath + '/isNodeRLInput',
                                                schemaPath: '#/properties/isNodeRLInput/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid1 = _errs12 === errors;
                                }
                                else {
                                    var valid1 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate22.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate22.errors = vErrors;
    return errors === 0;
}
export const calcTimeSchemaValidation = validate23;
const schema45 = {
    $id: 'urn:wisepipe-common-computation:CalcTime',
    type: 'object',
    properties: {
        pipeID: { type: 'string', uid: 10 },
        elementID: { type: 'string', uid: 10 },
        timestamp: { type: 'string', format: 'date-time' }
    },
    required: ['pipeID', 'elementID', 'timestamp']
};
const func27 = ucs2length;
const func28 = base64urlToBuffer;
const func29 = base64urlEncode;
const func30 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func31 = ucs2length;
const func32 = base64urlToBuffer;
const func33 = base64urlEncode;
const func34 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate23(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:CalcTime" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.pipeID === undefined && (missing0 = 'pipeID')) ||
                (data.elementID === undefined && (missing0 = 'elementID')) ||
                (data.timestamp === undefined && (missing0 = 'timestamp'))) {
                validate23.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pipeID !== undefined) {
                    let data0 = data.pipeID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func27(data0) < b64min0 || func27(data0) > b64max0) {
                                validate23.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func27(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func27(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func28(data0);
                                if (decoded0.length !== 10) {
                                    validate23.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func29(decoded0);
                                    if (func30(encoded0) !== func30(data0)) {
                                        validate23.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate23.errors = [
                                {
                                    instancePath: instancePath + '/pipeID',
                                    schemaPath: '#/properties/pipeID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.elementID !== undefined) {
                        let data1 = data.elementID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                const b64min1 = Math.ceil((4 * 10) / 3);
                                const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                if (func31(data1) < b64min1 || func31(data1) > b64max1) {
                                    validate23.errors = [
                                        {
                                            instancePath: instancePath + '/elementID',
                                            schemaPath: '#/properties/elementID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func31(data1) },
                                            message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func31(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded1 = func32(data1);
                                    if (decoded1.length !== 10) {
                                        validate23.errors = [
                                            {
                                                instancePath: instancePath + '/elementID',
                                                schemaPath: '#/properties/elementID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 10 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded1 = func33(decoded1);
                                        if (func34(encoded1) !== func34(data1)) {
                                            validate23.errors = [
                                                {
                                                    instancePath: instancePath + '/elementID',
                                                    schemaPath: '#/properties/elementID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate23.errors = [
                                    {
                                        instancePath: instancePath + '/elementID',
                                        schemaPath: '#/properties/elementID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.timestamp !== undefined) {
                            let data2 = data.timestamp;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (errors === _errs5) {
                                    if (typeof data2 === 'string') {
                                        if (!formats0.validate(data2)) {
                                            validate23.errors = [
                                                {
                                                    instancePath: instancePath + '/timestamp',
                                                    schemaPath: '#/properties/timestamp/format',
                                                    keyword: 'format',
                                                    params: { format: 'date-time' },
                                                    message: 'must match format "' + 'date-time' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate23.errors = [
                                            {
                                                instancePath: instancePath + '/timestamp',
                                                schemaPath: '#/properties/timestamp/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate23.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate23.errors = vErrors;
    return errors === 0;
}
export const calculationInputSchemaValidation = validate24;
const schema46 = {
    $id: 'urn:wisepipe-common-computation:CalculationInput',
    type: 'object',
    properties: { calcTask: { $ref: 'urn:wisepipe-common-computation:ComputeTask' } },
    required: []
};
const schema47 = {
    $id: 'urn:wisepipe-common-computation:ComputeTask',
    type: 'object',
    properties: {
        type: { type: 'string', enum: ['standard', 'transient_pipe', 'transient', 'locking'] },
        taskID: { type: 'string', minLength: 1 },
        user: { type: 'string', format: 'uuid' },
        userName: { type: 'string' },
        userEmail: { type: 'string' },
        orgID: { type: 'string', format: 'uuid' },
        orgPlan: { type: 'string', enum: ['Social', 'Enterprise', 'Integration', 'Temp', 'Starter', 'Professional'] },
        mode: { type: 'string', enum: ['standard', 'big'] },
        objectID: { type: 'string', minLength: 1 },
        runName: { type: 'string' },
        pythonEngineVersion: { type: 'string', enum: ['1', '2', '3'] },
        sparkEngineVersion: { type: 'string', enum: ['1', '2'] },
        extras: { type: 'array', items: { type: 'string' }, uniqueItems: true },
        incentivesComposerCalcConfig: { $ref: 'urn:wisepipe-common-computation:IncentivesComposerCalcConfig' },
        triggerDependeeCalc: { type: 'boolean' },
        dependeeAncestors: { type: 'array', items: { type: 'string' }, uniqueItems: true },
        rootTaskID: { type: 'string' },
        rootStart: { type: 'string', format: 'date-time' }
    },
    required: ['user', 'orgID', 'mode', 'objectID', 'taskID']
};
const formats6 = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
const schema48 = {
    $id: 'urn:wisepipe-common-computation:IncentivesComposerCalcConfig',
    type: 'object',
    properties: {
        table: { $ref: 'urn:wisepipe-common:IncentivesComposerS3Config' },
        importExport: { $ref: 'urn:wisepipe-common:IncentivesComposerS3Config' },
        importExportLocked: { $ref: 'urn:wisepipe-common:IncentivesComposerS3Config' },
        cdc: { $ref: 'urn:wisepipe-common:IncentivesComposerS3Config' },
        useNonIncrementalCalc: { type: 'boolean' }
    },
    required: ['table', 'importExport']
};
const schema49 = {
    $id: 'urn:wisepipe-common:IncentivesComposerS3Config',
    type: 'object',
    properties: {
        credentials: { $ref: 'urn:wisepipe-common:S3Credentials' },
        location: { $ref: 'urn:wisepipe-common:S3File' }
    },
    required: ['credentials', 'location']
};
const schema50 = {
    $id: 'urn:wisepipe-common:S3Credentials',
    type: 'object',
    properties: {
        accessKey: { type: 'string', minLength: 1 },
        secret: { type: 'string', minLength: 1 },
        sessionToken: { type: 'string', minLength: 1 }
    },
    required: ['accessKey', 'secret']
};
const schema51 = {
    $id: 'urn:wisepipe-common:S3File',
    type: 'object',
    properties: {
        bucket: { type: 'string', minLength: 1 },
        key: { type: 'string', minLength: 1 },
        uploadID: { type: 'string', uid: 9 }
    },
    required: ['bucket', 'key']
};
const func42 = ucs2length;
const func43 = base64urlToBuffer;
const func44 = base64urlEncode;
const func45 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate27(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common:IncentivesComposerS3Config" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.credentials === undefined && (missing0 = 'credentials')) ||
                (data.location === undefined && (missing0 = 'location'))) {
                validate27.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.credentials !== undefined) {
                    let data0 = data.credentials;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    if (errors === _errs2) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if ((data0.accessKey === undefined && (missing1 = 'accessKey')) ||
                                (data0.secret === undefined && (missing1 = 'secret'))) {
                                validate27.errors = [
                                    {
                                        instancePath: instancePath + '/credentials',
                                        schemaPath: 'urn:wisepipe-common:S3Credentials/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.accessKey !== undefined) {
                                    let data1 = data0.accessKey;
                                    const _errs4 = errors;
                                    if (errors === _errs4) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) < 1) {
                                                validate27.errors = [
                                                    {
                                                        instancePath: instancePath + '/credentials/accessKey',
                                                        schemaPath: 'urn:wisepipe-common:S3Credentials/properties/accessKey/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate27.errors = [
                                                {
                                                    instancePath: instancePath + '/credentials/accessKey',
                                                    schemaPath: 'urn:wisepipe-common:S3Credentials/properties/accessKey/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs4 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data0.secret !== undefined) {
                                        let data2 = data0.secret;
                                        const _errs6 = errors;
                                        if (errors === _errs6) {
                                            if (typeof data2 === 'string') {
                                                if (func2(data2) < 1) {
                                                    validate27.errors = [
                                                        {
                                                            instancePath: instancePath + '/credentials/secret',
                                                            schemaPath: 'urn:wisepipe-common:S3Credentials/properties/secret/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate27.errors = [
                                                    {
                                                        instancePath: instancePath + '/credentials/secret',
                                                        schemaPath: 'urn:wisepipe-common:S3Credentials/properties/secret/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs6 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data0.sessionToken !== undefined) {
                                            let data3 = data0.sessionToken;
                                            const _errs8 = errors;
                                            if (errors === _errs8) {
                                                if (typeof data3 === 'string') {
                                                    if (func2(data3) < 1) {
                                                        validate27.errors = [
                                                            {
                                                                instancePath: instancePath + '/credentials/sessionToken',
                                                                schemaPath: 'urn:wisepipe-common:S3Credentials/properties/sessionToken/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate27.errors = [
                                                        {
                                                            instancePath: instancePath + '/credentials/sessionToken',
                                                            schemaPath: 'urn:wisepipe-common:S3Credentials/properties/sessionToken/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid2 = _errs8 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate27.errors = [
                                {
                                    instancePath: instancePath + '/credentials',
                                    schemaPath: 'urn:wisepipe-common:S3Credentials/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.location !== undefined) {
                        let data4 = data.location;
                        const _errs10 = errors;
                        const _errs11 = errors;
                        if (errors === _errs11) {
                            if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                                let missing2;
                                if ((data4.bucket === undefined && (missing2 = 'bucket')) ||
                                    (data4.key === undefined && (missing2 = 'key'))) {
                                    validate27.errors = [
                                        {
                                            instancePath: instancePath + '/location',
                                            schemaPath: 'urn:wisepipe-common:S3File/required',
                                            keyword: 'required',
                                            params: { missingProperty: missing2 },
                                            message: "must have required property '" + missing2 + "'"
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data4.bucket !== undefined) {
                                        let data5 = data4.bucket;
                                        const _errs13 = errors;
                                        if (errors === _errs13) {
                                            if (typeof data5 === 'string') {
                                                if (func2(data5) < 1) {
                                                    validate27.errors = [
                                                        {
                                                            instancePath: instancePath + '/location/bucket',
                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate27.errors = [
                                                    {
                                                        instancePath: instancePath + '/location/bucket',
                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid4 = _errs13 === errors;
                                    }
                                    else {
                                        var valid4 = true;
                                    }
                                    if (valid4) {
                                        if (data4.key !== undefined) {
                                            let data6 = data4.key;
                                            const _errs15 = errors;
                                            if (errors === _errs15) {
                                                if (typeof data6 === 'string') {
                                                    if (func2(data6) < 1) {
                                                        validate27.errors = [
                                                            {
                                                                instancePath: instancePath + '/location/key',
                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate27.errors = [
                                                        {
                                                            instancePath: instancePath + '/location/key',
                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid4 = _errs15 === errors;
                                        }
                                        else {
                                            var valid4 = true;
                                        }
                                        if (valid4) {
                                            if (data4.uploadID !== undefined) {
                                                let data7 = data4.uploadID;
                                                const _errs17 = errors;
                                                if (errors === _errs17) {
                                                    if (typeof data7 === 'string') {
                                                        const b64min0 = Math.ceil((4 * 9) / 3);
                                                        const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                                        if (func42(data7) < b64min0 || func42(data7) > b64max0) {
                                                            validate27.errors = [
                                                                {
                                                                    instancePath: instancePath + '/location/uploadID',
                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                    keyword: 'uid',
                                                                    params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func42(data7) },
                                                                    message: 'length must be between ' +
                                                                        b64min0 +
                                                                        ' and ' +
                                                                        b64max0 +
                                                                        ', but is ' +
                                                                        func42(data7)
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            const decoded0 = func43(data7);
                                                            if (decoded0.length !== 9) {
                                                                validate27.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/location/uploadID',
                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                        keyword: 'uid',
                                                                        params: { error: 'decoded' },
                                                                        message: 'must decode to 9 bytes'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                const encoded0 = func44(decoded0);
                                                                if (func45(encoded0) !== func45(data7)) {
                                                                    validate27.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/location/uploadID',
                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                            keyword: 'uid',
                                                                            params: { error: 'ambiguous' },
                                                                            message: 'encoding is ambiguous'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate27.errors = [
                                                            {
                                                                instancePath: instancePath + '/location/uploadID',
                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid4 = _errs17 === errors;
                                            }
                                            else {
                                                var valid4 = true;
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate27.errors = [
                                    {
                                        instancePath: instancePath + '/location',
                                        schemaPath: 'urn:wisepipe-common:S3File/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs10 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate27.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate27.errors = vErrors;
    return errors === 0;
}
function validate26(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:IncentivesComposerCalcConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.table === undefined && (missing0 = 'table')) ||
                (data.importExport === undefined && (missing0 = 'importExport'))) {
                validate26.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.table !== undefined) {
                    const _errs1 = errors;
                    if (!validate27(data.table, {
                        instancePath: instancePath + '/table',
                        parentData: data,
                        parentDataProperty: 'table',
                        rootData
                    })) {
                        vErrors = vErrors === null ? validate27.errors : vErrors.concat(validate27.errors);
                        errors = vErrors.length;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.importExport !== undefined) {
                        const _errs2 = errors;
                        if (!validate27(data.importExport, {
                            instancePath: instancePath + '/importExport',
                            parentData: data,
                            parentDataProperty: 'importExport',
                            rootData
                        })) {
                            vErrors = vErrors === null ? validate27.errors : vErrors.concat(validate27.errors);
                            errors = vErrors.length;
                        }
                        var valid0 = _errs2 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.importExportLocked !== undefined) {
                            const _errs3 = errors;
                            if (!validate27(data.importExportLocked, {
                                instancePath: instancePath + '/importExportLocked',
                                parentData: data,
                                parentDataProperty: 'importExportLocked',
                                rootData
                            })) {
                                vErrors = vErrors === null ? validate27.errors : vErrors.concat(validate27.errors);
                                errors = vErrors.length;
                            }
                            var valid0 = _errs3 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.cdc !== undefined) {
                                const _errs4 = errors;
                                if (!validate27(data.cdc, {
                                    instancePath: instancePath + '/cdc',
                                    parentData: data,
                                    parentDataProperty: 'cdc',
                                    rootData
                                })) {
                                    vErrors = vErrors === null ? validate27.errors : vErrors.concat(validate27.errors);
                                    errors = vErrors.length;
                                }
                                var valid0 = _errs4 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.useNonIncrementalCalc !== undefined) {
                                    const _errs5 = errors;
                                    if (typeof data.useNonIncrementalCalc !== 'boolean') {
                                        validate26.errors = [
                                            {
                                                instancePath: instancePath + '/useNonIncrementalCalc',
                                                schemaPath: '#/properties/useNonIncrementalCalc/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs5 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate26.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate26.errors = vErrors;
    return errors === 0;
}
function validate25(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:ComputeTask" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.user === undefined && (missing0 = 'user')) ||
                (data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.mode === undefined && (missing0 = 'mode')) ||
                (data.objectID === undefined && (missing0 = 'objectID')) ||
                (data.taskID === undefined && (missing0 = 'taskID'))) {
                validate25.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.type !== undefined) {
                    let data0 = data.type;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate25.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'standard' || data0 === 'transient_pipe' || data0 === 'transient' || data0 === 'locking')) {
                        validate25.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema47.properties.type.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.taskID !== undefined) {
                        let data1 = data.taskID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate25.errors = [
                                        {
                                            instancePath: instancePath + '/taskID',
                                            schemaPath: '#/properties/taskID/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate25.errors = [
                                    {
                                        instancePath: instancePath + '/taskID',
                                        schemaPath: '#/properties/taskID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.user !== undefined) {
                            let data2 = data.user;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (errors === _errs5) {
                                    if (typeof data2 === 'string') {
                                        if (!formats6.test(data2)) {
                                            validate25.errors = [
                                                {
                                                    instancePath: instancePath + '/user',
                                                    schemaPath: '#/properties/user/format',
                                                    keyword: 'format',
                                                    params: { format: 'uuid' },
                                                    message: 'must match format "' + 'uuid' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate25.errors = [
                                            {
                                                instancePath: instancePath + '/user',
                                                schemaPath: '#/properties/user/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.userName !== undefined) {
                                const _errs7 = errors;
                                if (typeof data.userName !== 'string') {
                                    validate25.errors = [
                                        {
                                            instancePath: instancePath + '/userName',
                                            schemaPath: '#/properties/userName/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.userEmail !== undefined) {
                                    const _errs9 = errors;
                                    if (typeof data.userEmail !== 'string') {
                                        validate25.errors = [
                                            {
                                                instancePath: instancePath + '/userEmail',
                                                schemaPath: '#/properties/userEmail/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.orgID !== undefined) {
                                        let data5 = data.orgID;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (errors === _errs11) {
                                                if (typeof data5 === 'string') {
                                                    if (!formats6.test(data5)) {
                                                        validate25.errors = [
                                                            {
                                                                instancePath: instancePath + '/orgID',
                                                                schemaPath: '#/properties/orgID/format',
                                                                keyword: 'format',
                                                                params: { format: 'uuid' },
                                                                message: 'must match format "' + 'uuid' + '"'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate25.errors = [
                                                        {
                                                            instancePath: instancePath + '/orgID',
                                                            schemaPath: '#/properties/orgID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.orgPlan !== undefined) {
                                            let data6 = data.orgPlan;
                                            const _errs13 = errors;
                                            if (typeof data6 !== 'string') {
                                                validate25.errors = [
                                                    {
                                                        instancePath: instancePath + '/orgPlan',
                                                        schemaPath: '#/properties/orgPlan/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            if (!(data6 === 'Social' ||
                                                data6 === 'Enterprise' ||
                                                data6 === 'Integration' ||
                                                data6 === 'Temp' ||
                                                data6 === 'Starter' ||
                                                data6 === 'Professional')) {
                                                validate25.errors = [
                                                    {
                                                        instancePath: instancePath + '/orgPlan',
                                                        schemaPath: '#/properties/orgPlan/enum',
                                                        keyword: 'enum',
                                                        params: { allowedValues: schema47.properties.orgPlan.enum },
                                                        message: 'must be equal to one of the allowed values'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.mode !== undefined) {
                                                let data7 = data.mode;
                                                const _errs15 = errors;
                                                if (typeof data7 !== 'string') {
                                                    validate25.errors = [
                                                        {
                                                            instancePath: instancePath + '/mode',
                                                            schemaPath: '#/properties/mode/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                if (!(data7 === 'standard' || data7 === 'big')) {
                                                    validate25.errors = [
                                                        {
                                                            instancePath: instancePath + '/mode',
                                                            schemaPath: '#/properties/mode/enum',
                                                            keyword: 'enum',
                                                            params: { allowedValues: schema47.properties.mode.enum },
                                                            message: 'must be equal to one of the allowed values'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid0 = _errs15 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.objectID !== undefined) {
                                                    let data8 = data.objectID;
                                                    const _errs17 = errors;
                                                    if (errors === _errs17) {
                                                        if (typeof data8 === 'string') {
                                                            if (func2(data8) < 1) {
                                                                validate25.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/objectID',
                                                                        schemaPath: '#/properties/objectID/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 1 },
                                                                        message: 'must NOT have fewer than 1 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate25.errors = [
                                                                {
                                                                    instancePath: instancePath + '/objectID',
                                                                    schemaPath: '#/properties/objectID/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid0 = _errs17 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.runName !== undefined) {
                                                        const _errs19 = errors;
                                                        if (typeof data.runName !== 'string') {
                                                            validate25.errors = [
                                                                {
                                                                    instancePath: instancePath + '/runName',
                                                                    schemaPath: '#/properties/runName/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid0 = _errs19 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (data.pythonEngineVersion !== undefined) {
                                                            let data10 = data.pythonEngineVersion;
                                                            const _errs21 = errors;
                                                            if (typeof data10 !== 'string') {
                                                                validate25.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/pythonEngineVersion',
                                                                        schemaPath: '#/properties/pythonEngineVersion/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            if (!(data10 === '1' || data10 === '2' || data10 === '3')) {
                                                                validate25.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/pythonEngineVersion',
                                                                        schemaPath: '#/properties/pythonEngineVersion/enum',
                                                                        keyword: 'enum',
                                                                        params: { allowedValues: schema47.properties.pythonEngineVersion.enum },
                                                                        message: 'must be equal to one of the allowed values'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid0 = _errs21 === errors;
                                                        }
                                                        else {
                                                            var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                            if (data.sparkEngineVersion !== undefined) {
                                                                let data11 = data.sparkEngineVersion;
                                                                const _errs23 = errors;
                                                                if (typeof data11 !== 'string') {
                                                                    validate25.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/sparkEngineVersion',
                                                                            schemaPath: '#/properties/sparkEngineVersion/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                if (!(data11 === '1' || data11 === '2')) {
                                                                    validate25.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/sparkEngineVersion',
                                                                            schemaPath: '#/properties/sparkEngineVersion/enum',
                                                                            keyword: 'enum',
                                                                            params: { allowedValues: schema47.properties.sparkEngineVersion.enum },
                                                                            message: 'must be equal to one of the allowed values'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid0 = _errs23 === errors;
                                                            }
                                                            else {
                                                                var valid0 = true;
                                                            }
                                                            if (valid0) {
                                                                if (data.extras !== undefined) {
                                                                    let data12 = data.extras;
                                                                    const _errs25 = errors;
                                                                    if (errors === _errs25) {
                                                                        if (Array.isArray(data12)) {
                                                                            var valid1 = true;
                                                                            const len0 = data12.length;
                                                                            for (let i0 = 0; i0 < len0; i0++) {
                                                                                const _errs27 = errors;
                                                                                if (typeof data12[i0] !== 'string') {
                                                                                    validate25.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/extras/' + i0,
                                                                                            schemaPath: '#/properties/extras/items/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                var valid1 = _errs27 === errors;
                                                                                if (!valid1) {
                                                                                    break;
                                                                                }
                                                                            }
                                                                            if (valid1) {
                                                                                let i1 = data12.length;
                                                                                let j0;
                                                                                if (i1 > 1) {
                                                                                    const indices0 = {};
                                                                                    for (; i1--;) {
                                                                                        let item0 = data12[i1];
                                                                                        if (typeof item0 !== 'string') {
                                                                                            continue;
                                                                                        }
                                                                                        if (typeof indices0[item0] == 'number') {
                                                                                            j0 = indices0[item0];
                                                                                            validate25.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/extras',
                                                                                                    schemaPath: '#/properties/extras/uniqueItems',
                                                                                                    keyword: 'uniqueItems',
                                                                                                    params: { i: i1, j: j0 },
                                                                                                    message: 'must NOT have duplicate items (items ## ' +
                                                                                                        j0 +
                                                                                                        ' and ' +
                                                                                                        i1 +
                                                                                                        ' are identical)'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                            break;
                                                                                        }
                                                                                        indices0[item0] = i1;
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate25.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/extras',
                                                                                    schemaPath: '#/properties/extras/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'array' },
                                                                                    message: 'must be array'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid0 = _errs25 === errors;
                                                                }
                                                                else {
                                                                    var valid0 = true;
                                                                }
                                                                if (valid0) {
                                                                    if (data.incentivesComposerCalcConfig !== undefined) {
                                                                        const _errs29 = errors;
                                                                        if (!validate26(data.incentivesComposerCalcConfig, {
                                                                            instancePath: instancePath + '/incentivesComposerCalcConfig',
                                                                            parentData: data,
                                                                            parentDataProperty: 'incentivesComposerCalcConfig',
                                                                            rootData
                                                                        })) {
                                                                            vErrors =
                                                                                vErrors === null ? validate26.errors : vErrors.concat(validate26.errors);
                                                                            errors = vErrors.length;
                                                                        }
                                                                        var valid0 = _errs29 === errors;
                                                                    }
                                                                    else {
                                                                        var valid0 = true;
                                                                    }
                                                                    if (valid0) {
                                                                        if (data.triggerDependeeCalc !== undefined) {
                                                                            const _errs30 = errors;
                                                                            if (typeof data.triggerDependeeCalc !== 'boolean') {
                                                                                validate25.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/triggerDependeeCalc',
                                                                                        schemaPath: '#/properties/triggerDependeeCalc/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'boolean' },
                                                                                        message: 'must be boolean'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            var valid0 = _errs30 === errors;
                                                                        }
                                                                        else {
                                                                            var valid0 = true;
                                                                        }
                                                                        if (valid0) {
                                                                            if (data.dependeeAncestors !== undefined) {
                                                                                let data16 = data.dependeeAncestors;
                                                                                const _errs32 = errors;
                                                                                if (errors === _errs32) {
                                                                                    if (Array.isArray(data16)) {
                                                                                        var valid3 = true;
                                                                                        const len1 = data16.length;
                                                                                        for (let i2 = 0; i2 < len1; i2++) {
                                                                                            const _errs34 = errors;
                                                                                            if (typeof data16[i2] !== 'string') {
                                                                                                validate25.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/dependeeAncestors/' + i2,
                                                                                                        schemaPath: '#/properties/dependeeAncestors/items/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'string' },
                                                                                                        message: 'must be string'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                            var valid3 = _errs34 === errors;
                                                                                            if (!valid3) {
                                                                                                break;
                                                                                            }
                                                                                        }
                                                                                        if (valid3) {
                                                                                            let i3 = data16.length;
                                                                                            let j1;
                                                                                            if (i3 > 1) {
                                                                                                const indices1 = {};
                                                                                                for (; i3--;) {
                                                                                                    let item1 = data16[i3];
                                                                                                    if (typeof item1 !== 'string') {
                                                                                                        continue;
                                                                                                    }
                                                                                                    if (typeof indices1[item1] == 'number') {
                                                                                                        j1 = indices1[item1];
                                                                                                        validate25.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/dependeeAncestors',
                                                                                                                schemaPath: '#/properties/dependeeAncestors/uniqueItems',
                                                                                                                keyword: 'uniqueItems',
                                                                                                                params: { i: i3, j: j1 },
                                                                                                                message: 'must NOT have duplicate items (items ## ' +
                                                                                                                    j1 +
                                                                                                                    ' and ' +
                                                                                                                    i3 +
                                                                                                                    ' are identical)'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                        break;
                                                                                                    }
                                                                                                    indices1[item1] = i3;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate25.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/dependeeAncestors',
                                                                                                schemaPath: '#/properties/dependeeAncestors/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'array' },
                                                                                                message: 'must be array'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid0 = _errs32 === errors;
                                                                            }
                                                                            else {
                                                                                var valid0 = true;
                                                                            }
                                                                            if (valid0) {
                                                                                if (data.rootTaskID !== undefined) {
                                                                                    const _errs36 = errors;
                                                                                    if (typeof data.rootTaskID !== 'string') {
                                                                                        validate25.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/rootTaskID',
                                                                                                schemaPath: '#/properties/rootTaskID/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    var valid0 = _errs36 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid0 = true;
                                                                                }
                                                                                if (valid0) {
                                                                                    if (data.rootStart !== undefined) {
                                                                                        let data19 = data.rootStart;
                                                                                        const _errs38 = errors;
                                                                                        if (errors === _errs38) {
                                                                                            if (errors === _errs38) {
                                                                                                if (typeof data19 === 'string') {
                                                                                                    if (!formats0.validate(data19)) {
                                                                                                        validate25.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/rootStart',
                                                                                                                schemaPath: '#/properties/rootStart/format',
                                                                                                                keyword: 'format',
                                                                                                                params: { format: 'date-time' },
                                                                                                                message: 'must match format "' + 'date-time' + '"'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    validate25.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/rootStart',
                                                                                                            schemaPath: '#/properties/rootStart/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'string' },
                                                                                                            message: 'must be string'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                        var valid0 = _errs38 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid0 = true;
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate25.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate25.errors = vErrors;
    return errors === 0;
}
function validate24(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:CalculationInput" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.calcTask !== undefined) {
                if (!validate25(data.calcTask, {
                    instancePath: instancePath + '/calcTask',
                    parentData: data,
                    parentDataProperty: 'calcTask',
                    rootData
                })) {
                    vErrors = vErrors === null ? validate25.errors : vErrors.concat(validate25.errors);
                    errors = vErrors.length;
                }
            }
        }
        else {
            validate24.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate24.errors = vErrors;
    return errors === 0;
}
export const calculationRequestSchemaValidation = validate34;
const schema52 = {
    $id: 'urn:wisepipe-common-computation:CalculationRequest',
    type: 'object',
    properties: {
        pipeID: { type: 'string', uid: 10 },
        incentivesComposerCalcConfig: { $ref: 'urn:wisepipe-common-computation:IncentivesComposerCalcConfig' },
        triggerDependeeCalc: { type: 'boolean' },
        externalID: { type: 'string', minLength: 1 }
    },
    required: ['pipeID']
};
const func46 = ucs2length;
const func47 = base64urlToBuffer;
const func48 = base64urlEncode;
const func49 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate34(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:CalculationRequest" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.pipeID === undefined && (missing0 = 'pipeID')) {
                validate34.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pipeID !== undefined) {
                    let data0 = data.pipeID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func46(data0) < b64min0 || func46(data0) > b64max0) {
                                validate34.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func46(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func46(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func47(data0);
                                if (decoded0.length !== 10) {
                                    validate34.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func48(decoded0);
                                    if (func49(encoded0) !== func49(data0)) {
                                        validate34.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate34.errors = [
                                {
                                    instancePath: instancePath + '/pipeID',
                                    schemaPath: '#/properties/pipeID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.incentivesComposerCalcConfig !== undefined) {
                        const _errs3 = errors;
                        if (!validate26(data.incentivesComposerCalcConfig, {
                            instancePath: instancePath + '/incentivesComposerCalcConfig',
                            parentData: data,
                            parentDataProperty: 'incentivesComposerCalcConfig',
                            rootData
                        })) {
                            vErrors = vErrors === null ? validate26.errors : vErrors.concat(validate26.errors);
                            errors = vErrors.length;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.triggerDependeeCalc !== undefined) {
                            const _errs4 = errors;
                            if (typeof data.triggerDependeeCalc !== 'boolean') {
                                validate34.errors = [
                                    {
                                        instancePath: instancePath + '/triggerDependeeCalc',
                                        schemaPath: '#/properties/triggerDependeeCalc/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs4 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.externalID !== undefined) {
                                let data3 = data.externalID;
                                const _errs6 = errors;
                                if (errors === _errs6) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) < 1) {
                                            validate34.errors = [
                                                {
                                                    instancePath: instancePath + '/externalID',
                                                    schemaPath: '#/properties/externalID/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate34.errors = [
                                            {
                                                instancePath: instancePath + '/externalID',
                                                schemaPath: '#/properties/externalID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs6 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate34.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate34.errors = vErrors;
    return errors === 0;
}
export const calculationSchemaValidation = validate36;
const schema53 = {
    $id: 'urn:wisepipe-common-computation:Calculation',
    type: 'object',
    properties: {
        pipeID: { type: 'string', uid: 10 },
        pipeName: { type: 'string', minLength: 1 },
        taskID: { type: 'string', minLength: 1 }
    },
    required: ['pipeID']
};
const func51 = ucs2length;
const func52 = base64urlToBuffer;
const func53 = base64urlEncode;
const func54 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate36(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:Calculation" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.pipeID === undefined && (missing0 = 'pipeID')) {
                validate36.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pipeID !== undefined) {
                    let data0 = data.pipeID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func51(data0) < b64min0 || func51(data0) > b64max0) {
                                validate36.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func51(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func51(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func52(data0);
                                if (decoded0.length !== 10) {
                                    validate36.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func53(decoded0);
                                    if (func54(encoded0) !== func54(data0)) {
                                        validate36.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate36.errors = [
                                {
                                    instancePath: instancePath + '/pipeID',
                                    schemaPath: '#/properties/pipeID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.pipeName !== undefined) {
                        let data1 = data.pipeName;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate36.errors = [
                                        {
                                            instancePath: instancePath + '/pipeName',
                                            schemaPath: '#/properties/pipeName/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate36.errors = [
                                    {
                                        instancePath: instancePath + '/pipeName',
                                        schemaPath: '#/properties/pipeName/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.taskID !== undefined) {
                            let data2 = data.taskID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate36.errors = [
                                            {
                                                instancePath: instancePath + '/taskID',
                                                schemaPath: '#/properties/taskID/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate36.errors = [
                                        {
                                            instancePath: instancePath + '/taskID',
                                            schemaPath: '#/properties/taskID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate36.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate36.errors = vErrors;
    return errors === 0;
}
export const calculationStatusCheckEventSchemaValidation = validate37;
const schema54 = {
    $id: 'urn:wisepipe-common-computation:CalculationStatusCheckEvent',
    type: 'object',
    properties: {
        status: { type: 'string', enum: ['running', 'failed', 'cancelled', 'completed'] },
        task: { $ref: 'urn:wisepipe-common-computation:ComputeTask' },
        pipeCreatedAt: { type: 'string', format: 'date-time' }
    },
    required: ['status', 'task', 'pipeCreatedAt']
};
function validate37(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:CalculationStatusCheckEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.status === undefined && (missing0 = 'status')) ||
                (data.task === undefined && (missing0 = 'task')) ||
                (data.pipeCreatedAt === undefined && (missing0 = 'pipeCreatedAt'))) {
                validate37.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.status !== undefined) {
                    let data0 = data.status;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate37.errors = [
                            {
                                instancePath: instancePath + '/status',
                                schemaPath: '#/properties/status/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'running' || data0 === 'failed' || data0 === 'cancelled' || data0 === 'completed')) {
                        validate37.errors = [
                            {
                                instancePath: instancePath + '/status',
                                schemaPath: '#/properties/status/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema54.properties.status.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.task !== undefined) {
                        const _errs3 = errors;
                        if (!validate25(data.task, {
                            instancePath: instancePath + '/task',
                            parentData: data,
                            parentDataProperty: 'task',
                            rootData
                        })) {
                            vErrors = vErrors === null ? validate25.errors : vErrors.concat(validate25.errors);
                            errors = vErrors.length;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.pipeCreatedAt !== undefined) {
                            let data2 = data.pipeCreatedAt;
                            const _errs4 = errors;
                            if (errors === _errs4) {
                                if (errors === _errs4) {
                                    if (typeof data2 === 'string') {
                                        if (!formats0.validate(data2)) {
                                            validate37.errors = [
                                                {
                                                    instancePath: instancePath + '/pipeCreatedAt',
                                                    schemaPath: '#/properties/pipeCreatedAt/format',
                                                    keyword: 'format',
                                                    params: { format: 'date-time' },
                                                    message: 'must match format "' + 'date-time' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate37.errors = [
                                            {
                                                instancePath: instancePath + '/pipeCreatedAt',
                                                schemaPath: '#/properties/pipeCreatedAt/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs4 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate37.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate37.errors = vErrors;
    return errors === 0;
}
export const candlestickVisualParamsSchemaValidation = validate39;
const schema55 = {
    $id: 'urn:wisepipe-common-computation:CandlestickVisualParams',
    type: 'object',
    properties: {
        xAxis: { type: 'string', minLength: 1 },
        low: { type: 'string', minLength: 1 },
        open: { type: 'string', minLength: 1 },
        close: { type: 'string', minLength: 1 },
        high: { type: 'string', minLength: 1 }
    },
    required: ['xAxis', 'low', 'open', 'close', 'high']
};
function validate39(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:CandlestickVisualParams" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.xAxis === undefined && (missing0 = 'xAxis')) ||
                (data.low === undefined && (missing0 = 'low')) ||
                (data.open === undefined && (missing0 = 'open')) ||
                (data.close === undefined && (missing0 = 'close')) ||
                (data.high === undefined && (missing0 = 'high'))) {
                validate39.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.xAxis !== undefined) {
                    let data0 = data.xAxis;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate39.errors = [
                                    {
                                        instancePath: instancePath + '/xAxis',
                                        schemaPath: '#/properties/xAxis/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate39.errors = [
                                {
                                    instancePath: instancePath + '/xAxis',
                                    schemaPath: '#/properties/xAxis/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.low !== undefined) {
                        let data1 = data.low;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate39.errors = [
                                        {
                                            instancePath: instancePath + '/low',
                                            schemaPath: '#/properties/low/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate39.errors = [
                                    {
                                        instancePath: instancePath + '/low',
                                        schemaPath: '#/properties/low/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.open !== undefined) {
                            let data2 = data.open;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate39.errors = [
                                            {
                                                instancePath: instancePath + '/open',
                                                schemaPath: '#/properties/open/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate39.errors = [
                                        {
                                            instancePath: instancePath + '/open',
                                            schemaPath: '#/properties/open/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.close !== undefined) {
                                let data3 = data.close;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) < 1) {
                                            validate39.errors = [
                                                {
                                                    instancePath: instancePath + '/close',
                                                    schemaPath: '#/properties/close/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate39.errors = [
                                            {
                                                instancePath: instancePath + '/close',
                                                schemaPath: '#/properties/close/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.high !== undefined) {
                                    let data4 = data.high;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (typeof data4 === 'string') {
                                            if (func2(data4) < 1) {
                                                validate39.errors = [
                                                    {
                                                        instancePath: instancePath + '/high',
                                                        schemaPath: '#/properties/high/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate39.errors = [
                                                {
                                                    instancePath: instancePath + '/high',
                                                    schemaPath: '#/properties/high/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate39.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate39.errors = vErrors;
    return errors === 0;
}
export const categoricalByCategoricalGraphSchemaValidation = validate40;
const schema56 = {
    $id: 'urn:wisepipe-common-computation:CategoricalByCategoricalGraph',
    type: 'object',
    properties: { data: { type: 'array', items: { $ref: 'urn:wisepipe-common-computation:BarChartData' } } },
    required: ['data']
};
function validate40(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:CategoricalByCategoricalGraph" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.data === undefined && (missing0 = 'data')) {
                validate40.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.data !== undefined) {
                    let data0 = data.data;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                const _errs3 = errors;
                                if (!validate13(data0[i0], {
                                    instancePath: instancePath + '/data/' + i0,
                                    parentData: data0,
                                    parentDataProperty: i0,
                                    rootData
                                })) {
                                    vErrors = vErrors === null ? validate13.errors : vErrors.concat(validate13.errors);
                                    errors = vErrors.length;
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                        }
                        else {
                            validate40.errors = [
                                {
                                    instancePath: instancePath + '/data',
                                    schemaPath: '#/properties/data/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate40.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate40.errors = vErrors;
    return errors === 0;
}
export const categoricalByDateGraphSchemaValidation = validate42;
const schema57 = {
    $id: 'urn:wisepipe-common-computation:CategoricalByDateGraph',
    type: 'object',
    properties: {
        dates: { type: 'array', items: { type: 'string', format: 'date-time' } },
        categories: { type: 'array', items: { type: 'string' } },
        data: { type: 'array', items: { type: 'array', items: { type: 'number' } } }
    },
    required: ['dates', 'categories', 'data']
};
function validate42(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:CategoricalByDateGraph" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.dates === undefined && (missing0 = 'dates')) ||
                (data.categories === undefined && (missing0 = 'categories')) ||
                (data.data === undefined && (missing0 = 'data'))) {
                validate42.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.dates !== undefined) {
                    let data0 = data.dates;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                let data1 = data0[i0];
                                const _errs3 = errors;
                                if (errors === _errs3) {
                                    if (errors === _errs3) {
                                        if (typeof data1 === 'string') {
                                            if (!formats0.validate(data1)) {
                                                validate42.errors = [
                                                    {
                                                        instancePath: instancePath + '/dates/' + i0,
                                                        schemaPath: '#/properties/dates/items/format',
                                                        keyword: 'format',
                                                        params: { format: 'date-time' },
                                                        message: 'must match format "' + 'date-time' + '"'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate42.errors = [
                                                {
                                                    instancePath: instancePath + '/dates/' + i0,
                                                    schemaPath: '#/properties/dates/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                        }
                        else {
                            validate42.errors = [
                                {
                                    instancePath: instancePath + '/dates',
                                    schemaPath: '#/properties/dates/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.categories !== undefined) {
                        let data2 = data.categories;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (Array.isArray(data2)) {
                                var valid2 = true;
                                const len1 = data2.length;
                                for (let i1 = 0; i1 < len1; i1++) {
                                    const _errs7 = errors;
                                    if (typeof data2[i1] !== 'string') {
                                        validate42.errors = [
                                            {
                                                instancePath: instancePath + '/categories/' + i1,
                                                schemaPath: '#/properties/categories/items/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid2 = _errs7 === errors;
                                    if (!valid2) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate42.errors = [
                                    {
                                        instancePath: instancePath + '/categories',
                                        schemaPath: '#/properties/categories/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.data !== undefined) {
                            let data4 = data.data;
                            const _errs9 = errors;
                            if (errors === _errs9) {
                                if (Array.isArray(data4)) {
                                    var valid3 = true;
                                    const len2 = data4.length;
                                    for (let i2 = 0; i2 < len2; i2++) {
                                        let data5 = data4[i2];
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (Array.isArray(data5)) {
                                                var valid4 = true;
                                                const len3 = data5.length;
                                                for (let i3 = 0; i3 < len3; i3++) {
                                                    const _errs13 = errors;
                                                    if (!(typeof data5[i3] == 'number')) {
                                                        validate42.errors = [
                                                            {
                                                                instancePath: instancePath + '/data/' + i2 + '/' + i3,
                                                                schemaPath: '#/properties/data/items/items/type',
                                                                keyword: 'type',
                                                                params: { type: 'number' },
                                                                message: 'must be number'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid4 = _errs13 === errors;
                                                    if (!valid4) {
                                                        break;
                                                    }
                                                }
                                            }
                                            else {
                                                validate42.errors = [
                                                    {
                                                        instancePath: instancePath + '/data/' + i2,
                                                        schemaPath: '#/properties/data/items/type',
                                                        keyword: 'type',
                                                        params: { type: 'array' },
                                                        message: 'must be array'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid3 = _errs11 === errors;
                                        if (!valid3) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate42.errors = [
                                        {
                                            instancePath: instancePath + '/data',
                                            schemaPath: '#/properties/data/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs9 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate42.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate42.errors = vErrors;
    return errors === 0;
}
export const circleVisualParamsSchemaValidation = validate43;
const schema58 = {
    $id: 'urn:wisepipe-common-computation:CircleVisualParams',
    type: 'object',
    properties: {
        subType: { type: 'string', enum: ['doughnut', 'pie', 'nested'] },
        label: { type: 'string', minLength: 1 },
        value: { type: 'string', minLength: 1 },
        aggOp: {
            type: 'string',
            enum: ['MAX', 'MIN', 'COUNT', 'SUM', 'AVG', 'OR', 'AND', 'MEDIAN', 'DIFF', 'PCT', 'SHIFT', 'STDEV']
        },
        subLabel: { type: 'string', minLength: 1 }
    },
    required: ['subType', 'label', 'value']
};
function validate43(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:CircleVisualParams" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.subType === undefined && (missing0 = 'subType')) ||
                (data.label === undefined && (missing0 = 'label')) ||
                (data.value === undefined && (missing0 = 'value'))) {
                validate43.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.subType !== undefined) {
                    let data0 = data.subType;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate43.errors = [
                            {
                                instancePath: instancePath + '/subType',
                                schemaPath: '#/properties/subType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'doughnut' || data0 === 'pie' || data0 === 'nested')) {
                        validate43.errors = [
                            {
                                instancePath: instancePath + '/subType',
                                schemaPath: '#/properties/subType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema58.properties.subType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.label !== undefined) {
                        let data1 = data.label;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate43.errors = [
                                        {
                                            instancePath: instancePath + '/label',
                                            schemaPath: '#/properties/label/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate43.errors = [
                                    {
                                        instancePath: instancePath + '/label',
                                        schemaPath: '#/properties/label/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.value !== undefined) {
                            let data2 = data.value;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate43.errors = [
                                            {
                                                instancePath: instancePath + '/value',
                                                schemaPath: '#/properties/value/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate43.errors = [
                                        {
                                            instancePath: instancePath + '/value',
                                            schemaPath: '#/properties/value/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.aggOp !== undefined) {
                                let data3 = data.aggOp;
                                const _errs7 = errors;
                                if (typeof data3 !== 'string') {
                                    validate43.errors = [
                                        {
                                            instancePath: instancePath + '/aggOp',
                                            schemaPath: '#/properties/aggOp/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data3 === 'MAX' ||
                                    data3 === 'MIN' ||
                                    data3 === 'COUNT' ||
                                    data3 === 'SUM' ||
                                    data3 === 'AVG' ||
                                    data3 === 'OR' ||
                                    data3 === 'AND' ||
                                    data3 === 'MEDIAN' ||
                                    data3 === 'DIFF' ||
                                    data3 === 'PCT' ||
                                    data3 === 'SHIFT' ||
                                    data3 === 'STDEV')) {
                                    validate43.errors = [
                                        {
                                            instancePath: instancePath + '/aggOp',
                                            schemaPath: '#/properties/aggOp/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema58.properties.aggOp.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.subLabel !== undefined) {
                                    let data4 = data.subLabel;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (typeof data4 === 'string') {
                                            if (func2(data4) < 1) {
                                                validate43.errors = [
                                                    {
                                                        instancePath: instancePath + '/subLabel',
                                                        schemaPath: '#/properties/subLabel/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate43.errors = [
                                                {
                                                    instancePath: instancePath + '/subLabel',
                                                    schemaPath: '#/properties/subLabel/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate43.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate43.errors = vErrors;
    return errors === 0;
}
export const columnInfoSchemaValidation = validate44;
const schema59 = {
    $id: 'urn:wisepipe-common-computation:ColumnInfo',
    type: 'object',
    properties: { required: { type: 'boolean' }, column: { $ref: 'urn:wisepipe-common-data:Column' } },
    required: ['required', 'column']
};
const schema60 = {
    $id: 'urn:wisepipe-common-data:Column',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1, maxLength: 150 },
        type: { type: 'string', pattern: 'number|date|string|boolean|decimal|period' },
        metadata: {
            type: 'object',
            oneOf: [
                {
                    if: { properties: { type: { const: 'period' } } },
                    then: { $ref: 'urn:wisepipe-common-data:PeriodColumnMetadata' }
                },
                {
                    if: { properties: { type: { const: 'string' } } },
                    then: { $ref: 'urn:wisepipe-common-data:PicklistColumnMetadata' }
                }
            ]
        },
        isPrimaryKey: { type: 'boolean' }
    },
    required: ['name', 'type'],
    allOf: [
        {
            if: { properties: { type: { const: 'period' } } },
            then: {
                required: ['metadata'],
                properties: { metadata: { $ref: 'urn:wisepipe-common-data:PeriodColumnMetadata' } }
            }
        },
        {
            if: { properties: { type: { const: 'string' } } },
            then: { properties: { metadata: { $ref: 'urn:wisepipe-common-data:PicklistColumnMetadata' } } }
        },
        {
            if: { properties: { type: { enum: ['boolean', 'number', 'decimal', 'date'] } } },
            then: { not: { required: ['metadata'] } }
        }
    ]
};
const schema61 = {
    $id: 'urn:wisepipe-common-data:PeriodColumnMetadata',
    type: 'object',
    properties: { calendarID: { type: 'string', minLength: 1 }, level: { type: 'string', minLength: 1 } },
    required: ['calendarID', 'level']
};
const schema62 = {
    $id: 'urn:wisepipe-common-data:PicklistColumnMetadata',
    type: 'object',
    properties: { table: { type: 'string', minLength: 1 }, column: { type: 'string', minLength: 1 } },
    required: ['table', 'column']
};
const pattern0 = new RegExp('number|date|string|boolean|decimal|period', 'u');
function validate45(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:Column" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    const _errs2 = errors;
    let valid1 = true;
    const _errs3 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.type !== undefined) {
            if ('period' !== data.type) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs3 === errors;
    errors = _errs2;
    if (vErrors !== null) {
        if (_errs2) {
            vErrors.length = _errs2;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.metadata === undefined && (missing0 = 'metadata')) {
                validate45.errors = [
                    {
                        instancePath,
                        schemaPath: '#/allOf/0/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.metadata !== undefined) {
                    let data1 = data.metadata;
                    const _errs7 = errors;
                    if (errors === _errs7) {
                        if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                            let missing1;
                            if ((data1.calendarID === undefined && (missing1 = 'calendarID')) ||
                                (data1.level === undefined && (missing1 = 'level'))) {
                                validate45.errors = [
                                    {
                                        instancePath: instancePath + '/metadata',
                                        schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data1.calendarID !== undefined) {
                                    let data2 = data1.calendarID;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (typeof data2 === 'string') {
                                            if (func2(data2) < 1) {
                                                validate45.errors = [
                                                    {
                                                        instancePath: instancePath + '/metadata/calendarID',
                                                        schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/calendarID/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate45.errors = [
                                                {
                                                    instancePath: instancePath + '/metadata/calendarID',
                                                    schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/calendarID/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid5 = _errs9 === errors;
                                }
                                else {
                                    var valid5 = true;
                                }
                                if (valid5) {
                                    if (data1.level !== undefined) {
                                        let data3 = data1.level;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (typeof data3 === 'string') {
                                                if (func2(data3) < 1) {
                                                    validate45.errors = [
                                                        {
                                                            instancePath: instancePath + '/metadata/level',
                                                            schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/level/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate45.errors = [
                                                    {
                                                        instancePath: instancePath + '/metadata/level',
                                                        schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/level/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid5 = _errs11 === errors;
                                    }
                                    else {
                                        var valid5 = true;
                                    }
                                }
                            }
                        }
                        else {
                            validate45.errors = [
                                {
                                    instancePath: instancePath + '/metadata',
                                    schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        var _valid0 = _errs5 === errors;
        valid1 = _valid0;
    }
    if (!valid1) {
        const err1 = {
            instancePath,
            schemaPath: '#/allOf/0/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate45.errors = vErrors;
        return false;
    }
    var valid0 = _errs1 === errors;
    if (valid0) {
        const _errs13 = errors;
        const _errs14 = errors;
        let valid6 = true;
        const _errs15 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.type !== undefined) {
                if ('string' !== data.type) {
                    const err2 = {};
                    if (vErrors === null) {
                        vErrors = [err2];
                    }
                    else {
                        vErrors.push(err2);
                    }
                    errors++;
                }
            }
        }
        var _valid1 = _errs15 === errors;
        errors = _errs14;
        if (vErrors !== null) {
            if (_errs14) {
                vErrors.length = _errs14;
            }
            else {
                vErrors = null;
            }
        }
        if (_valid1) {
            const _errs17 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                if (data.metadata !== undefined) {
                    let data5 = data.metadata;
                    const _errs19 = errors;
                    if (errors === _errs19) {
                        if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                            let missing2;
                            if ((data5.table === undefined && (missing2 = 'table')) ||
                                (data5.column === undefined && (missing2 = 'column'))) {
                                validate45.errors = [
                                    {
                                        instancePath: instancePath + '/metadata',
                                        schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing2 },
                                        message: "must have required property '" + missing2 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data5.table !== undefined) {
                                    let data6 = data5.table;
                                    const _errs21 = errors;
                                    if (errors === _errs21) {
                                        if (typeof data6 === 'string') {
                                            if (func2(data6) < 1) {
                                                validate45.errors = [
                                                    {
                                                        instancePath: instancePath + '/metadata/table',
                                                        schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/table/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate45.errors = [
                                                {
                                                    instancePath: instancePath + '/metadata/table',
                                                    schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/table/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid10 = _errs21 === errors;
                                }
                                else {
                                    var valid10 = true;
                                }
                                if (valid10) {
                                    if (data5.column !== undefined) {
                                        let data7 = data5.column;
                                        const _errs23 = errors;
                                        if (errors === _errs23) {
                                            if (typeof data7 === 'string') {
                                                if (func2(data7) < 1) {
                                                    validate45.errors = [
                                                        {
                                                            instancePath: instancePath + '/metadata/column',
                                                            schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/column/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate45.errors = [
                                                    {
                                                        instancePath: instancePath + '/metadata/column',
                                                        schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/column/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid10 = _errs23 === errors;
                                    }
                                    else {
                                        var valid10 = true;
                                    }
                                }
                            }
                        }
                        else {
                            validate45.errors = [
                                {
                                    instancePath: instancePath + '/metadata',
                                    schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
            var _valid1 = _errs17 === errors;
            valid6 = _valid1;
        }
        if (!valid6) {
            const err3 = {
                instancePath,
                schemaPath: '#/allOf/1/if',
                keyword: 'if',
                params: { failingKeyword: 'then' },
                message: 'must match "then" schema'
            };
            if (vErrors === null) {
                vErrors = [err3];
            }
            else {
                vErrors.push(err3);
            }
            errors++;
            validate45.errors = vErrors;
            return false;
        }
        var valid0 = _errs13 === errors;
        if (valid0) {
            const _errs25 = errors;
            const _errs26 = errors;
            let valid11 = true;
            const _errs27 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                if (data.type !== undefined) {
                    let data8 = data.type;
                    if (!(data8 === 'boolean' || data8 === 'number' || data8 === 'decimal' || data8 === 'date')) {
                        const err4 = {};
                        if (vErrors === null) {
                            vErrors = [err4];
                        }
                        else {
                            vErrors.push(err4);
                        }
                        errors++;
                    }
                }
            }
            var _valid2 = _errs27 === errors;
            errors = _errs26;
            if (vErrors !== null) {
                if (_errs26) {
                    vErrors.length = _errs26;
                }
                else {
                    vErrors = null;
                }
            }
            if (_valid2) {
                const _errs29 = errors;
                const _errs30 = errors;
                const _errs31 = errors;
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    let missing3;
                    if (data.metadata === undefined && (missing3 = 'metadata')) {
                        const err5 = {};
                        if (vErrors === null) {
                            vErrors = [err5];
                        }
                        else {
                            vErrors.push(err5);
                        }
                        errors++;
                    }
                }
                var valid13 = _errs31 === errors;
                if (valid13) {
                    validate45.errors = [
                        { instancePath, schemaPath: '#/allOf/2/then/not', keyword: 'not', params: {}, message: 'must NOT be valid' }
                    ];
                    return false;
                }
                else {
                    errors = _errs30;
                    if (vErrors !== null) {
                        if (_errs30) {
                            vErrors.length = _errs30;
                        }
                        else {
                            vErrors = null;
                        }
                    }
                }
                var _valid2 = _errs29 === errors;
                valid11 = _valid2;
            }
            if (!valid11) {
                const err6 = {
                    instancePath,
                    schemaPath: '#/allOf/2/if',
                    keyword: 'if',
                    params: { failingKeyword: 'then' },
                    message: 'must match "then" schema'
                };
                if (vErrors === null) {
                    vErrors = [err6];
                }
                else {
                    vErrors.push(err6);
                }
                errors++;
                validate45.errors = vErrors;
                return false;
            }
            var valid0 = _errs25 === errors;
        }
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing4;
            if ((data.name === undefined && (missing4 = 'name')) || (data.type === undefined && (missing4 = 'type'))) {
                validate45.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing4 },
                        message: "must have required property '" + missing4 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data9 = data.name;
                    const _errs32 = errors;
                    if (errors === _errs32) {
                        if (typeof data9 === 'string') {
                            if (func2(data9) > 150) {
                                validate45.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 150 },
                                        message: 'must NOT have more than 150 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data9) < 1) {
                                    validate45.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate45.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid14 = _errs32 === errors;
                }
                else {
                    var valid14 = true;
                }
                if (valid14) {
                    if (data.type !== undefined) {
                        let data10 = data.type;
                        const _errs34 = errors;
                        if (errors === _errs34) {
                            if (typeof data10 === 'string') {
                                if (!pattern0.test(data10)) {
                                    validate45.errors = [
                                        {
                                            instancePath: instancePath + '/type',
                                            schemaPath: '#/properties/type/pattern',
                                            keyword: 'pattern',
                                            params: { pattern: 'number|date|string|boolean|decimal|period' },
                                            message: 'must match pattern "' + 'number|date|string|boolean|decimal|period' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate45.errors = [
                                    {
                                        instancePath: instancePath + '/type',
                                        schemaPath: '#/properties/type/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid14 = _errs34 === errors;
                    }
                    else {
                        var valid14 = true;
                    }
                    if (valid14) {
                        if (data.metadata !== undefined) {
                            let data11 = data.metadata;
                            const _errs36 = errors;
                            if (!(data11 && typeof data11 == 'object' && !Array.isArray(data11))) {
                                validate45.errors = [
                                    {
                                        instancePath: instancePath + '/metadata',
                                        schemaPath: '#/properties/metadata/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                            const _errs38 = errors;
                            let valid15 = false;
                            let passing0 = null;
                            const _errs39 = errors;
                            const _errs40 = errors;
                            let valid16 = true;
                            const _errs41 = errors;
                            if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                if (data11.type !== undefined) {
                                    if ('period' !== data11.type) {
                                        const err7 = {};
                                        if (vErrors === null) {
                                            vErrors = [err7];
                                        }
                                        else {
                                            vErrors.push(err7);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            var _valid4 = _errs41 === errors;
                            errors = _errs40;
                            if (vErrors !== null) {
                                if (_errs40) {
                                    vErrors.length = _errs40;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                            if (_valid4) {
                                const _errs43 = errors;
                                const _errs44 = errors;
                                if (errors === _errs44) {
                                    if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                        let missing5;
                                        if ((data11.calendarID === undefined && (missing5 = 'calendarID')) ||
                                            (data11.level === undefined && (missing5 = 'level'))) {
                                            const err8 = {
                                                instancePath: instancePath + '/metadata',
                                                schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing5 },
                                                message: "must have required property '" + missing5 + "'"
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err8];
                                            }
                                            else {
                                                vErrors.push(err8);
                                            }
                                            errors++;
                                        }
                                        else {
                                            if (data11.calendarID !== undefined) {
                                                let data13 = data11.calendarID;
                                                const _errs46 = errors;
                                                if (errors === _errs46) {
                                                    if (typeof data13 === 'string') {
                                                        if (func2(data13) < 1) {
                                                            const err9 = {
                                                                instancePath: instancePath + '/metadata/calendarID',
                                                                schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/calendarID/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err9];
                                                            }
                                                            else {
                                                                vErrors.push(err9);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    else {
                                                        const err10 = {
                                                            instancePath: instancePath + '/metadata/calendarID',
                                                            schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/calendarID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err10];
                                                        }
                                                        else {
                                                            vErrors.push(err10);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                                var valid19 = _errs46 === errors;
                                            }
                                            else {
                                                var valid19 = true;
                                            }
                                            if (valid19) {
                                                if (data11.level !== undefined) {
                                                    let data14 = data11.level;
                                                    const _errs48 = errors;
                                                    if (errors === _errs48) {
                                                        if (typeof data14 === 'string') {
                                                            if (func2(data14) < 1) {
                                                                const err11 = {
                                                                    instancePath: instancePath + '/metadata/level',
                                                                    schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/level/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                };
                                                                if (vErrors === null) {
                                                                    vErrors = [err11];
                                                                }
                                                                else {
                                                                    vErrors.push(err11);
                                                                }
                                                                errors++;
                                                            }
                                                        }
                                                        else {
                                                            const err12 = {
                                                                instancePath: instancePath + '/metadata/level',
                                                                schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/level/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err12];
                                                            }
                                                            else {
                                                                vErrors.push(err12);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    var valid19 = _errs48 === errors;
                                                }
                                                else {
                                                    var valid19 = true;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        const err13 = {
                                            instancePath: instancePath + '/metadata',
                                            schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err13];
                                        }
                                        else {
                                            vErrors.push(err13);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid4 = _errs43 === errors;
                                valid16 = _valid4;
                            }
                            if (!valid16) {
                                const err14 = {
                                    instancePath: instancePath + '/metadata',
                                    schemaPath: '#/properties/metadata/oneOf/0/if',
                                    keyword: 'if',
                                    params: { failingKeyword: 'then' },
                                    message: 'must match "then" schema'
                                };
                                if (vErrors === null) {
                                    vErrors = [err14];
                                }
                                else {
                                    vErrors.push(err14);
                                }
                                errors++;
                            }
                            var _valid3 = _errs39 === errors;
                            if (_valid3) {
                                valid15 = true;
                                passing0 = 0;
                            }
                            const _errs50 = errors;
                            const _errs51 = errors;
                            let valid20 = true;
                            const _errs52 = errors;
                            if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                if (data11.type !== undefined) {
                                    if ('string' !== data11.type) {
                                        const err15 = {};
                                        if (vErrors === null) {
                                            vErrors = [err15];
                                        }
                                        else {
                                            vErrors.push(err15);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            var _valid5 = _errs52 === errors;
                            errors = _errs51;
                            if (vErrors !== null) {
                                if (_errs51) {
                                    vErrors.length = _errs51;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                            if (_valid5) {
                                const _errs54 = errors;
                                const _errs55 = errors;
                                if (errors === _errs55) {
                                    if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                        let missing6;
                                        if ((data11.table === undefined && (missing6 = 'table')) ||
                                            (data11.column === undefined && (missing6 = 'column'))) {
                                            const err16 = {
                                                instancePath: instancePath + '/metadata',
                                                schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing6 },
                                                message: "must have required property '" + missing6 + "'"
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err16];
                                            }
                                            else {
                                                vErrors.push(err16);
                                            }
                                            errors++;
                                        }
                                        else {
                                            if (data11.table !== undefined) {
                                                let data16 = data11.table;
                                                const _errs57 = errors;
                                                if (errors === _errs57) {
                                                    if (typeof data16 === 'string') {
                                                        if (func2(data16) < 1) {
                                                            const err17 = {
                                                                instancePath: instancePath + '/metadata/table',
                                                                schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/table/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err17];
                                                            }
                                                            else {
                                                                vErrors.push(err17);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    else {
                                                        const err18 = {
                                                            instancePath: instancePath + '/metadata/table',
                                                            schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/table/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err18];
                                                        }
                                                        else {
                                                            vErrors.push(err18);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                                var valid23 = _errs57 === errors;
                                            }
                                            else {
                                                var valid23 = true;
                                            }
                                            if (valid23) {
                                                if (data11.column !== undefined) {
                                                    let data17 = data11.column;
                                                    const _errs59 = errors;
                                                    if (errors === _errs59) {
                                                        if (typeof data17 === 'string') {
                                                            if (func2(data17) < 1) {
                                                                const err19 = {
                                                                    instancePath: instancePath + '/metadata/column',
                                                                    schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/column/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                };
                                                                if (vErrors === null) {
                                                                    vErrors = [err19];
                                                                }
                                                                else {
                                                                    vErrors.push(err19);
                                                                }
                                                                errors++;
                                                            }
                                                        }
                                                        else {
                                                            const err20 = {
                                                                instancePath: instancePath + '/metadata/column',
                                                                schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/column/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err20];
                                                            }
                                                            else {
                                                                vErrors.push(err20);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    var valid23 = _errs59 === errors;
                                                }
                                                else {
                                                    var valid23 = true;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        const err21 = {
                                            instancePath: instancePath + '/metadata',
                                            schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err21];
                                        }
                                        else {
                                            vErrors.push(err21);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid5 = _errs54 === errors;
                                valid20 = _valid5;
                            }
                            if (!valid20) {
                                const err22 = {
                                    instancePath: instancePath + '/metadata',
                                    schemaPath: '#/properties/metadata/oneOf/1/if',
                                    keyword: 'if',
                                    params: { failingKeyword: 'then' },
                                    message: 'must match "then" schema'
                                };
                                if (vErrors === null) {
                                    vErrors = [err22];
                                }
                                else {
                                    vErrors.push(err22);
                                }
                                errors++;
                            }
                            var _valid3 = _errs50 === errors;
                            if (_valid3 && valid15) {
                                valid15 = false;
                                passing0 = [passing0, 1];
                            }
                            else {
                                if (_valid3) {
                                    valid15 = true;
                                    passing0 = 1;
                                }
                            }
                            if (!valid15) {
                                const err23 = {
                                    instancePath: instancePath + '/metadata',
                                    schemaPath: '#/properties/metadata/oneOf',
                                    keyword: 'oneOf',
                                    params: { passingSchemas: passing0 },
                                    message: 'must match exactly one schema in oneOf'
                                };
                                if (vErrors === null) {
                                    vErrors = [err23];
                                }
                                else {
                                    vErrors.push(err23);
                                }
                                errors++;
                                validate45.errors = vErrors;
                                return false;
                            }
                            else {
                                errors = _errs38;
                                if (vErrors !== null) {
                                    if (_errs38) {
                                        vErrors.length = _errs38;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                            }
                            var valid14 = _errs36 === errors;
                        }
                        else {
                            var valid14 = true;
                        }
                        if (valid14) {
                            if (data.isPrimaryKey !== undefined) {
                                const _errs61 = errors;
                                if (typeof data.isPrimaryKey !== 'boolean') {
                                    validate45.errors = [
                                        {
                                            instancePath: instancePath + '/isPrimaryKey',
                                            schemaPath: '#/properties/isPrimaryKey/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean'
                                        }
                                    ];
                                    return false;
                                }
                                var valid14 = _errs61 === errors;
                            }
                            else {
                                var valid14 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate45.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate45.errors = vErrors;
    return errors === 0;
}
function validate44(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:ColumnInfo" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.required === undefined && (missing0 = 'required')) ||
                (data.column === undefined && (missing0 = 'column'))) {
                validate44.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.required !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.required !== 'boolean') {
                        validate44.errors = [
                            {
                                instancePath: instancePath + '/required',
                                schemaPath: '#/properties/required/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.column !== undefined) {
                        const _errs3 = errors;
                        if (!validate45(data.column, {
                            instancePath: instancePath + '/column',
                            parentData: data,
                            parentDataProperty: 'column',
                            rootData
                        })) {
                            vErrors = vErrors === null ? validate45.errors : vErrors.concat(validate45.errors);
                            errors = vErrors.length;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate44.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate44.errors = vErrors;
    return errors === 0;
}
export const columnSchemaValidation = validate45;
export const columnToolVariableSchemaValidation = validate47;
function validate47(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:ColumnToolVariable" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate47.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate47.errors = vErrors;
    return errors === 0;
}
export const columnUpdateSchemaValidation = validate48;
const schema66 = {
    $id: 'urn:wisepipe-common-data:ColumnUpdate',
    type: 'object',
    properties: {
        column: { type: 'string' },
        columnUpdateType: { type: 'string', enum: ['drop', 'mask', 'modify'] },
        type: { type: 'string', enum: ['number', 'string', 'boolean', 'date', 'decimal'] },
        targetType: { type: 'string', enum: ['number', 'string', 'boolean', 'date', 'decimal'] },
        dateFormat: { type: 'string', minLength: 1 }
    },
    if: { properties: { columnUpdateType: { const: 'modify' } } },
    then: {
        required: ['type', 'targetType'],
        if: { properties: { targetType: { const: 'date' } }, required: ['targetType'] },
        then: { required: ['dateFormat'] }
    },
    required: ['column', 'columnUpdateType']
};
function validate48(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ColumnUpdate" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.columnUpdateType !== undefined) {
            if ('modify' !== data.columnUpdateType) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs4 = errors;
        const _errs5 = errors;
        let valid2 = true;
        const _errs6 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.targetType === undefined && (missing0 = 'targetType')) {
                const err1 = {};
                if (vErrors === null) {
                    vErrors = [err1];
                }
                else {
                    vErrors.push(err1);
                }
                errors++;
            }
            else {
                if (data.targetType !== undefined) {
                    if ('date' !== data.targetType) {
                        const err2 = {};
                        if (vErrors === null) {
                            vErrors = [err2];
                        }
                        else {
                            vErrors.push(err2);
                        }
                        errors++;
                    }
                }
            }
        }
        var _valid1 = _errs6 === errors;
        errors = _errs5;
        if (vErrors !== null) {
            if (_errs5) {
                vErrors.length = _errs5;
            }
            else {
                vErrors = null;
            }
        }
        if (_valid1) {
            const _errs8 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing1;
                if (data.dateFormat === undefined && (missing1 = 'dateFormat')) {
                    validate48.errors = [
                        {
                            instancePath,
                            schemaPath: '#/then/then/required',
                            keyword: 'required',
                            params: { missingProperty: missing1 },
                            message: "must have required property '" + missing1 + "'"
                        }
                    ];
                    return false;
                }
            }
            var _valid1 = _errs8 === errors;
            valid2 = _valid1;
        }
        if (!valid2) {
            const err3 = {
                instancePath,
                schemaPath: '#/then/if',
                keyword: 'if',
                params: { failingKeyword: 'then' },
                message: 'must match "then" schema'
            };
            if (vErrors === null) {
                vErrors = [err3];
            }
            else {
                vErrors.push(err3);
            }
            errors++;
            validate48.errors = vErrors;
            return false;
        }
        if (errors === _errs4) {
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing2;
                if ((data.type === undefined && (missing2 = 'type')) ||
                    (data.targetType === undefined && (missing2 = 'targetType'))) {
                    validate48.errors = [
                        {
                            instancePath,
                            schemaPath: '#/then/required',
                            keyword: 'required',
                            params: { missingProperty: missing2 },
                            message: "must have required property '" + missing2 + "'"
                        }
                    ];
                    return false;
                }
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err4 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err4];
        }
        else {
            vErrors.push(err4);
        }
        errors++;
        validate48.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing3;
            if ((data.column === undefined && (missing3 = 'column')) ||
                (data.columnUpdateType === undefined && (missing3 = 'columnUpdateType'))) {
                validate48.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing3 },
                        message: "must have required property '" + missing3 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.column !== undefined) {
                    const _errs9 = errors;
                    if (typeof data.column !== 'string') {
                        validate48.errors = [
                            {
                                instancePath: instancePath + '/column',
                                schemaPath: '#/properties/column/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid4 = _errs9 === errors;
                }
                else {
                    var valid4 = true;
                }
                if (valid4) {
                    if (data.columnUpdateType !== undefined) {
                        let data3 = data.columnUpdateType;
                        const _errs11 = errors;
                        if (typeof data3 !== 'string') {
                            validate48.errors = [
                                {
                                    instancePath: instancePath + '/columnUpdateType',
                                    schemaPath: '#/properties/columnUpdateType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data3 === 'drop' || data3 === 'mask' || data3 === 'modify')) {
                            validate48.errors = [
                                {
                                    instancePath: instancePath + '/columnUpdateType',
                                    schemaPath: '#/properties/columnUpdateType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema66.properties.columnUpdateType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid4 = _errs11 === errors;
                    }
                    else {
                        var valid4 = true;
                    }
                    if (valid4) {
                        if (data.type !== undefined) {
                            let data4 = data.type;
                            const _errs13 = errors;
                            if (typeof data4 !== 'string') {
                                validate48.errors = [
                                    {
                                        instancePath: instancePath + '/type',
                                        schemaPath: '#/properties/type/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data4 === 'number' ||
                                data4 === 'string' ||
                                data4 === 'boolean' ||
                                data4 === 'date' ||
                                data4 === 'decimal')) {
                                validate48.errors = [
                                    {
                                        instancePath: instancePath + '/type',
                                        schemaPath: '#/properties/type/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema66.properties.type.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid4 = _errs13 === errors;
                        }
                        else {
                            var valid4 = true;
                        }
                        if (valid4) {
                            if (data.targetType !== undefined) {
                                let data5 = data.targetType;
                                const _errs15 = errors;
                                if (typeof data5 !== 'string') {
                                    validate48.errors = [
                                        {
                                            instancePath: instancePath + '/targetType',
                                            schemaPath: '#/properties/targetType/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data5 === 'number' ||
                                    data5 === 'string' ||
                                    data5 === 'boolean' ||
                                    data5 === 'date' ||
                                    data5 === 'decimal')) {
                                    validate48.errors = [
                                        {
                                            instancePath: instancePath + '/targetType',
                                            schemaPath: '#/properties/targetType/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema66.properties.targetType.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid4 = _errs15 === errors;
                            }
                            else {
                                var valid4 = true;
                            }
                            if (valid4) {
                                if (data.dateFormat !== undefined) {
                                    let data6 = data.dateFormat;
                                    const _errs17 = errors;
                                    if (errors === _errs17) {
                                        if (typeof data6 === 'string') {
                                            if (func2(data6) < 1) {
                                                validate48.errors = [
                                                    {
                                                        instancePath: instancePath + '/dateFormat',
                                                        schemaPath: '#/properties/dateFormat/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate48.errors = [
                                                {
                                                    instancePath: instancePath + '/dateFormat',
                                                    schemaPath: '#/properties/dateFormat/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid4 = _errs17 === errors;
                                }
                                else {
                                    var valid4 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate48.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate48.errors = vErrors;
    return errors === 0;
}
export const combinationSeriesArgsSchemaValidation = validate49;
const schema67 = {
    $id: 'urn:wisepipe-common-computation:CombinationSeriesArgs',
    type: 'object',
    properties: {
        name: { type: 'string' },
        yAxis: { type: 'string', enum: ['left', 'right'] },
        form: { type: 'string', enum: ['column', 'line'] }
    },
    required: ['name', 'yAxis', 'form']
};
function validate49(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:CombinationSeriesArgs" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.name === undefined && (missing0 = 'name')) ||
                (data.yAxis === undefined && (missing0 = 'yAxis')) ||
                (data.form === undefined && (missing0 = 'form'))) {
                validate49.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.name !== 'string') {
                        validate49.errors = [
                            {
                                instancePath: instancePath + '/name',
                                schemaPath: '#/properties/name/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.yAxis !== undefined) {
                        let data1 = data.yAxis;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate49.errors = [
                                {
                                    instancePath: instancePath + '/yAxis',
                                    schemaPath: '#/properties/yAxis/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'left' || data1 === 'right')) {
                            validate49.errors = [
                                {
                                    instancePath: instancePath + '/yAxis',
                                    schemaPath: '#/properties/yAxis/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema67.properties.yAxis.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.form !== undefined) {
                            let data2 = data.form;
                            const _errs5 = errors;
                            if (typeof data2 !== 'string') {
                                validate49.errors = [
                                    {
                                        instancePath: instancePath + '/form',
                                        schemaPath: '#/properties/form/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data2 === 'column' || data2 === 'line')) {
                                validate49.errors = [
                                    {
                                        instancePath: instancePath + '/form',
                                        schemaPath: '#/properties/form/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema67.properties.form.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate49.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate49.errors = vErrors;
    return errors === 0;
}
export const combinationVisualParamsSchemaValidation = validate50;
const schema68 = {
    $id: 'urn:wisepipe-common-computation:CombinationVisualParams',
    type: 'object',
    properties: {
        xAxis: { type: 'string', minLength: 1 },
        series: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-computation:CombinationSeriesArgs' },
            uniqueItems: true,
            minItems: 1
        },
        aggOps: {
            type: 'array',
            items: {
                type: 'string',
                enum: ['MAX', 'MIN', 'COUNT', 'SUM', 'AVG', 'OR', 'AND', 'MEDIAN', 'DIFF', 'PCT', 'SHIFT', 'STDEV']
            },
            anyOf: [
                { minItems: 0, maxItems: 0 },
                { minItems: { $data: '1/series/length' }, maxItems: { $data: '1/series/length' } }
            ]
        }
    },
    required: ['xAxis', 'series', 'aggOps']
};
const func0 = ajvEqual;
function validate50(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:CombinationVisualParams" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.xAxis === undefined && (missing0 = 'xAxis')) ||
                (data.series === undefined && (missing0 = 'series')) ||
                (data.aggOps === undefined && (missing0 = 'aggOps'))) {
                validate50.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.xAxis !== undefined) {
                    let data0 = data.xAxis;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate50.errors = [
                                    {
                                        instancePath: instancePath + '/xAxis',
                                        schemaPath: '#/properties/xAxis/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate50.errors = [
                                {
                                    instancePath: instancePath + '/xAxis',
                                    schemaPath: '#/properties/xAxis/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.series !== undefined) {
                        let data1 = data.series;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                if (data1.length < 1) {
                                    validate50.errors = [
                                        {
                                            instancePath: instancePath + '/series',
                                            schemaPath: '#/properties/series/minItems',
                                            keyword: 'minItems',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid1 = true;
                                    const len0 = data1.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data2 = data1[i0];
                                        const _errs5 = errors;
                                        const _errs6 = errors;
                                        if (errors === _errs6) {
                                            if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                                let missing1;
                                                if ((data2.name === undefined && (missing1 = 'name')) ||
                                                    (data2.yAxis === undefined && (missing1 = 'yAxis')) ||
                                                    (data2.form === undefined && (missing1 = 'form'))) {
                                                    validate50.errors = [
                                                        {
                                                            instancePath: instancePath + '/series/' + i0,
                                                            schemaPath: 'urn:wisepipe-common-computation:CombinationSeriesArgs/required',
                                                            keyword: 'required',
                                                            params: { missingProperty: missing1 },
                                                            message: "must have required property '" + missing1 + "'"
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (data2.name !== undefined) {
                                                        const _errs8 = errors;
                                                        if (typeof data2.name !== 'string') {
                                                            validate50.errors = [
                                                                {
                                                                    instancePath: instancePath + '/series/' + i0 + '/name',
                                                                    schemaPath: 'urn:wisepipe-common-computation:CombinationSeriesArgs/properties/name/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid3 = _errs8 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                    if (valid3) {
                                                        if (data2.yAxis !== undefined) {
                                                            let data4 = data2.yAxis;
                                                            const _errs10 = errors;
                                                            if (typeof data4 !== 'string') {
                                                                validate50.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/series/' + i0 + '/yAxis',
                                                                        schemaPath: 'urn:wisepipe-common-computation:CombinationSeriesArgs/properties/yAxis/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            if (!(data4 === 'left' || data4 === 'right')) {
                                                                validate50.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/series/' + i0 + '/yAxis',
                                                                        schemaPath: 'urn:wisepipe-common-computation:CombinationSeriesArgs/properties/yAxis/enum',
                                                                        keyword: 'enum',
                                                                        params: { allowedValues: schema67.properties.yAxis.enum },
                                                                        message: 'must be equal to one of the allowed values'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid3 = _errs10 === errors;
                                                        }
                                                        else {
                                                            var valid3 = true;
                                                        }
                                                        if (valid3) {
                                                            if (data2.form !== undefined) {
                                                                let data5 = data2.form;
                                                                const _errs12 = errors;
                                                                if (typeof data5 !== 'string') {
                                                                    validate50.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/series/' + i0 + '/form',
                                                                            schemaPath: 'urn:wisepipe-common-computation:CombinationSeriesArgs/properties/form/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                if (!(data5 === 'column' || data5 === 'line')) {
                                                                    validate50.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/series/' + i0 + '/form',
                                                                            schemaPath: 'urn:wisepipe-common-computation:CombinationSeriesArgs/properties/form/enum',
                                                                            keyword: 'enum',
                                                                            params: { allowedValues: schema67.properties.form.enum },
                                                                            message: 'must be equal to one of the allowed values'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid3 = _errs12 === errors;
                                                            }
                                                            else {
                                                                var valid3 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate50.errors = [
                                                    {
                                                        instancePath: instancePath + '/series/' + i0,
                                                        schemaPath: 'urn:wisepipe-common-computation:CombinationSeriesArgs/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid1 = _errs5 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                    if (valid1) {
                                        let i1 = data1.length;
                                        let j0;
                                        if (i1 > 1) {
                                            outer0: for (; i1--;) {
                                                for (j0 = i1; j0--;) {
                                                    if (func0(data1[i1], data1[j0])) {
                                                        validate50.errors = [
                                                            {
                                                                instancePath: instancePath + '/series',
                                                                schemaPath: '#/properties/series/uniqueItems',
                                                                keyword: 'uniqueItems',
                                                                params: { i: i1, j: j0 },
                                                                message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                            }
                                                        ];
                                                        return false;
                                                        break outer0;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate50.errors = [
                                    {
                                        instancePath: instancePath + '/series',
                                        schemaPath: '#/properties/series/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.aggOps !== undefined) {
                            let data6 = data.aggOps;
                            const _errs14 = errors;
                            const _errs16 = errors;
                            let valid5 = false;
                            const _errs17 = errors;
                            if (Array.isArray(data6)) {
                                if (data6.length > 0) {
                                    const err0 = {
                                        instancePath: instancePath + '/aggOps',
                                        schemaPath: '#/properties/aggOps/anyOf/0/maxItems',
                                        keyword: 'maxItems',
                                        params: { limit: 0 },
                                        message: 'must NOT have more than 0 items'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err0];
                                    }
                                    else {
                                        vErrors.push(err0);
                                    }
                                    errors++;
                                }
                                else {
                                    if (data6.length < 0) {
                                        const err1 = {
                                            instancePath: instancePath + '/aggOps',
                                            schemaPath: '#/properties/aggOps/anyOf/0/minItems',
                                            keyword: 'minItems',
                                            params: { limit: 0 },
                                            message: 'must NOT have fewer than 0 items'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err1];
                                        }
                                        else {
                                            vErrors.push(err1);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            var _valid0 = _errs17 === errors;
                            valid5 = valid5 || _valid0;
                            if (!valid5) {
                                const _errs18 = errors;
                                if (Array.isArray(data6)) {
                                    const vSchema2 = data && data.series && data.series.length;
                                    if (vSchema2 !== undefined && (!(typeof vSchema2 == 'number') || data6.length > vSchema2)) {
                                        const err2 = {
                                            instancePath: instancePath + '/aggOps',
                                            schemaPath: '#/properties/aggOps/anyOf/1/maxItems',
                                            keyword: 'maxItems',
                                            params: { limit: vSchema2 },
                                            message: 'must NOT have more than ' + vSchema2 + ' items'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err2];
                                        }
                                        else {
                                            vErrors.push(err2);
                                        }
                                        errors++;
                                    }
                                    else {
                                        const vSchema3 = data && data.series && data.series.length;
                                        if (vSchema3 !== undefined && (!(typeof vSchema3 == 'number') || data6.length < vSchema3)) {
                                            const err3 = {
                                                instancePath: instancePath + '/aggOps',
                                                schemaPath: '#/properties/aggOps/anyOf/1/minItems',
                                                keyword: 'minItems',
                                                params: { limit: vSchema3 },
                                                message: 'must NOT have fewer than ' + vSchema3 + ' items'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err3];
                                            }
                                            else {
                                                vErrors.push(err3);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                                var _valid0 = _errs18 === errors;
                                valid5 = valid5 || _valid0;
                            }
                            if (!valid5) {
                                const err4 = {
                                    instancePath: instancePath + '/aggOps',
                                    schemaPath: '#/properties/aggOps/anyOf',
                                    keyword: 'anyOf',
                                    params: {},
                                    message: 'must match a schema in anyOf'
                                };
                                if (vErrors === null) {
                                    vErrors = [err4];
                                }
                                else {
                                    vErrors.push(err4);
                                }
                                errors++;
                                validate50.errors = vErrors;
                                return false;
                            }
                            else {
                                errors = _errs16;
                                if (vErrors !== null) {
                                    if (_errs16) {
                                        vErrors.length = _errs16;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                            }
                            if (errors === _errs14) {
                                if (Array.isArray(data6)) {
                                    var valid6 = true;
                                    const len1 = data6.length;
                                    for (let i2 = 0; i2 < len1; i2++) {
                                        let data7 = data6[i2];
                                        const _errs19 = errors;
                                        if (typeof data7 !== 'string') {
                                            validate50.errors = [
                                                {
                                                    instancePath: instancePath + '/aggOps/' + i2,
                                                    schemaPath: '#/properties/aggOps/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (!(data7 === 'MAX' ||
                                            data7 === 'MIN' ||
                                            data7 === 'COUNT' ||
                                            data7 === 'SUM' ||
                                            data7 === 'AVG' ||
                                            data7 === 'OR' ||
                                            data7 === 'AND' ||
                                            data7 === 'MEDIAN' ||
                                            data7 === 'DIFF' ||
                                            data7 === 'PCT' ||
                                            data7 === 'SHIFT' ||
                                            data7 === 'STDEV')) {
                                            validate50.errors = [
                                                {
                                                    instancePath: instancePath + '/aggOps/' + i2,
                                                    schemaPath: '#/properties/aggOps/items/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema68.properties.aggOps.items.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid6 = _errs19 === errors;
                                        if (!valid6) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate50.errors = [
                                        {
                                            instancePath: instancePath + '/aggOps',
                                            schemaPath: '#/properties/aggOps/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs14 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate50.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate50.errors = vErrors;
    return errors === 0;
}
export const comparisonGraphSchemaValidation = validate51;
const schema70 = {
    $id: 'urn:wisepipe-common-computation:ComparisonGraph',
    type: 'object',
    properties: {
        graphType: {
            type: 'string',
            enum: [
                'numericalByNumerical',
                'numericalByCategorical',
                'categoricalByCategorical',
                'numericalByDate',
                'categoricalByDate',
                'dateByDate'
            ]
        }
    },
    required: ['graphType']
};
function validate51(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:ComparisonGraph" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.graphType === undefined && (missing0 = 'graphType')) {
                validate51.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.graphType !== undefined) {
                    let data0 = data.graphType;
                    if (typeof data0 !== 'string') {
                        validate51.errors = [
                            {
                                instancePath: instancePath + '/graphType',
                                schemaPath: '#/properties/graphType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'numericalByNumerical' ||
                        data0 === 'numericalByCategorical' ||
                        data0 === 'categoricalByCategorical' ||
                        data0 === 'numericalByDate' ||
                        data0 === 'categoricalByDate' ||
                        data0 === 'dateByDate')) {
                        validate51.errors = [
                            {
                                instancePath: instancePath + '/graphType',
                                schemaPath: '#/properties/graphType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema70.properties.graphType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate51.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate51.errors = vErrors;
    return errors === 0;
}
export const computeTaskSchemaValidation = validate25;
export const connectionSchemaValidation = validate52;
const schema71 = {
    $id: 'urn:wisepipe-common-connection:Connection',
    type: 'object',
    properties: {
        connectionID: { type: 'string', uid: 9 },
        connectionType: {
            type: 'string',
            enum: [
                'google',
                'gsheetsImport',
                'gsheetsExport',
                'shopify',
                'salesForce',
                'postgreSql',
                'icm',
                'tq-postgres',
                'mySql',
                'msSql',
                'oracle',
                'amazonRedshift',
                'amazonAurora',
                'amazonS3',
                'amazonS3Export',
                'tqp',
                'hubspot',
                'symon',
                'snowflake',
                'dynamics',
                'agentSync',
                'workday',
                'workdayRaaS',
                'workdayExport',
                'tableau',
                'sftp',
                'powerbi',
                'rest',
                'gong',
                'netSuite',
                'oneDrive',
                'oneDriveExport',
                'sapSuccessFactors',
                'sapCrm',
                'ukg',
                'oracleHcm',
                'Adp',
                'dynamics365Sales',
                'ceridianDayforce',
                'oracleCrm',
                'oracleErpCloud',
                'sageIntacct',
                'bambooHr',
                'sapErp',
                'googleCloudPlatformCloudStorage',
                'sas',
                'dropbox',
                'googleDrive',
                'jira',
                'monday',
                'zuora',
                'adobeAnalytics',
                'zoomInfo',
                'marketo',
                'activeCampaign',
                'mailchimp',
                'infor',
                'cornerstoneOnDemand',
                'gusto',
                'paychexFlex',
                'zendesk',
                'serviceNow',
                'zohoCrm',
                'pipedrive',
                'quickBooks',
                'xero',
                'freshbooks',
                'zohoBooks',
                'waveFinancial'
            ]
        },
        name: { type: 'string', minLength: 1 },
        source: { type: 'string', minLength: 1 },
        failedOnLastTry: { type: 'boolean' },
        isDiscoveryFail: { type: 'boolean' },
        verificationErrorMessage: { type: 'string' }
    },
    required: ['connectionType', 'name']
};
const func78 = ucs2length;
const func79 = base64urlToBuffer;
const func80 = base64urlEncode;
const func81 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate52(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:Connection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.connectionType === undefined && (missing0 = 'connectionType')) ||
                (data.name === undefined && (missing0 = 'name'))) {
                validate52.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.connectionID !== undefined) {
                    let data0 = data.connectionID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 9) / 3);
                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                            if (func78(data0) < b64min0 || func78(data0) > b64max0) {
                                validate52.errors = [
                                    {
                                        instancePath: instancePath + '/connectionID',
                                        schemaPath: '#/properties/connectionID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func78(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func78(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func79(data0);
                                if (decoded0.length !== 9) {
                                    validate52.errors = [
                                        {
                                            instancePath: instancePath + '/connectionID',
                                            schemaPath: '#/properties/connectionID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 9 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func80(decoded0);
                                    if (func81(encoded0) !== func81(data0)) {
                                        validate52.errors = [
                                            {
                                                instancePath: instancePath + '/connectionID',
                                                schemaPath: '#/properties/connectionID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate52.errors = [
                                {
                                    instancePath: instancePath + '/connectionID',
                                    schemaPath: '#/properties/connectionID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.connectionType !== undefined) {
                        let data1 = data.connectionType;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate52.errors = [
                                {
                                    instancePath: instancePath + '/connectionType',
                                    schemaPath: '#/properties/connectionType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'google' ||
                            data1 === 'gsheetsImport' ||
                            data1 === 'gsheetsExport' ||
                            data1 === 'shopify' ||
                            data1 === 'salesForce' ||
                            data1 === 'postgreSql' ||
                            data1 === 'icm' ||
                            data1 === 'tq-postgres' ||
                            data1 === 'mySql' ||
                            data1 === 'msSql' ||
                            data1 === 'oracle' ||
                            data1 === 'amazonRedshift' ||
                            data1 === 'amazonAurora' ||
                            data1 === 'amazonS3' ||
                            data1 === 'amazonS3Export' ||
                            data1 === 'tqp' ||
                            data1 === 'hubspot' ||
                            data1 === 'symon' ||
                            data1 === 'snowflake' ||
                            data1 === 'dynamics' ||
                            data1 === 'agentSync' ||
                            data1 === 'workday' ||
                            data1 === 'workdayRaaS' ||
                            data1 === 'workdayExport' ||
                            data1 === 'tableau' ||
                            data1 === 'sftp' ||
                            data1 === 'powerbi' ||
                            data1 === 'rest' ||
                            data1 === 'gong' ||
                            data1 === 'netSuite' ||
                            data1 === 'oneDrive' ||
                            data1 === 'oneDriveExport' ||
                            data1 === 'sapSuccessFactors' ||
                            data1 === 'sapCrm' ||
                            data1 === 'ukg' ||
                            data1 === 'oracleHcm' ||
                            data1 === 'Adp' ||
                            data1 === 'dynamics365Sales' ||
                            data1 === 'ceridianDayforce' ||
                            data1 === 'oracleCrm' ||
                            data1 === 'oracleErpCloud' ||
                            data1 === 'sageIntacct' ||
                            data1 === 'bambooHr' ||
                            data1 === 'sapErp' ||
                            data1 === 'googleCloudPlatformCloudStorage' ||
                            data1 === 'sas' ||
                            data1 === 'dropbox' ||
                            data1 === 'googleDrive' ||
                            data1 === 'jira' ||
                            data1 === 'monday' ||
                            data1 === 'zuora' ||
                            data1 === 'adobeAnalytics' ||
                            data1 === 'zoomInfo' ||
                            data1 === 'marketo' ||
                            data1 === 'activeCampaign' ||
                            data1 === 'mailchimp' ||
                            data1 === 'infor' ||
                            data1 === 'cornerstoneOnDemand' ||
                            data1 === 'gusto' ||
                            data1 === 'paychexFlex' ||
                            data1 === 'zendesk' ||
                            data1 === 'serviceNow' ||
                            data1 === 'zohoCrm' ||
                            data1 === 'pipedrive' ||
                            data1 === 'quickBooks' ||
                            data1 === 'xero' ||
                            data1 === 'freshbooks' ||
                            data1 === 'zohoBooks' ||
                            data1 === 'waveFinancial')) {
                            validate52.errors = [
                                {
                                    instancePath: instancePath + '/connectionType',
                                    schemaPath: '#/properties/connectionType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema71.properties.connectionType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.name !== undefined) {
                            let data2 = data.name;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate52.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate52.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.source !== undefined) {
                                let data3 = data.source;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) < 1) {
                                            validate52.errors = [
                                                {
                                                    instancePath: instancePath + '/source',
                                                    schemaPath: '#/properties/source/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate52.errors = [
                                            {
                                                instancePath: instancePath + '/source',
                                                schemaPath: '#/properties/source/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.failedOnLastTry !== undefined) {
                                    const _errs9 = errors;
                                    if (typeof data.failedOnLastTry !== 'boolean') {
                                        validate52.errors = [
                                            {
                                                instancePath: instancePath + '/failedOnLastTry',
                                                schemaPath: '#/properties/failedOnLastTry/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.isDiscoveryFail !== undefined) {
                                        const _errs11 = errors;
                                        if (typeof data.isDiscoveryFail !== 'boolean') {
                                            validate52.errors = [
                                                {
                                                    instancePath: instancePath + '/isDiscoveryFail',
                                                    schemaPath: '#/properties/isDiscoveryFail/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.verificationErrorMessage !== undefined) {
                                            const _errs13 = errors;
                                            if (typeof data.verificationErrorMessage !== 'string') {
                                                validate52.errors = [
                                                    {
                                                        instancePath: instancePath + '/verificationErrorMessage',
                                                        schemaPath: '#/properties/verificationErrorMessage/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate52.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate52.errors = vErrors;
    return errors === 0;
}
export const correlationDataSchemaValidation = validate53;
const schema72 = {
    $id: 'urn:wisepipe-common-computation:CorrelationData',
    type: 'object',
    properties: {
        columns: { type: 'array', items: { type: 'string' } },
        values: { type: 'array', items: { type: 'array', items: { type: 'number' } } },
        groups: { type: 'array', items: { $ref: 'urn:wisepipe-common-computation:CorrelationGroup' } }
    },
    required: ['columns', 'values', 'groups']
};
const schema73 = {
    $id: 'urn:wisepipe-common-computation:CorrelationGroup',
    type: 'object',
    properties: { columns: { type: 'array', items: { type: 'string' } }, correlation: { type: 'number' } },
    required: ['columns', 'correlation']
};
function validate53(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:CorrelationData" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.columns === undefined && (missing0 = 'columns')) ||
                (data.values === undefined && (missing0 = 'values')) ||
                (data.groups === undefined && (missing0 = 'groups'))) {
                validate53.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data0 = data.columns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                const _errs3 = errors;
                                if (typeof data0[i0] !== 'string') {
                                    validate53.errors = [
                                        {
                                            instancePath: instancePath + '/columns/' + i0,
                                            schemaPath: '#/properties/columns/items/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                        }
                        else {
                            validate53.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.values !== undefined) {
                        let data2 = data.values;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (Array.isArray(data2)) {
                                var valid2 = true;
                                const len1 = data2.length;
                                for (let i1 = 0; i1 < len1; i1++) {
                                    let data3 = data2[i1];
                                    const _errs7 = errors;
                                    if (errors === _errs7) {
                                        if (Array.isArray(data3)) {
                                            var valid3 = true;
                                            const len2 = data3.length;
                                            for (let i2 = 0; i2 < len2; i2++) {
                                                const _errs9 = errors;
                                                if (!(typeof data3[i2] == 'number')) {
                                                    validate53.errors = [
                                                        {
                                                            instancePath: instancePath + '/values/' + i1 + '/' + i2,
                                                            schemaPath: '#/properties/values/items/items/type',
                                                            keyword: 'type',
                                                            params: { type: 'number' },
                                                            message: 'must be number'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid3 = _errs9 === errors;
                                                if (!valid3) {
                                                    break;
                                                }
                                            }
                                        }
                                        else {
                                            validate53.errors = [
                                                {
                                                    instancePath: instancePath + '/values/' + i1,
                                                    schemaPath: '#/properties/values/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'array' },
                                                    message: 'must be array'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs7 === errors;
                                    if (!valid2) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate53.errors = [
                                    {
                                        instancePath: instancePath + '/values',
                                        schemaPath: '#/properties/values/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.groups !== undefined) {
                            let data5 = data.groups;
                            const _errs11 = errors;
                            if (errors === _errs11) {
                                if (Array.isArray(data5)) {
                                    var valid4 = true;
                                    const len3 = data5.length;
                                    for (let i3 = 0; i3 < len3; i3++) {
                                        let data6 = data5[i3];
                                        const _errs13 = errors;
                                        const _errs14 = errors;
                                        if (errors === _errs14) {
                                            if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                                let missing1;
                                                if ((data6.columns === undefined && (missing1 = 'columns')) ||
                                                    (data6.correlation === undefined && (missing1 = 'correlation'))) {
                                                    validate53.errors = [
                                                        {
                                                            instancePath: instancePath + '/groups/' + i3,
                                                            schemaPath: 'urn:wisepipe-common-computation:CorrelationGroup/required',
                                                            keyword: 'required',
                                                            params: { missingProperty: missing1 },
                                                            message: "must have required property '" + missing1 + "'"
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (data6.columns !== undefined) {
                                                        let data7 = data6.columns;
                                                        const _errs16 = errors;
                                                        if (errors === _errs16) {
                                                            if (Array.isArray(data7)) {
                                                                var valid7 = true;
                                                                const len4 = data7.length;
                                                                for (let i4 = 0; i4 < len4; i4++) {
                                                                    const _errs18 = errors;
                                                                    if (typeof data7[i4] !== 'string') {
                                                                        validate53.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/groups/' + i3 + '/columns/' + i4,
                                                                                schemaPath: 'urn:wisepipe-common-computation:CorrelationGroup/properties/columns/items/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid7 = _errs18 === errors;
                                                                    if (!valid7) {
                                                                        break;
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate53.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/groups/' + i3 + '/columns',
                                                                        schemaPath: 'urn:wisepipe-common-computation:CorrelationGroup/properties/columns/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'array' },
                                                                        message: 'must be array'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid6 = _errs16 === errors;
                                                    }
                                                    else {
                                                        var valid6 = true;
                                                    }
                                                    if (valid6) {
                                                        if (data6.correlation !== undefined) {
                                                            const _errs20 = errors;
                                                            if (!(typeof data6.correlation == 'number')) {
                                                                validate53.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/groups/' + i3 + '/correlation',
                                                                        schemaPath: 'urn:wisepipe-common-computation:CorrelationGroup/properties/correlation/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'number' },
                                                                        message: 'must be number'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid6 = _errs20 === errors;
                                                        }
                                                        else {
                                                            var valid6 = true;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate53.errors = [
                                                    {
                                                        instancePath: instancePath + '/groups/' + i3,
                                                        schemaPath: 'urn:wisepipe-common-computation:CorrelationGroup/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid4 = _errs13 === errors;
                                        if (!valid4) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate53.errors = [
                                        {
                                            instancePath: instancePath + '/groups',
                                            schemaPath: '#/properties/groups/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs11 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate53.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate53.errors = vErrors;
    return errors === 0;
}
export const correlationGroupSchemaValidation = validate54;
function validate54(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:CorrelationGroup" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.columns === undefined && (missing0 = 'columns')) ||
                (data.correlation === undefined && (missing0 = 'correlation'))) {
                validate54.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data0 = data.columns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                const _errs3 = errors;
                                if (typeof data0[i0] !== 'string') {
                                    validate54.errors = [
                                        {
                                            instancePath: instancePath + '/columns/' + i0,
                                            schemaPath: '#/properties/columns/items/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                        }
                        else {
                            validate54.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.correlation !== undefined) {
                        const _errs5 = errors;
                        if (!(typeof data.correlation == 'number')) {
                            validate54.errors = [
                                {
                                    instancePath: instancePath + '/correlation',
                                    schemaPath: '#/properties/correlation/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate54.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate54.errors = vErrors;
    return errors === 0;
}
export const correlationsSchemaValidation = validate55;
const schema75 = {
    $id: 'urn:wisepipe-common-computation:Correlations',
    type: 'object',
    properties: {
        pearson: { $ref: 'urn:wisepipe-common-computation:CorrelationData' },
        spearman: { $ref: 'urn:wisepipe-common-computation:CorrelationData' },
        kendall: { $ref: 'urn:wisepipe-common-computation:CorrelationData' },
        phi_k: { $ref: 'urn:wisepipe-common-computation:CorrelationData' },
        cramers: { $ref: 'urn:wisepipe-common-computation:CorrelationData' }
    },
    required: []
};
function validate55(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:Correlations" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.pearson !== undefined) {
                const _errs1 = errors;
                if (!validate53(data.pearson, {
                    instancePath: instancePath + '/pearson',
                    parentData: data,
                    parentDataProperty: 'pearson',
                    rootData
                })) {
                    vErrors = vErrors === null ? validate53.errors : vErrors.concat(validate53.errors);
                    errors = vErrors.length;
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.spearman !== undefined) {
                    const _errs2 = errors;
                    if (!validate53(data.spearman, {
                        instancePath: instancePath + '/spearman',
                        parentData: data,
                        parentDataProperty: 'spearman',
                        rootData
                    })) {
                        vErrors = vErrors === null ? validate53.errors : vErrors.concat(validate53.errors);
                        errors = vErrors.length;
                    }
                    var valid0 = _errs2 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.kendall !== undefined) {
                        const _errs3 = errors;
                        if (!validate53(data.kendall, {
                            instancePath: instancePath + '/kendall',
                            parentData: data,
                            parentDataProperty: 'kendall',
                            rootData
                        })) {
                            vErrors = vErrors === null ? validate53.errors : vErrors.concat(validate53.errors);
                            errors = vErrors.length;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.phi_k !== undefined) {
                            const _errs4 = errors;
                            if (!validate53(data.phi_k, {
                                instancePath: instancePath + '/phi_k',
                                parentData: data,
                                parentDataProperty: 'phi_k',
                                rootData
                            })) {
                                vErrors = vErrors === null ? validate53.errors : vErrors.concat(validate53.errors);
                                errors = vErrors.length;
                            }
                            var valid0 = _errs4 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.cramers !== undefined) {
                                const _errs5 = errors;
                                if (!validate53(data.cramers, {
                                    instancePath: instancePath + '/cramers',
                                    parentData: data,
                                    parentDataProperty: 'cramers',
                                    rootData
                                })) {
                                    vErrors = vErrors === null ? validate53.errors : vErrors.concat(validate53.errors);
                                    errors = vErrors.length;
                                }
                                var valid0 = _errs5 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate55.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate55.errors = vErrors;
    return errors === 0;
}
export const credentialsSchemaValidation = validate61;
const schema76 = {
    $id: 'urn:wisepipe-common:Credentials',
    type: 'object',
    properties: {
        credentialsType: {
            type: 'string',
            enum: [
                'oauth',
                'userPassword',
                's3Credentials',
                'apiKey',
                'symon',
                'awsRoleAssumption',
                'rest',
                'tokenBasedAuthentication'
            ]
        }
    },
    required: ['credentialsType']
};
function validate61(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common:Credentials" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.credentialsType === undefined && (missing0 = 'credentialsType')) {
                validate61.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.credentialsType !== undefined) {
                    let data0 = data.credentialsType;
                    if (typeof data0 !== 'string') {
                        validate61.errors = [
                            {
                                instancePath: instancePath + '/credentialsType',
                                schemaPath: '#/properties/credentialsType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'oauth' ||
                        data0 === 'userPassword' ||
                        data0 === 's3Credentials' ||
                        data0 === 'apiKey' ||
                        data0 === 'symon' ||
                        data0 === 'awsRoleAssumption' ||
                        data0 === 'rest' ||
                        data0 === 'tokenBasedAuthentication')) {
                        validate61.errors = [
                            {
                                instancePath: instancePath + '/credentialsType',
                                schemaPath: '#/properties/credentialsType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema76.properties.credentialsType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate61.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate61.errors = vErrors;
    return errors === 0;
}
export const dataProfileRequestSchemaValidation = validate62;
const schema77 = {
    $id: 'urn:wisepipe-common-computation:DataProfileRequest',
    type: 'object',
    properties: {
        requestType: {
            type: 'string',
            enum: ['calc_data_profile', 'run_data_profile', 'data_source_data_profile', 'sample_data_profile']
        },
        pipeID: { type: 'string', uid: 10 },
        runID: { type: 'string', uid: 9 },
        dataSourceID: { type: 'string', uid: 9 },
        multiColumnMode: { type: 'boolean' },
        page: { type: 'number', minimum: 1 },
        comparisonColumns: { type: 'array', items: { type: 'string' }, minItems: 2, maxItems: 2 },
        correlationColumns: { type: 'array', items: { type: 'string' } }
    },
    if: { properties: { multiColumnMode: { const: true } } },
    then: { required: [] },
    else: { required: ['page'] },
    required: ['requestType', 'multiColumnMode'],
    anyOf: [{ required: ['pipeID'] }, { required: ['runID'] }, { required: ['dataSourceID'] }]
};
const func84 = ucs2length;
const func85 = base64urlToBuffer;
const func86 = base64urlEncode;
const func87 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func88 = ucs2length;
const func89 = base64urlToBuffer;
const func90 = base64urlEncode;
const func91 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func92 = ucs2length;
const func93 = base64urlToBuffer;
const func94 = base64urlEncode;
const func95 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate62(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:DataProfileRequest" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = false;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if (data.pipeID === undefined && (missing0 = 'pipeID')) {
            const err0 = {
                instancePath,
                schemaPath: '#/anyOf/0/required',
                keyword: 'required',
                params: { missingProperty: missing0 },
                message: "must have required property '" + missing0 + "'"
            };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
    }
    var _valid0 = _errs2 === errors;
    valid0 = valid0 || _valid0;
    if (!valid0) {
        const _errs3 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if (data.runID === undefined && (missing1 = 'runID')) {
                const err1 = {
                    instancePath,
                    schemaPath: '#/anyOf/1/required',
                    keyword: 'required',
                    params: { missingProperty: missing1 },
                    message: "must have required property '" + missing1 + "'"
                };
                if (vErrors === null) {
                    vErrors = [err1];
                }
                else {
                    vErrors.push(err1);
                }
                errors++;
            }
        }
        var _valid0 = _errs3 === errors;
        valid0 = valid0 || _valid0;
        if (!valid0) {
            const _errs4 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing2;
                if (data.dataSourceID === undefined && (missing2 = 'dataSourceID')) {
                    const err2 = {
                        instancePath,
                        schemaPath: '#/anyOf/2/required',
                        keyword: 'required',
                        params: { missingProperty: missing2 },
                        message: "must have required property '" + missing2 + "'"
                    };
                    if (vErrors === null) {
                        vErrors = [err2];
                    }
                    else {
                        vErrors.push(err2);
                    }
                    errors++;
                }
            }
            var _valid0 = _errs4 === errors;
            valid0 = valid0 || _valid0;
        }
    }
    if (!valid0) {
        const err3 = {
            instancePath,
            schemaPath: '#/anyOf',
            keyword: 'anyOf',
            params: {},
            message: 'must match a schema in anyOf'
        };
        if (vErrors === null) {
            vErrors = [err3];
        }
        else {
            vErrors.push(err3);
        }
        errors++;
        validate62.errors = vErrors;
        return false;
    }
    else {
        errors = _errs1;
        if (vErrors !== null) {
            if (_errs1) {
                vErrors.length = _errs1;
            }
            else {
                vErrors = null;
            }
        }
        const _errs5 = errors;
        let valid1 = true;
        const _errs6 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.multiColumnMode !== undefined) {
                if (true !== data.multiColumnMode) {
                    const err4 = {};
                    if (vErrors === null) {
                        vErrors = [err4];
                    }
                    else {
                        vErrors.push(err4);
                    }
                    errors++;
                }
            }
        }
        var _valid1 = _errs6 === errors;
        errors = _errs5;
        if (vErrors !== null) {
            if (_errs5) {
                vErrors.length = _errs5;
            }
            else {
                vErrors = null;
            }
        }
        let ifClause0;
        if (_valid1) {
            const _errs8 = errors;
            var _valid1 = _errs8 === errors;
            valid1 = _valid1;
            ifClause0 = 'then';
        }
        else {
            const _errs9 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing3;
                if (data.page === undefined && (missing3 = 'page')) {
                    validate62.errors = [
                        {
                            instancePath,
                            schemaPath: '#/else/required',
                            keyword: 'required',
                            params: { missingProperty: missing3 },
                            message: "must have required property '" + missing3 + "'"
                        }
                    ];
                    return false;
                }
            }
            var _valid1 = _errs9 === errors;
            valid1 = _valid1;
            ifClause0 = 'else';
        }
        if (!valid1) {
            const err5 = {
                instancePath,
                schemaPath: '#/if',
                keyword: 'if',
                params: { failingKeyword: ifClause0 },
                message: 'must match "' + ifClause0 + '" schema'
            };
            if (vErrors === null) {
                vErrors = [err5];
            }
            else {
                vErrors.push(err5);
            }
            errors++;
            validate62.errors = vErrors;
            return false;
        }
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing4;
            if ((data.requestType === undefined && (missing4 = 'requestType')) ||
                (data.multiColumnMode === undefined && (missing4 = 'multiColumnMode'))) {
                validate62.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing4 },
                        message: "must have required property '" + missing4 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.requestType !== undefined) {
                    let data1 = data.requestType;
                    const _errs10 = errors;
                    if (typeof data1 !== 'string') {
                        validate62.errors = [
                            {
                                instancePath: instancePath + '/requestType',
                                schemaPath: '#/properties/requestType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data1 === 'calc_data_profile' ||
                        data1 === 'run_data_profile' ||
                        data1 === 'data_source_data_profile' ||
                        data1 === 'sample_data_profile')) {
                        validate62.errors = [
                            {
                                instancePath: instancePath + '/requestType',
                                schemaPath: '#/properties/requestType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema77.properties.requestType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid3 = _errs10 === errors;
                }
                else {
                    var valid3 = true;
                }
                if (valid3) {
                    if (data.pipeID !== undefined) {
                        let data2 = data.pipeID;
                        const _errs12 = errors;
                        if (errors === _errs12) {
                            if (typeof data2 === 'string') {
                                const b64min0 = Math.ceil((4 * 10) / 3);
                                const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                                if (func84(data2) < b64min0 || func84(data2) > b64max0) {
                                    validate62.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func84(data2) },
                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func84(data2)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded0 = func85(data2);
                                    if (decoded0.length !== 10) {
                                        validate62.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 10 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded0 = func86(decoded0);
                                        if (func87(encoded0) !== func87(data2)) {
                                            validate62.errors = [
                                                {
                                                    instancePath: instancePath + '/pipeID',
                                                    schemaPath: '#/properties/pipeID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate62.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid3 = _errs12 === errors;
                    }
                    else {
                        var valid3 = true;
                    }
                    if (valid3) {
                        if (data.runID !== undefined) {
                            let data3 = data.runID;
                            const _errs14 = errors;
                            if (errors === _errs14) {
                                if (typeof data3 === 'string') {
                                    const b64min1 = Math.ceil((4 * 9) / 3);
                                    const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                    if (func88(data3) < b64min1 || func88(data3) > b64max1) {
                                        validate62.errors = [
                                            {
                                                instancePath: instancePath + '/runID',
                                                schemaPath: '#/properties/runID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func88(data3) },
                                                message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func88(data3)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded1 = func89(data3);
                                        if (decoded1.length !== 9) {
                                            validate62.errors = [
                                                {
                                                    instancePath: instancePath + '/runID',
                                                    schemaPath: '#/properties/runID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 9 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded1 = func90(decoded1);
                                            if (func91(encoded1) !== func91(data3)) {
                                                validate62.errors = [
                                                    {
                                                        instancePath: instancePath + '/runID',
                                                        schemaPath: '#/properties/runID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate62.errors = [
                                        {
                                            instancePath: instancePath + '/runID',
                                            schemaPath: '#/properties/runID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid3 = _errs14 === errors;
                        }
                        else {
                            var valid3 = true;
                        }
                        if (valid3) {
                            if (data.dataSourceID !== undefined) {
                                let data4 = data.dataSourceID;
                                const _errs16 = errors;
                                if (errors === _errs16) {
                                    if (typeof data4 === 'string') {
                                        const b64min2 = Math.ceil((4 * 9) / 3);
                                        const b64max2 = Math.ceil((4 * 9) / 3) + 3;
                                        if (func92(data4) < b64min2 || func92(data4) > b64max2) {
                                            validate62.errors = [
                                                {
                                                    instancePath: instancePath + '/dataSourceID',
                                                    schemaPath: '#/properties/dataSourceID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'encoded', b64min: b64min2, b64max: b64max2, length: func92(data4) },
                                                    message: 'length must be between ' + b64min2 + ' and ' + b64max2 + ', but is ' + func92(data4)
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const decoded2 = func93(data4);
                                            if (decoded2.length !== 9) {
                                                validate62.errors = [
                                                    {
                                                        instancePath: instancePath + '/dataSourceID',
                                                        schemaPath: '#/properties/dataSourceID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'decoded' },
                                                        message: 'must decode to 9 bytes'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const encoded2 = func94(decoded2);
                                                if (func95(encoded2) !== func95(data4)) {
                                                    validate62.errors = [
                                                        {
                                                            instancePath: instancePath + '/dataSourceID',
                                                            schemaPath: '#/properties/dataSourceID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'ambiguous' },
                                                            message: 'encoding is ambiguous'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate62.errors = [
                                            {
                                                instancePath: instancePath + '/dataSourceID',
                                                schemaPath: '#/properties/dataSourceID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid3 = _errs16 === errors;
                            }
                            else {
                                var valid3 = true;
                            }
                            if (valid3) {
                                if (data.multiColumnMode !== undefined) {
                                    const _errs18 = errors;
                                    if (typeof data.multiColumnMode !== 'boolean') {
                                        validate62.errors = [
                                            {
                                                instancePath: instancePath + '/multiColumnMode',
                                                schemaPath: '#/properties/multiColumnMode/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid3 = _errs18 === errors;
                                }
                                else {
                                    var valid3 = true;
                                }
                                if (valid3) {
                                    if (data.page !== undefined) {
                                        let data6 = data.page;
                                        const _errs20 = errors;
                                        if (errors === _errs20) {
                                            if (typeof data6 == 'number') {
                                                if (data6 < 1 || isNaN(data6)) {
                                                    validate62.errors = [
                                                        {
                                                            instancePath: instancePath + '/page',
                                                            schemaPath: '#/properties/page/minimum',
                                                            keyword: 'minimum',
                                                            params: { comparison: '>=', limit: 1 },
                                                            message: 'must be >= 1'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate62.errors = [
                                                    {
                                                        instancePath: instancePath + '/page',
                                                        schemaPath: '#/properties/page/type',
                                                        keyword: 'type',
                                                        params: { type: 'number' },
                                                        message: 'must be number'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid3 = _errs20 === errors;
                                    }
                                    else {
                                        var valid3 = true;
                                    }
                                    if (valid3) {
                                        if (data.comparisonColumns !== undefined) {
                                            let data7 = data.comparisonColumns;
                                            const _errs22 = errors;
                                            if (errors === _errs22) {
                                                if (Array.isArray(data7)) {
                                                    if (data7.length > 2) {
                                                        validate62.errors = [
                                                            {
                                                                instancePath: instancePath + '/comparisonColumns',
                                                                schemaPath: '#/properties/comparisonColumns/maxItems',
                                                                keyword: 'maxItems',
                                                                params: { limit: 2 },
                                                                message: 'must NOT have more than 2 items'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        if (data7.length < 2) {
                                                            validate62.errors = [
                                                                {
                                                                    instancePath: instancePath + '/comparisonColumns',
                                                                    schemaPath: '#/properties/comparisonColumns/minItems',
                                                                    keyword: 'minItems',
                                                                    params: { limit: 2 },
                                                                    message: 'must NOT have fewer than 2 items'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            var valid7 = true;
                                                            const len0 = data7.length;
                                                            for (let i0 = 0; i0 < len0; i0++) {
                                                                const _errs24 = errors;
                                                                if (typeof data7[i0] !== 'string') {
                                                                    validate62.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/comparisonColumns/' + i0,
                                                                            schemaPath: '#/properties/comparisonColumns/items/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid7 = _errs24 === errors;
                                                                if (!valid7) {
                                                                    break;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate62.errors = [
                                                        {
                                                            instancePath: instancePath + '/comparisonColumns',
                                                            schemaPath: '#/properties/comparisonColumns/type',
                                                            keyword: 'type',
                                                            params: { type: 'array' },
                                                            message: 'must be array'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid3 = _errs22 === errors;
                                        }
                                        else {
                                            var valid3 = true;
                                        }
                                        if (valid3) {
                                            if (data.correlationColumns !== undefined) {
                                                let data9 = data.correlationColumns;
                                                const _errs26 = errors;
                                                if (errors === _errs26) {
                                                    if (Array.isArray(data9)) {
                                                        var valid8 = true;
                                                        const len1 = data9.length;
                                                        for (let i1 = 0; i1 < len1; i1++) {
                                                            const _errs28 = errors;
                                                            if (typeof data9[i1] !== 'string') {
                                                                validate62.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/correlationColumns/' + i1,
                                                                        schemaPath: '#/properties/correlationColumns/items/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid8 = _errs28 === errors;
                                                            if (!valid8) {
                                                                break;
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate62.errors = [
                                                            {
                                                                instancePath: instancePath + '/correlationColumns',
                                                                schemaPath: '#/properties/correlationColumns/type',
                                                                keyword: 'type',
                                                                params: { type: 'array' },
                                                                message: 'must be array'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid3 = _errs26 === errors;
                                            }
                                            else {
                                                var valid3 = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate62.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate62.errors = vErrors;
    return errors === 0;
}
export const dataProfileSchemaValidation = validate63;
const schema78 = {
    $id: 'urn:wisepipe-common-computation:DataProfile',
    type: 'object',
    properties: {
        status: { type: 'string', enum: ['running', 'completed', 'failed'] },
        progress: { type: 'number', minimum: 0, maximum: 1 },
        continuationToken: { type: 'string', uid: 9 },
        multiColumnMode: { type: 'boolean' }
    },
    required: ['status', 'progress'],
    if: { properties: { progress: { type: 'number', exclusiveMaximum: 1 } } },
    then: { required: ['continuationToken'] }
};
const func96 = ucs2length;
const func97 = base64urlToBuffer;
const func98 = base64urlEncode;
const func99 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate63(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:DataProfile" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.progress !== undefined) {
            let data0 = data.progress;
            const _errs3 = errors;
            if (errors === _errs3) {
                if (typeof data0 == 'number') {
                    if (data0 >= 1 || isNaN(data0)) {
                        const err0 = {};
                        if (vErrors === null) {
                            vErrors = [err0];
                        }
                        else {
                            vErrors.push(err0);
                        }
                        errors++;
                    }
                }
                else {
                    const err1 = {};
                    if (vErrors === null) {
                        vErrors = [err1];
                    }
                    else {
                        vErrors.push(err1);
                    }
                    errors++;
                }
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.continuationToken === undefined && (missing0 = 'continuationToken')) {
                validate63.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs5 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err2 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err2];
        }
        else {
            vErrors.push(err2);
        }
        errors++;
        validate63.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.status === undefined && (missing1 = 'status')) ||
                (data.progress === undefined && (missing1 = 'progress'))) {
                validate63.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.status !== undefined) {
                    let data1 = data.status;
                    const _errs6 = errors;
                    if (typeof data1 !== 'string') {
                        validate63.errors = [
                            {
                                instancePath: instancePath + '/status',
                                schemaPath: '#/properties/status/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data1 === 'running' || data1 === 'completed' || data1 === 'failed')) {
                        validate63.errors = [
                            {
                                instancePath: instancePath + '/status',
                                schemaPath: '#/properties/status/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema78.properties.status.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid2 = _errs6 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.progress !== undefined) {
                        let data2 = data.progress;
                        const _errs8 = errors;
                        if (errors === _errs8) {
                            if (typeof data2 == 'number') {
                                if (data2 > 1 || isNaN(data2)) {
                                    validate63.errors = [
                                        {
                                            instancePath: instancePath + '/progress',
                                            schemaPath: '#/properties/progress/maximum',
                                            keyword: 'maximum',
                                            params: { comparison: '<=', limit: 1 },
                                            message: 'must be <= 1'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data2 < 0 || isNaN(data2)) {
                                        validate63.errors = [
                                            {
                                                instancePath: instancePath + '/progress',
                                                schemaPath: '#/properties/progress/minimum',
                                                keyword: 'minimum',
                                                params: { comparison: '>=', limit: 0 },
                                                message: 'must be >= 0'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate63.errors = [
                                    {
                                        instancePath: instancePath + '/progress',
                                        schemaPath: '#/properties/progress/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid2 = _errs8 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.continuationToken !== undefined) {
                            let data3 = data.continuationToken;
                            const _errs10 = errors;
                            if (errors === _errs10) {
                                if (typeof data3 === 'string') {
                                    const b64min0 = Math.ceil((4 * 9) / 3);
                                    const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                    if (func96(data3) < b64min0 || func96(data3) > b64max0) {
                                        validate63.errors = [
                                            {
                                                instancePath: instancePath + '/continuationToken',
                                                schemaPath: '#/properties/continuationToken/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func96(data3) },
                                                message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func96(data3)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded0 = func97(data3);
                                        if (decoded0.length !== 9) {
                                            validate63.errors = [
                                                {
                                                    instancePath: instancePath + '/continuationToken',
                                                    schemaPath: '#/properties/continuationToken/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 9 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded0 = func98(decoded0);
                                            if (func99(encoded0) !== func99(data3)) {
                                                validate63.errors = [
                                                    {
                                                        instancePath: instancePath + '/continuationToken',
                                                        schemaPath: '#/properties/continuationToken/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate63.errors = [
                                        {
                                            instancePath: instancePath + '/continuationToken',
                                            schemaPath: '#/properties/continuationToken/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid2 = _errs10 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                        if (valid2) {
                            if (data.multiColumnMode !== undefined) {
                                const _errs12 = errors;
                                if (typeof data.multiColumnMode !== 'boolean') {
                                    validate63.errors = [
                                        {
                                            instancePath: instancePath + '/multiColumnMode',
                                            schemaPath: '#/properties/multiColumnMode/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean'
                                        }
                                    ];
                                    return false;
                                }
                                var valid2 = _errs12 === errors;
                            }
                            else {
                                var valid2 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate63.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate63.errors = vErrors;
    return errors === 0;
}
export const dataRequestCopyEventSchemaValidation = validate64;
const schema79 = {
    $id: 'urn:wisepipe-common-computation:DataRequestCopyEvent',
    type: 'object',
    properties: {
        oldOrgID: { type: 'string', format: 'uuid' },
        oldPipeID: { type: 'string', uid: 10 },
        newOrgID: { type: 'string', format: 'uuid' },
        newPipeID: { type: 'string', uid: 10 },
        savedDataRequestIDMap: { type: 'object', additionalProperties: { type: 'string', uid: 9 } },
        elementIDMap: { type: 'object', additionalProperties: { type: 'string', uid: 10 } }
    },
    required: ['oldOrgID', 'oldPipeID', 'newOrgID', 'newPipeID', 'savedDataRequestIDMap']
};
const func100 = ucs2length;
const func101 = base64urlToBuffer;
const func102 = base64urlEncode;
const func103 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func104 = ucs2length;
const func105 = base64urlToBuffer;
const func106 = base64urlEncode;
const func107 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func108 = ucs2length;
const func109 = base64urlToBuffer;
const func110 = base64urlEncode;
const func111 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func112 = ucs2length;
const func113 = base64urlToBuffer;
const func114 = base64urlEncode;
const func115 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate64(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:DataRequestCopyEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.oldOrgID === undefined && (missing0 = 'oldOrgID')) ||
                (data.oldPipeID === undefined && (missing0 = 'oldPipeID')) ||
                (data.newOrgID === undefined && (missing0 = 'newOrgID')) ||
                (data.newPipeID === undefined && (missing0 = 'newPipeID')) ||
                (data.savedDataRequestIDMap === undefined && (missing0 = 'savedDataRequestIDMap'))) {
                validate64.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.oldOrgID !== undefined) {
                    let data0 = data.oldOrgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats6.test(data0)) {
                                    validate64.errors = [
                                        {
                                            instancePath: instancePath + '/oldOrgID',
                                            schemaPath: '#/properties/oldOrgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate64.errors = [
                                    {
                                        instancePath: instancePath + '/oldOrgID',
                                        schemaPath: '#/properties/oldOrgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.oldPipeID !== undefined) {
                        let data1 = data.oldPipeID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                const b64min0 = Math.ceil((4 * 10) / 3);
                                const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                                if (func100(data1) < b64min0 || func100(data1) > b64max0) {
                                    validate64.errors = [
                                        {
                                            instancePath: instancePath + '/oldPipeID',
                                            schemaPath: '#/properties/oldPipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func100(data1) },
                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func100(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded0 = func101(data1);
                                    if (decoded0.length !== 10) {
                                        validate64.errors = [
                                            {
                                                instancePath: instancePath + '/oldPipeID',
                                                schemaPath: '#/properties/oldPipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 10 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded0 = func102(decoded0);
                                        if (func103(encoded0) !== func103(data1)) {
                                            validate64.errors = [
                                                {
                                                    instancePath: instancePath + '/oldPipeID',
                                                    schemaPath: '#/properties/oldPipeID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate64.errors = [
                                    {
                                        instancePath: instancePath + '/oldPipeID',
                                        schemaPath: '#/properties/oldPipeID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.newOrgID !== undefined) {
                            let data2 = data.newOrgID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (errors === _errs5) {
                                    if (typeof data2 === 'string') {
                                        if (!formats6.test(data2)) {
                                            validate64.errors = [
                                                {
                                                    instancePath: instancePath + '/newOrgID',
                                                    schemaPath: '#/properties/newOrgID/format',
                                                    keyword: 'format',
                                                    params: { format: 'uuid' },
                                                    message: 'must match format "' + 'uuid' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate64.errors = [
                                            {
                                                instancePath: instancePath + '/newOrgID',
                                                schemaPath: '#/properties/newOrgID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.newPipeID !== undefined) {
                                let data3 = data.newPipeID;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        const b64min1 = Math.ceil((4 * 10) / 3);
                                        const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                        if (func104(data3) < b64min1 || func104(data3) > b64max1) {
                                            validate64.errors = [
                                                {
                                                    instancePath: instancePath + '/newPipeID',
                                                    schemaPath: '#/properties/newPipeID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func104(data3) },
                                                    message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func104(data3)
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const decoded1 = func105(data3);
                                            if (decoded1.length !== 10) {
                                                validate64.errors = [
                                                    {
                                                        instancePath: instancePath + '/newPipeID',
                                                        schemaPath: '#/properties/newPipeID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'decoded' },
                                                        message: 'must decode to 10 bytes'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const encoded1 = func106(decoded1);
                                                if (func107(encoded1) !== func107(data3)) {
                                                    validate64.errors = [
                                                        {
                                                            instancePath: instancePath + '/newPipeID',
                                                            schemaPath: '#/properties/newPipeID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'ambiguous' },
                                                            message: 'encoding is ambiguous'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate64.errors = [
                                            {
                                                instancePath: instancePath + '/newPipeID',
                                                schemaPath: '#/properties/newPipeID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.savedDataRequestIDMap !== undefined) {
                                    let data4 = data.savedDataRequestIDMap;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                                            for (const key0 in data4) {
                                                let data5 = data4[key0];
                                                const _errs12 = errors;
                                                if (errors === _errs12) {
                                                    if (typeof data5 === 'string') {
                                                        const b64min2 = Math.ceil((4 * 9) / 3);
                                                        const b64max2 = Math.ceil((4 * 9) / 3) + 3;
                                                        if (func108(data5) < b64min2 || func108(data5) > b64max2) {
                                                            validate64.errors = [
                                                                {
                                                                    instancePath: instancePath +
                                                                        '/savedDataRequestIDMap/' +
                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                    schemaPath: '#/properties/savedDataRequestIDMap/additionalProperties/uid',
                                                                    keyword: 'uid',
                                                                    params: {
                                                                        error: 'encoded',
                                                                        b64min: b64min2,
                                                                        b64max: b64max2,
                                                                        length: func108(data5)
                                                                    },
                                                                    message: 'length must be between ' +
                                                                        b64min2 +
                                                                        ' and ' +
                                                                        b64max2 +
                                                                        ', but is ' +
                                                                        func108(data5)
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            const decoded2 = func109(data5);
                                                            if (decoded2.length !== 9) {
                                                                validate64.errors = [
                                                                    {
                                                                        instancePath: instancePath +
                                                                            '/savedDataRequestIDMap/' +
                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                        schemaPath: '#/properties/savedDataRequestIDMap/additionalProperties/uid',
                                                                        keyword: 'uid',
                                                                        params: { error: 'decoded' },
                                                                        message: 'must decode to 9 bytes'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                const encoded2 = func110(decoded2);
                                                                if (func111(encoded2) !== func111(data5)) {
                                                                    validate64.errors = [
                                                                        {
                                                                            instancePath: instancePath +
                                                                                '/savedDataRequestIDMap/' +
                                                                                key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                            schemaPath: '#/properties/savedDataRequestIDMap/additionalProperties/uid',
                                                                            keyword: 'uid',
                                                                            params: { error: 'ambiguous' },
                                                                            message: 'encoding is ambiguous'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate64.errors = [
                                                            {
                                                                instancePath: instancePath +
                                                                    '/savedDataRequestIDMap/' +
                                                                    key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                schemaPath: '#/properties/savedDataRequestIDMap/additionalProperties/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid3 = _errs12 === errors;
                                                if (!valid3) {
                                                    break;
                                                }
                                            }
                                        }
                                        else {
                                            validate64.errors = [
                                                {
                                                    instancePath: instancePath + '/savedDataRequestIDMap',
                                                    schemaPath: '#/properties/savedDataRequestIDMap/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.elementIDMap !== undefined) {
                                        let data6 = data.elementIDMap;
                                        const _errs14 = errors;
                                        if (errors === _errs14) {
                                            if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                                for (const key1 in data6) {
                                                    let data7 = data6[key1];
                                                    const _errs17 = errors;
                                                    if (errors === _errs17) {
                                                        if (typeof data7 === 'string') {
                                                            const b64min3 = Math.ceil((4 * 10) / 3);
                                                            const b64max3 = Math.ceil((4 * 10) / 3) + 3;
                                                            if (func112(data7) < b64min3 || func112(data7) > b64max3) {
                                                                validate64.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/elementIDMap/' + key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                        schemaPath: '#/properties/elementIDMap/additionalProperties/uid',
                                                                        keyword: 'uid',
                                                                        params: {
                                                                            error: 'encoded',
                                                                            b64min: b64min3,
                                                                            b64max: b64max3,
                                                                            length: func112(data7)
                                                                        },
                                                                        message: 'length must be between ' +
                                                                            b64min3 +
                                                                            ' and ' +
                                                                            b64max3 +
                                                                            ', but is ' +
                                                                            func112(data7)
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                const decoded3 = func113(data7);
                                                                if (decoded3.length !== 10) {
                                                                    validate64.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/elementIDMap/' + key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                            schemaPath: '#/properties/elementIDMap/additionalProperties/uid',
                                                                            keyword: 'uid',
                                                                            params: { error: 'decoded' },
                                                                            message: 'must decode to 10 bytes'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    const encoded3 = func114(decoded3);
                                                                    if (func115(encoded3) !== func115(data7)) {
                                                                        validate64.errors = [
                                                                            {
                                                                                instancePath: instancePath +
                                                                                    '/elementIDMap/' +
                                                                                    key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                                schemaPath: '#/properties/elementIDMap/additionalProperties/uid',
                                                                                keyword: 'uid',
                                                                                params: { error: 'ambiguous' },
                                                                                message: 'encoding is ambiguous'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate64.errors = [
                                                                {
                                                                    instancePath: instancePath + '/elementIDMap/' + key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                    schemaPath: '#/properties/elementIDMap/additionalProperties/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid5 = _errs17 === errors;
                                                    if (!valid5) {
                                                        break;
                                                    }
                                                }
                                            }
                                            else {
                                                validate64.errors = [
                                                    {
                                                        instancePath: instancePath + '/elementIDMap',
                                                        schemaPath: '#/properties/elementIDMap/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs14 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate64.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate64.errors = vErrors;
    return errors === 0;
}
export const dataRequestSchemaValidation = validate65;
const schema80 = {
    $id: 'urn:wisepipe-common-computation:DataRequest',
    type: 'object',
    properties: {
        pipeID: { type: 'string', uid: 10 },
        runID: { type: 'string' },
        requestType: {
            type: 'string',
            enum: [
                'sample',
                'run',
                'data',
                'malformed',
                'pipe',
                'sample_visual',
                'run_visual',
                'data_visual',
                'pipe_visual',
                'sample_stats',
                'pipe_stats',
                'data_stats',
                'run_stats',
                'pipe_stats_v2',
                'data_stats_v2',
                'run_stats_v2'
            ]
        },
        filters: { type: 'array', items: { $ref: 'urn:wisepipe-common-computation:Filter' }, maxItems: 20 }
    },
    required: ['requestType']
};
const schema81 = {
    $id: 'urn:wisepipe-common-computation:Filter',
    type: 'object',
    properties: {
        column: { type: 'string', maxLength: 150 },
        filterType: { type: 'string', enum: ['boolean', 'date', 'string', 'number', 'group', 'decimal'] }
    },
    required: ['filterType']
};
const func116 = ucs2length;
const func117 = base64urlToBuffer;
const func118 = base64urlEncode;
const func119 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate65(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:DataRequest" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.requestType === undefined && (missing0 = 'requestType')) {
                validate65.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pipeID !== undefined) {
                    let data0 = data.pipeID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func116(data0) < b64min0 || func116(data0) > b64max0) {
                                validate65.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func116(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func116(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func117(data0);
                                if (decoded0.length !== 10) {
                                    validate65.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func118(decoded0);
                                    if (func119(encoded0) !== func119(data0)) {
                                        validate65.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate65.errors = [
                                {
                                    instancePath: instancePath + '/pipeID',
                                    schemaPath: '#/properties/pipeID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.runID !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.runID !== 'string') {
                            validate65.errors = [
                                {
                                    instancePath: instancePath + '/runID',
                                    schemaPath: '#/properties/runID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.requestType !== undefined) {
                            let data2 = data.requestType;
                            const _errs5 = errors;
                            if (typeof data2 !== 'string') {
                                validate65.errors = [
                                    {
                                        instancePath: instancePath + '/requestType',
                                        schemaPath: '#/properties/requestType/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data2 === 'sample' ||
                                data2 === 'run' ||
                                data2 === 'data' ||
                                data2 === 'malformed' ||
                                data2 === 'pipe' ||
                                data2 === 'sample_visual' ||
                                data2 === 'run_visual' ||
                                data2 === 'data_visual' ||
                                data2 === 'pipe_visual' ||
                                data2 === 'sample_stats' ||
                                data2 === 'pipe_stats' ||
                                data2 === 'data_stats' ||
                                data2 === 'run_stats' ||
                                data2 === 'pipe_stats_v2' ||
                                data2 === 'data_stats_v2' ||
                                data2 === 'run_stats_v2')) {
                                validate65.errors = [
                                    {
                                        instancePath: instancePath + '/requestType',
                                        schemaPath: '#/properties/requestType/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema80.properties.requestType.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.filters !== undefined) {
                                let data3 = data.filters;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (Array.isArray(data3)) {
                                        if (data3.length > 20) {
                                            validate65.errors = [
                                                {
                                                    instancePath: instancePath + '/filters',
                                                    schemaPath: '#/properties/filters/maxItems',
                                                    keyword: 'maxItems',
                                                    params: { limit: 20 },
                                                    message: 'must NOT have more than 20 items'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            var valid2 = true;
                                            const len0 = data3.length;
                                            for (let i0 = 0; i0 < len0; i0++) {
                                                let data4 = data3[i0];
                                                const _errs9 = errors;
                                                const _errs10 = errors;
                                                if (errors === _errs10) {
                                                    if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                                                        let missing1;
                                                        if (data4.filterType === undefined && (missing1 = 'filterType')) {
                                                            validate65.errors = [
                                                                {
                                                                    instancePath: instancePath + '/filters/' + i0,
                                                                    schemaPath: 'urn:wisepipe-common-computation:Filter/required',
                                                                    keyword: 'required',
                                                                    params: { missingProperty: missing1 },
                                                                    message: "must have required property '" + missing1 + "'"
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            if (data4.column !== undefined) {
                                                                let data5 = data4.column;
                                                                const _errs12 = errors;
                                                                if (errors === _errs12) {
                                                                    if (typeof data5 === 'string') {
                                                                        if (func2(data5) > 150) {
                                                                            validate65.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/filters/' + i0 + '/column',
                                                                                    schemaPath: 'urn:wisepipe-common-computation:Filter/properties/column/maxLength',
                                                                                    keyword: 'maxLength',
                                                                                    params: { limit: 150 },
                                                                                    message: 'must NOT have more than 150 characters'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate65.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/filters/' + i0 + '/column',
                                                                                schemaPath: 'urn:wisepipe-common-computation:Filter/properties/column/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid4 = _errs12 === errors;
                                                            }
                                                            else {
                                                                var valid4 = true;
                                                            }
                                                            if (valid4) {
                                                                if (data4.filterType !== undefined) {
                                                                    let data6 = data4.filterType;
                                                                    const _errs14 = errors;
                                                                    if (typeof data6 !== 'string') {
                                                                        validate65.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/filters/' + i0 + '/filterType',
                                                                                schemaPath: 'urn:wisepipe-common-computation:Filter/properties/filterType/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    if (!(data6 === 'boolean' ||
                                                                        data6 === 'date' ||
                                                                        data6 === 'string' ||
                                                                        data6 === 'number' ||
                                                                        data6 === 'group' ||
                                                                        data6 === 'decimal')) {
                                                                        validate65.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/filters/' + i0 + '/filterType',
                                                                                schemaPath: 'urn:wisepipe-common-computation:Filter/properties/filterType/enum',
                                                                                keyword: 'enum',
                                                                                params: { allowedValues: schema81.properties.filterType.enum },
                                                                                message: 'must be equal to one of the allowed values'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid4 = _errs14 === errors;
                                                                }
                                                                else {
                                                                    var valid4 = true;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate65.errors = [
                                                            {
                                                                instancePath: instancePath + '/filters/' + i0,
                                                                schemaPath: 'urn:wisepipe-common-computation:Filter/type',
                                                                keyword: 'type',
                                                                params: { type: 'object' },
                                                                message: 'must be object'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid2 = _errs9 === errors;
                                                if (!valid2) {
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate65.errors = [
                                            {
                                                instancePath: instancePath + '/filters',
                                                schemaPath: '#/properties/filters/type',
                                                keyword: 'type',
                                                params: { type: 'array' },
                                                message: 'must be array'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate65.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate65.errors = vErrors;
    return errors === 0;
}
export const dataSourceDataProfileRequestSchemaValidation = validate66;
const schema82 = {
    $id: 'urn:wisepipe-common-computation:DataSourceDataProfileRequest',
    type: 'object',
    properties: { dataSourceID: { type: 'string', uid: 9 } },
    required: ['dataSourceID']
};
const func121 = ucs2length;
const func122 = base64urlToBuffer;
const func123 = base64urlEncode;
const func124 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate66(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:DataSourceDataProfileRequest" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.dataSourceID === undefined && (missing0 = 'dataSourceID')) {
                validate66.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.dataSourceID !== undefined) {
                    let data0 = data.dataSourceID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 9) / 3);
                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                            if (func121(data0) < b64min0 || func121(data0) > b64max0) {
                                validate66.errors = [
                                    {
                                        instancePath: instancePath + '/dataSourceID',
                                        schemaPath: '#/properties/dataSourceID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func121(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func121(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func122(data0);
                                if (decoded0.length !== 9) {
                                    validate66.errors = [
                                        {
                                            instancePath: instancePath + '/dataSourceID',
                                            schemaPath: '#/properties/dataSourceID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 9 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func123(decoded0);
                                    if (func124(encoded0) !== func124(data0)) {
                                        validate66.errors = [
                                            {
                                                instancePath: instancePath + '/dataSourceID',
                                                schemaPath: '#/properties/dataSourceID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate66.errors = [
                                {
                                    instancePath: instancePath + '/dataSourceID',
                                    schemaPath: '#/properties/dataSourceID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate66.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate66.errors = vErrors;
    return errors === 0;
}
export const dataSourceStatsRequestSchemaValidation = validate67;
const schema83 = {
    $id: 'urn:wisepipe-common-computation:DataSourceStatsRequest',
    type: 'object',
    properties: { dataSourceID: { type: 'string', uid: 9 } },
    required: ['dataSourceID']
};
const func125 = ucs2length;
const func126 = base64urlToBuffer;
const func127 = base64urlEncode;
const func128 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate67(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:DataSourceStatsRequest" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.dataSourceID === undefined && (missing0 = 'dataSourceID')) {
                validate67.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.dataSourceID !== undefined) {
                    let data0 = data.dataSourceID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 9) / 3);
                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                            if (func125(data0) < b64min0 || func125(data0) > b64max0) {
                                validate67.errors = [
                                    {
                                        instancePath: instancePath + '/dataSourceID',
                                        schemaPath: '#/properties/dataSourceID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func125(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func125(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func126(data0);
                                if (decoded0.length !== 9) {
                                    validate67.errors = [
                                        {
                                            instancePath: instancePath + '/dataSourceID',
                                            schemaPath: '#/properties/dataSourceID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 9 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func127(decoded0);
                                    if (func128(encoded0) !== func128(data0)) {
                                        validate67.errors = [
                                            {
                                                instancePath: instancePath + '/dataSourceID',
                                                schemaPath: '#/properties/dataSourceID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate67.errors = [
                                {
                                    instancePath: instancePath + '/dataSourceID',
                                    schemaPath: '#/properties/dataSourceID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate67.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate67.errors = vErrors;
    return errors === 0;
}
export const dateByDateGraphSchemaValidation = validate68;
const schema84 = {
    $id: 'urn:wisepipe-common-computation:DateByDateGraph',
    type: 'object',
    properties: {
        frequency: { type: 'array', items: { type: 'number' } },
        binEdges: { type: 'array', items: { type: 'number' } }
    },
    required: ['frequency', 'binEdges']
};
function validate68(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:DateByDateGraph" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.frequency === undefined && (missing0 = 'frequency')) ||
                (data.binEdges === undefined && (missing0 = 'binEdges'))) {
                validate68.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.frequency !== undefined) {
                    let data0 = data.frequency;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                const _errs3 = errors;
                                if (!(typeof data0[i0] == 'number')) {
                                    validate68.errors = [
                                        {
                                            instancePath: instancePath + '/frequency/' + i0,
                                            schemaPath: '#/properties/frequency/items/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number'
                                        }
                                    ];
                                    return false;
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                        }
                        else {
                            validate68.errors = [
                                {
                                    instancePath: instancePath + '/frequency',
                                    schemaPath: '#/properties/frequency/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.binEdges !== undefined) {
                        let data2 = data.binEdges;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (Array.isArray(data2)) {
                                var valid2 = true;
                                const len1 = data2.length;
                                for (let i1 = 0; i1 < len1; i1++) {
                                    const _errs7 = errors;
                                    if (!(typeof data2[i1] == 'number')) {
                                        validate68.errors = [
                                            {
                                                instancePath: instancePath + '/binEdges/' + i1,
                                                schemaPath: '#/properties/binEdges/items/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid2 = _errs7 === errors;
                                    if (!valid2) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate68.errors = [
                                    {
                                        instancePath: instancePath + '/binEdges',
                                        schemaPath: '#/properties/binEdges/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate68.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate68.errors = vErrors;
    return errors === 0;
}
export const dateColumnInfoSchemaValidation = validate69;
const schema85 = {
    $id: 'urn:wisepipe-common-computation:DateColumnInfo',
    type: 'object',
    properties: {
        missing: { type: 'number' },
        unique: { type: 'number' },
        max: { type: 'string', format: 'date-time' },
        min: { type: 'string', format: 'date-time' },
        histogramFrequency: { type: 'array', items: { type: 'number' } },
        histogramBinEdges: { type: 'array', items: { type: 'number' } }
    },
    required: ['missing']
};
function validate69(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:DateColumnInfo" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.missing === undefined && (missing0 = 'missing')) {
                validate69.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.missing !== undefined) {
                    const _errs1 = errors;
                    if (!(typeof data.missing == 'number')) {
                        validate69.errors = [
                            {
                                instancePath: instancePath + '/missing',
                                schemaPath: '#/properties/missing/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.unique !== undefined) {
                        const _errs3 = errors;
                        if (!(typeof data.unique == 'number')) {
                            validate69.errors = [
                                {
                                    instancePath: instancePath + '/unique',
                                    schemaPath: '#/properties/unique/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.max !== undefined) {
                            let data2 = data.max;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (errors === _errs5) {
                                    if (typeof data2 === 'string') {
                                        if (!formats0.validate(data2)) {
                                            validate69.errors = [
                                                {
                                                    instancePath: instancePath + '/max',
                                                    schemaPath: '#/properties/max/format',
                                                    keyword: 'format',
                                                    params: { format: 'date-time' },
                                                    message: 'must match format "' + 'date-time' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate69.errors = [
                                            {
                                                instancePath: instancePath + '/max',
                                                schemaPath: '#/properties/max/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.min !== undefined) {
                                let data3 = data.min;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (errors === _errs7) {
                                        if (typeof data3 === 'string') {
                                            if (!formats0.validate(data3)) {
                                                validate69.errors = [
                                                    {
                                                        instancePath: instancePath + '/min',
                                                        schemaPath: '#/properties/min/format',
                                                        keyword: 'format',
                                                        params: { format: 'date-time' },
                                                        message: 'must match format "' + 'date-time' + '"'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate69.errors = [
                                                {
                                                    instancePath: instancePath + '/min',
                                                    schemaPath: '#/properties/min/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.histogramFrequency !== undefined) {
                                    let data4 = data.histogramFrequency;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (Array.isArray(data4)) {
                                            var valid1 = true;
                                            const len0 = data4.length;
                                            for (let i0 = 0; i0 < len0; i0++) {
                                                const _errs11 = errors;
                                                if (!(typeof data4[i0] == 'number')) {
                                                    validate69.errors = [
                                                        {
                                                            instancePath: instancePath + '/histogramFrequency/' + i0,
                                                            schemaPath: '#/properties/histogramFrequency/items/type',
                                                            keyword: 'type',
                                                            params: { type: 'number' },
                                                            message: 'must be number'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid1 = _errs11 === errors;
                                                if (!valid1) {
                                                    break;
                                                }
                                            }
                                        }
                                        else {
                                            validate69.errors = [
                                                {
                                                    instancePath: instancePath + '/histogramFrequency',
                                                    schemaPath: '#/properties/histogramFrequency/type',
                                                    keyword: 'type',
                                                    params: { type: 'array' },
                                                    message: 'must be array'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.histogramBinEdges !== undefined) {
                                        let data6 = data.histogramBinEdges;
                                        const _errs13 = errors;
                                        if (errors === _errs13) {
                                            if (Array.isArray(data6)) {
                                                var valid2 = true;
                                                const len1 = data6.length;
                                                for (let i1 = 0; i1 < len1; i1++) {
                                                    const _errs15 = errors;
                                                    if (!(typeof data6[i1] == 'number')) {
                                                        validate69.errors = [
                                                            {
                                                                instancePath: instancePath + '/histogramBinEdges/' + i1,
                                                                schemaPath: '#/properties/histogramBinEdges/items/type',
                                                                keyword: 'type',
                                                                params: { type: 'number' },
                                                                message: 'must be number'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid2 = _errs15 === errors;
                                                    if (!valid2) {
                                                        break;
                                                    }
                                                }
                                            }
                                            else {
                                                validate69.errors = [
                                                    {
                                                        instancePath: instancePath + '/histogramBinEdges',
                                                        schemaPath: '#/properties/histogramBinEdges/type',
                                                        keyword: 'type',
                                                        params: { type: 'array' },
                                                        message: 'must be array'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs13 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate69.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate69.errors = vErrors;
    return errors === 0;
}
export const dateFilterSchemaValidation = validate70;
const schema86 = {
    $id: 'urn:wisepipe-common-computation:DateFilter',
    type: 'object',
    properties: {
        start: { type: 'string', format: 'date-time' },
        end: { type: 'string', format: 'date-time' },
        closed: { type: 'string', enum: ['left', 'right', 'both', 'neither'] },
        values: { type: 'array', items: { type: ['string', 'null'], format: 'date-time' } }
    }
};
function validate70(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:DateFilter" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.start !== undefined) {
                let data0 = data.start;
                const _errs1 = errors;
                if (errors === _errs1) {
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (!formats0.validate(data0)) {
                                validate70.errors = [
                                    {
                                        instancePath: instancePath + '/start',
                                        schemaPath: '#/properties/start/format',
                                        keyword: 'format',
                                        params: { format: 'date-time' },
                                        message: 'must match format "' + 'date-time' + '"'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate70.errors = [
                                {
                                    instancePath: instancePath + '/start',
                                    schemaPath: '#/properties/start/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.end !== undefined) {
                    let data1 = data.end;
                    const _errs3 = errors;
                    if (errors === _errs3) {
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (!formats0.validate(data1)) {
                                    validate70.errors = [
                                        {
                                            instancePath: instancePath + '/end',
                                            schemaPath: '#/properties/end/format',
                                            keyword: 'format',
                                            params: { format: 'date-time' },
                                            message: 'must match format "' + 'date-time' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate70.errors = [
                                    {
                                        instancePath: instancePath + '/end',
                                        schemaPath: '#/properties/end/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.closed !== undefined) {
                        let data2 = data.closed;
                        const _errs5 = errors;
                        if (typeof data2 !== 'string') {
                            validate70.errors = [
                                {
                                    instancePath: instancePath + '/closed',
                                    schemaPath: '#/properties/closed/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data2 === 'left' || data2 === 'right' || data2 === 'both' || data2 === 'neither')) {
                            validate70.errors = [
                                {
                                    instancePath: instancePath + '/closed',
                                    schemaPath: '#/properties/closed/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema86.properties.closed.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.values !== undefined) {
                            let data3 = data.values;
                            const _errs7 = errors;
                            if (errors === _errs7) {
                                if (Array.isArray(data3)) {
                                    var valid1 = true;
                                    const len0 = data3.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data4 = data3[i0];
                                        const _errs9 = errors;
                                        if (typeof data4 !== 'string' && data4 !== null) {
                                            validate70.errors = [
                                                {
                                                    instancePath: instancePath + '/values/' + i0,
                                                    schemaPath: '#/properties/values/items/type',
                                                    keyword: 'type',
                                                    params: { type: schema86.properties.values.items.type },
                                                    message: 'must be string,null'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (errors === _errs9) {
                                            if (errors === _errs9) {
                                                if (typeof data4 === 'string') {
                                                    if (!formats0.validate(data4)) {
                                                        validate70.errors = [
                                                            {
                                                                instancePath: instancePath + '/values/' + i0,
                                                                schemaPath: '#/properties/values/items/format',
                                                                keyword: 'format',
                                                                params: { format: 'date-time' },
                                                                message: 'must match format "' + 'date-time' + '"'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                        }
                                        var valid1 = _errs9 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate70.errors = [
                                        {
                                            instancePath: instancePath + '/values',
                                            schemaPath: '#/properties/values/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate70.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate70.errors = vErrors;
    return errors === 0;
}
export const decimalFilterSchemaValidation = validate71;
const schema87 = {
    $id: 'urn:wisepipe-common-computation:DecimalFilter',
    type: 'object',
    properties: { values: { type: 'array', items: { type: ['string', 'null'] } } },
    if: { required: ['start', 'end'] },
    then: {
        properties: {
            start: { type: 'string' },
            end: { type: 'string', minimum: { $data: '1/start' } },
            closed: { type: 'string', enum: ['left', 'right', 'both', 'neither'] }
        }
    },
    else: { properties: { start: { type: 'string' }, end: { type: 'string' } } }
};
function validate71(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:DecimalFilter" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if ((data.start === undefined && (missing0 = 'start')) || (data.end === undefined && (missing0 = 'end'))) {
            const err0 = {};
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    let ifClause0;
    if (_valid0) {
        const _errs3 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.start !== undefined) {
                const _errs4 = errors;
                if (typeof data.start !== 'string') {
                    validate71.errors = [
                        {
                            instancePath: instancePath + '/start',
                            schemaPath: '#/then/properties/start/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string'
                        }
                    ];
                    return false;
                }
                var valid1 = _errs4 === errors;
            }
            else {
                var valid1 = true;
            }
            if (valid1) {
                if (data.end !== undefined) {
                    let data1 = data.end;
                    const _errs6 = errors;
                    if (typeof data1 !== 'string') {
                        validate71.errors = [
                            {
                                instancePath: instancePath + '/end',
                                schemaPath: '#/then/properties/end/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (errors === _errs6) {
                        if (typeof data1 == 'number') {
                            const vSchema0 = data && data.start;
                            if (vSchema0 !== undefined && (!(typeof vSchema0 == 'number') || data1 < vSchema0 || isNaN(data1))) {
                                validate71.errors = [
                                    {
                                        instancePath: instancePath + '/end',
                                        schemaPath: '#/then/properties/end/minimum',
                                        keyword: 'minimum',
                                        params: { comparison: '>=', limit: vSchema0 },
                                        message: 'must be >= ' + vSchema0
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid1 = _errs6 === errors;
                }
                else {
                    var valid1 = true;
                }
                if (valid1) {
                    if (data.closed !== undefined) {
                        let data2 = data.closed;
                        const _errs8 = errors;
                        if (typeof data2 !== 'string') {
                            validate71.errors = [
                                {
                                    instancePath: instancePath + '/closed',
                                    schemaPath: '#/then/properties/closed/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data2 === 'left' || data2 === 'right' || data2 === 'both' || data2 === 'neither')) {
                            validate71.errors = [
                                {
                                    instancePath: instancePath + '/closed',
                                    schemaPath: '#/then/properties/closed/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema87.then.properties.closed.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid1 = _errs8 === errors;
                    }
                    else {
                        var valid1 = true;
                    }
                }
            }
        }
        var _valid0 = _errs3 === errors;
        valid0 = _valid0;
        ifClause0 = 'then';
    }
    else {
        const _errs10 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.start !== undefined) {
                const _errs11 = errors;
                if (typeof data.start !== 'string') {
                    validate71.errors = [
                        {
                            instancePath: instancePath + '/start',
                            schemaPath: '#/else/properties/start/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string'
                        }
                    ];
                    return false;
                }
                var valid2 = _errs11 === errors;
            }
            else {
                var valid2 = true;
            }
            if (valid2) {
                if (data.end !== undefined) {
                    const _errs13 = errors;
                    if (typeof data.end !== 'string') {
                        validate71.errors = [
                            {
                                instancePath: instancePath + '/end',
                                schemaPath: '#/else/properties/end/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid2 = _errs13 === errors;
                }
                else {
                    var valid2 = true;
                }
            }
        }
        var _valid0 = _errs10 === errors;
        valid0 = _valid0;
        ifClause0 = 'else';
    }
    if (!valid0) {
        const err1 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: ifClause0 },
            message: 'must match "' + ifClause0 + '" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate71.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.values !== undefined) {
                let data5 = data.values;
                const _errs15 = errors;
                if (errors === _errs15) {
                    if (Array.isArray(data5)) {
                        var valid4 = true;
                        const len0 = data5.length;
                        for (let i0 = 0; i0 < len0; i0++) {
                            let data6 = data5[i0];
                            const _errs17 = errors;
                            if (typeof data6 !== 'string' && data6 !== null) {
                                validate71.errors = [
                                    {
                                        instancePath: instancePath + '/values/' + i0,
                                        schemaPath: '#/properties/values/items/type',
                                        keyword: 'type',
                                        params: { type: schema87.properties.values.items.type },
                                        message: 'must be string,null'
                                    }
                                ];
                                return false;
                            }
                            var valid4 = _errs17 === errors;
                            if (!valid4) {
                                break;
                            }
                        }
                    }
                    else {
                        validate71.errors = [
                            {
                                instancePath: instancePath + '/values',
                                schemaPath: '#/properties/values/type',
                                keyword: 'type',
                                params: { type: 'array' },
                                message: 'must be array'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate71.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate71.errors = vErrors;
    return errors === 0;
}
export const enumToolVariableSchemaValidation = validate72;
function validate72(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:EnumToolVariable" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.toolEnumType !== undefined) {
                let data0 = data.toolEnumType;
                if (typeof data0 !== 'string') {
                    validate72.errors = [
                        {
                            instancePath: instancePath + '/toolEnumType',
                            schemaPath: '#/properties/toolEnumType/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string'
                        }
                    ];
                    return false;
                }
                if (!(data0 === 'SortDirection' ||
                    data0 === 'AggregateColumnOperation' ||
                    data0 === 'DateFrequency' ||
                    data0 === 'DateAddType' ||
                    data0 === 'DateAddUnit' ||
                    data0 === 'DateUnitType' ||
                    data0 === 'DatePartType' ||
                    data0 === 'JoinOperator' ||
                    data0 === 'JoinPattern' ||
                    data0 === 'FilterStatementOp' ||
                    data0 === 'ColumnType' ||
                    data0 === 'PeriodAddType')) {
                    validate72.errors = [
                        {
                            instancePath: instancePath + '/toolEnumType',
                            schemaPath: '#/properties/toolEnumType/enum',
                            keyword: 'enum',
                            params: { allowedValues: schema31.properties.toolEnumType.enum },
                            message: 'must be equal to one of the allowed values'
                        }
                    ];
                    return false;
                }
            }
        }
        else {
            validate72.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate72.errors = vErrors;
    return errors === 0;
}
export const exportCompletedWarningSchemaValidation = validate73;
const schema89 = {
    $id: 'urn:wisepipe-common-export:ExportCompletedWarning',
    type: 'object',
    properties: {
        code: { type: 'string', enum: ['GSheetsMaxCellLimitReached', 'workdayPayrollPartialFailure'] },
        message: { type: 'string' }
    },
    required: ['code']
};
function validate73(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:ExportCompletedWarning" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.code === undefined && (missing0 = 'code')) {
                validate73.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.code !== undefined) {
                    let data0 = data.code;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate73.errors = [
                            {
                                instancePath: instancePath + '/code',
                                schemaPath: '#/properties/code/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'GSheetsMaxCellLimitReached' || data0 === 'workdayPayrollPartialFailure')) {
                        validate73.errors = [
                            {
                                instancePath: instancePath + '/code',
                                schemaPath: '#/properties/code/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema89.properties.code.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.message !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.message !== 'string') {
                            validate73.errors = [
                                {
                                    instancePath: instancePath + '/message',
                                    schemaPath: '#/properties/message/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate73.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate73.errors = vErrors;
    return errors === 0;
}
export const exportRunConfigSchemaValidation = validate74;
const schema90 = {
    $id: 'urn:wisepipe-common-computation:ExportRunConfig',
    type: 'object',
    properties: {
        colValFilterMap: {
            type: 'object',
            additionalProperties: {
                type: 'array',
                oneOf: [{ items: { type: 'boolean' } }, { items: { type: 'string' } }, { items: { type: 'number' } }],
                minItems: 1,
                maxItems: 1000,
                uniqueItems: true
            }
        },
        keyColumns: { type: 'array', items: { type: 'string' }, minItems: 1, maxItems: 1000, uniqueItems: true }
    }
};
function validate74(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:ExportRunConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.colValFilterMap !== undefined) {
                let data0 = data.colValFilterMap;
                const _errs1 = errors;
                if (errors === _errs1) {
                    if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                        for (const key0 in data0) {
                            let data1 = data0[key0];
                            const _errs4 = errors;
                            const _errs6 = errors;
                            let valid2 = false;
                            let passing0 = null;
                            const _errs7 = errors;
                            if (Array.isArray(data1)) {
                                var valid3 = true;
                                const len0 = data1.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    const _errs8 = errors;
                                    if (typeof data1[i0] !== 'boolean') {
                                        const err0 = {
                                            instancePath: instancePath + '/colValFilterMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1') + '/' + i0,
                                            schemaPath: '#/properties/colValFilterMap/additionalProperties/oneOf/0/items/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err0];
                                        }
                                        else {
                                            vErrors.push(err0);
                                        }
                                        errors++;
                                    }
                                    var valid3 = _errs8 === errors;
                                    if (!valid3) {
                                        break;
                                    }
                                }
                            }
                            var _valid0 = _errs7 === errors;
                            if (_valid0) {
                                valid2 = true;
                                passing0 = 0;
                            }
                            const _errs10 = errors;
                            if (Array.isArray(data1)) {
                                var valid4 = true;
                                const len1 = data1.length;
                                for (let i1 = 0; i1 < len1; i1++) {
                                    const _errs11 = errors;
                                    if (typeof data1[i1] !== 'string') {
                                        const err1 = {
                                            instancePath: instancePath + '/colValFilterMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1') + '/' + i1,
                                            schemaPath: '#/properties/colValFilterMap/additionalProperties/oneOf/1/items/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err1];
                                        }
                                        else {
                                            vErrors.push(err1);
                                        }
                                        errors++;
                                    }
                                    var valid4 = _errs11 === errors;
                                    if (!valid4) {
                                        break;
                                    }
                                }
                            }
                            var _valid0 = _errs10 === errors;
                            if (_valid0 && valid2) {
                                valid2 = false;
                                passing0 = [passing0, 1];
                            }
                            else {
                                if (_valid0) {
                                    valid2 = true;
                                    passing0 = 1;
                                }
                                const _errs13 = errors;
                                if (Array.isArray(data1)) {
                                    var valid5 = true;
                                    const len2 = data1.length;
                                    for (let i2 = 0; i2 < len2; i2++) {
                                        const _errs14 = errors;
                                        if (!(typeof data1[i2] == 'number')) {
                                            const err2 = {
                                                instancePath: instancePath + '/colValFilterMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1') + '/' + i2,
                                                schemaPath: '#/properties/colValFilterMap/additionalProperties/oneOf/2/items/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err2];
                                            }
                                            else {
                                                vErrors.push(err2);
                                            }
                                            errors++;
                                        }
                                        var valid5 = _errs14 === errors;
                                        if (!valid5) {
                                            break;
                                        }
                                    }
                                }
                                var _valid0 = _errs13 === errors;
                                if (_valid0 && valid2) {
                                    valid2 = false;
                                    passing0 = [passing0, 2];
                                }
                                else {
                                    if (_valid0) {
                                        valid2 = true;
                                        passing0 = 2;
                                    }
                                }
                            }
                            if (!valid2) {
                                const err3 = {
                                    instancePath: instancePath + '/colValFilterMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                    schemaPath: '#/properties/colValFilterMap/additionalProperties/oneOf',
                                    keyword: 'oneOf',
                                    params: { passingSchemas: passing0 },
                                    message: 'must match exactly one schema in oneOf'
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                }
                                else {
                                    vErrors.push(err3);
                                }
                                errors++;
                                validate74.errors = vErrors;
                                return false;
                            }
                            else {
                                errors = _errs6;
                                if (vErrors !== null) {
                                    if (_errs6) {
                                        vErrors.length = _errs6;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                            }
                            if (errors === _errs4) {
                                if (Array.isArray(data1)) {
                                    if (data1.length > 1000) {
                                        validate74.errors = [
                                            {
                                                instancePath: instancePath + '/colValFilterMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                schemaPath: '#/properties/colValFilterMap/additionalProperties/maxItems',
                                                keyword: 'maxItems',
                                                params: { limit: 1000 },
                                                message: 'must NOT have more than 1000 items'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (data1.length < 1) {
                                            validate74.errors = [
                                                {
                                                    instancePath: instancePath + '/colValFilterMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                    schemaPath: '#/properties/colValFilterMap/additionalProperties/minItems',
                                                    keyword: 'minItems',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 items'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            let i3 = data1.length;
                                            let j0;
                                            if (i3 > 1) {
                                                outer0: for (; i3--;) {
                                                    for (j0 = i3; j0--;) {
                                                        if (func0(data1[i3], data1[j0])) {
                                                            validate74.errors = [
                                                                {
                                                                    instancePath: instancePath + '/colValFilterMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                    schemaPath: '#/properties/colValFilterMap/additionalProperties/uniqueItems',
                                                                    keyword: 'uniqueItems',
                                                                    params: { i: i3, j: j0 },
                                                                    message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i3 + ' are identical)'
                                                                }
                                                            ];
                                                            return false;
                                                            break outer0;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate74.errors = [
                                        {
                                            instancePath: instancePath + '/colValFilterMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                            schemaPath: '#/properties/colValFilterMap/additionalProperties/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid1 = _errs4 === errors;
                            if (!valid1) {
                                break;
                            }
                        }
                    }
                    else {
                        validate74.errors = [
                            {
                                instancePath: instancePath + '/colValFilterMap',
                                schemaPath: '#/properties/colValFilterMap/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            }
                        ];
                        return false;
                    }
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.keyColumns !== undefined) {
                    let data5 = data.keyColumns;
                    const _errs16 = errors;
                    if (errors === _errs16) {
                        if (Array.isArray(data5)) {
                            if (data5.length > 1000) {
                                validate74.errors = [
                                    {
                                        instancePath: instancePath + '/keyColumns',
                                        schemaPath: '#/properties/keyColumns/maxItems',
                                        keyword: 'maxItems',
                                        params: { limit: 1000 },
                                        message: 'must NOT have more than 1000 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data5.length < 1) {
                                    validate74.errors = [
                                        {
                                            instancePath: instancePath + '/keyColumns',
                                            schemaPath: '#/properties/keyColumns/minItems',
                                            keyword: 'minItems',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid7 = true;
                                    const len3 = data5.length;
                                    for (let i4 = 0; i4 < len3; i4++) {
                                        const _errs18 = errors;
                                        if (typeof data5[i4] !== 'string') {
                                            validate74.errors = [
                                                {
                                                    instancePath: instancePath + '/keyColumns/' + i4,
                                                    schemaPath: '#/properties/keyColumns/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid7 = _errs18 === errors;
                                        if (!valid7) {
                                            break;
                                        }
                                    }
                                    if (valid7) {
                                        let i5 = data5.length;
                                        let j1;
                                        if (i5 > 1) {
                                            const indices0 = {};
                                            for (; i5--;) {
                                                let item0 = data5[i5];
                                                if (typeof item0 !== 'string') {
                                                    continue;
                                                }
                                                if (typeof indices0[item0] == 'number') {
                                                    j1 = indices0[item0];
                                                    validate74.errors = [
                                                        {
                                                            instancePath: instancePath + '/keyColumns',
                                                            schemaPath: '#/properties/keyColumns/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i5, j: j1 },
                                                            message: 'must NOT have duplicate items (items ## ' + j1 + ' and ' + i5 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break;
                                                }
                                                indices0[item0] = i5;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate74.errors = [
                                {
                                    instancePath: instancePath + '/keyColumns',
                                    schemaPath: '#/properties/keyColumns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs16 === errors;
                }
                else {
                    var valid0 = true;
                }
            }
        }
        else {
            validate74.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate74.errors = vErrors;
    return errors === 0;
}
export const exportSettingsSchemaValidation = validate75;
const schema91 = {
    $id: 'urn:wisepipe-common-export:ExportSettings',
    type: 'object',
    properties: {
        exportType: {
            type: 'string',
            enum: [
                'gsheets',
                'icm',
                'postgres',
                'tq-postgres',
                'powerbi',
                'symon',
                'salesForce',
                'workday-payroll',
                'tableau',
                'tqp',
                'sftp',
                's3-csv',
                'snowflake',
                's3parquet',
                'msSql',
                'oneDrive'
            ]
        }
    },
    required: ['exportType']
};
function validate75(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:ExportSettings" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.exportType === undefined && (missing0 = 'exportType')) {
                validate75.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.exportType !== undefined) {
                    let data0 = data.exportType;
                    if (typeof data0 !== 'string') {
                        validate75.errors = [
                            {
                                instancePath: instancePath + '/exportType',
                                schemaPath: '#/properties/exportType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'gsheets' ||
                        data0 === 'icm' ||
                        data0 === 'postgres' ||
                        data0 === 'tq-postgres' ||
                        data0 === 'powerbi' ||
                        data0 === 'symon' ||
                        data0 === 'salesForce' ||
                        data0 === 'workday-payroll' ||
                        data0 === 'tableau' ||
                        data0 === 'tqp' ||
                        data0 === 'sftp' ||
                        data0 === 's3-csv' ||
                        data0 === 'snowflake' ||
                        data0 === 's3parquet' ||
                        data0 === 'msSql' ||
                        data0 === 'oneDrive')) {
                        validate75.errors = [
                            {
                                instancePath: instancePath + '/exportType',
                                schemaPath: '#/properties/exportType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema91.properties.exportType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate75.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate75.errors = vErrors;
    return errors === 0;
}
export const featureImportanceSchemaValidation = validate76;
const schema92 = {
    $id: 'urn:wisepipe-common-computation:FeatureImportance',
    type: 'object',
    properties: {
        elementID: { type: 'string', uid: 10 },
        label: { type: 'string', minLength: 1 },
        feature: { type: 'string', minLength: 1, maxLength: 150 },
        value: { type: 'number' },
        timestamp: { type: 'string', format: 'date-time' }
    },
    required: ['elementID', 'feature', 'value', 'timestamp']
};
const func130 = ucs2length;
const func131 = base64urlToBuffer;
const func132 = base64urlEncode;
const func133 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate76(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:FeatureImportance" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.elementID === undefined && (missing0 = 'elementID')) ||
                (data.feature === undefined && (missing0 = 'feature')) ||
                (data.value === undefined && (missing0 = 'value')) ||
                (data.timestamp === undefined && (missing0 = 'timestamp'))) {
                validate76.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.elementID !== undefined) {
                    let data0 = data.elementID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func130(data0) < b64min0 || func130(data0) > b64max0) {
                                validate76.errors = [
                                    {
                                        instancePath: instancePath + '/elementID',
                                        schemaPath: '#/properties/elementID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func130(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func130(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func131(data0);
                                if (decoded0.length !== 10) {
                                    validate76.errors = [
                                        {
                                            instancePath: instancePath + '/elementID',
                                            schemaPath: '#/properties/elementID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func132(decoded0);
                                    if (func133(encoded0) !== func133(data0)) {
                                        validate76.errors = [
                                            {
                                                instancePath: instancePath + '/elementID',
                                                schemaPath: '#/properties/elementID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate76.errors = [
                                {
                                    instancePath: instancePath + '/elementID',
                                    schemaPath: '#/properties/elementID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.label !== undefined) {
                        let data1 = data.label;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate76.errors = [
                                        {
                                            instancePath: instancePath + '/label',
                                            schemaPath: '#/properties/label/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate76.errors = [
                                    {
                                        instancePath: instancePath + '/label',
                                        schemaPath: '#/properties/label/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.feature !== undefined) {
                            let data2 = data.feature;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) > 150) {
                                        validate76.errors = [
                                            {
                                                instancePath: instancePath + '/feature',
                                                schemaPath: '#/properties/feature/maxLength',
                                                keyword: 'maxLength',
                                                params: { limit: 150 },
                                                message: 'must NOT have more than 150 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (func2(data2) < 1) {
                                            validate76.errors = [
                                                {
                                                    instancePath: instancePath + '/feature',
                                                    schemaPath: '#/properties/feature/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                else {
                                    validate76.errors = [
                                        {
                                            instancePath: instancePath + '/feature',
                                            schemaPath: '#/properties/feature/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.value !== undefined) {
                                const _errs7 = errors;
                                if (!(typeof data.value == 'number')) {
                                    validate76.errors = [
                                        {
                                            instancePath: instancePath + '/value',
                                            schemaPath: '#/properties/value/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.timestamp !== undefined) {
                                    let data4 = data.timestamp;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (errors === _errs9) {
                                            if (typeof data4 === 'string') {
                                                if (!formats0.validate(data4)) {
                                                    validate76.errors = [
                                                        {
                                                            instancePath: instancePath + '/timestamp',
                                                            schemaPath: '#/properties/timestamp/format',
                                                            keyword: 'format',
                                                            params: { format: 'date-time' },
                                                            message: 'must match format "' + 'date-time' + '"'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate76.errors = [
                                                    {
                                                        instancePath: instancePath + '/timestamp',
                                                        schemaPath: '#/properties/timestamp/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate76.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate76.errors = vErrors;
    return errors === 0;
}
export const filterGroupSchemaValidation = validate77;
const schema93 = {
    $id: 'urn:wisepipe-common-computation:FilterGroup',
    type: 'object',
    properties: {
        op: { type: 'string', pattern: 'and|or' },
        filters: { type: 'array', items: { $ref: 'urn:wisepipe-common-computation:Filter' }, uniqueItems: true }
    },
    required: ['op', 'filters']
};
const pattern1 = new RegExp('and|or', 'u');
function validate77(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:FilterGroup" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.op === undefined && (missing0 = 'op')) || (data.filters === undefined && (missing0 = 'filters'))) {
                validate77.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.op !== undefined) {
                    let data0 = data.op;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (!pattern1.test(data0)) {
                                validate77.errors = [
                                    {
                                        instancePath: instancePath + '/op',
                                        schemaPath: '#/properties/op/pattern',
                                        keyword: 'pattern',
                                        params: { pattern: 'and|or' },
                                        message: 'must match pattern "' + 'and|or' + '"'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate77.errors = [
                                {
                                    instancePath: instancePath + '/op',
                                    schemaPath: '#/properties/op/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.filters !== undefined) {
                        let data1 = data.filters;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                var valid1 = true;
                                const len0 = data1.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data2 = data1[i0];
                                    const _errs5 = errors;
                                    const _errs6 = errors;
                                    if (errors === _errs6) {
                                        if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                            let missing1;
                                            if (data2.filterType === undefined && (missing1 = 'filterType')) {
                                                validate77.errors = [
                                                    {
                                                        instancePath: instancePath + '/filters/' + i0,
                                                        schemaPath: 'urn:wisepipe-common-computation:Filter/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing1 },
                                                        message: "must have required property '" + missing1 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data2.column !== undefined) {
                                                    let data3 = data2.column;
                                                    const _errs8 = errors;
                                                    if (errors === _errs8) {
                                                        if (typeof data3 === 'string') {
                                                            if (func2(data3) > 150) {
                                                                validate77.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/filters/' + i0 + '/column',
                                                                        schemaPath: 'urn:wisepipe-common-computation:Filter/properties/column/maxLength',
                                                                        keyword: 'maxLength',
                                                                        params: { limit: 150 },
                                                                        message: 'must NOT have more than 150 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate77.errors = [
                                                                {
                                                                    instancePath: instancePath + '/filters/' + i0 + '/column',
                                                                    schemaPath: 'urn:wisepipe-common-computation:Filter/properties/column/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid3 = _errs8 === errors;
                                                }
                                                else {
                                                    var valid3 = true;
                                                }
                                                if (valid3) {
                                                    if (data2.filterType !== undefined) {
                                                        let data4 = data2.filterType;
                                                        const _errs10 = errors;
                                                        if (typeof data4 !== 'string') {
                                                            validate77.errors = [
                                                                {
                                                                    instancePath: instancePath + '/filters/' + i0 + '/filterType',
                                                                    schemaPath: 'urn:wisepipe-common-computation:Filter/properties/filterType/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        if (!(data4 === 'boolean' ||
                                                            data4 === 'date' ||
                                                            data4 === 'string' ||
                                                            data4 === 'number' ||
                                                            data4 === 'group' ||
                                                            data4 === 'decimal')) {
                                                            validate77.errors = [
                                                                {
                                                                    instancePath: instancePath + '/filters/' + i0 + '/filterType',
                                                                    schemaPath: 'urn:wisepipe-common-computation:Filter/properties/filterType/enum',
                                                                    keyword: 'enum',
                                                                    params: { allowedValues: schema81.properties.filterType.enum },
                                                                    message: 'must be equal to one of the allowed values'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid3 = _errs10 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate77.errors = [
                                                {
                                                    instancePath: instancePath + '/filters/' + i0,
                                                    schemaPath: 'urn:wisepipe-common-computation:Filter/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs5 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    let i1 = data1.length;
                                    let j0;
                                    if (i1 > 1) {
                                        outer0: for (; i1--;) {
                                            for (j0 = i1; j0--;) {
                                                if (func0(data1[i1], data1[j0])) {
                                                    validate77.errors = [
                                                        {
                                                            instancePath: instancePath + '/filters',
                                                            schemaPath: '#/properties/filters/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i1, j: j0 },
                                                            message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break outer0;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate77.errors = [
                                    {
                                        instancePath: instancePath + '/filters',
                                        schemaPath: '#/properties/filters/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate77.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate77.errors = vErrors;
    return errors === 0;
}
export const filterSchemaValidation = validate78;
function validate78(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:Filter" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.filterType === undefined && (missing0 = 'filterType')) {
                validate78.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.column !== undefined) {
                    let data0 = data.column;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 150) {
                                validate78.errors = [
                                    {
                                        instancePath: instancePath + '/column',
                                        schemaPath: '#/properties/column/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 150 },
                                        message: 'must NOT have more than 150 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate78.errors = [
                                {
                                    instancePath: instancePath + '/column',
                                    schemaPath: '#/properties/column/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.filterType !== undefined) {
                        let data1 = data.filterType;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate78.errors = [
                                {
                                    instancePath: instancePath + '/filterType',
                                    schemaPath: '#/properties/filterType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'boolean' ||
                            data1 === 'date' ||
                            data1 === 'string' ||
                            data1 === 'number' ||
                            data1 === 'group' ||
                            data1 === 'decimal')) {
                            validate78.errors = [
                                {
                                    instancePath: instancePath + '/filterType',
                                    schemaPath: '#/properties/filterType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema81.properties.filterType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate78.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate78.errors = vErrors;
    return errors === 0;
}
export const forecastVisualParamsSchemaValidation = validate79;
const schema96 = {
    $id: 'urn:wisepipe-common-computation:ForecastVisualParams',
    type: 'object',
    properties: {
        xAxis: { type: 'string', minLength: 1 },
        analyzeBy: { type: 'array', items: { type: 'string', minLength: 1 }, uniqueItems: true },
        isForecast: { type: 'string', minLength: 1 },
        historicalValue: { type: 'string', minLength: 1 },
        forecastedValue: { type: 'string', minLength: 1 },
        forecastLower: { type: 'string', minLength: 1 },
        forecastUpper: { type: 'string', minLength: 1 }
    },
    required: ['xAxis', 'isForecast', 'historicalValue', 'forecastedValue', 'forecastLower', 'forecastUpper']
};
function validate79(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:ForecastVisualParams" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.xAxis === undefined && (missing0 = 'xAxis')) ||
                (data.isForecast === undefined && (missing0 = 'isForecast')) ||
                (data.historicalValue === undefined && (missing0 = 'historicalValue')) ||
                (data.forecastedValue === undefined && (missing0 = 'forecastedValue')) ||
                (data.forecastLower === undefined && (missing0 = 'forecastLower')) ||
                (data.forecastUpper === undefined && (missing0 = 'forecastUpper'))) {
                validate79.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.xAxis !== undefined) {
                    let data0 = data.xAxis;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate79.errors = [
                                    {
                                        instancePath: instancePath + '/xAxis',
                                        schemaPath: '#/properties/xAxis/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate79.errors = [
                                {
                                    instancePath: instancePath + '/xAxis',
                                    schemaPath: '#/properties/xAxis/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.analyzeBy !== undefined) {
                        let data1 = data.analyzeBy;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                var valid1 = true;
                                const len0 = data1.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data2 = data1[i0];
                                    const _errs5 = errors;
                                    if (errors === _errs5) {
                                        if (typeof data2 === 'string') {
                                            if (func2(data2) < 1) {
                                                validate79.errors = [
                                                    {
                                                        instancePath: instancePath + '/analyzeBy/' + i0,
                                                        schemaPath: '#/properties/analyzeBy/items/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate79.errors = [
                                                {
                                                    instancePath: instancePath + '/analyzeBy/' + i0,
                                                    schemaPath: '#/properties/analyzeBy/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs5 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    let i1 = data1.length;
                                    let j0;
                                    if (i1 > 1) {
                                        const indices0 = {};
                                        for (; i1--;) {
                                            let item0 = data1[i1];
                                            if (typeof item0 !== 'string') {
                                                continue;
                                            }
                                            if (typeof indices0[item0] == 'number') {
                                                j0 = indices0[item0];
                                                validate79.errors = [
                                                    {
                                                        instancePath: instancePath + '/analyzeBy',
                                                        schemaPath: '#/properties/analyzeBy/uniqueItems',
                                                        keyword: 'uniqueItems',
                                                        params: { i: i1, j: j0 },
                                                        message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                    }
                                                ];
                                                return false;
                                                break;
                                            }
                                            indices0[item0] = i1;
                                        }
                                    }
                                }
                            }
                            else {
                                validate79.errors = [
                                    {
                                        instancePath: instancePath + '/analyzeBy',
                                        schemaPath: '#/properties/analyzeBy/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.isForecast !== undefined) {
                            let data3 = data.isForecast;
                            const _errs7 = errors;
                            if (errors === _errs7) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) < 1) {
                                        validate79.errors = [
                                            {
                                                instancePath: instancePath + '/isForecast',
                                                schemaPath: '#/properties/isForecast/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate79.errors = [
                                        {
                                            instancePath: instancePath + '/isForecast',
                                            schemaPath: '#/properties/isForecast/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.historicalValue !== undefined) {
                                let data4 = data.historicalValue;
                                const _errs9 = errors;
                                if (errors === _errs9) {
                                    if (typeof data4 === 'string') {
                                        if (func2(data4) < 1) {
                                            validate79.errors = [
                                                {
                                                    instancePath: instancePath + '/historicalValue',
                                                    schemaPath: '#/properties/historicalValue/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate79.errors = [
                                            {
                                                instancePath: instancePath + '/historicalValue',
                                                schemaPath: '#/properties/historicalValue/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.forecastedValue !== undefined) {
                                    let data5 = data.forecastedValue;
                                    const _errs11 = errors;
                                    if (errors === _errs11) {
                                        if (typeof data5 === 'string') {
                                            if (func2(data5) < 1) {
                                                validate79.errors = [
                                                    {
                                                        instancePath: instancePath + '/forecastedValue',
                                                        schemaPath: '#/properties/forecastedValue/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate79.errors = [
                                                {
                                                    instancePath: instancePath + '/forecastedValue',
                                                    schemaPath: '#/properties/forecastedValue/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs11 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.forecastLower !== undefined) {
                                        let data6 = data.forecastLower;
                                        const _errs13 = errors;
                                        if (errors === _errs13) {
                                            if (typeof data6 === 'string') {
                                                if (func2(data6) < 1) {
                                                    validate79.errors = [
                                                        {
                                                            instancePath: instancePath + '/forecastLower',
                                                            schemaPath: '#/properties/forecastLower/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate79.errors = [
                                                    {
                                                        instancePath: instancePath + '/forecastLower',
                                                        schemaPath: '#/properties/forecastLower/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs13 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.forecastUpper !== undefined) {
                                            let data7 = data.forecastUpper;
                                            const _errs15 = errors;
                                            if (errors === _errs15) {
                                                if (typeof data7 === 'string') {
                                                    if (func2(data7) < 1) {
                                                        validate79.errors = [
                                                            {
                                                                instancePath: instancePath + '/forecastUpper',
                                                                schemaPath: '#/properties/forecastUpper/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate79.errors = [
                                                        {
                                                            instancePath: instancePath + '/forecastUpper',
                                                            schemaPath: '#/properties/forecastUpper/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs15 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate79.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate79.errors = vErrors;
    return errors === 0;
}
export const genericVisualParamsSchemaValidation = validate80;
const schema97 = {
    $id: 'urn:wisepipe-common-computation:GenericVisualParams',
    type: 'object',
    properties: {
        subType: {
            type: 'string',
            enum: [
                'area_line',
                'area_line_stacked',
                'area_smooth_line',
                'area_smooth_line_stacked',
                'area_step_line',
                'area_step_line_stacked',
                'bar',
                'bar_stacked',
                'column',
                'column_stacked',
                'generic',
                'line',
                'radar',
                'scatter',
                'smooth_line',
                'step_line',
                'waterfall'
            ]
        },
        xAxis: { type: 'string', minLength: 1 },
        series: { type: 'array', items: { type: 'string', minLength: 1 }, uniqueItems: true, minItems: 1 },
        descriptions: { type: 'array', items: { type: 'string', minLength: 1 }, uniqueItems: true },
        aggOps: {
            type: 'array',
            items: {
                type: 'string',
                enum: ['MAX', 'MIN', 'COUNT', 'SUM', 'AVG', 'OR', 'AND', 'MEDIAN', 'DIFF', 'PCT', 'SHIFT', 'STDEV']
            },
            anyOf: [
                { minItems: 0, maxItems: 0 },
                { minItems: { $data: '1/series/length' }, maxItems: { $data: '1/series/length' } }
            ]
        },
        gradient: { type: 'boolean' },
        shadow: { type: 'boolean' }
    },
    required: ['subType', 'xAxis', 'series', 'aggOps']
};
function validate80(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:GenericVisualParams" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.subType === undefined && (missing0 = 'subType')) ||
                (data.xAxis === undefined && (missing0 = 'xAxis')) ||
                (data.series === undefined && (missing0 = 'series')) ||
                (data.aggOps === undefined && (missing0 = 'aggOps'))) {
                validate80.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.subType !== undefined) {
                    let data0 = data.subType;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate80.errors = [
                            {
                                instancePath: instancePath + '/subType',
                                schemaPath: '#/properties/subType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'area_line' ||
                        data0 === 'area_line_stacked' ||
                        data0 === 'area_smooth_line' ||
                        data0 === 'area_smooth_line_stacked' ||
                        data0 === 'area_step_line' ||
                        data0 === 'area_step_line_stacked' ||
                        data0 === 'bar' ||
                        data0 === 'bar_stacked' ||
                        data0 === 'column' ||
                        data0 === 'column_stacked' ||
                        data0 === 'generic' ||
                        data0 === 'line' ||
                        data0 === 'radar' ||
                        data0 === 'scatter' ||
                        data0 === 'smooth_line' ||
                        data0 === 'step_line' ||
                        data0 === 'waterfall')) {
                        validate80.errors = [
                            {
                                instancePath: instancePath + '/subType',
                                schemaPath: '#/properties/subType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema97.properties.subType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.xAxis !== undefined) {
                        let data1 = data.xAxis;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate80.errors = [
                                        {
                                            instancePath: instancePath + '/xAxis',
                                            schemaPath: '#/properties/xAxis/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate80.errors = [
                                    {
                                        instancePath: instancePath + '/xAxis',
                                        schemaPath: '#/properties/xAxis/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.series !== undefined) {
                            let data2 = data.series;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (Array.isArray(data2)) {
                                    if (data2.length < 1) {
                                        validate80.errors = [
                                            {
                                                instancePath: instancePath + '/series',
                                                schemaPath: '#/properties/series/minItems',
                                                keyword: 'minItems',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 items'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        var valid1 = true;
                                        const len0 = data2.length;
                                        for (let i0 = 0; i0 < len0; i0++) {
                                            let data3 = data2[i0];
                                            const _errs7 = errors;
                                            if (errors === _errs7) {
                                                if (typeof data3 === 'string') {
                                                    if (func2(data3) < 1) {
                                                        validate80.errors = [
                                                            {
                                                                instancePath: instancePath + '/series/' + i0,
                                                                schemaPath: '#/properties/series/items/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate80.errors = [
                                                        {
                                                            instancePath: instancePath + '/series/' + i0,
                                                            schemaPath: '#/properties/series/items/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid1 = _errs7 === errors;
                                            if (!valid1) {
                                                break;
                                            }
                                        }
                                        if (valid1) {
                                            let i1 = data2.length;
                                            let j0;
                                            if (i1 > 1) {
                                                const indices0 = {};
                                                for (; i1--;) {
                                                    let item0 = data2[i1];
                                                    if (typeof item0 !== 'string') {
                                                        continue;
                                                    }
                                                    if (typeof indices0[item0] == 'number') {
                                                        j0 = indices0[item0];
                                                        validate80.errors = [
                                                            {
                                                                instancePath: instancePath + '/series',
                                                                schemaPath: '#/properties/series/uniqueItems',
                                                                keyword: 'uniqueItems',
                                                                params: { i: i1, j: j0 },
                                                                message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                            }
                                                        ];
                                                        return false;
                                                        break;
                                                    }
                                                    indices0[item0] = i1;
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate80.errors = [
                                        {
                                            instancePath: instancePath + '/series',
                                            schemaPath: '#/properties/series/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.descriptions !== undefined) {
                                let data4 = data.descriptions;
                                const _errs9 = errors;
                                if (errors === _errs9) {
                                    if (Array.isArray(data4)) {
                                        var valid3 = true;
                                        const len1 = data4.length;
                                        for (let i2 = 0; i2 < len1; i2++) {
                                            let data5 = data4[i2];
                                            const _errs11 = errors;
                                            if (errors === _errs11) {
                                                if (typeof data5 === 'string') {
                                                    if (func2(data5) < 1) {
                                                        validate80.errors = [
                                                            {
                                                                instancePath: instancePath + '/descriptions/' + i2,
                                                                schemaPath: '#/properties/descriptions/items/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate80.errors = [
                                                        {
                                                            instancePath: instancePath + '/descriptions/' + i2,
                                                            schemaPath: '#/properties/descriptions/items/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid3 = _errs11 === errors;
                                            if (!valid3) {
                                                break;
                                            }
                                        }
                                        if (valid3) {
                                            let i3 = data4.length;
                                            let j1;
                                            if (i3 > 1) {
                                                const indices1 = {};
                                                for (; i3--;) {
                                                    let item1 = data4[i3];
                                                    if (typeof item1 !== 'string') {
                                                        continue;
                                                    }
                                                    if (typeof indices1[item1] == 'number') {
                                                        j1 = indices1[item1];
                                                        validate80.errors = [
                                                            {
                                                                instancePath: instancePath + '/descriptions',
                                                                schemaPath: '#/properties/descriptions/uniqueItems',
                                                                keyword: 'uniqueItems',
                                                                params: { i: i3, j: j1 },
                                                                message: 'must NOT have duplicate items (items ## ' + j1 + ' and ' + i3 + ' are identical)'
                                                            }
                                                        ];
                                                        return false;
                                                        break;
                                                    }
                                                    indices1[item1] = i3;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate80.errors = [
                                            {
                                                instancePath: instancePath + '/descriptions',
                                                schemaPath: '#/properties/descriptions/type',
                                                keyword: 'type',
                                                params: { type: 'array' },
                                                message: 'must be array'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.aggOps !== undefined) {
                                    let data6 = data.aggOps;
                                    const _errs13 = errors;
                                    const _errs15 = errors;
                                    let valid5 = false;
                                    const _errs16 = errors;
                                    if (Array.isArray(data6)) {
                                        if (data6.length > 0) {
                                            const err0 = {
                                                instancePath: instancePath + '/aggOps',
                                                schemaPath: '#/properties/aggOps/anyOf/0/maxItems',
                                                keyword: 'maxItems',
                                                params: { limit: 0 },
                                                message: 'must NOT have more than 0 items'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err0];
                                            }
                                            else {
                                                vErrors.push(err0);
                                            }
                                            errors++;
                                        }
                                        else {
                                            if (data6.length < 0) {
                                                const err1 = {
                                                    instancePath: instancePath + '/aggOps',
                                                    schemaPath: '#/properties/aggOps/anyOf/0/minItems',
                                                    keyword: 'minItems',
                                                    params: { limit: 0 },
                                                    message: 'must NOT have fewer than 0 items'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err1];
                                                }
                                                else {
                                                    vErrors.push(err1);
                                                }
                                                errors++;
                                            }
                                        }
                                    }
                                    var _valid0 = _errs16 === errors;
                                    valid5 = valid5 || _valid0;
                                    if (!valid5) {
                                        const _errs17 = errors;
                                        if (Array.isArray(data6)) {
                                            const vSchema1 = data && data.series && data.series.length;
                                            if (vSchema1 !== undefined && (!(typeof vSchema1 == 'number') || data6.length > vSchema1)) {
                                                const err2 = {
                                                    instancePath: instancePath + '/aggOps',
                                                    schemaPath: '#/properties/aggOps/anyOf/1/maxItems',
                                                    keyword: 'maxItems',
                                                    params: { limit: vSchema1 },
                                                    message: 'must NOT have more than ' + vSchema1 + ' items'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err2];
                                                }
                                                else {
                                                    vErrors.push(err2);
                                                }
                                                errors++;
                                            }
                                            else {
                                                const vSchema2 = data && data.series && data.series.length;
                                                if (vSchema2 !== undefined && (!(typeof vSchema2 == 'number') || data6.length < vSchema2)) {
                                                    const err3 = {
                                                        instancePath: instancePath + '/aggOps',
                                                        schemaPath: '#/properties/aggOps/anyOf/1/minItems',
                                                        keyword: 'minItems',
                                                        params: { limit: vSchema2 },
                                                        message: 'must NOT have fewer than ' + vSchema2 + ' items'
                                                    };
                                                    if (vErrors === null) {
                                                        vErrors = [err3];
                                                    }
                                                    else {
                                                        vErrors.push(err3);
                                                    }
                                                    errors++;
                                                }
                                            }
                                        }
                                        var _valid0 = _errs17 === errors;
                                        valid5 = valid5 || _valid0;
                                    }
                                    if (!valid5) {
                                        const err4 = {
                                            instancePath: instancePath + '/aggOps',
                                            schemaPath: '#/properties/aggOps/anyOf',
                                            keyword: 'anyOf',
                                            params: {},
                                            message: 'must match a schema in anyOf'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err4];
                                        }
                                        else {
                                            vErrors.push(err4);
                                        }
                                        errors++;
                                        validate80.errors = vErrors;
                                        return false;
                                    }
                                    else {
                                        errors = _errs15;
                                        if (vErrors !== null) {
                                            if (_errs15) {
                                                vErrors.length = _errs15;
                                            }
                                            else {
                                                vErrors = null;
                                            }
                                        }
                                    }
                                    if (errors === _errs13) {
                                        if (Array.isArray(data6)) {
                                            var valid6 = true;
                                            const len2 = data6.length;
                                            for (let i4 = 0; i4 < len2; i4++) {
                                                let data7 = data6[i4];
                                                const _errs18 = errors;
                                                if (typeof data7 !== 'string') {
                                                    validate80.errors = [
                                                        {
                                                            instancePath: instancePath + '/aggOps/' + i4,
                                                            schemaPath: '#/properties/aggOps/items/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                if (!(data7 === 'MAX' ||
                                                    data7 === 'MIN' ||
                                                    data7 === 'COUNT' ||
                                                    data7 === 'SUM' ||
                                                    data7 === 'AVG' ||
                                                    data7 === 'OR' ||
                                                    data7 === 'AND' ||
                                                    data7 === 'MEDIAN' ||
                                                    data7 === 'DIFF' ||
                                                    data7 === 'PCT' ||
                                                    data7 === 'SHIFT' ||
                                                    data7 === 'STDEV')) {
                                                    validate80.errors = [
                                                        {
                                                            instancePath: instancePath + '/aggOps/' + i4,
                                                            schemaPath: '#/properties/aggOps/items/enum',
                                                            keyword: 'enum',
                                                            params: { allowedValues: schema97.properties.aggOps.items.enum },
                                                            message: 'must be equal to one of the allowed values'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid6 = _errs18 === errors;
                                                if (!valid6) {
                                                    break;
                                                }
                                            }
                                        }
                                        else {
                                            validate80.errors = [
                                                {
                                                    instancePath: instancePath + '/aggOps',
                                                    schemaPath: '#/properties/aggOps/type',
                                                    keyword: 'type',
                                                    params: { type: 'array' },
                                                    message: 'must be array'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs13 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.gradient !== undefined) {
                                        const _errs20 = errors;
                                        if (typeof data.gradient !== 'boolean') {
                                            validate80.errors = [
                                                {
                                                    instancePath: instancePath + '/gradient',
                                                    schemaPath: '#/properties/gradient/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs20 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.shadow !== undefined) {
                                            const _errs22 = errors;
                                            if (typeof data.shadow !== 'boolean') {
                                                validate80.errors = [
                                                    {
                                                        instancePath: instancePath + '/shadow',
                                                        schemaPath: '#/properties/shadow/type',
                                                        keyword: 'type',
                                                        params: { type: 'boolean' },
                                                        message: 'must be boolean'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs22 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate80.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate80.errors = vErrors;
    return errors === 0;
}
export const graphElementSchemaValidation = validate81;
const schema98 = {
    $id: 'urn:wisepipe-common-pipe:GraphElement',
    type: 'object',
    properties: {
        elementID: { type: 'string', uid: 10 },
        elementType: { type: 'string', pattern: 'edge|node|group' },
        lastModified: { type: 'string', format: 'date-time' },
        uniqueChangeID: { type: 'string' }
    },
    required: ['elementID', 'elementType']
};
const func150 = ucs2length;
const func151 = base64urlToBuffer;
const func152 = base64urlEncode;
const func153 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const pattern2 = new RegExp('edge|node|group', 'u');
function validate81(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:GraphElement" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.elementID === undefined && (missing0 = 'elementID')) ||
                (data.elementType === undefined && (missing0 = 'elementType'))) {
                validate81.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.elementID !== undefined) {
                    let data0 = data.elementID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func150(data0) < b64min0 || func150(data0) > b64max0) {
                                validate81.errors = [
                                    {
                                        instancePath: instancePath + '/elementID',
                                        schemaPath: '#/properties/elementID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func150(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func150(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func151(data0);
                                if (decoded0.length !== 10) {
                                    validate81.errors = [
                                        {
                                            instancePath: instancePath + '/elementID',
                                            schemaPath: '#/properties/elementID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func152(decoded0);
                                    if (func153(encoded0) !== func153(data0)) {
                                        validate81.errors = [
                                            {
                                                instancePath: instancePath + '/elementID',
                                                schemaPath: '#/properties/elementID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate81.errors = [
                                {
                                    instancePath: instancePath + '/elementID',
                                    schemaPath: '#/properties/elementID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.elementType !== undefined) {
                        let data1 = data.elementType;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (!pattern2.test(data1)) {
                                    validate81.errors = [
                                        {
                                            instancePath: instancePath + '/elementType',
                                            schemaPath: '#/properties/elementType/pattern',
                                            keyword: 'pattern',
                                            params: { pattern: 'edge|node|group' },
                                            message: 'must match pattern "' + 'edge|node|group' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate81.errors = [
                                    {
                                        instancePath: instancePath + '/elementType',
                                        schemaPath: '#/properties/elementType/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.lastModified !== undefined) {
                            let data2 = data.lastModified;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (errors === _errs5) {
                                    if (typeof data2 === 'string') {
                                        if (!formats0.validate(data2)) {
                                            validate81.errors = [
                                                {
                                                    instancePath: instancePath + '/lastModified',
                                                    schemaPath: '#/properties/lastModified/format',
                                                    keyword: 'format',
                                                    params: { format: 'date-time' },
                                                    message: 'must match format "' + 'date-time' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate81.errors = [
                                            {
                                                instancePath: instancePath + '/lastModified',
                                                schemaPath: '#/properties/lastModified/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.uniqueChangeID !== undefined) {
                                const _errs7 = errors;
                                if (typeof data.uniqueChangeID !== 'string') {
                                    validate81.errors = [
                                        {
                                            instancePath: instancePath + '/uniqueChangeID',
                                            schemaPath: '#/properties/uniqueChangeID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate81.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate81.errors = vErrors;
    return errors === 0;
}
export const heatmapVisualParamsSchemaValidation = validate82;
const schema99 = {
    $id: 'urn:wisepipe-common-computation:HeatmapVisualParams',
    type: 'object',
    properties: {
        xAxis: { type: 'string', minLength: 1 },
        yAxis: { type: 'string', minLength: 1 },
        value: { type: 'string', minLength: 1 },
        aggOp: {
            type: 'string',
            enum: ['MAX', 'MIN', 'COUNT', 'SUM', 'AVG', 'OR', 'AND', 'MEDIAN', 'DIFF', 'PCT', 'SHIFT', 'STDEV']
        }
    },
    required: ['xAxis', 'yAxis', 'value']
};
function validate82(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:HeatmapVisualParams" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.xAxis === undefined && (missing0 = 'xAxis')) ||
                (data.yAxis === undefined && (missing0 = 'yAxis')) ||
                (data.value === undefined && (missing0 = 'value'))) {
                validate82.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.xAxis !== undefined) {
                    let data0 = data.xAxis;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate82.errors = [
                                    {
                                        instancePath: instancePath + '/xAxis',
                                        schemaPath: '#/properties/xAxis/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate82.errors = [
                                {
                                    instancePath: instancePath + '/xAxis',
                                    schemaPath: '#/properties/xAxis/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.yAxis !== undefined) {
                        let data1 = data.yAxis;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate82.errors = [
                                        {
                                            instancePath: instancePath + '/yAxis',
                                            schemaPath: '#/properties/yAxis/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate82.errors = [
                                    {
                                        instancePath: instancePath + '/yAxis',
                                        schemaPath: '#/properties/yAxis/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.value !== undefined) {
                            let data2 = data.value;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate82.errors = [
                                            {
                                                instancePath: instancePath + '/value',
                                                schemaPath: '#/properties/value/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate82.errors = [
                                        {
                                            instancePath: instancePath + '/value',
                                            schemaPath: '#/properties/value/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.aggOp !== undefined) {
                                let data3 = data.aggOp;
                                const _errs7 = errors;
                                if (typeof data3 !== 'string') {
                                    validate82.errors = [
                                        {
                                            instancePath: instancePath + '/aggOp',
                                            schemaPath: '#/properties/aggOp/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data3 === 'MAX' ||
                                    data3 === 'MIN' ||
                                    data3 === 'COUNT' ||
                                    data3 === 'SUM' ||
                                    data3 === 'AVG' ||
                                    data3 === 'OR' ||
                                    data3 === 'AND' ||
                                    data3 === 'MEDIAN' ||
                                    data3 === 'DIFF' ||
                                    data3 === 'PCT' ||
                                    data3 === 'SHIFT' ||
                                    data3 === 'STDEV')) {
                                    validate82.errors = [
                                        {
                                            instancePath: instancePath + '/aggOp',
                                            schemaPath: '#/properties/aggOp/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema99.properties.aggOp.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate82.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate82.errors = vErrors;
    return errors === 0;
}
export const histogramVisualParamsSchemaValidation = validate83;
const schema100 = {
    $id: 'urn:wisepipe-common-computation:HistogramVisualParams',
    type: 'object',
    properties: { xAxis: { type: 'string', minLength: 1 }, numBins: { type: 'integer', minimum: 1, maximum: 100 } },
    required: ['xAxis']
};
function validate83(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:HistogramVisualParams" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.xAxis === undefined && (missing0 = 'xAxis')) {
                validate83.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.xAxis !== undefined) {
                    let data0 = data.xAxis;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate83.errors = [
                                    {
                                        instancePath: instancePath + '/xAxis',
                                        schemaPath: '#/properties/xAxis/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate83.errors = [
                                {
                                    instancePath: instancePath + '/xAxis',
                                    schemaPath: '#/properties/xAxis/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.numBins !== undefined) {
                        let data1 = data.numBins;
                        const _errs3 = errors;
                        if (!(typeof data1 == 'number' && !(data1 % 1) && !isNaN(data1))) {
                            validate83.errors = [
                                {
                                    instancePath: instancePath + '/numBins',
                                    schemaPath: '#/properties/numBins/type',
                                    keyword: 'type',
                                    params: { type: 'integer' },
                                    message: 'must be integer'
                                }
                            ];
                            return false;
                        }
                        if (errors === _errs3) {
                            if (typeof data1 == 'number') {
                                if (data1 > 100 || isNaN(data1)) {
                                    validate83.errors = [
                                        {
                                            instancePath: instancePath + '/numBins',
                                            schemaPath: '#/properties/numBins/maximum',
                                            keyword: 'maximum',
                                            params: { comparison: '<=', limit: 100 },
                                            message: 'must be <= 100'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data1 < 1 || isNaN(data1)) {
                                        validate83.errors = [
                                            {
                                                instancePath: instancePath + '/numBins',
                                                schemaPath: '#/properties/numBins/minimum',
                                                keyword: 'minimum',
                                                params: { comparison: '>=', limit: 1 },
                                                message: 'must be >= 1'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate83.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate83.errors = vErrors;
    return errors === 0;
}
export const importConfigSchemaValidation = validate84;
const schema101 = {
    $id: 'urn:wisepipe-common-data:ImportConfig',
    type: 'object',
    properties: {
        importConfigType: {
            type: 'string',
            enum: [
                's3csv',
                'gsheets',
                'adwords',
                'googleAnalytics',
                'shopify',
                'mySql',
                'oracle',
                'postgreSql',
                'amazonAurora',
                'amazonRedshift',
                'amazonS3',
                'icm',
                'salesForce',
                'parquet',
                'excel',
                'global',
                'hubspot',
                'symon',
                'dynamics',
                's3parquet',
                'snowflake',
                'msSql',
                'agentSync',
                'workday',
                'workdayRaaS',
                'tqp',
                'tableau',
                'sftp',
                'powerbi',
                'rest',
                'gong',
                'fwf',
                'netSuite',
                'oneDrive',
                'eltApi',
                'microsoftSqlServer',
                'stripe',
                'microsoftDynamics365',
                'github',
                'facebookAds',
                'amplitude',
                'appsFlyer',
                'customerIo',
                'freshDesk',
                'fullstory',
                'googleCloud',
                'googleEcommerce',
                'listrak',
                'livePerson',
                'onFleet',
                'saasquatch',
                'selligent',
                'userVoice',
                'vero',
                'adRoll',
                'afterShip',
                'asana',
                'autopilot',
                'azure',
                'bigCommerce',
                'bingAds',
                'brainTree',
                'bronto',
                'campaignManager',
                'campaignMonitor',
                'chargeBee',
                'closeIo',
                'clubspeed',
                'codat',
                'contentful',
                'delighted',
                'drip',
                'eloqua',
                'formkeep',
                'front',
                'ftp',
                'gitlab',
                'harvest',
                'heap',
                'helpScout',
                'heroku',
                'ibmDb2',
                'invoiced',
                'iterable',
                'klaviyo',
                'magento',
                'mailjet',
                'mariaDb',
                'mixpanel',
                'mongoDb',
                'outbrain',
                'particle',
                'purple',
                'quickBase',
                'recurly',
                'responsys',
                'revinate',
                'salesforceDesk',
                'salesforcePardot',
                'segment',
                'sendGrid',
                'sendWithUs',
                'shipHero',
                'shippo',
                'sparkPost',
                'square',
                'taboola',
                'toggl',
                'trello',
                'typeform',
                'urbanAirship',
                'webhooks',
                'yotpo',
                'zapier',
                'zendeskChat',
                'zendeskSupport',
                'googleBigQuery',
                'intercom',
                'sapSuccessFactors',
                'sapCrm',
                'ukg',
                'oracleHcm',
                'Adp',
                'dynamics365Sales',
                'ceridianDayforce',
                'oracleCrm',
                'oracleErpCloud',
                'sageIntacct',
                'bambooHr',
                'sapErp',
                'googleCloudPlatformCloudStorage',
                'sas',
                'dropbox',
                'googleDrive',
                'jira',
                'monday',
                'zuora',
                'adobeAnalytics',
                'zoomInfo',
                'marketo',
                'activeCampaign',
                'mailchimp',
                'infor',
                'cornerstoneOnDemand',
                'gusto',
                'paychexFlex',
                'zendesk',
                'serviceNow',
                'zohoCrm',
                'pipedrive',
                'quickBooks',
                'xero',
                'freshbooks',
                'zohoBooks',
                'waveFinancial'
            ]
        },
        columnsToUpdate: {
            type: 'object',
            additionalProperties: {
                type: 'array',
                items: { $ref: 'urn:wisepipe-common-data:ColumnUpdate' },
                uniqueItems: true
            }
        },
        columnsToDrop: {
            type: 'object',
            additionalProperties: { type: 'array', items: { type: 'string' }, uniqueItems: true }
        },
        columnsToMask: {
            type: 'object',
            additionalProperties: { type: 'array', items: { type: 'string' }, uniqueItems: true }
        },
        filters: { type: 'object', additionalProperties: { $ref: 'urn:wisepipe-common-data:ImportFilter' } },
        dataCategory: { type: 'string', enum: ['dataSource', 'unitTestDataSource', 'unitTestSnapshot'] }
    },
    required: ['importConfigType']
};
const schema103 = {
    $id: 'urn:wisepipe-common-data:ImportFilter',
    type: 'object',
    properties: {
        op: {
            type: 'string',
            enum: [
                'and',
                'or',
                'less_than',
                'less_than_equals',
                'equals',
                'not_equals',
                'greater_than_equals',
                'greater_than',
                'is_null',
                'is_not_null',
                'starts_with',
                'ends_with',
                'contains',
                'not_contains'
            ]
        },
        filterType: { type: 'string', enum: ['statement', 'group'] },
        filters: { type: 'array', items: { $ref: 'urn:wisepipe-common-data:ImportFilter' } },
        lhs: { $ref: 'urn:wisepipe-common-data:ImportFilterOperand' },
        rhs: { $ref: 'urn:wisepipe-common-data:ImportFilterOperand' }
    },
    required: ['op', 'filterType'],
    if: { properties: { filterType: { const: 'group' } } },
    then: { required: ['filters'] },
    else: { required: ['lhs', 'op'] }
};
const schema104 = {
    $id: 'urn:wisepipe-common-data:ImportFilterOperand',
    type: 'object',
    properties: {
        operandType: { type: 'string', enum: ['column', 'literal'] },
        name: { type: 'string' },
        litType: { type: 'string', enum: ['string', 'number', 'date', 'boolean'] },
        value: { type: 'string' }
    },
    required: ['operandType'],
    if: { properties: { operandType: { const: 'column' } } },
    then: { required: ['name'] },
    else: { required: ['litType', 'value'] }
};
const wrapper0 = { validate: validate85 };
function validate85(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ImportFilter" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.filterType !== undefined) {
            if ('group' !== data.filterType) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    let ifClause0;
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.filters === undefined && (missing0 = 'filters')) {
                validate85.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
        ifClause0 = 'then';
    }
    else {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.lhs === undefined && (missing1 = 'lhs')) || (data.op === undefined && (missing1 = 'op'))) {
                validate85.errors = [
                    {
                        instancePath,
                        schemaPath: '#/else/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs5 === errors;
        valid0 = _valid0;
        ifClause0 = 'else';
    }
    if (!valid0) {
        const err1 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: ifClause0 },
            message: 'must match "' + ifClause0 + '" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate85.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if ((data.op === undefined && (missing2 = 'op')) ||
                (data.filterType === undefined && (missing2 = 'filterType'))) {
                validate85.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing2 },
                        message: "must have required property '" + missing2 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.op !== undefined) {
                    let data1 = data.op;
                    const _errs6 = errors;
                    if (typeof data1 !== 'string') {
                        validate85.errors = [
                            {
                                instancePath: instancePath + '/op',
                                schemaPath: '#/properties/op/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data1 === 'and' ||
                        data1 === 'or' ||
                        data1 === 'less_than' ||
                        data1 === 'less_than_equals' ||
                        data1 === 'equals' ||
                        data1 === 'not_equals' ||
                        data1 === 'greater_than_equals' ||
                        data1 === 'greater_than' ||
                        data1 === 'is_null' ||
                        data1 === 'is_not_null' ||
                        data1 === 'starts_with' ||
                        data1 === 'ends_with' ||
                        data1 === 'contains' ||
                        data1 === 'not_contains')) {
                        validate85.errors = [
                            {
                                instancePath: instancePath + '/op',
                                schemaPath: '#/properties/op/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema103.properties.op.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid2 = _errs6 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.filterType !== undefined) {
                        let data2 = data.filterType;
                        const _errs8 = errors;
                        if (typeof data2 !== 'string') {
                            validate85.errors = [
                                {
                                    instancePath: instancePath + '/filterType',
                                    schemaPath: '#/properties/filterType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data2 === 'statement' || data2 === 'group')) {
                            validate85.errors = [
                                {
                                    instancePath: instancePath + '/filterType',
                                    schemaPath: '#/properties/filterType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema103.properties.filterType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid2 = _errs8 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.filters !== undefined) {
                            let data3 = data.filters;
                            const _errs10 = errors;
                            if (errors === _errs10) {
                                if (Array.isArray(data3)) {
                                    var valid3 = true;
                                    const len0 = data3.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        const _errs12 = errors;
                                        if (!wrapper0.validate(data3[i0], {
                                            instancePath: instancePath + '/filters/' + i0,
                                            parentData: data3,
                                            parentDataProperty: i0,
                                            rootData
                                        })) {
                                            vErrors = vErrors === null ? wrapper0.validate.errors : vErrors.concat(wrapper0.validate.errors);
                                            errors = vErrors.length;
                                        }
                                        var valid3 = _errs12 === errors;
                                        if (!valid3) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate85.errors = [
                                        {
                                            instancePath: instancePath + '/filters',
                                            schemaPath: '#/properties/filters/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid2 = _errs10 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                        if (valid2) {
                            if (data.lhs !== undefined) {
                                let data5 = data.lhs;
                                const _errs13 = errors;
                                const _errs14 = errors;
                                const _errs16 = errors;
                                let valid5 = true;
                                const _errs17 = errors;
                                if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                    if (data5.operandType !== undefined) {
                                        if ('column' !== data5.operandType) {
                                            const err2 = {};
                                            if (vErrors === null) {
                                                vErrors = [err2];
                                            }
                                            else {
                                                vErrors.push(err2);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                                var _valid1 = _errs17 === errors;
                                errors = _errs16;
                                if (vErrors !== null) {
                                    if (_errs16) {
                                        vErrors.length = _errs16;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                                let ifClause1;
                                if (_valid1) {
                                    const _errs19 = errors;
                                    if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                        let missing3;
                                        if (data5.name === undefined && (missing3 = 'name')) {
                                            validate85.errors = [
                                                {
                                                    instancePath: instancePath + '/lhs',
                                                    schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/then/required',
                                                    keyword: 'required',
                                                    params: { missingProperty: missing3 },
                                                    message: "must have required property '" + missing3 + "'"
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var _valid1 = _errs19 === errors;
                                    valid5 = _valid1;
                                    ifClause1 = 'then';
                                }
                                else {
                                    const _errs20 = errors;
                                    if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                        let missing4;
                                        if ((data5.litType === undefined && (missing4 = 'litType')) ||
                                            (data5.value === undefined && (missing4 = 'value'))) {
                                            validate85.errors = [
                                                {
                                                    instancePath: instancePath + '/lhs',
                                                    schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/else/required',
                                                    keyword: 'required',
                                                    params: { missingProperty: missing4 },
                                                    message: "must have required property '" + missing4 + "'"
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var _valid1 = _errs20 === errors;
                                    valid5 = _valid1;
                                    ifClause1 = 'else';
                                }
                                if (!valid5) {
                                    const err3 = {
                                        instancePath: instancePath + '/lhs',
                                        schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/if',
                                        keyword: 'if',
                                        params: { failingKeyword: ifClause1 },
                                        message: 'must match "' + ifClause1 + '" schema'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err3];
                                    }
                                    else {
                                        vErrors.push(err3);
                                    }
                                    errors++;
                                    validate85.errors = vErrors;
                                    return false;
                                }
                                if (errors === _errs14) {
                                    if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                        let missing5;
                                        if (data5.operandType === undefined && (missing5 = 'operandType')) {
                                            validate85.errors = [
                                                {
                                                    instancePath: instancePath + '/lhs',
                                                    schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/required',
                                                    keyword: 'required',
                                                    params: { missingProperty: missing5 },
                                                    message: "must have required property '" + missing5 + "'"
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (data5.operandType !== undefined) {
                                                let data7 = data5.operandType;
                                                const _errs21 = errors;
                                                if (typeof data7 !== 'string') {
                                                    validate85.errors = [
                                                        {
                                                            instancePath: instancePath + '/lhs/operandType',
                                                            schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/properties/operandType/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                if (!(data7 === 'column' || data7 === 'literal')) {
                                                    validate85.errors = [
                                                        {
                                                            instancePath: instancePath + '/lhs/operandType',
                                                            schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/properties/operandType/enum',
                                                            keyword: 'enum',
                                                            params: { allowedValues: schema104.properties.operandType.enum },
                                                            message: 'must be equal to one of the allowed values'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid7 = _errs21 === errors;
                                            }
                                            else {
                                                var valid7 = true;
                                            }
                                            if (valid7) {
                                                if (data5.name !== undefined) {
                                                    const _errs23 = errors;
                                                    if (typeof data5.name !== 'string') {
                                                        validate85.errors = [
                                                            {
                                                                instancePath: instancePath + '/lhs/name',
                                                                schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/properties/name/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid7 = _errs23 === errors;
                                                }
                                                else {
                                                    var valid7 = true;
                                                }
                                                if (valid7) {
                                                    if (data5.litType !== undefined) {
                                                        let data9 = data5.litType;
                                                        const _errs25 = errors;
                                                        if (typeof data9 !== 'string') {
                                                            validate85.errors = [
                                                                {
                                                                    instancePath: instancePath + '/lhs/litType',
                                                                    schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/properties/litType/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        if (!(data9 === 'string' || data9 === 'number' || data9 === 'date' || data9 === 'boolean')) {
                                                            validate85.errors = [
                                                                {
                                                                    instancePath: instancePath + '/lhs/litType',
                                                                    schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/properties/litType/enum',
                                                                    keyword: 'enum',
                                                                    params: { allowedValues: schema104.properties.litType.enum },
                                                                    message: 'must be equal to one of the allowed values'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid7 = _errs25 === errors;
                                                    }
                                                    else {
                                                        var valid7 = true;
                                                    }
                                                    if (valid7) {
                                                        if (data5.value !== undefined) {
                                                            const _errs27 = errors;
                                                            if (typeof data5.value !== 'string') {
                                                                validate85.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/lhs/value',
                                                                        schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/properties/value/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid7 = _errs27 === errors;
                                                        }
                                                        else {
                                                            var valid7 = true;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate85.errors = [
                                            {
                                                instancePath: instancePath + '/lhs',
                                                schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid2 = _errs13 === errors;
                            }
                            else {
                                var valid2 = true;
                            }
                            if (valid2) {
                                if (data.rhs !== undefined) {
                                    let data11 = data.rhs;
                                    const _errs29 = errors;
                                    const _errs30 = errors;
                                    const _errs32 = errors;
                                    let valid9 = true;
                                    const _errs33 = errors;
                                    if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                        if (data11.operandType !== undefined) {
                                            if ('column' !== data11.operandType) {
                                                const err4 = {};
                                                if (vErrors === null) {
                                                    vErrors = [err4];
                                                }
                                                else {
                                                    vErrors.push(err4);
                                                }
                                                errors++;
                                            }
                                        }
                                    }
                                    var _valid2 = _errs33 === errors;
                                    errors = _errs32;
                                    if (vErrors !== null) {
                                        if (_errs32) {
                                            vErrors.length = _errs32;
                                        }
                                        else {
                                            vErrors = null;
                                        }
                                    }
                                    let ifClause2;
                                    if (_valid2) {
                                        const _errs35 = errors;
                                        if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                            let missing6;
                                            if (data11.name === undefined && (missing6 = 'name')) {
                                                validate85.errors = [
                                                    {
                                                        instancePath: instancePath + '/rhs',
                                                        schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/then/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing6 },
                                                        message: "must have required property '" + missing6 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var _valid2 = _errs35 === errors;
                                        valid9 = _valid2;
                                        ifClause2 = 'then';
                                    }
                                    else {
                                        const _errs36 = errors;
                                        if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                            let missing7;
                                            if ((data11.litType === undefined && (missing7 = 'litType')) ||
                                                (data11.value === undefined && (missing7 = 'value'))) {
                                                validate85.errors = [
                                                    {
                                                        instancePath: instancePath + '/rhs',
                                                        schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/else/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing7 },
                                                        message: "must have required property '" + missing7 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var _valid2 = _errs36 === errors;
                                        valid9 = _valid2;
                                        ifClause2 = 'else';
                                    }
                                    if (!valid9) {
                                        const err5 = {
                                            instancePath: instancePath + '/rhs',
                                            schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/if',
                                            keyword: 'if',
                                            params: { failingKeyword: ifClause2 },
                                            message: 'must match "' + ifClause2 + '" schema'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err5];
                                        }
                                        else {
                                            vErrors.push(err5);
                                        }
                                        errors++;
                                        validate85.errors = vErrors;
                                        return false;
                                    }
                                    if (errors === _errs30) {
                                        if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                            let missing8;
                                            if (data11.operandType === undefined && (missing8 = 'operandType')) {
                                                validate85.errors = [
                                                    {
                                                        instancePath: instancePath + '/rhs',
                                                        schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing8 },
                                                        message: "must have required property '" + missing8 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data11.operandType !== undefined) {
                                                    let data13 = data11.operandType;
                                                    const _errs37 = errors;
                                                    if (typeof data13 !== 'string') {
                                                        validate85.errors = [
                                                            {
                                                                instancePath: instancePath + '/rhs/operandType',
                                                                schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/properties/operandType/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    if (!(data13 === 'column' || data13 === 'literal')) {
                                                        validate85.errors = [
                                                            {
                                                                instancePath: instancePath + '/rhs/operandType',
                                                                schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/properties/operandType/enum',
                                                                keyword: 'enum',
                                                                params: { allowedValues: schema104.properties.operandType.enum },
                                                                message: 'must be equal to one of the allowed values'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid11 = _errs37 === errors;
                                                }
                                                else {
                                                    var valid11 = true;
                                                }
                                                if (valid11) {
                                                    if (data11.name !== undefined) {
                                                        const _errs39 = errors;
                                                        if (typeof data11.name !== 'string') {
                                                            validate85.errors = [
                                                                {
                                                                    instancePath: instancePath + '/rhs/name',
                                                                    schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/properties/name/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid11 = _errs39 === errors;
                                                    }
                                                    else {
                                                        var valid11 = true;
                                                    }
                                                    if (valid11) {
                                                        if (data11.litType !== undefined) {
                                                            let data15 = data11.litType;
                                                            const _errs41 = errors;
                                                            if (typeof data15 !== 'string') {
                                                                validate85.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/rhs/litType',
                                                                        schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/properties/litType/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            if (!(data15 === 'string' ||
                                                                data15 === 'number' ||
                                                                data15 === 'date' ||
                                                                data15 === 'boolean')) {
                                                                validate85.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/rhs/litType',
                                                                        schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/properties/litType/enum',
                                                                        keyword: 'enum',
                                                                        params: { allowedValues: schema104.properties.litType.enum },
                                                                        message: 'must be equal to one of the allowed values'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid11 = _errs41 === errors;
                                                        }
                                                        else {
                                                            var valid11 = true;
                                                        }
                                                        if (valid11) {
                                                            if (data11.value !== undefined) {
                                                                const _errs43 = errors;
                                                                if (typeof data11.value !== 'string') {
                                                                    validate85.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/rhs/value',
                                                                            schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/properties/value/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid11 = _errs43 === errors;
                                                            }
                                                            else {
                                                                var valid11 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate85.errors = [
                                                {
                                                    instancePath: instancePath + '/rhs',
                                                    schemaPath: 'urn:wisepipe-common-data:ImportFilterOperand/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs29 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate85.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate85.errors = vErrors;
    return errors === 0;
}
function validate84(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.importConfigType === undefined && (missing0 = 'importConfigType')) {
                validate84.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.importConfigType !== undefined) {
                    let data0 = data.importConfigType;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate84.errors = [
                            {
                                instancePath: instancePath + '/importConfigType',
                                schemaPath: '#/properties/importConfigType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 's3csv' ||
                        data0 === 'gsheets' ||
                        data0 === 'adwords' ||
                        data0 === 'googleAnalytics' ||
                        data0 === 'shopify' ||
                        data0 === 'mySql' ||
                        data0 === 'oracle' ||
                        data0 === 'postgreSql' ||
                        data0 === 'amazonAurora' ||
                        data0 === 'amazonRedshift' ||
                        data0 === 'amazonS3' ||
                        data0 === 'icm' ||
                        data0 === 'salesForce' ||
                        data0 === 'parquet' ||
                        data0 === 'excel' ||
                        data0 === 'global' ||
                        data0 === 'hubspot' ||
                        data0 === 'symon' ||
                        data0 === 'dynamics' ||
                        data0 === 's3parquet' ||
                        data0 === 'snowflake' ||
                        data0 === 'msSql' ||
                        data0 === 'agentSync' ||
                        data0 === 'workday' ||
                        data0 === 'workdayRaaS' ||
                        data0 === 'tqp' ||
                        data0 === 'tableau' ||
                        data0 === 'sftp' ||
                        data0 === 'powerbi' ||
                        data0 === 'rest' ||
                        data0 === 'gong' ||
                        data0 === 'fwf' ||
                        data0 === 'netSuite' ||
                        data0 === 'oneDrive' ||
                        data0 === 'eltApi' ||
                        data0 === 'microsoftSqlServer' ||
                        data0 === 'stripe' ||
                        data0 === 'microsoftDynamics365' ||
                        data0 === 'github' ||
                        data0 === 'facebookAds' ||
                        data0 === 'amplitude' ||
                        data0 === 'appsFlyer' ||
                        data0 === 'customerIo' ||
                        data0 === 'freshDesk' ||
                        data0 === 'fullstory' ||
                        data0 === 'googleCloud' ||
                        data0 === 'googleEcommerce' ||
                        data0 === 'listrak' ||
                        data0 === 'livePerson' ||
                        data0 === 'onFleet' ||
                        data0 === 'saasquatch' ||
                        data0 === 'selligent' ||
                        data0 === 'userVoice' ||
                        data0 === 'vero' ||
                        data0 === 'adRoll' ||
                        data0 === 'afterShip' ||
                        data0 === 'asana' ||
                        data0 === 'autopilot' ||
                        data0 === 'azure' ||
                        data0 === 'bigCommerce' ||
                        data0 === 'bingAds' ||
                        data0 === 'brainTree' ||
                        data0 === 'bronto' ||
                        data0 === 'campaignManager' ||
                        data0 === 'campaignMonitor' ||
                        data0 === 'chargeBee' ||
                        data0 === 'closeIo' ||
                        data0 === 'clubspeed' ||
                        data0 === 'codat' ||
                        data0 === 'contentful' ||
                        data0 === 'delighted' ||
                        data0 === 'drip' ||
                        data0 === 'eloqua' ||
                        data0 === 'formkeep' ||
                        data0 === 'front' ||
                        data0 === 'ftp' ||
                        data0 === 'gitlab' ||
                        data0 === 'harvest' ||
                        data0 === 'heap' ||
                        data0 === 'helpScout' ||
                        data0 === 'heroku' ||
                        data0 === 'ibmDb2' ||
                        data0 === 'invoiced' ||
                        data0 === 'iterable' ||
                        data0 === 'klaviyo' ||
                        data0 === 'magento' ||
                        data0 === 'mailjet' ||
                        data0 === 'mariaDb' ||
                        data0 === 'mixpanel' ||
                        data0 === 'mongoDb' ||
                        data0 === 'outbrain' ||
                        data0 === 'particle' ||
                        data0 === 'purple' ||
                        data0 === 'quickBase' ||
                        data0 === 'recurly' ||
                        data0 === 'responsys' ||
                        data0 === 'revinate' ||
                        data0 === 'salesforceDesk' ||
                        data0 === 'salesforcePardot' ||
                        data0 === 'segment' ||
                        data0 === 'sendGrid' ||
                        data0 === 'sendWithUs' ||
                        data0 === 'shipHero' ||
                        data0 === 'shippo' ||
                        data0 === 'sparkPost' ||
                        data0 === 'square' ||
                        data0 === 'taboola' ||
                        data0 === 'toggl' ||
                        data0 === 'trello' ||
                        data0 === 'typeform' ||
                        data0 === 'urbanAirship' ||
                        data0 === 'webhooks' ||
                        data0 === 'yotpo' ||
                        data0 === 'zapier' ||
                        data0 === 'zendeskChat' ||
                        data0 === 'zendeskSupport' ||
                        data0 === 'googleBigQuery' ||
                        data0 === 'intercom' ||
                        data0 === 'sapSuccessFactors' ||
                        data0 === 'sapCrm' ||
                        data0 === 'ukg' ||
                        data0 === 'oracleHcm' ||
                        data0 === 'Adp' ||
                        data0 === 'dynamics365Sales' ||
                        data0 === 'ceridianDayforce' ||
                        data0 === 'oracleCrm' ||
                        data0 === 'oracleErpCloud' ||
                        data0 === 'sageIntacct' ||
                        data0 === 'bambooHr' ||
                        data0 === 'sapErp' ||
                        data0 === 'googleCloudPlatformCloudStorage' ||
                        data0 === 'sas' ||
                        data0 === 'dropbox' ||
                        data0 === 'googleDrive' ||
                        data0 === 'jira' ||
                        data0 === 'monday' ||
                        data0 === 'zuora' ||
                        data0 === 'adobeAnalytics' ||
                        data0 === 'zoomInfo' ||
                        data0 === 'marketo' ||
                        data0 === 'activeCampaign' ||
                        data0 === 'mailchimp' ||
                        data0 === 'infor' ||
                        data0 === 'cornerstoneOnDemand' ||
                        data0 === 'gusto' ||
                        data0 === 'paychexFlex' ||
                        data0 === 'zendesk' ||
                        data0 === 'serviceNow' ||
                        data0 === 'zohoCrm' ||
                        data0 === 'pipedrive' ||
                        data0 === 'quickBooks' ||
                        data0 === 'xero' ||
                        data0 === 'freshbooks' ||
                        data0 === 'zohoBooks' ||
                        data0 === 'waveFinancial')) {
                        validate84.errors = [
                            {
                                instancePath: instancePath + '/importConfigType',
                                schemaPath: '#/properties/importConfigType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema101.properties.importConfigType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.columnsToUpdate !== undefined) {
                        let data1 = data.columnsToUpdate;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                for (const key0 in data1) {
                                    let data2 = data1[key0];
                                    const _errs6 = errors;
                                    if (errors === _errs6) {
                                        if (Array.isArray(data2)) {
                                            var valid2 = true;
                                            const len0 = data2.length;
                                            for (let i0 = 0; i0 < len0; i0++) {
                                                let data3 = data2[i0];
                                                const _errs8 = errors;
                                                const _errs9 = errors;
                                                const _errs11 = errors;
                                                let valid4 = true;
                                                const _errs12 = errors;
                                                if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                                                    if (data3.columnUpdateType !== undefined) {
                                                        if ('modify' !== data3.columnUpdateType) {
                                                            const err0 = {};
                                                            if (vErrors === null) {
                                                                vErrors = [err0];
                                                            }
                                                            else {
                                                                vErrors.push(err0);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                }
                                                var _valid0 = _errs12 === errors;
                                                errors = _errs11;
                                                if (vErrors !== null) {
                                                    if (_errs11) {
                                                        vErrors.length = _errs11;
                                                    }
                                                    else {
                                                        vErrors = null;
                                                    }
                                                }
                                                if (_valid0) {
                                                    const _errs14 = errors;
                                                    const _errs15 = errors;
                                                    let valid6 = true;
                                                    const _errs16 = errors;
                                                    if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                                                        let missing1;
                                                        if (data3.targetType === undefined && (missing1 = 'targetType')) {
                                                            const err1 = {};
                                                            if (vErrors === null) {
                                                                vErrors = [err1];
                                                            }
                                                            else {
                                                                vErrors.push(err1);
                                                            }
                                                            errors++;
                                                        }
                                                        else {
                                                            if (data3.targetType !== undefined) {
                                                                if ('date' !== data3.targetType) {
                                                                    const err2 = {};
                                                                    if (vErrors === null) {
                                                                        vErrors = [err2];
                                                                    }
                                                                    else {
                                                                        vErrors.push(err2);
                                                                    }
                                                                    errors++;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    var _valid1 = _errs16 === errors;
                                                    errors = _errs15;
                                                    if (vErrors !== null) {
                                                        if (_errs15) {
                                                            vErrors.length = _errs15;
                                                        }
                                                        else {
                                                            vErrors = null;
                                                        }
                                                    }
                                                    if (_valid1) {
                                                        const _errs18 = errors;
                                                        if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                                                            let missing2;
                                                            if (data3.dateFormat === undefined && (missing2 = 'dateFormat')) {
                                                                validate84.errors = [
                                                                    {
                                                                        instancePath: instancePath +
                                                                            '/columnsToUpdate/' +
                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                            '/' +
                                                                            i0,
                                                                        schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/then/then/required',
                                                                        keyword: 'required',
                                                                        params: { missingProperty: missing2 },
                                                                        message: "must have required property '" + missing2 + "'"
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var _valid1 = _errs18 === errors;
                                                        valid6 = _valid1;
                                                    }
                                                    if (!valid6) {
                                                        const err3 = {
                                                            instancePath: instancePath +
                                                                '/columnsToUpdate/' +
                                                                key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                '/' +
                                                                i0,
                                                            schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/then/if',
                                                            keyword: 'if',
                                                            params: { failingKeyword: 'then' },
                                                            message: 'must match "then" schema'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err3];
                                                        }
                                                        else {
                                                            vErrors.push(err3);
                                                        }
                                                        errors++;
                                                        validate84.errors = vErrors;
                                                        return false;
                                                    }
                                                    if (errors === _errs14) {
                                                        if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                                                            let missing3;
                                                            if ((data3.type === undefined && (missing3 = 'type')) ||
                                                                (data3.targetType === undefined && (missing3 = 'targetType'))) {
                                                                validate84.errors = [
                                                                    {
                                                                        instancePath: instancePath +
                                                                            '/columnsToUpdate/' +
                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                            '/' +
                                                                            i0,
                                                                        schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/then/required',
                                                                        keyword: 'required',
                                                                        params: { missingProperty: missing3 },
                                                                        message: "must have required property '" + missing3 + "'"
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                    }
                                                    var _valid0 = _errs14 === errors;
                                                    valid4 = _valid0;
                                                }
                                                if (!valid4) {
                                                    const err4 = {
                                                        instancePath: instancePath +
                                                            '/columnsToUpdate/' +
                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                            '/' +
                                                            i0,
                                                        schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/if',
                                                        keyword: 'if',
                                                        params: { failingKeyword: 'then' },
                                                        message: 'must match "then" schema'
                                                    };
                                                    if (vErrors === null) {
                                                        vErrors = [err4];
                                                    }
                                                    else {
                                                        vErrors.push(err4);
                                                    }
                                                    errors++;
                                                    validate84.errors = vErrors;
                                                    return false;
                                                }
                                                if (errors === _errs9) {
                                                    if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                                                        let missing4;
                                                        if ((data3.column === undefined && (missing4 = 'column')) ||
                                                            (data3.columnUpdateType === undefined && (missing4 = 'columnUpdateType'))) {
                                                            validate84.errors = [
                                                                {
                                                                    instancePath: instancePath +
                                                                        '/columnsToUpdate/' +
                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                        '/' +
                                                                        i0,
                                                                    schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/required',
                                                                    keyword: 'required',
                                                                    params: { missingProperty: missing4 },
                                                                    message: "must have required property '" + missing4 + "'"
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            if (data3.column !== undefined) {
                                                                const _errs19 = errors;
                                                                if (typeof data3.column !== 'string') {
                                                                    validate84.errors = [
                                                                        {
                                                                            instancePath: instancePath +
                                                                                '/columnsToUpdate/' +
                                                                                key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                '/' +
                                                                                i0 +
                                                                                '/column',
                                                                            schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/properties/column/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid8 = _errs19 === errors;
                                                            }
                                                            else {
                                                                var valid8 = true;
                                                            }
                                                            if (valid8) {
                                                                if (data3.columnUpdateType !== undefined) {
                                                                    let data7 = data3.columnUpdateType;
                                                                    const _errs21 = errors;
                                                                    if (typeof data7 !== 'string') {
                                                                        validate84.errors = [
                                                                            {
                                                                                instancePath: instancePath +
                                                                                    '/columnsToUpdate/' +
                                                                                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                    '/' +
                                                                                    i0 +
                                                                                    '/columnUpdateType',
                                                                                schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/properties/columnUpdateType/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    if (!(data7 === 'drop' || data7 === 'mask' || data7 === 'modify')) {
                                                                        validate84.errors = [
                                                                            {
                                                                                instancePath: instancePath +
                                                                                    '/columnsToUpdate/' +
                                                                                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                    '/' +
                                                                                    i0 +
                                                                                    '/columnUpdateType',
                                                                                schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/properties/columnUpdateType/enum',
                                                                                keyword: 'enum',
                                                                                params: { allowedValues: schema66.properties.columnUpdateType.enum },
                                                                                message: 'must be equal to one of the allowed values'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid8 = _errs21 === errors;
                                                                }
                                                                else {
                                                                    var valid8 = true;
                                                                }
                                                                if (valid8) {
                                                                    if (data3.type !== undefined) {
                                                                        let data8 = data3.type;
                                                                        const _errs23 = errors;
                                                                        if (typeof data8 !== 'string') {
                                                                            validate84.errors = [
                                                                                {
                                                                                    instancePath: instancePath +
                                                                                        '/columnsToUpdate/' +
                                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                        '/' +
                                                                                        i0 +
                                                                                        '/type',
                                                                                    schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/properties/type/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        if (!(data8 === 'number' ||
                                                                            data8 === 'string' ||
                                                                            data8 === 'boolean' ||
                                                                            data8 === 'date' ||
                                                                            data8 === 'decimal')) {
                                                                            validate84.errors = [
                                                                                {
                                                                                    instancePath: instancePath +
                                                                                        '/columnsToUpdate/' +
                                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                        '/' +
                                                                                        i0 +
                                                                                        '/type',
                                                                                    schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/properties/type/enum',
                                                                                    keyword: 'enum',
                                                                                    params: { allowedValues: schema66.properties.type.enum },
                                                                                    message: 'must be equal to one of the allowed values'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        var valid8 = _errs23 === errors;
                                                                    }
                                                                    else {
                                                                        var valid8 = true;
                                                                    }
                                                                    if (valid8) {
                                                                        if (data3.targetType !== undefined) {
                                                                            let data9 = data3.targetType;
                                                                            const _errs25 = errors;
                                                                            if (typeof data9 !== 'string') {
                                                                                validate84.errors = [
                                                                                    {
                                                                                        instancePath: instancePath +
                                                                                            '/columnsToUpdate/' +
                                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                            '/' +
                                                                                            i0 +
                                                                                            '/targetType',
                                                                                        schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/properties/targetType/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            if (!(data9 === 'number' ||
                                                                                data9 === 'string' ||
                                                                                data9 === 'boolean' ||
                                                                                data9 === 'date' ||
                                                                                data9 === 'decimal')) {
                                                                                validate84.errors = [
                                                                                    {
                                                                                        instancePath: instancePath +
                                                                                            '/columnsToUpdate/' +
                                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                            '/' +
                                                                                            i0 +
                                                                                            '/targetType',
                                                                                        schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/properties/targetType/enum',
                                                                                        keyword: 'enum',
                                                                                        params: { allowedValues: schema66.properties.targetType.enum },
                                                                                        message: 'must be equal to one of the allowed values'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            var valid8 = _errs25 === errors;
                                                                        }
                                                                        else {
                                                                            var valid8 = true;
                                                                        }
                                                                        if (valid8) {
                                                                            if (data3.dateFormat !== undefined) {
                                                                                let data10 = data3.dateFormat;
                                                                                const _errs27 = errors;
                                                                                if (errors === _errs27) {
                                                                                    if (typeof data10 === 'string') {
                                                                                        if (func2(data10) < 1) {
                                                                                            validate84.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath +
                                                                                                        '/columnsToUpdate/' +
                                                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                        '/' +
                                                                                                        i0 +
                                                                                                        '/dateFormat',
                                                                                                    schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/properties/dateFormat/minLength',
                                                                                                    keyword: 'minLength',
                                                                                                    params: { limit: 1 },
                                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate84.errors = [
                                                                                            {
                                                                                                instancePath: instancePath +
                                                                                                    '/columnsToUpdate/' +
                                                                                                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                    '/' +
                                                                                                    i0 +
                                                                                                    '/dateFormat',
                                                                                                schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/properties/dateFormat/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid8 = _errs27 === errors;
                                                                            }
                                                                            else {
                                                                                var valid8 = true;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate84.errors = [
                                                            {
                                                                instancePath: instancePath +
                                                                    '/columnsToUpdate/' +
                                                                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                    '/' +
                                                                    i0,
                                                                schemaPath: 'urn:wisepipe-common-data:ColumnUpdate/type',
                                                                keyword: 'type',
                                                                params: { type: 'object' },
                                                                message: 'must be object'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid2 = _errs8 === errors;
                                                if (!valid2) {
                                                    break;
                                                }
                                            }
                                            if (valid2) {
                                                let i1 = data2.length;
                                                let j0;
                                                if (i1 > 1) {
                                                    outer0: for (; i1--;) {
                                                        for (j0 = i1; j0--;) {
                                                            if (func0(data2[i1], data2[j0])) {
                                                                validate84.errors = [
                                                                    {
                                                                        instancePath: instancePath +
                                                                            '/columnsToUpdate/' +
                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                        schemaPath: '#/properties/columnsToUpdate/additionalProperties/uniqueItems',
                                                                        keyword: 'uniqueItems',
                                                                        params: { i: i1, j: j0 },
                                                                        message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                                    }
                                                                ];
                                                                return false;
                                                                break outer0;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate84.errors = [
                                                {
                                                    instancePath: instancePath + '/columnsToUpdate/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                    schemaPath: '#/properties/columnsToUpdate/additionalProperties/type',
                                                    keyword: 'type',
                                                    params: { type: 'array' },
                                                    message: 'must be array'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs6 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate84.errors = [
                                    {
                                        instancePath: instancePath + '/columnsToUpdate',
                                        schemaPath: '#/properties/columnsToUpdate/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.columnsToDrop !== undefined) {
                            let data11 = data.columnsToDrop;
                            const _errs29 = errors;
                            if (errors === _errs29) {
                                if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                    for (const key1 in data11) {
                                        let data12 = data11[key1];
                                        const _errs32 = errors;
                                        if (errors === _errs32) {
                                            if (Array.isArray(data12)) {
                                                var valid11 = true;
                                                const len1 = data12.length;
                                                for (let i2 = 0; i2 < len1; i2++) {
                                                    const _errs34 = errors;
                                                    if (typeof data12[i2] !== 'string') {
                                                        validate84.errors = [
                                                            {
                                                                instancePath: instancePath +
                                                                    '/columnsToDrop/' +
                                                                    key1.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                    '/' +
                                                                    i2,
                                                                schemaPath: '#/properties/columnsToDrop/additionalProperties/items/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid11 = _errs34 === errors;
                                                    if (!valid11) {
                                                        break;
                                                    }
                                                }
                                                if (valid11) {
                                                    let i3 = data12.length;
                                                    let j1;
                                                    if (i3 > 1) {
                                                        const indices0 = {};
                                                        for (; i3--;) {
                                                            let item0 = data12[i3];
                                                            if (typeof item0 !== 'string') {
                                                                continue;
                                                            }
                                                            if (typeof indices0[item0] == 'number') {
                                                                j1 = indices0[item0];
                                                                validate84.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/columnsToDrop/' + key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                        schemaPath: '#/properties/columnsToDrop/additionalProperties/uniqueItems',
                                                                        keyword: 'uniqueItems',
                                                                        params: { i: i3, j: j1 },
                                                                        message: 'must NOT have duplicate items (items ## ' + j1 + ' and ' + i3 + ' are identical)'
                                                                    }
                                                                ];
                                                                return false;
                                                                break;
                                                            }
                                                            indices0[item0] = i3;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate84.errors = [
                                                    {
                                                        instancePath: instancePath + '/columnsToDrop/' + key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                        schemaPath: '#/properties/columnsToDrop/additionalProperties/type',
                                                        keyword: 'type',
                                                        params: { type: 'array' },
                                                        message: 'must be array'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid10 = _errs32 === errors;
                                        if (!valid10) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate84.errors = [
                                        {
                                            instancePath: instancePath + '/columnsToDrop',
                                            schemaPath: '#/properties/columnsToDrop/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs29 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.columnsToMask !== undefined) {
                                let data14 = data.columnsToMask;
                                const _errs36 = errors;
                                if (errors === _errs36) {
                                    if (data14 && typeof data14 == 'object' && !Array.isArray(data14)) {
                                        for (const key2 in data14) {
                                            let data15 = data14[key2];
                                            const _errs39 = errors;
                                            if (errors === _errs39) {
                                                if (Array.isArray(data15)) {
                                                    var valid14 = true;
                                                    const len2 = data15.length;
                                                    for (let i4 = 0; i4 < len2; i4++) {
                                                        const _errs41 = errors;
                                                        if (typeof data15[i4] !== 'string') {
                                                            validate84.errors = [
                                                                {
                                                                    instancePath: instancePath +
                                                                        '/columnsToMask/' +
                                                                        key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                        '/' +
                                                                        i4,
                                                                    schemaPath: '#/properties/columnsToMask/additionalProperties/items/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid14 = _errs41 === errors;
                                                        if (!valid14) {
                                                            break;
                                                        }
                                                    }
                                                    if (valid14) {
                                                        let i5 = data15.length;
                                                        let j2;
                                                        if (i5 > 1) {
                                                            const indices1 = {};
                                                            for (; i5--;) {
                                                                let item1 = data15[i5];
                                                                if (typeof item1 !== 'string') {
                                                                    continue;
                                                                }
                                                                if (typeof indices1[item1] == 'number') {
                                                                    j2 = indices1[item1];
                                                                    validate84.errors = [
                                                                        {
                                                                            instancePath: instancePath +
                                                                                '/columnsToMask/' +
                                                                                key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                            schemaPath: '#/properties/columnsToMask/additionalProperties/uniqueItems',
                                                                            keyword: 'uniqueItems',
                                                                            params: { i: i5, j: j2 },
                                                                            message: 'must NOT have duplicate items (items ## ' +
                                                                                j2 +
                                                                                ' and ' +
                                                                                i5 +
                                                                                ' are identical)'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                    break;
                                                                }
                                                                indices1[item1] = i5;
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate84.errors = [
                                                        {
                                                            instancePath: instancePath + '/columnsToMask/' + key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                            schemaPath: '#/properties/columnsToMask/additionalProperties/type',
                                                            keyword: 'type',
                                                            params: { type: 'array' },
                                                            message: 'must be array'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid13 = _errs39 === errors;
                                            if (!valid13) {
                                                break;
                                            }
                                        }
                                    }
                                    else {
                                        validate84.errors = [
                                            {
                                                instancePath: instancePath + '/columnsToMask',
                                                schemaPath: '#/properties/columnsToMask/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs36 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.filters !== undefined) {
                                    let data17 = data.filters;
                                    const _errs43 = errors;
                                    if (errors === _errs43) {
                                        if (data17 && typeof data17 == 'object' && !Array.isArray(data17)) {
                                            for (const key3 in data17) {
                                                const _errs46 = errors;
                                                if (!validate85(data17[key3], {
                                                    instancePath: instancePath + '/filters/' + key3.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                    parentData: data17,
                                                    parentDataProperty: key3,
                                                    rootData
                                                })) {
                                                    vErrors = vErrors === null ? validate85.errors : vErrors.concat(validate85.errors);
                                                    errors = vErrors.length;
                                                }
                                                var valid16 = _errs46 === errors;
                                                if (!valid16) {
                                                    break;
                                                }
                                            }
                                        }
                                        else {
                                            validate84.errors = [
                                                {
                                                    instancePath: instancePath + '/filters',
                                                    schemaPath: '#/properties/filters/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs43 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.dataCategory !== undefined) {
                                        let data19 = data.dataCategory;
                                        const _errs47 = errors;
                                        if (typeof data19 !== 'string') {
                                            validate84.errors = [
                                                {
                                                    instancePath: instancePath + '/dataCategory',
                                                    schemaPath: '#/properties/dataCategory/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (!(data19 === 'dataSource' || data19 === 'unitTestDataSource' || data19 === 'unitTestSnapshot')) {
                                            validate84.errors = [
                                                {
                                                    instancePath: instancePath + '/dataCategory',
                                                    schemaPath: '#/properties/dataCategory/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema101.properties.dataCategory.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs47 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate84.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate84.errors = vErrors;
    return errors === 0;
}
export const importFilterOperandSchemaValidation = validate87;
function validate87(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:ImportFilterOperand" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.operandType !== undefined) {
            if ('column' !== data.operandType) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    let ifClause0;
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.name === undefined && (missing0 = 'name')) {
                validate87.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
        ifClause0 = 'then';
    }
    else {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.litType === undefined && (missing1 = 'litType')) ||
                (data.value === undefined && (missing1 = 'value'))) {
                validate87.errors = [
                    {
                        instancePath,
                        schemaPath: '#/else/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs5 === errors;
        valid0 = _valid0;
        ifClause0 = 'else';
    }
    if (!valid0) {
        const err1 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: ifClause0 },
            message: 'must match "' + ifClause0 + '" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate87.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if (data.operandType === undefined && (missing2 = 'operandType')) {
                validate87.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing2 },
                        message: "must have required property '" + missing2 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.operandType !== undefined) {
                    let data1 = data.operandType;
                    const _errs6 = errors;
                    if (typeof data1 !== 'string') {
                        validate87.errors = [
                            {
                                instancePath: instancePath + '/operandType',
                                schemaPath: '#/properties/operandType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data1 === 'column' || data1 === 'literal')) {
                        validate87.errors = [
                            {
                                instancePath: instancePath + '/operandType',
                                schemaPath: '#/properties/operandType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema104.properties.operandType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid2 = _errs6 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.name !== undefined) {
                        const _errs8 = errors;
                        if (typeof data.name !== 'string') {
                            validate87.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid2 = _errs8 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.litType !== undefined) {
                            let data3 = data.litType;
                            const _errs10 = errors;
                            if (typeof data3 !== 'string') {
                                validate87.errors = [
                                    {
                                        instancePath: instancePath + '/litType',
                                        schemaPath: '#/properties/litType/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data3 === 'string' || data3 === 'number' || data3 === 'date' || data3 === 'boolean')) {
                                validate87.errors = [
                                    {
                                        instancePath: instancePath + '/litType',
                                        schemaPath: '#/properties/litType/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema104.properties.litType.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid2 = _errs10 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                        if (valid2) {
                            if (data.value !== undefined) {
                                const _errs12 = errors;
                                if (typeof data.value !== 'string') {
                                    validate87.errors = [
                                        {
                                            instancePath: instancePath + '/value',
                                            schemaPath: '#/properties/value/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid2 = _errs12 === errors;
                            }
                            else {
                                var valid2 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate87.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate87.errors = vErrors;
    return errors === 0;
}
export const importFilterSchemaValidation = validate85;
export const incentivesCalendarSchemaValidation = validate88;
const schema107 = {
    $id: 'urn:wisepipe-common-data:IncentivesCalendar',
    type: 'object',
    properties: {
        calendarID: { type: 'string', minLength: 1 },
        timeLevels: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-data:IncentivesTimeLevel' },
            uniqueItemProperties: ['order', 'level']
        },
        periods: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-data:IncentivesPeriod' },
            uniqueItemProperties: ['name']
        },
        lastModified: { type: 'string', format: 'date-time' },
        lastLockedPeriod: { type: 'string', minLength: 1 }
    },
    required: ['calendarID', 'timeLevels', 'periods', 'lastModified']
};
const schema108 = {
    $id: 'urn:wisepipe-common-data:IncentivesTimeLevel',
    type: 'object',
    properties: { order: { type: 'number', minimum: 0 }, level: { type: 'string', minLength: 1 } },
    required: ['order', 'level']
};
const schema109 = {
    $id: 'urn:wisepipe-common-data:IncentivesPeriod',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1 },
        level: { type: 'string', minLength: 1 },
        parentPeriod: { type: 'string', minLength: 1 },
        start: { type: 'string', format: 'date' },
        end: { type: 'string', format: 'date' }
    },
    required: ['name', 'level', 'start', 'end']
};
const func162 = ajvEqual;
const func166 = ajvEqual;
const formats34 = formatWrapper.date;
function validate88(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:IncentivesCalendar" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.calendarID === undefined && (missing0 = 'calendarID')) ||
                (data.timeLevels === undefined && (missing0 = 'timeLevels')) ||
                (data.periods === undefined && (missing0 = 'periods')) ||
                (data.lastModified === undefined && (missing0 = 'lastModified'))) {
                validate88.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.calendarID !== undefined) {
                    let data0 = data.calendarID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate88.errors = [
                                    {
                                        instancePath: instancePath + '/calendarID',
                                        schemaPath: '#/properties/calendarID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate88.errors = [
                                {
                                    instancePath: instancePath + '/calendarID',
                                    schemaPath: '#/properties/calendarID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.timeLevels !== undefined) {
                        let data1 = data.timeLevels;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                var valid1 = true;
                                const len0 = data1.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data2 = data1[i0];
                                    const _errs5 = errors;
                                    const _errs6 = errors;
                                    if (errors === _errs6) {
                                        if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                            let missing1;
                                            if ((data2.order === undefined && (missing1 = 'order')) ||
                                                (data2.level === undefined && (missing1 = 'level'))) {
                                                validate88.errors = [
                                                    {
                                                        instancePath: instancePath + '/timeLevels/' + i0,
                                                        schemaPath: 'urn:wisepipe-common-data:IncentivesTimeLevel/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing1 },
                                                        message: "must have required property '" + missing1 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data2.order !== undefined) {
                                                    let data3 = data2.order;
                                                    const _errs8 = errors;
                                                    if (errors === _errs8) {
                                                        if (typeof data3 == 'number') {
                                                            if (data3 < 0 || isNaN(data3)) {
                                                                validate88.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/timeLevels/' + i0 + '/order',
                                                                        schemaPath: 'urn:wisepipe-common-data:IncentivesTimeLevel/properties/order/minimum',
                                                                        keyword: 'minimum',
                                                                        params: { comparison: '>=', limit: 0 },
                                                                        message: 'must be >= 0'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate88.errors = [
                                                                {
                                                                    instancePath: instancePath + '/timeLevels/' + i0 + '/order',
                                                                    schemaPath: 'urn:wisepipe-common-data:IncentivesTimeLevel/properties/order/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'number' },
                                                                    message: 'must be number'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid3 = _errs8 === errors;
                                                }
                                                else {
                                                    var valid3 = true;
                                                }
                                                if (valid3) {
                                                    if (data2.level !== undefined) {
                                                        let data4 = data2.level;
                                                        const _errs10 = errors;
                                                        if (errors === _errs10) {
                                                            if (typeof data4 === 'string') {
                                                                if (func2(data4) < 1) {
                                                                    validate88.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/timeLevels/' + i0 + '/level',
                                                                            schemaPath: 'urn:wisepipe-common-data:IncentivesTimeLevel/properties/level/minLength',
                                                                            keyword: 'minLength',
                                                                            params: { limit: 1 },
                                                                            message: 'must NOT have fewer than 1 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate88.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/timeLevels/' + i0 + '/level',
                                                                        schemaPath: 'urn:wisepipe-common-data:IncentivesTimeLevel/properties/level/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid3 = _errs10 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate88.errors = [
                                                {
                                                    instancePath: instancePath + '/timeLevels/' + i0,
                                                    schemaPath: 'urn:wisepipe-common-data:IncentivesTimeLevel/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs5 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    const keys0 = schema107.properties.timeLevels.uniqueItemProperties;
                                    let k0;
                                    let i1 = data1.length;
                                    let j0;
                                    if (i1 > 1) {
                                        outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                            let key0 = keys0[k0];
                                            for (i1 = data1.length; i1--;) {
                                                let x0 = data1[i1];
                                                if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                    continue;
                                                }
                                                for (j0 = i1; j0--;) {
                                                    let y0 = data1[j0];
                                                    if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func162(x0[key0], y0[key0])) {
                                                        validate88.errors = [
                                                            {
                                                                instancePath: instancePath + '/timeLevels',
                                                                schemaPath: '#/properties/timeLevels/uniqueItemProperties',
                                                                keyword: 'uniqueItemProperties',
                                                                params: {},
                                                                message: 'must pass "uniqueItemProperties" keyword validation'
                                                            }
                                                        ];
                                                        return false;
                                                        break outer0;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate88.errors = [
                                    {
                                        instancePath: instancePath + '/timeLevels',
                                        schemaPath: '#/properties/timeLevels/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.periods !== undefined) {
                            let data5 = data.periods;
                            const _errs12 = errors;
                            if (errors === _errs12) {
                                if (Array.isArray(data5)) {
                                    var valid5 = true;
                                    const len1 = data5.length;
                                    for (let i2 = 0; i2 < len1; i2++) {
                                        let data6 = data5[i2];
                                        const _errs14 = errors;
                                        const _errs15 = errors;
                                        if (errors === _errs15) {
                                            if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                                let missing2;
                                                if ((data6.name === undefined && (missing2 = 'name')) ||
                                                    (data6.level === undefined && (missing2 = 'level')) ||
                                                    (data6.start === undefined && (missing2 = 'start')) ||
                                                    (data6.end === undefined && (missing2 = 'end'))) {
                                                    validate88.errors = [
                                                        {
                                                            instancePath: instancePath + '/periods/' + i2,
                                                            schemaPath: 'urn:wisepipe-common-data:IncentivesPeriod/required',
                                                            keyword: 'required',
                                                            params: { missingProperty: missing2 },
                                                            message: "must have required property '" + missing2 + "'"
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (data6.name !== undefined) {
                                                        let data7 = data6.name;
                                                        const _errs17 = errors;
                                                        if (errors === _errs17) {
                                                            if (typeof data7 === 'string') {
                                                                if (func2(data7) < 1) {
                                                                    validate88.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/periods/' + i2 + '/name',
                                                                            schemaPath: 'urn:wisepipe-common-data:IncentivesPeriod/properties/name/minLength',
                                                                            keyword: 'minLength',
                                                                            params: { limit: 1 },
                                                                            message: 'must NOT have fewer than 1 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate88.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/periods/' + i2 + '/name',
                                                                        schemaPath: 'urn:wisepipe-common-data:IncentivesPeriod/properties/name/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid7 = _errs17 === errors;
                                                    }
                                                    else {
                                                        var valid7 = true;
                                                    }
                                                    if (valid7) {
                                                        if (data6.level !== undefined) {
                                                            let data8 = data6.level;
                                                            const _errs19 = errors;
                                                            if (errors === _errs19) {
                                                                if (typeof data8 === 'string') {
                                                                    if (func2(data8) < 1) {
                                                                        validate88.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/periods/' + i2 + '/level',
                                                                                schemaPath: 'urn:wisepipe-common-data:IncentivesPeriod/properties/level/minLength',
                                                                                keyword: 'minLength',
                                                                                params: { limit: 1 },
                                                                                message: 'must NOT have fewer than 1 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate88.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/periods/' + i2 + '/level',
                                                                            schemaPath: 'urn:wisepipe-common-data:IncentivesPeriod/properties/level/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid7 = _errs19 === errors;
                                                        }
                                                        else {
                                                            var valid7 = true;
                                                        }
                                                        if (valid7) {
                                                            if (data6.parentPeriod !== undefined) {
                                                                let data9 = data6.parentPeriod;
                                                                const _errs21 = errors;
                                                                if (errors === _errs21) {
                                                                    if (typeof data9 === 'string') {
                                                                        if (func2(data9) < 1) {
                                                                            validate88.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/periods/' + i2 + '/parentPeriod',
                                                                                    schemaPath: 'urn:wisepipe-common-data:IncentivesPeriod/properties/parentPeriod/minLength',
                                                                                    keyword: 'minLength',
                                                                                    params: { limit: 1 },
                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate88.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/periods/' + i2 + '/parentPeriod',
                                                                                schemaPath: 'urn:wisepipe-common-data:IncentivesPeriod/properties/parentPeriod/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid7 = _errs21 === errors;
                                                            }
                                                            else {
                                                                var valid7 = true;
                                                            }
                                                            if (valid7) {
                                                                if (data6.start !== undefined) {
                                                                    let data10 = data6.start;
                                                                    const _errs23 = errors;
                                                                    if (errors === _errs23) {
                                                                        if (errors === _errs23) {
                                                                            if (typeof data10 === 'string') {
                                                                                if (!formats34.validate(data10)) {
                                                                                    validate88.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/periods/' + i2 + '/start',
                                                                                            schemaPath: 'urn:wisepipe-common-data:IncentivesPeriod/properties/start/format',
                                                                                            keyword: 'format',
                                                                                            params: { format: 'date' },
                                                                                            message: 'must match format "' + 'date' + '"'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate88.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/periods/' + i2 + '/start',
                                                                                        schemaPath: 'urn:wisepipe-common-data:IncentivesPeriod/properties/start/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                    }
                                                                    var valid7 = _errs23 === errors;
                                                                }
                                                                else {
                                                                    var valid7 = true;
                                                                }
                                                                if (valid7) {
                                                                    if (data6.end !== undefined) {
                                                                        let data11 = data6.end;
                                                                        const _errs25 = errors;
                                                                        if (errors === _errs25) {
                                                                            if (errors === _errs25) {
                                                                                if (typeof data11 === 'string') {
                                                                                    if (!formats34.validate(data11)) {
                                                                                        validate88.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/periods/' + i2 + '/end',
                                                                                                schemaPath: 'urn:wisepipe-common-data:IncentivesPeriod/properties/end/format',
                                                                                                keyword: 'format',
                                                                                                params: { format: 'date' },
                                                                                                message: 'must match format "' + 'date' + '"'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate88.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/periods/' + i2 + '/end',
                                                                                            schemaPath: 'urn:wisepipe-common-data:IncentivesPeriod/properties/end/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                        }
                                                                        var valid7 = _errs25 === errors;
                                                                    }
                                                                    else {
                                                                        var valid7 = true;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate88.errors = [
                                                    {
                                                        instancePath: instancePath + '/periods/' + i2,
                                                        schemaPath: 'urn:wisepipe-common-data:IncentivesPeriod/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid5 = _errs14 === errors;
                                        if (!valid5) {
                                            break;
                                        }
                                    }
                                    if (valid5) {
                                        const keys1 = schema107.properties.periods.uniqueItemProperties;
                                        let k1;
                                        let i3 = data5.length;
                                        let j1;
                                        if (i3 > 1) {
                                            outer1: for (k1 = 0; k1 < keys1.length; k1++) {
                                                let key1 = keys1[k1];
                                                for (i3 = data5.length; i3--;) {
                                                    let x1 = data5[i3];
                                                    if (!(x1 && typeof x1 == 'object' && !Array.isArray(x1))) {
                                                        continue;
                                                    }
                                                    for (j1 = i3; j1--;) {
                                                        let y1 = data5[j1];
                                                        if (y1 && typeof y1 == 'object' && !Array.isArray(y1) && func166(x1[key1], y1[key1])) {
                                                            validate88.errors = [
                                                                {
                                                                    instancePath: instancePath + '/periods',
                                                                    schemaPath: '#/properties/periods/uniqueItemProperties',
                                                                    keyword: 'uniqueItemProperties',
                                                                    params: {},
                                                                    message: 'must pass "uniqueItemProperties" keyword validation'
                                                                }
                                                            ];
                                                            return false;
                                                            break outer1;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate88.errors = [
                                        {
                                            instancePath: instancePath + '/periods',
                                            schemaPath: '#/properties/periods/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs12 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.lastModified !== undefined) {
                                let data12 = data.lastModified;
                                const _errs27 = errors;
                                if (errors === _errs27) {
                                    if (errors === _errs27) {
                                        if (typeof data12 === 'string') {
                                            if (!formats0.validate(data12)) {
                                                validate88.errors = [
                                                    {
                                                        instancePath: instancePath + '/lastModified',
                                                        schemaPath: '#/properties/lastModified/format',
                                                        keyword: 'format',
                                                        params: { format: 'date-time' },
                                                        message: 'must match format "' + 'date-time' + '"'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate88.errors = [
                                                {
                                                    instancePath: instancePath + '/lastModified',
                                                    schemaPath: '#/properties/lastModified/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid0 = _errs27 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.lastLockedPeriod !== undefined) {
                                    let data13 = data.lastLockedPeriod;
                                    const _errs29 = errors;
                                    if (errors === _errs29) {
                                        if (typeof data13 === 'string') {
                                            if (func2(data13) < 1) {
                                                validate88.errors = [
                                                    {
                                                        instancePath: instancePath + '/lastLockedPeriod',
                                                        schemaPath: '#/properties/lastLockedPeriod/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate88.errors = [
                                                {
                                                    instancePath: instancePath + '/lastLockedPeriod',
                                                    schemaPath: '#/properties/lastLockedPeriod/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs29 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate88.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate88.errors = vErrors;
    return errors === 0;
}
export const incentivesComposerCalcConfigSchemaValidation = validate26;
export const incentivesComposerS3ConfigSchemaValidation = validate27;
export const incentivesDataProcessingTaskSchemaValidation = validate89;
const schema110 = {
    $id: 'urn:wisepipe-common-computation:IncentivesDataProcessingTask',
    type: 'object',
    properties: {
        taskID: { type: 'string', minLength: 1 },
        orgID: { type: 'string', format: 'uuid' },
        orgPlan: { type: 'string', enum: ['Social', 'Enterprise', 'Integration', 'Temp', 'Starter', 'Professional'] },
        dataSourceID: { type: 'string', pattern: '^([_\\p{L}][_\\p{L}0-9]*)$' },
        primaryKeys: { type: 'array', items: { type: 'string' } },
        incentivesComposerCalcConfig: { $ref: 'urn:wisepipe-common-computation:IncentivesComposerCalcConfig' },
        externalID: { type: 'string', minLength: 1 }
    },
    required: ['taskID', 'orgID', 'orgPlan', 'dataSourceID', 'primaryKeys', 'incentivesComposerCalcConfig', 'externalID']
};
const pattern3 = new RegExp('^([_\\p{L}][_\\p{L}0-9]*)$', 'u');
function validate89(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:IncentivesDataProcessingTask" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.taskID === undefined && (missing0 = 'taskID')) ||
                (data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.orgPlan === undefined && (missing0 = 'orgPlan')) ||
                (data.dataSourceID === undefined && (missing0 = 'dataSourceID')) ||
                (data.primaryKeys === undefined && (missing0 = 'primaryKeys')) ||
                (data.incentivesComposerCalcConfig === undefined && (missing0 = 'incentivesComposerCalcConfig')) ||
                (data.externalID === undefined && (missing0 = 'externalID'))) {
                validate89.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.taskID !== undefined) {
                    let data0 = data.taskID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate89.errors = [
                                    {
                                        instancePath: instancePath + '/taskID',
                                        schemaPath: '#/properties/taskID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate89.errors = [
                                {
                                    instancePath: instancePath + '/taskID',
                                    schemaPath: '#/properties/taskID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.orgID !== undefined) {
                        let data1 = data.orgID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats6.test(data1)) {
                                        validate89.errors = [
                                            {
                                                instancePath: instancePath + '/orgID',
                                                schemaPath: '#/properties/orgID/format',
                                                keyword: 'format',
                                                params: { format: 'uuid' },
                                                message: 'must match format "' + 'uuid' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate89.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.orgPlan !== undefined) {
                            let data2 = data.orgPlan;
                            const _errs5 = errors;
                            if (typeof data2 !== 'string') {
                                validate89.errors = [
                                    {
                                        instancePath: instancePath + '/orgPlan',
                                        schemaPath: '#/properties/orgPlan/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data2 === 'Social' ||
                                data2 === 'Enterprise' ||
                                data2 === 'Integration' ||
                                data2 === 'Temp' ||
                                data2 === 'Starter' ||
                                data2 === 'Professional')) {
                                validate89.errors = [
                                    {
                                        instancePath: instancePath + '/orgPlan',
                                        schemaPath: '#/properties/orgPlan/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema110.properties.orgPlan.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.dataSourceID !== undefined) {
                                let data3 = data.dataSourceID;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        if (!pattern3.test(data3)) {
                                            validate89.errors = [
                                                {
                                                    instancePath: instancePath + '/dataSourceID',
                                                    schemaPath: '#/properties/dataSourceID/pattern',
                                                    keyword: 'pattern',
                                                    params: { pattern: '^([_\\p{L}][_\\p{L}0-9]*)$' },
                                                    message: 'must match pattern "' + '^([_\\p{L}][_\\p{L}0-9]*)$' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate89.errors = [
                                            {
                                                instancePath: instancePath + '/dataSourceID',
                                                schemaPath: '#/properties/dataSourceID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.primaryKeys !== undefined) {
                                    let data4 = data.primaryKeys;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (Array.isArray(data4)) {
                                            var valid1 = true;
                                            const len0 = data4.length;
                                            for (let i0 = 0; i0 < len0; i0++) {
                                                const _errs11 = errors;
                                                if (typeof data4[i0] !== 'string') {
                                                    validate89.errors = [
                                                        {
                                                            instancePath: instancePath + '/primaryKeys/' + i0,
                                                            schemaPath: '#/properties/primaryKeys/items/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid1 = _errs11 === errors;
                                                if (!valid1) {
                                                    break;
                                                }
                                            }
                                        }
                                        else {
                                            validate89.errors = [
                                                {
                                                    instancePath: instancePath + '/primaryKeys',
                                                    schemaPath: '#/properties/primaryKeys/type',
                                                    keyword: 'type',
                                                    params: { type: 'array' },
                                                    message: 'must be array'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.incentivesComposerCalcConfig !== undefined) {
                                        const _errs13 = errors;
                                        if (!validate26(data.incentivesComposerCalcConfig, {
                                            instancePath: instancePath + '/incentivesComposerCalcConfig',
                                            parentData: data,
                                            parentDataProperty: 'incentivesComposerCalcConfig',
                                            rootData
                                        })) {
                                            vErrors = vErrors === null ? validate26.errors : vErrors.concat(validate26.errors);
                                            errors = vErrors.length;
                                        }
                                        var valid0 = _errs13 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.externalID !== undefined) {
                                            let data7 = data.externalID;
                                            const _errs14 = errors;
                                            if (errors === _errs14) {
                                                if (typeof data7 === 'string') {
                                                    if (func2(data7) < 1) {
                                                        validate89.errors = [
                                                            {
                                                                instancePath: instancePath + '/externalID',
                                                                schemaPath: '#/properties/externalID/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate89.errors = [
                                                        {
                                                            instancePath: instancePath + '/externalID',
                                                            schemaPath: '#/properties/externalID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs14 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate89.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate89.errors = vErrors;
    return errors === 0;
}
export const incentivesPeriodSchemaValidation = validate91;
function validate91(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:IncentivesPeriod" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.name === undefined && (missing0 = 'name')) ||
                (data.level === undefined && (missing0 = 'level')) ||
                (data.start === undefined && (missing0 = 'start')) ||
                (data.end === undefined && (missing0 = 'end'))) {
                validate91.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data0 = data.name;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate91.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate91.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.level !== undefined) {
                        let data1 = data.level;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate91.errors = [
                                        {
                                            instancePath: instancePath + '/level',
                                            schemaPath: '#/properties/level/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate91.errors = [
                                    {
                                        instancePath: instancePath + '/level',
                                        schemaPath: '#/properties/level/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.parentPeriod !== undefined) {
                            let data2 = data.parentPeriod;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate91.errors = [
                                            {
                                                instancePath: instancePath + '/parentPeriod',
                                                schemaPath: '#/properties/parentPeriod/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate91.errors = [
                                        {
                                            instancePath: instancePath + '/parentPeriod',
                                            schemaPath: '#/properties/parentPeriod/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.start !== undefined) {
                                let data3 = data.start;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (errors === _errs7) {
                                        if (typeof data3 === 'string') {
                                            if (!formats34.validate(data3)) {
                                                validate91.errors = [
                                                    {
                                                        instancePath: instancePath + '/start',
                                                        schemaPath: '#/properties/start/format',
                                                        keyword: 'format',
                                                        params: { format: 'date' },
                                                        message: 'must match format "' + 'date' + '"'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate91.errors = [
                                                {
                                                    instancePath: instancePath + '/start',
                                                    schemaPath: '#/properties/start/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.end !== undefined) {
                                    let data4 = data.end;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (errors === _errs9) {
                                            if (typeof data4 === 'string') {
                                                if (!formats34.validate(data4)) {
                                                    validate91.errors = [
                                                        {
                                                            instancePath: instancePath + '/end',
                                                            schemaPath: '#/properties/end/format',
                                                            keyword: 'format',
                                                            params: { format: 'date' },
                                                            message: 'must match format "' + 'date' + '"'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate91.errors = [
                                                    {
                                                        instancePath: instancePath + '/end',
                                                        schemaPath: '#/properties/end/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate91.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate91.errors = vErrors;
    return errors === 0;
}
export const incentivesTimeLevelSchemaValidation = validate92;
function validate92(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:IncentivesTimeLevel" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.order === undefined && (missing0 = 'order')) || (data.level === undefined && (missing0 = 'level'))) {
                validate92.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.order !== undefined) {
                    let data0 = data.order;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 == 'number') {
                            if (data0 < 0 || isNaN(data0)) {
                                validate92.errors = [
                                    {
                                        instancePath: instancePath + '/order',
                                        schemaPath: '#/properties/order/minimum',
                                        keyword: 'minimum',
                                        params: { comparison: '>=', limit: 0 },
                                        message: 'must be >= 0'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate92.errors = [
                                {
                                    instancePath: instancePath + '/order',
                                    schemaPath: '#/properties/order/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.level !== undefined) {
                        let data1 = data.level;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate92.errors = [
                                        {
                                            instancePath: instancePath + '/level',
                                            schemaPath: '#/properties/level/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate92.errors = [
                                    {
                                        instancePath: instancePath + '/level',
                                        schemaPath: '#/properties/level/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate92.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate92.errors = vErrors;
    return errors === 0;
}
export const inferenceRequestSchemaValidation = validate93;
const schema113 = {
    $id: 'urn:wisepipe-common-computation:InferenceRequest',
    type: 'object',
    properties: {
        pipeID: { type: 'string', uid: 10 },
        dataMap: { type: 'object', additionalProperties: { $ref: 'urn:wisepipe-common-computation:NodeDataMap' } },
        outputName: { type: ['string', 'null'], if: { type: 'string' }, then: { minLength: 1 } },
        elementID: { type: ['string', 'null'], if: { type: 'string' }, then: { uid: 10 } },
        port: { type: 'string', minLength: 1 },
        explain: { type: 'boolean' },
        runResult: { type: 'boolean' }
    },
    required: ['pipeID', 'dataMap', 'port', 'explain'],
    oneOf: [{ properties: { outputName: { type: 'null' } } }, { properties: { elementID: { type: 'null' } } }]
};
const func174 = ucs2length;
const func175 = base64urlToBuffer;
const func176 = base64urlEncode;
const func177 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func179 = ucs2length;
const func180 = base64urlToBuffer;
const func181 = base64urlEncode;
const func182 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const schema114 = {
    $id: 'urn:wisepipe-common-computation:NodeDataMap',
    type: 'object',
    properties: {
        dataMap: { type: 'object', additionalProperties: { $ref: 'urn:wisepipe-common-computation:PortData' } }
    },
    required: ['dataMap']
};
const schema115 = {
    $id: 'urn:wisepipe-common-computation:PortData',
    type: 'object',
    properties: {
        columns: { type: 'array', items: { $ref: 'urn:wisepipe-common-data:Column' } },
        values: {
            type: 'array',
            items: {
                type: 'array',
                items: { type: ['boolean', 'string', 'number', 'null'] },
                minItems: { $data: '2/columns/length' },
                maxItems: { $data: '2/columns/length' }
            }
        }
    },
    required: ['columns', 'values']
};
function validate95(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:PortData" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.columns === undefined && (missing0 = 'columns')) ||
                (data.values === undefined && (missing0 = 'values'))) {
                validate95.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data0 = data.columns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                const _errs3 = errors;
                                if (!validate45(data0[i0], {
                                    instancePath: instancePath + '/columns/' + i0,
                                    parentData: data0,
                                    parentDataProperty: i0,
                                    rootData
                                })) {
                                    vErrors = vErrors === null ? validate45.errors : vErrors.concat(validate45.errors);
                                    errors = vErrors.length;
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                        }
                        else {
                            validate95.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.values !== undefined) {
                        let data2 = data.values;
                        const _errs4 = errors;
                        if (errors === _errs4) {
                            if (Array.isArray(data2)) {
                                var valid2 = true;
                                const len1 = data2.length;
                                for (let i1 = 0; i1 < len1; i1++) {
                                    let data3 = data2[i1];
                                    const _errs6 = errors;
                                    if (errors === _errs6) {
                                        if (Array.isArray(data3)) {
                                            const vSchema0 = data && data.columns && data.columns.length;
                                            if (vSchema0 !== undefined && (!(typeof vSchema0 == 'number') || data3.length > vSchema0)) {
                                                validate95.errors = [
                                                    {
                                                        instancePath: instancePath + '/values/' + i1,
                                                        schemaPath: '#/properties/values/items/maxItems',
                                                        keyword: 'maxItems',
                                                        params: { limit: vSchema0 },
                                                        message: 'must NOT have more than ' + vSchema0 + ' items'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const vSchema1 = data && data.columns && data.columns.length;
                                                if (vSchema1 !== undefined && (!(typeof vSchema1 == 'number') || data3.length < vSchema1)) {
                                                    validate95.errors = [
                                                        {
                                                            instancePath: instancePath + '/values/' + i1,
                                                            schemaPath: '#/properties/values/items/minItems',
                                                            keyword: 'minItems',
                                                            params: { limit: vSchema1 },
                                                            message: 'must NOT have fewer than ' + vSchema1 + ' items'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    var valid3 = true;
                                                    const len2 = data3.length;
                                                    for (let i2 = 0; i2 < len2; i2++) {
                                                        let data4 = data3[i2];
                                                        const _errs8 = errors;
                                                        if (typeof data4 !== 'boolean' &&
                                                            typeof data4 !== 'string' &&
                                                            !(typeof data4 == 'number') &&
                                                            data4 !== null) {
                                                            validate95.errors = [
                                                                {
                                                                    instancePath: instancePath + '/values/' + i1 + '/' + i2,
                                                                    schemaPath: '#/properties/values/items/items/type',
                                                                    keyword: 'type',
                                                                    params: { type: schema115.properties.values.items.items.type },
                                                                    message: 'must be boolean,string,number,null'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid3 = _errs8 === errors;
                                                        if (!valid3) {
                                                            break;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate95.errors = [
                                                {
                                                    instancePath: instancePath + '/values/' + i1,
                                                    schemaPath: '#/properties/values/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'array' },
                                                    message: 'must be array'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs6 === errors;
                                    if (!valid2) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate95.errors = [
                                    {
                                        instancePath: instancePath + '/values',
                                        schemaPath: '#/properties/values/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs4 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate95.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate95.errors = vErrors;
    return errors === 0;
}
function validate94(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:NodeDataMap" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.dataMap === undefined && (missing0 = 'dataMap')) {
                validate94.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.dataMap !== undefined) {
                    let data0 = data.dataMap;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            for (const key0 in data0) {
                                const _errs4 = errors;
                                if (!validate95(data0[key0], {
                                    instancePath: instancePath + '/dataMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                    parentData: data0,
                                    parentDataProperty: key0,
                                    rootData
                                })) {
                                    vErrors = vErrors === null ? validate95.errors : vErrors.concat(validate95.errors);
                                    errors = vErrors.length;
                                }
                                var valid1 = _errs4 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                        }
                        else {
                            validate94.errors = [
                                {
                                    instancePath: instancePath + '/dataMap',
                                    schemaPath: '#/properties/dataMap/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate94.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate94.errors = vErrors;
    return errors === 0;
}
function validate93(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:InferenceRequest" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.outputName !== undefined) {
            if (data.outputName !== null) {
                const err0 = {
                    instancePath: instancePath + '/outputName',
                    schemaPath: '#/oneOf/0/properties/outputName/type',
                    keyword: 'type',
                    params: { type: 'null' },
                    message: 'must be null'
                };
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    const _errs5 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.elementID !== undefined) {
            if (data.elementID !== null) {
                const err1 = {
                    instancePath: instancePath + '/elementID',
                    schemaPath: '#/oneOf/1/properties/elementID/type',
                    keyword: 'type',
                    params: { type: 'null' },
                    message: 'must be null'
                };
                if (vErrors === null) {
                    vErrors = [err1];
                }
                else {
                    vErrors.push(err1);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs5 === errors;
    if (_valid0 && valid0) {
        valid0 = false;
        passing0 = [passing0, 1];
    }
    else {
        if (_valid0) {
            valid0 = true;
            passing0 = 1;
        }
    }
    if (!valid0) {
        const err2 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf'
        };
        if (vErrors === null) {
            vErrors = [err2];
        }
        else {
            vErrors.push(err2);
        }
        errors++;
        validate93.errors = vErrors;
        return false;
    }
    else {
        errors = _errs1;
        if (vErrors !== null) {
            if (_errs1) {
                vErrors.length = _errs1;
            }
            else {
                vErrors = null;
            }
        }
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.pipeID === undefined && (missing0 = 'pipeID')) ||
                (data.dataMap === undefined && (missing0 = 'dataMap')) ||
                (data.port === undefined && (missing0 = 'port')) ||
                (data.explain === undefined && (missing0 = 'explain'))) {
                validate93.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pipeID !== undefined) {
                    let data2 = data.pipeID;
                    const _errs8 = errors;
                    if (errors === _errs8) {
                        if (typeof data2 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func174(data2) < b64min0 || func174(data2) > b64max0) {
                                validate93.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func174(data2) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func174(data2)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func175(data2);
                                if (decoded0.length !== 10) {
                                    validate93.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func176(decoded0);
                                    if (func177(encoded0) !== func177(data2)) {
                                        validate93.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate93.errors = [
                                {
                                    instancePath: instancePath + '/pipeID',
                                    schemaPath: '#/properties/pipeID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid3 = _errs8 === errors;
                }
                else {
                    var valid3 = true;
                }
                if (valid3) {
                    if (data.dataMap !== undefined) {
                        let data3 = data.dataMap;
                        const _errs10 = errors;
                        if (errors === _errs10) {
                            if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                                for (const key0 in data3) {
                                    const _errs13 = errors;
                                    if (!validate94(data3[key0], {
                                        instancePath: instancePath + '/dataMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                        parentData: data3,
                                        parentDataProperty: key0,
                                        rootData
                                    })) {
                                        vErrors = vErrors === null ? validate94.errors : vErrors.concat(validate94.errors);
                                        errors = vErrors.length;
                                    }
                                    var valid5 = _errs13 === errors;
                                    if (!valid5) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate93.errors = [
                                    {
                                        instancePath: instancePath + '/dataMap',
                                        schemaPath: '#/properties/dataMap/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid3 = _errs10 === errors;
                    }
                    else {
                        var valid3 = true;
                    }
                    if (valid3) {
                        if (data.outputName !== undefined) {
                            let data5 = data.outputName;
                            const _errs14 = errors;
                            if (typeof data5 !== 'string' && data5 !== null) {
                                validate93.errors = [
                                    {
                                        instancePath: instancePath + '/outputName',
                                        schemaPath: '#/properties/outputName/type',
                                        keyword: 'type',
                                        params: { type: schema113.properties.outputName.type },
                                        message: 'must be string,null'
                                    }
                                ];
                                return false;
                            }
                            const _errs16 = errors;
                            let valid6 = true;
                            const _errs17 = errors;
                            if (typeof data5 !== 'string') {
                                const err3 = {};
                                if (vErrors === null) {
                                    vErrors = [err3];
                                }
                                else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                            var _valid1 = _errs17 === errors;
                            errors = _errs16;
                            if (vErrors !== null) {
                                if (_errs16) {
                                    vErrors.length = _errs16;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                            if (_valid1) {
                                const _errs19 = errors;
                                if (typeof data5 === 'string') {
                                    if (func2(data5) < 1) {
                                        validate93.errors = [
                                            {
                                                instancePath: instancePath + '/outputName',
                                                schemaPath: '#/properties/outputName/then/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var _valid1 = _errs19 === errors;
                                valid6 = _valid1;
                            }
                            if (!valid6) {
                                const err4 = {
                                    instancePath: instancePath + '/outputName',
                                    schemaPath: '#/properties/outputName/if',
                                    keyword: 'if',
                                    params: { failingKeyword: 'then' },
                                    message: 'must match "then" schema'
                                };
                                if (vErrors === null) {
                                    vErrors = [err4];
                                }
                                else {
                                    vErrors.push(err4);
                                }
                                errors++;
                                validate93.errors = vErrors;
                                return false;
                            }
                            var valid3 = _errs14 === errors;
                        }
                        else {
                            var valid3 = true;
                        }
                        if (valid3) {
                            if (data.elementID !== undefined) {
                                let data6 = data.elementID;
                                const _errs20 = errors;
                                if (typeof data6 !== 'string' && data6 !== null) {
                                    validate93.errors = [
                                        {
                                            instancePath: instancePath + '/elementID',
                                            schemaPath: '#/properties/elementID/type',
                                            keyword: 'type',
                                            params: { type: schema113.properties.elementID.type },
                                            message: 'must be string,null'
                                        }
                                    ];
                                    return false;
                                }
                                const _errs22 = errors;
                                let valid7 = true;
                                const _errs23 = errors;
                                if (typeof data6 !== 'string') {
                                    const err5 = {};
                                    if (vErrors === null) {
                                        vErrors = [err5];
                                    }
                                    else {
                                        vErrors.push(err5);
                                    }
                                    errors++;
                                }
                                var _valid2 = _errs23 === errors;
                                errors = _errs22;
                                if (vErrors !== null) {
                                    if (_errs22) {
                                        vErrors.length = _errs22;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                                if (_valid2) {
                                    const _errs25 = errors;
                                    if (typeof data6 === 'string') {
                                        const b64min1 = Math.ceil((4 * 10) / 3);
                                        const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                        if (func179(data6) < b64min1 || func179(data6) > b64max1) {
                                            validate93.errors = [
                                                {
                                                    instancePath: instancePath + '/elementID',
                                                    schemaPath: '#/properties/elementID/then/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func179(data6) },
                                                    message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func179(data6)
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const decoded1 = func180(data6);
                                            if (decoded1.length !== 10) {
                                                validate93.errors = [
                                                    {
                                                        instancePath: instancePath + '/elementID',
                                                        schemaPath: '#/properties/elementID/then/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'decoded' },
                                                        message: 'must decode to 10 bytes'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const encoded1 = func181(decoded1);
                                                if (func182(encoded1) !== func182(data6)) {
                                                    validate93.errors = [
                                                        {
                                                            instancePath: instancePath + '/elementID',
                                                            schemaPath: '#/properties/elementID/then/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'ambiguous' },
                                                            message: 'encoding is ambiguous'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                    }
                                    var _valid2 = _errs25 === errors;
                                    valid7 = _valid2;
                                }
                                if (!valid7) {
                                    const err6 = {
                                        instancePath: instancePath + '/elementID',
                                        schemaPath: '#/properties/elementID/if',
                                        keyword: 'if',
                                        params: { failingKeyword: 'then' },
                                        message: 'must match "then" schema'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err6];
                                    }
                                    else {
                                        vErrors.push(err6);
                                    }
                                    errors++;
                                    validate93.errors = vErrors;
                                    return false;
                                }
                                var valid3 = _errs20 === errors;
                            }
                            else {
                                var valid3 = true;
                            }
                            if (valid3) {
                                if (data.port !== undefined) {
                                    let data7 = data.port;
                                    const _errs26 = errors;
                                    if (errors === _errs26) {
                                        if (typeof data7 === 'string') {
                                            if (func2(data7) < 1) {
                                                validate93.errors = [
                                                    {
                                                        instancePath: instancePath + '/port',
                                                        schemaPath: '#/properties/port/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate93.errors = [
                                                {
                                                    instancePath: instancePath + '/port',
                                                    schemaPath: '#/properties/port/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid3 = _errs26 === errors;
                                }
                                else {
                                    var valid3 = true;
                                }
                                if (valid3) {
                                    if (data.explain !== undefined) {
                                        const _errs28 = errors;
                                        if (typeof data.explain !== 'boolean') {
                                            validate93.errors = [
                                                {
                                                    instancePath: instancePath + '/explain',
                                                    schemaPath: '#/properties/explain/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid3 = _errs28 === errors;
                                    }
                                    else {
                                        var valid3 = true;
                                    }
                                    if (valid3) {
                                        if (data.runResult !== undefined) {
                                            const _errs30 = errors;
                                            if (typeof data.runResult !== 'boolean') {
                                                validate93.errors = [
                                                    {
                                                        instancePath: instancePath + '/runResult',
                                                        schemaPath: '#/properties/runResult/type',
                                                        keyword: 'type',
                                                        params: { type: 'boolean' },
                                                        message: 'must be boolean'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid3 = _errs30 === errors;
                                        }
                                        else {
                                            var valid3 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate93.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate93.errors = vErrors;
    return errors === 0;
}
export const insSchemaInfoSchemaValidation = validate99;
const schema116 = {
    $id: 'urn:wisepipe-common-computation:InsSchemaInfo',
    type: 'object',
    properties: {
        dataSourceName: { type: 'string' },
        dataSourceID: { type: 'string', uid: 9 },
        elementID: { type: 'string', uid: 10 },
        columnInfo: { type: 'array', items: { $ref: 'urn:wisepipe-common-computation:ColumnInfo' } }
    },
    required: ['dataSourceName', 'dataSourceID', 'elementID', 'columnInfo']
};
const func184 = ucs2length;
const func185 = base64urlToBuffer;
const func186 = base64urlEncode;
const func187 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func188 = ucs2length;
const func189 = base64urlToBuffer;
const func190 = base64urlEncode;
const func191 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate99(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:InsSchemaInfo" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.dataSourceName === undefined && (missing0 = 'dataSourceName')) ||
                (data.dataSourceID === undefined && (missing0 = 'dataSourceID')) ||
                (data.elementID === undefined && (missing0 = 'elementID')) ||
                (data.columnInfo === undefined && (missing0 = 'columnInfo'))) {
                validate99.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.dataSourceName !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.dataSourceName !== 'string') {
                        validate99.errors = [
                            {
                                instancePath: instancePath + '/dataSourceName',
                                schemaPath: '#/properties/dataSourceName/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.dataSourceID !== undefined) {
                        let data1 = data.dataSourceID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                const b64min0 = Math.ceil((4 * 9) / 3);
                                const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                if (func184(data1) < b64min0 || func184(data1) > b64max0) {
                                    validate99.errors = [
                                        {
                                            instancePath: instancePath + '/dataSourceID',
                                            schemaPath: '#/properties/dataSourceID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func184(data1) },
                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func184(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded0 = func185(data1);
                                    if (decoded0.length !== 9) {
                                        validate99.errors = [
                                            {
                                                instancePath: instancePath + '/dataSourceID',
                                                schemaPath: '#/properties/dataSourceID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 9 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded0 = func186(decoded0);
                                        if (func187(encoded0) !== func187(data1)) {
                                            validate99.errors = [
                                                {
                                                    instancePath: instancePath + '/dataSourceID',
                                                    schemaPath: '#/properties/dataSourceID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate99.errors = [
                                    {
                                        instancePath: instancePath + '/dataSourceID',
                                        schemaPath: '#/properties/dataSourceID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.elementID !== undefined) {
                            let data2 = data.elementID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    const b64min1 = Math.ceil((4 * 10) / 3);
                                    const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                    if (func188(data2) < b64min1 || func188(data2) > b64max1) {
                                        validate99.errors = [
                                            {
                                                instancePath: instancePath + '/elementID',
                                                schemaPath: '#/properties/elementID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func188(data2) },
                                                message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func188(data2)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded1 = func189(data2);
                                        if (decoded1.length !== 10) {
                                            validate99.errors = [
                                                {
                                                    instancePath: instancePath + '/elementID',
                                                    schemaPath: '#/properties/elementID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 10 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded1 = func190(decoded1);
                                            if (func191(encoded1) !== func191(data2)) {
                                                validate99.errors = [
                                                    {
                                                        instancePath: instancePath + '/elementID',
                                                        schemaPath: '#/properties/elementID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate99.errors = [
                                        {
                                            instancePath: instancePath + '/elementID',
                                            schemaPath: '#/properties/elementID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.columnInfo !== undefined) {
                                let data3 = data.columnInfo;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (Array.isArray(data3)) {
                                        var valid3 = true;
                                        const len0 = data3.length;
                                        for (let i0 = 0; i0 < len0; i0++) {
                                            const _errs9 = errors;
                                            if (!validate44(data3[i0], {
                                                instancePath: instancePath + '/columnInfo/' + i0,
                                                parentData: data3,
                                                parentDataProperty: i0,
                                                rootData
                                            })) {
                                                vErrors = vErrors === null ? validate44.errors : vErrors.concat(validate44.errors);
                                                errors = vErrors.length;
                                            }
                                            var valid3 = _errs9 === errors;
                                            if (!valid3) {
                                                break;
                                            }
                                        }
                                    }
                                    else {
                                        validate99.errors = [
                                            {
                                                instancePath: instancePath + '/columnInfo',
                                                schemaPath: '#/properties/columnInfo/type',
                                                keyword: 'type',
                                                params: { type: 'array' },
                                                message: 'must be array'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate99.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate99.errors = vErrors;
    return errors === 0;
}
export const integrationActiveCalcEventSchemaValidation = validate101;
const schema117 = {
    $id: 'urn:wisepipe-common-computation:IntegrationActiveCalcEvent',
    type: 'object',
    properties: {
        orgID: { type: 'string', minLength: 1, maxLength: 128 },
        pipeID: { type: 'string', uid: 10 },
        externalID: { type: 'string', minLength: 1 },
        status: { type: 'string', enum: ['running', 'failed', 'cancelled', 'completed'] },
        calcInitType: { type: 'string', enum: ['withDependees', 'withoutDependees', 'calcAll'] },
        taskID: { type: 'string', minLength: 1 },
        rootTaskID: { type: 'string' },
        error: { type: 'object' },
        start: { type: 'string', format: 'date-time' },
        end: { type: 'string', format: 'date-time' },
        processingStartTime: { type: 'string', format: 'date-time' },
        nodeCalcStatusSummary: {
            type: 'object',
            additionalProperties: { type: 'string', enum: ['successful', 'failed', 'skipped', 'unprocessed'] }
        }
    },
    required: ['orgID', 'pipeID', 'status', 'start', 'taskID']
};
const func194 = ucs2length;
const func195 = base64urlToBuffer;
const func196 = base64urlEncode;
const func197 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate101(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:IntegrationActiveCalcEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.pipeID === undefined && (missing0 = 'pipeID')) ||
                (data.status === undefined && (missing0 = 'status')) ||
                (data.start === undefined && (missing0 = 'start')) ||
                (data.taskID === undefined && (missing0 = 'taskID'))) {
                validate101.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 128) {
                                validate101.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 128 },
                                        message: 'must NOT have more than 128 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate101.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate101.errors = [
                                {
                                    instancePath: instancePath + '/orgID',
                                    schemaPath: '#/properties/orgID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.pipeID !== undefined) {
                        let data1 = data.pipeID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                const b64min0 = Math.ceil((4 * 10) / 3);
                                const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                                if (func194(data1) < b64min0 || func194(data1) > b64max0) {
                                    validate101.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func194(data1) },
                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func194(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded0 = func195(data1);
                                    if (decoded0.length !== 10) {
                                        validate101.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 10 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded0 = func196(decoded0);
                                        if (func197(encoded0) !== func197(data1)) {
                                            validate101.errors = [
                                                {
                                                    instancePath: instancePath + '/pipeID',
                                                    schemaPath: '#/properties/pipeID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate101.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.externalID !== undefined) {
                            let data2 = data.externalID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate101.errors = [
                                            {
                                                instancePath: instancePath + '/externalID',
                                                schemaPath: '#/properties/externalID/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate101.errors = [
                                        {
                                            instancePath: instancePath + '/externalID',
                                            schemaPath: '#/properties/externalID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.status !== undefined) {
                                let data3 = data.status;
                                const _errs7 = errors;
                                if (typeof data3 !== 'string') {
                                    validate101.errors = [
                                        {
                                            instancePath: instancePath + '/status',
                                            schemaPath: '#/properties/status/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data3 === 'running' || data3 === 'failed' || data3 === 'cancelled' || data3 === 'completed')) {
                                    validate101.errors = [
                                        {
                                            instancePath: instancePath + '/status',
                                            schemaPath: '#/properties/status/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema117.properties.status.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.calcInitType !== undefined) {
                                    let data4 = data.calcInitType;
                                    const _errs9 = errors;
                                    if (typeof data4 !== 'string') {
                                        validate101.errors = [
                                            {
                                                instancePath: instancePath + '/calcInitType',
                                                schemaPath: '#/properties/calcInitType/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data4 === 'withDependees' || data4 === 'withoutDependees' || data4 === 'calcAll')) {
                                        validate101.errors = [
                                            {
                                                instancePath: instancePath + '/calcInitType',
                                                schemaPath: '#/properties/calcInitType/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema117.properties.calcInitType.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.taskID !== undefined) {
                                        let data5 = data.taskID;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (typeof data5 === 'string') {
                                                if (func2(data5) < 1) {
                                                    validate101.errors = [
                                                        {
                                                            instancePath: instancePath + '/taskID',
                                                            schemaPath: '#/properties/taskID/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate101.errors = [
                                                    {
                                                        instancePath: instancePath + '/taskID',
                                                        schemaPath: '#/properties/taskID/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.rootTaskID !== undefined) {
                                            const _errs13 = errors;
                                            if (typeof data.rootTaskID !== 'string') {
                                                validate101.errors = [
                                                    {
                                                        instancePath: instancePath + '/rootTaskID',
                                                        schemaPath: '#/properties/rootTaskID/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.error !== undefined) {
                                                let data7 = data.error;
                                                const _errs15 = errors;
                                                if (!(data7 && typeof data7 == 'object' && !Array.isArray(data7))) {
                                                    validate101.errors = [
                                                        {
                                                            instancePath: instancePath + '/error',
                                                            schemaPath: '#/properties/error/type',
                                                            keyword: 'type',
                                                            params: { type: 'object' },
                                                            message: 'must be object'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid0 = _errs15 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.start !== undefined) {
                                                    let data8 = data.start;
                                                    const _errs17 = errors;
                                                    if (errors === _errs17) {
                                                        if (errors === _errs17) {
                                                            if (typeof data8 === 'string') {
                                                                if (!formats0.validate(data8)) {
                                                                    validate101.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/start',
                                                                            schemaPath: '#/properties/start/format',
                                                                            keyword: 'format',
                                                                            params: { format: 'date-time' },
                                                                            message: 'must match format "' + 'date-time' + '"'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate101.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/start',
                                                                        schemaPath: '#/properties/start/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                    }
                                                    var valid0 = _errs17 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.end !== undefined) {
                                                        let data9 = data.end;
                                                        const _errs19 = errors;
                                                        if (errors === _errs19) {
                                                            if (errors === _errs19) {
                                                                if (typeof data9 === 'string') {
                                                                    if (!formats0.validate(data9)) {
                                                                        validate101.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/end',
                                                                                schemaPath: '#/properties/end/format',
                                                                                keyword: 'format',
                                                                                params: { format: 'date-time' },
                                                                                message: 'must match format "' + 'date-time' + '"'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate101.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/end',
                                                                            schemaPath: '#/properties/end/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                        var valid0 = _errs19 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (data.processingStartTime !== undefined) {
                                                            let data10 = data.processingStartTime;
                                                            const _errs21 = errors;
                                                            if (errors === _errs21) {
                                                                if (errors === _errs21) {
                                                                    if (typeof data10 === 'string') {
                                                                        if (!formats0.validate(data10)) {
                                                                            validate101.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/processingStartTime',
                                                                                    schemaPath: '#/properties/processingStartTime/format',
                                                                                    keyword: 'format',
                                                                                    params: { format: 'date-time' },
                                                                                    message: 'must match format "' + 'date-time' + '"'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate101.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/processingStartTime',
                                                                                schemaPath: '#/properties/processingStartTime/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                            var valid0 = _errs21 === errors;
                                                        }
                                                        else {
                                                            var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                            if (data.nodeCalcStatusSummary !== undefined) {
                                                                let data11 = data.nodeCalcStatusSummary;
                                                                const _errs23 = errors;
                                                                if (errors === _errs23) {
                                                                    if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                                                        for (const key0 in data11) {
                                                                            let data12 = data11[key0];
                                                                            const _errs26 = errors;
                                                                            if (typeof data12 !== 'string') {
                                                                                validate101.errors = [
                                                                                    {
                                                                                        instancePath: instancePath +
                                                                                            '/nodeCalcStatusSummary/' +
                                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                                        schemaPath: '#/properties/nodeCalcStatusSummary/additionalProperties/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            if (!(data12 === 'successful' ||
                                                                                data12 === 'failed' ||
                                                                                data12 === 'skipped' ||
                                                                                data12 === 'unprocessed')) {
                                                                                validate101.errors = [
                                                                                    {
                                                                                        instancePath: instancePath +
                                                                                            '/nodeCalcStatusSummary/' +
                                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                                        schemaPath: '#/properties/nodeCalcStatusSummary/additionalProperties/enum',
                                                                                        keyword: 'enum',
                                                                                        params: {
                                                                                            allowedValues: schema117.properties.nodeCalcStatusSummary.additionalProperties.enum
                                                                                        },
                                                                                        message: 'must be equal to one of the allowed values'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            var valid2 = _errs26 === errors;
                                                                            if (!valid2) {
                                                                                break;
                                                                            }
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate101.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/nodeCalcStatusSummary',
                                                                                schemaPath: '#/properties/nodeCalcStatusSummary/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'object' },
                                                                                message: 'must be object'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid0 = _errs23 === errors;
                                                            }
                                                            else {
                                                                var valid0 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate101.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate101.errors = vErrors;
    return errors === 0;
}
export const integrationCalcProgressEventSchemaValidation = validate102;
const schema118 = {
    $id: 'urn:wisepipe-common-computation:IntegrationCalcProgressEvent',
    type: 'object',
    properties: {
        orgID: { type: 'string', minLength: 1, maxLength: 128 },
        taskID: { type: 'string', minLength: 1 },
        externalID: { type: 'string', minLength: 1 },
        progress: { type: 'number', minimum: 0, maximum: 1 },
        progressObjectType: {
            type: 'string',
            enum: [
                'unknown',
                'pipe',
                'calculation',
                'import',
                'import_rowcount',
                'unit_test_data_import',
                'unit_test_data_rowcount',
                'unit_test_snapshot_import',
                'run',
                'download',
                'match',
                'export',
                'lock',
                'unit_test',
                'restore',
                'incentives_data_processing'
            ]
        },
        pipeID: { type: 'string', minLength: 1 },
        dataSourceID: { type: 'string', pattern: '^([_\\p{L}][_\\p{L}0-9]*)$' }
    },
    required: ['orgID', 'taskID', 'externalID', 'progress', 'progressObjectType'],
    allOf: [
        { if: { properties: { progressObjectType: { const: 'calculation' } } }, then: { required: ['pipeID'] } },
        {
            if: { properties: { progressObjectType: { const: 'incentives_data_processing' } } },
            then: { required: ['dataSourceID'] }
        }
    ]
};
function validate102(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:IntegrationCalcProgressEvent" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    const _errs2 = errors;
    let valid1 = true;
    const _errs3 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.progressObjectType !== undefined) {
            if ('calculation' !== data.progressObjectType) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs3 === errors;
    errors = _errs2;
    if (vErrors !== null) {
        if (_errs2) {
            vErrors.length = _errs2;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.pipeID === undefined && (missing0 = 'pipeID')) {
                validate102.errors = [
                    {
                        instancePath,
                        schemaPath: '#/allOf/0/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs5 === errors;
        valid1 = _valid0;
    }
    if (!valid1) {
        const err1 = {
            instancePath,
            schemaPath: '#/allOf/0/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate102.errors = vErrors;
        return false;
    }
    var valid0 = _errs1 === errors;
    if (valid0) {
        const _errs6 = errors;
        const _errs7 = errors;
        let valid3 = true;
        const _errs8 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.progressObjectType !== undefined) {
                if ('incentives_data_processing' !== data.progressObjectType) {
                    const err2 = {};
                    if (vErrors === null) {
                        vErrors = [err2];
                    }
                    else {
                        vErrors.push(err2);
                    }
                    errors++;
                }
            }
        }
        var _valid1 = _errs8 === errors;
        errors = _errs7;
        if (vErrors !== null) {
            if (_errs7) {
                vErrors.length = _errs7;
            }
            else {
                vErrors = null;
            }
        }
        if (_valid1) {
            const _errs10 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing1;
                if (data.dataSourceID === undefined && (missing1 = 'dataSourceID')) {
                    validate102.errors = [
                        {
                            instancePath,
                            schemaPath: '#/allOf/1/then/required',
                            keyword: 'required',
                            params: { missingProperty: missing1 },
                            message: "must have required property '" + missing1 + "'"
                        }
                    ];
                    return false;
                }
            }
            var _valid1 = _errs10 === errors;
            valid3 = _valid1;
        }
        if (!valid3) {
            const err3 = {
                instancePath,
                schemaPath: '#/allOf/1/if',
                keyword: 'if',
                params: { failingKeyword: 'then' },
                message: 'must match "then" schema'
            };
            if (vErrors === null) {
                vErrors = [err3];
            }
            else {
                vErrors.push(err3);
            }
            errors++;
            validate102.errors = vErrors;
            return false;
        }
        var valid0 = _errs6 === errors;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if ((data.orgID === undefined && (missing2 = 'orgID')) ||
                (data.taskID === undefined && (missing2 = 'taskID')) ||
                (data.externalID === undefined && (missing2 = 'externalID')) ||
                (data.progress === undefined && (missing2 = 'progress')) ||
                (data.progressObjectType === undefined && (missing2 = 'progressObjectType'))) {
                validate102.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing2 },
                        message: "must have required property '" + missing2 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data2 = data.orgID;
                    const _errs11 = errors;
                    if (errors === _errs11) {
                        if (typeof data2 === 'string') {
                            if (func2(data2) > 128) {
                                validate102.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 128 },
                                        message: 'must NOT have more than 128 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data2) < 1) {
                                    validate102.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate102.errors = [
                                {
                                    instancePath: instancePath + '/orgID',
                                    schemaPath: '#/properties/orgID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid5 = _errs11 === errors;
                }
                else {
                    var valid5 = true;
                }
                if (valid5) {
                    if (data.taskID !== undefined) {
                        let data3 = data.taskID;
                        const _errs13 = errors;
                        if (errors === _errs13) {
                            if (typeof data3 === 'string') {
                                if (func2(data3) < 1) {
                                    validate102.errors = [
                                        {
                                            instancePath: instancePath + '/taskID',
                                            schemaPath: '#/properties/taskID/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate102.errors = [
                                    {
                                        instancePath: instancePath + '/taskID',
                                        schemaPath: '#/properties/taskID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid5 = _errs13 === errors;
                    }
                    else {
                        var valid5 = true;
                    }
                    if (valid5) {
                        if (data.externalID !== undefined) {
                            let data4 = data.externalID;
                            const _errs15 = errors;
                            if (errors === _errs15) {
                                if (typeof data4 === 'string') {
                                    if (func2(data4) < 1) {
                                        validate102.errors = [
                                            {
                                                instancePath: instancePath + '/externalID',
                                                schemaPath: '#/properties/externalID/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate102.errors = [
                                        {
                                            instancePath: instancePath + '/externalID',
                                            schemaPath: '#/properties/externalID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid5 = _errs15 === errors;
                        }
                        else {
                            var valid5 = true;
                        }
                        if (valid5) {
                            if (data.progress !== undefined) {
                                let data5 = data.progress;
                                const _errs17 = errors;
                                if (errors === _errs17) {
                                    if (typeof data5 == 'number') {
                                        if (data5 > 1 || isNaN(data5)) {
                                            validate102.errors = [
                                                {
                                                    instancePath: instancePath + '/progress',
                                                    schemaPath: '#/properties/progress/maximum',
                                                    keyword: 'maximum',
                                                    params: { comparison: '<=', limit: 1 },
                                                    message: 'must be <= 1'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (data5 < 0 || isNaN(data5)) {
                                                validate102.errors = [
                                                    {
                                                        instancePath: instancePath + '/progress',
                                                        schemaPath: '#/properties/progress/minimum',
                                                        keyword: 'minimum',
                                                        params: { comparison: '>=', limit: 0 },
                                                        message: 'must be >= 0'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    else {
                                        validate102.errors = [
                                            {
                                                instancePath: instancePath + '/progress',
                                                schemaPath: '#/properties/progress/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid5 = _errs17 === errors;
                            }
                            else {
                                var valid5 = true;
                            }
                            if (valid5) {
                                if (data.progressObjectType !== undefined) {
                                    let data6 = data.progressObjectType;
                                    const _errs19 = errors;
                                    if (typeof data6 !== 'string') {
                                        validate102.errors = [
                                            {
                                                instancePath: instancePath + '/progressObjectType',
                                                schemaPath: '#/properties/progressObjectType/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data6 === 'unknown' ||
                                        data6 === 'pipe' ||
                                        data6 === 'calculation' ||
                                        data6 === 'import' ||
                                        data6 === 'import_rowcount' ||
                                        data6 === 'unit_test_data_import' ||
                                        data6 === 'unit_test_data_rowcount' ||
                                        data6 === 'unit_test_snapshot_import' ||
                                        data6 === 'run' ||
                                        data6 === 'download' ||
                                        data6 === 'match' ||
                                        data6 === 'export' ||
                                        data6 === 'lock' ||
                                        data6 === 'unit_test' ||
                                        data6 === 'restore' ||
                                        data6 === 'incentives_data_processing')) {
                                        validate102.errors = [
                                            {
                                                instancePath: instancePath + '/progressObjectType',
                                                schemaPath: '#/properties/progressObjectType/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema118.properties.progressObjectType.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid5 = _errs19 === errors;
                                }
                                else {
                                    var valid5 = true;
                                }
                                if (valid5) {
                                    if (data.pipeID !== undefined) {
                                        let data7 = data.pipeID;
                                        const _errs21 = errors;
                                        if (errors === _errs21) {
                                            if (typeof data7 === 'string') {
                                                if (func2(data7) < 1) {
                                                    validate102.errors = [
                                                        {
                                                            instancePath: instancePath + '/pipeID',
                                                            schemaPath: '#/properties/pipeID/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate102.errors = [
                                                    {
                                                        instancePath: instancePath + '/pipeID',
                                                        schemaPath: '#/properties/pipeID/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid5 = _errs21 === errors;
                                    }
                                    else {
                                        var valid5 = true;
                                    }
                                    if (valid5) {
                                        if (data.dataSourceID !== undefined) {
                                            let data8 = data.dataSourceID;
                                            const _errs23 = errors;
                                            if (errors === _errs23) {
                                                if (typeof data8 === 'string') {
                                                    if (!pattern3.test(data8)) {
                                                        validate102.errors = [
                                                            {
                                                                instancePath: instancePath + '/dataSourceID',
                                                                schemaPath: '#/properties/dataSourceID/pattern',
                                                                keyword: 'pattern',
                                                                params: { pattern: '^([_\\p{L}][_\\p{L}0-9]*)$' },
                                                                message: 'must match pattern "' + '^([_\\p{L}][_\\p{L}0-9]*)$' + '"'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate102.errors = [
                                                        {
                                                            instancePath: instancePath + '/dataSourceID',
                                                            schemaPath: '#/properties/dataSourceID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid5 = _errs23 === errors;
                                        }
                                        else {
                                            var valid5 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate102.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate102.errors = vErrors;
    return errors === 0;
}
export const integrationLockingCalcEventSchemaValidation = validate103;
const schema119 = {
    $id: 'urn:wisepipe-common-computation:IntegrationLockingCalcEvent',
    type: 'object',
    properties: {
        orgID: { type: 'string', minLength: 1, maxLength: 128 },
        calendarID: { type: 'string', minLength: 1 },
        taskID: { type: 'string', minLength: 1 },
        status: { type: 'string', enum: ['running', 'failed', 'cancelled', 'completed'] },
        start: { type: 'string', format: 'date-time' },
        end: { type: 'string', format: 'date-time' },
        error: { type: 'object' }
    },
    required: ['orgID', 'calendarID', 'taskID', 'status', 'start']
};
function validate103(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:IntegrationLockingCalcEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.calendarID === undefined && (missing0 = 'calendarID')) ||
                (data.taskID === undefined && (missing0 = 'taskID')) ||
                (data.status === undefined && (missing0 = 'status')) ||
                (data.start === undefined && (missing0 = 'start'))) {
                validate103.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 128) {
                                validate103.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 128 },
                                        message: 'must NOT have more than 128 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate103.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate103.errors = [
                                {
                                    instancePath: instancePath + '/orgID',
                                    schemaPath: '#/properties/orgID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.calendarID !== undefined) {
                        let data1 = data.calendarID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate103.errors = [
                                        {
                                            instancePath: instancePath + '/calendarID',
                                            schemaPath: '#/properties/calendarID/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate103.errors = [
                                    {
                                        instancePath: instancePath + '/calendarID',
                                        schemaPath: '#/properties/calendarID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.taskID !== undefined) {
                            let data2 = data.taskID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate103.errors = [
                                            {
                                                instancePath: instancePath + '/taskID',
                                                schemaPath: '#/properties/taskID/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate103.errors = [
                                        {
                                            instancePath: instancePath + '/taskID',
                                            schemaPath: '#/properties/taskID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.status !== undefined) {
                                let data3 = data.status;
                                const _errs7 = errors;
                                if (typeof data3 !== 'string') {
                                    validate103.errors = [
                                        {
                                            instancePath: instancePath + '/status',
                                            schemaPath: '#/properties/status/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data3 === 'running' || data3 === 'failed' || data3 === 'cancelled' || data3 === 'completed')) {
                                    validate103.errors = [
                                        {
                                            instancePath: instancePath + '/status',
                                            schemaPath: '#/properties/status/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema119.properties.status.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.start !== undefined) {
                                    let data4 = data.start;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (errors === _errs9) {
                                            if (typeof data4 === 'string') {
                                                if (!formats0.validate(data4)) {
                                                    validate103.errors = [
                                                        {
                                                            instancePath: instancePath + '/start',
                                                            schemaPath: '#/properties/start/format',
                                                            keyword: 'format',
                                                            params: { format: 'date-time' },
                                                            message: 'must match format "' + 'date-time' + '"'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate103.errors = [
                                                    {
                                                        instancePath: instancePath + '/start',
                                                        schemaPath: '#/properties/start/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.end !== undefined) {
                                        let data5 = data.end;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (errors === _errs11) {
                                                if (typeof data5 === 'string') {
                                                    if (!formats0.validate(data5)) {
                                                        validate103.errors = [
                                                            {
                                                                instancePath: instancePath + '/end',
                                                                schemaPath: '#/properties/end/format',
                                                                keyword: 'format',
                                                                params: { format: 'date-time' },
                                                                message: 'must match format "' + 'date-time' + '"'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate103.errors = [
                                                        {
                                                            instancePath: instancePath + '/end',
                                                            schemaPath: '#/properties/end/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.error !== undefined) {
                                            let data6 = data.error;
                                            const _errs13 = errors;
                                            if (!(data6 && typeof data6 == 'object' && !Array.isArray(data6))) {
                                                validate103.errors = [
                                                    {
                                                        instancePath: instancePath + '/error',
                                                        schemaPath: '#/properties/error/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate103.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate103.errors = vErrors;
    return errors === 0;
}
export const joinStatsSchemaValidation = validate104;
const schema120 = {
    $id: 'urn:wisepipe-common-computation:JoinStats',
    type: 'object',
    properties: {
        elementID: { type: 'string', uid: 10 },
        rowsLeft: { type: 'number' },
        rowsRight: { type: 'number' },
        rowsAfter: { type: 'number' },
        colsAdded: { type: 'number' },
        multipleMatches: { type: 'number' },
        excludeRows: { type: 'number' },
        excludeRowsLeft: { type: 'number' },
        excludeRowsRight: { type: 'number' },
        includeRowsLeft: { type: 'number' },
        includeRowsRight: { type: 'number' },
        duplicatesLeft: { type: 'number' },
        duplicatesRight: { type: 'number' },
        duplicatesAfter: { type: 'number' },
        blankColumnsLeft: { type: 'number' },
        blankColumnsRight: { type: 'number' },
        blankColumnsAfter: { type: 'number' },
        lastBuiltJoinType: { type: 'string' },
        timestamp: { type: 'string', format: 'date-time' }
    },
    required: [
        'elementID',
        'rowsLeft',
        'rowsRight',
        'rowsAfter',
        'colsAdded',
        'multipleMatches',
        'excludeRows',
        'excludeRowsLeft',
        'excludeRowsRight',
        'includeRowsLeft',
        'includeRowsRight',
        'duplicatesLeft',
        'duplicatesRight',
        'duplicatesAfter',
        'blankColumnsLeft',
        'blankColumnsRight',
        'blankColumnsAfter',
        'lastBuiltJoinType',
        'timestamp'
    ]
};
const func209 = ucs2length;
const func210 = base64urlToBuffer;
const func211 = base64urlEncode;
const func212 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate104(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:JoinStats" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.elementID === undefined && (missing0 = 'elementID')) ||
                (data.rowsLeft === undefined && (missing0 = 'rowsLeft')) ||
                (data.rowsRight === undefined && (missing0 = 'rowsRight')) ||
                (data.rowsAfter === undefined && (missing0 = 'rowsAfter')) ||
                (data.colsAdded === undefined && (missing0 = 'colsAdded')) ||
                (data.multipleMatches === undefined && (missing0 = 'multipleMatches')) ||
                (data.excludeRows === undefined && (missing0 = 'excludeRows')) ||
                (data.excludeRowsLeft === undefined && (missing0 = 'excludeRowsLeft')) ||
                (data.excludeRowsRight === undefined && (missing0 = 'excludeRowsRight')) ||
                (data.includeRowsLeft === undefined && (missing0 = 'includeRowsLeft')) ||
                (data.includeRowsRight === undefined && (missing0 = 'includeRowsRight')) ||
                (data.duplicatesLeft === undefined && (missing0 = 'duplicatesLeft')) ||
                (data.duplicatesRight === undefined && (missing0 = 'duplicatesRight')) ||
                (data.duplicatesAfter === undefined && (missing0 = 'duplicatesAfter')) ||
                (data.blankColumnsLeft === undefined && (missing0 = 'blankColumnsLeft')) ||
                (data.blankColumnsRight === undefined && (missing0 = 'blankColumnsRight')) ||
                (data.blankColumnsAfter === undefined && (missing0 = 'blankColumnsAfter')) ||
                (data.lastBuiltJoinType === undefined && (missing0 = 'lastBuiltJoinType')) ||
                (data.timestamp === undefined && (missing0 = 'timestamp'))) {
                validate104.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.elementID !== undefined) {
                    let data0 = data.elementID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func209(data0) < b64min0 || func209(data0) > b64max0) {
                                validate104.errors = [
                                    {
                                        instancePath: instancePath + '/elementID',
                                        schemaPath: '#/properties/elementID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func209(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func209(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func210(data0);
                                if (decoded0.length !== 10) {
                                    validate104.errors = [
                                        {
                                            instancePath: instancePath + '/elementID',
                                            schemaPath: '#/properties/elementID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func211(decoded0);
                                    if (func212(encoded0) !== func212(data0)) {
                                        validate104.errors = [
                                            {
                                                instancePath: instancePath + '/elementID',
                                                schemaPath: '#/properties/elementID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate104.errors = [
                                {
                                    instancePath: instancePath + '/elementID',
                                    schemaPath: '#/properties/elementID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.rowsLeft !== undefined) {
                        const _errs3 = errors;
                        if (!(typeof data.rowsLeft == 'number')) {
                            validate104.errors = [
                                {
                                    instancePath: instancePath + '/rowsLeft',
                                    schemaPath: '#/properties/rowsLeft/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.rowsRight !== undefined) {
                            const _errs5 = errors;
                            if (!(typeof data.rowsRight == 'number')) {
                                validate104.errors = [
                                    {
                                        instancePath: instancePath + '/rowsRight',
                                        schemaPath: '#/properties/rowsRight/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.rowsAfter !== undefined) {
                                const _errs7 = errors;
                                if (!(typeof data.rowsAfter == 'number')) {
                                    validate104.errors = [
                                        {
                                            instancePath: instancePath + '/rowsAfter',
                                            schemaPath: '#/properties/rowsAfter/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.colsAdded !== undefined) {
                                    const _errs9 = errors;
                                    if (!(typeof data.colsAdded == 'number')) {
                                        validate104.errors = [
                                            {
                                                instancePath: instancePath + '/colsAdded',
                                                schemaPath: '#/properties/colsAdded/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.multipleMatches !== undefined) {
                                        const _errs11 = errors;
                                        if (!(typeof data.multipleMatches == 'number')) {
                                            validate104.errors = [
                                                {
                                                    instancePath: instancePath + '/multipleMatches',
                                                    schemaPath: '#/properties/multipleMatches/type',
                                                    keyword: 'type',
                                                    params: { type: 'number' },
                                                    message: 'must be number'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.excludeRows !== undefined) {
                                            const _errs13 = errors;
                                            if (!(typeof data.excludeRows == 'number')) {
                                                validate104.errors = [
                                                    {
                                                        instancePath: instancePath + '/excludeRows',
                                                        schemaPath: '#/properties/excludeRows/type',
                                                        keyword: 'type',
                                                        params: { type: 'number' },
                                                        message: 'must be number'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.excludeRowsLeft !== undefined) {
                                                const _errs15 = errors;
                                                if (!(typeof data.excludeRowsLeft == 'number')) {
                                                    validate104.errors = [
                                                        {
                                                            instancePath: instancePath + '/excludeRowsLeft',
                                                            schemaPath: '#/properties/excludeRowsLeft/type',
                                                            keyword: 'type',
                                                            params: { type: 'number' },
                                                            message: 'must be number'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid0 = _errs15 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.excludeRowsRight !== undefined) {
                                                    const _errs17 = errors;
                                                    if (!(typeof data.excludeRowsRight == 'number')) {
                                                        validate104.errors = [
                                                            {
                                                                instancePath: instancePath + '/excludeRowsRight',
                                                                schemaPath: '#/properties/excludeRowsRight/type',
                                                                keyword: 'type',
                                                                params: { type: 'number' },
                                                                message: 'must be number'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid0 = _errs17 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.includeRowsLeft !== undefined) {
                                                        const _errs19 = errors;
                                                        if (!(typeof data.includeRowsLeft == 'number')) {
                                                            validate104.errors = [
                                                                {
                                                                    instancePath: instancePath + '/includeRowsLeft',
                                                                    schemaPath: '#/properties/includeRowsLeft/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'number' },
                                                                    message: 'must be number'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid0 = _errs19 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (data.includeRowsRight !== undefined) {
                                                            const _errs21 = errors;
                                                            if (!(typeof data.includeRowsRight == 'number')) {
                                                                validate104.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/includeRowsRight',
                                                                        schemaPath: '#/properties/includeRowsRight/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'number' },
                                                                        message: 'must be number'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid0 = _errs21 === errors;
                                                        }
                                                        else {
                                                            var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                            if (data.duplicatesLeft !== undefined) {
                                                                const _errs23 = errors;
                                                                if (!(typeof data.duplicatesLeft == 'number')) {
                                                                    validate104.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/duplicatesLeft',
                                                                            schemaPath: '#/properties/duplicatesLeft/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'number' },
                                                                            message: 'must be number'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid0 = _errs23 === errors;
                                                            }
                                                            else {
                                                                var valid0 = true;
                                                            }
                                                            if (valid0) {
                                                                if (data.duplicatesRight !== undefined) {
                                                                    const _errs25 = errors;
                                                                    if (!(typeof data.duplicatesRight == 'number')) {
                                                                        validate104.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/duplicatesRight',
                                                                                schemaPath: '#/properties/duplicatesRight/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'number' },
                                                                                message: 'must be number'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid0 = _errs25 === errors;
                                                                }
                                                                else {
                                                                    var valid0 = true;
                                                                }
                                                                if (valid0) {
                                                                    if (data.duplicatesAfter !== undefined) {
                                                                        const _errs27 = errors;
                                                                        if (!(typeof data.duplicatesAfter == 'number')) {
                                                                            validate104.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/duplicatesAfter',
                                                                                    schemaPath: '#/properties/duplicatesAfter/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'number' },
                                                                                    message: 'must be number'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        var valid0 = _errs27 === errors;
                                                                    }
                                                                    else {
                                                                        var valid0 = true;
                                                                    }
                                                                    if (valid0) {
                                                                        if (data.blankColumnsLeft !== undefined) {
                                                                            const _errs29 = errors;
                                                                            if (!(typeof data.blankColumnsLeft == 'number')) {
                                                                                validate104.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/blankColumnsLeft',
                                                                                        schemaPath: '#/properties/blankColumnsLeft/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'number' },
                                                                                        message: 'must be number'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            var valid0 = _errs29 === errors;
                                                                        }
                                                                        else {
                                                                            var valid0 = true;
                                                                        }
                                                                        if (valid0) {
                                                                            if (data.blankColumnsRight !== undefined) {
                                                                                const _errs31 = errors;
                                                                                if (!(typeof data.blankColumnsRight == 'number')) {
                                                                                    validate104.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/blankColumnsRight',
                                                                                            schemaPath: '#/properties/blankColumnsRight/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'number' },
                                                                                            message: 'must be number'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                var valid0 = _errs31 === errors;
                                                                            }
                                                                            else {
                                                                                var valid0 = true;
                                                                            }
                                                                            if (valid0) {
                                                                                if (data.blankColumnsAfter !== undefined) {
                                                                                    const _errs33 = errors;
                                                                                    if (!(typeof data.blankColumnsAfter == 'number')) {
                                                                                        validate104.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/blankColumnsAfter',
                                                                                                schemaPath: '#/properties/blankColumnsAfter/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'number' },
                                                                                                message: 'must be number'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    var valid0 = _errs33 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid0 = true;
                                                                                }
                                                                                if (valid0) {
                                                                                    if (data.lastBuiltJoinType !== undefined) {
                                                                                        const _errs35 = errors;
                                                                                        if (typeof data.lastBuiltJoinType !== 'string') {
                                                                                            validate104.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/lastBuiltJoinType',
                                                                                                    schemaPath: '#/properties/lastBuiltJoinType/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'string' },
                                                                                                    message: 'must be string'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        var valid0 = _errs35 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid0 = true;
                                                                                    }
                                                                                    if (valid0) {
                                                                                        if (data.timestamp !== undefined) {
                                                                                            let data18 = data.timestamp;
                                                                                            const _errs37 = errors;
                                                                                            if (errors === _errs37) {
                                                                                                if (errors === _errs37) {
                                                                                                    if (typeof data18 === 'string') {
                                                                                                        if (!formats0.validate(data18)) {
                                                                                                            validate104.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/timestamp',
                                                                                                                    schemaPath: '#/properties/timestamp/format',
                                                                                                                    keyword: 'format',
                                                                                                                    params: { format: 'date-time' },
                                                                                                                    message: 'must match format "' + 'date-time' + '"'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                    else {
                                                                                                        validate104.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/timestamp',
                                                                                                                schemaPath: '#/properties/timestamp/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'string' },
                                                                                                                message: 'must be string'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                            var valid0 = _errs37 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid0 = true;
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate104.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate104.errors = vErrors;
    return errors === 0;
}
export const lockedCalendarSchemaValidation = validate105;
const schema121 = {
    $id: 'urn:wisepipe-common-computation:LockedCalendar',
    type: 'object',
    properties: { calendarID: { type: 'string', minLength: 1 }, lastLockedPeriod: { type: 'string', minLength: 1 } },
    required: ['calendarID']
};
function validate105(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:LockedCalendar" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.calendarID === undefined && (missing0 = 'calendarID')) {
                validate105.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.calendarID !== undefined) {
                    let data0 = data.calendarID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate105.errors = [
                                    {
                                        instancePath: instancePath + '/calendarID',
                                        schemaPath: '#/properties/calendarID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate105.errors = [
                                {
                                    instancePath: instancePath + '/calendarID',
                                    schemaPath: '#/properties/calendarID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.lastLockedPeriod !== undefined) {
                        let data1 = data.lastLockedPeriod;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate105.errors = [
                                        {
                                            instancePath: instancePath + '/lastLockedPeriod',
                                            schemaPath: '#/properties/lastLockedPeriod/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate105.errors = [
                                    {
                                        instancePath: instancePath + '/lastLockedPeriod',
                                        schemaPath: '#/properties/lastLockedPeriod/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate105.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate105.errors = vErrors;
    return errors === 0;
}
export const lockedModelMetadataSchemaValidation = validate106;
const schema122 = {
    $id: 'urn:wisepipe-common-computation:LockedModelMetadata',
    type: 'object',
    properties: {
        lockedCalendars: {
            type: 'object',
            additionalProperties: { $ref: 'urn:wisepipe-common-computation:LockedCalendar' }
        },
        step: { type: 'number' },
        requestedCalendarID: { type: 'string' }
    },
    required: ['lockedCalendars'],
    if: { required: ['step'] },
    then: { required: ['requestedCalendarID'] }
};
function validate106(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:LockedModelMetadata" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if (data.step === undefined && (missing0 = 'step')) {
            const err0 = {};
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs3 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if (data.requestedCalendarID === undefined && (missing1 = 'requestedCalendarID')) {
                validate106.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs3 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err1 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate106.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if (data.lockedCalendars === undefined && (missing2 = 'lockedCalendars')) {
                validate106.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing2 },
                        message: "must have required property '" + missing2 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.lockedCalendars !== undefined) {
                    let data0 = data.lockedCalendars;
                    const _errs4 = errors;
                    if (errors === _errs4) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            for (const key0 in data0) {
                                let data1 = data0[key0];
                                const _errs7 = errors;
                                const _errs8 = errors;
                                if (errors === _errs8) {
                                    if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                        let missing3;
                                        if (data1.calendarID === undefined && (missing3 = 'calendarID')) {
                                            validate106.errors = [
                                                {
                                                    instancePath: instancePath + '/lockedCalendars/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                    schemaPath: 'urn:wisepipe-common-computation:LockedCalendar/required',
                                                    keyword: 'required',
                                                    params: { missingProperty: missing3 },
                                                    message: "must have required property '" + missing3 + "'"
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (data1.calendarID !== undefined) {
                                                let data2 = data1.calendarID;
                                                const _errs10 = errors;
                                                if (errors === _errs10) {
                                                    if (typeof data2 === 'string') {
                                                        if (func2(data2) < 1) {
                                                            validate106.errors = [
                                                                {
                                                                    instancePath: instancePath +
                                                                        '/lockedCalendars/' +
                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                        '/calendarID',
                                                                    schemaPath: 'urn:wisepipe-common-computation:LockedCalendar/properties/calendarID/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate106.errors = [
                                                            {
                                                                instancePath: instancePath +
                                                                    '/lockedCalendars/' +
                                                                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                    '/calendarID',
                                                                schemaPath: 'urn:wisepipe-common-computation:LockedCalendar/properties/calendarID/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid4 = _errs10 === errors;
                                            }
                                            else {
                                                var valid4 = true;
                                            }
                                            if (valid4) {
                                                if (data1.lastLockedPeriod !== undefined) {
                                                    let data3 = data1.lastLockedPeriod;
                                                    const _errs12 = errors;
                                                    if (errors === _errs12) {
                                                        if (typeof data3 === 'string') {
                                                            if (func2(data3) < 1) {
                                                                validate106.errors = [
                                                                    {
                                                                        instancePath: instancePath +
                                                                            '/lockedCalendars/' +
                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                            '/lastLockedPeriod',
                                                                        schemaPath: 'urn:wisepipe-common-computation:LockedCalendar/properties/lastLockedPeriod/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 1 },
                                                                        message: 'must NOT have fewer than 1 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate106.errors = [
                                                                {
                                                                    instancePath: instancePath +
                                                                        '/lockedCalendars/' +
                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                        '/lastLockedPeriod',
                                                                    schemaPath: 'urn:wisepipe-common-computation:LockedCalendar/properties/lastLockedPeriod/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid4 = _errs12 === errors;
                                                }
                                                else {
                                                    var valid4 = true;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate106.errors = [
                                            {
                                                instancePath: instancePath + '/lockedCalendars/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                schemaPath: 'urn:wisepipe-common-computation:LockedCalendar/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid2 = _errs7 === errors;
                                if (!valid2) {
                                    break;
                                }
                            }
                        }
                        else {
                            validate106.errors = [
                                {
                                    instancePath: instancePath + '/lockedCalendars',
                                    schemaPath: '#/properties/lockedCalendars/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid1 = _errs4 === errors;
                }
                else {
                    var valid1 = true;
                }
                if (valid1) {
                    if (data.step !== undefined) {
                        const _errs14 = errors;
                        if (!(typeof data.step == 'number')) {
                            validate106.errors = [
                                {
                                    instancePath: instancePath + '/step',
                                    schemaPath: '#/properties/step/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                        var valid1 = _errs14 === errors;
                    }
                    else {
                        var valid1 = true;
                    }
                    if (valid1) {
                        if (data.requestedCalendarID !== undefined) {
                            const _errs16 = errors;
                            if (typeof data.requestedCalendarID !== 'string') {
                                validate106.errors = [
                                    {
                                        instancePath: instancePath + '/requestedCalendarID',
                                        schemaPath: '#/properties/requestedCalendarID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid1 = _errs16 === errors;
                        }
                        else {
                            var valid1 = true;
                        }
                    }
                }
            }
        }
        else {
            validate106.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate106.errors = vErrors;
    return errors === 0;
}
export const lockingCalcInputSchemaValidation = validate107;
const schema124 = {
    $id: 'urn:wisepipe-common-computation:LockingCalcInput',
    type: 'object',
    properties: { lockingCalcTask: { $ref: 'urn:wisepipe-common-computation:LockingCalcTask' } },
    required: ['lockingCalcTask']
};
const schema125 = {
    $id: 'urn:wisepipe-common-computation:LockingCalcTask',
    type: 'object',
    properties: {
        taskID: { type: 'string', uid: 9 },
        user: { type: 'string', format: 'uuid' },
        orgID: { type: 'string', format: 'uuid' },
        orgPlan: { type: 'string', enum: ['Social', 'Enterprise', 'Integration', 'Temp', 'Starter', 'Professional'] },
        calendar: { $ref: 'urn:wisepipe-common-data:IncentivesCalendar' },
        lockPeriod: { type: 'string', minLength: 1 },
        incentivesExportOpenConfig: { $ref: 'urn:wisepipe-common:IncentivesComposerS3Config' },
        incentivesExportLockedConfig: { $ref: 'urn:wisepipe-common:IncentivesComposerS3Config' },
        incentivesMetaConfig: { $ref: 'urn:wisepipe-common:IncentivesComposerS3Config' },
        userName: { type: 'string' },
        userEmail: { type: 'string' }
    },
    required: [
        'taskID',
        'orgID',
        'orgPlan',
        'user',
        'calendar',
        'incentivesExportOpenConfig',
        'incentivesExportLockedConfig',
        'incentivesMetaConfig'
    ]
};
const func217 = ucs2length;
const func218 = base64urlToBuffer;
const func219 = base64urlEncode;
const func220 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate108(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:LockingCalcTask" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.taskID === undefined && (missing0 = 'taskID')) ||
                (data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.orgPlan === undefined && (missing0 = 'orgPlan')) ||
                (data.user === undefined && (missing0 = 'user')) ||
                (data.calendar === undefined && (missing0 = 'calendar')) ||
                (data.incentivesExportOpenConfig === undefined && (missing0 = 'incentivesExportOpenConfig')) ||
                (data.incentivesExportLockedConfig === undefined && (missing0 = 'incentivesExportLockedConfig')) ||
                (data.incentivesMetaConfig === undefined && (missing0 = 'incentivesMetaConfig'))) {
                validate108.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.taskID !== undefined) {
                    let data0 = data.taskID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 9) / 3);
                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                            if (func217(data0) < b64min0 || func217(data0) > b64max0) {
                                validate108.errors = [
                                    {
                                        instancePath: instancePath + '/taskID',
                                        schemaPath: '#/properties/taskID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func217(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func217(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func218(data0);
                                if (decoded0.length !== 9) {
                                    validate108.errors = [
                                        {
                                            instancePath: instancePath + '/taskID',
                                            schemaPath: '#/properties/taskID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 9 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func219(decoded0);
                                    if (func220(encoded0) !== func220(data0)) {
                                        validate108.errors = [
                                            {
                                                instancePath: instancePath + '/taskID',
                                                schemaPath: '#/properties/taskID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate108.errors = [
                                {
                                    instancePath: instancePath + '/taskID',
                                    schemaPath: '#/properties/taskID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.user !== undefined) {
                        let data1 = data.user;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats6.test(data1)) {
                                        validate108.errors = [
                                            {
                                                instancePath: instancePath + '/user',
                                                schemaPath: '#/properties/user/format',
                                                keyword: 'format',
                                                params: { format: 'uuid' },
                                                message: 'must match format "' + 'uuid' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate108.errors = [
                                        {
                                            instancePath: instancePath + '/user',
                                            schemaPath: '#/properties/user/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.orgID !== undefined) {
                            let data2 = data.orgID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (errors === _errs5) {
                                    if (typeof data2 === 'string') {
                                        if (!formats6.test(data2)) {
                                            validate108.errors = [
                                                {
                                                    instancePath: instancePath + '/orgID',
                                                    schemaPath: '#/properties/orgID/format',
                                                    keyword: 'format',
                                                    params: { format: 'uuid' },
                                                    message: 'must match format "' + 'uuid' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate108.errors = [
                                            {
                                                instancePath: instancePath + '/orgID',
                                                schemaPath: '#/properties/orgID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.orgPlan !== undefined) {
                                let data3 = data.orgPlan;
                                const _errs7 = errors;
                                if (typeof data3 !== 'string') {
                                    validate108.errors = [
                                        {
                                            instancePath: instancePath + '/orgPlan',
                                            schemaPath: '#/properties/orgPlan/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data3 === 'Social' ||
                                    data3 === 'Enterprise' ||
                                    data3 === 'Integration' ||
                                    data3 === 'Temp' ||
                                    data3 === 'Starter' ||
                                    data3 === 'Professional')) {
                                    validate108.errors = [
                                        {
                                            instancePath: instancePath + '/orgPlan',
                                            schemaPath: '#/properties/orgPlan/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema125.properties.orgPlan.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.calendar !== undefined) {
                                    const _errs9 = errors;
                                    if (!validate88(data.calendar, {
                                        instancePath: instancePath + '/calendar',
                                        parentData: data,
                                        parentDataProperty: 'calendar',
                                        rootData
                                    })) {
                                        vErrors = vErrors === null ? validate88.errors : vErrors.concat(validate88.errors);
                                        errors = vErrors.length;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.lockPeriod !== undefined) {
                                        let data5 = data.lockPeriod;
                                        const _errs10 = errors;
                                        if (errors === _errs10) {
                                            if (typeof data5 === 'string') {
                                                if (func2(data5) < 1) {
                                                    validate108.errors = [
                                                        {
                                                            instancePath: instancePath + '/lockPeriod',
                                                            schemaPath: '#/properties/lockPeriod/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate108.errors = [
                                                    {
                                                        instancePath: instancePath + '/lockPeriod',
                                                        schemaPath: '#/properties/lockPeriod/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs10 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.incentivesExportOpenConfig !== undefined) {
                                            const _errs12 = errors;
                                            if (!validate27(data.incentivesExportOpenConfig, {
                                                instancePath: instancePath + '/incentivesExportOpenConfig',
                                                parentData: data,
                                                parentDataProperty: 'incentivesExportOpenConfig',
                                                rootData
                                            })) {
                                                vErrors = vErrors === null ? validate27.errors : vErrors.concat(validate27.errors);
                                                errors = vErrors.length;
                                            }
                                            var valid0 = _errs12 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.incentivesExportLockedConfig !== undefined) {
                                                const _errs13 = errors;
                                                if (!validate27(data.incentivesExportLockedConfig, {
                                                    instancePath: instancePath + '/incentivesExportLockedConfig',
                                                    parentData: data,
                                                    parentDataProperty: 'incentivesExportLockedConfig',
                                                    rootData
                                                })) {
                                                    vErrors = vErrors === null ? validate27.errors : vErrors.concat(validate27.errors);
                                                    errors = vErrors.length;
                                                }
                                                var valid0 = _errs13 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.incentivesMetaConfig !== undefined) {
                                                    const _errs14 = errors;
                                                    if (!validate27(data.incentivesMetaConfig, {
                                                        instancePath: instancePath + '/incentivesMetaConfig',
                                                        parentData: data,
                                                        parentDataProperty: 'incentivesMetaConfig',
                                                        rootData
                                                    })) {
                                                        vErrors = vErrors === null ? validate27.errors : vErrors.concat(validate27.errors);
                                                        errors = vErrors.length;
                                                    }
                                                    var valid0 = _errs14 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.userName !== undefined) {
                                                        const _errs15 = errors;
                                                        if (typeof data.userName !== 'string') {
                                                            validate108.errors = [
                                                                {
                                                                    instancePath: instancePath + '/userName',
                                                                    schemaPath: '#/properties/userName/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid0 = _errs15 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (data.userEmail !== undefined) {
                                                            const _errs17 = errors;
                                                            if (typeof data.userEmail !== 'string') {
                                                                validate108.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/userEmail',
                                                                        schemaPath: '#/properties/userEmail/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid0 = _errs17 === errors;
                                                        }
                                                        else {
                                                            var valid0 = true;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate108.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate108.errors = vErrors;
    return errors === 0;
}
function validate107(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:LockingCalcInput" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.lockingCalcTask === undefined && (missing0 = 'lockingCalcTask')) {
                validate107.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.lockingCalcTask !== undefined) {
                    if (!validate108(data.lockingCalcTask, {
                        instancePath: instancePath + '/lockingCalcTask',
                        parentData: data,
                        parentDataProperty: 'lockingCalcTask',
                        rootData
                    })) {
                        vErrors = vErrors === null ? validate108.errors : vErrors.concat(validate108.errors);
                        errors = vErrors.length;
                    }
                }
            }
        }
        else {
            validate107.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate107.errors = vErrors;
    return errors === 0;
}
export const lockingCalcRequestSchemaValidation = validate114;
const schema126 = {
    $id: 'urn:wisepipe-common-computation:LockingCalcRequest',
    type: 'object',
    properties: {
        calendarID: { type: 'string', minLength: 1 },
        lockPeriod: { type: 'string', minLength: 1 },
        incentivesExportOpenConfig: { $ref: 'urn:wisepipe-common:IncentivesComposerS3Config' },
        incentivesExportLockedConfig: { $ref: 'urn:wisepipe-common:IncentivesComposerS3Config' },
        incentivesMetaConfig: { $ref: 'urn:wisepipe-common:IncentivesComposerS3Config' }
    },
    required: ['calendarID', 'incentivesExportOpenConfig', 'incentivesExportLockedConfig', 'incentivesMetaConfig']
};
function validate114(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:LockingCalcRequest" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.calendarID === undefined && (missing0 = 'calendarID')) ||
                (data.incentivesExportOpenConfig === undefined && (missing0 = 'incentivesExportOpenConfig')) ||
                (data.incentivesExportLockedConfig === undefined && (missing0 = 'incentivesExportLockedConfig')) ||
                (data.incentivesMetaConfig === undefined && (missing0 = 'incentivesMetaConfig'))) {
                validate114.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.calendarID !== undefined) {
                    let data0 = data.calendarID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate114.errors = [
                                    {
                                        instancePath: instancePath + '/calendarID',
                                        schemaPath: '#/properties/calendarID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate114.errors = [
                                {
                                    instancePath: instancePath + '/calendarID',
                                    schemaPath: '#/properties/calendarID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.lockPeriod !== undefined) {
                        let data1 = data.lockPeriod;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate114.errors = [
                                        {
                                            instancePath: instancePath + '/lockPeriod',
                                            schemaPath: '#/properties/lockPeriod/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate114.errors = [
                                    {
                                        instancePath: instancePath + '/lockPeriod',
                                        schemaPath: '#/properties/lockPeriod/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.incentivesExportOpenConfig !== undefined) {
                            const _errs5 = errors;
                            if (!validate27(data.incentivesExportOpenConfig, {
                                instancePath: instancePath + '/incentivesExportOpenConfig',
                                parentData: data,
                                parentDataProperty: 'incentivesExportOpenConfig',
                                rootData
                            })) {
                                vErrors = vErrors === null ? validate27.errors : vErrors.concat(validate27.errors);
                                errors = vErrors.length;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.incentivesExportLockedConfig !== undefined) {
                                const _errs6 = errors;
                                if (!validate27(data.incentivesExportLockedConfig, {
                                    instancePath: instancePath + '/incentivesExportLockedConfig',
                                    parentData: data,
                                    parentDataProperty: 'incentivesExportLockedConfig',
                                    rootData
                                })) {
                                    vErrors = vErrors === null ? validate27.errors : vErrors.concat(validate27.errors);
                                    errors = vErrors.length;
                                }
                                var valid0 = _errs6 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.incentivesMetaConfig !== undefined) {
                                    const _errs7 = errors;
                                    if (!validate27(data.incentivesMetaConfig, {
                                        instancePath: instancePath + '/incentivesMetaConfig',
                                        parentData: data,
                                        parentDataProperty: 'incentivesMetaConfig',
                                        rootData
                                    })) {
                                        vErrors = vErrors === null ? validate27.errors : vErrors.concat(validate27.errors);
                                        errors = vErrors.length;
                                    }
                                    var valid0 = _errs7 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate114.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate114.errors = vErrors;
    return errors === 0;
}
export const lockingCalcTaskSchemaValidation = validate108;
export const mapVisualParamsSchemaValidation = validate118;
const schema127 = {
    $id: 'urn:wisepipe-common-computation:MapVisualParams',
    type: 'object',
    properties: {
        mapType: { type: 'string', enum: ['world', 'usa', 'canada'] },
        location: { type: 'string', minLength: 1 },
        value: { type: 'string', minLength: 1 },
        aggOp: {
            type: 'string',
            enum: ['MAX', 'MIN', 'COUNT', 'SUM', 'AVG', 'OR', 'AND', 'MEDIAN', 'DIFF', 'PCT', 'SHIFT', 'STDEV']
        }
    },
    required: ['mapType', 'location', 'value']
};
function validate118(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:MapVisualParams" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.mapType === undefined && (missing0 = 'mapType')) ||
                (data.location === undefined && (missing0 = 'location')) ||
                (data.value === undefined && (missing0 = 'value'))) {
                validate118.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.mapType !== undefined) {
                    let data0 = data.mapType;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate118.errors = [
                            {
                                instancePath: instancePath + '/mapType',
                                schemaPath: '#/properties/mapType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'world' || data0 === 'usa' || data0 === 'canada')) {
                        validate118.errors = [
                            {
                                instancePath: instancePath + '/mapType',
                                schemaPath: '#/properties/mapType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema127.properties.mapType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.location !== undefined) {
                        let data1 = data.location;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate118.errors = [
                                        {
                                            instancePath: instancePath + '/location',
                                            schemaPath: '#/properties/location/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate118.errors = [
                                    {
                                        instancePath: instancePath + '/location',
                                        schemaPath: '#/properties/location/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.value !== undefined) {
                            let data2 = data.value;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate118.errors = [
                                            {
                                                instancePath: instancePath + '/value',
                                                schemaPath: '#/properties/value/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate118.errors = [
                                        {
                                            instancePath: instancePath + '/value',
                                            schemaPath: '#/properties/value/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.aggOp !== undefined) {
                                let data3 = data.aggOp;
                                const _errs7 = errors;
                                if (typeof data3 !== 'string') {
                                    validate118.errors = [
                                        {
                                            instancePath: instancePath + '/aggOp',
                                            schemaPath: '#/properties/aggOp/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data3 === 'MAX' ||
                                    data3 === 'MIN' ||
                                    data3 === 'COUNT' ||
                                    data3 === 'SUM' ||
                                    data3 === 'AVG' ||
                                    data3 === 'OR' ||
                                    data3 === 'AND' ||
                                    data3 === 'MEDIAN' ||
                                    data3 === 'DIFF' ||
                                    data3 === 'PCT' ||
                                    data3 === 'SHIFT' ||
                                    data3 === 'STDEV')) {
                                    validate118.errors = [
                                        {
                                            instancePath: instancePath + '/aggOp',
                                            schemaPath: '#/properties/aggOp/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema127.properties.aggOp.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate118.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate118.errors = vErrors;
    return errors === 0;
}
export const metricSchemaValidation = validate119;
const schema128 = {
    $id: 'urn:wisepipe-base-computation:Metric',
    type: 'object',
    properties: {
        elementID: { type: 'string', uid: 10 },
        name: { type: 'string', minLength: 1, maxLength: 100 },
        type: { type: 'string', enum: ['number', 'string', 'boolean'] },
        timestamp: { type: 'string', format: 'date-time' },
        reason: { type: 'string' }
    },
    if: { properties: { type: { const: 'number' } } },
    then: { properties: { value: { type: 'number' } } },
    else: {
        if: { properties: { type: { const: 'string' } } },
        then: { properties: { value: { type: 'string' } } },
        else: { if: { properties: { type: { const: 'boolean' } } }, then: { properties: { value: { type: 'boolean' } } } }
    },
    required: ['elementID', 'name', 'type', 'value', 'timestamp']
};
const func226 = ucs2length;
const func227 = base64urlToBuffer;
const func228 = base64urlEncode;
const func229 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate119(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-computation:Metric" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.type !== undefined) {
            if ('number' !== data.type) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    let ifClause0;
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.value !== undefined) {
                if (!(typeof data.value == 'number')) {
                    validate119.errors = [
                        {
                            instancePath: instancePath + '/value',
                            schemaPath: '#/then/properties/value/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number'
                        }
                    ];
                    return false;
                }
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
        ifClause0 = 'then';
    }
    else {
        const _errs7 = errors;
        const _errs8 = errors;
        let valid3 = true;
        const _errs9 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.type !== undefined) {
                if ('string' !== data.type) {
                    const err1 = {};
                    if (vErrors === null) {
                        vErrors = [err1];
                    }
                    else {
                        vErrors.push(err1);
                    }
                    errors++;
                }
            }
        }
        var _valid1 = _errs9 === errors;
        errors = _errs8;
        if (vErrors !== null) {
            if (_errs8) {
                vErrors.length = _errs8;
            }
            else {
                vErrors = null;
            }
        }
        let ifClause1;
        if (_valid1) {
            const _errs11 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                if (data.value !== undefined) {
                    if (typeof data.value !== 'string') {
                        validate119.errors = [
                            {
                                instancePath: instancePath + '/value',
                                schemaPath: '#/else/then/properties/value/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                }
            }
            var _valid1 = _errs11 === errors;
            valid3 = _valid1;
            ifClause1 = 'then';
        }
        else {
            const _errs14 = errors;
            const _errs15 = errors;
            let valid6 = true;
            const _errs16 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                if (data.type !== undefined) {
                    if ('boolean' !== data.type) {
                        const err2 = {};
                        if (vErrors === null) {
                            vErrors = [err2];
                        }
                        else {
                            vErrors.push(err2);
                        }
                        errors++;
                    }
                }
            }
            var _valid2 = _errs16 === errors;
            errors = _errs15;
            if (vErrors !== null) {
                if (_errs15) {
                    vErrors.length = _errs15;
                }
                else {
                    vErrors = null;
                }
            }
            if (_valid2) {
                const _errs18 = errors;
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    if (data.value !== undefined) {
                        if (typeof data.value !== 'boolean') {
                            validate119.errors = [
                                {
                                    instancePath: instancePath + '/value',
                                    schemaPath: '#/else/else/then/properties/value/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean'
                                }
                            ];
                            return false;
                        }
                    }
                }
                var _valid2 = _errs18 === errors;
                valid6 = _valid2;
            }
            if (!valid6) {
                const err3 = {
                    instancePath,
                    schemaPath: '#/else/else/if',
                    keyword: 'if',
                    params: { failingKeyword: 'then' },
                    message: 'must match "then" schema'
                };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
                validate119.errors = vErrors;
                return false;
            }
            var _valid1 = _errs14 === errors;
            valid3 = _valid1;
            ifClause1 = 'else';
        }
        if (!valid3) {
            const err4 = {
                instancePath,
                schemaPath: '#/else/if',
                keyword: 'if',
                params: { failingKeyword: ifClause1 },
                message: 'must match "' + ifClause1 + '" schema'
            };
            if (vErrors === null) {
                vErrors = [err4];
            }
            else {
                vErrors.push(err4);
            }
            errors++;
            validate119.errors = vErrors;
            return false;
        }
        var _valid0 = _errs7 === errors;
        valid0 = _valid0;
        ifClause0 = 'else';
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: ifClause0 },
            message: 'must match "' + ifClause0 + '" schema'
        };
        if (vErrors === null) {
            vErrors = [err5];
        }
        else {
            vErrors.push(err5);
        }
        errors++;
        validate119.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.elementID === undefined && (missing0 = 'elementID')) ||
                (data.name === undefined && (missing0 = 'name')) ||
                (data.type === undefined && (missing0 = 'type')) ||
                (data.value === undefined && (missing0 = 'value')) ||
                (data.timestamp === undefined && (missing0 = 'timestamp'))) {
                validate119.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.elementID !== undefined) {
                    let data6 = data.elementID;
                    const _errs21 = errors;
                    if (errors === _errs21) {
                        if (typeof data6 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func226(data6) < b64min0 || func226(data6) > b64max0) {
                                validate119.errors = [
                                    {
                                        instancePath: instancePath + '/elementID',
                                        schemaPath: '#/properties/elementID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func226(data6) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func226(data6)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func227(data6);
                                if (decoded0.length !== 10) {
                                    validate119.errors = [
                                        {
                                            instancePath: instancePath + '/elementID',
                                            schemaPath: '#/properties/elementID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func228(decoded0);
                                    if (func229(encoded0) !== func229(data6)) {
                                        validate119.errors = [
                                            {
                                                instancePath: instancePath + '/elementID',
                                                schemaPath: '#/properties/elementID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate119.errors = [
                                {
                                    instancePath: instancePath + '/elementID',
                                    schemaPath: '#/properties/elementID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid9 = _errs21 === errors;
                }
                else {
                    var valid9 = true;
                }
                if (valid9) {
                    if (data.name !== undefined) {
                        let data7 = data.name;
                        const _errs23 = errors;
                        if (errors === _errs23) {
                            if (typeof data7 === 'string') {
                                if (func2(data7) > 100) {
                                    validate119.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 100 },
                                            message: 'must NOT have more than 100 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data7) < 1) {
                                        validate119.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate119.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid9 = _errs23 === errors;
                    }
                    else {
                        var valid9 = true;
                    }
                    if (valid9) {
                        if (data.type !== undefined) {
                            let data8 = data.type;
                            const _errs25 = errors;
                            if (typeof data8 !== 'string') {
                                validate119.errors = [
                                    {
                                        instancePath: instancePath + '/type',
                                        schemaPath: '#/properties/type/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data8 === 'number' || data8 === 'string' || data8 === 'boolean')) {
                                validate119.errors = [
                                    {
                                        instancePath: instancePath + '/type',
                                        schemaPath: '#/properties/type/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema128.properties.type.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid9 = _errs25 === errors;
                        }
                        else {
                            var valid9 = true;
                        }
                        if (valid9) {
                            if (data.timestamp !== undefined) {
                                let data9 = data.timestamp;
                                const _errs27 = errors;
                                if (errors === _errs27) {
                                    if (errors === _errs27) {
                                        if (typeof data9 === 'string') {
                                            if (!formats0.validate(data9)) {
                                                validate119.errors = [
                                                    {
                                                        instancePath: instancePath + '/timestamp',
                                                        schemaPath: '#/properties/timestamp/format',
                                                        keyword: 'format',
                                                        params: { format: 'date-time' },
                                                        message: 'must match format "' + 'date-time' + '"'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate119.errors = [
                                                {
                                                    instancePath: instancePath + '/timestamp',
                                                    schemaPath: '#/properties/timestamp/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid9 = _errs27 === errors;
                            }
                            else {
                                var valid9 = true;
                            }
                            if (valid9) {
                                if (data.reason !== undefined) {
                                    const _errs29 = errors;
                                    if (typeof data.reason !== 'string') {
                                        validate119.errors = [
                                            {
                                                instancePath: instancePath + '/reason',
                                                schemaPath: '#/properties/reason/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid9 = _errs29 === errors;
                                }
                                else {
                                    var valid9 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate119.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate119.errors = vErrors;
    return errors === 0;
}
export const metricsSchemaValidation = validate120;
const schema129 = {
    $id: 'urn:wisepipe-common-computation:Metrics',
    type: 'object',
    properties: {
        type: { type: 'string', enum: ['calc', 'run'] },
        metrics: { type: 'array', items: { $ref: 'urn:wisepipe-base-computation:Metric' } }
    },
    if: { properties: { type: { const: 'calc' } }, required: ['type'] },
    then: { properties: { id: { type: 'string', uid: 10 } }, required: ['id'] },
    else: {
        if: { properties: { type: { const: 'run' } }, required: ['type'] },
        then: { properties: { id: { type: 'string', uid: 9 } }, required: ['id'] }
    },
    required: ['type', 'metrics']
};
const func232 = ucs2length;
const func233 = base64urlToBuffer;
const func234 = base64urlEncode;
const func235 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func236 = ucs2length;
const func237 = base64urlToBuffer;
const func238 = base64urlEncode;
const func239 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func240 = ucs2length;
const func241 = base64urlToBuffer;
const func242 = base64urlEncode;
const func243 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate120(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:Metrics" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if (data.type === undefined && (missing0 = 'type')) {
            const err0 = {};
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        else {
            if (data.type !== undefined) {
                if ('calc' !== data.type) {
                    const err1 = {};
                    if (vErrors === null) {
                        vErrors = [err1];
                    }
                    else {
                        vErrors.push(err1);
                    }
                    errors++;
                }
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    let ifClause0;
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if (data.id === undefined && (missing1 = 'id')) {
                validate120.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.id !== undefined) {
                    let data1 = data.id;
                    const _errs5 = errors;
                    if (errors === _errs5) {
                        if (typeof data1 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func232(data1) < b64min0 || func232(data1) > b64max0) {
                                validate120.errors = [
                                    {
                                        instancePath: instancePath + '/id',
                                        schemaPath: '#/then/properties/id/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func232(data1) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func232(data1)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func233(data1);
                                if (decoded0.length !== 10) {
                                    validate120.errors = [
                                        {
                                            instancePath: instancePath + '/id',
                                            schemaPath: '#/then/properties/id/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func234(decoded0);
                                    if (func235(encoded0) !== func235(data1)) {
                                        validate120.errors = [
                                            {
                                                instancePath: instancePath + '/id',
                                                schemaPath: '#/then/properties/id/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate120.errors = [
                                {
                                    instancePath: instancePath + '/id',
                                    schemaPath: '#/then/properties/id/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
        ifClause0 = 'then';
    }
    else {
        const _errs7 = errors;
        const _errs8 = errors;
        let valid4 = true;
        const _errs9 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if (data.type === undefined && (missing2 = 'type')) {
                const err2 = {};
                if (vErrors === null) {
                    vErrors = [err2];
                }
                else {
                    vErrors.push(err2);
                }
                errors++;
            }
            else {
                if (data.type !== undefined) {
                    if ('run' !== data.type) {
                        const err3 = {};
                        if (vErrors === null) {
                            vErrors = [err3];
                        }
                        else {
                            vErrors.push(err3);
                        }
                        errors++;
                    }
                }
            }
        }
        var _valid1 = _errs9 === errors;
        errors = _errs8;
        if (vErrors !== null) {
            if (_errs8) {
                vErrors.length = _errs8;
            }
            else {
                vErrors = null;
            }
        }
        if (_valid1) {
            const _errs11 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing3;
                if (data.id === undefined && (missing3 = 'id')) {
                    validate120.errors = [
                        {
                            instancePath,
                            schemaPath: '#/else/then/required',
                            keyword: 'required',
                            params: { missingProperty: missing3 },
                            message: "must have required property '" + missing3 + "'"
                        }
                    ];
                    return false;
                }
                else {
                    if (data.id !== undefined) {
                        let data3 = data.id;
                        const _errs12 = errors;
                        if (errors === _errs12) {
                            if (typeof data3 === 'string') {
                                const b64min1 = Math.ceil((4 * 9) / 3);
                                const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                if (func236(data3) < b64min1 || func236(data3) > b64max1) {
                                    validate120.errors = [
                                        {
                                            instancePath: instancePath + '/id',
                                            schemaPath: '#/else/then/properties/id/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func236(data3) },
                                            message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func236(data3)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded1 = func237(data3);
                                    if (decoded1.length !== 9) {
                                        validate120.errors = [
                                            {
                                                instancePath: instancePath + '/id',
                                                schemaPath: '#/else/then/properties/id/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 9 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded1 = func238(decoded1);
                                        if (func239(encoded1) !== func239(data3)) {
                                            validate120.errors = [
                                                {
                                                    instancePath: instancePath + '/id',
                                                    schemaPath: '#/else/then/properties/id/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate120.errors = [
                                    {
                                        instancePath: instancePath + '/id',
                                        schemaPath: '#/else/then/properties/id/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                }
            }
            var _valid1 = _errs11 === errors;
            valid4 = _valid1;
        }
        if (!valid4) {
            const err4 = {
                instancePath,
                schemaPath: '#/else/if',
                keyword: 'if',
                params: { failingKeyword: 'then' },
                message: 'must match "then" schema'
            };
            if (vErrors === null) {
                vErrors = [err4];
            }
            else {
                vErrors.push(err4);
            }
            errors++;
            validate120.errors = vErrors;
            return false;
        }
        var _valid0 = _errs7 === errors;
        valid0 = _valid0;
        ifClause0 = 'else';
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: ifClause0 },
            message: 'must match "' + ifClause0 + '" schema'
        };
        if (vErrors === null) {
            vErrors = [err5];
        }
        else {
            vErrors.push(err5);
        }
        errors++;
        validate120.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing4;
            if ((data.type === undefined && (missing4 = 'type')) || (data.metrics === undefined && (missing4 = 'metrics'))) {
                validate120.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing4 },
                        message: "must have required property '" + missing4 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.type !== undefined) {
                    let data4 = data.type;
                    const _errs14 = errors;
                    if (typeof data4 !== 'string') {
                        validate120.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data4 === 'calc' || data4 === 'run')) {
                        validate120.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema129.properties.type.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid8 = _errs14 === errors;
                }
                else {
                    var valid8 = true;
                }
                if (valid8) {
                    if (data.metrics !== undefined) {
                        let data5 = data.metrics;
                        const _errs16 = errors;
                        if (errors === _errs16) {
                            if (Array.isArray(data5)) {
                                var valid9 = true;
                                const len0 = data5.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data6 = data5[i0];
                                    const _errs18 = errors;
                                    const _errs19 = errors;
                                    const _errs21 = errors;
                                    let valid11 = true;
                                    const _errs22 = errors;
                                    if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                        if (data6.type !== undefined) {
                                            if ('number' !== data6.type) {
                                                const err6 = {};
                                                if (vErrors === null) {
                                                    vErrors = [err6];
                                                }
                                                else {
                                                    vErrors.push(err6);
                                                }
                                                errors++;
                                            }
                                        }
                                    }
                                    var _valid2 = _errs22 === errors;
                                    errors = _errs21;
                                    if (vErrors !== null) {
                                        if (_errs21) {
                                            vErrors.length = _errs21;
                                        }
                                        else {
                                            vErrors = null;
                                        }
                                    }
                                    let ifClause1;
                                    if (_valid2) {
                                        const _errs24 = errors;
                                        if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                            if (data6.value !== undefined) {
                                                if (!(typeof data6.value == 'number')) {
                                                    validate120.errors = [
                                                        {
                                                            instancePath: instancePath + '/metrics/' + i0 + '/value',
                                                            schemaPath: 'urn:wisepipe-base-computation:Metric/then/properties/value/type',
                                                            keyword: 'type',
                                                            params: { type: 'number' },
                                                            message: 'must be number'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        var _valid2 = _errs24 === errors;
                                        valid11 = _valid2;
                                        ifClause1 = 'then';
                                    }
                                    else {
                                        const _errs27 = errors;
                                        const _errs28 = errors;
                                        let valid14 = true;
                                        const _errs29 = errors;
                                        if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                            if (data6.type !== undefined) {
                                                if ('string' !== data6.type) {
                                                    const err7 = {};
                                                    if (vErrors === null) {
                                                        vErrors = [err7];
                                                    }
                                                    else {
                                                        vErrors.push(err7);
                                                    }
                                                    errors++;
                                                }
                                            }
                                        }
                                        var _valid3 = _errs29 === errors;
                                        errors = _errs28;
                                        if (vErrors !== null) {
                                            if (_errs28) {
                                                vErrors.length = _errs28;
                                            }
                                            else {
                                                vErrors = null;
                                            }
                                        }
                                        let ifClause2;
                                        if (_valid3) {
                                            const _errs31 = errors;
                                            if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                                if (data6.value !== undefined) {
                                                    if (typeof data6.value !== 'string') {
                                                        validate120.errors = [
                                                            {
                                                                instancePath: instancePath + '/metrics/' + i0 + '/value',
                                                                schemaPath: 'urn:wisepipe-base-computation:Metric/else/then/properties/value/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                            var _valid3 = _errs31 === errors;
                                            valid14 = _valid3;
                                            ifClause2 = 'then';
                                        }
                                        else {
                                            const _errs34 = errors;
                                            const _errs35 = errors;
                                            let valid17 = true;
                                            const _errs36 = errors;
                                            if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                                if (data6.type !== undefined) {
                                                    if ('boolean' !== data6.type) {
                                                        const err8 = {};
                                                        if (vErrors === null) {
                                                            vErrors = [err8];
                                                        }
                                                        else {
                                                            vErrors.push(err8);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                            }
                                            var _valid4 = _errs36 === errors;
                                            errors = _errs35;
                                            if (vErrors !== null) {
                                                if (_errs35) {
                                                    vErrors.length = _errs35;
                                                }
                                                else {
                                                    vErrors = null;
                                                }
                                            }
                                            if (_valid4) {
                                                const _errs38 = errors;
                                                if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                                    if (data6.value !== undefined) {
                                                        if (typeof data6.value !== 'boolean') {
                                                            validate120.errors = [
                                                                {
                                                                    instancePath: instancePath + '/metrics/' + i0 + '/value',
                                                                    schemaPath: 'urn:wisepipe-base-computation:Metric/else/else/then/properties/value/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'boolean' },
                                                                    message: 'must be boolean'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                                var _valid4 = _errs38 === errors;
                                                valid17 = _valid4;
                                            }
                                            if (!valid17) {
                                                const err9 = {
                                                    instancePath: instancePath + '/metrics/' + i0,
                                                    schemaPath: 'urn:wisepipe-base-computation:Metric/else/else/if',
                                                    keyword: 'if',
                                                    params: { failingKeyword: 'then' },
                                                    message: 'must match "then" schema'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err9];
                                                }
                                                else {
                                                    vErrors.push(err9);
                                                }
                                                errors++;
                                                validate120.errors = vErrors;
                                                return false;
                                            }
                                            var _valid3 = _errs34 === errors;
                                            valid14 = _valid3;
                                            ifClause2 = 'else';
                                        }
                                        if (!valid14) {
                                            const err10 = {
                                                instancePath: instancePath + '/metrics/' + i0,
                                                schemaPath: 'urn:wisepipe-base-computation:Metric/else/if',
                                                keyword: 'if',
                                                params: { failingKeyword: ifClause2 },
                                                message: 'must match "' + ifClause2 + '" schema'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err10];
                                            }
                                            else {
                                                vErrors.push(err10);
                                            }
                                            errors++;
                                            validate120.errors = vErrors;
                                            return false;
                                        }
                                        var _valid2 = _errs27 === errors;
                                        valid11 = _valid2;
                                        ifClause1 = 'else';
                                    }
                                    if (!valid11) {
                                        const err11 = {
                                            instancePath: instancePath + '/metrics/' + i0,
                                            schemaPath: 'urn:wisepipe-base-computation:Metric/if',
                                            keyword: 'if',
                                            params: { failingKeyword: ifClause1 },
                                            message: 'must match "' + ifClause1 + '" schema'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err11];
                                        }
                                        else {
                                            vErrors.push(err11);
                                        }
                                        errors++;
                                        validate120.errors = vErrors;
                                        return false;
                                    }
                                    if (errors === _errs19) {
                                        if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                            let missing5;
                                            if ((data6.elementID === undefined && (missing5 = 'elementID')) ||
                                                (data6.name === undefined && (missing5 = 'name')) ||
                                                (data6.type === undefined && (missing5 = 'type')) ||
                                                (data6.value === undefined && (missing5 = 'value')) ||
                                                (data6.timestamp === undefined && (missing5 = 'timestamp'))) {
                                                validate120.errors = [
                                                    {
                                                        instancePath: instancePath + '/metrics/' + i0,
                                                        schemaPath: 'urn:wisepipe-base-computation:Metric/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing5 },
                                                        message: "must have required property '" + missing5 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data6.elementID !== undefined) {
                                                    let data13 = data6.elementID;
                                                    const _errs41 = errors;
                                                    if (errors === _errs41) {
                                                        if (typeof data13 === 'string') {
                                                            const b64min2 = Math.ceil((4 * 10) / 3);
                                                            const b64max2 = Math.ceil((4 * 10) / 3) + 3;
                                                            if (func240(data13) < b64min2 || func240(data13) > b64max2) {
                                                                validate120.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/metrics/' + i0 + '/elementID',
                                                                        schemaPath: 'urn:wisepipe-base-computation:Metric/properties/elementID/uid',
                                                                        keyword: 'uid',
                                                                        params: {
                                                                            error: 'encoded',
                                                                            b64min: b64min2,
                                                                            b64max: b64max2,
                                                                            length: func240(data13)
                                                                        },
                                                                        message: 'length must be between ' +
                                                                            b64min2 +
                                                                            ' and ' +
                                                                            b64max2 +
                                                                            ', but is ' +
                                                                            func240(data13)
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                const decoded2 = func241(data13);
                                                                if (decoded2.length !== 10) {
                                                                    validate120.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/metrics/' + i0 + '/elementID',
                                                                            schemaPath: 'urn:wisepipe-base-computation:Metric/properties/elementID/uid',
                                                                            keyword: 'uid',
                                                                            params: { error: 'decoded' },
                                                                            message: 'must decode to 10 bytes'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    const encoded2 = func242(decoded2);
                                                                    if (func243(encoded2) !== func243(data13)) {
                                                                        validate120.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/metrics/' + i0 + '/elementID',
                                                                                schemaPath: 'urn:wisepipe-base-computation:Metric/properties/elementID/uid',
                                                                                keyword: 'uid',
                                                                                params: { error: 'ambiguous' },
                                                                                message: 'encoding is ambiguous'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate120.errors = [
                                                                {
                                                                    instancePath: instancePath + '/metrics/' + i0 + '/elementID',
                                                                    schemaPath: 'urn:wisepipe-base-computation:Metric/properties/elementID/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid20 = _errs41 === errors;
                                                }
                                                else {
                                                    var valid20 = true;
                                                }
                                                if (valid20) {
                                                    if (data6.name !== undefined) {
                                                        let data14 = data6.name;
                                                        const _errs43 = errors;
                                                        if (errors === _errs43) {
                                                            if (typeof data14 === 'string') {
                                                                if (func2(data14) > 100) {
                                                                    validate120.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/metrics/' + i0 + '/name',
                                                                            schemaPath: 'urn:wisepipe-base-computation:Metric/properties/name/maxLength',
                                                                            keyword: 'maxLength',
                                                                            params: { limit: 100 },
                                                                            message: 'must NOT have more than 100 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    if (func2(data14) < 1) {
                                                                        validate120.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/metrics/' + i0 + '/name',
                                                                                schemaPath: 'urn:wisepipe-base-computation:Metric/properties/name/minLength',
                                                                                keyword: 'minLength',
                                                                                params: { limit: 1 },
                                                                                message: 'must NOT have fewer than 1 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate120.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/metrics/' + i0 + '/name',
                                                                        schemaPath: 'urn:wisepipe-base-computation:Metric/properties/name/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid20 = _errs43 === errors;
                                                    }
                                                    else {
                                                        var valid20 = true;
                                                    }
                                                    if (valid20) {
                                                        if (data6.type !== undefined) {
                                                            let data15 = data6.type;
                                                            const _errs45 = errors;
                                                            if (typeof data15 !== 'string') {
                                                                validate120.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/metrics/' + i0 + '/type',
                                                                        schemaPath: 'urn:wisepipe-base-computation:Metric/properties/type/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            if (!(data15 === 'number' || data15 === 'string' || data15 === 'boolean')) {
                                                                validate120.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/metrics/' + i0 + '/type',
                                                                        schemaPath: 'urn:wisepipe-base-computation:Metric/properties/type/enum',
                                                                        keyword: 'enum',
                                                                        params: { allowedValues: schema128.properties.type.enum },
                                                                        message: 'must be equal to one of the allowed values'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid20 = _errs45 === errors;
                                                        }
                                                        else {
                                                            var valid20 = true;
                                                        }
                                                        if (valid20) {
                                                            if (data6.timestamp !== undefined) {
                                                                let data16 = data6.timestamp;
                                                                const _errs47 = errors;
                                                                if (errors === _errs47) {
                                                                    if (errors === _errs47) {
                                                                        if (typeof data16 === 'string') {
                                                                            if (!formats0.validate(data16)) {
                                                                                validate120.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/metrics/' + i0 + '/timestamp',
                                                                                        schemaPath: 'urn:wisepipe-base-computation:Metric/properties/timestamp/format',
                                                                                        keyword: 'format',
                                                                                        params: { format: 'date-time' },
                                                                                        message: 'must match format "' + 'date-time' + '"'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate120.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/metrics/' + i0 + '/timestamp',
                                                                                    schemaPath: 'urn:wisepipe-base-computation:Metric/properties/timestamp/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                }
                                                                var valid20 = _errs47 === errors;
                                                            }
                                                            else {
                                                                var valid20 = true;
                                                            }
                                                            if (valid20) {
                                                                if (data6.reason !== undefined) {
                                                                    const _errs49 = errors;
                                                                    if (typeof data6.reason !== 'string') {
                                                                        validate120.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/metrics/' + i0 + '/reason',
                                                                                schemaPath: 'urn:wisepipe-base-computation:Metric/properties/reason/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid20 = _errs49 === errors;
                                                                }
                                                                else {
                                                                    var valid20 = true;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate120.errors = [
                                                {
                                                    instancePath: instancePath + '/metrics/' + i0,
                                                    schemaPath: 'urn:wisepipe-base-computation:Metric/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid9 = _errs18 === errors;
                                    if (!valid9) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate120.errors = [
                                    {
                                        instancePath: instancePath + '/metrics',
                                        schemaPath: '#/properties/metrics/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid8 = _errs16 === errors;
                    }
                    else {
                        var valid8 = true;
                    }
                }
            }
        }
        else {
            validate120.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate120.errors = vErrors;
    return errors === 0;
}
export const monteCarloResultVariableStatsSchemaValidation = validate121;
const schema131 = {
    $id: 'urn:wisepipe-common-computation:MonteCarloResultVariableStats',
    type: 'object',
    properties: {
        columnName: { type: 'string', minLength: 1 },
        histogram: {
            type: 'object',
            properties: {
                binCount: { type: 'array', items: { type: 'number' }, minItems: 1 },
                binEdges: { type: 'array', items: { type: 'number' }, minItems: 1 }
            }
        },
        percentiles: { type: 'array', items: { type: 'number' }, minItems: 1 },
        confidenceInterval95: { type: 'object', properties: { lower: { type: 'number' }, upper: { type: 'number' } } },
        mean: { type: 'number' },
        median: { type: 'number' },
        min: { type: 'number' },
        max: { type: 'number' },
        std: { type: 'number' },
        Q1: { type: 'number' },
        Q3: { type: 'number' }
    },
    required: [
        'columnName',
        'histogram',
        'percentiles',
        'confidenceInterval95',
        'mean',
        'median',
        'min',
        'max',
        'std',
        'Q1',
        'Q3'
    ]
};
function validate121(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:MonteCarloResultVariableStats" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.columnName === undefined && (missing0 = 'columnName')) ||
                (data.histogram === undefined && (missing0 = 'histogram')) ||
                (data.percentiles === undefined && (missing0 = 'percentiles')) ||
                (data.confidenceInterval95 === undefined && (missing0 = 'confidenceInterval95')) ||
                (data.mean === undefined && (missing0 = 'mean')) ||
                (data.median === undefined && (missing0 = 'median')) ||
                (data.min === undefined && (missing0 = 'min')) ||
                (data.max === undefined && (missing0 = 'max')) ||
                (data.std === undefined && (missing0 = 'std')) ||
                (data.Q1 === undefined && (missing0 = 'Q1')) ||
                (data.Q3 === undefined && (missing0 = 'Q3'))) {
                validate121.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columnName !== undefined) {
                    let data0 = data.columnName;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate121.errors = [
                                    {
                                        instancePath: instancePath + '/columnName',
                                        schemaPath: '#/properties/columnName/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate121.errors = [
                                {
                                    instancePath: instancePath + '/columnName',
                                    schemaPath: '#/properties/columnName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.histogram !== undefined) {
                        let data1 = data.histogram;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                if (data1.binCount !== undefined) {
                                    let data2 = data1.binCount;
                                    const _errs5 = errors;
                                    if (errors === _errs5) {
                                        if (Array.isArray(data2)) {
                                            if (data2.length < 1) {
                                                validate121.errors = [
                                                    {
                                                        instancePath: instancePath + '/histogram/binCount',
                                                        schemaPath: '#/properties/histogram/properties/binCount/minItems',
                                                        keyword: 'minItems',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 items'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                var valid2 = true;
                                                const len0 = data2.length;
                                                for (let i0 = 0; i0 < len0; i0++) {
                                                    const _errs7 = errors;
                                                    if (!(typeof data2[i0] == 'number')) {
                                                        validate121.errors = [
                                                            {
                                                                instancePath: instancePath + '/histogram/binCount/' + i0,
                                                                schemaPath: '#/properties/histogram/properties/binCount/items/type',
                                                                keyword: 'type',
                                                                params: { type: 'number' },
                                                                message: 'must be number'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid2 = _errs7 === errors;
                                                    if (!valid2) {
                                                        break;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate121.errors = [
                                                {
                                                    instancePath: instancePath + '/histogram/binCount',
                                                    schemaPath: '#/properties/histogram/properties/binCount/type',
                                                    keyword: 'type',
                                                    params: { type: 'array' },
                                                    message: 'must be array'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs5 === errors;
                                }
                                else {
                                    var valid1 = true;
                                }
                                if (valid1) {
                                    if (data1.binEdges !== undefined) {
                                        let data4 = data1.binEdges;
                                        const _errs9 = errors;
                                        if (errors === _errs9) {
                                            if (Array.isArray(data4)) {
                                                if (data4.length < 1) {
                                                    validate121.errors = [
                                                        {
                                                            instancePath: instancePath + '/histogram/binEdges',
                                                            schemaPath: '#/properties/histogram/properties/binEdges/minItems',
                                                            keyword: 'minItems',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 items'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    var valid3 = true;
                                                    const len1 = data4.length;
                                                    for (let i1 = 0; i1 < len1; i1++) {
                                                        const _errs11 = errors;
                                                        if (!(typeof data4[i1] == 'number')) {
                                                            validate121.errors = [
                                                                {
                                                                    instancePath: instancePath + '/histogram/binEdges/' + i1,
                                                                    schemaPath: '#/properties/histogram/properties/binEdges/items/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'number' },
                                                                    message: 'must be number'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid3 = _errs11 === errors;
                                                        if (!valid3) {
                                                            break;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate121.errors = [
                                                    {
                                                        instancePath: instancePath + '/histogram/binEdges',
                                                        schemaPath: '#/properties/histogram/properties/binEdges/type',
                                                        keyword: 'type',
                                                        params: { type: 'array' },
                                                        message: 'must be array'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid1 = _errs9 === errors;
                                    }
                                    else {
                                        var valid1 = true;
                                    }
                                }
                            }
                            else {
                                validate121.errors = [
                                    {
                                        instancePath: instancePath + '/histogram',
                                        schemaPath: '#/properties/histogram/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.percentiles !== undefined) {
                            let data6 = data.percentiles;
                            const _errs13 = errors;
                            if (errors === _errs13) {
                                if (Array.isArray(data6)) {
                                    if (data6.length < 1) {
                                        validate121.errors = [
                                            {
                                                instancePath: instancePath + '/percentiles',
                                                schemaPath: '#/properties/percentiles/minItems',
                                                keyword: 'minItems',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 items'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        var valid4 = true;
                                        const len2 = data6.length;
                                        for (let i2 = 0; i2 < len2; i2++) {
                                            const _errs15 = errors;
                                            if (!(typeof data6[i2] == 'number')) {
                                                validate121.errors = [
                                                    {
                                                        instancePath: instancePath + '/percentiles/' + i2,
                                                        schemaPath: '#/properties/percentiles/items/type',
                                                        keyword: 'type',
                                                        params: { type: 'number' },
                                                        message: 'must be number'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid4 = _errs15 === errors;
                                            if (!valid4) {
                                                break;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate121.errors = [
                                        {
                                            instancePath: instancePath + '/percentiles',
                                            schemaPath: '#/properties/percentiles/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs13 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.confidenceInterval95 !== undefined) {
                                let data8 = data.confidenceInterval95;
                                const _errs17 = errors;
                                if (errors === _errs17) {
                                    if (data8 && typeof data8 == 'object' && !Array.isArray(data8)) {
                                        if (data8.lower !== undefined) {
                                            const _errs19 = errors;
                                            if (!(typeof data8.lower == 'number')) {
                                                validate121.errors = [
                                                    {
                                                        instancePath: instancePath + '/confidenceInterval95/lower',
                                                        schemaPath: '#/properties/confidenceInterval95/properties/lower/type',
                                                        keyword: 'type',
                                                        params: { type: 'number' },
                                                        message: 'must be number'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid5 = _errs19 === errors;
                                        }
                                        else {
                                            var valid5 = true;
                                        }
                                        if (valid5) {
                                            if (data8.upper !== undefined) {
                                                const _errs21 = errors;
                                                if (!(typeof data8.upper == 'number')) {
                                                    validate121.errors = [
                                                        {
                                                            instancePath: instancePath + '/confidenceInterval95/upper',
                                                            schemaPath: '#/properties/confidenceInterval95/properties/upper/type',
                                                            keyword: 'type',
                                                            params: { type: 'number' },
                                                            message: 'must be number'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid5 = _errs21 === errors;
                                            }
                                            else {
                                                var valid5 = true;
                                            }
                                        }
                                    }
                                    else {
                                        validate121.errors = [
                                            {
                                                instancePath: instancePath + '/confidenceInterval95',
                                                schemaPath: '#/properties/confidenceInterval95/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs17 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.mean !== undefined) {
                                    const _errs23 = errors;
                                    if (!(typeof data.mean == 'number')) {
                                        validate121.errors = [
                                            {
                                                instancePath: instancePath + '/mean',
                                                schemaPath: '#/properties/mean/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs23 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.median !== undefined) {
                                        const _errs25 = errors;
                                        if (!(typeof data.median == 'number')) {
                                            validate121.errors = [
                                                {
                                                    instancePath: instancePath + '/median',
                                                    schemaPath: '#/properties/median/type',
                                                    keyword: 'type',
                                                    params: { type: 'number' },
                                                    message: 'must be number'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs25 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.min !== undefined) {
                                            const _errs27 = errors;
                                            if (!(typeof data.min == 'number')) {
                                                validate121.errors = [
                                                    {
                                                        instancePath: instancePath + '/min',
                                                        schemaPath: '#/properties/min/type',
                                                        keyword: 'type',
                                                        params: { type: 'number' },
                                                        message: 'must be number'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs27 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.max !== undefined) {
                                                const _errs29 = errors;
                                                if (!(typeof data.max == 'number')) {
                                                    validate121.errors = [
                                                        {
                                                            instancePath: instancePath + '/max',
                                                            schemaPath: '#/properties/max/type',
                                                            keyword: 'type',
                                                            params: { type: 'number' },
                                                            message: 'must be number'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid0 = _errs29 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.std !== undefined) {
                                                    const _errs31 = errors;
                                                    if (!(typeof data.std == 'number')) {
                                                        validate121.errors = [
                                                            {
                                                                instancePath: instancePath + '/std',
                                                                schemaPath: '#/properties/std/type',
                                                                keyword: 'type',
                                                                params: { type: 'number' },
                                                                message: 'must be number'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid0 = _errs31 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.Q1 !== undefined) {
                                                        const _errs33 = errors;
                                                        if (!(typeof data.Q1 == 'number')) {
                                                            validate121.errors = [
                                                                {
                                                                    instancePath: instancePath + '/Q1',
                                                                    schemaPath: '#/properties/Q1/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'number' },
                                                                    message: 'must be number'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid0 = _errs33 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (data.Q3 !== undefined) {
                                                            const _errs35 = errors;
                                                            if (!(typeof data.Q3 == 'number')) {
                                                                validate121.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/Q3',
                                                                        schemaPath: '#/properties/Q3/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'number' },
                                                                        message: 'must be number'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid0 = _errs35 === errors;
                                                        }
                                                        else {
                                                            var valid0 = true;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate121.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate121.errors = vErrors;
    return errors === 0;
}
export const monteCarloStatsSchemaValidation = validate122;
const schema132 = {
    $id: 'urn:wisepipe-common-computation:MonteCarloStats',
    type: 'object',
    properties: {
        elementID: { type: 'string', uid: 10 },
        data: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    scenarioName: { type: 'string', minimum: 1 },
                    resultVariables: {
                        type: 'array',
                        items: {
                            type: 'object',
                            properties: {
                                name: { type: 'string', minLength: 1 },
                                type: { type: 'string', minLength: 1 },
                                stats: {
                                    type: 'array',
                                    items: { $ref: 'urn:wisepipe-common-computation:MonteCarloResultVariableStats' },
                                    minItems: 1
                                }
                            }
                        },
                        minItems: 1
                    }
                }
            },
            minItems: 1
        },
        timestamp: { type: 'string', format: 'date-time' }
    },
    required: ['elementID', 'data', 'timestamp']
};
const func247 = ucs2length;
const func248 = base64urlToBuffer;
const func249 = base64urlEncode;
const func250 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate122(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:MonteCarloStats" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.elementID === undefined && (missing0 = 'elementID')) ||
                (data.data === undefined && (missing0 = 'data')) ||
                (data.timestamp === undefined && (missing0 = 'timestamp'))) {
                validate122.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.elementID !== undefined) {
                    let data0 = data.elementID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func247(data0) < b64min0 || func247(data0) > b64max0) {
                                validate122.errors = [
                                    {
                                        instancePath: instancePath + '/elementID',
                                        schemaPath: '#/properties/elementID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func247(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func247(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func248(data0);
                                if (decoded0.length !== 10) {
                                    validate122.errors = [
                                        {
                                            instancePath: instancePath + '/elementID',
                                            schemaPath: '#/properties/elementID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func249(decoded0);
                                    if (func250(encoded0) !== func250(data0)) {
                                        validate122.errors = [
                                            {
                                                instancePath: instancePath + '/elementID',
                                                schemaPath: '#/properties/elementID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate122.errors = [
                                {
                                    instancePath: instancePath + '/elementID',
                                    schemaPath: '#/properties/elementID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.data !== undefined) {
                        let data1 = data.data;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                if (data1.length < 1) {
                                    validate122.errors = [
                                        {
                                            instancePath: instancePath + '/data',
                                            schemaPath: '#/properties/data/minItems',
                                            keyword: 'minItems',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid2 = true;
                                    const len0 = data1.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data2 = data1[i0];
                                        const _errs5 = errors;
                                        if (errors === _errs5) {
                                            if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                                if (data2.scenarioName !== undefined) {
                                                    let data3 = data2.scenarioName;
                                                    const _errs7 = errors;
                                                    if (typeof data3 !== 'string') {
                                                        validate122.errors = [
                                                            {
                                                                instancePath: instancePath + '/data/' + i0 + '/scenarioName',
                                                                schemaPath: '#/properties/data/items/properties/scenarioName/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    if (errors === _errs7) {
                                                        if (typeof data3 == 'number') {
                                                            if (data3 < 1 || isNaN(data3)) {
                                                                validate122.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/data/' + i0 + '/scenarioName',
                                                                        schemaPath: '#/properties/data/items/properties/scenarioName/minimum',
                                                                        keyword: 'minimum',
                                                                        params: { comparison: '>=', limit: 1 },
                                                                        message: 'must be >= 1'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                    }
                                                    var valid3 = _errs7 === errors;
                                                }
                                                else {
                                                    var valid3 = true;
                                                }
                                                if (valid3) {
                                                    if (data2.resultVariables !== undefined) {
                                                        let data4 = data2.resultVariables;
                                                        const _errs9 = errors;
                                                        if (errors === _errs9) {
                                                            if (Array.isArray(data4)) {
                                                                if (data4.length < 1) {
                                                                    validate122.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/data/' + i0 + '/resultVariables',
                                                                            schemaPath: '#/properties/data/items/properties/resultVariables/minItems',
                                                                            keyword: 'minItems',
                                                                            params: { limit: 1 },
                                                                            message: 'must NOT have fewer than 1 items'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    var valid4 = true;
                                                                    const len1 = data4.length;
                                                                    for (let i1 = 0; i1 < len1; i1++) {
                                                                        let data5 = data4[i1];
                                                                        const _errs11 = errors;
                                                                        if (errors === _errs11) {
                                                                            if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                                                                if (data5.name !== undefined) {
                                                                                    let data6 = data5.name;
                                                                                    const _errs13 = errors;
                                                                                    if (errors === _errs13) {
                                                                                        if (typeof data6 === 'string') {
                                                                                            if (func2(data6) < 1) {
                                                                                                validate122.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/data/' + i0 + '/resultVariables/' + i1 + '/name',
                                                                                                        schemaPath: '#/properties/data/items/properties/resultVariables/items/properties/name/minLength',
                                                                                                        keyword: 'minLength',
                                                                                                        params: { limit: 1 },
                                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        else {
                                                                                            validate122.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/data/' + i0 + '/resultVariables/' + i1 + '/name',
                                                                                                    schemaPath: '#/properties/data/items/properties/resultVariables/items/properties/name/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'string' },
                                                                                                    message: 'must be string'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    var valid5 = _errs13 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid5 = true;
                                                                                }
                                                                                if (valid5) {
                                                                                    if (data5.type !== undefined) {
                                                                                        let data7 = data5.type;
                                                                                        const _errs15 = errors;
                                                                                        if (errors === _errs15) {
                                                                                            if (typeof data7 === 'string') {
                                                                                                if (func2(data7) < 1) {
                                                                                                    validate122.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath +
                                                                                                                '/data/' +
                                                                                                                i0 +
                                                                                                                '/resultVariables/' +
                                                                                                                i1 +
                                                                                                                '/type',
                                                                                                            schemaPath: '#/properties/data/items/properties/resultVariables/items/properties/type/minLength',
                                                                                                            keyword: 'minLength',
                                                                                                            params: { limit: 1 },
                                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            else {
                                                                                                validate122.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/data/' + i0 + '/resultVariables/' + i1 + '/type',
                                                                                                        schemaPath: '#/properties/data/items/properties/resultVariables/items/properties/type/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'string' },
                                                                                                        message: 'must be string'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        var valid5 = _errs15 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid5 = true;
                                                                                    }
                                                                                    if (valid5) {
                                                                                        if (data5.stats !== undefined) {
                                                                                            let data8 = data5.stats;
                                                                                            const _errs17 = errors;
                                                                                            if (errors === _errs17) {
                                                                                                if (Array.isArray(data8)) {
                                                                                                    if (data8.length < 1) {
                                                                                                        validate122.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath +
                                                                                                                    '/data/' +
                                                                                                                    i0 +
                                                                                                                    '/resultVariables/' +
                                                                                                                    i1 +
                                                                                                                    '/stats',
                                                                                                                schemaPath: '#/properties/data/items/properties/resultVariables/items/properties/stats/minItems',
                                                                                                                keyword: 'minItems',
                                                                                                                params: { limit: 1 },
                                                                                                                message: 'must NOT have fewer than 1 items'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    else {
                                                                                                        var valid6 = true;
                                                                                                        const len2 = data8.length;
                                                                                                        for (let i2 = 0; i2 < len2; i2++) {
                                                                                                            let data9 = data8[i2];
                                                                                                            const _errs19 = errors;
                                                                                                            const _errs20 = errors;
                                                                                                            if (errors === _errs20) {
                                                                                                                if (data9 &&
                                                                                                                    typeof data9 == 'object' &&
                                                                                                                    !Array.isArray(data9)) {
                                                                                                                    let missing1;
                                                                                                                    if ((data9.columnName === undefined &&
                                                                                                                        (missing1 = 'columnName')) ||
                                                                                                                        (data9.histogram === undefined &&
                                                                                                                            (missing1 = 'histogram')) ||
                                                                                                                        (data9.percentiles === undefined &&
                                                                                                                            (missing1 = 'percentiles')) ||
                                                                                                                        (data9.confidenceInterval95 === undefined &&
                                                                                                                            (missing1 = 'confidenceInterval95')) ||
                                                                                                                        (data9.mean === undefined && (missing1 = 'mean')) ||
                                                                                                                        (data9.median === undefined && (missing1 = 'median')) ||
                                                                                                                        (data9.min === undefined && (missing1 = 'min')) ||
                                                                                                                        (data9.max === undefined && (missing1 = 'max')) ||
                                                                                                                        (data9.std === undefined && (missing1 = 'std')) ||
                                                                                                                        (data9.Q1 === undefined && (missing1 = 'Q1')) ||
                                                                                                                        (data9.Q3 === undefined && (missing1 = 'Q3'))) {
                                                                                                                        validate122.errors = [
                                                                                                                            {
                                                                                                                                instancePath: instancePath +
                                                                                                                                    '/data/' +
                                                                                                                                    i0 +
                                                                                                                                    '/resultVariables/' +
                                                                                                                                    i1 +
                                                                                                                                    '/stats/' +
                                                                                                                                    i2,
                                                                                                                                schemaPath: 'urn:wisepipe-common-computation:MonteCarloResultVariableStats/required',
                                                                                                                                keyword: 'required',
                                                                                                                                params: { missingProperty: missing1 },
                                                                                                                                message: "must have required property '" + missing1 + "'"
                                                                                                                            }
                                                                                                                        ];
                                                                                                                        return false;
                                                                                                                    }
                                                                                                                    else {
                                                                                                                        if (data9.columnName !== undefined) {
                                                                                                                            let data10 = data9.columnName;
                                                                                                                            const _errs22 = errors;
                                                                                                                            if (errors === _errs22) {
                                                                                                                                if (typeof data10 === 'string') {
                                                                                                                                    if (func2(data10) < 1) {
                                                                                                                                        validate122.errors = [
                                                                                                                                            {
                                                                                                                                                instancePath: instancePath +
                                                                                                                                                    '/data/' +
                                                                                                                                                    i0 +
                                                                                                                                                    '/resultVariables/' +
                                                                                                                                                    i1 +
                                                                                                                                                    '/stats/' +
                                                                                                                                                    i2 +
                                                                                                                                                    '/columnName',
                                                                                                                                                schemaPath: 'urn:wisepipe-common-computation:MonteCarloResultVariableStats/properties/columnName/minLength',
                                                                                                                                                keyword: 'minLength',
                                                                                                                                                params: { limit: 1 },
                                                                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                                                                            }
                                                                                                                                        ];
                                                                                                                                        return false;
                                                                                                                                    }
                                                                                                                                }
                                                                                                                                else {
                                                                                                                                    validate122.errors = [
                                                                                                                                        {
                                                                                                                                            instancePath: instancePath +
                                                                                                                                                '/data/' +
                                                                                                                                                i0 +
                                                                                                                                                '/resultVariables/' +
                                                                                                                                                i1 +
                                                                                                                                                '/stats/' +
                                                                                                                                                i2 +
                                                                                                                                                '/columnName',
                                                                                                                                            schemaPath: 'urn:wisepipe-common-computation:MonteCarloResultVariableStats/properties/columnName/type',
                                                                                                                                            keyword: 'type',
                                                                                                                                            params: { type: 'string' },
                                                                                                                                            message: 'must be string'
                                                                                                                                        }
                                                                                                                                    ];
                                                                                                                                    return false;
                                                                                                                                }
                                                                                                                            }
                                                                                                                            var valid8 = _errs22 === errors;
                                                                                                                        }
                                                                                                                        else {
                                                                                                                            var valid8 = true;
                                                                                                                        }
                                                                                                                        if (valid8) {
                                                                                                                            if (data9.histogram !== undefined) {
                                                                                                                                let data11 = data9.histogram;
                                                                                                                                const _errs24 = errors;
                                                                                                                                if (errors === _errs24) {
                                                                                                                                    if (data11 &&
                                                                                                                                        typeof data11 == 'object' &&
                                                                                                                                        !Array.isArray(data11)) {
                                                                                                                                        if (data11.binCount !== undefined) {
                                                                                                                                            let data12 = data11.binCount;
                                                                                                                                            const _errs26 = errors;
                                                                                                                                            if (errors === _errs26) {
                                                                                                                                                if (Array.isArray(data12)) {
                                                                                                                                                    if (data12.length < 1) {
                                                                                                                                                        validate122.errors = [
                                                                                                                                                            {
                                                                                                                                                                instancePath: instancePath +
                                                                                                                                                                    '/data/' +
                                                                                                                                                                    i0 +
                                                                                                                                                                    '/resultVariables/' +
                                                                                                                                                                    i1 +
                                                                                                                                                                    '/stats/' +
                                                                                                                                                                    i2 +
                                                                                                                                                                    '/histogram/binCount',
                                                                                                                                                                schemaPath: 'urn:wisepipe-common-computation:MonteCarloResultVariableStats/properties/histogram/properties/binCount/minItems',
                                                                                                                                                                keyword: 'minItems',
                                                                                                                                                                params: { limit: 1 },
                                                                                                                                                                message: 'must NOT have fewer than 1 items'
                                                                                                                                                            }
                                                                                                                                                        ];
                                                                                                                                                        return false;
                                                                                                                                                    }
                                                                                                                                                    else {
                                                                                                                                                        var valid10 = true;
                                                                                                                                                        const len3 = data12.length;
                                                                                                                                                        for (let i3 = 0; i3 < len3; i3++) {
                                                                                                                                                            const _errs28 = errors;
                                                                                                                                                            if (!(typeof data12[i3] == 'number')) {
                                                                                                                                                                validate122.errors = [
                                                                                                                                                                    {
                                                                                                                                                                        instancePath: instancePath +
                                                                                                                                                                            '/data/' +
                                                                                                                                                                            i0 +
                                                                                                                                                                            '/resultVariables/' +
                                                                                                                                                                            i1 +
                                                                                                                                                                            '/stats/' +
                                                                                                                                                                            i2 +
                                                                                                                                                                            '/histogram/binCount/' +
                                                                                                                                                                            i3,
                                                                                                                                                                        schemaPath: 'urn:wisepipe-common-computation:MonteCarloResultVariableStats/properties/histogram/properties/binCount/items/type',
                                                                                                                                                                        keyword: 'type',
                                                                                                                                                                        params: { type: 'number' },
                                                                                                                                                                        message: 'must be number'
                                                                                                                                                                    }
                                                                                                                                                                ];
                                                                                                                                                                return false;
                                                                                                                                                            }
                                                                                                                                                            var valid10 = _errs28 === errors;
                                                                                                                                                            if (!valid10) {
                                                                                                                                                                break;
                                                                                                                                                            }
                                                                                                                                                        }
                                                                                                                                                    }
                                                                                                                                                }
                                                                                                                                                else {
                                                                                                                                                    validate122.errors = [
                                                                                                                                                        {
                                                                                                                                                            instancePath: instancePath +
                                                                                                                                                                '/data/' +
                                                                                                                                                                i0 +
                                                                                                                                                                '/resultVariables/' +
                                                                                                                                                                i1 +
                                                                                                                                                                '/stats/' +
                                                                                                                                                                i2 +
                                                                                                                                                                '/histogram/binCount',
                                                                                                                                                            schemaPath: 'urn:wisepipe-common-computation:MonteCarloResultVariableStats/properties/histogram/properties/binCount/type',
                                                                                                                                                            keyword: 'type',
                                                                                                                                                            params: { type: 'array' },
                                                                                                                                                            message: 'must be array'
                                                                                                                                                        }
                                                                                                                                                    ];
                                                                                                                                                    return false;
                                                                                                                                                }
                                                                                                                                            }
                                                                                                                                            var valid9 = _errs26 === errors;
                                                                                                                                        }
                                                                                                                                        else {
                                                                                                                                            var valid9 = true;
                                                                                                                                        }
                                                                                                                                        if (valid9) {
                                                                                                                                            if (data11.binEdges !== undefined) {
                                                                                                                                                let data14 = data11.binEdges;
                                                                                                                                                const _errs30 = errors;
                                                                                                                                                if (errors === _errs30) {
                                                                                                                                                    if (Array.isArray(data14)) {
                                                                                                                                                        if (data14.length < 1) {
                                                                                                                                                            validate122.errors = [
                                                                                                                                                                {
                                                                                                                                                                    instancePath: instancePath +
                                                                                                                                                                        '/data/' +
                                                                                                                                                                        i0 +
                                                                                                                                                                        '/resultVariables/' +
                                                                                                                                                                        i1 +
                                                                                                                                                                        '/stats/' +
                                                                                                                                                                        i2 +
                                                                                                                                                                        '/histogram/binEdges',
                                                                                                                                                                    schemaPath: 'urn:wisepipe-common-computation:MonteCarloResultVariableStats/properties/histogram/properties/binEdges/minItems',
                                                                                                                                                                    keyword: 'minItems',
                                                                                                                                                                    params: { limit: 1 },
                                                                                                                                                                    message: 'must NOT have fewer than 1 items'
                                                                                                                                                                }
                                                                                                                                                            ];
                                                                                                                                                            return false;
                                                                                                                                                        }
                                                                                                                                                        else {
                                                                                                                                                            var valid11 = true;
                                                                                                                                                            const len4 = data14.length;
                                                                                                                                                            for (let i4 = 0; i4 < len4; i4++) {
                                                                                                                                                                const _errs32 = errors;
                                                                                                                                                                if (!(typeof data14[i4] == 'number')) {
                                                                                                                                                                    validate122.errors = [
                                                                                                                                                                        {
                                                                                                                                                                            instancePath: instancePath +
                                                                                                                                                                                '/data/' +
                                                                                                                                                                                i0 +
                                                                                                                                                                                '/resultVariables/' +
                                                                                                                                                                                i1 +
                                                                                                                                                                                '/stats/' +
                                                                                                                                                                                i2 +
                                                                                                                                                                                '/histogram/binEdges/' +
                                                                                                                                                                                i4,
                                                                                                                                                                            schemaPath: 'urn:wisepipe-common-computation:MonteCarloResultVariableStats/properties/histogram/properties/binEdges/items/type',
                                                                                                                                                                            keyword: 'type',
                                                                                                                                                                            params: { type: 'number' },
                                                                                                                                                                            message: 'must be number'
                                                                                                                                                                        }
                                                                                                                                                                    ];
                                                                                                                                                                    return false;
                                                                                                                                                                }
                                                                                                                                                                var valid11 = _errs32 === errors;
                                                                                                                                                                if (!valid11) {
                                                                                                                                                                    break;
                                                                                                                                                                }
                                                                                                                                                            }
                                                                                                                                                        }
                                                                                                                                                    }
                                                                                                                                                    else {
                                                                                                                                                        validate122.errors = [
                                                                                                                                                            {
                                                                                                                                                                instancePath: instancePath +
                                                                                                                                                                    '/data/' +
                                                                                                                                                                    i0 +
                                                                                                                                                                    '/resultVariables/' +
                                                                                                                                                                    i1 +
                                                                                                                                                                    '/stats/' +
                                                                                                                                                                    i2 +
                                                                                                                                                                    '/histogram/binEdges',
                                                                                                                                                                schemaPath: 'urn:wisepipe-common-computation:MonteCarloResultVariableStats/properties/histogram/properties/binEdges/type',
                                                                                                                                                                keyword: 'type',
                                                                                                                                                                params: { type: 'array' },
                                                                                                                                                                message: 'must be array'
                                                                                                                                                            }
                                                                                                                                                        ];
                                                                                                                                                        return false;
                                                                                                                                                    }
                                                                                                                                                }
                                                                                                                                                var valid9 = _errs30 === errors;
                                                                                                                                            }
                                                                                                                                            else {
                                                                                                                                                var valid9 = true;
                                                                                                                                            }
                                                                                                                                        }
                                                                                                                                    }
                                                                                                                                    else {
                                                                                                                                        validate122.errors = [
                                                                                                                                            {
                                                                                                                                                instancePath: instancePath +
                                                                                                                                                    '/data/' +
                                                                                                                                                    i0 +
                                                                                                                                                    '/resultVariables/' +
                                                                                                                                                    i1 +
                                                                                                                                                    '/stats/' +
                                                                                                                                                    i2 +
                                                                                                                                                    '/histogram',
                                                                                                                                                schemaPath: 'urn:wisepipe-common-computation:MonteCarloResultVariableStats/properties/histogram/type',
                                                                                                                                                keyword: 'type',
                                                                                                                                                params: { type: 'object' },
                                                                                                                                                message: 'must be object'
                                                                                                                                            }
                                                                                                                                        ];
                                                                                                                                        return false;
                                                                                                                                    }
                                                                                                                                }
                                                                                                                                var valid8 = _errs24 === errors;
                                                                                                                            }
                                                                                                                            else {
                                                                                                                                var valid8 = true;
                                                                                                                            }
                                                                                                                            if (valid8) {
                                                                                                                                if (data9.percentiles !== undefined) {
                                                                                                                                    let data16 = data9.percentiles;
                                                                                                                                    const _errs34 = errors;
                                                                                                                                    if (errors === _errs34) {
                                                                                                                                        if (Array.isArray(data16)) {
                                                                                                                                            if (data16.length < 1) {
                                                                                                                                                validate122.errors = [
                                                                                                                                                    {
                                                                                                                                                        instancePath: instancePath +
                                                                                                                                                            '/data/' +
                                                                                                                                                            i0 +
                                                                                                                                                            '/resultVariables/' +
                                                                                                                                                            i1 +
                                                                                                                                                            '/stats/' +
                                                                                                                                                            i2 +
                                                                                                                                                            '/percentiles',
                                                                                                                                                        schemaPath: 'urn:wisepipe-common-computation:MonteCarloResultVariableStats/properties/percentiles/minItems',
                                                                                                                                                        keyword: 'minItems',
                                                                                                                                                        params: { limit: 1 },
                                                                                                                                                        message: 'must NOT have fewer than 1 items'
                                                                                                                                                    }
                                                                                                                                                ];
                                                                                                                                                return false;
                                                                                                                                            }
                                                                                                                                            else {
                                                                                                                                                var valid12 = true;
                                                                                                                                                const len5 = data16.length;
                                                                                                                                                for (let i5 = 0; i5 < len5; i5++) {
                                                                                                                                                    const _errs36 = errors;
                                                                                                                                                    if (!(typeof data16[i5] == 'number')) {
                                                                                                                                                        validate122.errors = [
                                                                                                                                                            {
                                                                                                                                                                instancePath: instancePath +
                                                                                                                                                                    '/data/' +
                                                                                                                                                                    i0 +
                                                                                                                                                                    '/resultVariables/' +
                                                                                                                                                                    i1 +
                                                                                                                                                                    '/stats/' +
                                                                                                                                                                    i2 +
                                                                                                                                                                    '/percentiles/' +
                                                                                                                                                                    i5,
                                                                                                                                                                schemaPath: 'urn:wisepipe-common-computation:MonteCarloResultVariableStats/properties/percentiles/items/type',
                                                                                                                                                                keyword: 'type',
                                                                                                                                                                params: { type: 'number' },
                                                                                                                                                                message: 'must be number'
                                                                                                                                                            }
                                                                                                                                                        ];
                                                                                                                                                        return false;
                                                                                                                                                    }
                                                                                                                                                    var valid12 = _errs36 === errors;
                                                                                                                                                    if (!valid12) {
                                                                                                                                                        break;
                                                                                                                                                    }
                                                                                                                                                }
                                                                                                                                            }
                                                                                                                                        }
                                                                                                                                        else {
                                                                                                                                            validate122.errors = [
                                                                                                                                                {
                                                                                                                                                    instancePath: instancePath +
                                                                                                                                                        '/data/' +
                                                                                                                                                        i0 +
                                                                                                                                                        '/resultVariables/' +
                                                                                                                                                        i1 +
                                                                                                                                                        '/stats/' +
                                                                                                                                                        i2 +
                                                                                                                                                        '/percentiles',
                                                                                                                                                    schemaPath: 'urn:wisepipe-common-computation:MonteCarloResultVariableStats/properties/percentiles/type',
                                                                                                                                                    keyword: 'type',
                                                                                                                                                    params: { type: 'array' },
                                                                                                                                                    message: 'must be array'
                                                                                                                                                }
                                                                                                                                            ];
                                                                                                                                            return false;
                                                                                                                                        }
                                                                                                                                    }
                                                                                                                                    var valid8 = _errs34 === errors;
                                                                                                                                }
                                                                                                                                else {
                                                                                                                                    var valid8 = true;
                                                                                                                                }
                                                                                                                                if (valid8) {
                                                                                                                                    if (data9.confidenceInterval95 !== undefined) {
                                                                                                                                        let data18 = data9.confidenceInterval95;
                                                                                                                                        const _errs38 = errors;
                                                                                                                                        if (errors === _errs38) {
                                                                                                                                            if (data18 &&
                                                                                                                                                typeof data18 == 'object' &&
                                                                                                                                                !Array.isArray(data18)) {
                                                                                                                                                if (data18.lower !== undefined) {
                                                                                                                                                    const _errs40 = errors;
                                                                                                                                                    if (!(typeof data18.lower == 'number')) {
                                                                                                                                                        validate122.errors = [
                                                                                                                                                            {
                                                                                                                                                                instancePath: instancePath +
                                                                                                                                                                    '/data/' +
                                                                                                                                                                    i0 +
                                                                                                                                                                    '/resultVariables/' +
                                                                                                                                                                    i1 +
                                                                                                                                                                    '/stats/' +
                                                                                                                                                                    i2 +
                                                                                                                                                                    '/confidenceInterval95/lower',
                                                                                                                                                                schemaPath: 'urn:wisepipe-common-computation:MonteCarloResultVariableStats/properties/confidenceInterval95/properties/lower/type',
                                                                                                                                                                keyword: 'type',
                                                                                                                                                                params: { type: 'number' },
                                                                                                                                                                message: 'must be number'
                                                                                                                                                            }
                                                                                                                                                        ];
                                                                                                                                                        return false;
                                                                                                                                                    }
                                                                                                                                                    var valid13 = _errs40 === errors;
                                                                                                                                                }
                                                                                                                                                else {
                                                                                                                                                    var valid13 = true;
                                                                                                                                                }
                                                                                                                                                if (valid13) {
                                                                                                                                                    if (data18.upper !== undefined) {
                                                                                                                                                        const _errs42 = errors;
                                                                                                                                                        if (!(typeof data18.upper == 'number')) {
                                                                                                                                                            validate122.errors = [
                                                                                                                                                                {
                                                                                                                                                                    instancePath: instancePath +
                                                                                                                                                                        '/data/' +
                                                                                                                                                                        i0 +
                                                                                                                                                                        '/resultVariables/' +
                                                                                                                                                                        i1 +
                                                                                                                                                                        '/stats/' +
                                                                                                                                                                        i2 +
                                                                                                                                                                        '/confidenceInterval95/upper',
                                                                                                                                                                    schemaPath: 'urn:wisepipe-common-computation:MonteCarloResultVariableStats/properties/confidenceInterval95/properties/upper/type',
                                                                                                                                                                    keyword: 'type',
                                                                                                                                                                    params: { type: 'number' },
                                                                                                                                                                    message: 'must be number'
                                                                                                                                                                }
                                                                                                                                                            ];
                                                                                                                                                            return false;
                                                                                                                                                        }
                                                                                                                                                        var valid13 = _errs42 === errors;
                                                                                                                                                    }
                                                                                                                                                    else {
                                                                                                                                                        var valid13 = true;
                                                                                                                                                    }
                                                                                                                                                }
                                                                                                                                            }
                                                                                                                                            else {
                                                                                                                                                validate122.errors = [
                                                                                                                                                    {
                                                                                                                                                        instancePath: instancePath +
                                                                                                                                                            '/data/' +
                                                                                                                                                            i0 +
                                                                                                                                                            '/resultVariables/' +
                                                                                                                                                            i1 +
                                                                                                                                                            '/stats/' +
                                                                                                                                                            i2 +
                                                                                                                                                            '/confidenceInterval95',
                                                                                                                                                        schemaPath: 'urn:wisepipe-common-computation:MonteCarloResultVariableStats/properties/confidenceInterval95/type',
                                                                                                                                                        keyword: 'type',
                                                                                                                                                        params: { type: 'object' },
                                                                                                                                                        message: 'must be object'
                                                                                                                                                    }
                                                                                                                                                ];
                                                                                                                                                return false;
                                                                                                                                            }
                                                                                                                                        }
                                                                                                                                        var valid8 = _errs38 === errors;
                                                                                                                                    }
                                                                                                                                    else {
                                                                                                                                        var valid8 = true;
                                                                                                                                    }
                                                                                                                                    if (valid8) {
                                                                                                                                        if (data9.mean !== undefined) {
                                                                                                                                            const _errs44 = errors;
                                                                                                                                            if (!(typeof data9.mean == 'number')) {
                                                                                                                                                validate122.errors = [
                                                                                                                                                    {
                                                                                                                                                        instancePath: instancePath +
                                                                                                                                                            '/data/' +
                                                                                                                                                            i0 +
                                                                                                                                                            '/resultVariables/' +
                                                                                                                                                            i1 +
                                                                                                                                                            '/stats/' +
                                                                                                                                                            i2 +
                                                                                                                                                            '/mean',
                                                                                                                                                        schemaPath: 'urn:wisepipe-common-computation:MonteCarloResultVariableStats/properties/mean/type',
                                                                                                                                                        keyword: 'type',
                                                                                                                                                        params: { type: 'number' },
                                                                                                                                                        message: 'must be number'
                                                                                                                                                    }
                                                                                                                                                ];
                                                                                                                                                return false;
                                                                                                                                            }
                                                                                                                                            var valid8 = _errs44 === errors;
                                                                                                                                        }
                                                                                                                                        else {
                                                                                                                                            var valid8 = true;
                                                                                                                                        }
                                                                                                                                        if (valid8) {
                                                                                                                                            if (data9.median !== undefined) {
                                                                                                                                                const _errs46 = errors;
                                                                                                                                                if (!(typeof data9.median == 'number')) {
                                                                                                                                                    validate122.errors = [
                                                                                                                                                        {
                                                                                                                                                            instancePath: instancePath +
                                                                                                                                                                '/data/' +
                                                                                                                                                                i0 +
                                                                                                                                                                '/resultVariables/' +
                                                                                                                                                                i1 +
                                                                                                                                                                '/stats/' +
                                                                                                                                                                i2 +
                                                                                                                                                                '/median',
                                                                                                                                                            schemaPath: 'urn:wisepipe-common-computation:MonteCarloResultVariableStats/properties/median/type',
                                                                                                                                                            keyword: 'type',
                                                                                                                                                            params: { type: 'number' },
                                                                                                                                                            message: 'must be number'
                                                                                                                                                        }
                                                                                                                                                    ];
                                                                                                                                                    return false;
                                                                                                                                                }
                                                                                                                                                var valid8 = _errs46 === errors;
                                                                                                                                            }
                                                                                                                                            else {
                                                                                                                                                var valid8 = true;
                                                                                                                                            }
                                                                                                                                            if (valid8) {
                                                                                                                                                if (data9.min !== undefined) {
                                                                                                                                                    const _errs48 = errors;
                                                                                                                                                    if (!(typeof data9.min == 'number')) {
                                                                                                                                                        validate122.errors = [
                                                                                                                                                            {
                                                                                                                                                                instancePath: instancePath +
                                                                                                                                                                    '/data/' +
                                                                                                                                                                    i0 +
                                                                                                                                                                    '/resultVariables/' +
                                                                                                                                                                    i1 +
                                                                                                                                                                    '/stats/' +
                                                                                                                                                                    i2 +
                                                                                                                                                                    '/min',
                                                                                                                                                                schemaPath: 'urn:wisepipe-common-computation:MonteCarloResultVariableStats/properties/min/type',
                                                                                                                                                                keyword: 'type',
                                                                                                                                                                params: { type: 'number' },
                                                                                                                                                                message: 'must be number'
                                                                                                                                                            }
                                                                                                                                                        ];
                                                                                                                                                        return false;
                                                                                                                                                    }
                                                                                                                                                    var valid8 = _errs48 === errors;
                                                                                                                                                }
                                                                                                                                                else {
                                                                                                                                                    var valid8 = true;
                                                                                                                                                }
                                                                                                                                                if (valid8) {
                                                                                                                                                    if (data9.max !== undefined) {
                                                                                                                                                        const _errs50 = errors;
                                                                                                                                                        if (!(typeof data9.max == 'number')) {
                                                                                                                                                            validate122.errors = [
                                                                                                                                                                {
                                                                                                                                                                    instancePath: instancePath +
                                                                                                                                                                        '/data/' +
                                                                                                                                                                        i0 +
                                                                                                                                                                        '/resultVariables/' +
                                                                                                                                                                        i1 +
                                                                                                                                                                        '/stats/' +
                                                                                                                                                                        i2 +
                                                                                                                                                                        '/max',
                                                                                                                                                                    schemaPath: 'urn:wisepipe-common-computation:MonteCarloResultVariableStats/properties/max/type',
                                                                                                                                                                    keyword: 'type',
                                                                                                                                                                    params: { type: 'number' },
                                                                                                                                                                    message: 'must be number'
                                                                                                                                                                }
                                                                                                                                                            ];
                                                                                                                                                            return false;
                                                                                                                                                        }
                                                                                                                                                        var valid8 = _errs50 === errors;
                                                                                                                                                    }
                                                                                                                                                    else {
                                                                                                                                                        var valid8 = true;
                                                                                                                                                    }
                                                                                                                                                    if (valid8) {
                                                                                                                                                        if (data9.std !== undefined) {
                                                                                                                                                            const _errs52 = errors;
                                                                                                                                                            if (!(typeof data9.std == 'number')) {
                                                                                                                                                                validate122.errors = [
                                                                                                                                                                    {
                                                                                                                                                                        instancePath: instancePath +
                                                                                                                                                                            '/data/' +
                                                                                                                                                                            i0 +
                                                                                                                                                                            '/resultVariables/' +
                                                                                                                                                                            i1 +
                                                                                                                                                                            '/stats/' +
                                                                                                                                                                            i2 +
                                                                                                                                                                            '/std',
                                                                                                                                                                        schemaPath: 'urn:wisepipe-common-computation:MonteCarloResultVariableStats/properties/std/type',
                                                                                                                                                                        keyword: 'type',
                                                                                                                                                                        params: { type: 'number' },
                                                                                                                                                                        message: 'must be number'
                                                                                                                                                                    }
                                                                                                                                                                ];
                                                                                                                                                                return false;
                                                                                                                                                            }
                                                                                                                                                            var valid8 = _errs52 === errors;
                                                                                                                                                        }
                                                                                                                                                        else {
                                                                                                                                                            var valid8 = true;
                                                                                                                                                        }
                                                                                                                                                        if (valid8) {
                                                                                                                                                            if (data9.Q1 !== undefined) {
                                                                                                                                                                const _errs54 = errors;
                                                                                                                                                                if (!(typeof data9.Q1 == 'number')) {
                                                                                                                                                                    validate122.errors = [
                                                                                                                                                                        {
                                                                                                                                                                            instancePath: instancePath +
                                                                                                                                                                                '/data/' +
                                                                                                                                                                                i0 +
                                                                                                                                                                                '/resultVariables/' +
                                                                                                                                                                                i1 +
                                                                                                                                                                                '/stats/' +
                                                                                                                                                                                i2 +
                                                                                                                                                                                '/Q1',
                                                                                                                                                                            schemaPath: 'urn:wisepipe-common-computation:MonteCarloResultVariableStats/properties/Q1/type',
                                                                                                                                                                            keyword: 'type',
                                                                                                                                                                            params: { type: 'number' },
                                                                                                                                                                            message: 'must be number'
                                                                                                                                                                        }
                                                                                                                                                                    ];
                                                                                                                                                                    return false;
                                                                                                                                                                }
                                                                                                                                                                var valid8 = _errs54 === errors;
                                                                                                                                                            }
                                                                                                                                                            else {
                                                                                                                                                                var valid8 = true;
                                                                                                                                                            }
                                                                                                                                                            if (valid8) {
                                                                                                                                                                if (data9.Q3 !== undefined) {
                                                                                                                                                                    const _errs56 = errors;
                                                                                                                                                                    if (!(typeof data9.Q3 == 'number')) {
                                                                                                                                                                        validate122.errors = [
                                                                                                                                                                            {
                                                                                                                                                                                instancePath: instancePath +
                                                                                                                                                                                    '/data/' +
                                                                                                                                                                                    i0 +
                                                                                                                                                                                    '/resultVariables/' +
                                                                                                                                                                                    i1 +
                                                                                                                                                                                    '/stats/' +
                                                                                                                                                                                    i2 +
                                                                                                                                                                                    '/Q3',
                                                                                                                                                                                schemaPath: 'urn:wisepipe-common-computation:MonteCarloResultVariableStats/properties/Q3/type',
                                                                                                                                                                                keyword: 'type',
                                                                                                                                                                                params: { type: 'number' },
                                                                                                                                                                                message: 'must be number'
                                                                                                                                                                            }
                                                                                                                                                                        ];
                                                                                                                                                                        return false;
                                                                                                                                                                    }
                                                                                                                                                                    var valid8 = _errs56 === errors;
                                                                                                                                                                }
                                                                                                                                                                else {
                                                                                                                                                                    var valid8 = true;
                                                                                                                                                                }
                                                                                                                                                            }
                                                                                                                                                        }
                                                                                                                                                    }
                                                                                                                                                }
                                                                                                                                            }
                                                                                                                                        }
                                                                                                                                    }
                                                                                                                                }
                                                                                                                            }
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                                else {
                                                                                                                    validate122.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath +
                                                                                                                                '/data/' +
                                                                                                                                i0 +
                                                                                                                                '/resultVariables/' +
                                                                                                                                i1 +
                                                                                                                                '/stats/' +
                                                                                                                                i2,
                                                                                                                            schemaPath: 'urn:wisepipe-common-computation:MonteCarloResultVariableStats/type',
                                                                                                                            keyword: 'type',
                                                                                                                            params: { type: 'object' },
                                                                                                                            message: 'must be object'
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                            }
                                                                                                            var valid6 = _errs19 === errors;
                                                                                                            if (!valid6) {
                                                                                                                break;
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    validate122.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath +
                                                                                                                '/data/' +
                                                                                                                i0 +
                                                                                                                '/resultVariables/' +
                                                                                                                i1 +
                                                                                                                '/stats',
                                                                                                            schemaPath: '#/properties/data/items/properties/resultVariables/items/properties/stats/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'array' },
                                                                                                            message: 'must be array'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            var valid5 = _errs17 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid5 = true;
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate122.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/data/' + i0 + '/resultVariables/' + i1,
                                                                                        schemaPath: '#/properties/data/items/properties/resultVariables/items/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'object' },
                                                                                        message: 'must be object'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid4 = _errs11 === errors;
                                                                        if (!valid4) {
                                                                            break;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate122.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/data/' + i0 + '/resultVariables',
                                                                        schemaPath: '#/properties/data/items/properties/resultVariables/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'array' },
                                                                        message: 'must be array'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid3 = _errs9 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                }
                                            }
                                            else {
                                                validate122.errors = [
                                                    {
                                                        instancePath: instancePath + '/data/' + i0,
                                                        schemaPath: '#/properties/data/items/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs5 === errors;
                                        if (!valid2) {
                                            break;
                                        }
                                    }
                                }
                            }
                            else {
                                validate122.errors = [
                                    {
                                        instancePath: instancePath + '/data',
                                        schemaPath: '#/properties/data/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.timestamp !== undefined) {
                            let data28 = data.timestamp;
                            const _errs58 = errors;
                            if (errors === _errs58) {
                                if (errors === _errs58) {
                                    if (typeof data28 === 'string') {
                                        if (!formats0.validate(data28)) {
                                            validate122.errors = [
                                                {
                                                    instancePath: instancePath + '/timestamp',
                                                    schemaPath: '#/properties/timestamp/format',
                                                    keyword: 'format',
                                                    params: { format: 'date-time' },
                                                    message: 'must match format "' + 'date-time' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate122.errors = [
                                            {
                                                instancePath: instancePath + '/timestamp',
                                                schemaPath: '#/properties/timestamp/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs58 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate122.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate122.errors = vErrors;
    return errors === 0;
}
export const multiColumnModeDataProfileSchemaValidation = validate123;
const schema134 = {
    $id: 'urn:wisepipe-common-computation:MultiModeDataProfile',
    type: 'object',
    properties: {
        comparisonGraph: { $ref: 'urn:wisepipe-common-computation:ComparisonGraph' },
        correlations: { $ref: 'urn:wisepipe-common-computation:Correlations' }
    },
    required: []
};
function validate123(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:MultiModeDataProfile" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.comparisonGraph !== undefined) {
                let data0 = data.comparisonGraph;
                const _errs1 = errors;
                const _errs2 = errors;
                if (errors === _errs2) {
                    if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                        let missing0;
                        if (data0.graphType === undefined && (missing0 = 'graphType')) {
                            validate123.errors = [
                                {
                                    instancePath: instancePath + '/comparisonGraph',
                                    schemaPath: 'urn:wisepipe-common-computation:ComparisonGraph/required',
                                    keyword: 'required',
                                    params: { missingProperty: missing0 },
                                    message: "must have required property '" + missing0 + "'"
                                }
                            ];
                            return false;
                        }
                        else {
                            if (data0.graphType !== undefined) {
                                let data1 = data0.graphType;
                                if (typeof data1 !== 'string') {
                                    validate123.errors = [
                                        {
                                            instancePath: instancePath + '/comparisonGraph/graphType',
                                            schemaPath: 'urn:wisepipe-common-computation:ComparisonGraph/properties/graphType/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data1 === 'numericalByNumerical' ||
                                    data1 === 'numericalByCategorical' ||
                                    data1 === 'categoricalByCategorical' ||
                                    data1 === 'numericalByDate' ||
                                    data1 === 'categoricalByDate' ||
                                    data1 === 'dateByDate')) {
                                    validate123.errors = [
                                        {
                                            instancePath: instancePath + '/comparisonGraph/graphType',
                                            schemaPath: 'urn:wisepipe-common-computation:ComparisonGraph/properties/graphType/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema70.properties.graphType.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                    }
                    else {
                        validate123.errors = [
                            {
                                instancePath: instancePath + '/comparisonGraph',
                                schemaPath: 'urn:wisepipe-common-computation:ComparisonGraph/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            }
                        ];
                        return false;
                    }
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.correlations !== undefined) {
                    const _errs6 = errors;
                    if (!validate55(data.correlations, {
                        instancePath: instancePath + '/correlations',
                        parentData: data,
                        parentDataProperty: 'correlations',
                        rootData
                    })) {
                        vErrors = vErrors === null ? validate55.errors : vErrors.concat(validate55.errors);
                        errors = vErrors.length;
                    }
                    var valid0 = _errs6 === errors;
                }
                else {
                    var valid0 = true;
                }
            }
        }
        else {
            validate123.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate123.errors = vErrors;
    return errors === 0;
}
export const nodeDataMapSchemaValidation = validate94;
export const nonMultiColumnModeDataProfileSchemaValidation = validate125;
const schema136 = {
    $id: 'urn:wisepipe-common-computation:NonMultiColumnModeDataProfile',
    type: 'object',
    properties: {
        summary: { $ref: 'urn:wisepipe-common-computation:Summary' },
        singleColumnsInfo: { type: 'array', items: { $ref: 'urn:wisepipe-common-computation:SingleColumnInfo' } }
    },
    required: ['summary', 'singleColumnsInfo']
};
const schema137 = {
    $id: 'urn:wisepipe-common-computation:Summary',
    type: 'object',
    properties: {
        rows: { type: 'number' },
        columns: { type: 'number' },
        textColumns: { type: 'array', items: { type: 'string' } },
        numericColumns: { type: 'array', items: { type: 'string' } },
        dateColumns: { type: 'array', items: { type: 'string' } },
        booleanColumns: { type: 'array', items: { type: 'string' } },
        missingValuesColumns: { type: 'array', items: { type: 'string' } },
        constantValuesColumns: { type: 'array', items: { type: 'string' } },
        uniqueValuesColumns: { type: 'array', items: { type: 'string' } }
    },
    required: [
        'rows',
        'columns',
        'textColumns',
        'numericColumns',
        'dateColumns',
        'booleanColumns',
        'missingValuesColumns',
        'constantValuesColumns',
        'uniqueValuesColumns'
    ]
};
const schema138 = {
    $id: 'urn:wisepipe-common-computation:SingleColumnInfo',
    type: 'object',
    properties: {
        columnName: { type: 'string' },
        columnType: { type: 'string', pattern: 'number|date|string|boolean|decimal' }
    },
    required: ['columnName', 'columnType']
};
const pattern5 = new RegExp('number|date|string|boolean|decimal', 'u');
function validate125(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:NonMultiColumnModeDataProfile" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.summary === undefined && (missing0 = 'summary')) ||
                (data.singleColumnsInfo === undefined && (missing0 = 'singleColumnsInfo'))) {
                validate125.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.summary !== undefined) {
                    let data0 = data.summary;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    if (errors === _errs2) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if ((data0.rows === undefined && (missing1 = 'rows')) ||
                                (data0.columns === undefined && (missing1 = 'columns')) ||
                                (data0.textColumns === undefined && (missing1 = 'textColumns')) ||
                                (data0.numericColumns === undefined && (missing1 = 'numericColumns')) ||
                                (data0.dateColumns === undefined && (missing1 = 'dateColumns')) ||
                                (data0.booleanColumns === undefined && (missing1 = 'booleanColumns')) ||
                                (data0.missingValuesColumns === undefined && (missing1 = 'missingValuesColumns')) ||
                                (data0.constantValuesColumns === undefined && (missing1 = 'constantValuesColumns')) ||
                                (data0.uniqueValuesColumns === undefined && (missing1 = 'uniqueValuesColumns'))) {
                                validate125.errors = [
                                    {
                                        instancePath: instancePath + '/summary',
                                        schemaPath: 'urn:wisepipe-common-computation:Summary/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.rows !== undefined) {
                                    const _errs4 = errors;
                                    if (!(typeof data0.rows == 'number')) {
                                        validate125.errors = [
                                            {
                                                instancePath: instancePath + '/summary/rows',
                                                schemaPath: 'urn:wisepipe-common-computation:Summary/properties/rows/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid2 = _errs4 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data0.columns !== undefined) {
                                        const _errs6 = errors;
                                        if (!(typeof data0.columns == 'number')) {
                                            validate125.errors = [
                                                {
                                                    instancePath: instancePath + '/summary/columns',
                                                    schemaPath: 'urn:wisepipe-common-computation:Summary/properties/columns/type',
                                                    keyword: 'type',
                                                    params: { type: 'number' },
                                                    message: 'must be number'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid2 = _errs6 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data0.textColumns !== undefined) {
                                            let data3 = data0.textColumns;
                                            const _errs8 = errors;
                                            if (errors === _errs8) {
                                                if (Array.isArray(data3)) {
                                                    var valid3 = true;
                                                    const len0 = data3.length;
                                                    for (let i0 = 0; i0 < len0; i0++) {
                                                        const _errs10 = errors;
                                                        if (typeof data3[i0] !== 'string') {
                                                            validate125.errors = [
                                                                {
                                                                    instancePath: instancePath + '/summary/textColumns/' + i0,
                                                                    schemaPath: 'urn:wisepipe-common-computation:Summary/properties/textColumns/items/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid3 = _errs10 === errors;
                                                        if (!valid3) {
                                                            break;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate125.errors = [
                                                        {
                                                            instancePath: instancePath + '/summary/textColumns',
                                                            schemaPath: 'urn:wisepipe-common-computation:Summary/properties/textColumns/type',
                                                            keyword: 'type',
                                                            params: { type: 'array' },
                                                            message: 'must be array'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid2 = _errs8 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                        if (valid2) {
                                            if (data0.numericColumns !== undefined) {
                                                let data5 = data0.numericColumns;
                                                const _errs12 = errors;
                                                if (errors === _errs12) {
                                                    if (Array.isArray(data5)) {
                                                        var valid4 = true;
                                                        const len1 = data5.length;
                                                        for (let i1 = 0; i1 < len1; i1++) {
                                                            const _errs14 = errors;
                                                            if (typeof data5[i1] !== 'string') {
                                                                validate125.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/summary/numericColumns/' + i1,
                                                                        schemaPath: 'urn:wisepipe-common-computation:Summary/properties/numericColumns/items/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid4 = _errs14 === errors;
                                                            if (!valid4) {
                                                                break;
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate125.errors = [
                                                            {
                                                                instancePath: instancePath + '/summary/numericColumns',
                                                                schemaPath: 'urn:wisepipe-common-computation:Summary/properties/numericColumns/type',
                                                                keyword: 'type',
                                                                params: { type: 'array' },
                                                                message: 'must be array'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid2 = _errs12 === errors;
                                            }
                                            else {
                                                var valid2 = true;
                                            }
                                            if (valid2) {
                                                if (data0.dateColumns !== undefined) {
                                                    let data7 = data0.dateColumns;
                                                    const _errs16 = errors;
                                                    if (errors === _errs16) {
                                                        if (Array.isArray(data7)) {
                                                            var valid5 = true;
                                                            const len2 = data7.length;
                                                            for (let i2 = 0; i2 < len2; i2++) {
                                                                const _errs18 = errors;
                                                                if (typeof data7[i2] !== 'string') {
                                                                    validate125.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/summary/dateColumns/' + i2,
                                                                            schemaPath: 'urn:wisepipe-common-computation:Summary/properties/dateColumns/items/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid5 = _errs18 === errors;
                                                                if (!valid5) {
                                                                    break;
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate125.errors = [
                                                                {
                                                                    instancePath: instancePath + '/summary/dateColumns',
                                                                    schemaPath: 'urn:wisepipe-common-computation:Summary/properties/dateColumns/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'array' },
                                                                    message: 'must be array'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid2 = _errs16 === errors;
                                                }
                                                else {
                                                    var valid2 = true;
                                                }
                                                if (valid2) {
                                                    if (data0.booleanColumns !== undefined) {
                                                        let data9 = data0.booleanColumns;
                                                        const _errs20 = errors;
                                                        if (errors === _errs20) {
                                                            if (Array.isArray(data9)) {
                                                                var valid6 = true;
                                                                const len3 = data9.length;
                                                                for (let i3 = 0; i3 < len3; i3++) {
                                                                    const _errs22 = errors;
                                                                    if (typeof data9[i3] !== 'string') {
                                                                        validate125.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/summary/booleanColumns/' + i3,
                                                                                schemaPath: 'urn:wisepipe-common-computation:Summary/properties/booleanColumns/items/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid6 = _errs22 === errors;
                                                                    if (!valid6) {
                                                                        break;
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate125.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/summary/booleanColumns',
                                                                        schemaPath: 'urn:wisepipe-common-computation:Summary/properties/booleanColumns/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'array' },
                                                                        message: 'must be array'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid2 = _errs20 === errors;
                                                    }
                                                    else {
                                                        var valid2 = true;
                                                    }
                                                    if (valid2) {
                                                        if (data0.missingValuesColumns !== undefined) {
                                                            let data11 = data0.missingValuesColumns;
                                                            const _errs24 = errors;
                                                            if (errors === _errs24) {
                                                                if (Array.isArray(data11)) {
                                                                    var valid7 = true;
                                                                    const len4 = data11.length;
                                                                    for (let i4 = 0; i4 < len4; i4++) {
                                                                        const _errs26 = errors;
                                                                        if (typeof data11[i4] !== 'string') {
                                                                            validate125.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/summary/missingValuesColumns/' + i4,
                                                                                    schemaPath: 'urn:wisepipe-common-computation:Summary/properties/missingValuesColumns/items/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        var valid7 = _errs26 === errors;
                                                                        if (!valid7) {
                                                                            break;
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate125.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/summary/missingValuesColumns',
                                                                            schemaPath: 'urn:wisepipe-common-computation:Summary/properties/missingValuesColumns/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'array' },
                                                                            message: 'must be array'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid2 = _errs24 === errors;
                                                        }
                                                        else {
                                                            var valid2 = true;
                                                        }
                                                        if (valid2) {
                                                            if (data0.constantValuesColumns !== undefined) {
                                                                let data13 = data0.constantValuesColumns;
                                                                const _errs28 = errors;
                                                                if (errors === _errs28) {
                                                                    if (Array.isArray(data13)) {
                                                                        var valid8 = true;
                                                                        const len5 = data13.length;
                                                                        for (let i5 = 0; i5 < len5; i5++) {
                                                                            const _errs30 = errors;
                                                                            if (typeof data13[i5] !== 'string') {
                                                                                validate125.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/summary/constantValuesColumns/' + i5,
                                                                                        schemaPath: 'urn:wisepipe-common-computation:Summary/properties/constantValuesColumns/items/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            var valid8 = _errs30 === errors;
                                                                            if (!valid8) {
                                                                                break;
                                                                            }
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate125.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/summary/constantValuesColumns',
                                                                                schemaPath: 'urn:wisepipe-common-computation:Summary/properties/constantValuesColumns/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'array' },
                                                                                message: 'must be array'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid2 = _errs28 === errors;
                                                            }
                                                            else {
                                                                var valid2 = true;
                                                            }
                                                            if (valid2) {
                                                                if (data0.uniqueValuesColumns !== undefined) {
                                                                    let data15 = data0.uniqueValuesColumns;
                                                                    const _errs32 = errors;
                                                                    if (errors === _errs32) {
                                                                        if (Array.isArray(data15)) {
                                                                            var valid9 = true;
                                                                            const len6 = data15.length;
                                                                            for (let i6 = 0; i6 < len6; i6++) {
                                                                                const _errs34 = errors;
                                                                                if (typeof data15[i6] !== 'string') {
                                                                                    validate125.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/summary/uniqueValuesColumns/' + i6,
                                                                                            schemaPath: 'urn:wisepipe-common-computation:Summary/properties/uniqueValuesColumns/items/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                var valid9 = _errs34 === errors;
                                                                                if (!valid9) {
                                                                                    break;
                                                                                }
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate125.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/summary/uniqueValuesColumns',
                                                                                    schemaPath: 'urn:wisepipe-common-computation:Summary/properties/uniqueValuesColumns/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'array' },
                                                                                    message: 'must be array'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid2 = _errs32 === errors;
                                                                }
                                                                else {
                                                                    var valid2 = true;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate125.errors = [
                                {
                                    instancePath: instancePath + '/summary',
                                    schemaPath: 'urn:wisepipe-common-computation:Summary/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.singleColumnsInfo !== undefined) {
                        let data17 = data.singleColumnsInfo;
                        const _errs36 = errors;
                        if (errors === _errs36) {
                            if (Array.isArray(data17)) {
                                var valid10 = true;
                                const len7 = data17.length;
                                for (let i7 = 0; i7 < len7; i7++) {
                                    let data18 = data17[i7];
                                    const _errs38 = errors;
                                    const _errs39 = errors;
                                    if (errors === _errs39) {
                                        if (data18 && typeof data18 == 'object' && !Array.isArray(data18)) {
                                            let missing2;
                                            if ((data18.columnName === undefined && (missing2 = 'columnName')) ||
                                                (data18.columnType === undefined && (missing2 = 'columnType'))) {
                                                validate125.errors = [
                                                    {
                                                        instancePath: instancePath + '/singleColumnsInfo/' + i7,
                                                        schemaPath: 'urn:wisepipe-common-computation:SingleColumnInfo/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing2 },
                                                        message: "must have required property '" + missing2 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data18.columnName !== undefined) {
                                                    const _errs41 = errors;
                                                    if (typeof data18.columnName !== 'string') {
                                                        validate125.errors = [
                                                            {
                                                                instancePath: instancePath + '/singleColumnsInfo/' + i7 + '/columnName',
                                                                schemaPath: 'urn:wisepipe-common-computation:SingleColumnInfo/properties/columnName/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid12 = _errs41 === errors;
                                                }
                                                else {
                                                    var valid12 = true;
                                                }
                                                if (valid12) {
                                                    if (data18.columnType !== undefined) {
                                                        let data20 = data18.columnType;
                                                        const _errs43 = errors;
                                                        if (errors === _errs43) {
                                                            if (typeof data20 === 'string') {
                                                                if (!pattern5.test(data20)) {
                                                                    validate125.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/singleColumnsInfo/' + i7 + '/columnType',
                                                                            schemaPath: 'urn:wisepipe-common-computation:SingleColumnInfo/properties/columnType/pattern',
                                                                            keyword: 'pattern',
                                                                            params: { pattern: 'number|date|string|boolean|decimal' },
                                                                            message: 'must match pattern "' + 'number|date|string|boolean|decimal' + '"'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate125.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/singleColumnsInfo/' + i7 + '/columnType',
                                                                        schemaPath: 'urn:wisepipe-common-computation:SingleColumnInfo/properties/columnType/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid12 = _errs43 === errors;
                                                    }
                                                    else {
                                                        var valid12 = true;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate125.errors = [
                                                {
                                                    instancePath: instancePath + '/singleColumnsInfo/' + i7,
                                                    schemaPath: 'urn:wisepipe-common-computation:SingleColumnInfo/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid10 = _errs38 === errors;
                                    if (!valid10) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate125.errors = [
                                    {
                                        instancePath: instancePath + '/singleColumnsInfo',
                                        schemaPath: '#/properties/singleColumnsInfo/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs36 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate125.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate125.errors = vErrors;
    return errors === 0;
}
export const numberFilterSchemaValidation = validate126;
const schema139 = {
    $id: 'urn:wisepipe-common-computation:NumberFilter',
    type: 'object',
    properties: { values: { type: 'array', items: { type: ['number', 'null'] } } },
    if: { required: ['start', 'end'] },
    then: {
        properties: {
            start: { type: 'number' },
            end: { type: 'number', minimum: { $data: '1/start' } },
            closed: { type: 'string', enum: ['left', 'right', 'both', 'neither'] }
        }
    },
    else: { properties: { start: { type: 'number' }, end: { type: 'number' } } }
};
function validate126(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:NumberFilter" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if ((data.start === undefined && (missing0 = 'start')) || (data.end === undefined && (missing0 = 'end'))) {
            const err0 = {};
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    let ifClause0;
    if (_valid0) {
        const _errs3 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.start !== undefined) {
                const _errs4 = errors;
                if (!(typeof data.start == 'number')) {
                    validate126.errors = [
                        {
                            instancePath: instancePath + '/start',
                            schemaPath: '#/then/properties/start/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number'
                        }
                    ];
                    return false;
                }
                var valid1 = _errs4 === errors;
            }
            else {
                var valid1 = true;
            }
            if (valid1) {
                if (data.end !== undefined) {
                    let data1 = data.end;
                    const _errs6 = errors;
                    if (errors === _errs6) {
                        if (typeof data1 == 'number') {
                            const vSchema0 = data && data.start;
                            if (vSchema0 !== undefined && (!(typeof vSchema0 == 'number') || data1 < vSchema0 || isNaN(data1))) {
                                validate126.errors = [
                                    {
                                        instancePath: instancePath + '/end',
                                        schemaPath: '#/then/properties/end/minimum',
                                        keyword: 'minimum',
                                        params: { comparison: '>=', limit: vSchema0 },
                                        message: 'must be >= ' + vSchema0
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate126.errors = [
                                {
                                    instancePath: instancePath + '/end',
                                    schemaPath: '#/then/properties/end/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid1 = _errs6 === errors;
                }
                else {
                    var valid1 = true;
                }
                if (valid1) {
                    if (data.closed !== undefined) {
                        let data2 = data.closed;
                        const _errs8 = errors;
                        if (typeof data2 !== 'string') {
                            validate126.errors = [
                                {
                                    instancePath: instancePath + '/closed',
                                    schemaPath: '#/then/properties/closed/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data2 === 'left' || data2 === 'right' || data2 === 'both' || data2 === 'neither')) {
                            validate126.errors = [
                                {
                                    instancePath: instancePath + '/closed',
                                    schemaPath: '#/then/properties/closed/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema139.then.properties.closed.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid1 = _errs8 === errors;
                    }
                    else {
                        var valid1 = true;
                    }
                }
            }
        }
        var _valid0 = _errs3 === errors;
        valid0 = _valid0;
        ifClause0 = 'then';
    }
    else {
        const _errs10 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.start !== undefined) {
                const _errs11 = errors;
                if (!(typeof data.start == 'number')) {
                    validate126.errors = [
                        {
                            instancePath: instancePath + '/start',
                            schemaPath: '#/else/properties/start/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number'
                        }
                    ];
                    return false;
                }
                var valid2 = _errs11 === errors;
            }
            else {
                var valid2 = true;
            }
            if (valid2) {
                if (data.end !== undefined) {
                    const _errs13 = errors;
                    if (!(typeof data.end == 'number')) {
                        validate126.errors = [
                            {
                                instancePath: instancePath + '/end',
                                schemaPath: '#/else/properties/end/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            }
                        ];
                        return false;
                    }
                    var valid2 = _errs13 === errors;
                }
                else {
                    var valid2 = true;
                }
            }
        }
        var _valid0 = _errs10 === errors;
        valid0 = _valid0;
        ifClause0 = 'else';
    }
    if (!valid0) {
        const err1 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: ifClause0 },
            message: 'must match "' + ifClause0 + '" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate126.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.values !== undefined) {
                let data5 = data.values;
                const _errs15 = errors;
                if (errors === _errs15) {
                    if (Array.isArray(data5)) {
                        var valid4 = true;
                        const len0 = data5.length;
                        for (let i0 = 0; i0 < len0; i0++) {
                            let data6 = data5[i0];
                            const _errs17 = errors;
                            if (!(typeof data6 == 'number') && data6 !== null) {
                                validate126.errors = [
                                    {
                                        instancePath: instancePath + '/values/' + i0,
                                        schemaPath: '#/properties/values/items/type',
                                        keyword: 'type',
                                        params: { type: schema139.properties.values.items.type },
                                        message: 'must be number,null'
                                    }
                                ];
                                return false;
                            }
                            var valid4 = _errs17 === errors;
                            if (!valid4) {
                                break;
                            }
                        }
                    }
                    else {
                        validate126.errors = [
                            {
                                instancePath: instancePath + '/values',
                                schemaPath: '#/properties/values/type',
                                keyword: 'type',
                                params: { type: 'array' },
                                message: 'must be array'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate126.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate126.errors = vErrors;
    return errors === 0;
}
export const numericColumnInfoSchemaValidation = validate127;
const schema140 = {
    $id: 'urn:wisepipe-common-computation:NumericColumnInfo',
    type: 'object',
    properties: {
        missing: { type: 'number' },
        unique: { type: 'number' },
        mean: { type: 'number' },
        max: { type: 'number' },
        min: { type: 'number' },
        stdDeviation: { type: 'number' },
        histogramFrequency: { type: 'array', items: { type: 'number' } },
        histogramBinEdges: { type: 'array', items: { type: 'number' } }
    },
    required: ['missing']
};
function validate127(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:NumericColumnInfo" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.missing === undefined && (missing0 = 'missing')) {
                validate127.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.missing !== undefined) {
                    const _errs1 = errors;
                    if (!(typeof data.missing == 'number')) {
                        validate127.errors = [
                            {
                                instancePath: instancePath + '/missing',
                                schemaPath: '#/properties/missing/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.unique !== undefined) {
                        const _errs3 = errors;
                        if (!(typeof data.unique == 'number')) {
                            validate127.errors = [
                                {
                                    instancePath: instancePath + '/unique',
                                    schemaPath: '#/properties/unique/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.mean !== undefined) {
                            const _errs5 = errors;
                            if (!(typeof data.mean == 'number')) {
                                validate127.errors = [
                                    {
                                        instancePath: instancePath + '/mean',
                                        schemaPath: '#/properties/mean/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.max !== undefined) {
                                const _errs7 = errors;
                                if (!(typeof data.max == 'number')) {
                                    validate127.errors = [
                                        {
                                            instancePath: instancePath + '/max',
                                            schemaPath: '#/properties/max/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.min !== undefined) {
                                    const _errs9 = errors;
                                    if (!(typeof data.min == 'number')) {
                                        validate127.errors = [
                                            {
                                                instancePath: instancePath + '/min',
                                                schemaPath: '#/properties/min/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.stdDeviation !== undefined) {
                                        const _errs11 = errors;
                                        if (!(typeof data.stdDeviation == 'number')) {
                                            validate127.errors = [
                                                {
                                                    instancePath: instancePath + '/stdDeviation',
                                                    schemaPath: '#/properties/stdDeviation/type',
                                                    keyword: 'type',
                                                    params: { type: 'number' },
                                                    message: 'must be number'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.histogramFrequency !== undefined) {
                                            let data6 = data.histogramFrequency;
                                            const _errs13 = errors;
                                            if (errors === _errs13) {
                                                if (Array.isArray(data6)) {
                                                    var valid1 = true;
                                                    const len0 = data6.length;
                                                    for (let i0 = 0; i0 < len0; i0++) {
                                                        const _errs15 = errors;
                                                        if (!(typeof data6[i0] == 'number')) {
                                                            validate127.errors = [
                                                                {
                                                                    instancePath: instancePath + '/histogramFrequency/' + i0,
                                                                    schemaPath: '#/properties/histogramFrequency/items/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'number' },
                                                                    message: 'must be number'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid1 = _errs15 === errors;
                                                        if (!valid1) {
                                                            break;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate127.errors = [
                                                        {
                                                            instancePath: instancePath + '/histogramFrequency',
                                                            schemaPath: '#/properties/histogramFrequency/type',
                                                            keyword: 'type',
                                                            params: { type: 'array' },
                                                            message: 'must be array'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.histogramBinEdges !== undefined) {
                                                let data8 = data.histogramBinEdges;
                                                const _errs17 = errors;
                                                if (errors === _errs17) {
                                                    if (Array.isArray(data8)) {
                                                        var valid2 = true;
                                                        const len1 = data8.length;
                                                        for (let i1 = 0; i1 < len1; i1++) {
                                                            const _errs19 = errors;
                                                            if (!(typeof data8[i1] == 'number')) {
                                                                validate127.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/histogramBinEdges/' + i1,
                                                                        schemaPath: '#/properties/histogramBinEdges/items/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'number' },
                                                                        message: 'must be number'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid2 = _errs19 === errors;
                                                            if (!valid2) {
                                                                break;
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate127.errors = [
                                                            {
                                                                instancePath: instancePath + '/histogramBinEdges',
                                                                schemaPath: '#/properties/histogramBinEdges/type',
                                                                keyword: 'type',
                                                                params: { type: 'array' },
                                                                message: 'must be array'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid0 = _errs17 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate127.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate127.errors = vErrors;
    return errors === 0;
}
export const numericalByCategoricalGraphSchemaValidation = validate128;
const schema141 = {
    $id: 'urn:wisepipe-common-computation:NumericalByCategoricalGraph',
    type: 'object',
    properties: {
        categories: { type: 'array', items: { type: 'string' } },
        data: { type: 'array', items: { $ref: 'urn:wisepipe-common-computation:BoxPlotData' } }
    },
    required: ['categories', 'data']
};
function validate128(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:NumericalByCategoricalGraph" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.categories === undefined && (missing0 = 'categories')) ||
                (data.data === undefined && (missing0 = 'data'))) {
                validate128.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.categories !== undefined) {
                    let data0 = data.categories;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                const _errs3 = errors;
                                if (typeof data0[i0] !== 'string') {
                                    validate128.errors = [
                                        {
                                            instancePath: instancePath + '/categories/' + i0,
                                            schemaPath: '#/properties/categories/items/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                        }
                        else {
                            validate128.errors = [
                                {
                                    instancePath: instancePath + '/categories',
                                    schemaPath: '#/properties/categories/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.data !== undefined) {
                        let data2 = data.data;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (Array.isArray(data2)) {
                                var valid2 = true;
                                const len1 = data2.length;
                                for (let i1 = 0; i1 < len1; i1++) {
                                    let data3 = data2[i1];
                                    const _errs7 = errors;
                                    const _errs8 = errors;
                                    if (errors === _errs8) {
                                        if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                                            let missing1;
                                            if ((data3.q1 === undefined && (missing1 = 'q1')) ||
                                                (data3.q3 === undefined && (missing1 = 'q3')) ||
                                                (data3.median === undefined && (missing1 = 'median')) ||
                                                (data3.min === undefined && (missing1 = 'min')) ||
                                                (data3.max === undefined && (missing1 = 'max'))) {
                                                validate128.errors = [
                                                    {
                                                        instancePath: instancePath + '/data/' + i1,
                                                        schemaPath: 'urn:wisepipe-common-computation:BoxPlotData/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing1 },
                                                        message: "must have required property '" + missing1 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data3.q1 !== undefined) {
                                                    let data4 = data3.q1;
                                                    const _errs10 = errors;
                                                    if (!(typeof data4 == 'number') && data4 !== null) {
                                                        validate128.errors = [
                                                            {
                                                                instancePath: instancePath + '/data/' + i1 + '/q1',
                                                                schemaPath: 'urn:wisepipe-common-computation:BoxPlotData/properties/q1/type',
                                                                keyword: 'type',
                                                                params: { type: schema40.properties.q1.type },
                                                                message: 'must be number,null'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid4 = _errs10 === errors;
                                                }
                                                else {
                                                    var valid4 = true;
                                                }
                                                if (valid4) {
                                                    if (data3.q3 !== undefined) {
                                                        let data5 = data3.q3;
                                                        const _errs12 = errors;
                                                        if (!(typeof data5 == 'number') && data5 !== null) {
                                                            validate128.errors = [
                                                                {
                                                                    instancePath: instancePath + '/data/' + i1 + '/q3',
                                                                    schemaPath: 'urn:wisepipe-common-computation:BoxPlotData/properties/q3/type',
                                                                    keyword: 'type',
                                                                    params: { type: schema40.properties.q3.type },
                                                                    message: 'must be number,null'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid4 = _errs12 === errors;
                                                    }
                                                    else {
                                                        var valid4 = true;
                                                    }
                                                    if (valid4) {
                                                        if (data3.median !== undefined) {
                                                            let data6 = data3.median;
                                                            const _errs14 = errors;
                                                            if (!(typeof data6 == 'number') && data6 !== null) {
                                                                validate128.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/data/' + i1 + '/median',
                                                                        schemaPath: 'urn:wisepipe-common-computation:BoxPlotData/properties/median/type',
                                                                        keyword: 'type',
                                                                        params: { type: schema40.properties.median.type },
                                                                        message: 'must be number,null'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid4 = _errs14 === errors;
                                                        }
                                                        else {
                                                            var valid4 = true;
                                                        }
                                                        if (valid4) {
                                                            if (data3.min !== undefined) {
                                                                let data7 = data3.min;
                                                                const _errs16 = errors;
                                                                if (!(typeof data7 == 'number') && data7 !== null) {
                                                                    validate128.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/data/' + i1 + '/min',
                                                                            schemaPath: 'urn:wisepipe-common-computation:BoxPlotData/properties/min/type',
                                                                            keyword: 'type',
                                                                            params: { type: schema40.properties.min.type },
                                                                            message: 'must be number,null'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid4 = _errs16 === errors;
                                                            }
                                                            else {
                                                                var valid4 = true;
                                                            }
                                                            if (valid4) {
                                                                if (data3.max !== undefined) {
                                                                    let data8 = data3.max;
                                                                    const _errs18 = errors;
                                                                    if (!(typeof data8 == 'number') && data8 !== null) {
                                                                        validate128.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/data/' + i1 + '/max',
                                                                                schemaPath: 'urn:wisepipe-common-computation:BoxPlotData/properties/max/type',
                                                                                keyword: 'type',
                                                                                params: { type: schema40.properties.max.type },
                                                                                message: 'must be number,null'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid4 = _errs18 === errors;
                                                                }
                                                                else {
                                                                    var valid4 = true;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate128.errors = [
                                                {
                                                    instancePath: instancePath + '/data/' + i1,
                                                    schemaPath: 'urn:wisepipe-common-computation:BoxPlotData/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs7 === errors;
                                    if (!valid2) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate128.errors = [
                                    {
                                        instancePath: instancePath + '/data',
                                        schemaPath: '#/properties/data/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate128.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate128.errors = vErrors;
    return errors === 0;
}
export const numericalByDateGraphSchemaValidation = validate129;
const schema143 = {
    $id: 'urn:wisepipe-common-computation:NumericalByDateGraph',
    type: 'object',
    properties: {
        dates: { type: 'array', items: { type: ['string', 'null'], format: 'date-time' } },
        numbers: { type: 'array', items: { type: ['number', 'null'] } }
    },
    required: ['dates', 'numbers']
};
function validate129(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:NumericalByDateGraph" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.dates === undefined && (missing0 = 'dates')) ||
                (data.numbers === undefined && (missing0 = 'numbers'))) {
                validate129.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.dates !== undefined) {
                    let data0 = data.dates;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                let data1 = data0[i0];
                                const _errs3 = errors;
                                if (typeof data1 !== 'string' && data1 !== null) {
                                    validate129.errors = [
                                        {
                                            instancePath: instancePath + '/dates/' + i0,
                                            schemaPath: '#/properties/dates/items/type',
                                            keyword: 'type',
                                            params: { type: schema143.properties.dates.items.type },
                                            message: 'must be string,null'
                                        }
                                    ];
                                    return false;
                                }
                                if (errors === _errs3) {
                                    if (errors === _errs3) {
                                        if (typeof data1 === 'string') {
                                            if (!formats0.validate(data1)) {
                                                validate129.errors = [
                                                    {
                                                        instancePath: instancePath + '/dates/' + i0,
                                                        schemaPath: '#/properties/dates/items/format',
                                                        keyword: 'format',
                                                        params: { format: 'date-time' },
                                                        message: 'must match format "' + 'date-time' + '"'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                        }
                        else {
                            validate129.errors = [
                                {
                                    instancePath: instancePath + '/dates',
                                    schemaPath: '#/properties/dates/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.numbers !== undefined) {
                        let data2 = data.numbers;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (Array.isArray(data2)) {
                                var valid2 = true;
                                const len1 = data2.length;
                                for (let i1 = 0; i1 < len1; i1++) {
                                    let data3 = data2[i1];
                                    const _errs7 = errors;
                                    if (!(typeof data3 == 'number') && data3 !== null) {
                                        validate129.errors = [
                                            {
                                                instancePath: instancePath + '/numbers/' + i1,
                                                schemaPath: '#/properties/numbers/items/type',
                                                keyword: 'type',
                                                params: { type: schema143.properties.numbers.items.type },
                                                message: 'must be number,null'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid2 = _errs7 === errors;
                                    if (!valid2) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate129.errors = [
                                    {
                                        instancePath: instancePath + '/numbers',
                                        schemaPath: '#/properties/numbers/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate129.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate129.errors = vErrors;
    return errors === 0;
}
export const numericalByNumericalGraphSchemaValidation = validate130;
const schema144 = {
    $id: 'urn:wisepipe-common-computation:NumericalByNumericalGraph',
    type: 'object',
    properties: {
        column1Name: { type: 'string' },
        column2Name: { type: 'string' },
        column1Values: { type: 'array', items: { type: ['number', 'null'] } },
        column2Values: { type: 'array', items: { type: ['number', 'null'] } }
    },
    required: ['column1Name', 'column2Name', 'column1Values', 'column2Values']
};
function validate130(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:NumericalByNumericalGraph" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.column1Name === undefined && (missing0 = 'column1Name')) ||
                (data.column2Name === undefined && (missing0 = 'column2Name')) ||
                (data.column1Values === undefined && (missing0 = 'column1Values')) ||
                (data.column2Values === undefined && (missing0 = 'column2Values'))) {
                validate130.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.column1Name !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.column1Name !== 'string') {
                        validate130.errors = [
                            {
                                instancePath: instancePath + '/column1Name',
                                schemaPath: '#/properties/column1Name/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.column2Name !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.column2Name !== 'string') {
                            validate130.errors = [
                                {
                                    instancePath: instancePath + '/column2Name',
                                    schemaPath: '#/properties/column2Name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.column1Values !== undefined) {
                            let data2 = data.column1Values;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (Array.isArray(data2)) {
                                    var valid1 = true;
                                    const len0 = data2.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data3 = data2[i0];
                                        const _errs7 = errors;
                                        if (!(typeof data3 == 'number') && data3 !== null) {
                                            validate130.errors = [
                                                {
                                                    instancePath: instancePath + '/column1Values/' + i0,
                                                    schemaPath: '#/properties/column1Values/items/type',
                                                    keyword: 'type',
                                                    params: { type: schema144.properties.column1Values.items.type },
                                                    message: 'must be number,null'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid1 = _errs7 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate130.errors = [
                                        {
                                            instancePath: instancePath + '/column1Values',
                                            schemaPath: '#/properties/column1Values/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.column2Values !== undefined) {
                                let data4 = data.column2Values;
                                const _errs9 = errors;
                                if (errors === _errs9) {
                                    if (Array.isArray(data4)) {
                                        var valid2 = true;
                                        const len1 = data4.length;
                                        for (let i1 = 0; i1 < len1; i1++) {
                                            let data5 = data4[i1];
                                            const _errs11 = errors;
                                            if (!(typeof data5 == 'number') && data5 !== null) {
                                                validate130.errors = [
                                                    {
                                                        instancePath: instancePath + '/column2Values/' + i1,
                                                        schemaPath: '#/properties/column2Values/items/type',
                                                        keyword: 'type',
                                                        params: { type: schema144.properties.column2Values.items.type },
                                                        message: 'must be number,null'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid2 = _errs11 === errors;
                                            if (!valid2) {
                                                break;
                                            }
                                        }
                                    }
                                    else {
                                        validate130.errors = [
                                            {
                                                instancePath: instancePath + '/column2Values',
                                                schemaPath: '#/properties/column2Values/type',
                                                keyword: 'type',
                                                params: { type: 'array' },
                                                message: 'must be array'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate130.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate130.errors = vErrors;
    return errors === 0;
}
export const outsSchemaInfoSchemaValidation = validate131;
const schema145 = {
    $id: 'urn:wisepipe-common-computation:OutsSchemaInfo',
    type: 'object',
    properties: {
        exportName: { type: 'string' },
        exportID: { type: 'string', uid: 10 },
        columns: { type: 'array', items: { $ref: 'urn:wisepipe-common-data:Column' } }
    },
    required: ['exportName', 'exportID', 'columns']
};
const func254 = ucs2length;
const func255 = base64urlToBuffer;
const func256 = base64urlEncode;
const func257 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate131(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:OutsSchemaInfo" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.exportName === undefined && (missing0 = 'exportName')) ||
                (data.exportID === undefined && (missing0 = 'exportID')) ||
                (data.columns === undefined && (missing0 = 'columns'))) {
                validate131.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.exportName !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.exportName !== 'string') {
                        validate131.errors = [
                            {
                                instancePath: instancePath + '/exportName',
                                schemaPath: '#/properties/exportName/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.exportID !== undefined) {
                        let data1 = data.exportID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                const b64min0 = Math.ceil((4 * 10) / 3);
                                const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                                if (func254(data1) < b64min0 || func254(data1) > b64max0) {
                                    validate131.errors = [
                                        {
                                            instancePath: instancePath + '/exportID',
                                            schemaPath: '#/properties/exportID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func254(data1) },
                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func254(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded0 = func255(data1);
                                    if (decoded0.length !== 10) {
                                        validate131.errors = [
                                            {
                                                instancePath: instancePath + '/exportID',
                                                schemaPath: '#/properties/exportID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 10 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded0 = func256(decoded0);
                                        if (func257(encoded0) !== func257(data1)) {
                                            validate131.errors = [
                                                {
                                                    instancePath: instancePath + '/exportID',
                                                    schemaPath: '#/properties/exportID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate131.errors = [
                                    {
                                        instancePath: instancePath + '/exportID',
                                        schemaPath: '#/properties/exportID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.columns !== undefined) {
                            let data2 = data.columns;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (Array.isArray(data2)) {
                                    var valid2 = true;
                                    const len0 = data2.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        const _errs7 = errors;
                                        if (!validate45(data2[i0], {
                                            instancePath: instancePath + '/columns/' + i0,
                                            parentData: data2,
                                            parentDataProperty: i0,
                                            rootData
                                        })) {
                                            vErrors = vErrors === null ? validate45.errors : vErrors.concat(validate45.errors);
                                            errors = vErrors.length;
                                        }
                                        var valid2 = _errs7 === errors;
                                        if (!valid2) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate131.errors = [
                                        {
                                            instancePath: instancePath + '/columns',
                                            schemaPath: '#/properties/columns/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate131.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate131.errors = vErrors;
    return errors === 0;
}
export const periodColumnMetadataSchemaValidation = validate133;
function validate133(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:PeriodColumnMetadata" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.calendarID === undefined && (missing0 = 'calendarID')) ||
                (data.level === undefined && (missing0 = 'level'))) {
                validate133.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.calendarID !== undefined) {
                    let data0 = data.calendarID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate133.errors = [
                                    {
                                        instancePath: instancePath + '/calendarID',
                                        schemaPath: '#/properties/calendarID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate133.errors = [
                                {
                                    instancePath: instancePath + '/calendarID',
                                    schemaPath: '#/properties/calendarID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.level !== undefined) {
                        let data1 = data.level;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate133.errors = [
                                        {
                                            instancePath: instancePath + '/level',
                                            schemaPath: '#/properties/level/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate133.errors = [
                                    {
                                        instancePath: instancePath + '/level',
                                        schemaPath: '#/properties/level/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate133.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate133.errors = vErrors;
    return errors === 0;
}
export const picklistColumnMetadataSchemaValidation = validate134;
function validate134(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:PicklistColumnMetadata" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.table === undefined && (missing0 = 'table')) || (data.column === undefined && (missing0 = 'column'))) {
                validate134.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.table !== undefined) {
                    let data0 = data.table;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate134.errors = [
                                    {
                                        instancePath: instancePath + '/table',
                                        schemaPath: '#/properties/table/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate134.errors = [
                                {
                                    instancePath: instancePath + '/table',
                                    schemaPath: '#/properties/table/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.column !== undefined) {
                        let data1 = data.column;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate134.errors = [
                                        {
                                            instancePath: instancePath + '/column',
                                            schemaPath: '#/properties/column/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate134.errors = [
                                    {
                                        instancePath: instancePath + '/column',
                                        schemaPath: '#/properties/column/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate134.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate134.errors = vErrors;
    return errors === 0;
}
export const portDataSchemaValidation = validate95;
export const runConfigSchemaValidation = validate135;
const schema148 = {
    $id: 'urn:wisepipe-common-computation:RunConfig',
    type: 'object',
    properties: {
        type: {
            type: 'string',
            enum: [
                'file',
                'cloud',
                'demand_forecast',
                'sample_customers',
                'pipe',
                'multi_port_pipe',
                'adapt',
                'aggregate',
                'aggregate_v2',
                'amortization',
                'binning',
                'category_encoder',
                'case',
                'change_case',
                'change_type',
                'clean_character',
                'combination_matcher',
                'conditional',
                'confusion_matrix',
                'date_add',
                'date_diff',
                'date_part',
                'date_aggregate',
                'date_format',
                'distinct',
                'drop',
                'export',
                'extract',
                'fill',
                'filter',
                'formula',
                'multi_formula',
                'fuzzy_matcher',
                'join',
                'join_v2',
                'lag',
                'limit',
                'merge_columns',
                'min_max_scaler',
                'monte_carlo',
                'most_common',
                'one_hot_encoder',
                'oversample',
                'predict_gender',
                'quantile',
                'random_number_generator',
                'rank',
                'record_id',
                'remove_outliers',
                'remove_empty',
                'rename',
                'reorder',
                'repeat',
                'replace',
                'multi_replace',
                'reshape',
                'reshape_v2',
                'running_average',
                'running_total',
                'sample',
                'segmentation',
                'select',
                'select_word',
                'smart_matcher',
                'snapshot',
                'sort',
                'split',
                'standard_scaler',
                'text_grade_level',
                'text_between',
                'text_length',
                'text_part',
                'text_sentiment',
                'trim',
                'trim_tags',
                'undersample',
                'union',
                'multi_union',
                'weighted_average',
                'classifier',
                'cat_boost_classifier',
                'decision_tree_train',
                'gbt_train',
                'k_neighbors_classifier',
                'lgbm_classifier',
                'logistic_regression_train',
                'naive_bayes_train',
                'random_forest_train',
                'svm_train',
                'xgb_classifier',
                'regressor',
                'decision_tree_regressor',
                'gbt_regressor',
                'k_neighbors_regressor',
                'lgbm_regressor',
                'linear_regression_train',
                'mlp_regressor',
                'random_forest_regressor',
                'xgb_regressor',
                'cat_boost_regressor',
                'forecast',
                'arima_forecast',
                'auto_regressive_forecast',
                'exp_smoothing_forecast',
                'linear_regression_forecast',
                'moving_average_forecast',
                'prophet_forecast',
                'seasonal_arima_forecast',
                'simple_exp_smoothing_forecast',
                'vector_auto_regressive_forecast',
                'weighted_moving_average_forecast',
                'cnn_text_classifier',
                'bow_text_classifier',
                'ensemble_text_classifier',
                'text_classifier',
                'word_frequency',
                'outlier',
                'abod_outlier',
                'cblof_outlier',
                'cof_outlier',
                'hbos_outlier',
                'iqr_outlier',
                'isolation_forest_outlier',
                'k_neighbors_outlier',
                'multi_objective_gaal_outlier',
                'one_class_svm_outlier',
                'pca_outlier',
                'single_objective_gaal_outlier',
                'subspace_outlier',
                'z_score_outlier',
                'assignment_optimization',
                'predictor',
                'us_income',
                'us_population',
                'weather',
                'hierarchy',
                'hierarchy_v2',
                'hierarchy_validator',
                'hierarchy_validator_v2',
                'lookup',
                'split_columns',
                'period_mapper',
                'rule_mapper',
                'rule_mapper_v2',
                'incentives_export',
                'incentives_import',
                'incentives_table',
                'incentives_period',
                'user_defined_calc',
                'sort_calc',
                'time_shift_calc',
                'category_calc',
                'true_up',
                'period_add',
                'period_diff',
                'expand_picklist',
                'period_accumulation',
                'reusable_logic_input',
                'reusable_logic_output',
                'reusable_logic',
                'none'
            ]
        }
    },
    required: ['type']
};
function validate135(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:RunConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.type === undefined && (missing0 = 'type')) {
                validate135.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.type !== undefined) {
                    let data0 = data.type;
                    if (typeof data0 !== 'string') {
                        validate135.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'file' ||
                        data0 === 'cloud' ||
                        data0 === 'demand_forecast' ||
                        data0 === 'sample_customers' ||
                        data0 === 'pipe' ||
                        data0 === 'multi_port_pipe' ||
                        data0 === 'adapt' ||
                        data0 === 'aggregate' ||
                        data0 === 'aggregate_v2' ||
                        data0 === 'amortization' ||
                        data0 === 'binning' ||
                        data0 === 'category_encoder' ||
                        data0 === 'case' ||
                        data0 === 'change_case' ||
                        data0 === 'change_type' ||
                        data0 === 'clean_character' ||
                        data0 === 'combination_matcher' ||
                        data0 === 'conditional' ||
                        data0 === 'confusion_matrix' ||
                        data0 === 'date_add' ||
                        data0 === 'date_diff' ||
                        data0 === 'date_part' ||
                        data0 === 'date_aggregate' ||
                        data0 === 'date_format' ||
                        data0 === 'distinct' ||
                        data0 === 'drop' ||
                        data0 === 'export' ||
                        data0 === 'extract' ||
                        data0 === 'fill' ||
                        data0 === 'filter' ||
                        data0 === 'formula' ||
                        data0 === 'multi_formula' ||
                        data0 === 'fuzzy_matcher' ||
                        data0 === 'join' ||
                        data0 === 'join_v2' ||
                        data0 === 'lag' ||
                        data0 === 'limit' ||
                        data0 === 'merge_columns' ||
                        data0 === 'min_max_scaler' ||
                        data0 === 'monte_carlo' ||
                        data0 === 'most_common' ||
                        data0 === 'one_hot_encoder' ||
                        data0 === 'oversample' ||
                        data0 === 'predict_gender' ||
                        data0 === 'quantile' ||
                        data0 === 'random_number_generator' ||
                        data0 === 'rank' ||
                        data0 === 'record_id' ||
                        data0 === 'remove_outliers' ||
                        data0 === 'remove_empty' ||
                        data0 === 'rename' ||
                        data0 === 'reorder' ||
                        data0 === 'repeat' ||
                        data0 === 'replace' ||
                        data0 === 'multi_replace' ||
                        data0 === 'reshape' ||
                        data0 === 'reshape_v2' ||
                        data0 === 'running_average' ||
                        data0 === 'running_total' ||
                        data0 === 'sample' ||
                        data0 === 'segmentation' ||
                        data0 === 'select' ||
                        data0 === 'select_word' ||
                        data0 === 'smart_matcher' ||
                        data0 === 'snapshot' ||
                        data0 === 'sort' ||
                        data0 === 'split' ||
                        data0 === 'standard_scaler' ||
                        data0 === 'text_grade_level' ||
                        data0 === 'text_between' ||
                        data0 === 'text_length' ||
                        data0 === 'text_part' ||
                        data0 === 'text_sentiment' ||
                        data0 === 'trim' ||
                        data0 === 'trim_tags' ||
                        data0 === 'undersample' ||
                        data0 === 'union' ||
                        data0 === 'multi_union' ||
                        data0 === 'weighted_average' ||
                        data0 === 'classifier' ||
                        data0 === 'cat_boost_classifier' ||
                        data0 === 'decision_tree_train' ||
                        data0 === 'gbt_train' ||
                        data0 === 'k_neighbors_classifier' ||
                        data0 === 'lgbm_classifier' ||
                        data0 === 'logistic_regression_train' ||
                        data0 === 'naive_bayes_train' ||
                        data0 === 'random_forest_train' ||
                        data0 === 'svm_train' ||
                        data0 === 'xgb_classifier' ||
                        data0 === 'regressor' ||
                        data0 === 'decision_tree_regressor' ||
                        data0 === 'gbt_regressor' ||
                        data0 === 'k_neighbors_regressor' ||
                        data0 === 'lgbm_regressor' ||
                        data0 === 'linear_regression_train' ||
                        data0 === 'mlp_regressor' ||
                        data0 === 'random_forest_regressor' ||
                        data0 === 'xgb_regressor' ||
                        data0 === 'cat_boost_regressor' ||
                        data0 === 'forecast' ||
                        data0 === 'arima_forecast' ||
                        data0 === 'auto_regressive_forecast' ||
                        data0 === 'exp_smoothing_forecast' ||
                        data0 === 'linear_regression_forecast' ||
                        data0 === 'moving_average_forecast' ||
                        data0 === 'prophet_forecast' ||
                        data0 === 'seasonal_arima_forecast' ||
                        data0 === 'simple_exp_smoothing_forecast' ||
                        data0 === 'vector_auto_regressive_forecast' ||
                        data0 === 'weighted_moving_average_forecast' ||
                        data0 === 'cnn_text_classifier' ||
                        data0 === 'bow_text_classifier' ||
                        data0 === 'ensemble_text_classifier' ||
                        data0 === 'text_classifier' ||
                        data0 === 'word_frequency' ||
                        data0 === 'outlier' ||
                        data0 === 'abod_outlier' ||
                        data0 === 'cblof_outlier' ||
                        data0 === 'cof_outlier' ||
                        data0 === 'hbos_outlier' ||
                        data0 === 'iqr_outlier' ||
                        data0 === 'isolation_forest_outlier' ||
                        data0 === 'k_neighbors_outlier' ||
                        data0 === 'multi_objective_gaal_outlier' ||
                        data0 === 'one_class_svm_outlier' ||
                        data0 === 'pca_outlier' ||
                        data0 === 'single_objective_gaal_outlier' ||
                        data0 === 'subspace_outlier' ||
                        data0 === 'z_score_outlier' ||
                        data0 === 'assignment_optimization' ||
                        data0 === 'predictor' ||
                        data0 === 'us_income' ||
                        data0 === 'us_population' ||
                        data0 === 'weather' ||
                        data0 === 'hierarchy' ||
                        data0 === 'hierarchy_v2' ||
                        data0 === 'hierarchy_validator' ||
                        data0 === 'hierarchy_validator_v2' ||
                        data0 === 'lookup' ||
                        data0 === 'split_columns' ||
                        data0 === 'period_mapper' ||
                        data0 === 'rule_mapper' ||
                        data0 === 'rule_mapper_v2' ||
                        data0 === 'incentives_export' ||
                        data0 === 'incentives_import' ||
                        data0 === 'incentives_table' ||
                        data0 === 'incentives_period' ||
                        data0 === 'user_defined_calc' ||
                        data0 === 'sort_calc' ||
                        data0 === 'time_shift_calc' ||
                        data0 === 'category_calc' ||
                        data0 === 'true_up' ||
                        data0 === 'period_add' ||
                        data0 === 'period_diff' ||
                        data0 === 'expand_picklist' ||
                        data0 === 'period_accumulation' ||
                        data0 === 'reusable_logic_input' ||
                        data0 === 'reusable_logic_output' ||
                        data0 === 'reusable_logic' ||
                        data0 === 'none')) {
                        validate135.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema148.properties.type.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate135.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate135.errors = vErrors;
    return errors === 0;
}
export const runDataProfileRequestSchemaValidation = validate136;
const schema149 = {
    $id: 'urn:wisepipe-common-computation:RunDataProfileRequest',
    type: 'object',
    properties: {
        pipeID: { type: ['string', 'null'], if: { type: 'string' }, then: { uid: 10 } },
        runID: { type: ['string', 'null'], if: { type: 'string' }, then: { uid: 9 } },
        elementID: { type: ['string', 'null'], if: { type: 'string' }, then: { uid: 10 } },
        port: { type: 'string', minLength: 1 },
        reusableLogicParentNodeIDPath: { type: 'string', minLength: 1 },
        isNodeRLInput: { type: 'boolean' }
    },
    required: ['elementID', 'port'],
    anyOf: [{ required: ['pipeID'] }, { required: ['runID'] }],
    if: { required: ['isNodeRLInput'] },
    then: { required: ['reusableLogicParentNodeIDPath'] }
};
const func262 = ucs2length;
const func263 = base64urlToBuffer;
const func264 = base64urlEncode;
const func265 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func266 = ucs2length;
const func267 = base64urlToBuffer;
const func268 = base64urlEncode;
const func269 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func270 = ucs2length;
const func271 = base64urlToBuffer;
const func272 = base64urlEncode;
const func273 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate136(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:RunDataProfileRequest" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = false;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if (data.pipeID === undefined && (missing0 = 'pipeID')) {
            const err0 = {
                instancePath,
                schemaPath: '#/anyOf/0/required',
                keyword: 'required',
                params: { missingProperty: missing0 },
                message: "must have required property '" + missing0 + "'"
            };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
    }
    var _valid0 = _errs2 === errors;
    valid0 = valid0 || _valid0;
    if (!valid0) {
        const _errs3 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if (data.runID === undefined && (missing1 = 'runID')) {
                const err1 = {
                    instancePath,
                    schemaPath: '#/anyOf/1/required',
                    keyword: 'required',
                    params: { missingProperty: missing1 },
                    message: "must have required property '" + missing1 + "'"
                };
                if (vErrors === null) {
                    vErrors = [err1];
                }
                else {
                    vErrors.push(err1);
                }
                errors++;
            }
        }
        var _valid0 = _errs3 === errors;
        valid0 = valid0 || _valid0;
    }
    if (!valid0) {
        const err2 = {
            instancePath,
            schemaPath: '#/anyOf',
            keyword: 'anyOf',
            params: {},
            message: 'must match a schema in anyOf'
        };
        if (vErrors === null) {
            vErrors = [err2];
        }
        else {
            vErrors.push(err2);
        }
        errors++;
        validate136.errors = vErrors;
        return false;
    }
    else {
        errors = _errs1;
        if (vErrors !== null) {
            if (_errs1) {
                vErrors.length = _errs1;
            }
            else {
                vErrors = null;
            }
        }
        const _errs4 = errors;
        let valid1 = true;
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if (data.isNodeRLInput === undefined && (missing2 = 'isNodeRLInput')) {
                const err3 = {};
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
        }
        var _valid1 = _errs5 === errors;
        errors = _errs4;
        if (vErrors !== null) {
            if (_errs4) {
                vErrors.length = _errs4;
            }
            else {
                vErrors = null;
            }
        }
        if (_valid1) {
            const _errs6 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing3;
                if (data.reusableLogicParentNodeIDPath === undefined && (missing3 = 'reusableLogicParentNodeIDPath')) {
                    validate136.errors = [
                        {
                            instancePath,
                            schemaPath: '#/then/required',
                            keyword: 'required',
                            params: { missingProperty: missing3 },
                            message: "must have required property '" + missing3 + "'"
                        }
                    ];
                    return false;
                }
            }
            var _valid1 = _errs6 === errors;
            valid1 = _valid1;
        }
        if (!valid1) {
            const err4 = {
                instancePath,
                schemaPath: '#/if',
                keyword: 'if',
                params: { failingKeyword: 'then' },
                message: 'must match "then" schema'
            };
            if (vErrors === null) {
                vErrors = [err4];
            }
            else {
                vErrors.push(err4);
            }
            errors++;
            validate136.errors = vErrors;
            return false;
        }
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing4;
            if ((data.elementID === undefined && (missing4 = 'elementID')) ||
                (data.port === undefined && (missing4 = 'port'))) {
                validate136.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing4 },
                        message: "must have required property '" + missing4 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pipeID !== undefined) {
                    let data0 = data.pipeID;
                    const _errs7 = errors;
                    if (typeof data0 !== 'string' && data0 !== null) {
                        validate136.errors = [
                            {
                                instancePath: instancePath + '/pipeID',
                                schemaPath: '#/properties/pipeID/type',
                                keyword: 'type',
                                params: { type: schema149.properties.pipeID.type },
                                message: 'must be string,null'
                            }
                        ];
                        return false;
                    }
                    const _errs9 = errors;
                    let valid3 = true;
                    const _errs10 = errors;
                    if (typeof data0 !== 'string') {
                        const err5 = {};
                        if (vErrors === null) {
                            vErrors = [err5];
                        }
                        else {
                            vErrors.push(err5);
                        }
                        errors++;
                    }
                    var _valid2 = _errs10 === errors;
                    errors = _errs9;
                    if (vErrors !== null) {
                        if (_errs9) {
                            vErrors.length = _errs9;
                        }
                        else {
                            vErrors = null;
                        }
                    }
                    if (_valid2) {
                        const _errs12 = errors;
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func262(data0) < b64min0 || func262(data0) > b64max0) {
                                validate136.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/then/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func262(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func262(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func263(data0);
                                if (decoded0.length !== 10) {
                                    validate136.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/then/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func264(decoded0);
                                    if (func265(encoded0) !== func265(data0)) {
                                        validate136.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/then/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        var _valid2 = _errs12 === errors;
                        valid3 = _valid2;
                    }
                    if (!valid3) {
                        const err6 = {
                            instancePath: instancePath + '/pipeID',
                            schemaPath: '#/properties/pipeID/if',
                            keyword: 'if',
                            params: { failingKeyword: 'then' },
                            message: 'must match "then" schema'
                        };
                        if (vErrors === null) {
                            vErrors = [err6];
                        }
                        else {
                            vErrors.push(err6);
                        }
                        errors++;
                        validate136.errors = vErrors;
                        return false;
                    }
                    var valid2 = _errs7 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.runID !== undefined) {
                        let data1 = data.runID;
                        const _errs13 = errors;
                        if (typeof data1 !== 'string' && data1 !== null) {
                            validate136.errors = [
                                {
                                    instancePath: instancePath + '/runID',
                                    schemaPath: '#/properties/runID/type',
                                    keyword: 'type',
                                    params: { type: schema149.properties.runID.type },
                                    message: 'must be string,null'
                                }
                            ];
                            return false;
                        }
                        const _errs15 = errors;
                        let valid5 = true;
                        const _errs16 = errors;
                        if (typeof data1 !== 'string') {
                            const err7 = {};
                            if (vErrors === null) {
                                vErrors = [err7];
                            }
                            else {
                                vErrors.push(err7);
                            }
                            errors++;
                        }
                        var _valid3 = _errs16 === errors;
                        errors = _errs15;
                        if (vErrors !== null) {
                            if (_errs15) {
                                vErrors.length = _errs15;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                        if (_valid3) {
                            const _errs18 = errors;
                            if (typeof data1 === 'string') {
                                const b64min1 = Math.ceil((4 * 9) / 3);
                                const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                if (func266(data1) < b64min1 || func266(data1) > b64max1) {
                                    validate136.errors = [
                                        {
                                            instancePath: instancePath + '/runID',
                                            schemaPath: '#/properties/runID/then/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func266(data1) },
                                            message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func266(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded1 = func267(data1);
                                    if (decoded1.length !== 9) {
                                        validate136.errors = [
                                            {
                                                instancePath: instancePath + '/runID',
                                                schemaPath: '#/properties/runID/then/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 9 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded1 = func268(decoded1);
                                        if (func269(encoded1) !== func269(data1)) {
                                            validate136.errors = [
                                                {
                                                    instancePath: instancePath + '/runID',
                                                    schemaPath: '#/properties/runID/then/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            var _valid3 = _errs18 === errors;
                            valid5 = _valid3;
                        }
                        if (!valid5) {
                            const err8 = {
                                instancePath: instancePath + '/runID',
                                schemaPath: '#/properties/runID/if',
                                keyword: 'if',
                                params: { failingKeyword: 'then' },
                                message: 'must match "then" schema'
                            };
                            if (vErrors === null) {
                                vErrors = [err8];
                            }
                            else {
                                vErrors.push(err8);
                            }
                            errors++;
                            validate136.errors = vErrors;
                            return false;
                        }
                        var valid2 = _errs13 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.elementID !== undefined) {
                            let data2 = data.elementID;
                            const _errs19 = errors;
                            if (typeof data2 !== 'string' && data2 !== null) {
                                validate136.errors = [
                                    {
                                        instancePath: instancePath + '/elementID',
                                        schemaPath: '#/properties/elementID/type',
                                        keyword: 'type',
                                        params: { type: schema149.properties.elementID.type },
                                        message: 'must be string,null'
                                    }
                                ];
                                return false;
                            }
                            const _errs21 = errors;
                            let valid7 = true;
                            const _errs22 = errors;
                            if (typeof data2 !== 'string') {
                                const err9 = {};
                                if (vErrors === null) {
                                    vErrors = [err9];
                                }
                                else {
                                    vErrors.push(err9);
                                }
                                errors++;
                            }
                            var _valid4 = _errs22 === errors;
                            errors = _errs21;
                            if (vErrors !== null) {
                                if (_errs21) {
                                    vErrors.length = _errs21;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                            if (_valid4) {
                                const _errs24 = errors;
                                if (typeof data2 === 'string') {
                                    const b64min2 = Math.ceil((4 * 10) / 3);
                                    const b64max2 = Math.ceil((4 * 10) / 3) + 3;
                                    if (func270(data2) < b64min2 || func270(data2) > b64max2) {
                                        validate136.errors = [
                                            {
                                                instancePath: instancePath + '/elementID',
                                                schemaPath: '#/properties/elementID/then/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min2, b64max: b64max2, length: func270(data2) },
                                                message: 'length must be between ' + b64min2 + ' and ' + b64max2 + ', but is ' + func270(data2)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded2 = func271(data2);
                                        if (decoded2.length !== 10) {
                                            validate136.errors = [
                                                {
                                                    instancePath: instancePath + '/elementID',
                                                    schemaPath: '#/properties/elementID/then/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 10 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded2 = func272(decoded2);
                                            if (func273(encoded2) !== func273(data2)) {
                                                validate136.errors = [
                                                    {
                                                        instancePath: instancePath + '/elementID',
                                                        schemaPath: '#/properties/elementID/then/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                var _valid4 = _errs24 === errors;
                                valid7 = _valid4;
                            }
                            if (!valid7) {
                                const err10 = {
                                    instancePath: instancePath + '/elementID',
                                    schemaPath: '#/properties/elementID/if',
                                    keyword: 'if',
                                    params: { failingKeyword: 'then' },
                                    message: 'must match "then" schema'
                                };
                                if (vErrors === null) {
                                    vErrors = [err10];
                                }
                                else {
                                    vErrors.push(err10);
                                }
                                errors++;
                                validate136.errors = vErrors;
                                return false;
                            }
                            var valid2 = _errs19 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                        if (valid2) {
                            if (data.port !== undefined) {
                                let data3 = data.port;
                                const _errs25 = errors;
                                if (errors === _errs25) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) < 1) {
                                            validate136.errors = [
                                                {
                                                    instancePath: instancePath + '/port',
                                                    schemaPath: '#/properties/port/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate136.errors = [
                                            {
                                                instancePath: instancePath + '/port',
                                                schemaPath: '#/properties/port/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid2 = _errs25 === errors;
                            }
                            else {
                                var valid2 = true;
                            }
                            if (valid2) {
                                if (data.reusableLogicParentNodeIDPath !== undefined) {
                                    let data4 = data.reusableLogicParentNodeIDPath;
                                    const _errs27 = errors;
                                    if (errors === _errs27) {
                                        if (typeof data4 === 'string') {
                                            if (func2(data4) < 1) {
                                                validate136.errors = [
                                                    {
                                                        instancePath: instancePath + '/reusableLogicParentNodeIDPath',
                                                        schemaPath: '#/properties/reusableLogicParentNodeIDPath/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate136.errors = [
                                                {
                                                    instancePath: instancePath + '/reusableLogicParentNodeIDPath',
                                                    schemaPath: '#/properties/reusableLogicParentNodeIDPath/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs27 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data.isNodeRLInput !== undefined) {
                                        const _errs29 = errors;
                                        if (typeof data.isNodeRLInput !== 'boolean') {
                                            validate136.errors = [
                                                {
                                                    instancePath: instancePath + '/isNodeRLInput',
                                                    schemaPath: '#/properties/isNodeRLInput/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid2 = _errs29 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate136.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate136.errors = vErrors;
    return errors === 0;
}
export const runEventSchemaValidation = validate137;
const schema150 = {
    $id: 'urn:wisepipe-common-computation:RunEvent',
    type: 'object',
    properties: {
        type: { type: 'string', enum: ['start', 'success', 'fail', 'remove', 'abort'] },
        orgID: { type: 'string', format: 'uuid' },
        userID: { type: 'string', minLength: 1, maxLength: 128 },
        orgPlan: { type: 'string', enum: ['Social', 'Enterprise', 'Integration', 'Temp', 'Starter', 'Professional'] },
        pipeID: { type: 'string', uid: 10 },
        runID: { type: 'string', uid: 9 },
        userName: { type: 'string' },
        userEmail: { type: 'string' },
        errorMessage: { type: 'string' }
    },
    if: { properties: { type: { const: 'success' } } },
    then: { required: ['userID'] },
    required: ['orgID', 'type', 'pipeID', 'runID']
};
const func278 = ucs2length;
const func279 = base64urlToBuffer;
const func280 = base64urlEncode;
const func281 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func282 = ucs2length;
const func283 = base64urlToBuffer;
const func284 = base64urlEncode;
const func285 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate137(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:RunEvent" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.type !== undefined) {
            if ('success' !== data.type) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.userID === undefined && (missing0 = 'userID')) {
                validate137.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err1 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate137.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.orgID === undefined && (missing1 = 'orgID')) ||
                (data.type === undefined && (missing1 = 'type')) ||
                (data.pipeID === undefined && (missing1 = 'pipeID')) ||
                (data.runID === undefined && (missing1 = 'runID'))) {
                validate137.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.type !== undefined) {
                    let data1 = data.type;
                    const _errs5 = errors;
                    if (typeof data1 !== 'string') {
                        validate137.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data1 === 'start' || data1 === 'success' || data1 === 'fail' || data1 === 'remove' || data1 === 'abort')) {
                        validate137.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema150.properties.type.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid2 = _errs5 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.orgID !== undefined) {
                        let data2 = data.orgID;
                        const _errs7 = errors;
                        if (errors === _errs7) {
                            if (errors === _errs7) {
                                if (typeof data2 === 'string') {
                                    if (!formats6.test(data2)) {
                                        validate137.errors = [
                                            {
                                                instancePath: instancePath + '/orgID',
                                                schemaPath: '#/properties/orgID/format',
                                                keyword: 'format',
                                                params: { format: 'uuid' },
                                                message: 'must match format "' + 'uuid' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate137.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid2 = _errs7 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.userID !== undefined) {
                            let data3 = data.userID;
                            const _errs9 = errors;
                            if (errors === _errs9) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) > 128) {
                                        validate137.errors = [
                                            {
                                                instancePath: instancePath + '/userID',
                                                schemaPath: '#/properties/userID/maxLength',
                                                keyword: 'maxLength',
                                                params: { limit: 128 },
                                                message: 'must NOT have more than 128 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (func2(data3) < 1) {
                                            validate137.errors = [
                                                {
                                                    instancePath: instancePath + '/userID',
                                                    schemaPath: '#/properties/userID/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                else {
                                    validate137.errors = [
                                        {
                                            instancePath: instancePath + '/userID',
                                            schemaPath: '#/properties/userID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid2 = _errs9 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                        if (valid2) {
                            if (data.orgPlan !== undefined) {
                                let data4 = data.orgPlan;
                                const _errs11 = errors;
                                if (typeof data4 !== 'string') {
                                    validate137.errors = [
                                        {
                                            instancePath: instancePath + '/orgPlan',
                                            schemaPath: '#/properties/orgPlan/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data4 === 'Social' ||
                                    data4 === 'Enterprise' ||
                                    data4 === 'Integration' ||
                                    data4 === 'Temp' ||
                                    data4 === 'Starter' ||
                                    data4 === 'Professional')) {
                                    validate137.errors = [
                                        {
                                            instancePath: instancePath + '/orgPlan',
                                            schemaPath: '#/properties/orgPlan/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema150.properties.orgPlan.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid2 = _errs11 === errors;
                            }
                            else {
                                var valid2 = true;
                            }
                            if (valid2) {
                                if (data.pipeID !== undefined) {
                                    let data5 = data.pipeID;
                                    const _errs13 = errors;
                                    if (errors === _errs13) {
                                        if (typeof data5 === 'string') {
                                            const b64min0 = Math.ceil((4 * 10) / 3);
                                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                                            if (func278(data5) < b64min0 || func278(data5) > b64max0) {
                                                validate137.errors = [
                                                    {
                                                        instancePath: instancePath + '/pipeID',
                                                        schemaPath: '#/properties/pipeID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func278(data5) },
                                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func278(data5)
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const decoded0 = func279(data5);
                                                if (decoded0.length !== 10) {
                                                    validate137.errors = [
                                                        {
                                                            instancePath: instancePath + '/pipeID',
                                                            schemaPath: '#/properties/pipeID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'decoded' },
                                                            message: 'must decode to 10 bytes'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    const encoded0 = func280(decoded0);
                                                    if (func281(encoded0) !== func281(data5)) {
                                                        validate137.errors = [
                                                            {
                                                                instancePath: instancePath + '/pipeID',
                                                                schemaPath: '#/properties/pipeID/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'ambiguous' },
                                                                message: 'encoding is ambiguous'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate137.errors = [
                                                {
                                                    instancePath: instancePath + '/pipeID',
                                                    schemaPath: '#/properties/pipeID/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs13 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data.runID !== undefined) {
                                        let data6 = data.runID;
                                        const _errs15 = errors;
                                        if (errors === _errs15) {
                                            if (typeof data6 === 'string') {
                                                const b64min1 = Math.ceil((4 * 9) / 3);
                                                const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                                if (func282(data6) < b64min1 || func282(data6) > b64max1) {
                                                    validate137.errors = [
                                                        {
                                                            instancePath: instancePath + '/runID',
                                                            schemaPath: '#/properties/runID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func282(data6) },
                                                            message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func282(data6)
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    const decoded1 = func283(data6);
                                                    if (decoded1.length !== 9) {
                                                        validate137.errors = [
                                                            {
                                                                instancePath: instancePath + '/runID',
                                                                schemaPath: '#/properties/runID/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'decoded' },
                                                                message: 'must decode to 9 bytes'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        const encoded1 = func284(decoded1);
                                                        if (func285(encoded1) !== func285(data6)) {
                                                            validate137.errors = [
                                                                {
                                                                    instancePath: instancePath + '/runID',
                                                                    schemaPath: '#/properties/runID/uid',
                                                                    keyword: 'uid',
                                                                    params: { error: 'ambiguous' },
                                                                    message: 'encoding is ambiguous'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate137.errors = [
                                                    {
                                                        instancePath: instancePath + '/runID',
                                                        schemaPath: '#/properties/runID/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs15 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data.userName !== undefined) {
                                            const _errs17 = errors;
                                            if (typeof data.userName !== 'string') {
                                                validate137.errors = [
                                                    {
                                                        instancePath: instancePath + '/userName',
                                                        schemaPath: '#/properties/userName/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid2 = _errs17 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                        if (valid2) {
                                            if (data.userEmail !== undefined) {
                                                const _errs19 = errors;
                                                if (typeof data.userEmail !== 'string') {
                                                    validate137.errors = [
                                                        {
                                                            instancePath: instancePath + '/userEmail',
                                                            schemaPath: '#/properties/userEmail/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid2 = _errs19 === errors;
                                            }
                                            else {
                                                var valid2 = true;
                                            }
                                            if (valid2) {
                                                if (data.errorMessage !== undefined) {
                                                    const _errs21 = errors;
                                                    if (typeof data.errorMessage !== 'string') {
                                                        validate137.errors = [
                                                            {
                                                                instancePath: instancePath + '/errorMessage',
                                                                schemaPath: '#/properties/errorMessage/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid2 = _errs21 === errors;
                                                }
                                                else {
                                                    var valid2 = true;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate137.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate137.errors = vErrors;
    return errors === 0;
}
export const runInputSchemaValidation = validate138;
const schema151 = {
    $id: 'urn:wisepipe-common-computation:RunInput',
    type: 'object',
    properties: { runTask: { $ref: 'urn:wisepipe-common-computation:ComputeTask' } },
    required: []
};
function validate138(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:RunInput" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.runTask !== undefined) {
                if (!validate25(data.runTask, {
                    instancePath: instancePath + '/runTask',
                    parentData: data,
                    parentDataProperty: 'runTask',
                    rootData
                })) {
                    vErrors = vErrors === null ? validate25.errors : vErrors.concat(validate25.errors);
                    errors = vErrors.length;
                }
            }
        }
        else {
            validate138.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate138.errors = vErrors;
    return errors === 0;
}
export const runOutputSchemaValidation = validate140;
const schema152 = {
    $id: 'urn:wisepipe-common-computation:RunOutput',
    type: 'object',
    properties: {
        outputName: { type: 'string', minLength: 1 },
        port: { type: 'string', minLength: 1 },
        elementID: { type: 'string', uid: 10 },
        exportID: { type: 'string', uid: 9 },
        exportType: { type: 'string' },
        exportCompletedWarnings: { type: 'array', items: { $ref: 'urn:wisepipe-common-export:ExportCompletedWarning' } }
    },
    required: ['outputName', 'port', 'elementID']
};
const func288 = ucs2length;
const func289 = base64urlToBuffer;
const func290 = base64urlEncode;
const func291 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func292 = ucs2length;
const func293 = base64urlToBuffer;
const func294 = base64urlEncode;
const func295 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate140(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:RunOutput" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.outputName === undefined && (missing0 = 'outputName')) ||
                (data.port === undefined && (missing0 = 'port')) ||
                (data.elementID === undefined && (missing0 = 'elementID'))) {
                validate140.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.outputName !== undefined) {
                    let data0 = data.outputName;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate140.errors = [
                                    {
                                        instancePath: instancePath + '/outputName',
                                        schemaPath: '#/properties/outputName/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate140.errors = [
                                {
                                    instancePath: instancePath + '/outputName',
                                    schemaPath: '#/properties/outputName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.port !== undefined) {
                        let data1 = data.port;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate140.errors = [
                                        {
                                            instancePath: instancePath + '/port',
                                            schemaPath: '#/properties/port/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate140.errors = [
                                    {
                                        instancePath: instancePath + '/port',
                                        schemaPath: '#/properties/port/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.elementID !== undefined) {
                            let data2 = data.elementID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    const b64min0 = Math.ceil((4 * 10) / 3);
                                    const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                                    if (func288(data2) < b64min0 || func288(data2) > b64max0) {
                                        validate140.errors = [
                                            {
                                                instancePath: instancePath + '/elementID',
                                                schemaPath: '#/properties/elementID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func288(data2) },
                                                message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func288(data2)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded0 = func289(data2);
                                        if (decoded0.length !== 10) {
                                            validate140.errors = [
                                                {
                                                    instancePath: instancePath + '/elementID',
                                                    schemaPath: '#/properties/elementID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 10 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded0 = func290(decoded0);
                                            if (func291(encoded0) !== func291(data2)) {
                                                validate140.errors = [
                                                    {
                                                        instancePath: instancePath + '/elementID',
                                                        schemaPath: '#/properties/elementID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate140.errors = [
                                        {
                                            instancePath: instancePath + '/elementID',
                                            schemaPath: '#/properties/elementID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.exportID !== undefined) {
                                let data3 = data.exportID;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        const b64min1 = Math.ceil((4 * 9) / 3);
                                        const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                        if (func292(data3) < b64min1 || func292(data3) > b64max1) {
                                            validate140.errors = [
                                                {
                                                    instancePath: instancePath + '/exportID',
                                                    schemaPath: '#/properties/exportID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func292(data3) },
                                                    message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func292(data3)
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const decoded1 = func293(data3);
                                            if (decoded1.length !== 9) {
                                                validate140.errors = [
                                                    {
                                                        instancePath: instancePath + '/exportID',
                                                        schemaPath: '#/properties/exportID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'decoded' },
                                                        message: 'must decode to 9 bytes'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const encoded1 = func294(decoded1);
                                                if (func295(encoded1) !== func295(data3)) {
                                                    validate140.errors = [
                                                        {
                                                            instancePath: instancePath + '/exportID',
                                                            schemaPath: '#/properties/exportID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'ambiguous' },
                                                            message: 'encoding is ambiguous'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate140.errors = [
                                            {
                                                instancePath: instancePath + '/exportID',
                                                schemaPath: '#/properties/exportID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.exportType !== undefined) {
                                    const _errs9 = errors;
                                    if (typeof data.exportType !== 'string') {
                                        validate140.errors = [
                                            {
                                                instancePath: instancePath + '/exportType',
                                                schemaPath: '#/properties/exportType/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.exportCompletedWarnings !== undefined) {
                                        let data5 = data.exportCompletedWarnings;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (Array.isArray(data5)) {
                                                var valid3 = true;
                                                const len0 = data5.length;
                                                for (let i0 = 0; i0 < len0; i0++) {
                                                    let data6 = data5[i0];
                                                    const _errs13 = errors;
                                                    const _errs14 = errors;
                                                    if (errors === _errs14) {
                                                        if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                                            let missing1;
                                                            if (data6.code === undefined && (missing1 = 'code')) {
                                                                validate140.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/exportCompletedWarnings/' + i0,
                                                                        schemaPath: 'urn:wisepipe-common-export:ExportCompletedWarning/required',
                                                                        keyword: 'required',
                                                                        params: { missingProperty: missing1 },
                                                                        message: "must have required property '" + missing1 + "'"
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                if (data6.code !== undefined) {
                                                                    let data7 = data6.code;
                                                                    const _errs16 = errors;
                                                                    if (typeof data7 !== 'string') {
                                                                        validate140.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/exportCompletedWarnings/' + i0 + '/code',
                                                                                schemaPath: 'urn:wisepipe-common-export:ExportCompletedWarning/properties/code/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    if (!(data7 === 'GSheetsMaxCellLimitReached' || data7 === 'workdayPayrollPartialFailure')) {
                                                                        validate140.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/exportCompletedWarnings/' + i0 + '/code',
                                                                                schemaPath: 'urn:wisepipe-common-export:ExportCompletedWarning/properties/code/enum',
                                                                                keyword: 'enum',
                                                                                params: { allowedValues: schema89.properties.code.enum },
                                                                                message: 'must be equal to one of the allowed values'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid5 = _errs16 === errors;
                                                                }
                                                                else {
                                                                    var valid5 = true;
                                                                }
                                                                if (valid5) {
                                                                    if (data6.message !== undefined) {
                                                                        const _errs18 = errors;
                                                                        if (typeof data6.message !== 'string') {
                                                                            validate140.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/exportCompletedWarnings/' + i0 + '/message',
                                                                                    schemaPath: 'urn:wisepipe-common-export:ExportCompletedWarning/properties/message/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        var valid5 = _errs18 === errors;
                                                                    }
                                                                    else {
                                                                        var valid5 = true;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate140.errors = [
                                                                {
                                                                    instancePath: instancePath + '/exportCompletedWarnings/' + i0,
                                                                    schemaPath: 'urn:wisepipe-common-export:ExportCompletedWarning/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'object' },
                                                                    message: 'must be object'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid3 = _errs13 === errors;
                                                    if (!valid3) {
                                                        break;
                                                    }
                                                }
                                            }
                                            else {
                                                validate140.errors = [
                                                    {
                                                        instancePath: instancePath + '/exportCompletedWarnings',
                                                        schemaPath: '#/properties/exportCompletedWarnings/type',
                                                        keyword: 'type',
                                                        params: { type: 'array' },
                                                        message: 'must be array'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate140.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate140.errors = vErrors;
    return errors === 0;
}
export const runPreferencesSchemaValidation = validate141;
const schema154 = {
    $id: 'urn:wisepipe-common-computation:RunPreferences',
    type: 'object',
    properties: {
        pipeID: { type: 'string', uid: 10 },
        passIDs: { type: 'array', items: { type: 'string', uid: 10 }, uniqueItems: true }
    },
    required: ['pipeID', 'passIDs']
};
const func296 = ucs2length;
const func297 = base64urlToBuffer;
const func298 = base64urlEncode;
const func299 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func300 = ucs2length;
const func301 = base64urlToBuffer;
const func302 = base64urlEncode;
const func303 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate141(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:RunPreferences" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.pipeID === undefined && (missing0 = 'pipeID')) ||
                (data.passIDs === undefined && (missing0 = 'passIDs'))) {
                validate141.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pipeID !== undefined) {
                    let data0 = data.pipeID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func296(data0) < b64min0 || func296(data0) > b64max0) {
                                validate141.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func296(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func296(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func297(data0);
                                if (decoded0.length !== 10) {
                                    validate141.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func298(decoded0);
                                    if (func299(encoded0) !== func299(data0)) {
                                        validate141.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate141.errors = [
                                {
                                    instancePath: instancePath + '/pipeID',
                                    schemaPath: '#/properties/pipeID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.passIDs !== undefined) {
                        let data1 = data.passIDs;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                var valid2 = true;
                                const len0 = data1.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data2 = data1[i0];
                                    const _errs5 = errors;
                                    if (errors === _errs5) {
                                        if (typeof data2 === 'string') {
                                            const b64min1 = Math.ceil((4 * 10) / 3);
                                            const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                            if (func300(data2) < b64min1 || func300(data2) > b64max1) {
                                                validate141.errors = [
                                                    {
                                                        instancePath: instancePath + '/passIDs/' + i0,
                                                        schemaPath: '#/properties/passIDs/items/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func300(data2) },
                                                        message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func300(data2)
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const decoded1 = func301(data2);
                                                if (decoded1.length !== 10) {
                                                    validate141.errors = [
                                                        {
                                                            instancePath: instancePath + '/passIDs/' + i0,
                                                            schemaPath: '#/properties/passIDs/items/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'decoded' },
                                                            message: 'must decode to 10 bytes'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    const encoded1 = func302(decoded1);
                                                    if (func303(encoded1) !== func303(data2)) {
                                                        validate141.errors = [
                                                            {
                                                                instancePath: instancePath + '/passIDs/' + i0,
                                                                schemaPath: '#/properties/passIDs/items/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'ambiguous' },
                                                                message: 'encoding is ambiguous'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate141.errors = [
                                                {
                                                    instancePath: instancePath + '/passIDs/' + i0,
                                                    schemaPath: '#/properties/passIDs/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs5 === errors;
                                    if (!valid2) {
                                        break;
                                    }
                                }
                                if (valid2) {
                                    let i1 = data1.length;
                                    let j0;
                                    if (i1 > 1) {
                                        const indices0 = {};
                                        for (; i1--;) {
                                            let item0 = data1[i1];
                                            if (typeof item0 !== 'string') {
                                                continue;
                                            }
                                            if (typeof indices0[item0] == 'number') {
                                                j0 = indices0[item0];
                                                validate141.errors = [
                                                    {
                                                        instancePath: instancePath + '/passIDs',
                                                        schemaPath: '#/properties/passIDs/uniqueItems',
                                                        keyword: 'uniqueItems',
                                                        params: { i: i1, j: j0 },
                                                        message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                    }
                                                ];
                                                return false;
                                                break;
                                            }
                                            indices0[item0] = i1;
                                        }
                                    }
                                }
                            }
                            else {
                                validate141.errors = [
                                    {
                                        instancePath: instancePath + '/passIDs',
                                        schemaPath: '#/properties/passIDs/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate141.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate141.errors = vErrors;
    return errors === 0;
}
export const runRequestSchemaValidation = validate142;
const schema155 = {
    $id: 'urn:wisepipe-common-computation:RunRequest',
    type: 'object',
    properties: {
        pipeID: { type: 'string', uid: 10 },
        dataMap: { type: 'object', additionalProperties: { type: 'string', uid: 9 } },
        exportMap: {
            type: 'object',
            additionalProperties: { type: ['string', 'null'], if: { type: 'string' }, then: { uid: 9 } }
        },
        name: { type: 'string', minLength: 1 },
        runConfig: { type: 'object', additionalProperties: { $ref: 'urn:wisepipe-common-computation:RunConfig' } },
        transientConfig: { $ref: 'urn:wisepipe-common-computation:TransientConfig' },
        runTrigger: { type: 'string', enum: ['user', 'scheduler', 'external', 'unknown'] },
        scheduleID: { type: 'string', uid: 9 },
        selectedOutputs: { type: 'array', items: { type: 'string', uid: 10 } },
        skippedDSRefreshes: { type: 'array', items: { type: 'string', uid: 9 } },
        nodeToIsExcelExport: { type: 'object', additionalProperties: { type: 'boolean' } }
    },
    required: ['pipeID', 'dataMap'],
    not: { required: ['transientConfig', 'exportMap'] }
};
const func304 = ucs2length;
const func305 = base64urlToBuffer;
const func306 = base64urlEncode;
const func307 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func308 = ucs2length;
const func309 = base64urlToBuffer;
const func310 = base64urlEncode;
const func311 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func312 = ucs2length;
const func313 = base64urlToBuffer;
const func314 = base64urlEncode;
const func315 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func364 = ucs2length;
const func365 = base64urlToBuffer;
const func366 = base64urlEncode;
const func367 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func368 = ucs2length;
const func369 = base64urlToBuffer;
const func370 = base64urlEncode;
const func371 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func372 = ucs2length;
const func373 = base64urlToBuffer;
const func374 = base64urlEncode;
const func375 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const schema157 = {
    $id: 'urn:wisepipe-common-computation:TransientConfig',
    type: 'object',
    properties: {
        dataConfigMap: {
            type: 'object',
            additionalProperties: { $ref: 'urn:wisepipe-common-computation:TransientDataConfig' }
        },
        exportIDs: { type: 'array', items: { type: 'string', uid: 10 }, uniqueItems: true, minItems: 1 },
        exportFileMap: { type: 'object', additionalProperties: { $ref: 'urn:wisepipe-common:S3File' } },
        exportConnectorMap: {
            type: 'object',
            additionalProperties: { $ref: 'urn:wisepipe-common-export:TransientPipeExport' }
        },
        downloadFormat: { type: 'string', enum: ['csv', 'parquet'] }
    },
    required: ['exportIDs', 'dataConfigMap']
};
const schema158 = {
    $id: 'urn:wisepipe-common-computation:TransientDataConfig',
    type: 'object',
    properties: {
        fileLocation: { $ref: 'urn:wisepipe-common:S3File' },
        filePartLocations: { type: 'array', items: { $ref: 'urn:wisepipe-common:S3File' }, uniqueItems: true },
        schema: { type: 'array', items: { $ref: 'urn:wisepipe-common-data:Column' }, uniqueItems: true },
        importConfig: { $ref: 'urn:wisepipe-common-data:ImportConfig' },
        connection: { $ref: 'urn:wisepipe-common-connection:Connection' },
        credentials: { $ref: 'urn:wisepipe-common:Credentials' },
        connID: { type: 'string', uid: 9 },
        streamID: { type: 'string', minLength: 1 },
        delimiter: { type: 'string', minLength: 1 },
        quotechar: { type: 'string', minLength: 1 }
    },
    required: []
};
const func319 = ucs2length;
const func320 = base64urlToBuffer;
const func321 = base64urlEncode;
const func322 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func325 = ucs2length;
const func326 = base64urlToBuffer;
const func327 = base64urlEncode;
const func328 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func331 = ucs2length;
const func332 = base64urlToBuffer;
const func333 = base64urlEncode;
const func334 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func337 = ucs2length;
const func338 = base64urlToBuffer;
const func339 = base64urlEncode;
const func340 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate144(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:TransientDataConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.fileLocation !== undefined) {
                let data0 = data.fileLocation;
                const _errs1 = errors;
                const _errs2 = errors;
                if (errors === _errs2) {
                    if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                        let missing0;
                        if ((data0.bucket === undefined && (missing0 = 'bucket')) ||
                            (data0.key === undefined && (missing0 = 'key'))) {
                            validate144.errors = [
                                {
                                    instancePath: instancePath + '/fileLocation',
                                    schemaPath: 'urn:wisepipe-common:S3File/required',
                                    keyword: 'required',
                                    params: { missingProperty: missing0 },
                                    message: "must have required property '" + missing0 + "'"
                                }
                            ];
                            return false;
                        }
                        else {
                            if (data0.bucket !== undefined) {
                                let data1 = data0.bucket;
                                const _errs4 = errors;
                                if (errors === _errs4) {
                                    if (typeof data1 === 'string') {
                                        if (func2(data1) < 1) {
                                            validate144.errors = [
                                                {
                                                    instancePath: instancePath + '/fileLocation/bucket',
                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate144.errors = [
                                            {
                                                instancePath: instancePath + '/fileLocation/bucket',
                                                schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid2 = _errs4 === errors;
                            }
                            else {
                                var valid2 = true;
                            }
                            if (valid2) {
                                if (data0.key !== undefined) {
                                    let data2 = data0.key;
                                    const _errs6 = errors;
                                    if (errors === _errs6) {
                                        if (typeof data2 === 'string') {
                                            if (func2(data2) < 1) {
                                                validate144.errors = [
                                                    {
                                                        instancePath: instancePath + '/fileLocation/key',
                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate144.errors = [
                                                {
                                                    instancePath: instancePath + '/fileLocation/key',
                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs6 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data0.uploadID !== undefined) {
                                        let data3 = data0.uploadID;
                                        const _errs8 = errors;
                                        if (errors === _errs8) {
                                            if (typeof data3 === 'string') {
                                                const b64min0 = Math.ceil((4 * 9) / 3);
                                                const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                                if (func319(data3) < b64min0 || func319(data3) > b64max0) {
                                                    validate144.errors = [
                                                        {
                                                            instancePath: instancePath + '/fileLocation/uploadID',
                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func319(data3) },
                                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func319(data3)
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    const decoded0 = func320(data3);
                                                    if (decoded0.length !== 9) {
                                                        validate144.errors = [
                                                            {
                                                                instancePath: instancePath + '/fileLocation/uploadID',
                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'decoded' },
                                                                message: 'must decode to 9 bytes'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        const encoded0 = func321(decoded0);
                                                        if (func322(encoded0) !== func322(data3)) {
                                                            validate144.errors = [
                                                                {
                                                                    instancePath: instancePath + '/fileLocation/uploadID',
                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                    keyword: 'uid',
                                                                    params: { error: 'ambiguous' },
                                                                    message: 'encoding is ambiguous'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate144.errors = [
                                                    {
                                                        instancePath: instancePath + '/fileLocation/uploadID',
                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs8 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                }
                            }
                        }
                    }
                    else {
                        validate144.errors = [
                            {
                                instancePath: instancePath + '/fileLocation',
                                schemaPath: 'urn:wisepipe-common:S3File/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            }
                        ];
                        return false;
                    }
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.filePartLocations !== undefined) {
                    let data4 = data.filePartLocations;
                    const _errs10 = errors;
                    if (errors === _errs10) {
                        if (Array.isArray(data4)) {
                            var valid4 = true;
                            const len0 = data4.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                let data5 = data4[i0];
                                const _errs12 = errors;
                                const _errs13 = errors;
                                if (errors === _errs13) {
                                    if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                        let missing1;
                                        if ((data5.bucket === undefined && (missing1 = 'bucket')) ||
                                            (data5.key === undefined && (missing1 = 'key'))) {
                                            validate144.errors = [
                                                {
                                                    instancePath: instancePath + '/filePartLocations/' + i0,
                                                    schemaPath: 'urn:wisepipe-common:S3File/required',
                                                    keyword: 'required',
                                                    params: { missingProperty: missing1 },
                                                    message: "must have required property '" + missing1 + "'"
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (data5.bucket !== undefined) {
                                                let data6 = data5.bucket;
                                                const _errs15 = errors;
                                                if (errors === _errs15) {
                                                    if (typeof data6 === 'string') {
                                                        if (func2(data6) < 1) {
                                                            validate144.errors = [
                                                                {
                                                                    instancePath: instancePath + '/filePartLocations/' + i0 + '/bucket',
                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate144.errors = [
                                                            {
                                                                instancePath: instancePath + '/filePartLocations/' + i0 + '/bucket',
                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid6 = _errs15 === errors;
                                            }
                                            else {
                                                var valid6 = true;
                                            }
                                            if (valid6) {
                                                if (data5.key !== undefined) {
                                                    let data7 = data5.key;
                                                    const _errs17 = errors;
                                                    if (errors === _errs17) {
                                                        if (typeof data7 === 'string') {
                                                            if (func2(data7) < 1) {
                                                                validate144.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/filePartLocations/' + i0 + '/key',
                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 1 },
                                                                        message: 'must NOT have fewer than 1 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate144.errors = [
                                                                {
                                                                    instancePath: instancePath + '/filePartLocations/' + i0 + '/key',
                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid6 = _errs17 === errors;
                                                }
                                                else {
                                                    var valid6 = true;
                                                }
                                                if (valid6) {
                                                    if (data5.uploadID !== undefined) {
                                                        let data8 = data5.uploadID;
                                                        const _errs19 = errors;
                                                        if (errors === _errs19) {
                                                            if (typeof data8 === 'string') {
                                                                const b64min1 = Math.ceil((4 * 9) / 3);
                                                                const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                                                if (func325(data8) < b64min1 || func325(data8) > b64max1) {
                                                                    validate144.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/filePartLocations/' + i0 + '/uploadID',
                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                            keyword: 'uid',
                                                                            params: {
                                                                                error: 'encoded',
                                                                                b64min: b64min1,
                                                                                b64max: b64max1,
                                                                                length: func325(data8)
                                                                            },
                                                                            message: 'length must be between ' +
                                                                                b64min1 +
                                                                                ' and ' +
                                                                                b64max1 +
                                                                                ', but is ' +
                                                                                func325(data8)
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    const decoded1 = func326(data8);
                                                                    if (decoded1.length !== 9) {
                                                                        validate144.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/filePartLocations/' + i0 + '/uploadID',
                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                keyword: 'uid',
                                                                                params: { error: 'decoded' },
                                                                                message: 'must decode to 9 bytes'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    else {
                                                                        const encoded1 = func327(decoded1);
                                                                        if (func328(encoded1) !== func328(data8)) {
                                                                            validate144.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/filePartLocations/' + i0 + '/uploadID',
                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                    keyword: 'uid',
                                                                                    params: { error: 'ambiguous' },
                                                                                    message: 'encoding is ambiguous'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate144.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/filePartLocations/' + i0 + '/uploadID',
                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid6 = _errs19 === errors;
                                                    }
                                                    else {
                                                        var valid6 = true;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate144.errors = [
                                            {
                                                instancePath: instancePath + '/filePartLocations/' + i0,
                                                schemaPath: 'urn:wisepipe-common:S3File/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid4 = _errs12 === errors;
                                if (!valid4) {
                                    break;
                                }
                            }
                            if (valid4) {
                                let i1 = data4.length;
                                let j0;
                                if (i1 > 1) {
                                    outer0: for (; i1--;) {
                                        for (j0 = i1; j0--;) {
                                            if (func0(data4[i1], data4[j0])) {
                                                validate144.errors = [
                                                    {
                                                        instancePath: instancePath + '/filePartLocations',
                                                        schemaPath: '#/properties/filePartLocations/uniqueItems',
                                                        keyword: 'uniqueItems',
                                                        params: { i: i1, j: j0 },
                                                        message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                    }
                                                ];
                                                return false;
                                                break outer0;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate144.errors = [
                                {
                                    instancePath: instancePath + '/filePartLocations',
                                    schemaPath: '#/properties/filePartLocations/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs10 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.schema !== undefined) {
                        let data9 = data.schema;
                        const _errs21 = errors;
                        if (errors === _errs21) {
                            if (Array.isArray(data9)) {
                                var valid9 = true;
                                const len1 = data9.length;
                                for (let i2 = 0; i2 < len1; i2++) {
                                    const _errs23 = errors;
                                    if (!validate45(data9[i2], {
                                        instancePath: instancePath + '/schema/' + i2,
                                        parentData: data9,
                                        parentDataProperty: i2,
                                        rootData
                                    })) {
                                        vErrors = vErrors === null ? validate45.errors : vErrors.concat(validate45.errors);
                                        errors = vErrors.length;
                                    }
                                    var valid9 = _errs23 === errors;
                                    if (!valid9) {
                                        break;
                                    }
                                }
                                if (valid9) {
                                    let i3 = data9.length;
                                    let j1;
                                    if (i3 > 1) {
                                        outer1: for (; i3--;) {
                                            for (j1 = i3; j1--;) {
                                                if (func0(data9[i3], data9[j1])) {
                                                    validate144.errors = [
                                                        {
                                                            instancePath: instancePath + '/schema',
                                                            schemaPath: '#/properties/schema/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i3, j: j1 },
                                                            message: 'must NOT have duplicate items (items ## ' + j1 + ' and ' + i3 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break outer1;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate144.errors = [
                                    {
                                        instancePath: instancePath + '/schema',
                                        schemaPath: '#/properties/schema/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs21 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.importConfig !== undefined) {
                            const _errs24 = errors;
                            if (!validate84(data.importConfig, {
                                instancePath: instancePath + '/importConfig',
                                parentData: data,
                                parentDataProperty: 'importConfig',
                                rootData
                            })) {
                                vErrors = vErrors === null ? validate84.errors : vErrors.concat(validate84.errors);
                                errors = vErrors.length;
                            }
                            var valid0 = _errs24 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.connection !== undefined) {
                                let data12 = data.connection;
                                const _errs25 = errors;
                                const _errs26 = errors;
                                if (errors === _errs26) {
                                    if (data12 && typeof data12 == 'object' && !Array.isArray(data12)) {
                                        let missing2;
                                        if ((data12.connectionType === undefined && (missing2 = 'connectionType')) ||
                                            (data12.name === undefined && (missing2 = 'name'))) {
                                            validate144.errors = [
                                                {
                                                    instancePath: instancePath + '/connection',
                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/required',
                                                    keyword: 'required',
                                                    params: { missingProperty: missing2 },
                                                    message: "must have required property '" + missing2 + "'"
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (data12.connectionID !== undefined) {
                                                let data13 = data12.connectionID;
                                                const _errs28 = errors;
                                                if (errors === _errs28) {
                                                    if (typeof data13 === 'string') {
                                                        const b64min2 = Math.ceil((4 * 9) / 3);
                                                        const b64max2 = Math.ceil((4 * 9) / 3) + 3;
                                                        if (func331(data13) < b64min2 || func331(data13) > b64max2) {
                                                            validate144.errors = [
                                                                {
                                                                    instancePath: instancePath + '/connection/connectionID',
                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/uid',
                                                                    keyword: 'uid',
                                                                    params: {
                                                                        error: 'encoded',
                                                                        b64min: b64min2,
                                                                        b64max: b64max2,
                                                                        length: func331(data13)
                                                                    },
                                                                    message: 'length must be between ' +
                                                                        b64min2 +
                                                                        ' and ' +
                                                                        b64max2 +
                                                                        ', but is ' +
                                                                        func331(data13)
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            const decoded2 = func332(data13);
                                                            if (decoded2.length !== 9) {
                                                                validate144.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/connection/connectionID',
                                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/uid',
                                                                        keyword: 'uid',
                                                                        params: { error: 'decoded' },
                                                                        message: 'must decode to 9 bytes'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                const encoded2 = func333(decoded2);
                                                                if (func334(encoded2) !== func334(data13)) {
                                                                    validate144.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/connection/connectionID',
                                                                            schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/uid',
                                                                            keyword: 'uid',
                                                                            params: { error: 'ambiguous' },
                                                                            message: 'encoding is ambiguous'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate144.errors = [
                                                            {
                                                                instancePath: instancePath + '/connection/connectionID',
                                                                schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid12 = _errs28 === errors;
                                            }
                                            else {
                                                var valid12 = true;
                                            }
                                            if (valid12) {
                                                if (data12.connectionType !== undefined) {
                                                    let data14 = data12.connectionType;
                                                    const _errs30 = errors;
                                                    if (typeof data14 !== 'string') {
                                                        validate144.errors = [
                                                            {
                                                                instancePath: instancePath + '/connection/connectionType',
                                                                schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionType/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    if (!(data14 === 'google' ||
                                                        data14 === 'gsheetsImport' ||
                                                        data14 === 'gsheetsExport' ||
                                                        data14 === 'shopify' ||
                                                        data14 === 'salesForce' ||
                                                        data14 === 'postgreSql' ||
                                                        data14 === 'icm' ||
                                                        data14 === 'tq-postgres' ||
                                                        data14 === 'mySql' ||
                                                        data14 === 'msSql' ||
                                                        data14 === 'oracle' ||
                                                        data14 === 'amazonRedshift' ||
                                                        data14 === 'amazonAurora' ||
                                                        data14 === 'amazonS3' ||
                                                        data14 === 'amazonS3Export' ||
                                                        data14 === 'tqp' ||
                                                        data14 === 'hubspot' ||
                                                        data14 === 'symon' ||
                                                        data14 === 'snowflake' ||
                                                        data14 === 'dynamics' ||
                                                        data14 === 'agentSync' ||
                                                        data14 === 'workday' ||
                                                        data14 === 'workdayRaaS' ||
                                                        data14 === 'workdayExport' ||
                                                        data14 === 'tableau' ||
                                                        data14 === 'sftp' ||
                                                        data14 === 'powerbi' ||
                                                        data14 === 'rest' ||
                                                        data14 === 'gong' ||
                                                        data14 === 'netSuite' ||
                                                        data14 === 'oneDrive' ||
                                                        data14 === 'oneDriveExport' ||
                                                        data14 === 'sapSuccessFactors' ||
                                                        data14 === 'sapCrm' ||
                                                        data14 === 'ukg' ||
                                                        data14 === 'oracleHcm' ||
                                                        data14 === 'Adp' ||
                                                        data14 === 'dynamics365Sales' ||
                                                        data14 === 'ceridianDayforce' ||
                                                        data14 === 'oracleCrm' ||
                                                        data14 === 'oracleErpCloud' ||
                                                        data14 === 'sageIntacct' ||
                                                        data14 === 'bambooHr' ||
                                                        data14 === 'sapErp' ||
                                                        data14 === 'googleCloudPlatformCloudStorage' ||
                                                        data14 === 'sas' ||
                                                        data14 === 'dropbox' ||
                                                        data14 === 'googleDrive' ||
                                                        data14 === 'jira' ||
                                                        data14 === 'monday' ||
                                                        data14 === 'zuora' ||
                                                        data14 === 'adobeAnalytics' ||
                                                        data14 === 'zoomInfo' ||
                                                        data14 === 'marketo' ||
                                                        data14 === 'activeCampaign' ||
                                                        data14 === 'mailchimp' ||
                                                        data14 === 'infor' ||
                                                        data14 === 'cornerstoneOnDemand' ||
                                                        data14 === 'gusto' ||
                                                        data14 === 'paychexFlex' ||
                                                        data14 === 'zendesk' ||
                                                        data14 === 'serviceNow' ||
                                                        data14 === 'zohoCrm' ||
                                                        data14 === 'pipedrive' ||
                                                        data14 === 'quickBooks' ||
                                                        data14 === 'xero' ||
                                                        data14 === 'freshbooks' ||
                                                        data14 === 'zohoBooks' ||
                                                        data14 === 'waveFinancial')) {
                                                        validate144.errors = [
                                                            {
                                                                instancePath: instancePath + '/connection/connectionType',
                                                                schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionType/enum',
                                                                keyword: 'enum',
                                                                params: { allowedValues: schema71.properties.connectionType.enum },
                                                                message: 'must be equal to one of the allowed values'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid12 = _errs30 === errors;
                                                }
                                                else {
                                                    var valid12 = true;
                                                }
                                                if (valid12) {
                                                    if (data12.name !== undefined) {
                                                        let data15 = data12.name;
                                                        const _errs32 = errors;
                                                        if (errors === _errs32) {
                                                            if (typeof data15 === 'string') {
                                                                if (func2(data15) < 1) {
                                                                    validate144.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/connection/name',
                                                                            schemaPath: 'urn:wisepipe-common-connection:Connection/properties/name/minLength',
                                                                            keyword: 'minLength',
                                                                            params: { limit: 1 },
                                                                            message: 'must NOT have fewer than 1 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate144.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/connection/name',
                                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/properties/name/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid12 = _errs32 === errors;
                                                    }
                                                    else {
                                                        var valid12 = true;
                                                    }
                                                    if (valid12) {
                                                        if (data12.source !== undefined) {
                                                            let data16 = data12.source;
                                                            const _errs34 = errors;
                                                            if (errors === _errs34) {
                                                                if (typeof data16 === 'string') {
                                                                    if (func2(data16) < 1) {
                                                                        validate144.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/connection/source',
                                                                                schemaPath: 'urn:wisepipe-common-connection:Connection/properties/source/minLength',
                                                                                keyword: 'minLength',
                                                                                params: { limit: 1 },
                                                                                message: 'must NOT have fewer than 1 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate144.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/connection/source',
                                                                            schemaPath: 'urn:wisepipe-common-connection:Connection/properties/source/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid12 = _errs34 === errors;
                                                        }
                                                        else {
                                                            var valid12 = true;
                                                        }
                                                        if (valid12) {
                                                            if (data12.failedOnLastTry !== undefined) {
                                                                const _errs36 = errors;
                                                                if (typeof data12.failedOnLastTry !== 'boolean') {
                                                                    validate144.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/connection/failedOnLastTry',
                                                                            schemaPath: 'urn:wisepipe-common-connection:Connection/properties/failedOnLastTry/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'boolean' },
                                                                            message: 'must be boolean'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid12 = _errs36 === errors;
                                                            }
                                                            else {
                                                                var valid12 = true;
                                                            }
                                                            if (valid12) {
                                                                if (data12.isDiscoveryFail !== undefined) {
                                                                    const _errs38 = errors;
                                                                    if (typeof data12.isDiscoveryFail !== 'boolean') {
                                                                        validate144.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/connection/isDiscoveryFail',
                                                                                schemaPath: 'urn:wisepipe-common-connection:Connection/properties/isDiscoveryFail/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'boolean' },
                                                                                message: 'must be boolean'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid12 = _errs38 === errors;
                                                                }
                                                                else {
                                                                    var valid12 = true;
                                                                }
                                                                if (valid12) {
                                                                    if (data12.verificationErrorMessage !== undefined) {
                                                                        const _errs40 = errors;
                                                                        if (typeof data12.verificationErrorMessage !== 'string') {
                                                                            validate144.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/connection/verificationErrorMessage',
                                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/verificationErrorMessage/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        var valid12 = _errs40 === errors;
                                                                    }
                                                                    else {
                                                                        var valid12 = true;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate144.errors = [
                                            {
                                                instancePath: instancePath + '/connection',
                                                schemaPath: 'urn:wisepipe-common-connection:Connection/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs25 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.credentials !== undefined) {
                                    let data20 = data.credentials;
                                    const _errs42 = errors;
                                    const _errs43 = errors;
                                    if (errors === _errs43) {
                                        if (data20 && typeof data20 == 'object' && !Array.isArray(data20)) {
                                            let missing3;
                                            if (data20.credentialsType === undefined && (missing3 = 'credentialsType')) {
                                                validate144.errors = [
                                                    {
                                                        instancePath: instancePath + '/credentials',
                                                        schemaPath: 'urn:wisepipe-common:Credentials/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing3 },
                                                        message: "must have required property '" + missing3 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data20.credentialsType !== undefined) {
                                                    let data21 = data20.credentialsType;
                                                    if (typeof data21 !== 'string') {
                                                        validate144.errors = [
                                                            {
                                                                instancePath: instancePath + '/credentials/credentialsType',
                                                                schemaPath: 'urn:wisepipe-common:Credentials/properties/credentialsType/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    if (!(data21 === 'oauth' ||
                                                        data21 === 'userPassword' ||
                                                        data21 === 's3Credentials' ||
                                                        data21 === 'apiKey' ||
                                                        data21 === 'symon' ||
                                                        data21 === 'awsRoleAssumption' ||
                                                        data21 === 'rest' ||
                                                        data21 === 'tokenBasedAuthentication')) {
                                                        validate144.errors = [
                                                            {
                                                                instancePath: instancePath + '/credentials/credentialsType',
                                                                schemaPath: 'urn:wisepipe-common:Credentials/properties/credentialsType/enum',
                                                                keyword: 'enum',
                                                                params: { allowedValues: schema76.properties.credentialsType.enum },
                                                                message: 'must be equal to one of the allowed values'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate144.errors = [
                                                {
                                                    instancePath: instancePath + '/credentials',
                                                    schemaPath: 'urn:wisepipe-common:Credentials/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs42 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.connID !== undefined) {
                                        let data22 = data.connID;
                                        const _errs47 = errors;
                                        if (errors === _errs47) {
                                            if (typeof data22 === 'string') {
                                                const b64min3 = Math.ceil((4 * 9) / 3);
                                                const b64max3 = Math.ceil((4 * 9) / 3) + 3;
                                                if (func337(data22) < b64min3 || func337(data22) > b64max3) {
                                                    validate144.errors = [
                                                        {
                                                            instancePath: instancePath + '/connID',
                                                            schemaPath: '#/properties/connID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'encoded', b64min: b64min3, b64max: b64max3, length: func337(data22) },
                                                            message: 'length must be between ' + b64min3 + ' and ' + b64max3 + ', but is ' + func337(data22)
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    const decoded3 = func338(data22);
                                                    if (decoded3.length !== 9) {
                                                        validate144.errors = [
                                                            {
                                                                instancePath: instancePath + '/connID',
                                                                schemaPath: '#/properties/connID/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'decoded' },
                                                                message: 'must decode to 9 bytes'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        const encoded3 = func339(decoded3);
                                                        if (func340(encoded3) !== func340(data22)) {
                                                            validate144.errors = [
                                                                {
                                                                    instancePath: instancePath + '/connID',
                                                                    schemaPath: '#/properties/connID/uid',
                                                                    keyword: 'uid',
                                                                    params: { error: 'ambiguous' },
                                                                    message: 'encoding is ambiguous'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate144.errors = [
                                                    {
                                                        instancePath: instancePath + '/connID',
                                                        schemaPath: '#/properties/connID/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs47 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.streamID !== undefined) {
                                            let data23 = data.streamID;
                                            const _errs49 = errors;
                                            if (errors === _errs49) {
                                                if (typeof data23 === 'string') {
                                                    if (func2(data23) < 1) {
                                                        validate144.errors = [
                                                            {
                                                                instancePath: instancePath + '/streamID',
                                                                schemaPath: '#/properties/streamID/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate144.errors = [
                                                        {
                                                            instancePath: instancePath + '/streamID',
                                                            schemaPath: '#/properties/streamID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs49 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.delimiter !== undefined) {
                                                let data24 = data.delimiter;
                                                const _errs51 = errors;
                                                if (errors === _errs51) {
                                                    if (typeof data24 === 'string') {
                                                        if (func2(data24) < 1) {
                                                            validate144.errors = [
                                                                {
                                                                    instancePath: instancePath + '/delimiter',
                                                                    schemaPath: '#/properties/delimiter/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate144.errors = [
                                                            {
                                                                instancePath: instancePath + '/delimiter',
                                                                schemaPath: '#/properties/delimiter/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid0 = _errs51 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.quotechar !== undefined) {
                                                    let data25 = data.quotechar;
                                                    const _errs53 = errors;
                                                    if (errors === _errs53) {
                                                        if (typeof data25 === 'string') {
                                                            if (func2(data25) < 1) {
                                                                validate144.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/quotechar',
                                                                        schemaPath: '#/properties/quotechar/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 1 },
                                                                        message: 'must NOT have fewer than 1 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate144.errors = [
                                                                {
                                                                    instancePath: instancePath + '/quotechar',
                                                                    schemaPath: '#/properties/quotechar/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid0 = _errs53 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate144.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate144.errors = vErrors;
    return errors === 0;
}
const schema164 = {
    $id: 'urn:wisepipe-common-export:TransientPipeExport',
    type: 'object',
    properties: {
        exportSettings: { $ref: 'urn:wisepipe-common-export:ExportSettings' },
        connection: { $ref: 'urn:wisepipe-common-connection:Connection' },
        credentials: { $ref: 'urn:wisepipe-common:Credentials' },
        connID: { type: 'string', uid: 9 }
    },
    required: ['exportSettings']
};
const func354 = ucs2length;
const func355 = base64urlToBuffer;
const func356 = base64urlEncode;
const func357 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func360 = ucs2length;
const func361 = base64urlToBuffer;
const func362 = base64urlEncode;
const func363 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate148(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:TransientPipeExport" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.exportSettings === undefined && (missing0 = 'exportSettings')) {
                validate148.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.exportSettings !== undefined) {
                    let data0 = data.exportSettings;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    if (errors === _errs2) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if (data0.exportType === undefined && (missing1 = 'exportType')) {
                                validate148.errors = [
                                    {
                                        instancePath: instancePath + '/exportSettings',
                                        schemaPath: 'urn:wisepipe-common-export:ExportSettings/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.exportType !== undefined) {
                                    let data1 = data0.exportType;
                                    if (typeof data1 !== 'string') {
                                        validate148.errors = [
                                            {
                                                instancePath: instancePath + '/exportSettings/exportType',
                                                schemaPath: 'urn:wisepipe-common-export:ExportSettings/properties/exportType/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data1 === 'gsheets' ||
                                        data1 === 'icm' ||
                                        data1 === 'postgres' ||
                                        data1 === 'tq-postgres' ||
                                        data1 === 'powerbi' ||
                                        data1 === 'symon' ||
                                        data1 === 'salesForce' ||
                                        data1 === 'workday-payroll' ||
                                        data1 === 'tableau' ||
                                        data1 === 'tqp' ||
                                        data1 === 'sftp' ||
                                        data1 === 's3-csv' ||
                                        data1 === 'snowflake' ||
                                        data1 === 's3parquet' ||
                                        data1 === 'msSql' ||
                                        data1 === 'oneDrive')) {
                                        validate148.errors = [
                                            {
                                                instancePath: instancePath + '/exportSettings/exportType',
                                                schemaPath: 'urn:wisepipe-common-export:ExportSettings/properties/exportType/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema91.properties.exportType.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate148.errors = [
                                {
                                    instancePath: instancePath + '/exportSettings',
                                    schemaPath: 'urn:wisepipe-common-export:ExportSettings/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.connection !== undefined) {
                        let data2 = data.connection;
                        const _errs6 = errors;
                        const _errs7 = errors;
                        if (errors === _errs7) {
                            if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                let missing2;
                                if ((data2.connectionType === undefined && (missing2 = 'connectionType')) ||
                                    (data2.name === undefined && (missing2 = 'name'))) {
                                    validate148.errors = [
                                        {
                                            instancePath: instancePath + '/connection',
                                            schemaPath: 'urn:wisepipe-common-connection:Connection/required',
                                            keyword: 'required',
                                            params: { missingProperty: missing2 },
                                            message: "must have required property '" + missing2 + "'"
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data2.connectionID !== undefined) {
                                        let data3 = data2.connectionID;
                                        const _errs9 = errors;
                                        if (errors === _errs9) {
                                            if (typeof data3 === 'string') {
                                                const b64min0 = Math.ceil((4 * 9) / 3);
                                                const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                                if (func354(data3) < b64min0 || func354(data3) > b64max0) {
                                                    validate148.errors = [
                                                        {
                                                            instancePath: instancePath + '/connection/connectionID',
                                                            schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func354(data3) },
                                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func354(data3)
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    const decoded0 = func355(data3);
                                                    if (decoded0.length !== 9) {
                                                        validate148.errors = [
                                                            {
                                                                instancePath: instancePath + '/connection/connectionID',
                                                                schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'decoded' },
                                                                message: 'must decode to 9 bytes'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        const encoded0 = func356(decoded0);
                                                        if (func357(encoded0) !== func357(data3)) {
                                                            validate148.errors = [
                                                                {
                                                                    instancePath: instancePath + '/connection/connectionID',
                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/uid',
                                                                    keyword: 'uid',
                                                                    params: { error: 'ambiguous' },
                                                                    message: 'encoding is ambiguous'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate148.errors = [
                                                    {
                                                        instancePath: instancePath + '/connection/connectionID',
                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid4 = _errs9 === errors;
                                    }
                                    else {
                                        var valid4 = true;
                                    }
                                    if (valid4) {
                                        if (data2.connectionType !== undefined) {
                                            let data4 = data2.connectionType;
                                            const _errs11 = errors;
                                            if (typeof data4 !== 'string') {
                                                validate148.errors = [
                                                    {
                                                        instancePath: instancePath + '/connection/connectionType',
                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionType/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            if (!(data4 === 'google' ||
                                                data4 === 'gsheetsImport' ||
                                                data4 === 'gsheetsExport' ||
                                                data4 === 'shopify' ||
                                                data4 === 'salesForce' ||
                                                data4 === 'postgreSql' ||
                                                data4 === 'icm' ||
                                                data4 === 'tq-postgres' ||
                                                data4 === 'mySql' ||
                                                data4 === 'msSql' ||
                                                data4 === 'oracle' ||
                                                data4 === 'amazonRedshift' ||
                                                data4 === 'amazonAurora' ||
                                                data4 === 'amazonS3' ||
                                                data4 === 'amazonS3Export' ||
                                                data4 === 'tqp' ||
                                                data4 === 'hubspot' ||
                                                data4 === 'symon' ||
                                                data4 === 'snowflake' ||
                                                data4 === 'dynamics' ||
                                                data4 === 'agentSync' ||
                                                data4 === 'workday' ||
                                                data4 === 'workdayRaaS' ||
                                                data4 === 'workdayExport' ||
                                                data4 === 'tableau' ||
                                                data4 === 'sftp' ||
                                                data4 === 'powerbi' ||
                                                data4 === 'rest' ||
                                                data4 === 'gong' ||
                                                data4 === 'netSuite' ||
                                                data4 === 'oneDrive' ||
                                                data4 === 'oneDriveExport' ||
                                                data4 === 'sapSuccessFactors' ||
                                                data4 === 'sapCrm' ||
                                                data4 === 'ukg' ||
                                                data4 === 'oracleHcm' ||
                                                data4 === 'Adp' ||
                                                data4 === 'dynamics365Sales' ||
                                                data4 === 'ceridianDayforce' ||
                                                data4 === 'oracleCrm' ||
                                                data4 === 'oracleErpCloud' ||
                                                data4 === 'sageIntacct' ||
                                                data4 === 'bambooHr' ||
                                                data4 === 'sapErp' ||
                                                data4 === 'googleCloudPlatformCloudStorage' ||
                                                data4 === 'sas' ||
                                                data4 === 'dropbox' ||
                                                data4 === 'googleDrive' ||
                                                data4 === 'jira' ||
                                                data4 === 'monday' ||
                                                data4 === 'zuora' ||
                                                data4 === 'adobeAnalytics' ||
                                                data4 === 'zoomInfo' ||
                                                data4 === 'marketo' ||
                                                data4 === 'activeCampaign' ||
                                                data4 === 'mailchimp' ||
                                                data4 === 'infor' ||
                                                data4 === 'cornerstoneOnDemand' ||
                                                data4 === 'gusto' ||
                                                data4 === 'paychexFlex' ||
                                                data4 === 'zendesk' ||
                                                data4 === 'serviceNow' ||
                                                data4 === 'zohoCrm' ||
                                                data4 === 'pipedrive' ||
                                                data4 === 'quickBooks' ||
                                                data4 === 'xero' ||
                                                data4 === 'freshbooks' ||
                                                data4 === 'zohoBooks' ||
                                                data4 === 'waveFinancial')) {
                                                validate148.errors = [
                                                    {
                                                        instancePath: instancePath + '/connection/connectionType',
                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionType/enum',
                                                        keyword: 'enum',
                                                        params: { allowedValues: schema71.properties.connectionType.enum },
                                                        message: 'must be equal to one of the allowed values'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid4 = _errs11 === errors;
                                        }
                                        else {
                                            var valid4 = true;
                                        }
                                        if (valid4) {
                                            if (data2.name !== undefined) {
                                                let data5 = data2.name;
                                                const _errs13 = errors;
                                                if (errors === _errs13) {
                                                    if (typeof data5 === 'string') {
                                                        if (func2(data5) < 1) {
                                                            validate148.errors = [
                                                                {
                                                                    instancePath: instancePath + '/connection/name',
                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/name/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate148.errors = [
                                                            {
                                                                instancePath: instancePath + '/connection/name',
                                                                schemaPath: 'urn:wisepipe-common-connection:Connection/properties/name/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid4 = _errs13 === errors;
                                            }
                                            else {
                                                var valid4 = true;
                                            }
                                            if (valid4) {
                                                if (data2.source !== undefined) {
                                                    let data6 = data2.source;
                                                    const _errs15 = errors;
                                                    if (errors === _errs15) {
                                                        if (typeof data6 === 'string') {
                                                            if (func2(data6) < 1) {
                                                                validate148.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/connection/source',
                                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/properties/source/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 1 },
                                                                        message: 'must NOT have fewer than 1 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate148.errors = [
                                                                {
                                                                    instancePath: instancePath + '/connection/source',
                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/source/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid4 = _errs15 === errors;
                                                }
                                                else {
                                                    var valid4 = true;
                                                }
                                                if (valid4) {
                                                    if (data2.failedOnLastTry !== undefined) {
                                                        const _errs17 = errors;
                                                        if (typeof data2.failedOnLastTry !== 'boolean') {
                                                            validate148.errors = [
                                                                {
                                                                    instancePath: instancePath + '/connection/failedOnLastTry',
                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/failedOnLastTry/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'boolean' },
                                                                    message: 'must be boolean'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid4 = _errs17 === errors;
                                                    }
                                                    else {
                                                        var valid4 = true;
                                                    }
                                                    if (valid4) {
                                                        if (data2.isDiscoveryFail !== undefined) {
                                                            const _errs19 = errors;
                                                            if (typeof data2.isDiscoveryFail !== 'boolean') {
                                                                validate148.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/connection/isDiscoveryFail',
                                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/properties/isDiscoveryFail/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'boolean' },
                                                                        message: 'must be boolean'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid4 = _errs19 === errors;
                                                        }
                                                        else {
                                                            var valid4 = true;
                                                        }
                                                        if (valid4) {
                                                            if (data2.verificationErrorMessage !== undefined) {
                                                                const _errs21 = errors;
                                                                if (typeof data2.verificationErrorMessage !== 'string') {
                                                                    validate148.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/connection/verificationErrorMessage',
                                                                            schemaPath: 'urn:wisepipe-common-connection:Connection/properties/verificationErrorMessage/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid4 = _errs21 === errors;
                                                            }
                                                            else {
                                                                var valid4 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate148.errors = [
                                    {
                                        instancePath: instancePath + '/connection',
                                        schemaPath: 'urn:wisepipe-common-connection:Connection/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs6 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.credentials !== undefined) {
                            let data10 = data.credentials;
                            const _errs23 = errors;
                            const _errs24 = errors;
                            if (errors === _errs24) {
                                if (data10 && typeof data10 == 'object' && !Array.isArray(data10)) {
                                    let missing3;
                                    if (data10.credentialsType === undefined && (missing3 = 'credentialsType')) {
                                        validate148.errors = [
                                            {
                                                instancePath: instancePath + '/credentials',
                                                schemaPath: 'urn:wisepipe-common:Credentials/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing3 },
                                                message: "must have required property '" + missing3 + "'"
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (data10.credentialsType !== undefined) {
                                            let data11 = data10.credentialsType;
                                            if (typeof data11 !== 'string') {
                                                validate148.errors = [
                                                    {
                                                        instancePath: instancePath + '/credentials/credentialsType',
                                                        schemaPath: 'urn:wisepipe-common:Credentials/properties/credentialsType/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            if (!(data11 === 'oauth' ||
                                                data11 === 'userPassword' ||
                                                data11 === 's3Credentials' ||
                                                data11 === 'apiKey' ||
                                                data11 === 'symon' ||
                                                data11 === 'awsRoleAssumption' ||
                                                data11 === 'rest' ||
                                                data11 === 'tokenBasedAuthentication')) {
                                                validate148.errors = [
                                                    {
                                                        instancePath: instancePath + '/credentials/credentialsType',
                                                        schemaPath: 'urn:wisepipe-common:Credentials/properties/credentialsType/enum',
                                                        keyword: 'enum',
                                                        params: { allowedValues: schema76.properties.credentialsType.enum },
                                                        message: 'must be equal to one of the allowed values'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate148.errors = [
                                        {
                                            instancePath: instancePath + '/credentials',
                                            schemaPath: 'urn:wisepipe-common:Credentials/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs23 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.connID !== undefined) {
                                let data12 = data.connID;
                                const _errs28 = errors;
                                if (errors === _errs28) {
                                    if (typeof data12 === 'string') {
                                        const b64min1 = Math.ceil((4 * 9) / 3);
                                        const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                        if (func360(data12) < b64min1 || func360(data12) > b64max1) {
                                            validate148.errors = [
                                                {
                                                    instancePath: instancePath + '/connID',
                                                    schemaPath: '#/properties/connID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func360(data12) },
                                                    message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func360(data12)
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const decoded1 = func361(data12);
                                            if (decoded1.length !== 9) {
                                                validate148.errors = [
                                                    {
                                                        instancePath: instancePath + '/connID',
                                                        schemaPath: '#/properties/connID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'decoded' },
                                                        message: 'must decode to 9 bytes'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const encoded1 = func362(decoded1);
                                                if (func363(encoded1) !== func363(data12)) {
                                                    validate148.errors = [
                                                        {
                                                            instancePath: instancePath + '/connID',
                                                            schemaPath: '#/properties/connID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'ambiguous' },
                                                            message: 'encoding is ambiguous'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate148.errors = [
                                            {
                                                instancePath: instancePath + '/connID',
                                                schemaPath: '#/properties/connID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs28 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate148.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate148.errors = vErrors;
    return errors === 0;
}
const func344 = ucs2length;
const func345 = base64urlToBuffer;
const func346 = base64urlEncode;
const func347 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func350 = ucs2length;
const func351 = base64urlToBuffer;
const func352 = base64urlEncode;
const func353 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate143(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:TransientConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.exportIDs === undefined && (missing0 = 'exportIDs')) ||
                (data.dataConfigMap === undefined && (missing0 = 'dataConfigMap'))) {
                validate143.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.dataConfigMap !== undefined) {
                    let data0 = data.dataConfigMap;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            for (const key0 in data0) {
                                const _errs4 = errors;
                                if (!validate144(data0[key0], {
                                    instancePath: instancePath + '/dataConfigMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                    parentData: data0,
                                    parentDataProperty: key0,
                                    rootData
                                })) {
                                    vErrors = vErrors === null ? validate144.errors : vErrors.concat(validate144.errors);
                                    errors = vErrors.length;
                                }
                                var valid1 = _errs4 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                        }
                        else {
                            validate143.errors = [
                                {
                                    instancePath: instancePath + '/dataConfigMap',
                                    schemaPath: '#/properties/dataConfigMap/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.exportIDs !== undefined) {
                        let data2 = data.exportIDs;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (Array.isArray(data2)) {
                                if (data2.length < 1) {
                                    validate143.errors = [
                                        {
                                            instancePath: instancePath + '/exportIDs',
                                            schemaPath: '#/properties/exportIDs/minItems',
                                            keyword: 'minItems',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid2 = true;
                                    const len0 = data2.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data3 = data2[i0];
                                        const _errs7 = errors;
                                        if (errors === _errs7) {
                                            if (typeof data3 === 'string') {
                                                const b64min0 = Math.ceil((4 * 10) / 3);
                                                const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                                                if (func344(data3) < b64min0 || func344(data3) > b64max0) {
                                                    validate143.errors = [
                                                        {
                                                            instancePath: instancePath + '/exportIDs/' + i0,
                                                            schemaPath: '#/properties/exportIDs/items/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func344(data3) },
                                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func344(data3)
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    const decoded0 = func345(data3);
                                                    if (decoded0.length !== 10) {
                                                        validate143.errors = [
                                                            {
                                                                instancePath: instancePath + '/exportIDs/' + i0,
                                                                schemaPath: '#/properties/exportIDs/items/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'decoded' },
                                                                message: 'must decode to 10 bytes'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        const encoded0 = func346(decoded0);
                                                        if (func347(encoded0) !== func347(data3)) {
                                                            validate143.errors = [
                                                                {
                                                                    instancePath: instancePath + '/exportIDs/' + i0,
                                                                    schemaPath: '#/properties/exportIDs/items/uid',
                                                                    keyword: 'uid',
                                                                    params: { error: 'ambiguous' },
                                                                    message: 'encoding is ambiguous'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate143.errors = [
                                                    {
                                                        instancePath: instancePath + '/exportIDs/' + i0,
                                                        schemaPath: '#/properties/exportIDs/items/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs7 === errors;
                                        if (!valid2) {
                                            break;
                                        }
                                    }
                                    if (valid2) {
                                        let i1 = data2.length;
                                        let j0;
                                        if (i1 > 1) {
                                            const indices0 = {};
                                            for (; i1--;) {
                                                let item0 = data2[i1];
                                                if (typeof item0 !== 'string') {
                                                    continue;
                                                }
                                                if (typeof indices0[item0] == 'number') {
                                                    j0 = indices0[item0];
                                                    validate143.errors = [
                                                        {
                                                            instancePath: instancePath + '/exportIDs',
                                                            schemaPath: '#/properties/exportIDs/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i1, j: j0 },
                                                            message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break;
                                                }
                                                indices0[item0] = i1;
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate143.errors = [
                                    {
                                        instancePath: instancePath + '/exportIDs',
                                        schemaPath: '#/properties/exportIDs/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.exportFileMap !== undefined) {
                            let data4 = data.exportFileMap;
                            const _errs9 = errors;
                            if (errors === _errs9) {
                                if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                                    for (const key1 in data4) {
                                        let data5 = data4[key1];
                                        const _errs12 = errors;
                                        const _errs13 = errors;
                                        if (errors === _errs13) {
                                            if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                                let missing1;
                                                if ((data5.bucket === undefined && (missing1 = 'bucket')) ||
                                                    (data5.key === undefined && (missing1 = 'key'))) {
                                                    validate143.errors = [
                                                        {
                                                            instancePath: instancePath + '/exportFileMap/' + key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                            schemaPath: 'urn:wisepipe-common:S3File/required',
                                                            keyword: 'required',
                                                            params: { missingProperty: missing1 },
                                                            message: "must have required property '" + missing1 + "'"
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (data5.bucket !== undefined) {
                                                        let data6 = data5.bucket;
                                                        const _errs15 = errors;
                                                        if (errors === _errs15) {
                                                            if (typeof data6 === 'string') {
                                                                if (func2(data6) < 1) {
                                                                    validate143.errors = [
                                                                        {
                                                                            instancePath: instancePath +
                                                                                '/exportFileMap/' +
                                                                                key1.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                '/bucket',
                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                            keyword: 'minLength',
                                                                            params: { limit: 1 },
                                                                            message: 'must NOT have fewer than 1 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate143.errors = [
                                                                    {
                                                                        instancePath: instancePath +
                                                                            '/exportFileMap/' +
                                                                            key1.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                            '/bucket',
                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid7 = _errs15 === errors;
                                                    }
                                                    else {
                                                        var valid7 = true;
                                                    }
                                                    if (valid7) {
                                                        if (data5.key !== undefined) {
                                                            let data7 = data5.key;
                                                            const _errs17 = errors;
                                                            if (errors === _errs17) {
                                                                if (typeof data7 === 'string') {
                                                                    if (func2(data7) < 1) {
                                                                        validate143.errors = [
                                                                            {
                                                                                instancePath: instancePath +
                                                                                    '/exportFileMap/' +
                                                                                    key1.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                    '/key',
                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                                keyword: 'minLength',
                                                                                params: { limit: 1 },
                                                                                message: 'must NOT have fewer than 1 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate143.errors = [
                                                                        {
                                                                            instancePath: instancePath +
                                                                                '/exportFileMap/' +
                                                                                key1.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                '/key',
                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid7 = _errs17 === errors;
                                                        }
                                                        else {
                                                            var valid7 = true;
                                                        }
                                                        if (valid7) {
                                                            if (data5.uploadID !== undefined) {
                                                                let data8 = data5.uploadID;
                                                                const _errs19 = errors;
                                                                if (errors === _errs19) {
                                                                    if (typeof data8 === 'string') {
                                                                        const b64min1 = Math.ceil((4 * 9) / 3);
                                                                        const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                                                        if (func350(data8) < b64min1 || func350(data8) > b64max1) {
                                                                            validate143.errors = [
                                                                                {
                                                                                    instancePath: instancePath +
                                                                                        '/exportFileMap/' +
                                                                                        key1.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                        '/uploadID',
                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                    keyword: 'uid',
                                                                                    params: {
                                                                                        error: 'encoded',
                                                                                        b64min: b64min1,
                                                                                        b64max: b64max1,
                                                                                        length: func350(data8)
                                                                                    },
                                                                                    message: 'length must be between ' +
                                                                                        b64min1 +
                                                                                        ' and ' +
                                                                                        b64max1 +
                                                                                        ', but is ' +
                                                                                        func350(data8)
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        else {
                                                                            const decoded1 = func351(data8);
                                                                            if (decoded1.length !== 9) {
                                                                                validate143.errors = [
                                                                                    {
                                                                                        instancePath: instancePath +
                                                                                            '/exportFileMap/' +
                                                                                            key1.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                            '/uploadID',
                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                        keyword: 'uid',
                                                                                        params: { error: 'decoded' },
                                                                                        message: 'must decode to 9 bytes'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            else {
                                                                                const encoded1 = func352(decoded1);
                                                                                if (func353(encoded1) !== func353(data8)) {
                                                                                    validate143.errors = [
                                                                                        {
                                                                                            instancePath: instancePath +
                                                                                                '/exportFileMap/' +
                                                                                                key1.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                '/uploadID',
                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                            keyword: 'uid',
                                                                                            params: { error: 'ambiguous' },
                                                                                            message: 'encoding is ambiguous'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate143.errors = [
                                                                            {
                                                                                instancePath: instancePath +
                                                                                    '/exportFileMap/' +
                                                                                    key1.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                    '/uploadID',
                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid7 = _errs19 === errors;
                                                            }
                                                            else {
                                                                var valid7 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate143.errors = [
                                                    {
                                                        instancePath: instancePath + '/exportFileMap/' + key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                        schemaPath: 'urn:wisepipe-common:S3File/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid5 = _errs12 === errors;
                                        if (!valid5) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate143.errors = [
                                        {
                                            instancePath: instancePath + '/exportFileMap',
                                            schemaPath: '#/properties/exportFileMap/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs9 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.exportConnectorMap !== undefined) {
                                let data9 = data.exportConnectorMap;
                                const _errs21 = errors;
                                if (errors === _errs21) {
                                    if (data9 && typeof data9 == 'object' && !Array.isArray(data9)) {
                                        for (const key2 in data9) {
                                            const _errs24 = errors;
                                            if (!validate148(data9[key2], {
                                                instancePath: instancePath + '/exportConnectorMap/' + key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                parentData: data9,
                                                parentDataProperty: key2,
                                                rootData
                                            })) {
                                                vErrors = vErrors === null ? validate148.errors : vErrors.concat(validate148.errors);
                                                errors = vErrors.length;
                                            }
                                            var valid9 = _errs24 === errors;
                                            if (!valid9) {
                                                break;
                                            }
                                        }
                                    }
                                    else {
                                        validate143.errors = [
                                            {
                                                instancePath: instancePath + '/exportConnectorMap',
                                                schemaPath: '#/properties/exportConnectorMap/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs21 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.downloadFormat !== undefined) {
                                    let data11 = data.downloadFormat;
                                    const _errs25 = errors;
                                    if (typeof data11 !== 'string') {
                                        validate143.errors = [
                                            {
                                                instancePath: instancePath + '/downloadFormat',
                                                schemaPath: '#/properties/downloadFormat/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data11 === 'csv' || data11 === 'parquet')) {
                                        validate143.errors = [
                                            {
                                                instancePath: instancePath + '/downloadFormat',
                                                schemaPath: '#/properties/downloadFormat/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema157.properties.downloadFormat.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs25 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate143.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate143.errors = vErrors;
    return errors === 0;
}
function validate142(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:RunRequest" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if ((data.transientConfig === undefined && (missing0 = 'transientConfig')) ||
            (data.exportMap === undefined && (missing0 = 'exportMap'))) {
            const err0 = {};
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
    }
    var valid0 = _errs2 === errors;
    if (valid0) {
        validate142.errors = [
            { instancePath, schemaPath: '#/not', keyword: 'not', params: {}, message: 'must NOT be valid' }
        ];
        return false;
    }
    else {
        errors = _errs1;
        if (vErrors !== null) {
            if (_errs1) {
                vErrors.length = _errs1;
            }
            else {
                vErrors = null;
            }
        }
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.pipeID === undefined && (missing1 = 'pipeID')) ||
                (data.dataMap === undefined && (missing1 = 'dataMap'))) {
                validate142.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pipeID !== undefined) {
                    let data0 = data.pipeID;
                    const _errs3 = errors;
                    if (errors === _errs3) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func304(data0) < b64min0 || func304(data0) > b64max0) {
                                validate142.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func304(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func304(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func305(data0);
                                if (decoded0.length !== 10) {
                                    validate142.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func306(decoded0);
                                    if (func307(encoded0) !== func307(data0)) {
                                        validate142.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate142.errors = [
                                {
                                    instancePath: instancePath + '/pipeID',
                                    schemaPath: '#/properties/pipeID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid1 = _errs3 === errors;
                }
                else {
                    var valid1 = true;
                }
                if (valid1) {
                    if (data.dataMap !== undefined) {
                        let data1 = data.dataMap;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                for (const key0 in data1) {
                                    let data2 = data1[key0];
                                    const _errs8 = errors;
                                    if (errors === _errs8) {
                                        if (typeof data2 === 'string') {
                                            const b64min1 = Math.ceil((4 * 9) / 3);
                                            const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                            if (func308(data2) < b64min1 || func308(data2) > b64max1) {
                                                validate142.errors = [
                                                    {
                                                        instancePath: instancePath + '/dataMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                        schemaPath: '#/properties/dataMap/additionalProperties/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func308(data2) },
                                                        message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func308(data2)
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const decoded1 = func309(data2);
                                                if (decoded1.length !== 9) {
                                                    validate142.errors = [
                                                        {
                                                            instancePath: instancePath + '/dataMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                            schemaPath: '#/properties/dataMap/additionalProperties/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'decoded' },
                                                            message: 'must decode to 9 bytes'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    const encoded1 = func310(decoded1);
                                                    if (func311(encoded1) !== func311(data2)) {
                                                        validate142.errors = [
                                                            {
                                                                instancePath: instancePath + '/dataMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                schemaPath: '#/properties/dataMap/additionalProperties/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'ambiguous' },
                                                                message: 'encoding is ambiguous'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate142.errors = [
                                                {
                                                    instancePath: instancePath + '/dataMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                    schemaPath: '#/properties/dataMap/additionalProperties/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid3 = _errs8 === errors;
                                    if (!valid3) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate142.errors = [
                                    {
                                        instancePath: instancePath + '/dataMap',
                                        schemaPath: '#/properties/dataMap/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid1 = _errs5 === errors;
                    }
                    else {
                        var valid1 = true;
                    }
                    if (valid1) {
                        if (data.exportMap !== undefined) {
                            let data3 = data.exportMap;
                            const _errs10 = errors;
                            if (errors === _errs10) {
                                if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                                    for (const key1 in data3) {
                                        let data4 = data3[key1];
                                        const _errs13 = errors;
                                        if (typeof data4 !== 'string' && data4 !== null) {
                                            validate142.errors = [
                                                {
                                                    instancePath: instancePath + '/exportMap/' + key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                    schemaPath: '#/properties/exportMap/additionalProperties/type',
                                                    keyword: 'type',
                                                    params: { type: schema155.properties.exportMap.additionalProperties.type },
                                                    message: 'must be string,null'
                                                }
                                            ];
                                            return false;
                                        }
                                        const _errs15 = errors;
                                        let valid6 = true;
                                        const _errs16 = errors;
                                        if (typeof data4 !== 'string') {
                                            const err1 = {};
                                            if (vErrors === null) {
                                                vErrors = [err1];
                                            }
                                            else {
                                                vErrors.push(err1);
                                            }
                                            errors++;
                                        }
                                        var _valid0 = _errs16 === errors;
                                        errors = _errs15;
                                        if (vErrors !== null) {
                                            if (_errs15) {
                                                vErrors.length = _errs15;
                                            }
                                            else {
                                                vErrors = null;
                                            }
                                        }
                                        if (_valid0) {
                                            const _errs18 = errors;
                                            if (typeof data4 === 'string') {
                                                const b64min2 = Math.ceil((4 * 9) / 3);
                                                const b64max2 = Math.ceil((4 * 9) / 3) + 3;
                                                if (func312(data4) < b64min2 || func312(data4) > b64max2) {
                                                    validate142.errors = [
                                                        {
                                                            instancePath: instancePath + '/exportMap/' + key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                            schemaPath: '#/properties/exportMap/additionalProperties/then/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'encoded', b64min: b64min2, b64max: b64max2, length: func312(data4) },
                                                            message: 'length must be between ' + b64min2 + ' and ' + b64max2 + ', but is ' + func312(data4)
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    const decoded2 = func313(data4);
                                                    if (decoded2.length !== 9) {
                                                        validate142.errors = [
                                                            {
                                                                instancePath: instancePath + '/exportMap/' + key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                schemaPath: '#/properties/exportMap/additionalProperties/then/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'decoded' },
                                                                message: 'must decode to 9 bytes'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        const encoded2 = func314(decoded2);
                                                        if (func315(encoded2) !== func315(data4)) {
                                                            validate142.errors = [
                                                                {
                                                                    instancePath: instancePath + '/exportMap/' + key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                    schemaPath: '#/properties/exportMap/additionalProperties/then/uid',
                                                                    keyword: 'uid',
                                                                    params: { error: 'ambiguous' },
                                                                    message: 'encoding is ambiguous'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                            }
                                            var _valid0 = _errs18 === errors;
                                            valid6 = _valid0;
                                        }
                                        if (!valid6) {
                                            const err2 = {
                                                instancePath: instancePath + '/exportMap/' + key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                schemaPath: '#/properties/exportMap/additionalProperties/if',
                                                keyword: 'if',
                                                params: { failingKeyword: 'then' },
                                                message: 'must match "then" schema'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err2];
                                            }
                                            else {
                                                vErrors.push(err2);
                                            }
                                            errors++;
                                            validate142.errors = vErrors;
                                            return false;
                                        }
                                        var valid5 = _errs13 === errors;
                                        if (!valid5) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate142.errors = [
                                        {
                                            instancePath: instancePath + '/exportMap',
                                            schemaPath: '#/properties/exportMap/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid1 = _errs10 === errors;
                        }
                        else {
                            var valid1 = true;
                        }
                        if (valid1) {
                            if (data.name !== undefined) {
                                let data5 = data.name;
                                const _errs19 = errors;
                                if (errors === _errs19) {
                                    if (typeof data5 === 'string') {
                                        if (func2(data5) < 1) {
                                            validate142.errors = [
                                                {
                                                    instancePath: instancePath + '/name',
                                                    schemaPath: '#/properties/name/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate142.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid1 = _errs19 === errors;
                            }
                            else {
                                var valid1 = true;
                            }
                            if (valid1) {
                                if (data.runConfig !== undefined) {
                                    let data6 = data.runConfig;
                                    const _errs21 = errors;
                                    if (errors === _errs21) {
                                        if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                            for (const key2 in data6) {
                                                let data7 = data6[key2];
                                                const _errs24 = errors;
                                                const _errs25 = errors;
                                                if (errors === _errs25) {
                                                    if (data7 && typeof data7 == 'object' && !Array.isArray(data7)) {
                                                        let missing2;
                                                        if (data7.type === undefined && (missing2 = 'type')) {
                                                            validate142.errors = [
                                                                {
                                                                    instancePath: instancePath + '/runConfig/' + key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                    schemaPath: 'urn:wisepipe-common-computation:RunConfig/required',
                                                                    keyword: 'required',
                                                                    params: { missingProperty: missing2 },
                                                                    message: "must have required property '" + missing2 + "'"
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            if (data7.type !== undefined) {
                                                                let data8 = data7.type;
                                                                if (typeof data8 !== 'string') {
                                                                    validate142.errors = [
                                                                        {
                                                                            instancePath: instancePath +
                                                                                '/runConfig/' +
                                                                                key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                '/type',
                                                                            schemaPath: 'urn:wisepipe-common-computation:RunConfig/properties/type/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                if (!(data8 === 'file' ||
                                                                    data8 === 'cloud' ||
                                                                    data8 === 'demand_forecast' ||
                                                                    data8 === 'sample_customers' ||
                                                                    data8 === 'pipe' ||
                                                                    data8 === 'multi_port_pipe' ||
                                                                    data8 === 'adapt' ||
                                                                    data8 === 'aggregate' ||
                                                                    data8 === 'aggregate_v2' ||
                                                                    data8 === 'amortization' ||
                                                                    data8 === 'binning' ||
                                                                    data8 === 'category_encoder' ||
                                                                    data8 === 'case' ||
                                                                    data8 === 'change_case' ||
                                                                    data8 === 'change_type' ||
                                                                    data8 === 'clean_character' ||
                                                                    data8 === 'combination_matcher' ||
                                                                    data8 === 'conditional' ||
                                                                    data8 === 'confusion_matrix' ||
                                                                    data8 === 'date_add' ||
                                                                    data8 === 'date_diff' ||
                                                                    data8 === 'date_part' ||
                                                                    data8 === 'date_aggregate' ||
                                                                    data8 === 'date_format' ||
                                                                    data8 === 'distinct' ||
                                                                    data8 === 'drop' ||
                                                                    data8 === 'export' ||
                                                                    data8 === 'extract' ||
                                                                    data8 === 'fill' ||
                                                                    data8 === 'filter' ||
                                                                    data8 === 'formula' ||
                                                                    data8 === 'multi_formula' ||
                                                                    data8 === 'fuzzy_matcher' ||
                                                                    data8 === 'join' ||
                                                                    data8 === 'join_v2' ||
                                                                    data8 === 'lag' ||
                                                                    data8 === 'limit' ||
                                                                    data8 === 'merge_columns' ||
                                                                    data8 === 'min_max_scaler' ||
                                                                    data8 === 'monte_carlo' ||
                                                                    data8 === 'most_common' ||
                                                                    data8 === 'one_hot_encoder' ||
                                                                    data8 === 'oversample' ||
                                                                    data8 === 'predict_gender' ||
                                                                    data8 === 'quantile' ||
                                                                    data8 === 'random_number_generator' ||
                                                                    data8 === 'rank' ||
                                                                    data8 === 'record_id' ||
                                                                    data8 === 'remove_outliers' ||
                                                                    data8 === 'remove_empty' ||
                                                                    data8 === 'rename' ||
                                                                    data8 === 'reorder' ||
                                                                    data8 === 'repeat' ||
                                                                    data8 === 'replace' ||
                                                                    data8 === 'multi_replace' ||
                                                                    data8 === 'reshape' ||
                                                                    data8 === 'reshape_v2' ||
                                                                    data8 === 'running_average' ||
                                                                    data8 === 'running_total' ||
                                                                    data8 === 'sample' ||
                                                                    data8 === 'segmentation' ||
                                                                    data8 === 'select' ||
                                                                    data8 === 'select_word' ||
                                                                    data8 === 'smart_matcher' ||
                                                                    data8 === 'snapshot' ||
                                                                    data8 === 'sort' ||
                                                                    data8 === 'split' ||
                                                                    data8 === 'standard_scaler' ||
                                                                    data8 === 'text_grade_level' ||
                                                                    data8 === 'text_between' ||
                                                                    data8 === 'text_length' ||
                                                                    data8 === 'text_part' ||
                                                                    data8 === 'text_sentiment' ||
                                                                    data8 === 'trim' ||
                                                                    data8 === 'trim_tags' ||
                                                                    data8 === 'undersample' ||
                                                                    data8 === 'union' ||
                                                                    data8 === 'multi_union' ||
                                                                    data8 === 'weighted_average' ||
                                                                    data8 === 'classifier' ||
                                                                    data8 === 'cat_boost_classifier' ||
                                                                    data8 === 'decision_tree_train' ||
                                                                    data8 === 'gbt_train' ||
                                                                    data8 === 'k_neighbors_classifier' ||
                                                                    data8 === 'lgbm_classifier' ||
                                                                    data8 === 'logistic_regression_train' ||
                                                                    data8 === 'naive_bayes_train' ||
                                                                    data8 === 'random_forest_train' ||
                                                                    data8 === 'svm_train' ||
                                                                    data8 === 'xgb_classifier' ||
                                                                    data8 === 'regressor' ||
                                                                    data8 === 'decision_tree_regressor' ||
                                                                    data8 === 'gbt_regressor' ||
                                                                    data8 === 'k_neighbors_regressor' ||
                                                                    data8 === 'lgbm_regressor' ||
                                                                    data8 === 'linear_regression_train' ||
                                                                    data8 === 'mlp_regressor' ||
                                                                    data8 === 'random_forest_regressor' ||
                                                                    data8 === 'xgb_regressor' ||
                                                                    data8 === 'cat_boost_regressor' ||
                                                                    data8 === 'forecast' ||
                                                                    data8 === 'arima_forecast' ||
                                                                    data8 === 'auto_regressive_forecast' ||
                                                                    data8 === 'exp_smoothing_forecast' ||
                                                                    data8 === 'linear_regression_forecast' ||
                                                                    data8 === 'moving_average_forecast' ||
                                                                    data8 === 'prophet_forecast' ||
                                                                    data8 === 'seasonal_arima_forecast' ||
                                                                    data8 === 'simple_exp_smoothing_forecast' ||
                                                                    data8 === 'vector_auto_regressive_forecast' ||
                                                                    data8 === 'weighted_moving_average_forecast' ||
                                                                    data8 === 'cnn_text_classifier' ||
                                                                    data8 === 'bow_text_classifier' ||
                                                                    data8 === 'ensemble_text_classifier' ||
                                                                    data8 === 'text_classifier' ||
                                                                    data8 === 'word_frequency' ||
                                                                    data8 === 'outlier' ||
                                                                    data8 === 'abod_outlier' ||
                                                                    data8 === 'cblof_outlier' ||
                                                                    data8 === 'cof_outlier' ||
                                                                    data8 === 'hbos_outlier' ||
                                                                    data8 === 'iqr_outlier' ||
                                                                    data8 === 'isolation_forest_outlier' ||
                                                                    data8 === 'k_neighbors_outlier' ||
                                                                    data8 === 'multi_objective_gaal_outlier' ||
                                                                    data8 === 'one_class_svm_outlier' ||
                                                                    data8 === 'pca_outlier' ||
                                                                    data8 === 'single_objective_gaal_outlier' ||
                                                                    data8 === 'subspace_outlier' ||
                                                                    data8 === 'z_score_outlier' ||
                                                                    data8 === 'assignment_optimization' ||
                                                                    data8 === 'predictor' ||
                                                                    data8 === 'us_income' ||
                                                                    data8 === 'us_population' ||
                                                                    data8 === 'weather' ||
                                                                    data8 === 'hierarchy' ||
                                                                    data8 === 'hierarchy_v2' ||
                                                                    data8 === 'hierarchy_validator' ||
                                                                    data8 === 'hierarchy_validator_v2' ||
                                                                    data8 === 'lookup' ||
                                                                    data8 === 'split_columns' ||
                                                                    data8 === 'period_mapper' ||
                                                                    data8 === 'rule_mapper' ||
                                                                    data8 === 'rule_mapper_v2' ||
                                                                    data8 === 'incentives_export' ||
                                                                    data8 === 'incentives_import' ||
                                                                    data8 === 'incentives_table' ||
                                                                    data8 === 'incentives_period' ||
                                                                    data8 === 'user_defined_calc' ||
                                                                    data8 === 'sort_calc' ||
                                                                    data8 === 'time_shift_calc' ||
                                                                    data8 === 'category_calc' ||
                                                                    data8 === 'true_up' ||
                                                                    data8 === 'period_add' ||
                                                                    data8 === 'period_diff' ||
                                                                    data8 === 'expand_picklist' ||
                                                                    data8 === 'period_accumulation' ||
                                                                    data8 === 'reusable_logic_input' ||
                                                                    data8 === 'reusable_logic_output' ||
                                                                    data8 === 'reusable_logic' ||
                                                                    data8 === 'none')) {
                                                                    validate142.errors = [
                                                                        {
                                                                            instancePath: instancePath +
                                                                                '/runConfig/' +
                                                                                key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                '/type',
                                                                            schemaPath: 'urn:wisepipe-common-computation:RunConfig/properties/type/enum',
                                                                            keyword: 'enum',
                                                                            params: { allowedValues: schema148.properties.type.enum },
                                                                            message: 'must be equal to one of the allowed values'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate142.errors = [
                                                            {
                                                                instancePath: instancePath + '/runConfig/' + key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                schemaPath: 'urn:wisepipe-common-computation:RunConfig/type',
                                                                keyword: 'type',
                                                                params: { type: 'object' },
                                                                message: 'must be object'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid8 = _errs24 === errors;
                                                if (!valid8) {
                                                    break;
                                                }
                                            }
                                        }
                                        else {
                                            validate142.errors = [
                                                {
                                                    instancePath: instancePath + '/runConfig',
                                                    schemaPath: '#/properties/runConfig/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs21 === errors;
                                }
                                else {
                                    var valid1 = true;
                                }
                                if (valid1) {
                                    if (data.transientConfig !== undefined) {
                                        const _errs29 = errors;
                                        if (!validate143(data.transientConfig, {
                                            instancePath: instancePath + '/transientConfig',
                                            parentData: data,
                                            parentDataProperty: 'transientConfig',
                                            rootData
                                        })) {
                                            vErrors = vErrors === null ? validate143.errors : vErrors.concat(validate143.errors);
                                            errors = vErrors.length;
                                        }
                                        var valid1 = _errs29 === errors;
                                    }
                                    else {
                                        var valid1 = true;
                                    }
                                    if (valid1) {
                                        if (data.runTrigger !== undefined) {
                                            let data10 = data.runTrigger;
                                            const _errs30 = errors;
                                            if (typeof data10 !== 'string') {
                                                validate142.errors = [
                                                    {
                                                        instancePath: instancePath + '/runTrigger',
                                                        schemaPath: '#/properties/runTrigger/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            if (!(data10 === 'user' || data10 === 'scheduler' || data10 === 'external' || data10 === 'unknown')) {
                                                validate142.errors = [
                                                    {
                                                        instancePath: instancePath + '/runTrigger',
                                                        schemaPath: '#/properties/runTrigger/enum',
                                                        keyword: 'enum',
                                                        params: { allowedValues: schema155.properties.runTrigger.enum },
                                                        message: 'must be equal to one of the allowed values'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid1 = _errs30 === errors;
                                        }
                                        else {
                                            var valid1 = true;
                                        }
                                        if (valid1) {
                                            if (data.scheduleID !== undefined) {
                                                let data11 = data.scheduleID;
                                                const _errs32 = errors;
                                                if (errors === _errs32) {
                                                    if (typeof data11 === 'string') {
                                                        const b64min3 = Math.ceil((4 * 9) / 3);
                                                        const b64max3 = Math.ceil((4 * 9) / 3) + 3;
                                                        if (func364(data11) < b64min3 || func364(data11) > b64max3) {
                                                            validate142.errors = [
                                                                {
                                                                    instancePath: instancePath + '/scheduleID',
                                                                    schemaPath: '#/properties/scheduleID/uid',
                                                                    keyword: 'uid',
                                                                    params: {
                                                                        error: 'encoded',
                                                                        b64min: b64min3,
                                                                        b64max: b64max3,
                                                                        length: func364(data11)
                                                                    },
                                                                    message: 'length must be between ' +
                                                                        b64min3 +
                                                                        ' and ' +
                                                                        b64max3 +
                                                                        ', but is ' +
                                                                        func364(data11)
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            const decoded3 = func365(data11);
                                                            if (decoded3.length !== 9) {
                                                                validate142.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/scheduleID',
                                                                        schemaPath: '#/properties/scheduleID/uid',
                                                                        keyword: 'uid',
                                                                        params: { error: 'decoded' },
                                                                        message: 'must decode to 9 bytes'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                const encoded3 = func366(decoded3);
                                                                if (func367(encoded3) !== func367(data11)) {
                                                                    validate142.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/scheduleID',
                                                                            schemaPath: '#/properties/scheduleID/uid',
                                                                            keyword: 'uid',
                                                                            params: { error: 'ambiguous' },
                                                                            message: 'encoding is ambiguous'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate142.errors = [
                                                            {
                                                                instancePath: instancePath + '/scheduleID',
                                                                schemaPath: '#/properties/scheduleID/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid1 = _errs32 === errors;
                                            }
                                            else {
                                                var valid1 = true;
                                            }
                                            if (valid1) {
                                                if (data.selectedOutputs !== undefined) {
                                                    let data12 = data.selectedOutputs;
                                                    const _errs34 = errors;
                                                    if (errors === _errs34) {
                                                        if (Array.isArray(data12)) {
                                                            var valid12 = true;
                                                            const len0 = data12.length;
                                                            for (let i0 = 0; i0 < len0; i0++) {
                                                                let data13 = data12[i0];
                                                                const _errs36 = errors;
                                                                if (errors === _errs36) {
                                                                    if (typeof data13 === 'string') {
                                                                        const b64min4 = Math.ceil((4 * 10) / 3);
                                                                        const b64max4 = Math.ceil((4 * 10) / 3) + 3;
                                                                        if (func368(data13) < b64min4 || func368(data13) > b64max4) {
                                                                            validate142.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/selectedOutputs/' + i0,
                                                                                    schemaPath: '#/properties/selectedOutputs/items/uid',
                                                                                    keyword: 'uid',
                                                                                    params: {
                                                                                        error: 'encoded',
                                                                                        b64min: b64min4,
                                                                                        b64max: b64max4,
                                                                                        length: func368(data13)
                                                                                    },
                                                                                    message: 'length must be between ' +
                                                                                        b64min4 +
                                                                                        ' and ' +
                                                                                        b64max4 +
                                                                                        ', but is ' +
                                                                                        func368(data13)
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        else {
                                                                            const decoded4 = func369(data13);
                                                                            if (decoded4.length !== 10) {
                                                                                validate142.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/selectedOutputs/' + i0,
                                                                                        schemaPath: '#/properties/selectedOutputs/items/uid',
                                                                                        keyword: 'uid',
                                                                                        params: { error: 'decoded' },
                                                                                        message: 'must decode to 10 bytes'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            else {
                                                                                const encoded4 = func370(decoded4);
                                                                                if (func371(encoded4) !== func371(data13)) {
                                                                                    validate142.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/selectedOutputs/' + i0,
                                                                                            schemaPath: '#/properties/selectedOutputs/items/uid',
                                                                                            keyword: 'uid',
                                                                                            params: { error: 'ambiguous' },
                                                                                            message: 'encoding is ambiguous'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate142.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/selectedOutputs/' + i0,
                                                                                schemaPath: '#/properties/selectedOutputs/items/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid12 = _errs36 === errors;
                                                                if (!valid12) {
                                                                    break;
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate142.errors = [
                                                                {
                                                                    instancePath: instancePath + '/selectedOutputs',
                                                                    schemaPath: '#/properties/selectedOutputs/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'array' },
                                                                    message: 'must be array'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid1 = _errs34 === errors;
                                                }
                                                else {
                                                    var valid1 = true;
                                                }
                                                if (valid1) {
                                                    if (data.skippedDSRefreshes !== undefined) {
                                                        let data14 = data.skippedDSRefreshes;
                                                        const _errs38 = errors;
                                                        if (errors === _errs38) {
                                                            if (Array.isArray(data14)) {
                                                                var valid14 = true;
                                                                const len1 = data14.length;
                                                                for (let i1 = 0; i1 < len1; i1++) {
                                                                    let data15 = data14[i1];
                                                                    const _errs40 = errors;
                                                                    if (errors === _errs40) {
                                                                        if (typeof data15 === 'string') {
                                                                            const b64min5 = Math.ceil((4 * 9) / 3);
                                                                            const b64max5 = Math.ceil((4 * 9) / 3) + 3;
                                                                            if (func372(data15) < b64min5 || func372(data15) > b64max5) {
                                                                                validate142.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/skippedDSRefreshes/' + i1,
                                                                                        schemaPath: '#/properties/skippedDSRefreshes/items/uid',
                                                                                        keyword: 'uid',
                                                                                        params: {
                                                                                            error: 'encoded',
                                                                                            b64min: b64min5,
                                                                                            b64max: b64max5,
                                                                                            length: func372(data15)
                                                                                        },
                                                                                        message: 'length must be between ' +
                                                                                            b64min5 +
                                                                                            ' and ' +
                                                                                            b64max5 +
                                                                                            ', but is ' +
                                                                                            func372(data15)
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            else {
                                                                                const decoded5 = func373(data15);
                                                                                if (decoded5.length !== 9) {
                                                                                    validate142.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/skippedDSRefreshes/' + i1,
                                                                                            schemaPath: '#/properties/skippedDSRefreshes/items/uid',
                                                                                            keyword: 'uid',
                                                                                            params: { error: 'decoded' },
                                                                                            message: 'must decode to 9 bytes'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                else {
                                                                                    const encoded5 = func374(decoded5);
                                                                                    if (func375(encoded5) !== func375(data15)) {
                                                                                        validate142.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/skippedDSRefreshes/' + i1,
                                                                                                schemaPath: '#/properties/skippedDSRefreshes/items/uid',
                                                                                                keyword: 'uid',
                                                                                                params: { error: 'ambiguous' },
                                                                                                message: 'encoding is ambiguous'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate142.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/skippedDSRefreshes/' + i1,
                                                                                    schemaPath: '#/properties/skippedDSRefreshes/items/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid14 = _errs40 === errors;
                                                                    if (!valid14) {
                                                                        break;
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate142.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/skippedDSRefreshes',
                                                                        schemaPath: '#/properties/skippedDSRefreshes/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'array' },
                                                                        message: 'must be array'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid1 = _errs38 === errors;
                                                    }
                                                    else {
                                                        var valid1 = true;
                                                    }
                                                    if (valid1) {
                                                        if (data.nodeToIsExcelExport !== undefined) {
                                                            let data16 = data.nodeToIsExcelExport;
                                                            const _errs42 = errors;
                                                            if (errors === _errs42) {
                                                                if (data16 && typeof data16 == 'object' && !Array.isArray(data16)) {
                                                                    for (const key3 in data16) {
                                                                        const _errs45 = errors;
                                                                        if (typeof data16[key3] !== 'boolean') {
                                                                            validate142.errors = [
                                                                                {
                                                                                    instancePath: instancePath +
                                                                                        '/nodeToIsExcelExport/' +
                                                                                        key3.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                                    schemaPath: '#/properties/nodeToIsExcelExport/additionalProperties/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'boolean' },
                                                                                    message: 'must be boolean'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        var valid16 = _errs45 === errors;
                                                                        if (!valid16) {
                                                                            break;
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate142.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/nodeToIsExcelExport',
                                                                            schemaPath: '#/properties/nodeToIsExcelExport/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'object' },
                                                                            message: 'must be object'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid1 = _errs42 === errors;
                                                        }
                                                        else {
                                                            var valid1 = true;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate142.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate142.errors = vErrors;
    return errors === 0;
}
export const runSchemaValidation = validate151;
const schema168 = {
    $id: 'urn:wisepipe-common-computation:Run',
    type: 'object',
    properties: {
        runID: { type: 'string', uid: 9 },
        pipeID: { type: 'string', uid: 10 },
        name: { type: 'string', minLength: 1 },
        dataMap: { type: 'object', additionalProperties: { type: 'string', uid: 9 } },
        exportMap: {
            type: 'object',
            additionalProperties: { type: ['string', 'null'], if: { type: 'string' }, then: { uid: 9 } }
        },
        status: { type: 'string', enum: ['running', 'failed', 'cancelled', 'completed'] },
        progress: { type: 'number', minimum: 0, maximum: 1 },
        start: { type: 'string', format: 'date-time' },
        outputs: { type: 'array', items: { $ref: 'urn:wisepipe-common-computation:RunOutput' } },
        end: { type: 'string', format: 'date-time' },
        error: { type: 'object' },
        transientExportFileMap: {
            type: 'object',
            additionalProperties: { type: 'array', items: { $ref: 'urn:wisepipe-common:S3File' } }
        },
        runTrigger: { type: 'string', enum: ['user', 'scheduler', 'external', 'unknown'] },
        scheduleID: { type: 'string', uid: 9 },
        selectedOutputs: { type: 'array', items: { type: 'string', uid: 10 } },
        skippedDSRefreshes: { type: 'array', items: { type: 'string', uid: 9 } },
        nodeToIsExcelExport: { type: 'object', additionalProperties: { type: 'boolean' } }
    },
    required: ['runID', 'pipeID', 'name', 'dataMap', 'status', 'progress', 'start']
};
const func376 = ucs2length;
const func377 = base64urlToBuffer;
const func378 = base64urlEncode;
const func379 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func380 = ucs2length;
const func381 = base64urlToBuffer;
const func382 = base64urlEncode;
const func383 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func385 = ucs2length;
const func386 = base64urlToBuffer;
const func387 = base64urlEncode;
const func388 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func389 = ucs2length;
const func390 = base64urlToBuffer;
const func391 = base64urlEncode;
const func392 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func395 = ucs2length;
const func396 = base64urlToBuffer;
const func397 = base64urlEncode;
const func398 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func399 = ucs2length;
const func400 = base64urlToBuffer;
const func401 = base64urlEncode;
const func402 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func403 = ucs2length;
const func404 = base64urlToBuffer;
const func405 = base64urlEncode;
const func406 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func407 = ucs2length;
const func408 = base64urlToBuffer;
const func409 = base64urlEncode;
const func410 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate151(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:Run" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.runID === undefined && (missing0 = 'runID')) ||
                (data.pipeID === undefined && (missing0 = 'pipeID')) ||
                (data.name === undefined && (missing0 = 'name')) ||
                (data.dataMap === undefined && (missing0 = 'dataMap')) ||
                (data.status === undefined && (missing0 = 'status')) ||
                (data.progress === undefined && (missing0 = 'progress')) ||
                (data.start === undefined && (missing0 = 'start'))) {
                validate151.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.runID !== undefined) {
                    let data0 = data.runID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 9) / 3);
                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                            if (func376(data0) < b64min0 || func376(data0) > b64max0) {
                                validate151.errors = [
                                    {
                                        instancePath: instancePath + '/runID',
                                        schemaPath: '#/properties/runID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func376(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func376(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func377(data0);
                                if (decoded0.length !== 9) {
                                    validate151.errors = [
                                        {
                                            instancePath: instancePath + '/runID',
                                            schemaPath: '#/properties/runID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 9 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func378(decoded0);
                                    if (func379(encoded0) !== func379(data0)) {
                                        validate151.errors = [
                                            {
                                                instancePath: instancePath + '/runID',
                                                schemaPath: '#/properties/runID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate151.errors = [
                                {
                                    instancePath: instancePath + '/runID',
                                    schemaPath: '#/properties/runID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.pipeID !== undefined) {
                        let data1 = data.pipeID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                const b64min1 = Math.ceil((4 * 10) / 3);
                                const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                if (func380(data1) < b64min1 || func380(data1) > b64max1) {
                                    validate151.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func380(data1) },
                                            message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func380(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded1 = func381(data1);
                                    if (decoded1.length !== 10) {
                                        validate151.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 10 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded1 = func382(decoded1);
                                        if (func383(encoded1) !== func383(data1)) {
                                            validate151.errors = [
                                                {
                                                    instancePath: instancePath + '/pipeID',
                                                    schemaPath: '#/properties/pipeID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate151.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.name !== undefined) {
                            let data2 = data.name;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate151.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate151.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.dataMap !== undefined) {
                                let data3 = data.dataMap;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                                        for (const key0 in data3) {
                                            let data4 = data3[key0];
                                            const _errs10 = errors;
                                            if (errors === _errs10) {
                                                if (typeof data4 === 'string') {
                                                    const b64min2 = Math.ceil((4 * 9) / 3);
                                                    const b64max2 = Math.ceil((4 * 9) / 3) + 3;
                                                    if (func385(data4) < b64min2 || func385(data4) > b64max2) {
                                                        validate151.errors = [
                                                            {
                                                                instancePath: instancePath + '/dataMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                schemaPath: '#/properties/dataMap/additionalProperties/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'encoded', b64min: b64min2, b64max: b64max2, length: func385(data4) },
                                                                message: 'length must be between ' + b64min2 + ' and ' + b64max2 + ', but is ' + func385(data4)
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        const decoded2 = func386(data4);
                                                        if (decoded2.length !== 9) {
                                                            validate151.errors = [
                                                                {
                                                                    instancePath: instancePath + '/dataMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                    schemaPath: '#/properties/dataMap/additionalProperties/uid',
                                                                    keyword: 'uid',
                                                                    params: { error: 'decoded' },
                                                                    message: 'must decode to 9 bytes'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            const encoded2 = func387(decoded2);
                                                            if (func388(encoded2) !== func388(data4)) {
                                                                validate151.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/dataMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                        schemaPath: '#/properties/dataMap/additionalProperties/uid',
                                                                        keyword: 'uid',
                                                                        params: { error: 'ambiguous' },
                                                                        message: 'encoding is ambiguous'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate151.errors = [
                                                        {
                                                            instancePath: instancePath + '/dataMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                            schemaPath: '#/properties/dataMap/additionalProperties/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid3 = _errs10 === errors;
                                            if (!valid3) {
                                                break;
                                            }
                                        }
                                    }
                                    else {
                                        validate151.errors = [
                                            {
                                                instancePath: instancePath + '/dataMap',
                                                schemaPath: '#/properties/dataMap/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.exportMap !== undefined) {
                                    let data5 = data.exportMap;
                                    const _errs12 = errors;
                                    if (errors === _errs12) {
                                        if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                            for (const key1 in data5) {
                                                let data6 = data5[key1];
                                                const _errs15 = errors;
                                                if (typeof data6 !== 'string' && data6 !== null) {
                                                    validate151.errors = [
                                                        {
                                                            instancePath: instancePath + '/exportMap/' + key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                            schemaPath: '#/properties/exportMap/additionalProperties/type',
                                                            keyword: 'type',
                                                            params: { type: schema168.properties.exportMap.additionalProperties.type },
                                                            message: 'must be string,null'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                const _errs17 = errors;
                                                let valid6 = true;
                                                const _errs18 = errors;
                                                if (typeof data6 !== 'string') {
                                                    const err0 = {};
                                                    if (vErrors === null) {
                                                        vErrors = [err0];
                                                    }
                                                    else {
                                                        vErrors.push(err0);
                                                    }
                                                    errors++;
                                                }
                                                var _valid0 = _errs18 === errors;
                                                errors = _errs17;
                                                if (vErrors !== null) {
                                                    if (_errs17) {
                                                        vErrors.length = _errs17;
                                                    }
                                                    else {
                                                        vErrors = null;
                                                    }
                                                }
                                                if (_valid0) {
                                                    const _errs20 = errors;
                                                    if (typeof data6 === 'string') {
                                                        const b64min3 = Math.ceil((4 * 9) / 3);
                                                        const b64max3 = Math.ceil((4 * 9) / 3) + 3;
                                                        if (func389(data6) < b64min3 || func389(data6) > b64max3) {
                                                            validate151.errors = [
                                                                {
                                                                    instancePath: instancePath + '/exportMap/' + key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                    schemaPath: '#/properties/exportMap/additionalProperties/then/uid',
                                                                    keyword: 'uid',
                                                                    params: {
                                                                        error: 'encoded',
                                                                        b64min: b64min3,
                                                                        b64max: b64max3,
                                                                        length: func389(data6)
                                                                    },
                                                                    message: 'length must be between ' +
                                                                        b64min3 +
                                                                        ' and ' +
                                                                        b64max3 +
                                                                        ', but is ' +
                                                                        func389(data6)
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            const decoded3 = func390(data6);
                                                            if (decoded3.length !== 9) {
                                                                validate151.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/exportMap/' + key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                        schemaPath: '#/properties/exportMap/additionalProperties/then/uid',
                                                                        keyword: 'uid',
                                                                        params: { error: 'decoded' },
                                                                        message: 'must decode to 9 bytes'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                const encoded3 = func391(decoded3);
                                                                if (func392(encoded3) !== func392(data6)) {
                                                                    validate151.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/exportMap/' + key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                            schemaPath: '#/properties/exportMap/additionalProperties/then/uid',
                                                                            keyword: 'uid',
                                                                            params: { error: 'ambiguous' },
                                                                            message: 'encoding is ambiguous'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    var _valid0 = _errs20 === errors;
                                                    valid6 = _valid0;
                                                }
                                                if (!valid6) {
                                                    const err1 = {
                                                        instancePath: instancePath + '/exportMap/' + key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                        schemaPath: '#/properties/exportMap/additionalProperties/if',
                                                        keyword: 'if',
                                                        params: { failingKeyword: 'then' },
                                                        message: 'must match "then" schema'
                                                    };
                                                    if (vErrors === null) {
                                                        vErrors = [err1];
                                                    }
                                                    else {
                                                        vErrors.push(err1);
                                                    }
                                                    errors++;
                                                    validate151.errors = vErrors;
                                                    return false;
                                                }
                                                var valid5 = _errs15 === errors;
                                                if (!valid5) {
                                                    break;
                                                }
                                            }
                                        }
                                        else {
                                            validate151.errors = [
                                                {
                                                    instancePath: instancePath + '/exportMap',
                                                    schemaPath: '#/properties/exportMap/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs12 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.status !== undefined) {
                                        let data7 = data.status;
                                        const _errs21 = errors;
                                        if (typeof data7 !== 'string') {
                                            validate151.errors = [
                                                {
                                                    instancePath: instancePath + '/status',
                                                    schemaPath: '#/properties/status/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (!(data7 === 'running' || data7 === 'failed' || data7 === 'cancelled' || data7 === 'completed')) {
                                            validate151.errors = [
                                                {
                                                    instancePath: instancePath + '/status',
                                                    schemaPath: '#/properties/status/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema168.properties.status.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs21 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.progress !== undefined) {
                                            let data8 = data.progress;
                                            const _errs23 = errors;
                                            if (errors === _errs23) {
                                                if (typeof data8 == 'number') {
                                                    if (data8 > 1 || isNaN(data8)) {
                                                        validate151.errors = [
                                                            {
                                                                instancePath: instancePath + '/progress',
                                                                schemaPath: '#/properties/progress/maximum',
                                                                keyword: 'maximum',
                                                                params: { comparison: '<=', limit: 1 },
                                                                message: 'must be <= 1'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        if (data8 < 0 || isNaN(data8)) {
                                                            validate151.errors = [
                                                                {
                                                                    instancePath: instancePath + '/progress',
                                                                    schemaPath: '#/properties/progress/minimum',
                                                                    keyword: 'minimum',
                                                                    params: { comparison: '>=', limit: 0 },
                                                                    message: 'must be >= 0'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate151.errors = [
                                                        {
                                                            instancePath: instancePath + '/progress',
                                                            schemaPath: '#/properties/progress/type',
                                                            keyword: 'type',
                                                            params: { type: 'number' },
                                                            message: 'must be number'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs23 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.start !== undefined) {
                                                let data9 = data.start;
                                                const _errs25 = errors;
                                                if (errors === _errs25) {
                                                    if (errors === _errs25) {
                                                        if (typeof data9 === 'string') {
                                                            if (!formats0.validate(data9)) {
                                                                validate151.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/start',
                                                                        schemaPath: '#/properties/start/format',
                                                                        keyword: 'format',
                                                                        params: { format: 'date-time' },
                                                                        message: 'must match format "' + 'date-time' + '"'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate151.errors = [
                                                                {
                                                                    instancePath: instancePath + '/start',
                                                                    schemaPath: '#/properties/start/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                                var valid0 = _errs25 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.outputs !== undefined) {
                                                    let data10 = data.outputs;
                                                    const _errs27 = errors;
                                                    if (errors === _errs27) {
                                                        if (Array.isArray(data10)) {
                                                            var valid8 = true;
                                                            const len0 = data10.length;
                                                            for (let i0 = 0; i0 < len0; i0++) {
                                                                const _errs29 = errors;
                                                                if (!validate140(data10[i0], {
                                                                    instancePath: instancePath + '/outputs/' + i0,
                                                                    parentData: data10,
                                                                    parentDataProperty: i0,
                                                                    rootData
                                                                })) {
                                                                    vErrors = vErrors === null ? validate140.errors : vErrors.concat(validate140.errors);
                                                                    errors = vErrors.length;
                                                                }
                                                                var valid8 = _errs29 === errors;
                                                                if (!valid8) {
                                                                    break;
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate151.errors = [
                                                                {
                                                                    instancePath: instancePath + '/outputs',
                                                                    schemaPath: '#/properties/outputs/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'array' },
                                                                    message: 'must be array'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid0 = _errs27 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.end !== undefined) {
                                                        let data12 = data.end;
                                                        const _errs30 = errors;
                                                        if (errors === _errs30) {
                                                            if (errors === _errs30) {
                                                                if (typeof data12 === 'string') {
                                                                    if (!formats0.validate(data12)) {
                                                                        validate151.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/end',
                                                                                schemaPath: '#/properties/end/format',
                                                                                keyword: 'format',
                                                                                params: { format: 'date-time' },
                                                                                message: 'must match format "' + 'date-time' + '"'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate151.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/end',
                                                                            schemaPath: '#/properties/end/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                        var valid0 = _errs30 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (data.error !== undefined) {
                                                            let data13 = data.error;
                                                            const _errs32 = errors;
                                                            if (!(data13 && typeof data13 == 'object' && !Array.isArray(data13))) {
                                                                validate151.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/error',
                                                                        schemaPath: '#/properties/error/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'object' },
                                                                        message: 'must be object'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid0 = _errs32 === errors;
                                                        }
                                                        else {
                                                            var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                            if (data.transientExportFileMap !== undefined) {
                                                                let data14 = data.transientExportFileMap;
                                                                const _errs34 = errors;
                                                                if (errors === _errs34) {
                                                                    if (data14 && typeof data14 == 'object' && !Array.isArray(data14)) {
                                                                        for (const key2 in data14) {
                                                                            let data15 = data14[key2];
                                                                            const _errs37 = errors;
                                                                            if (errors === _errs37) {
                                                                                if (Array.isArray(data15)) {
                                                                                    var valid10 = true;
                                                                                    const len1 = data15.length;
                                                                                    for (let i1 = 0; i1 < len1; i1++) {
                                                                                        let data16 = data15[i1];
                                                                                        const _errs39 = errors;
                                                                                        const _errs40 = errors;
                                                                                        if (errors === _errs40) {
                                                                                            if (data16 && typeof data16 == 'object' && !Array.isArray(data16)) {
                                                                                                let missing1;
                                                                                                if ((data16.bucket === undefined && (missing1 = 'bucket')) ||
                                                                                                    (data16.key === undefined && (missing1 = 'key'))) {
                                                                                                    validate151.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath +
                                                                                                                '/transientExportFileMap/' +
                                                                                                                key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                                '/' +
                                                                                                                i1,
                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/required',
                                                                                                            keyword: 'required',
                                                                                                            params: { missingProperty: missing1 },
                                                                                                            message: "must have required property '" + missing1 + "'"
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                                else {
                                                                                                    if (data16.bucket !== undefined) {
                                                                                                        let data17 = data16.bucket;
                                                                                                        const _errs42 = errors;
                                                                                                        if (errors === _errs42) {
                                                                                                            if (typeof data17 === 'string') {
                                                                                                                if (func2(data17) < 1) {
                                                                                                                    validate151.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath +
                                                                                                                                '/transientExportFileMap/' +
                                                                                                                                key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                                                '/' +
                                                                                                                                i1 +
                                                                                                                                '/bucket',
                                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                                                                            keyword: 'minLength',
                                                                                                                            params: { limit: 1 },
                                                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                            }
                                                                                                            else {
                                                                                                                validate151.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath +
                                                                                                                            '/transientExportFileMap/' +
                                                                                                                            key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                                            '/' +
                                                                                                                            i1 +
                                                                                                                            '/bucket',
                                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                                                                        keyword: 'type',
                                                                                                                        params: { type: 'string' },
                                                                                                                        message: 'must be string'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                        }
                                                                                                        var valid12 = _errs42 === errors;
                                                                                                    }
                                                                                                    else {
                                                                                                        var valid12 = true;
                                                                                                    }
                                                                                                    if (valid12) {
                                                                                                        if (data16.key !== undefined) {
                                                                                                            let data18 = data16.key;
                                                                                                            const _errs44 = errors;
                                                                                                            if (errors === _errs44) {
                                                                                                                if (typeof data18 === 'string') {
                                                                                                                    if (func2(data18) < 1) {
                                                                                                                        validate151.errors = [
                                                                                                                            {
                                                                                                                                instancePath: instancePath +
                                                                                                                                    '/transientExportFileMap/' +
                                                                                                                                    key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                                                    '/' +
                                                                                                                                    i1 +
                                                                                                                                    '/key',
                                                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                                                                                keyword: 'minLength',
                                                                                                                                params: { limit: 1 },
                                                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                                                            }
                                                                                                                        ];
                                                                                                                        return false;
                                                                                                                    }
                                                                                                                }
                                                                                                                else {
                                                                                                                    validate151.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath +
                                                                                                                                '/transientExportFileMap/' +
                                                                                                                                key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                                                '/' +
                                                                                                                                i1 +
                                                                                                                                '/key',
                                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                                                                            keyword: 'type',
                                                                                                                            params: { type: 'string' },
                                                                                                                            message: 'must be string'
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                            }
                                                                                                            var valid12 = _errs44 === errors;
                                                                                                        }
                                                                                                        else {
                                                                                                            var valid12 = true;
                                                                                                        }
                                                                                                        if (valid12) {
                                                                                                            if (data16.uploadID !== undefined) {
                                                                                                                let data19 = data16.uploadID;
                                                                                                                const _errs46 = errors;
                                                                                                                if (errors === _errs46) {
                                                                                                                    if (typeof data19 === 'string') {
                                                                                                                        const b64min4 = Math.ceil((4 * 9) / 3);
                                                                                                                        const b64max4 = Math.ceil((4 * 9) / 3) + 3;
                                                                                                                        if (func395(data19) < b64min4 ||
                                                                                                                            func395(data19) > b64max4) {
                                                                                                                            validate151.errors = [
                                                                                                                                {
                                                                                                                                    instancePath: instancePath +
                                                                                                                                        '/transientExportFileMap/' +
                                                                                                                                        key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                                                        '/' +
                                                                                                                                        i1 +
                                                                                                                                        '/uploadID',
                                                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                                    keyword: 'uid',
                                                                                                                                    params: {
                                                                                                                                        error: 'encoded',
                                                                                                                                        b64min: b64min4,
                                                                                                                                        b64max: b64max4,
                                                                                                                                        length: func395(data19)
                                                                                                                                    },
                                                                                                                                    message: 'length must be between ' +
                                                                                                                                        b64min4 +
                                                                                                                                        ' and ' +
                                                                                                                                        b64max4 +
                                                                                                                                        ', but is ' +
                                                                                                                                        func395(data19)
                                                                                                                                }
                                                                                                                            ];
                                                                                                                            return false;
                                                                                                                        }
                                                                                                                        else {
                                                                                                                            const decoded4 = func396(data19);
                                                                                                                            if (decoded4.length !== 9) {
                                                                                                                                validate151.errors = [
                                                                                                                                    {
                                                                                                                                        instancePath: instancePath +
                                                                                                                                            '/transientExportFileMap/' +
                                                                                                                                            key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                                                            '/' +
                                                                                                                                            i1 +
                                                                                                                                            '/uploadID',
                                                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                                        keyword: 'uid',
                                                                                                                                        params: { error: 'decoded' },
                                                                                                                                        message: 'must decode to 9 bytes'
                                                                                                                                    }
                                                                                                                                ];
                                                                                                                                return false;
                                                                                                                            }
                                                                                                                            else {
                                                                                                                                const encoded4 = func397(decoded4);
                                                                                                                                if (func398(encoded4) !== func398(data19)) {
                                                                                                                                    validate151.errors = [
                                                                                                                                        {
                                                                                                                                            instancePath: instancePath +
                                                                                                                                                '/transientExportFileMap/' +
                                                                                                                                                key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                                                                '/' +
                                                                                                                                                i1 +
                                                                                                                                                '/uploadID',
                                                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                                            keyword: 'uid',
                                                                                                                                            params: { error: 'ambiguous' },
                                                                                                                                            message: 'encoding is ambiguous'
                                                                                                                                        }
                                                                                                                                    ];
                                                                                                                                    return false;
                                                                                                                                }
                                                                                                                            }
                                                                                                                        }
                                                                                                                    }
                                                                                                                    else {
                                                                                                                        validate151.errors = [
                                                                                                                            {
                                                                                                                                instancePath: instancePath +
                                                                                                                                    '/transientExportFileMap/' +
                                                                                                                                    key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                                                    '/' +
                                                                                                                                    i1 +
                                                                                                                                    '/uploadID',
                                                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                                                                                keyword: 'type',
                                                                                                                                params: { type: 'string' },
                                                                                                                                message: 'must be string'
                                                                                                                            }
                                                                                                                        ];
                                                                                                                        return false;
                                                                                                                    }
                                                                                                                }
                                                                                                                var valid12 = _errs46 === errors;
                                                                                                            }
                                                                                                            else {
                                                                                                                var valid12 = true;
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                            else {
                                                                                                validate151.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath +
                                                                                                            '/transientExportFileMap/' +
                                                                                                            key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                            '/' +
                                                                                                            i1,
                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'object' },
                                                                                                        message: 'must be object'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        var valid10 = _errs39 === errors;
                                                                                        if (!valid10) {
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate151.errors = [
                                                                                        {
                                                                                            instancePath: instancePath +
                                                                                                '/transientExportFileMap/' +
                                                                                                key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                                            schemaPath: '#/properties/transientExportFileMap/additionalProperties/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'array' },
                                                                                            message: 'must be array'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid9 = _errs37 === errors;
                                                                            if (!valid9) {
                                                                                break;
                                                                            }
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate151.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/transientExportFileMap',
                                                                                schemaPath: '#/properties/transientExportFileMap/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'object' },
                                                                                message: 'must be object'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid0 = _errs34 === errors;
                                                            }
                                                            else {
                                                                var valid0 = true;
                                                            }
                                                            if (valid0) {
                                                                if (data.runTrigger !== undefined) {
                                                                    let data20 = data.runTrigger;
                                                                    const _errs48 = errors;
                                                                    if (typeof data20 !== 'string') {
                                                                        validate151.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/runTrigger',
                                                                                schemaPath: '#/properties/runTrigger/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    if (!(data20 === 'user' ||
                                                                        data20 === 'scheduler' ||
                                                                        data20 === 'external' ||
                                                                        data20 === 'unknown')) {
                                                                        validate151.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/runTrigger',
                                                                                schemaPath: '#/properties/runTrigger/enum',
                                                                                keyword: 'enum',
                                                                                params: { allowedValues: schema168.properties.runTrigger.enum },
                                                                                message: 'must be equal to one of the allowed values'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid0 = _errs48 === errors;
                                                                }
                                                                else {
                                                                    var valid0 = true;
                                                                }
                                                                if (valid0) {
                                                                    if (data.scheduleID !== undefined) {
                                                                        let data21 = data.scheduleID;
                                                                        const _errs50 = errors;
                                                                        if (errors === _errs50) {
                                                                            if (typeof data21 === 'string') {
                                                                                const b64min5 = Math.ceil((4 * 9) / 3);
                                                                                const b64max5 = Math.ceil((4 * 9) / 3) + 3;
                                                                                if (func399(data21) < b64min5 || func399(data21) > b64max5) {
                                                                                    validate151.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/scheduleID',
                                                                                            schemaPath: '#/properties/scheduleID/uid',
                                                                                            keyword: 'uid',
                                                                                            params: {
                                                                                                error: 'encoded',
                                                                                                b64min: b64min5,
                                                                                                b64max: b64max5,
                                                                                                length: func399(data21)
                                                                                            },
                                                                                            message: 'length must be between ' +
                                                                                                b64min5 +
                                                                                                ' and ' +
                                                                                                b64max5 +
                                                                                                ', but is ' +
                                                                                                func399(data21)
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                else {
                                                                                    const decoded5 = func400(data21);
                                                                                    if (decoded5.length !== 9) {
                                                                                        validate151.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/scheduleID',
                                                                                                schemaPath: '#/properties/scheduleID/uid',
                                                                                                keyword: 'uid',
                                                                                                params: { error: 'decoded' },
                                                                                                message: 'must decode to 9 bytes'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    else {
                                                                                        const encoded5 = func401(decoded5);
                                                                                        if (func402(encoded5) !== func402(data21)) {
                                                                                            validate151.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/scheduleID',
                                                                                                    schemaPath: '#/properties/scheduleID/uid',
                                                                                                    keyword: 'uid',
                                                                                                    params: { error: 'ambiguous' },
                                                                                                    message: 'encoding is ambiguous'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate151.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/scheduleID',
                                                                                        schemaPath: '#/properties/scheduleID/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid0 = _errs50 === errors;
                                                                    }
                                                                    else {
                                                                        var valid0 = true;
                                                                    }
                                                                    if (valid0) {
                                                                        if (data.selectedOutputs !== undefined) {
                                                                            let data22 = data.selectedOutputs;
                                                                            const _errs52 = errors;
                                                                            if (errors === _errs52) {
                                                                                if (Array.isArray(data22)) {
                                                                                    var valid15 = true;
                                                                                    const len2 = data22.length;
                                                                                    for (let i2 = 0; i2 < len2; i2++) {
                                                                                        let data23 = data22[i2];
                                                                                        const _errs54 = errors;
                                                                                        if (errors === _errs54) {
                                                                                            if (typeof data23 === 'string') {
                                                                                                const b64min6 = Math.ceil((4 * 10) / 3);
                                                                                                const b64max6 = Math.ceil((4 * 10) / 3) + 3;
                                                                                                if (func403(data23) < b64min6 || func403(data23) > b64max6) {
                                                                                                    validate151.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/selectedOutputs/' + i2,
                                                                                                            schemaPath: '#/properties/selectedOutputs/items/uid',
                                                                                                            keyword: 'uid',
                                                                                                            params: {
                                                                                                                error: 'encoded',
                                                                                                                b64min: b64min6,
                                                                                                                b64max: b64max6,
                                                                                                                length: func403(data23)
                                                                                                            },
                                                                                                            message: 'length must be between ' +
                                                                                                                b64min6 +
                                                                                                                ' and ' +
                                                                                                                b64max6 +
                                                                                                                ', but is ' +
                                                                                                                func403(data23)
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                                else {
                                                                                                    const decoded6 = func404(data23);
                                                                                                    if (decoded6.length !== 10) {
                                                                                                        validate151.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/selectedOutputs/' + i2,
                                                                                                                schemaPath: '#/properties/selectedOutputs/items/uid',
                                                                                                                keyword: 'uid',
                                                                                                                params: { error: 'decoded' },
                                                                                                                message: 'must decode to 10 bytes'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    else {
                                                                                                        const encoded6 = func405(decoded6);
                                                                                                        if (func406(encoded6) !== func406(data23)) {
                                                                                                            validate151.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/selectedOutputs/' + i2,
                                                                                                                    schemaPath: '#/properties/selectedOutputs/items/uid',
                                                                                                                    keyword: 'uid',
                                                                                                                    params: { error: 'ambiguous' },
                                                                                                                    message: 'encoding is ambiguous'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                            else {
                                                                                                validate151.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/selectedOutputs/' + i2,
                                                                                                        schemaPath: '#/properties/selectedOutputs/items/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'string' },
                                                                                                        message: 'must be string'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        var valid15 = _errs54 === errors;
                                                                                        if (!valid15) {
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate151.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/selectedOutputs',
                                                                                            schemaPath: '#/properties/selectedOutputs/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'array' },
                                                                                            message: 'must be array'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid0 = _errs52 === errors;
                                                                        }
                                                                        else {
                                                                            var valid0 = true;
                                                                        }
                                                                        if (valid0) {
                                                                            if (data.skippedDSRefreshes !== undefined) {
                                                                                let data24 = data.skippedDSRefreshes;
                                                                                const _errs56 = errors;
                                                                                if (errors === _errs56) {
                                                                                    if (Array.isArray(data24)) {
                                                                                        var valid17 = true;
                                                                                        const len3 = data24.length;
                                                                                        for (let i3 = 0; i3 < len3; i3++) {
                                                                                            let data25 = data24[i3];
                                                                                            const _errs58 = errors;
                                                                                            if (errors === _errs58) {
                                                                                                if (typeof data25 === 'string') {
                                                                                                    const b64min7 = Math.ceil((4 * 9) / 3);
                                                                                                    const b64max7 = Math.ceil((4 * 9) / 3) + 3;
                                                                                                    if (func407(data25) < b64min7 || func407(data25) > b64max7) {
                                                                                                        validate151.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/skippedDSRefreshes/' + i3,
                                                                                                                schemaPath: '#/properties/skippedDSRefreshes/items/uid',
                                                                                                                keyword: 'uid',
                                                                                                                params: {
                                                                                                                    error: 'encoded',
                                                                                                                    b64min: b64min7,
                                                                                                                    b64max: b64max7,
                                                                                                                    length: func407(data25)
                                                                                                                },
                                                                                                                message: 'length must be between ' +
                                                                                                                    b64min7 +
                                                                                                                    ' and ' +
                                                                                                                    b64max7 +
                                                                                                                    ', but is ' +
                                                                                                                    func407(data25)
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    else {
                                                                                                        const decoded7 = func408(data25);
                                                                                                        if (decoded7.length !== 9) {
                                                                                                            validate151.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/skippedDSRefreshes/' + i3,
                                                                                                                    schemaPath: '#/properties/skippedDSRefreshes/items/uid',
                                                                                                                    keyword: 'uid',
                                                                                                                    params: { error: 'decoded' },
                                                                                                                    message: 'must decode to 9 bytes'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                        else {
                                                                                                            const encoded7 = func409(decoded7);
                                                                                                            if (func410(encoded7) !== func410(data25)) {
                                                                                                                validate151.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/skippedDSRefreshes/' + i3,
                                                                                                                        schemaPath: '#/properties/skippedDSRefreshes/items/uid',
                                                                                                                        keyword: 'uid',
                                                                                                                        params: { error: 'ambiguous' },
                                                                                                                        message: 'encoding is ambiguous'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    validate151.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/skippedDSRefreshes/' + i3,
                                                                                                            schemaPath: '#/properties/skippedDSRefreshes/items/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'string' },
                                                                                                            message: 'must be string'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            var valid17 = _errs58 === errors;
                                                                                            if (!valid17) {
                                                                                                break;
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate151.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/skippedDSRefreshes',
                                                                                                schemaPath: '#/properties/skippedDSRefreshes/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'array' },
                                                                                                message: 'must be array'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid0 = _errs56 === errors;
                                                                            }
                                                                            else {
                                                                                var valid0 = true;
                                                                            }
                                                                            if (valid0) {
                                                                                if (data.nodeToIsExcelExport !== undefined) {
                                                                                    let data26 = data.nodeToIsExcelExport;
                                                                                    const _errs60 = errors;
                                                                                    if (errors === _errs60) {
                                                                                        if (data26 && typeof data26 == 'object' && !Array.isArray(data26)) {
                                                                                            for (const key3 in data26) {
                                                                                                const _errs63 = errors;
                                                                                                if (typeof data26[key3] !== 'boolean') {
                                                                                                    validate151.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath +
                                                                                                                '/nodeToIsExcelExport/' +
                                                                                                                key3.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                                                            schemaPath: '#/properties/nodeToIsExcelExport/additionalProperties/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'boolean' },
                                                                                                            message: 'must be boolean'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                                var valid19 = _errs63 === errors;
                                                                                                if (!valid19) {
                                                                                                    break;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                        else {
                                                                                            validate151.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/nodeToIsExcelExport',
                                                                                                    schemaPath: '#/properties/nodeToIsExcelExport/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'object' },
                                                                                                    message: 'must be object'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    var valid0 = _errs60 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid0 = true;
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate151.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate151.errors = vErrors;
    return errors === 0;
}
export const runStatusCheckEventSchemaValidation = validate153;
const schema170 = {
    $id: 'urn:wisepipe-common-computation:RunStatusCheckEvent',
    type: 'object',
    properties: {
        status: { type: 'string', enum: ['running', 'failed', 'cancelled', 'completed'] },
        task: { $ref: 'urn:wisepipe-common-computation:ComputeTask' },
        pipeCreatedAt: { type: 'string', format: 'date-time' }
    },
    required: ['status', 'task', 'pipeCreatedAt']
};
function validate153(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:RunStatusCheckEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.status === undefined && (missing0 = 'status')) ||
                (data.task === undefined && (missing0 = 'task')) ||
                (data.pipeCreatedAt === undefined && (missing0 = 'pipeCreatedAt'))) {
                validate153.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.status !== undefined) {
                    let data0 = data.status;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate153.errors = [
                            {
                                instancePath: instancePath + '/status',
                                schemaPath: '#/properties/status/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'running' || data0 === 'failed' || data0 === 'cancelled' || data0 === 'completed')) {
                        validate153.errors = [
                            {
                                instancePath: instancePath + '/status',
                                schemaPath: '#/properties/status/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema170.properties.status.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.task !== undefined) {
                        const _errs3 = errors;
                        if (!validate25(data.task, {
                            instancePath: instancePath + '/task',
                            parentData: data,
                            parentDataProperty: 'task',
                            rootData
                        })) {
                            vErrors = vErrors === null ? validate25.errors : vErrors.concat(validate25.errors);
                            errors = vErrors.length;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.pipeCreatedAt !== undefined) {
                            let data2 = data.pipeCreatedAt;
                            const _errs4 = errors;
                            if (errors === _errs4) {
                                if (errors === _errs4) {
                                    if (typeof data2 === 'string') {
                                        if (!formats0.validate(data2)) {
                                            validate153.errors = [
                                                {
                                                    instancePath: instancePath + '/pipeCreatedAt',
                                                    schemaPath: '#/properties/pipeCreatedAt/format',
                                                    keyword: 'format',
                                                    params: { format: 'date-time' },
                                                    message: 'must match format "' + 'date-time' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate153.errors = [
                                            {
                                                instancePath: instancePath + '/pipeCreatedAt',
                                                schemaPath: '#/properties/pipeCreatedAt/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs4 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate153.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate153.errors = vErrors;
    return errors === 0;
}
export const s3CredentialsSchemaValidation = validate155;
function validate155(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common:S3Credentials" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.accessKey === undefined && (missing0 = 'accessKey')) ||
                (data.secret === undefined && (missing0 = 'secret'))) {
                validate155.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.accessKey !== undefined) {
                    let data0 = data.accessKey;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate155.errors = [
                                    {
                                        instancePath: instancePath + '/accessKey',
                                        schemaPath: '#/properties/accessKey/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate155.errors = [
                                {
                                    instancePath: instancePath + '/accessKey',
                                    schemaPath: '#/properties/accessKey/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.secret !== undefined) {
                        let data1 = data.secret;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate155.errors = [
                                        {
                                            instancePath: instancePath + '/secret',
                                            schemaPath: '#/properties/secret/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate155.errors = [
                                    {
                                        instancePath: instancePath + '/secret',
                                        schemaPath: '#/properties/secret/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.sessionToken !== undefined) {
                            let data2 = data.sessionToken;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate155.errors = [
                                            {
                                                instancePath: instancePath + '/sessionToken',
                                                schemaPath: '#/properties/sessionToken/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate155.errors = [
                                        {
                                            instancePath: instancePath + '/sessionToken',
                                            schemaPath: '#/properties/sessionToken/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate155.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate155.errors = vErrors;
    return errors === 0;
}
export const s3FileSchemaValidation = validate156;
const func416 = ucs2length;
const func417 = base64urlToBuffer;
const func418 = base64urlEncode;
const func419 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate156(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common:S3File" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.bucket === undefined && (missing0 = 'bucket')) || (data.key === undefined && (missing0 = 'key'))) {
                validate156.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.bucket !== undefined) {
                    let data0 = data.bucket;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate156.errors = [
                                    {
                                        instancePath: instancePath + '/bucket',
                                        schemaPath: '#/properties/bucket/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate156.errors = [
                                {
                                    instancePath: instancePath + '/bucket',
                                    schemaPath: '#/properties/bucket/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.key !== undefined) {
                        let data1 = data.key;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate156.errors = [
                                        {
                                            instancePath: instancePath + '/key',
                                            schemaPath: '#/properties/key/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate156.errors = [
                                    {
                                        instancePath: instancePath + '/key',
                                        schemaPath: '#/properties/key/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.uploadID !== undefined) {
                            let data2 = data.uploadID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    const b64min0 = Math.ceil((4 * 9) / 3);
                                    const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                    if (func416(data2) < b64min0 || func416(data2) > b64max0) {
                                        validate156.errors = [
                                            {
                                                instancePath: instancePath + '/uploadID',
                                                schemaPath: '#/properties/uploadID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func416(data2) },
                                                message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func416(data2)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded0 = func417(data2);
                                        if (decoded0.length !== 9) {
                                            validate156.errors = [
                                                {
                                                    instancePath: instancePath + '/uploadID',
                                                    schemaPath: '#/properties/uploadID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 9 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded0 = func418(decoded0);
                                            if (func419(encoded0) !== func419(data2)) {
                                                validate156.errors = [
                                                    {
                                                        instancePath: instancePath + '/uploadID',
                                                        schemaPath: '#/properties/uploadID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate156.errors = [
                                        {
                                            instancePath: instancePath + '/uploadID',
                                            schemaPath: '#/properties/uploadID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate156.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate156.errors = vErrors;
    return errors === 0;
}
export const sampleDataProfileRequestSchemaValidation = validate157;
const schema173 = {
    $id: 'urn:wisepipe-common-computation:SampleDataProfileRequest',
    type: 'object',
    properties: {
        pipeID: { type: 'string', uid: 10 },
        elementID: { type: 'string', uid: 10 },
        port: { type: 'string', minLength: 1 },
        reusableLogicParentNodeIDPath: { type: 'string', minLength: 1 },
        isNodeRLInput: { type: 'boolean' },
        draftReusableLogicIDs: { type: 'array', items: { type: 'string' } }
    },
    required: ['pipeID', 'elementID', 'port'],
    if: { anyOf: [{ required: ['isNodeRLInput'] }, { required: ['draftReusableLogicIDs'] }] },
    then: { required: ['reusableLogicParentNodeIDPath'] }
};
const func420 = ucs2length;
const func421 = base64urlToBuffer;
const func422 = base64urlEncode;
const func423 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func424 = ucs2length;
const func425 = base64urlToBuffer;
const func426 = base64urlEncode;
const func427 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate157(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:SampleDataProfileRequest" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    const _errs3 = errors;
    let valid1 = false;
    const _errs4 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if (data.isNodeRLInput === undefined && (missing0 = 'isNodeRLInput')) {
            const err0 = {};
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
    }
    var _valid1 = _errs4 === errors;
    valid1 = valid1 || _valid1;
    if (!valid1) {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if (data.draftReusableLogicIDs === undefined && (missing1 = 'draftReusableLogicIDs')) {
                const err1 = {};
                if (vErrors === null) {
                    vErrors = [err1];
                }
                else {
                    vErrors.push(err1);
                }
                errors++;
            }
        }
        var _valid1 = _errs5 === errors;
        valid1 = valid1 || _valid1;
    }
    if (!valid1) {
        const err2 = {};
        if (vErrors === null) {
            vErrors = [err2];
        }
        else {
            vErrors.push(err2);
        }
        errors++;
    }
    else {
        errors = _errs3;
        if (vErrors !== null) {
            if (_errs3) {
                vErrors.length = _errs3;
            }
            else {
                vErrors = null;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs6 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if (data.reusableLogicParentNodeIDPath === undefined && (missing2 = 'reusableLogicParentNodeIDPath')) {
                validate157.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing2 },
                        message: "must have required property '" + missing2 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs6 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err3 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err3];
        }
        else {
            vErrors.push(err3);
        }
        errors++;
        validate157.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing3;
            if ((data.pipeID === undefined && (missing3 = 'pipeID')) ||
                (data.elementID === undefined && (missing3 = 'elementID')) ||
                (data.port === undefined && (missing3 = 'port'))) {
                validate157.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing3 },
                        message: "must have required property '" + missing3 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pipeID !== undefined) {
                    let data0 = data.pipeID;
                    const _errs7 = errors;
                    if (errors === _errs7) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func420(data0) < b64min0 || func420(data0) > b64max0) {
                                validate157.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func420(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func420(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func421(data0);
                                if (decoded0.length !== 10) {
                                    validate157.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func422(decoded0);
                                    if (func423(encoded0) !== func423(data0)) {
                                        validate157.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate157.errors = [
                                {
                                    instancePath: instancePath + '/pipeID',
                                    schemaPath: '#/properties/pipeID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid2 = _errs7 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.elementID !== undefined) {
                        let data1 = data.elementID;
                        const _errs9 = errors;
                        if (errors === _errs9) {
                            if (typeof data1 === 'string') {
                                const b64min1 = Math.ceil((4 * 10) / 3);
                                const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                if (func424(data1) < b64min1 || func424(data1) > b64max1) {
                                    validate157.errors = [
                                        {
                                            instancePath: instancePath + '/elementID',
                                            schemaPath: '#/properties/elementID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func424(data1) },
                                            message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func424(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded1 = func425(data1);
                                    if (decoded1.length !== 10) {
                                        validate157.errors = [
                                            {
                                                instancePath: instancePath + '/elementID',
                                                schemaPath: '#/properties/elementID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 10 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded1 = func426(decoded1);
                                        if (func427(encoded1) !== func427(data1)) {
                                            validate157.errors = [
                                                {
                                                    instancePath: instancePath + '/elementID',
                                                    schemaPath: '#/properties/elementID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate157.errors = [
                                    {
                                        instancePath: instancePath + '/elementID',
                                        schemaPath: '#/properties/elementID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid2 = _errs9 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.port !== undefined) {
                            let data2 = data.port;
                            const _errs11 = errors;
                            if (errors === _errs11) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate157.errors = [
                                            {
                                                instancePath: instancePath + '/port',
                                                schemaPath: '#/properties/port/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate157.errors = [
                                        {
                                            instancePath: instancePath + '/port',
                                            schemaPath: '#/properties/port/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid2 = _errs11 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                        if (valid2) {
                            if (data.reusableLogicParentNodeIDPath !== undefined) {
                                let data3 = data.reusableLogicParentNodeIDPath;
                                const _errs13 = errors;
                                if (errors === _errs13) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) < 1) {
                                            validate157.errors = [
                                                {
                                                    instancePath: instancePath + '/reusableLogicParentNodeIDPath',
                                                    schemaPath: '#/properties/reusableLogicParentNodeIDPath/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate157.errors = [
                                            {
                                                instancePath: instancePath + '/reusableLogicParentNodeIDPath',
                                                schemaPath: '#/properties/reusableLogicParentNodeIDPath/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid2 = _errs13 === errors;
                            }
                            else {
                                var valid2 = true;
                            }
                            if (valid2) {
                                if (data.isNodeRLInput !== undefined) {
                                    const _errs15 = errors;
                                    if (typeof data.isNodeRLInput !== 'boolean') {
                                        validate157.errors = [
                                            {
                                                instancePath: instancePath + '/isNodeRLInput',
                                                schemaPath: '#/properties/isNodeRLInput/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid2 = _errs15 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data.draftReusableLogicIDs !== undefined) {
                                        let data5 = data.draftReusableLogicIDs;
                                        const _errs17 = errors;
                                        if (errors === _errs17) {
                                            if (Array.isArray(data5)) {
                                                var valid5 = true;
                                                const len0 = data5.length;
                                                for (let i0 = 0; i0 < len0; i0++) {
                                                    const _errs19 = errors;
                                                    if (typeof data5[i0] !== 'string') {
                                                        validate157.errors = [
                                                            {
                                                                instancePath: instancePath + '/draftReusableLogicIDs/' + i0,
                                                                schemaPath: '#/properties/draftReusableLogicIDs/items/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid5 = _errs19 === errors;
                                                    if (!valid5) {
                                                        break;
                                                    }
                                                }
                                            }
                                            else {
                                                validate157.errors = [
                                                    {
                                                        instancePath: instancePath + '/draftReusableLogicIDs',
                                                        schemaPath: '#/properties/draftReusableLogicIDs/type',
                                                        keyword: 'type',
                                                        params: { type: 'array' },
                                                        message: 'must be array'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs17 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate157.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate157.errors = vErrors;
    return errors === 0;
}
export const sampleRequestSchemaValidation = validate158;
const schema174 = {
    $id: 'urn:wisepipe-common-computation:SampleRequest',
    type: 'object',
    properties: {
        pipeID: { type: 'string', uid: 10 },
        elementID: { type: 'string', uid: 10 },
        port: { type: 'string', minLength: 1 },
        uniqueValuesColumn: { type: 'string', minLength: 0 },
        aggValuesColumn: { $ref: 'urn:wisepipe-base-pipe:AggregateColumn' },
        reusableLogicParentNodeIDPath: { type: 'string', minLength: 1 },
        isNodeRLInput: { type: 'boolean' },
        draftReusableLogicIDs: { type: 'array', items: { type: 'string' } }
    },
    required: ['pipeID', 'elementID', 'port'],
    if: { anyOf: [{ required: ['isNodeRLInput'] }, { required: ['draftReusableLogicIDs'] }] },
    then: { required: ['reusableLogicParentNodeIDPath'] }
};
const func430 = ucs2length;
const func431 = base64urlToBuffer;
const func432 = base64urlEncode;
const func433 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func434 = ucs2length;
const func435 = base64urlToBuffer;
const func436 = base64urlEncode;
const func437 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate158(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:SampleRequest" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    const _errs3 = errors;
    let valid1 = false;
    const _errs4 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if (data.isNodeRLInput === undefined && (missing0 = 'isNodeRLInput')) {
            const err0 = {};
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
    }
    var _valid1 = _errs4 === errors;
    valid1 = valid1 || _valid1;
    if (!valid1) {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if (data.draftReusableLogicIDs === undefined && (missing1 = 'draftReusableLogicIDs')) {
                const err1 = {};
                if (vErrors === null) {
                    vErrors = [err1];
                }
                else {
                    vErrors.push(err1);
                }
                errors++;
            }
        }
        var _valid1 = _errs5 === errors;
        valid1 = valid1 || _valid1;
    }
    if (!valid1) {
        const err2 = {};
        if (vErrors === null) {
            vErrors = [err2];
        }
        else {
            vErrors.push(err2);
        }
        errors++;
    }
    else {
        errors = _errs3;
        if (vErrors !== null) {
            if (_errs3) {
                vErrors.length = _errs3;
            }
            else {
                vErrors = null;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs6 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if (data.reusableLogicParentNodeIDPath === undefined && (missing2 = 'reusableLogicParentNodeIDPath')) {
                validate158.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing2 },
                        message: "must have required property '" + missing2 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs6 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err3 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err3];
        }
        else {
            vErrors.push(err3);
        }
        errors++;
        validate158.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing3;
            if ((data.pipeID === undefined && (missing3 = 'pipeID')) ||
                (data.elementID === undefined && (missing3 = 'elementID')) ||
                (data.port === undefined && (missing3 = 'port'))) {
                validate158.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing3 },
                        message: "must have required property '" + missing3 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pipeID !== undefined) {
                    let data0 = data.pipeID;
                    const _errs7 = errors;
                    if (errors === _errs7) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func430(data0) < b64min0 || func430(data0) > b64max0) {
                                validate158.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func430(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func430(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func431(data0);
                                if (decoded0.length !== 10) {
                                    validate158.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func432(decoded0);
                                    if (func433(encoded0) !== func433(data0)) {
                                        validate158.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate158.errors = [
                                {
                                    instancePath: instancePath + '/pipeID',
                                    schemaPath: '#/properties/pipeID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid2 = _errs7 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.elementID !== undefined) {
                        let data1 = data.elementID;
                        const _errs9 = errors;
                        if (errors === _errs9) {
                            if (typeof data1 === 'string') {
                                const b64min1 = Math.ceil((4 * 10) / 3);
                                const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                if (func434(data1) < b64min1 || func434(data1) > b64max1) {
                                    validate158.errors = [
                                        {
                                            instancePath: instancePath + '/elementID',
                                            schemaPath: '#/properties/elementID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func434(data1) },
                                            message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func434(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded1 = func435(data1);
                                    if (decoded1.length !== 10) {
                                        validate158.errors = [
                                            {
                                                instancePath: instancePath + '/elementID',
                                                schemaPath: '#/properties/elementID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 10 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded1 = func436(decoded1);
                                        if (func437(encoded1) !== func437(data1)) {
                                            validate158.errors = [
                                                {
                                                    instancePath: instancePath + '/elementID',
                                                    schemaPath: '#/properties/elementID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate158.errors = [
                                    {
                                        instancePath: instancePath + '/elementID',
                                        schemaPath: '#/properties/elementID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid2 = _errs9 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.port !== undefined) {
                            let data2 = data.port;
                            const _errs11 = errors;
                            if (errors === _errs11) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate158.errors = [
                                            {
                                                instancePath: instancePath + '/port',
                                                schemaPath: '#/properties/port/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate158.errors = [
                                        {
                                            instancePath: instancePath + '/port',
                                            schemaPath: '#/properties/port/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid2 = _errs11 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                        if (valid2) {
                            if (data.uniqueValuesColumn !== undefined) {
                                let data3 = data.uniqueValuesColumn;
                                const _errs13 = errors;
                                if (errors === _errs13) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) < 0) {
                                            validate158.errors = [
                                                {
                                                    instancePath: instancePath + '/uniqueValuesColumn',
                                                    schemaPath: '#/properties/uniqueValuesColumn/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 0 },
                                                    message: 'must NOT have fewer than 0 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate158.errors = [
                                            {
                                                instancePath: instancePath + '/uniqueValuesColumn',
                                                schemaPath: '#/properties/uniqueValuesColumn/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid2 = _errs13 === errors;
                            }
                            else {
                                var valid2 = true;
                            }
                            if (valid2) {
                                if (data.aggValuesColumn !== undefined) {
                                    const _errs15 = errors;
                                    if (!validate12(data.aggValuesColumn, {
                                        instancePath: instancePath + '/aggValuesColumn',
                                        parentData: data,
                                        parentDataProperty: 'aggValuesColumn',
                                        rootData
                                    })) {
                                        vErrors = vErrors === null ? validate12.errors : vErrors.concat(validate12.errors);
                                        errors = vErrors.length;
                                    }
                                    var valid2 = _errs15 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data.reusableLogicParentNodeIDPath !== undefined) {
                                        let data5 = data.reusableLogicParentNodeIDPath;
                                        const _errs16 = errors;
                                        if (errors === _errs16) {
                                            if (typeof data5 === 'string') {
                                                if (func2(data5) < 1) {
                                                    validate158.errors = [
                                                        {
                                                            instancePath: instancePath + '/reusableLogicParentNodeIDPath',
                                                            schemaPath: '#/properties/reusableLogicParentNodeIDPath/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate158.errors = [
                                                    {
                                                        instancePath: instancePath + '/reusableLogicParentNodeIDPath',
                                                        schemaPath: '#/properties/reusableLogicParentNodeIDPath/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs16 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data.isNodeRLInput !== undefined) {
                                            const _errs18 = errors;
                                            if (typeof data.isNodeRLInput !== 'boolean') {
                                                validate158.errors = [
                                                    {
                                                        instancePath: instancePath + '/isNodeRLInput',
                                                        schemaPath: '#/properties/isNodeRLInput/type',
                                                        keyword: 'type',
                                                        params: { type: 'boolean' },
                                                        message: 'must be boolean'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid2 = _errs18 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                        if (valid2) {
                                            if (data.draftReusableLogicIDs !== undefined) {
                                                let data7 = data.draftReusableLogicIDs;
                                                const _errs20 = errors;
                                                if (errors === _errs20) {
                                                    if (Array.isArray(data7)) {
                                                        var valid5 = true;
                                                        const len0 = data7.length;
                                                        for (let i0 = 0; i0 < len0; i0++) {
                                                            const _errs22 = errors;
                                                            if (typeof data7[i0] !== 'string') {
                                                                validate158.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/draftReusableLogicIDs/' + i0,
                                                                        schemaPath: '#/properties/draftReusableLogicIDs/items/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid5 = _errs22 === errors;
                                                            if (!valid5) {
                                                                break;
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate158.errors = [
                                                            {
                                                                instancePath: instancePath + '/draftReusableLogicIDs',
                                                                schemaPath: '#/properties/draftReusableLogicIDs/type',
                                                                keyword: 'type',
                                                                params: { type: 'array' },
                                                                message: 'must be array'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid2 = _errs20 === errors;
                                            }
                                            else {
                                                var valid2 = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate158.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate158.errors = vErrors;
    return errors === 0;
}
export const sampleStatsRequestSchemaValidation = validate160;
const schema175 = {
    $id: 'urn:wisepipe-common-computation:SampleStatsRequest',
    type: 'object',
    properties: {
        pipeID: { type: 'string', uid: 10 },
        elementID: { type: 'string', uid: 10 },
        port: { type: 'string', minLength: 1 },
        reusableLogicParentNodeIDPath: { type: 'string', minLength: 1 },
        isNodeRLInput: { type: 'boolean' },
        draftReusableLogicIDs: { type: 'array', items: { type: 'string' } }
    },
    required: ['pipeID', 'elementID', 'port'],
    if: { anyOf: [{ required: ['isNodeRLInput'] }, { required: ['draftReusableLogicIDs'] }] },
    then: { required: ['reusableLogicParentNodeIDPath'] }
};
const func441 = ucs2length;
const func442 = base64urlToBuffer;
const func443 = base64urlEncode;
const func444 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func445 = ucs2length;
const func446 = base64urlToBuffer;
const func447 = base64urlEncode;
const func448 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate160(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:SampleStatsRequest" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    const _errs3 = errors;
    let valid1 = false;
    const _errs4 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if (data.isNodeRLInput === undefined && (missing0 = 'isNodeRLInput')) {
            const err0 = {};
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
    }
    var _valid1 = _errs4 === errors;
    valid1 = valid1 || _valid1;
    if (!valid1) {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if (data.draftReusableLogicIDs === undefined && (missing1 = 'draftReusableLogicIDs')) {
                const err1 = {};
                if (vErrors === null) {
                    vErrors = [err1];
                }
                else {
                    vErrors.push(err1);
                }
                errors++;
            }
        }
        var _valid1 = _errs5 === errors;
        valid1 = valid1 || _valid1;
    }
    if (!valid1) {
        const err2 = {};
        if (vErrors === null) {
            vErrors = [err2];
        }
        else {
            vErrors.push(err2);
        }
        errors++;
    }
    else {
        errors = _errs3;
        if (vErrors !== null) {
            if (_errs3) {
                vErrors.length = _errs3;
            }
            else {
                vErrors = null;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs6 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if (data.reusableLogicParentNodeIDPath === undefined && (missing2 = 'reusableLogicParentNodeIDPath')) {
                validate160.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing2 },
                        message: "must have required property '" + missing2 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs6 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err3 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err3];
        }
        else {
            vErrors.push(err3);
        }
        errors++;
        validate160.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing3;
            if ((data.pipeID === undefined && (missing3 = 'pipeID')) ||
                (data.elementID === undefined && (missing3 = 'elementID')) ||
                (data.port === undefined && (missing3 = 'port'))) {
                validate160.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing3 },
                        message: "must have required property '" + missing3 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pipeID !== undefined) {
                    let data0 = data.pipeID;
                    const _errs7 = errors;
                    if (errors === _errs7) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func441(data0) < b64min0 || func441(data0) > b64max0) {
                                validate160.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func441(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func441(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func442(data0);
                                if (decoded0.length !== 10) {
                                    validate160.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func443(decoded0);
                                    if (func444(encoded0) !== func444(data0)) {
                                        validate160.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate160.errors = [
                                {
                                    instancePath: instancePath + '/pipeID',
                                    schemaPath: '#/properties/pipeID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid2 = _errs7 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.elementID !== undefined) {
                        let data1 = data.elementID;
                        const _errs9 = errors;
                        if (errors === _errs9) {
                            if (typeof data1 === 'string') {
                                const b64min1 = Math.ceil((4 * 10) / 3);
                                const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                if (func445(data1) < b64min1 || func445(data1) > b64max1) {
                                    validate160.errors = [
                                        {
                                            instancePath: instancePath + '/elementID',
                                            schemaPath: '#/properties/elementID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func445(data1) },
                                            message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func445(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded1 = func446(data1);
                                    if (decoded1.length !== 10) {
                                        validate160.errors = [
                                            {
                                                instancePath: instancePath + '/elementID',
                                                schemaPath: '#/properties/elementID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 10 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded1 = func447(decoded1);
                                        if (func448(encoded1) !== func448(data1)) {
                                            validate160.errors = [
                                                {
                                                    instancePath: instancePath + '/elementID',
                                                    schemaPath: '#/properties/elementID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate160.errors = [
                                    {
                                        instancePath: instancePath + '/elementID',
                                        schemaPath: '#/properties/elementID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid2 = _errs9 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.port !== undefined) {
                            let data2 = data.port;
                            const _errs11 = errors;
                            if (errors === _errs11) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate160.errors = [
                                            {
                                                instancePath: instancePath + '/port',
                                                schemaPath: '#/properties/port/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate160.errors = [
                                        {
                                            instancePath: instancePath + '/port',
                                            schemaPath: '#/properties/port/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid2 = _errs11 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                        if (valid2) {
                            if (data.reusableLogicParentNodeIDPath !== undefined) {
                                let data3 = data.reusableLogicParentNodeIDPath;
                                const _errs13 = errors;
                                if (errors === _errs13) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) < 1) {
                                            validate160.errors = [
                                                {
                                                    instancePath: instancePath + '/reusableLogicParentNodeIDPath',
                                                    schemaPath: '#/properties/reusableLogicParentNodeIDPath/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate160.errors = [
                                            {
                                                instancePath: instancePath + '/reusableLogicParentNodeIDPath',
                                                schemaPath: '#/properties/reusableLogicParentNodeIDPath/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid2 = _errs13 === errors;
                            }
                            else {
                                var valid2 = true;
                            }
                            if (valid2) {
                                if (data.isNodeRLInput !== undefined) {
                                    const _errs15 = errors;
                                    if (typeof data.isNodeRLInput !== 'boolean') {
                                        validate160.errors = [
                                            {
                                                instancePath: instancePath + '/isNodeRLInput',
                                                schemaPath: '#/properties/isNodeRLInput/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid2 = _errs15 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data.draftReusableLogicIDs !== undefined) {
                                        let data5 = data.draftReusableLogicIDs;
                                        const _errs17 = errors;
                                        if (errors === _errs17) {
                                            if (Array.isArray(data5)) {
                                                var valid5 = true;
                                                const len0 = data5.length;
                                                for (let i0 = 0; i0 < len0; i0++) {
                                                    const _errs19 = errors;
                                                    if (typeof data5[i0] !== 'string') {
                                                        validate160.errors = [
                                                            {
                                                                instancePath: instancePath + '/draftReusableLogicIDs/' + i0,
                                                                schemaPath: '#/properties/draftReusableLogicIDs/items/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid5 = _errs19 === errors;
                                                    if (!valid5) {
                                                        break;
                                                    }
                                                }
                                            }
                                            else {
                                                validate160.errors = [
                                                    {
                                                        instancePath: instancePath + '/draftReusableLogicIDs',
                                                        schemaPath: '#/properties/draftReusableLogicIDs/type',
                                                        keyword: 'type',
                                                        params: { type: 'array' },
                                                        message: 'must be array'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs17 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate160.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate160.errors = vErrors;
    return errors === 0;
}
export const sampleVisualRequestSchemaValidation = validate161;
const schema176 = {
    $id: 'urn:wisepipe-common-computation:SampleVisualRequest',
    type: 'object',
    properties: {
        pipeID: { type: 'string', uid: 10 },
        elementID: { type: 'string', uid: 10 },
        port: { type: 'string', minLength: 1 },
        params: { $ref: 'urn:wisepipe-common-computation:VisualParams' },
        reusableLogicParentNodeIDPath: { type: 'string', minLength: 1 },
        isNodeRLInput: { type: 'boolean' },
        draftReusableLogicIDs: { type: 'array', items: { type: 'string' } }
    },
    required: ['pipeID', 'elementID', 'port', 'params'],
    if: { anyOf: [{ required: ['isNodeRLInput'] }, { required: ['draftReusableLogicIDs'] }] },
    then: { required: ['reusableLogicParentNodeIDPath'] }
};
const func451 = ucs2length;
const func452 = base64urlToBuffer;
const func453 = base64urlEncode;
const func454 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func455 = ucs2length;
const func456 = base64urlToBuffer;
const func457 = base64urlEncode;
const func458 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const schema177 = {
    $id: 'urn:wisepipe-common-computation:VisualParams',
    type: 'object',
    properties: {
        visualType: {
            type: 'string',
            enum: [
                'bubble',
                'bubbleSingleAxis',
                'candlestick',
                'boxplot',
                'circle',
                'generic',
                'heatmap',
                'histogram',
                'map',
                'sankey',
                'scatter_map',
                'combination',
                'table',
                'forecast'
            ]
        },
        sortDir: { type: 'string', enum: ['ascending', 'descending'] },
        showTitle: { type: 'boolean' },
        showSubTitle: { type: 'boolean' },
        subTitle: { type: 'string' },
        xTitleName: { type: 'string' },
        xTitleShow: { type: 'boolean' },
        xAxisLabelAngle: { type: 'number' },
        yTitleName: { type: 'string' },
        yTitleShow: { type: 'boolean' },
        yAxisLabelAngle: { type: 'number' },
        yRightTitle: { type: 'string' },
        yRightShow: { type: 'boolean' },
        yRightAxisLabelAngle: { type: 'number' },
        legendShow: { type: 'boolean' },
        legendSubcatShow: { type: 'boolean' },
        legendTop: { type: 'string' },
        legendLeft: { type: 'string' },
        gradient: { type: 'boolean' },
        shadow: { type: 'boolean' },
        colorMap: { type: 'object', additionalProperties: { type: 'string' } },
        sortColumns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:SortColumn' },
            minItems: 1,
            uniqueItemProperties: ['name']
        },
        spacing: {
            type: 'object',
            properties: {
                left: { type: ['number', 'null'] },
                right: { type: ['number', 'null'] },
                top: { type: ['number', 'null'] },
                bottom: { type: ['number', 'null'] }
            }
        },
        overflow: { type: 'string', enum: ['truncate', 'break', 'breakAll'] },
        filters: { type: 'array', items: { $ref: 'urn:wisepipe-common-computation:Filter' }, maxItems: 20 }
    },
    required: ['visualType']
};
const schema178 = {
    $id: 'urn:wisepipe-common-pipe:SortColumn',
    type: 'object',
    properties: {
        name: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string' }] },
        direction: {
            oneOf: [
                { $ref: 'urn:wisepipe-base-pipe:EnumToolVariable' },
                { type: 'string', enum: ['ascending', 'descending'] }
            ]
        }
    },
    required: ['name', 'direction']
};
function validate163(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:SortColumn" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.name === undefined && (missing0 = 'name')) ||
                (data.direction === undefined && (missing0 = 'direction'))) {
                validate163.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data0 = data.name;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    let valid1 = false;
                    let passing0 = null;
                    const _errs3 = errors;
                    const _errs4 = errors;
                    if (errors === _errs4) {
                        if (!(data0 && typeof data0 == 'object' && !Array.isArray(data0))) {
                            const err0 = {
                                instancePath: instancePath + '/name',
                                schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            };
                            if (vErrors === null) {
                                vErrors = [err0];
                            }
                            else {
                                vErrors.push(err0);
                            }
                            errors++;
                        }
                    }
                    var _valid0 = _errs3 === errors;
                    if (_valid0) {
                        valid1 = true;
                        passing0 = 0;
                    }
                    const _errs6 = errors;
                    if (typeof data0 !== 'string') {
                        const err1 = {
                            instancePath: instancePath + '/name',
                            schemaPath: '#/properties/name/oneOf/1/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string'
                        };
                        if (vErrors === null) {
                            vErrors = [err1];
                        }
                        else {
                            vErrors.push(err1);
                        }
                        errors++;
                    }
                    var _valid0 = _errs6 === errors;
                    if (_valid0 && valid1) {
                        valid1 = false;
                        passing0 = [passing0, 1];
                    }
                    else {
                        if (_valid0) {
                            valid1 = true;
                            passing0 = 1;
                        }
                    }
                    if (!valid1) {
                        const err2 = {
                            instancePath: instancePath + '/name',
                            schemaPath: '#/properties/name/oneOf',
                            keyword: 'oneOf',
                            params: { passingSchemas: passing0 },
                            message: 'must match exactly one schema in oneOf'
                        };
                        if (vErrors === null) {
                            vErrors = [err2];
                        }
                        else {
                            vErrors.push(err2);
                        }
                        errors++;
                        validate163.errors = vErrors;
                        return false;
                    }
                    else {
                        errors = _errs2;
                        if (vErrors !== null) {
                            if (_errs2) {
                                vErrors.length = _errs2;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.direction !== undefined) {
                        let data1 = data.direction;
                        const _errs8 = errors;
                        const _errs9 = errors;
                        let valid3 = false;
                        let passing1 = null;
                        const _errs10 = errors;
                        const _errs11 = errors;
                        if (errors === _errs11) {
                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                if (data1.toolEnumType !== undefined) {
                                    let data2 = data1.toolEnumType;
                                    if (typeof data2 !== 'string') {
                                        const err3 = {
                                            instancePath: instancePath + '/direction/toolEnumType',
                                            schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err3];
                                        }
                                        else {
                                            vErrors.push(err3);
                                        }
                                        errors++;
                                    }
                                    if (!(data2 === 'SortDirection' ||
                                        data2 === 'AggregateColumnOperation' ||
                                        data2 === 'DateFrequency' ||
                                        data2 === 'DateAddType' ||
                                        data2 === 'DateAddUnit' ||
                                        data2 === 'DateUnitType' ||
                                        data2 === 'DatePartType' ||
                                        data2 === 'JoinOperator' ||
                                        data2 === 'JoinPattern' ||
                                        data2 === 'FilterStatementOp' ||
                                        data2 === 'ColumnType' ||
                                        data2 === 'PeriodAddType')) {
                                        const err4 = {
                                            instancePath: instancePath + '/direction/toolEnumType',
                                            schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema31.properties.toolEnumType.enum },
                                            message: 'must be equal to one of the allowed values'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err4];
                                        }
                                        else {
                                            vErrors.push(err4);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            else {
                                const err5 = {
                                    instancePath: instancePath + '/direction',
                                    schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                };
                                if (vErrors === null) {
                                    vErrors = [err5];
                                }
                                else {
                                    vErrors.push(err5);
                                }
                                errors++;
                            }
                        }
                        var _valid1 = _errs10 === errors;
                        if (_valid1) {
                            valid3 = true;
                            passing1 = 0;
                        }
                        const _errs15 = errors;
                        if (typeof data1 !== 'string') {
                            const err6 = {
                                instancePath: instancePath + '/direction',
                                schemaPath: '#/properties/direction/oneOf/1/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            };
                            if (vErrors === null) {
                                vErrors = [err6];
                            }
                            else {
                                vErrors.push(err6);
                            }
                            errors++;
                        }
                        if (!(data1 === 'ascending' || data1 === 'descending')) {
                            const err7 = {
                                instancePath: instancePath + '/direction',
                                schemaPath: '#/properties/direction/oneOf/1/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema178.properties.direction.oneOf[1].enum },
                                message: 'must be equal to one of the allowed values'
                            };
                            if (vErrors === null) {
                                vErrors = [err7];
                            }
                            else {
                                vErrors.push(err7);
                            }
                            errors++;
                        }
                        var _valid1 = _errs15 === errors;
                        if (_valid1 && valid3) {
                            valid3 = false;
                            passing1 = [passing1, 1];
                        }
                        else {
                            if (_valid1) {
                                valid3 = true;
                                passing1 = 1;
                            }
                        }
                        if (!valid3) {
                            const err8 = {
                                instancePath: instancePath + '/direction',
                                schemaPath: '#/properties/direction/oneOf',
                                keyword: 'oneOf',
                                params: { passingSchemas: passing1 },
                                message: 'must match exactly one schema in oneOf'
                            };
                            if (vErrors === null) {
                                vErrors = [err8];
                            }
                            else {
                                vErrors.push(err8);
                            }
                            errors++;
                            validate163.errors = vErrors;
                            return false;
                        }
                        else {
                            errors = _errs9;
                            if (vErrors !== null) {
                                if (_errs9) {
                                    vErrors.length = _errs9;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                        }
                        var valid0 = _errs8 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate163.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate163.errors = vErrors;
    return errors === 0;
}
const func460 = ajvEqual;
function validate162(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:VisualParams" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.visualType === undefined && (missing0 = 'visualType')) {
                validate162.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.visualType !== undefined) {
                    let data0 = data.visualType;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate162.errors = [
                            {
                                instancePath: instancePath + '/visualType',
                                schemaPath: '#/properties/visualType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'bubble' ||
                        data0 === 'bubbleSingleAxis' ||
                        data0 === 'candlestick' ||
                        data0 === 'boxplot' ||
                        data0 === 'circle' ||
                        data0 === 'generic' ||
                        data0 === 'heatmap' ||
                        data0 === 'histogram' ||
                        data0 === 'map' ||
                        data0 === 'sankey' ||
                        data0 === 'scatter_map' ||
                        data0 === 'combination' ||
                        data0 === 'table' ||
                        data0 === 'forecast')) {
                        validate162.errors = [
                            {
                                instancePath: instancePath + '/visualType',
                                schemaPath: '#/properties/visualType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema177.properties.visualType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.sortDir !== undefined) {
                        let data1 = data.sortDir;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate162.errors = [
                                {
                                    instancePath: instancePath + '/sortDir',
                                    schemaPath: '#/properties/sortDir/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'ascending' || data1 === 'descending')) {
                            validate162.errors = [
                                {
                                    instancePath: instancePath + '/sortDir',
                                    schemaPath: '#/properties/sortDir/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema177.properties.sortDir.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.showTitle !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.showTitle !== 'boolean') {
                                validate162.errors = [
                                    {
                                        instancePath: instancePath + '/showTitle',
                                        schemaPath: '#/properties/showTitle/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.showSubTitle !== undefined) {
                                const _errs7 = errors;
                                if (typeof data.showSubTitle !== 'boolean') {
                                    validate162.errors = [
                                        {
                                            instancePath: instancePath + '/showSubTitle',
                                            schemaPath: '#/properties/showSubTitle/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.subTitle !== undefined) {
                                    const _errs9 = errors;
                                    if (typeof data.subTitle !== 'string') {
                                        validate162.errors = [
                                            {
                                                instancePath: instancePath + '/subTitle',
                                                schemaPath: '#/properties/subTitle/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.xTitleName !== undefined) {
                                        const _errs11 = errors;
                                        if (typeof data.xTitleName !== 'string') {
                                            validate162.errors = [
                                                {
                                                    instancePath: instancePath + '/xTitleName',
                                                    schemaPath: '#/properties/xTitleName/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.xTitleShow !== undefined) {
                                            const _errs13 = errors;
                                            if (typeof data.xTitleShow !== 'boolean') {
                                                validate162.errors = [
                                                    {
                                                        instancePath: instancePath + '/xTitleShow',
                                                        schemaPath: '#/properties/xTitleShow/type',
                                                        keyword: 'type',
                                                        params: { type: 'boolean' },
                                                        message: 'must be boolean'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.xAxisLabelAngle !== undefined) {
                                                const _errs15 = errors;
                                                if (!(typeof data.xAxisLabelAngle == 'number')) {
                                                    validate162.errors = [
                                                        {
                                                            instancePath: instancePath + '/xAxisLabelAngle',
                                                            schemaPath: '#/properties/xAxisLabelAngle/type',
                                                            keyword: 'type',
                                                            params: { type: 'number' },
                                                            message: 'must be number'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid0 = _errs15 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.yTitleName !== undefined) {
                                                    const _errs17 = errors;
                                                    if (typeof data.yTitleName !== 'string') {
                                                        validate162.errors = [
                                                            {
                                                                instancePath: instancePath + '/yTitleName',
                                                                schemaPath: '#/properties/yTitleName/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid0 = _errs17 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.yTitleShow !== undefined) {
                                                        const _errs19 = errors;
                                                        if (typeof data.yTitleShow !== 'boolean') {
                                                            validate162.errors = [
                                                                {
                                                                    instancePath: instancePath + '/yTitleShow',
                                                                    schemaPath: '#/properties/yTitleShow/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'boolean' },
                                                                    message: 'must be boolean'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid0 = _errs19 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (data.yAxisLabelAngle !== undefined) {
                                                            const _errs21 = errors;
                                                            if (!(typeof data.yAxisLabelAngle == 'number')) {
                                                                validate162.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/yAxisLabelAngle',
                                                                        schemaPath: '#/properties/yAxisLabelAngle/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'number' },
                                                                        message: 'must be number'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid0 = _errs21 === errors;
                                                        }
                                                        else {
                                                            var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                            if (data.yRightTitle !== undefined) {
                                                                const _errs23 = errors;
                                                                if (typeof data.yRightTitle !== 'string') {
                                                                    validate162.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/yRightTitle',
                                                                            schemaPath: '#/properties/yRightTitle/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid0 = _errs23 === errors;
                                                            }
                                                            else {
                                                                var valid0 = true;
                                                            }
                                                            if (valid0) {
                                                                if (data.yRightShow !== undefined) {
                                                                    const _errs25 = errors;
                                                                    if (typeof data.yRightShow !== 'boolean') {
                                                                        validate162.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/yRightShow',
                                                                                schemaPath: '#/properties/yRightShow/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'boolean' },
                                                                                message: 'must be boolean'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid0 = _errs25 === errors;
                                                                }
                                                                else {
                                                                    var valid0 = true;
                                                                }
                                                                if (valid0) {
                                                                    if (data.yRightAxisLabelAngle !== undefined) {
                                                                        const _errs27 = errors;
                                                                        if (!(typeof data.yRightAxisLabelAngle == 'number')) {
                                                                            validate162.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/yRightAxisLabelAngle',
                                                                                    schemaPath: '#/properties/yRightAxisLabelAngle/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'number' },
                                                                                    message: 'must be number'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        var valid0 = _errs27 === errors;
                                                                    }
                                                                    else {
                                                                        var valid0 = true;
                                                                    }
                                                                    if (valid0) {
                                                                        if (data.legendShow !== undefined) {
                                                                            const _errs29 = errors;
                                                                            if (typeof data.legendShow !== 'boolean') {
                                                                                validate162.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/legendShow',
                                                                                        schemaPath: '#/properties/legendShow/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'boolean' },
                                                                                        message: 'must be boolean'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            var valid0 = _errs29 === errors;
                                                                        }
                                                                        else {
                                                                            var valid0 = true;
                                                                        }
                                                                        if (valid0) {
                                                                            if (data.legendSubcatShow !== undefined) {
                                                                                const _errs31 = errors;
                                                                                if (typeof data.legendSubcatShow !== 'boolean') {
                                                                                    validate162.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/legendSubcatShow',
                                                                                            schemaPath: '#/properties/legendSubcatShow/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'boolean' },
                                                                                            message: 'must be boolean'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                var valid0 = _errs31 === errors;
                                                                            }
                                                                            else {
                                                                                var valid0 = true;
                                                                            }
                                                                            if (valid0) {
                                                                                if (data.legendTop !== undefined) {
                                                                                    const _errs33 = errors;
                                                                                    if (typeof data.legendTop !== 'string') {
                                                                                        validate162.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/legendTop',
                                                                                                schemaPath: '#/properties/legendTop/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    var valid0 = _errs33 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid0 = true;
                                                                                }
                                                                                if (valid0) {
                                                                                    if (data.legendLeft !== undefined) {
                                                                                        const _errs35 = errors;
                                                                                        if (typeof data.legendLeft !== 'string') {
                                                                                            validate162.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/legendLeft',
                                                                                                    schemaPath: '#/properties/legendLeft/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'string' },
                                                                                                    message: 'must be string'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        var valid0 = _errs35 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid0 = true;
                                                                                    }
                                                                                    if (valid0) {
                                                                                        if (data.gradient !== undefined) {
                                                                                            const _errs37 = errors;
                                                                                            if (typeof data.gradient !== 'boolean') {
                                                                                                validate162.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/gradient',
                                                                                                        schemaPath: '#/properties/gradient/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'boolean' },
                                                                                                        message: 'must be boolean'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                            var valid0 = _errs37 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid0 = true;
                                                                                        }
                                                                                        if (valid0) {
                                                                                            if (data.shadow !== undefined) {
                                                                                                const _errs39 = errors;
                                                                                                if (typeof data.shadow !== 'boolean') {
                                                                                                    validate162.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/shadow',
                                                                                                            schemaPath: '#/properties/shadow/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'boolean' },
                                                                                                            message: 'must be boolean'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                                var valid0 = _errs39 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid0 = true;
                                                                                            }
                                                                                            if (valid0) {
                                                                                                if (data.colorMap !== undefined) {
                                                                                                    let data20 = data.colorMap;
                                                                                                    const _errs41 = errors;
                                                                                                    if (errors === _errs41) {
                                                                                                        if (data20 && typeof data20 == 'object' && !Array.isArray(data20)) {
                                                                                                            for (const key0 in data20) {
                                                                                                                const _errs44 = errors;
                                                                                                                if (typeof data20[key0] !== 'string') {
                                                                                                                    validate162.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath +
                                                                                                                                '/colorMap/' +
                                                                                                                                key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                                                                            schemaPath: '#/properties/colorMap/additionalProperties/type',
                                                                                                                            keyword: 'type',
                                                                                                                            params: { type: 'string' },
                                                                                                                            message: 'must be string'
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                                var valid1 = _errs44 === errors;
                                                                                                                if (!valid1) {
                                                                                                                    break;
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                        else {
                                                                                                            validate162.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/colorMap',
                                                                                                                    schemaPath: '#/properties/colorMap/type',
                                                                                                                    keyword: 'type',
                                                                                                                    params: { type: 'object' },
                                                                                                                    message: 'must be object'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                    var valid0 = _errs41 === errors;
                                                                                                }
                                                                                                else {
                                                                                                    var valid0 = true;
                                                                                                }
                                                                                                if (valid0) {
                                                                                                    if (data.sortColumns !== undefined) {
                                                                                                        let data22 = data.sortColumns;
                                                                                                        const _errs46 = errors;
                                                                                                        if (errors === _errs46) {
                                                                                                            if (Array.isArray(data22)) {
                                                                                                                if (data22.length < 1) {
                                                                                                                    validate162.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath + '/sortColumns',
                                                                                                                            schemaPath: '#/properties/sortColumns/minItems',
                                                                                                                            keyword: 'minItems',
                                                                                                                            params: { limit: 1 },
                                                                                                                            message: 'must NOT have fewer than 1 items'
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                                else {
                                                                                                                    var valid2 = true;
                                                                                                                    const len0 = data22.length;
                                                                                                                    for (let i0 = 0; i0 < len0; i0++) {
                                                                                                                        const _errs48 = errors;
                                                                                                                        if (!validate163(data22[i0], {
                                                                                                                            instancePath: instancePath + '/sortColumns/' + i0,
                                                                                                                            parentData: data22,
                                                                                                                            parentDataProperty: i0,
                                                                                                                            rootData
                                                                                                                        })) {
                                                                                                                            vErrors =
                                                                                                                                vErrors === null
                                                                                                                                    ? validate163.errors
                                                                                                                                    : vErrors.concat(validate163.errors);
                                                                                                                            errors = vErrors.length;
                                                                                                                        }
                                                                                                                        var valid2 = _errs48 === errors;
                                                                                                                        if (!valid2) {
                                                                                                                            break;
                                                                                                                        }
                                                                                                                    }
                                                                                                                    if (valid2) {
                                                                                                                        const keys0 = schema177.properties.sortColumns.uniqueItemProperties;
                                                                                                                        let k0;
                                                                                                                        let i1 = data22.length;
                                                                                                                        let j0;
                                                                                                                        if (i1 > 1) {
                                                                                                                            outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                                                                                                                let key1 = keys0[k0];
                                                                                                                                for (i1 = data22.length; i1--;) {
                                                                                                                                    let x0 = data22[i1];
                                                                                                                                    if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                                                                                                        continue;
                                                                                                                                    }
                                                                                                                                    for (j0 = i1; j0--;) {
                                                                                                                                        let y0 = data22[j0];
                                                                                                                                        if (y0 &&
                                                                                                                                            typeof y0 == 'object' &&
                                                                                                                                            !Array.isArray(y0) &&
                                                                                                                                            func460(x0[key1], y0[key1])) {
                                                                                                                                            validate162.errors = [
                                                                                                                                                {
                                                                                                                                                    instancePath: instancePath + '/sortColumns',
                                                                                                                                                    schemaPath: '#/properties/sortColumns/uniqueItemProperties',
                                                                                                                                                    keyword: 'uniqueItemProperties',
                                                                                                                                                    params: {},
                                                                                                                                                    message: 'must pass "uniqueItemProperties" keyword validation'
                                                                                                                                                }
                                                                                                                                            ];
                                                                                                                                            return false;
                                                                                                                                            break outer0;
                                                                                                                                        }
                                                                                                                                    }
                                                                                                                                }
                                                                                                                            }
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                            else {
                                                                                                                validate162.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/sortColumns',
                                                                                                                        schemaPath: '#/properties/sortColumns/type',
                                                                                                                        keyword: 'type',
                                                                                                                        params: { type: 'array' },
                                                                                                                        message: 'must be array'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                        }
                                                                                                        var valid0 = _errs46 === errors;
                                                                                                    }
                                                                                                    else {
                                                                                                        var valid0 = true;
                                                                                                    }
                                                                                                    if (valid0) {
                                                                                                        if (data.spacing !== undefined) {
                                                                                                            let data24 = data.spacing;
                                                                                                            const _errs49 = errors;
                                                                                                            if (errors === _errs49) {
                                                                                                                if (data24 &&
                                                                                                                    typeof data24 == 'object' &&
                                                                                                                    !Array.isArray(data24)) {
                                                                                                                    if (data24.left !== undefined) {
                                                                                                                        let data25 = data24.left;
                                                                                                                        const _errs51 = errors;
                                                                                                                        if (!(typeof data25 == 'number') && data25 !== null) {
                                                                                                                            validate162.errors = [
                                                                                                                                {
                                                                                                                                    instancePath: instancePath + '/spacing/left',
                                                                                                                                    schemaPath: '#/properties/spacing/properties/left/type',
                                                                                                                                    keyword: 'type',
                                                                                                                                    params: {
                                                                                                                                        type: schema177.properties.spacing.properties.left
                                                                                                                                            .type
                                                                                                                                    },
                                                                                                                                    message: 'must be number,null'
                                                                                                                                }
                                                                                                                            ];
                                                                                                                            return false;
                                                                                                                        }
                                                                                                                        var valid4 = _errs51 === errors;
                                                                                                                    }
                                                                                                                    else {
                                                                                                                        var valid4 = true;
                                                                                                                    }
                                                                                                                    if (valid4) {
                                                                                                                        if (data24.right !== undefined) {
                                                                                                                            let data26 = data24.right;
                                                                                                                            const _errs53 = errors;
                                                                                                                            if (!(typeof data26 == 'number') && data26 !== null) {
                                                                                                                                validate162.errors = [
                                                                                                                                    {
                                                                                                                                        instancePath: instancePath + '/spacing/right',
                                                                                                                                        schemaPath: '#/properties/spacing/properties/right/type',
                                                                                                                                        keyword: 'type',
                                                                                                                                        params: {
                                                                                                                                            type: schema177.properties.spacing.properties
                                                                                                                                                .right.type
                                                                                                                                        },
                                                                                                                                        message: 'must be number,null'
                                                                                                                                    }
                                                                                                                                ];
                                                                                                                                return false;
                                                                                                                            }
                                                                                                                            var valid4 = _errs53 === errors;
                                                                                                                        }
                                                                                                                        else {
                                                                                                                            var valid4 = true;
                                                                                                                        }
                                                                                                                        if (valid4) {
                                                                                                                            if (data24.top !== undefined) {
                                                                                                                                let data27 = data24.top;
                                                                                                                                const _errs55 = errors;
                                                                                                                                if (!(typeof data27 == 'number') && data27 !== null) {
                                                                                                                                    validate162.errors = [
                                                                                                                                        {
                                                                                                                                            instancePath: instancePath + '/spacing/top',
                                                                                                                                            schemaPath: '#/properties/spacing/properties/top/type',
                                                                                                                                            keyword: 'type',
                                                                                                                                            params: {
                                                                                                                                                type: schema177.properties.spacing.properties
                                                                                                                                                    .top.type
                                                                                                                                            },
                                                                                                                                            message: 'must be number,null'
                                                                                                                                        }
                                                                                                                                    ];
                                                                                                                                    return false;
                                                                                                                                }
                                                                                                                                var valid4 = _errs55 === errors;
                                                                                                                            }
                                                                                                                            else {
                                                                                                                                var valid4 = true;
                                                                                                                            }
                                                                                                                            if (valid4) {
                                                                                                                                if (data24.bottom !== undefined) {
                                                                                                                                    let data28 = data24.bottom;
                                                                                                                                    const _errs57 = errors;
                                                                                                                                    if (!(typeof data28 == 'number') && data28 !== null) {
                                                                                                                                        validate162.errors = [
                                                                                                                                            {
                                                                                                                                                instancePath: instancePath + '/spacing/bottom',
                                                                                                                                                schemaPath: '#/properties/spacing/properties/bottom/type',
                                                                                                                                                keyword: 'type',
                                                                                                                                                params: {
                                                                                                                                                    type: schema177.properties.spacing.properties
                                                                                                                                                        .bottom.type
                                                                                                                                                },
                                                                                                                                                message: 'must be number,null'
                                                                                                                                            }
                                                                                                                                        ];
                                                                                                                                        return false;
                                                                                                                                    }
                                                                                                                                    var valid4 = _errs57 === errors;
                                                                                                                                }
                                                                                                                                else {
                                                                                                                                    var valid4 = true;
                                                                                                                                }
                                                                                                                            }
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                                else {
                                                                                                                    validate162.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath + '/spacing',
                                                                                                                            schemaPath: '#/properties/spacing/type',
                                                                                                                            keyword: 'type',
                                                                                                                            params: { type: 'object' },
                                                                                                                            message: 'must be object'
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                            }
                                                                                                            var valid0 = _errs49 === errors;
                                                                                                        }
                                                                                                        else {
                                                                                                            var valid0 = true;
                                                                                                        }
                                                                                                        if (valid0) {
                                                                                                            if (data.overflow !== undefined) {
                                                                                                                let data29 = data.overflow;
                                                                                                                const _errs59 = errors;
                                                                                                                if (typeof data29 !== 'string') {
                                                                                                                    validate162.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath + '/overflow',
                                                                                                                            schemaPath: '#/properties/overflow/type',
                                                                                                                            keyword: 'type',
                                                                                                                            params: { type: 'string' },
                                                                                                                            message: 'must be string'
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                                if (!(data29 === 'truncate' ||
                                                                                                                    data29 === 'break' ||
                                                                                                                    data29 === 'breakAll')) {
                                                                                                                    validate162.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath + '/overflow',
                                                                                                                            schemaPath: '#/properties/overflow/enum',
                                                                                                                            keyword: 'enum',
                                                                                                                            params: {
                                                                                                                                allowedValues: schema177.properties.overflow.enum
                                                                                                                            },
                                                                                                                            message: 'must be equal to one of the allowed values'
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                                var valid0 = _errs59 === errors;
                                                                                                            }
                                                                                                            else {
                                                                                                                var valid0 = true;
                                                                                                            }
                                                                                                            if (valid0) {
                                                                                                                if (data.filters !== undefined) {
                                                                                                                    let data30 = data.filters;
                                                                                                                    const _errs61 = errors;
                                                                                                                    if (errors === _errs61) {
                                                                                                                        if (Array.isArray(data30)) {
                                                                                                                            if (data30.length > 20) {
                                                                                                                                validate162.errors = [
                                                                                                                                    {
                                                                                                                                        instancePath: instancePath + '/filters',
                                                                                                                                        schemaPath: '#/properties/filters/maxItems',
                                                                                                                                        keyword: 'maxItems',
                                                                                                                                        params: { limit: 20 },
                                                                                                                                        message: 'must NOT have more than 20 items'
                                                                                                                                    }
                                                                                                                                ];
                                                                                                                                return false;
                                                                                                                            }
                                                                                                                            else {
                                                                                                                                var valid5 = true;
                                                                                                                                const len1 = data30.length;
                                                                                                                                for (let i2 = 0; i2 < len1; i2++) {
                                                                                                                                    let data31 = data30[i2];
                                                                                                                                    const _errs63 = errors;
                                                                                                                                    const _errs64 = errors;
                                                                                                                                    if (errors === _errs64) {
                                                                                                                                        if (data31 &&
                                                                                                                                            typeof data31 == 'object' &&
                                                                                                                                            !Array.isArray(data31)) {
                                                                                                                                            let missing1;
                                                                                                                                            if (data31.filterType === undefined &&
                                                                                                                                                (missing1 = 'filterType')) {
                                                                                                                                                validate162.errors = [
                                                                                                                                                    {
                                                                                                                                                        instancePath: instancePath + '/filters/' + i2,
                                                                                                                                                        schemaPath: 'urn:wisepipe-common-computation:Filter/required',
                                                                                                                                                        keyword: 'required',
                                                                                                                                                        params: { missingProperty: missing1 },
                                                                                                                                                        message: "must have required property '" +
                                                                                                                                                            missing1 +
                                                                                                                                                            "'"
                                                                                                                                                    }
                                                                                                                                                ];
                                                                                                                                                return false;
                                                                                                                                            }
                                                                                                                                            else {
                                                                                                                                                if (data31.column !== undefined) {
                                                                                                                                                    let data32 = data31.column;
                                                                                                                                                    const _errs66 = errors;
                                                                                                                                                    if (errors === _errs66) {
                                                                                                                                                        if (typeof data32 === 'string') {
                                                                                                                                                            if (func2(data32) > 150) {
                                                                                                                                                                validate162.errors = [
                                                                                                                                                                    {
                                                                                                                                                                        instancePath: instancePath +
                                                                                                                                                                            '/filters/' +
                                                                                                                                                                            i2 +
                                                                                                                                                                            '/column',
                                                                                                                                                                        schemaPath: 'urn:wisepipe-common-computation:Filter/properties/column/maxLength',
                                                                                                                                                                        keyword: 'maxLength',
                                                                                                                                                                        params: { limit: 150 },
                                                                                                                                                                        message: 'must NOT have more than 150 characters'
                                                                                                                                                                    }
                                                                                                                                                                ];
                                                                                                                                                                return false;
                                                                                                                                                            }
                                                                                                                                                        }
                                                                                                                                                        else {
                                                                                                                                                            validate162.errors = [
                                                                                                                                                                {
                                                                                                                                                                    instancePath: instancePath +
                                                                                                                                                                        '/filters/' +
                                                                                                                                                                        i2 +
                                                                                                                                                                        '/column',
                                                                                                                                                                    schemaPath: 'urn:wisepipe-common-computation:Filter/properties/column/type',
                                                                                                                                                                    keyword: 'type',
                                                                                                                                                                    params: { type: 'string' },
                                                                                                                                                                    message: 'must be string'
                                                                                                                                                                }
                                                                                                                                                            ];
                                                                                                                                                            return false;
                                                                                                                                                        }
                                                                                                                                                    }
                                                                                                                                                    var valid7 = _errs66 === errors;
                                                                                                                                                }
                                                                                                                                                else {
                                                                                                                                                    var valid7 = true;
                                                                                                                                                }
                                                                                                                                                if (valid7) {
                                                                                                                                                    if (data31.filterType !== undefined) {
                                                                                                                                                        let data33 = data31.filterType;
                                                                                                                                                        const _errs68 = errors;
                                                                                                                                                        if (typeof data33 !== 'string') {
                                                                                                                                                            validate162.errors = [
                                                                                                                                                                {
                                                                                                                                                                    instancePath: instancePath +
                                                                                                                                                                        '/filters/' +
                                                                                                                                                                        i2 +
                                                                                                                                                                        '/filterType',
                                                                                                                                                                    schemaPath: 'urn:wisepipe-common-computation:Filter/properties/filterType/type',
                                                                                                                                                                    keyword: 'type',
                                                                                                                                                                    params: { type: 'string' },
                                                                                                                                                                    message: 'must be string'
                                                                                                                                                                }
                                                                                                                                                            ];
                                                                                                                                                            return false;
                                                                                                                                                        }
                                                                                                                                                        if (!(data33 === 'boolean' ||
                                                                                                                                                            data33 === 'date' ||
                                                                                                                                                            data33 === 'string' ||
                                                                                                                                                            data33 === 'number' ||
                                                                                                                                                            data33 === 'group' ||
                                                                                                                                                            data33 === 'decimal')) {
                                                                                                                                                            validate162.errors = [
                                                                                                                                                                {
                                                                                                                                                                    instancePath: instancePath +
                                                                                                                                                                        '/filters/' +
                                                                                                                                                                        i2 +
                                                                                                                                                                        '/filterType',
                                                                                                                                                                    schemaPath: 'urn:wisepipe-common-computation:Filter/properties/filterType/enum',
                                                                                                                                                                    keyword: 'enum',
                                                                                                                                                                    params: {
                                                                                                                                                                        allowedValues: schema81.properties.filterType
                                                                                                                                                                            .enum
                                                                                                                                                                    },
                                                                                                                                                                    message: 'must be equal to one of the allowed values'
                                                                                                                                                                }
                                                                                                                                                            ];
                                                                                                                                                            return false;
                                                                                                                                                        }
                                                                                                                                                        var valid7 = _errs68 === errors;
                                                                                                                                                    }
                                                                                                                                                    else {
                                                                                                                                                        var valid7 = true;
                                                                                                                                                    }
                                                                                                                                                }
                                                                                                                                            }
                                                                                                                                        }
                                                                                                                                        else {
                                                                                                                                            validate162.errors = [
                                                                                                                                                {
                                                                                                                                                    instancePath: instancePath + '/filters/' + i2,
                                                                                                                                                    schemaPath: 'urn:wisepipe-common-computation:Filter/type',
                                                                                                                                                    keyword: 'type',
                                                                                                                                                    params: { type: 'object' },
                                                                                                                                                    message: 'must be object'
                                                                                                                                                }
                                                                                                                                            ];
                                                                                                                                            return false;
                                                                                                                                        }
                                                                                                                                    }
                                                                                                                                    var valid5 = _errs63 === errors;
                                                                                                                                    if (!valid5) {
                                                                                                                                        break;
                                                                                                                                    }
                                                                                                                                }
                                                                                                                            }
                                                                                                                        }
                                                                                                                        else {
                                                                                                                            validate162.errors = [
                                                                                                                                {
                                                                                                                                    instancePath: instancePath + '/filters',
                                                                                                                                    schemaPath: '#/properties/filters/type',
                                                                                                                                    keyword: 'type',
                                                                                                                                    params: { type: 'array' },
                                                                                                                                    message: 'must be array'
                                                                                                                                }
                                                                                                                            ];
                                                                                                                            return false;
                                                                                                                        }
                                                                                                                    }
                                                                                                                    var valid0 = _errs61 === errors;
                                                                                                                }
                                                                                                                else {
                                                                                                                    var valid0 = true;
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate162.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate162.errors = vErrors;
    return errors === 0;
}
function validate161(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:SampleVisualRequest" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    const _errs3 = errors;
    let valid1 = false;
    const _errs4 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if (data.isNodeRLInput === undefined && (missing0 = 'isNodeRLInput')) {
            const err0 = {};
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
    }
    var _valid1 = _errs4 === errors;
    valid1 = valid1 || _valid1;
    if (!valid1) {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if (data.draftReusableLogicIDs === undefined && (missing1 = 'draftReusableLogicIDs')) {
                const err1 = {};
                if (vErrors === null) {
                    vErrors = [err1];
                }
                else {
                    vErrors.push(err1);
                }
                errors++;
            }
        }
        var _valid1 = _errs5 === errors;
        valid1 = valid1 || _valid1;
    }
    if (!valid1) {
        const err2 = {};
        if (vErrors === null) {
            vErrors = [err2];
        }
        else {
            vErrors.push(err2);
        }
        errors++;
    }
    else {
        errors = _errs3;
        if (vErrors !== null) {
            if (_errs3) {
                vErrors.length = _errs3;
            }
            else {
                vErrors = null;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs6 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if (data.reusableLogicParentNodeIDPath === undefined && (missing2 = 'reusableLogicParentNodeIDPath')) {
                validate161.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing2 },
                        message: "must have required property '" + missing2 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs6 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err3 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err3];
        }
        else {
            vErrors.push(err3);
        }
        errors++;
        validate161.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing3;
            if ((data.pipeID === undefined && (missing3 = 'pipeID')) ||
                (data.elementID === undefined && (missing3 = 'elementID')) ||
                (data.port === undefined && (missing3 = 'port')) ||
                (data.params === undefined && (missing3 = 'params'))) {
                validate161.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing3 },
                        message: "must have required property '" + missing3 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pipeID !== undefined) {
                    let data0 = data.pipeID;
                    const _errs7 = errors;
                    if (errors === _errs7) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func451(data0) < b64min0 || func451(data0) > b64max0) {
                                validate161.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func451(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func451(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func452(data0);
                                if (decoded0.length !== 10) {
                                    validate161.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func453(decoded0);
                                    if (func454(encoded0) !== func454(data0)) {
                                        validate161.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate161.errors = [
                                {
                                    instancePath: instancePath + '/pipeID',
                                    schemaPath: '#/properties/pipeID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid2 = _errs7 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.elementID !== undefined) {
                        let data1 = data.elementID;
                        const _errs9 = errors;
                        if (errors === _errs9) {
                            if (typeof data1 === 'string') {
                                const b64min1 = Math.ceil((4 * 10) / 3);
                                const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                if (func455(data1) < b64min1 || func455(data1) > b64max1) {
                                    validate161.errors = [
                                        {
                                            instancePath: instancePath + '/elementID',
                                            schemaPath: '#/properties/elementID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func455(data1) },
                                            message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func455(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded1 = func456(data1);
                                    if (decoded1.length !== 10) {
                                        validate161.errors = [
                                            {
                                                instancePath: instancePath + '/elementID',
                                                schemaPath: '#/properties/elementID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 10 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded1 = func457(decoded1);
                                        if (func458(encoded1) !== func458(data1)) {
                                            validate161.errors = [
                                                {
                                                    instancePath: instancePath + '/elementID',
                                                    schemaPath: '#/properties/elementID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate161.errors = [
                                    {
                                        instancePath: instancePath + '/elementID',
                                        schemaPath: '#/properties/elementID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid2 = _errs9 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.port !== undefined) {
                            let data2 = data.port;
                            const _errs11 = errors;
                            if (errors === _errs11) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate161.errors = [
                                            {
                                                instancePath: instancePath + '/port',
                                                schemaPath: '#/properties/port/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate161.errors = [
                                        {
                                            instancePath: instancePath + '/port',
                                            schemaPath: '#/properties/port/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid2 = _errs11 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                        if (valid2) {
                            if (data.params !== undefined) {
                                const _errs13 = errors;
                                if (!validate162(data.params, {
                                    instancePath: instancePath + '/params',
                                    parentData: data,
                                    parentDataProperty: 'params',
                                    rootData
                                })) {
                                    vErrors = vErrors === null ? validate162.errors : vErrors.concat(validate162.errors);
                                    errors = vErrors.length;
                                }
                                var valid2 = _errs13 === errors;
                            }
                            else {
                                var valid2 = true;
                            }
                            if (valid2) {
                                if (data.reusableLogicParentNodeIDPath !== undefined) {
                                    let data4 = data.reusableLogicParentNodeIDPath;
                                    const _errs14 = errors;
                                    if (errors === _errs14) {
                                        if (typeof data4 === 'string') {
                                            if (func2(data4) < 1) {
                                                validate161.errors = [
                                                    {
                                                        instancePath: instancePath + '/reusableLogicParentNodeIDPath',
                                                        schemaPath: '#/properties/reusableLogicParentNodeIDPath/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate161.errors = [
                                                {
                                                    instancePath: instancePath + '/reusableLogicParentNodeIDPath',
                                                    schemaPath: '#/properties/reusableLogicParentNodeIDPath/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs14 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data.isNodeRLInput !== undefined) {
                                        const _errs16 = errors;
                                        if (typeof data.isNodeRLInput !== 'boolean') {
                                            validate161.errors = [
                                                {
                                                    instancePath: instancePath + '/isNodeRLInput',
                                                    schemaPath: '#/properties/isNodeRLInput/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid2 = _errs16 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data.draftReusableLogicIDs !== undefined) {
                                            let data6 = data.draftReusableLogicIDs;
                                            const _errs18 = errors;
                                            if (errors === _errs18) {
                                                if (Array.isArray(data6)) {
                                                    var valid5 = true;
                                                    const len0 = data6.length;
                                                    for (let i0 = 0; i0 < len0; i0++) {
                                                        const _errs20 = errors;
                                                        if (typeof data6[i0] !== 'string') {
                                                            validate161.errors = [
                                                                {
                                                                    instancePath: instancePath + '/draftReusableLogicIDs/' + i0,
                                                                    schemaPath: '#/properties/draftReusableLogicIDs/items/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid5 = _errs20 === errors;
                                                        if (!valid5) {
                                                            break;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate161.errors = [
                                                        {
                                                            instancePath: instancePath + '/draftReusableLogicIDs',
                                                            schemaPath: '#/properties/draftReusableLogicIDs/type',
                                                            keyword: 'type',
                                                            params: { type: 'array' },
                                                            message: 'must be array'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid2 = _errs18 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate161.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate161.errors = vErrors;
    return errors === 0;
}
export const sankeyVisualParamsSchemaValidation = validate166;
const schema182 = {
    $id: 'urn:wisepipe-common-computation:SankeyVisualParams',
    type: 'object',
    properties: {
        from: { type: 'string', minLength: 1 },
        to: { type: 'string', minLength: 1 },
        value: { type: 'string', minLength: 1 }
    },
    required: ['from', 'to', 'value']
};
function validate166(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:SankeyVisualParams" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.from === undefined && (missing0 = 'from')) ||
                (data.to === undefined && (missing0 = 'to')) ||
                (data.value === undefined && (missing0 = 'value'))) {
                validate166.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.from !== undefined) {
                    let data0 = data.from;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate166.errors = [
                                    {
                                        instancePath: instancePath + '/from',
                                        schemaPath: '#/properties/from/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate166.errors = [
                                {
                                    instancePath: instancePath + '/from',
                                    schemaPath: '#/properties/from/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.to !== undefined) {
                        let data1 = data.to;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate166.errors = [
                                        {
                                            instancePath: instancePath + '/to',
                                            schemaPath: '#/properties/to/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate166.errors = [
                                    {
                                        instancePath: instancePath + '/to',
                                        schemaPath: '#/properties/to/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.value !== undefined) {
                            let data2 = data.value;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate166.errors = [
                                            {
                                                instancePath: instancePath + '/value',
                                                schemaPath: '#/properties/value/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate166.errors = [
                                        {
                                            instancePath: instancePath + '/value',
                                            schemaPath: '#/properties/value/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate166.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate166.errors = vErrors;
    return errors === 0;
}
export const scatterMapVisualParamsSchemaValidation = validate167;
const schema183 = {
    $id: 'urn:wisepipe-common-computation:ScatterMapVisualParams',
    type: 'object',
    properties: {
        mapType: { type: 'string', enum: ['world', 'usa', 'canada'] },
        longitude: { type: 'string', minLength: 1 },
        latitude: { type: 'string', minLength: 1 },
        size: { type: 'string', minLength: 1 },
        gradient: { type: 'boolean' },
        shadow: { type: 'boolean' }
    },
    required: ['mapType', 'longitude', 'latitude', 'size']
};
function validate167(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:ScatterMapVisualParams" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.mapType === undefined && (missing0 = 'mapType')) ||
                (data.longitude === undefined && (missing0 = 'longitude')) ||
                (data.latitude === undefined && (missing0 = 'latitude')) ||
                (data.size === undefined && (missing0 = 'size'))) {
                validate167.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.mapType !== undefined) {
                    let data0 = data.mapType;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate167.errors = [
                            {
                                instancePath: instancePath + '/mapType',
                                schemaPath: '#/properties/mapType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'world' || data0 === 'usa' || data0 === 'canada')) {
                        validate167.errors = [
                            {
                                instancePath: instancePath + '/mapType',
                                schemaPath: '#/properties/mapType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema183.properties.mapType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.longitude !== undefined) {
                        let data1 = data.longitude;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate167.errors = [
                                        {
                                            instancePath: instancePath + '/longitude',
                                            schemaPath: '#/properties/longitude/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate167.errors = [
                                    {
                                        instancePath: instancePath + '/longitude',
                                        schemaPath: '#/properties/longitude/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.latitude !== undefined) {
                            let data2 = data.latitude;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate167.errors = [
                                            {
                                                instancePath: instancePath + '/latitude',
                                                schemaPath: '#/properties/latitude/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate167.errors = [
                                        {
                                            instancePath: instancePath + '/latitude',
                                            schemaPath: '#/properties/latitude/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.size !== undefined) {
                                let data3 = data.size;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) < 1) {
                                            validate167.errors = [
                                                {
                                                    instancePath: instancePath + '/size',
                                                    schemaPath: '#/properties/size/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate167.errors = [
                                            {
                                                instancePath: instancePath + '/size',
                                                schemaPath: '#/properties/size/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.gradient !== undefined) {
                                    const _errs9 = errors;
                                    if (typeof data.gradient !== 'boolean') {
                                        validate167.errors = [
                                            {
                                                instancePath: instancePath + '/gradient',
                                                schemaPath: '#/properties/gradient/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.shadow !== undefined) {
                                        const _errs11 = errors;
                                        if (typeof data.shadow !== 'boolean') {
                                            validate167.errors = [
                                                {
                                                    instancePath: instancePath + '/shadow',
                                                    schemaPath: '#/properties/shadow/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate167.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate167.errors = vErrors;
    return errors === 0;
}
export const schemaInfoSchemaValidation = validate168;
const schema184 = {
    $id: 'urn:wisepipe-common-computation:SchemaInfo',
    type: 'object',
    properties: {
        insSchemas: { type: 'array', items: { $ref: 'urn:wisepipe-common-computation:InsSchemaInfo' } },
        outsSchemas: { type: 'array', items: { $ref: 'urn:wisepipe-common-computation:OutsSchemaInfo' } },
        isCurrentSchema: { type: 'boolean' }
    },
    required: ['insSchemas', 'outsSchemas']
};
function validate168(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:SchemaInfo" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.insSchemas === undefined && (missing0 = 'insSchemas')) ||
                (data.outsSchemas === undefined && (missing0 = 'outsSchemas'))) {
                validate168.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.insSchemas !== undefined) {
                    let data0 = data.insSchemas;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                const _errs3 = errors;
                                if (!validate99(data0[i0], {
                                    instancePath: instancePath + '/insSchemas/' + i0,
                                    parentData: data0,
                                    parentDataProperty: i0,
                                    rootData
                                })) {
                                    vErrors = vErrors === null ? validate99.errors : vErrors.concat(validate99.errors);
                                    errors = vErrors.length;
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                        }
                        else {
                            validate168.errors = [
                                {
                                    instancePath: instancePath + '/insSchemas',
                                    schemaPath: '#/properties/insSchemas/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.outsSchemas !== undefined) {
                        let data2 = data.outsSchemas;
                        const _errs4 = errors;
                        if (errors === _errs4) {
                            if (Array.isArray(data2)) {
                                var valid2 = true;
                                const len1 = data2.length;
                                for (let i1 = 0; i1 < len1; i1++) {
                                    const _errs6 = errors;
                                    if (!validate131(data2[i1], {
                                        instancePath: instancePath + '/outsSchemas/' + i1,
                                        parentData: data2,
                                        parentDataProperty: i1,
                                        rootData
                                    })) {
                                        vErrors = vErrors === null ? validate131.errors : vErrors.concat(validate131.errors);
                                        errors = vErrors.length;
                                    }
                                    var valid2 = _errs6 === errors;
                                    if (!valid2) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate168.errors = [
                                    {
                                        instancePath: instancePath + '/outsSchemas',
                                        schemaPath: '#/properties/outsSchemas/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs4 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.isCurrentSchema !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.isCurrentSchema !== 'boolean') {
                                validate168.errors = [
                                    {
                                        instancePath: instancePath + '/isCurrentSchema',
                                        schemaPath: '#/properties/isCurrentSchema/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate168.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate168.errors = vErrors;
    return errors === 0;
}
export const schemaRequestSchemaValidation = validate171;
const schema185 = {
    $id: 'urn:wisepipe-common-computation:SchemaRequest',
    type: 'object',
    properties: {
        pipeID: { type: 'string', uid: 10 },
        nodeColumnMap: {
            type: 'object',
            additionalProperties: { type: 'array', items: { $ref: 'urn:wisepipe-common-data:Column' }, uniqueItems: true }
        },
        name: { type: 'string', minLength: 1 }
    },
    required: ['pipeID', 'nodeColumnMap']
};
const func469 = ucs2length;
const func470 = base64urlToBuffer;
const func471 = base64urlEncode;
const func472 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate171(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:SchemaRequest" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.pipeID === undefined && (missing0 = 'pipeID')) ||
                (data.nodeColumnMap === undefined && (missing0 = 'nodeColumnMap'))) {
                validate171.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pipeID !== undefined) {
                    let data0 = data.pipeID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func469(data0) < b64min0 || func469(data0) > b64max0) {
                                validate171.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func469(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func469(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func470(data0);
                                if (decoded0.length !== 10) {
                                    validate171.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func471(decoded0);
                                    if (func472(encoded0) !== func472(data0)) {
                                        validate171.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate171.errors = [
                                {
                                    instancePath: instancePath + '/pipeID',
                                    schemaPath: '#/properties/pipeID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.nodeColumnMap !== undefined) {
                        let data1 = data.nodeColumnMap;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                for (const key0 in data1) {
                                    let data2 = data1[key0];
                                    const _errs6 = errors;
                                    if (errors === _errs6) {
                                        if (Array.isArray(data2)) {
                                            var valid3 = true;
                                            const len0 = data2.length;
                                            for (let i0 = 0; i0 < len0; i0++) {
                                                const _errs8 = errors;
                                                if (!validate45(data2[i0], {
                                                    instancePath: instancePath +
                                                        '/nodeColumnMap/' +
                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                        '/' +
                                                        i0,
                                                    parentData: data2,
                                                    parentDataProperty: i0,
                                                    rootData
                                                })) {
                                                    vErrors = vErrors === null ? validate45.errors : vErrors.concat(validate45.errors);
                                                    errors = vErrors.length;
                                                }
                                                var valid3 = _errs8 === errors;
                                                if (!valid3) {
                                                    break;
                                                }
                                            }
                                            if (valid3) {
                                                let i1 = data2.length;
                                                let j0;
                                                if (i1 > 1) {
                                                    outer0: for (; i1--;) {
                                                        for (j0 = i1; j0--;) {
                                                            if (func0(data2[i1], data2[j0])) {
                                                                validate171.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/nodeColumnMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                        schemaPath: '#/properties/nodeColumnMap/additionalProperties/uniqueItems',
                                                                        keyword: 'uniqueItems',
                                                                        params: { i: i1, j: j0 },
                                                                        message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                                    }
                                                                ];
                                                                return false;
                                                                break outer0;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate171.errors = [
                                                {
                                                    instancePath: instancePath + '/nodeColumnMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                    schemaPath: '#/properties/nodeColumnMap/additionalProperties/type',
                                                    keyword: 'type',
                                                    params: { type: 'array' },
                                                    message: 'must be array'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs6 === errors;
                                    if (!valid2) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate171.errors = [
                                    {
                                        instancePath: instancePath + '/nodeColumnMap',
                                        schemaPath: '#/properties/nodeColumnMap/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.name !== undefined) {
                            let data4 = data.name;
                            const _errs9 = errors;
                            if (errors === _errs9) {
                                if (typeof data4 === 'string') {
                                    if (func2(data4) < 1) {
                                        validate171.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate171.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs9 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate171.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate171.errors = vErrors;
    return errors === 0;
}
export const singleColumnInfoSchemaValidation = validate173;
function validate173(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:SingleColumnInfo" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.columnName === undefined && (missing0 = 'columnName')) ||
                (data.columnType === undefined && (missing0 = 'columnType'))) {
                validate173.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columnName !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.columnName !== 'string') {
                        validate173.errors = [
                            {
                                instancePath: instancePath + '/columnName',
                                schemaPath: '#/properties/columnName/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.columnType !== undefined) {
                        let data1 = data.columnType;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (!pattern5.test(data1)) {
                                    validate173.errors = [
                                        {
                                            instancePath: instancePath + '/columnType',
                                            schemaPath: '#/properties/columnType/pattern',
                                            keyword: 'pattern',
                                            params: { pattern: 'number|date|string|boolean|decimal' },
                                            message: 'must match pattern "' + 'number|date|string|boolean|decimal' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate173.errors = [
                                    {
                                        instancePath: instancePath + '/columnType',
                                        schemaPath: '#/properties/columnType/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate173.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate173.errors = vErrors;
    return errors === 0;
}
export const sortColumnSchemaValidation = validate163;
export const stringFilterSchemaValidation = validate174;
const schema187 = {
    $id: 'urn:wisepipe-common-computation:StringFilter',
    type: 'object',
    properties: { values: { type: 'array', items: { type: ['string', 'null'], maxLength: 1000 } } },
    if: { anyOf: [{ required: ['op'] }, { required: ['match'] }] },
    then: {
        properties: {
            op: { type: 'string', enum: ['contains', 'equal', 'starts_with', 'ends_with'] },
            match: { type: 'string', maxLength: 1000 }
        },
        required: ['op', 'match']
    }
};
function validate174(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:StringFilter" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    const _errs3 = errors;
    let valid1 = false;
    const _errs4 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if (data.op === undefined && (missing0 = 'op')) {
            const err0 = {};
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
    }
    var _valid1 = _errs4 === errors;
    valid1 = valid1 || _valid1;
    if (!valid1) {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if (data.match === undefined && (missing1 = 'match')) {
                const err1 = {};
                if (vErrors === null) {
                    vErrors = [err1];
                }
                else {
                    vErrors.push(err1);
                }
                errors++;
            }
        }
        var _valid1 = _errs5 === errors;
        valid1 = valid1 || _valid1;
    }
    if (!valid1) {
        const err2 = {};
        if (vErrors === null) {
            vErrors = [err2];
        }
        else {
            vErrors.push(err2);
        }
        errors++;
    }
    else {
        errors = _errs3;
        if (vErrors !== null) {
            if (_errs3) {
                vErrors.length = _errs3;
            }
            else {
                vErrors = null;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs6 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if ((data.op === undefined && (missing2 = 'op')) || (data.match === undefined && (missing2 = 'match'))) {
                validate174.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing2 },
                        message: "must have required property '" + missing2 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.op !== undefined) {
                    let data0 = data.op;
                    const _errs7 = errors;
                    if (typeof data0 !== 'string') {
                        validate174.errors = [
                            {
                                instancePath: instancePath + '/op',
                                schemaPath: '#/then/properties/op/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'contains' || data0 === 'equal' || data0 === 'starts_with' || data0 === 'ends_with')) {
                        validate174.errors = [
                            {
                                instancePath: instancePath + '/op',
                                schemaPath: '#/then/properties/op/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema187.then.properties.op.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid2 = _errs7 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.match !== undefined) {
                        let data1 = data.match;
                        const _errs9 = errors;
                        if (errors === _errs9) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 1000) {
                                    validate174.errors = [
                                        {
                                            instancePath: instancePath + '/match',
                                            schemaPath: '#/then/properties/match/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 1000 },
                                            message: 'must NOT have more than 1000 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate174.errors = [
                                    {
                                        instancePath: instancePath + '/match',
                                        schemaPath: '#/then/properties/match/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid2 = _errs9 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                }
            }
        }
        var _valid0 = _errs6 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err3 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err3];
        }
        else {
            vErrors.push(err3);
        }
        errors++;
        validate174.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.values !== undefined) {
                let data2 = data.values;
                const _errs11 = errors;
                if (errors === _errs11) {
                    if (Array.isArray(data2)) {
                        var valid4 = true;
                        const len0 = data2.length;
                        for (let i0 = 0; i0 < len0; i0++) {
                            let data3 = data2[i0];
                            const _errs13 = errors;
                            if (typeof data3 !== 'string' && data3 !== null) {
                                validate174.errors = [
                                    {
                                        instancePath: instancePath + '/values/' + i0,
                                        schemaPath: '#/properties/values/items/type',
                                        keyword: 'type',
                                        params: { type: schema187.properties.values.items.type },
                                        message: 'must be string,null'
                                    }
                                ];
                                return false;
                            }
                            if (errors === _errs13) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) > 1000) {
                                        validate174.errors = [
                                            {
                                                instancePath: instancePath + '/values/' + i0,
                                                schemaPath: '#/properties/values/items/maxLength',
                                                keyword: 'maxLength',
                                                params: { limit: 1000 },
                                                message: 'must NOT have more than 1000 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid4 = _errs13 === errors;
                            if (!valid4) {
                                break;
                            }
                        }
                    }
                    else {
                        validate174.errors = [
                            {
                                instancePath: instancePath + '/values',
                                schemaPath: '#/properties/values/type',
                                keyword: 'type',
                                params: { type: 'array' },
                                message: 'must be array'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate174.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate174.errors = vErrors;
    return errors === 0;
}
export const stringToolVariableSchemaValidation = validate175;
function validate175(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:StringToolVariable" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate175.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate175.errors = vErrors;
    return errors === 0;
}
export const summarySchemaValidation = validate176;
function validate176(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:Summary" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.rows === undefined && (missing0 = 'rows')) ||
                (data.columns === undefined && (missing0 = 'columns')) ||
                (data.textColumns === undefined && (missing0 = 'textColumns')) ||
                (data.numericColumns === undefined && (missing0 = 'numericColumns')) ||
                (data.dateColumns === undefined && (missing0 = 'dateColumns')) ||
                (data.booleanColumns === undefined && (missing0 = 'booleanColumns')) ||
                (data.missingValuesColumns === undefined && (missing0 = 'missingValuesColumns')) ||
                (data.constantValuesColumns === undefined && (missing0 = 'constantValuesColumns')) ||
                (data.uniqueValuesColumns === undefined && (missing0 = 'uniqueValuesColumns'))) {
                validate176.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.rows !== undefined) {
                    const _errs1 = errors;
                    if (!(typeof data.rows == 'number')) {
                        validate176.errors = [
                            {
                                instancePath: instancePath + '/rows',
                                schemaPath: '#/properties/rows/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.columns !== undefined) {
                        const _errs3 = errors;
                        if (!(typeof data.columns == 'number')) {
                            validate176.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.textColumns !== undefined) {
                            let data2 = data.textColumns;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (Array.isArray(data2)) {
                                    var valid1 = true;
                                    const len0 = data2.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        const _errs7 = errors;
                                        if (typeof data2[i0] !== 'string') {
                                            validate176.errors = [
                                                {
                                                    instancePath: instancePath + '/textColumns/' + i0,
                                                    schemaPath: '#/properties/textColumns/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid1 = _errs7 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate176.errors = [
                                        {
                                            instancePath: instancePath + '/textColumns',
                                            schemaPath: '#/properties/textColumns/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.numericColumns !== undefined) {
                                let data4 = data.numericColumns;
                                const _errs9 = errors;
                                if (errors === _errs9) {
                                    if (Array.isArray(data4)) {
                                        var valid2 = true;
                                        const len1 = data4.length;
                                        for (let i1 = 0; i1 < len1; i1++) {
                                            const _errs11 = errors;
                                            if (typeof data4[i1] !== 'string') {
                                                validate176.errors = [
                                                    {
                                                        instancePath: instancePath + '/numericColumns/' + i1,
                                                        schemaPath: '#/properties/numericColumns/items/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid2 = _errs11 === errors;
                                            if (!valid2) {
                                                break;
                                            }
                                        }
                                    }
                                    else {
                                        validate176.errors = [
                                            {
                                                instancePath: instancePath + '/numericColumns',
                                                schemaPath: '#/properties/numericColumns/type',
                                                keyword: 'type',
                                                params: { type: 'array' },
                                                message: 'must be array'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.dateColumns !== undefined) {
                                    let data6 = data.dateColumns;
                                    const _errs13 = errors;
                                    if (errors === _errs13) {
                                        if (Array.isArray(data6)) {
                                            var valid3 = true;
                                            const len2 = data6.length;
                                            for (let i2 = 0; i2 < len2; i2++) {
                                                const _errs15 = errors;
                                                if (typeof data6[i2] !== 'string') {
                                                    validate176.errors = [
                                                        {
                                                            instancePath: instancePath + '/dateColumns/' + i2,
                                                            schemaPath: '#/properties/dateColumns/items/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid3 = _errs15 === errors;
                                                if (!valid3) {
                                                    break;
                                                }
                                            }
                                        }
                                        else {
                                            validate176.errors = [
                                                {
                                                    instancePath: instancePath + '/dateColumns',
                                                    schemaPath: '#/properties/dateColumns/type',
                                                    keyword: 'type',
                                                    params: { type: 'array' },
                                                    message: 'must be array'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs13 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.booleanColumns !== undefined) {
                                        let data8 = data.booleanColumns;
                                        const _errs17 = errors;
                                        if (errors === _errs17) {
                                            if (Array.isArray(data8)) {
                                                var valid4 = true;
                                                const len3 = data8.length;
                                                for (let i3 = 0; i3 < len3; i3++) {
                                                    const _errs19 = errors;
                                                    if (typeof data8[i3] !== 'string') {
                                                        validate176.errors = [
                                                            {
                                                                instancePath: instancePath + '/booleanColumns/' + i3,
                                                                schemaPath: '#/properties/booleanColumns/items/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid4 = _errs19 === errors;
                                                    if (!valid4) {
                                                        break;
                                                    }
                                                }
                                            }
                                            else {
                                                validate176.errors = [
                                                    {
                                                        instancePath: instancePath + '/booleanColumns',
                                                        schemaPath: '#/properties/booleanColumns/type',
                                                        keyword: 'type',
                                                        params: { type: 'array' },
                                                        message: 'must be array'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs17 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.missingValuesColumns !== undefined) {
                                            let data10 = data.missingValuesColumns;
                                            const _errs21 = errors;
                                            if (errors === _errs21) {
                                                if (Array.isArray(data10)) {
                                                    var valid5 = true;
                                                    const len4 = data10.length;
                                                    for (let i4 = 0; i4 < len4; i4++) {
                                                        const _errs23 = errors;
                                                        if (typeof data10[i4] !== 'string') {
                                                            validate176.errors = [
                                                                {
                                                                    instancePath: instancePath + '/missingValuesColumns/' + i4,
                                                                    schemaPath: '#/properties/missingValuesColumns/items/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid5 = _errs23 === errors;
                                                        if (!valid5) {
                                                            break;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate176.errors = [
                                                        {
                                                            instancePath: instancePath + '/missingValuesColumns',
                                                            schemaPath: '#/properties/missingValuesColumns/type',
                                                            keyword: 'type',
                                                            params: { type: 'array' },
                                                            message: 'must be array'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs21 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.constantValuesColumns !== undefined) {
                                                let data12 = data.constantValuesColumns;
                                                const _errs25 = errors;
                                                if (errors === _errs25) {
                                                    if (Array.isArray(data12)) {
                                                        var valid6 = true;
                                                        const len5 = data12.length;
                                                        for (let i5 = 0; i5 < len5; i5++) {
                                                            const _errs27 = errors;
                                                            if (typeof data12[i5] !== 'string') {
                                                                validate176.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/constantValuesColumns/' + i5,
                                                                        schemaPath: '#/properties/constantValuesColumns/items/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid6 = _errs27 === errors;
                                                            if (!valid6) {
                                                                break;
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate176.errors = [
                                                            {
                                                                instancePath: instancePath + '/constantValuesColumns',
                                                                schemaPath: '#/properties/constantValuesColumns/type',
                                                                keyword: 'type',
                                                                params: { type: 'array' },
                                                                message: 'must be array'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid0 = _errs25 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.uniqueValuesColumns !== undefined) {
                                                    let data14 = data.uniqueValuesColumns;
                                                    const _errs29 = errors;
                                                    if (errors === _errs29) {
                                                        if (Array.isArray(data14)) {
                                                            var valid7 = true;
                                                            const len6 = data14.length;
                                                            for (let i6 = 0; i6 < len6; i6++) {
                                                                const _errs31 = errors;
                                                                if (typeof data14[i6] !== 'string') {
                                                                    validate176.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/uniqueValuesColumns/' + i6,
                                                                            schemaPath: '#/properties/uniqueValuesColumns/items/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid7 = _errs31 === errors;
                                                                if (!valid7) {
                                                                    break;
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate176.errors = [
                                                                {
                                                                    instancePath: instancePath + '/uniqueValuesColumns',
                                                                    schemaPath: '#/properties/uniqueValuesColumns/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'array' },
                                                                    message: 'must be array'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid0 = _errs29 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate176.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate176.errors = vErrors;
    return errors === 0;
}
export const tableColumnSchemaValidation = validate177;
const schema190 = {
    $id: 'urn:wisepipe-common-computation:TableColumn',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1 },
        width: { type: 'number', minimum: 0 },
        numericFormat: {
            type: 'object',
            properties: {
                type: { type: 'string', enum: ['percent', 'dollar'] },
                decimals: { type: 'number', minimum: 0, maximum: 14 },
                thousandSeparator: { type: 'boolean' }
            },
            anyOf: [{ required: ['type'] }, { required: ['decimals'] }, { required: ['thousandSeparator'] }]
        },
        format: {
            type: 'object',
            properties: {
                backgroundColor: { type: 'string', minLength: 1 },
                fontColor: { type: 'string', minLength: 1 },
                bold: { type: 'number', minimum: 0 },
                italics: { type: 'boolean' },
                underline: { type: 'boolean' },
                fontSize: { type: 'number', minimum: 0 }
            },
            anyOf: [
                { required: ['backgroundColor'] },
                { required: ['fontColor'] },
                { required: ['bold'] },
                { required: ['italics'] },
                { required: ['underline'] },
                { required: ['fontSize'] }
            ]
        },
        conditionalFormat: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    symbol: { type: 'string', minLength: 1 },
                    value: { type: 'number' },
                    logic: { type: 'string' },
                    logicSymbol: { type: 'string', minLength: 0 },
                    logicValue: { type: 'number' },
                    format: {
                        type: 'object',
                        properties: {
                            backgroundColor: { type: 'string', minLength: 1 },
                            fontColor: { type: 'string', minLength: 1 },
                            bold: { type: 'number', minimum: 0 },
                            italics: { type: 'boolean' },
                            underline: { type: 'boolean' },
                            fontSize: { type: 'number', minimum: 0 }
                        },
                        anyOf: [
                            { required: ['backgroundColor'] },
                            { required: ['fontColor'] },
                            { required: ['bold'] },
                            { required: ['italics'] },
                            { required: ['underline'] },
                            { required: ['fontSize'] }
                        ]
                    }
                },
                anyOf: [{ required: ['symbol'] }, { required: ['value'] }]
            }
        },
        dateFormat: { type: 'string', enum: ['fullDateAndTime', 'longDate', 'shortDate', 'time', 'shortMonth', 'none'] }
    },
    required: ['name']
};
function validate177(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:TableColumn" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.name === undefined && (missing0 = 'name')) {
                validate177.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data0 = data.name;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate177.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate177.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.width !== undefined) {
                        let data1 = data.width;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 == 'number') {
                                if (data1 < 0 || isNaN(data1)) {
                                    validate177.errors = [
                                        {
                                            instancePath: instancePath + '/width',
                                            schemaPath: '#/properties/width/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 0 },
                                            message: 'must be >= 0'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate177.errors = [
                                    {
                                        instancePath: instancePath + '/width',
                                        schemaPath: '#/properties/width/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.numericFormat !== undefined) {
                            let data2 = data.numericFormat;
                            const _errs5 = errors;
                            const _errs7 = errors;
                            let valid1 = false;
                            const _errs8 = errors;
                            if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                let missing1;
                                if (data2.type === undefined && (missing1 = 'type')) {
                                    const err0 = {
                                        instancePath: instancePath + '/numericFormat',
                                        schemaPath: '#/properties/numericFormat/anyOf/0/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err0];
                                    }
                                    else {
                                        vErrors.push(err0);
                                    }
                                    errors++;
                                }
                            }
                            var _valid0 = _errs8 === errors;
                            valid1 = valid1 || _valid0;
                            if (!valid1) {
                                const _errs9 = errors;
                                if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                    let missing2;
                                    if (data2.decimals === undefined && (missing2 = 'decimals')) {
                                        const err1 = {
                                            instancePath: instancePath + '/numericFormat',
                                            schemaPath: '#/properties/numericFormat/anyOf/1/required',
                                            keyword: 'required',
                                            params: { missingProperty: missing2 },
                                            message: "must have required property '" + missing2 + "'"
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err1];
                                        }
                                        else {
                                            vErrors.push(err1);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid0 = _errs9 === errors;
                                valid1 = valid1 || _valid0;
                                if (!valid1) {
                                    const _errs10 = errors;
                                    if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                        let missing3;
                                        if (data2.thousandSeparator === undefined && (missing3 = 'thousandSeparator')) {
                                            const err2 = {
                                                instancePath: instancePath + '/numericFormat',
                                                schemaPath: '#/properties/numericFormat/anyOf/2/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing3 },
                                                message: "must have required property '" + missing3 + "'"
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err2];
                                            }
                                            else {
                                                vErrors.push(err2);
                                            }
                                            errors++;
                                        }
                                    }
                                    var _valid0 = _errs10 === errors;
                                    valid1 = valid1 || _valid0;
                                }
                            }
                            if (!valid1) {
                                const err3 = {
                                    instancePath: instancePath + '/numericFormat',
                                    schemaPath: '#/properties/numericFormat/anyOf',
                                    keyword: 'anyOf',
                                    params: {},
                                    message: 'must match a schema in anyOf'
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                }
                                else {
                                    vErrors.push(err3);
                                }
                                errors++;
                                validate177.errors = vErrors;
                                return false;
                            }
                            else {
                                errors = _errs7;
                                if (vErrors !== null) {
                                    if (_errs7) {
                                        vErrors.length = _errs7;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                            }
                            if (errors === _errs5) {
                                if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                    if (data2.type !== undefined) {
                                        let data3 = data2.type;
                                        const _errs11 = errors;
                                        if (typeof data3 !== 'string') {
                                            validate177.errors = [
                                                {
                                                    instancePath: instancePath + '/numericFormat/type',
                                                    schemaPath: '#/properties/numericFormat/properties/type/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (!(data3 === 'percent' || data3 === 'dollar')) {
                                            validate177.errors = [
                                                {
                                                    instancePath: instancePath + '/numericFormat/type',
                                                    schemaPath: '#/properties/numericFormat/properties/type/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema190.properties.numericFormat.properties.type.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid2 = _errs11 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data2.decimals !== undefined) {
                                            let data4 = data2.decimals;
                                            const _errs13 = errors;
                                            if (errors === _errs13) {
                                                if (typeof data4 == 'number') {
                                                    if (data4 > 14 || isNaN(data4)) {
                                                        validate177.errors = [
                                                            {
                                                                instancePath: instancePath + '/numericFormat/decimals',
                                                                schemaPath: '#/properties/numericFormat/properties/decimals/maximum',
                                                                keyword: 'maximum',
                                                                params: { comparison: '<=', limit: 14 },
                                                                message: 'must be <= 14'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        if (data4 < 0 || isNaN(data4)) {
                                                            validate177.errors = [
                                                                {
                                                                    instancePath: instancePath + '/numericFormat/decimals',
                                                                    schemaPath: '#/properties/numericFormat/properties/decimals/minimum',
                                                                    keyword: 'minimum',
                                                                    params: { comparison: '>=', limit: 0 },
                                                                    message: 'must be >= 0'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate177.errors = [
                                                        {
                                                            instancePath: instancePath + '/numericFormat/decimals',
                                                            schemaPath: '#/properties/numericFormat/properties/decimals/type',
                                                            keyword: 'type',
                                                            params: { type: 'number' },
                                                            message: 'must be number'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid2 = _errs13 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                        if (valid2) {
                                            if (data2.thousandSeparator !== undefined) {
                                                const _errs15 = errors;
                                                if (typeof data2.thousandSeparator !== 'boolean') {
                                                    validate177.errors = [
                                                        {
                                                            instancePath: instancePath + '/numericFormat/thousandSeparator',
                                                            schemaPath: '#/properties/numericFormat/properties/thousandSeparator/type',
                                                            keyword: 'type',
                                                            params: { type: 'boolean' },
                                                            message: 'must be boolean'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid2 = _errs15 === errors;
                                            }
                                            else {
                                                var valid2 = true;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate177.errors = [
                                        {
                                            instancePath: instancePath + '/numericFormat',
                                            schemaPath: '#/properties/numericFormat/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.format !== undefined) {
                                let data6 = data.format;
                                const _errs17 = errors;
                                const _errs19 = errors;
                                let valid3 = false;
                                const _errs20 = errors;
                                if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                    let missing4;
                                    if (data6.backgroundColor === undefined && (missing4 = 'backgroundColor')) {
                                        const err4 = {
                                            instancePath: instancePath + '/format',
                                            schemaPath: '#/properties/format/anyOf/0/required',
                                            keyword: 'required',
                                            params: { missingProperty: missing4 },
                                            message: "must have required property '" + missing4 + "'"
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err4];
                                        }
                                        else {
                                            vErrors.push(err4);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid1 = _errs20 === errors;
                                valid3 = valid3 || _valid1;
                                if (!valid3) {
                                    const _errs21 = errors;
                                    if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                        let missing5;
                                        if (data6.fontColor === undefined && (missing5 = 'fontColor')) {
                                            const err5 = {
                                                instancePath: instancePath + '/format',
                                                schemaPath: '#/properties/format/anyOf/1/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing5 },
                                                message: "must have required property '" + missing5 + "'"
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err5];
                                            }
                                            else {
                                                vErrors.push(err5);
                                            }
                                            errors++;
                                        }
                                    }
                                    var _valid1 = _errs21 === errors;
                                    valid3 = valid3 || _valid1;
                                    if (!valid3) {
                                        const _errs22 = errors;
                                        if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                            let missing6;
                                            if (data6.bold === undefined && (missing6 = 'bold')) {
                                                const err6 = {
                                                    instancePath: instancePath + '/format',
                                                    schemaPath: '#/properties/format/anyOf/2/required',
                                                    keyword: 'required',
                                                    params: { missingProperty: missing6 },
                                                    message: "must have required property '" + missing6 + "'"
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err6];
                                                }
                                                else {
                                                    vErrors.push(err6);
                                                }
                                                errors++;
                                            }
                                        }
                                        var _valid1 = _errs22 === errors;
                                        valid3 = valid3 || _valid1;
                                        if (!valid3) {
                                            const _errs23 = errors;
                                            if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                                let missing7;
                                                if (data6.italics === undefined && (missing7 = 'italics')) {
                                                    const err7 = {
                                                        instancePath: instancePath + '/format',
                                                        schemaPath: '#/properties/format/anyOf/3/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing7 },
                                                        message: "must have required property '" + missing7 + "'"
                                                    };
                                                    if (vErrors === null) {
                                                        vErrors = [err7];
                                                    }
                                                    else {
                                                        vErrors.push(err7);
                                                    }
                                                    errors++;
                                                }
                                            }
                                            var _valid1 = _errs23 === errors;
                                            valid3 = valid3 || _valid1;
                                            if (!valid3) {
                                                const _errs24 = errors;
                                                if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                                    let missing8;
                                                    if (data6.underline === undefined && (missing8 = 'underline')) {
                                                        const err8 = {
                                                            instancePath: instancePath + '/format',
                                                            schemaPath: '#/properties/format/anyOf/4/required',
                                                            keyword: 'required',
                                                            params: { missingProperty: missing8 },
                                                            message: "must have required property '" + missing8 + "'"
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err8];
                                                        }
                                                        else {
                                                            vErrors.push(err8);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                                var _valid1 = _errs24 === errors;
                                                valid3 = valid3 || _valid1;
                                                if (!valid3) {
                                                    const _errs25 = errors;
                                                    if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                                        let missing9;
                                                        if (data6.fontSize === undefined && (missing9 = 'fontSize')) {
                                                            const err9 = {
                                                                instancePath: instancePath + '/format',
                                                                schemaPath: '#/properties/format/anyOf/5/required',
                                                                keyword: 'required',
                                                                params: { missingProperty: missing9 },
                                                                message: "must have required property '" + missing9 + "'"
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err9];
                                                            }
                                                            else {
                                                                vErrors.push(err9);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    var _valid1 = _errs25 === errors;
                                                    valid3 = valid3 || _valid1;
                                                }
                                            }
                                        }
                                    }
                                }
                                if (!valid3) {
                                    const err10 = {
                                        instancePath: instancePath + '/format',
                                        schemaPath: '#/properties/format/anyOf',
                                        keyword: 'anyOf',
                                        params: {},
                                        message: 'must match a schema in anyOf'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err10];
                                    }
                                    else {
                                        vErrors.push(err10);
                                    }
                                    errors++;
                                    validate177.errors = vErrors;
                                    return false;
                                }
                                else {
                                    errors = _errs19;
                                    if (vErrors !== null) {
                                        if (_errs19) {
                                            vErrors.length = _errs19;
                                        }
                                        else {
                                            vErrors = null;
                                        }
                                    }
                                }
                                if (errors === _errs17) {
                                    if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                        if (data6.backgroundColor !== undefined) {
                                            let data7 = data6.backgroundColor;
                                            const _errs26 = errors;
                                            if (errors === _errs26) {
                                                if (typeof data7 === 'string') {
                                                    if (func2(data7) < 1) {
                                                        validate177.errors = [
                                                            {
                                                                instancePath: instancePath + '/format/backgroundColor',
                                                                schemaPath: '#/properties/format/properties/backgroundColor/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate177.errors = [
                                                        {
                                                            instancePath: instancePath + '/format/backgroundColor',
                                                            schemaPath: '#/properties/format/properties/backgroundColor/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid4 = _errs26 === errors;
                                        }
                                        else {
                                            var valid4 = true;
                                        }
                                        if (valid4) {
                                            if (data6.fontColor !== undefined) {
                                                let data8 = data6.fontColor;
                                                const _errs28 = errors;
                                                if (errors === _errs28) {
                                                    if (typeof data8 === 'string') {
                                                        if (func2(data8) < 1) {
                                                            validate177.errors = [
                                                                {
                                                                    instancePath: instancePath + '/format/fontColor',
                                                                    schemaPath: '#/properties/format/properties/fontColor/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate177.errors = [
                                                            {
                                                                instancePath: instancePath + '/format/fontColor',
                                                                schemaPath: '#/properties/format/properties/fontColor/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid4 = _errs28 === errors;
                                            }
                                            else {
                                                var valid4 = true;
                                            }
                                            if (valid4) {
                                                if (data6.bold !== undefined) {
                                                    let data9 = data6.bold;
                                                    const _errs30 = errors;
                                                    if (errors === _errs30) {
                                                        if (typeof data9 == 'number') {
                                                            if (data9 < 0 || isNaN(data9)) {
                                                                validate177.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/format/bold',
                                                                        schemaPath: '#/properties/format/properties/bold/minimum',
                                                                        keyword: 'minimum',
                                                                        params: { comparison: '>=', limit: 0 },
                                                                        message: 'must be >= 0'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate177.errors = [
                                                                {
                                                                    instancePath: instancePath + '/format/bold',
                                                                    schemaPath: '#/properties/format/properties/bold/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'number' },
                                                                    message: 'must be number'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid4 = _errs30 === errors;
                                                }
                                                else {
                                                    var valid4 = true;
                                                }
                                                if (valid4) {
                                                    if (data6.italics !== undefined) {
                                                        const _errs32 = errors;
                                                        if (typeof data6.italics !== 'boolean') {
                                                            validate177.errors = [
                                                                {
                                                                    instancePath: instancePath + '/format/italics',
                                                                    schemaPath: '#/properties/format/properties/italics/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'boolean' },
                                                                    message: 'must be boolean'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid4 = _errs32 === errors;
                                                    }
                                                    else {
                                                        var valid4 = true;
                                                    }
                                                    if (valid4) {
                                                        if (data6.underline !== undefined) {
                                                            const _errs34 = errors;
                                                            if (typeof data6.underline !== 'boolean') {
                                                                validate177.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/format/underline',
                                                                        schemaPath: '#/properties/format/properties/underline/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'boolean' },
                                                                        message: 'must be boolean'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid4 = _errs34 === errors;
                                                        }
                                                        else {
                                                            var valid4 = true;
                                                        }
                                                        if (valid4) {
                                                            if (data6.fontSize !== undefined) {
                                                                let data12 = data6.fontSize;
                                                                const _errs36 = errors;
                                                                if (errors === _errs36) {
                                                                    if (typeof data12 == 'number') {
                                                                        if (data12 < 0 || isNaN(data12)) {
                                                                            validate177.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/format/fontSize',
                                                                                    schemaPath: '#/properties/format/properties/fontSize/minimum',
                                                                                    keyword: 'minimum',
                                                                                    params: { comparison: '>=', limit: 0 },
                                                                                    message: 'must be >= 0'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate177.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/format/fontSize',
                                                                                schemaPath: '#/properties/format/properties/fontSize/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'number' },
                                                                                message: 'must be number'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid4 = _errs36 === errors;
                                                            }
                                                            else {
                                                                var valid4 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate177.errors = [
                                            {
                                                instancePath: instancePath + '/format',
                                                schemaPath: '#/properties/format/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs17 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.conditionalFormat !== undefined) {
                                    let data13 = data.conditionalFormat;
                                    const _errs38 = errors;
                                    if (errors === _errs38) {
                                        if (Array.isArray(data13)) {
                                            var valid5 = true;
                                            const len0 = data13.length;
                                            for (let i0 = 0; i0 < len0; i0++) {
                                                let data14 = data13[i0];
                                                const _errs40 = errors;
                                                const _errs42 = errors;
                                                let valid6 = false;
                                                const _errs43 = errors;
                                                if (data14 && typeof data14 == 'object' && !Array.isArray(data14)) {
                                                    let missing10;
                                                    if (data14.symbol === undefined && (missing10 = 'symbol')) {
                                                        const err11 = {
                                                            instancePath: instancePath + '/conditionalFormat/' + i0,
                                                            schemaPath: '#/properties/conditionalFormat/items/anyOf/0/required',
                                                            keyword: 'required',
                                                            params: { missingProperty: missing10 },
                                                            message: "must have required property '" + missing10 + "'"
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err11];
                                                        }
                                                        else {
                                                            vErrors.push(err11);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                                var _valid2 = _errs43 === errors;
                                                valid6 = valid6 || _valid2;
                                                if (!valid6) {
                                                    const _errs44 = errors;
                                                    if (data14 && typeof data14 == 'object' && !Array.isArray(data14)) {
                                                        let missing11;
                                                        if (data14.value === undefined && (missing11 = 'value')) {
                                                            const err12 = {
                                                                instancePath: instancePath + '/conditionalFormat/' + i0,
                                                                schemaPath: '#/properties/conditionalFormat/items/anyOf/1/required',
                                                                keyword: 'required',
                                                                params: { missingProperty: missing11 },
                                                                message: "must have required property '" + missing11 + "'"
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err12];
                                                            }
                                                            else {
                                                                vErrors.push(err12);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    var _valid2 = _errs44 === errors;
                                                    valid6 = valid6 || _valid2;
                                                }
                                                if (!valid6) {
                                                    const err13 = {
                                                        instancePath: instancePath + '/conditionalFormat/' + i0,
                                                        schemaPath: '#/properties/conditionalFormat/items/anyOf',
                                                        keyword: 'anyOf',
                                                        params: {},
                                                        message: 'must match a schema in anyOf'
                                                    };
                                                    if (vErrors === null) {
                                                        vErrors = [err13];
                                                    }
                                                    else {
                                                        vErrors.push(err13);
                                                    }
                                                    errors++;
                                                    validate177.errors = vErrors;
                                                    return false;
                                                }
                                                else {
                                                    errors = _errs42;
                                                    if (vErrors !== null) {
                                                        if (_errs42) {
                                                            vErrors.length = _errs42;
                                                        }
                                                        else {
                                                            vErrors = null;
                                                        }
                                                    }
                                                }
                                                if (errors === _errs40) {
                                                    if (data14 && typeof data14 == 'object' && !Array.isArray(data14)) {
                                                        if (data14.symbol !== undefined) {
                                                            let data15 = data14.symbol;
                                                            const _errs45 = errors;
                                                            if (errors === _errs45) {
                                                                if (typeof data15 === 'string') {
                                                                    if (func2(data15) < 1) {
                                                                        validate177.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/conditionalFormat/' + i0 + '/symbol',
                                                                                schemaPath: '#/properties/conditionalFormat/items/properties/symbol/minLength',
                                                                                keyword: 'minLength',
                                                                                params: { limit: 1 },
                                                                                message: 'must NOT have fewer than 1 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate177.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/conditionalFormat/' + i0 + '/symbol',
                                                                            schemaPath: '#/properties/conditionalFormat/items/properties/symbol/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid7 = _errs45 === errors;
                                                        }
                                                        else {
                                                            var valid7 = true;
                                                        }
                                                        if (valid7) {
                                                            if (data14.value !== undefined) {
                                                                const _errs47 = errors;
                                                                if (!(typeof data14.value == 'number')) {
                                                                    validate177.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/conditionalFormat/' + i0 + '/value',
                                                                            schemaPath: '#/properties/conditionalFormat/items/properties/value/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'number' },
                                                                            message: 'must be number'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid7 = _errs47 === errors;
                                                            }
                                                            else {
                                                                var valid7 = true;
                                                            }
                                                            if (valid7) {
                                                                if (data14.logic !== undefined) {
                                                                    const _errs49 = errors;
                                                                    if (typeof data14.logic !== 'string') {
                                                                        validate177.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/conditionalFormat/' + i0 + '/logic',
                                                                                schemaPath: '#/properties/conditionalFormat/items/properties/logic/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid7 = _errs49 === errors;
                                                                }
                                                                else {
                                                                    var valid7 = true;
                                                                }
                                                                if (valid7) {
                                                                    if (data14.logicSymbol !== undefined) {
                                                                        let data18 = data14.logicSymbol;
                                                                        const _errs51 = errors;
                                                                        if (errors === _errs51) {
                                                                            if (typeof data18 === 'string') {
                                                                                if (func2(data18) < 0) {
                                                                                    validate177.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/conditionalFormat/' + i0 + '/logicSymbol',
                                                                                            schemaPath: '#/properties/conditionalFormat/items/properties/logicSymbol/minLength',
                                                                                            keyword: 'minLength',
                                                                                            params: { limit: 0 },
                                                                                            message: 'must NOT have fewer than 0 characters'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate177.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/conditionalFormat/' + i0 + '/logicSymbol',
                                                                                        schemaPath: '#/properties/conditionalFormat/items/properties/logicSymbol/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid7 = _errs51 === errors;
                                                                    }
                                                                    else {
                                                                        var valid7 = true;
                                                                    }
                                                                    if (valid7) {
                                                                        if (data14.logicValue !== undefined) {
                                                                            const _errs53 = errors;
                                                                            if (!(typeof data14.logicValue == 'number')) {
                                                                                validate177.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/conditionalFormat/' + i0 + '/logicValue',
                                                                                        schemaPath: '#/properties/conditionalFormat/items/properties/logicValue/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'number' },
                                                                                        message: 'must be number'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            var valid7 = _errs53 === errors;
                                                                        }
                                                                        else {
                                                                            var valid7 = true;
                                                                        }
                                                                        if (valid7) {
                                                                            if (data14.format !== undefined) {
                                                                                let data20 = data14.format;
                                                                                const _errs55 = errors;
                                                                                const _errs57 = errors;
                                                                                let valid8 = false;
                                                                                const _errs58 = errors;
                                                                                if (data20 && typeof data20 == 'object' && !Array.isArray(data20)) {
                                                                                    let missing12;
                                                                                    if (data20.backgroundColor === undefined && (missing12 = 'backgroundColor')) {
                                                                                        const err14 = {
                                                                                            instancePath: instancePath + '/conditionalFormat/' + i0 + '/format',
                                                                                            schemaPath: '#/properties/conditionalFormat/items/properties/format/anyOf/0/required',
                                                                                            keyword: 'required',
                                                                                            params: { missingProperty: missing12 },
                                                                                            message: "must have required property '" + missing12 + "'"
                                                                                        };
                                                                                        if (vErrors === null) {
                                                                                            vErrors = [err14];
                                                                                        }
                                                                                        else {
                                                                                            vErrors.push(err14);
                                                                                        }
                                                                                        errors++;
                                                                                    }
                                                                                }
                                                                                var _valid3 = _errs58 === errors;
                                                                                valid8 = valid8 || _valid3;
                                                                                if (!valid8) {
                                                                                    const _errs59 = errors;
                                                                                    if (data20 && typeof data20 == 'object' && !Array.isArray(data20)) {
                                                                                        let missing13;
                                                                                        if (data20.fontColor === undefined && (missing13 = 'fontColor')) {
                                                                                            const err15 = {
                                                                                                instancePath: instancePath + '/conditionalFormat/' + i0 + '/format',
                                                                                                schemaPath: '#/properties/conditionalFormat/items/properties/format/anyOf/1/required',
                                                                                                keyword: 'required',
                                                                                                params: { missingProperty: missing13 },
                                                                                                message: "must have required property '" + missing13 + "'"
                                                                                            };
                                                                                            if (vErrors === null) {
                                                                                                vErrors = [err15];
                                                                                            }
                                                                                            else {
                                                                                                vErrors.push(err15);
                                                                                            }
                                                                                            errors++;
                                                                                        }
                                                                                    }
                                                                                    var _valid3 = _errs59 === errors;
                                                                                    valid8 = valid8 || _valid3;
                                                                                    if (!valid8) {
                                                                                        const _errs60 = errors;
                                                                                        if (data20 && typeof data20 == 'object' && !Array.isArray(data20)) {
                                                                                            let missing14;
                                                                                            if (data20.bold === undefined && (missing14 = 'bold')) {
                                                                                                const err16 = {
                                                                                                    instancePath: instancePath + '/conditionalFormat/' + i0 + '/format',
                                                                                                    schemaPath: '#/properties/conditionalFormat/items/properties/format/anyOf/2/required',
                                                                                                    keyword: 'required',
                                                                                                    params: { missingProperty: missing14 },
                                                                                                    message: "must have required property '" + missing14 + "'"
                                                                                                };
                                                                                                if (vErrors === null) {
                                                                                                    vErrors = [err16];
                                                                                                }
                                                                                                else {
                                                                                                    vErrors.push(err16);
                                                                                                }
                                                                                                errors++;
                                                                                            }
                                                                                        }
                                                                                        var _valid3 = _errs60 === errors;
                                                                                        valid8 = valid8 || _valid3;
                                                                                        if (!valid8) {
                                                                                            const _errs61 = errors;
                                                                                            if (data20 && typeof data20 == 'object' && !Array.isArray(data20)) {
                                                                                                let missing15;
                                                                                                if (data20.italics === undefined && (missing15 = 'italics')) {
                                                                                                    const err17 = {
                                                                                                        instancePath: instancePath + '/conditionalFormat/' + i0 + '/format',
                                                                                                        schemaPath: '#/properties/conditionalFormat/items/properties/format/anyOf/3/required',
                                                                                                        keyword: 'required',
                                                                                                        params: { missingProperty: missing15 },
                                                                                                        message: "must have required property '" + missing15 + "'"
                                                                                                    };
                                                                                                    if (vErrors === null) {
                                                                                                        vErrors = [err17];
                                                                                                    }
                                                                                                    else {
                                                                                                        vErrors.push(err17);
                                                                                                    }
                                                                                                    errors++;
                                                                                                }
                                                                                            }
                                                                                            var _valid3 = _errs61 === errors;
                                                                                            valid8 = valid8 || _valid3;
                                                                                            if (!valid8) {
                                                                                                const _errs62 = errors;
                                                                                                if (data20 && typeof data20 == 'object' && !Array.isArray(data20)) {
                                                                                                    let missing16;
                                                                                                    if (data20.underline === undefined && (missing16 = 'underline')) {
                                                                                                        const err18 = {
                                                                                                            instancePath: instancePath + '/conditionalFormat/' + i0 + '/format',
                                                                                                            schemaPath: '#/properties/conditionalFormat/items/properties/format/anyOf/4/required',
                                                                                                            keyword: 'required',
                                                                                                            params: { missingProperty: missing16 },
                                                                                                            message: "must have required property '" + missing16 + "'"
                                                                                                        };
                                                                                                        if (vErrors === null) {
                                                                                                            vErrors = [err18];
                                                                                                        }
                                                                                                        else {
                                                                                                            vErrors.push(err18);
                                                                                                        }
                                                                                                        errors++;
                                                                                                    }
                                                                                                }
                                                                                                var _valid3 = _errs62 === errors;
                                                                                                valid8 = valid8 || _valid3;
                                                                                                if (!valid8) {
                                                                                                    const _errs63 = errors;
                                                                                                    if (data20 && typeof data20 == 'object' && !Array.isArray(data20)) {
                                                                                                        let missing17;
                                                                                                        if (data20.fontSize === undefined && (missing17 = 'fontSize')) {
                                                                                                            const err19 = {
                                                                                                                instancePath: instancePath + '/conditionalFormat/' + i0 + '/format',
                                                                                                                schemaPath: '#/properties/conditionalFormat/items/properties/format/anyOf/5/required',
                                                                                                                keyword: 'required',
                                                                                                                params: { missingProperty: missing17 },
                                                                                                                message: "must have required property '" + missing17 + "'"
                                                                                                            };
                                                                                                            if (vErrors === null) {
                                                                                                                vErrors = [err19];
                                                                                                            }
                                                                                                            else {
                                                                                                                vErrors.push(err19);
                                                                                                            }
                                                                                                            errors++;
                                                                                                        }
                                                                                                    }
                                                                                                    var _valid3 = _errs63 === errors;
                                                                                                    valid8 = valid8 || _valid3;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                                if (!valid8) {
                                                                                    const err20 = {
                                                                                        instancePath: instancePath + '/conditionalFormat/' + i0 + '/format',
                                                                                        schemaPath: '#/properties/conditionalFormat/items/properties/format/anyOf',
                                                                                        keyword: 'anyOf',
                                                                                        params: {},
                                                                                        message: 'must match a schema in anyOf'
                                                                                    };
                                                                                    if (vErrors === null) {
                                                                                        vErrors = [err20];
                                                                                    }
                                                                                    else {
                                                                                        vErrors.push(err20);
                                                                                    }
                                                                                    errors++;
                                                                                    validate177.errors = vErrors;
                                                                                    return false;
                                                                                }
                                                                                else {
                                                                                    errors = _errs57;
                                                                                    if (vErrors !== null) {
                                                                                        if (_errs57) {
                                                                                            vErrors.length = _errs57;
                                                                                        }
                                                                                        else {
                                                                                            vErrors = null;
                                                                                        }
                                                                                    }
                                                                                }
                                                                                if (errors === _errs55) {
                                                                                    if (data20 && typeof data20 == 'object' && !Array.isArray(data20)) {
                                                                                        if (data20.backgroundColor !== undefined) {
                                                                                            let data21 = data20.backgroundColor;
                                                                                            const _errs64 = errors;
                                                                                            if (errors === _errs64) {
                                                                                                if (typeof data21 === 'string') {
                                                                                                    if (func2(data21) < 1) {
                                                                                                        validate177.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath +
                                                                                                                    '/conditionalFormat/' +
                                                                                                                    i0 +
                                                                                                                    '/format/backgroundColor',
                                                                                                                schemaPath: '#/properties/conditionalFormat/items/properties/format/properties/backgroundColor/minLength',
                                                                                                                keyword: 'minLength',
                                                                                                                params: { limit: 1 },
                                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    validate177.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath +
                                                                                                                '/conditionalFormat/' +
                                                                                                                i0 +
                                                                                                                '/format/backgroundColor',
                                                                                                            schemaPath: '#/properties/conditionalFormat/items/properties/format/properties/backgroundColor/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'string' },
                                                                                                            message: 'must be string'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            var valid9 = _errs64 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid9 = true;
                                                                                        }
                                                                                        if (valid9) {
                                                                                            if (data20.fontColor !== undefined) {
                                                                                                let data22 = data20.fontColor;
                                                                                                const _errs66 = errors;
                                                                                                if (errors === _errs66) {
                                                                                                    if (typeof data22 === 'string') {
                                                                                                        if (func2(data22) < 1) {
                                                                                                            validate177.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath +
                                                                                                                        '/conditionalFormat/' +
                                                                                                                        i0 +
                                                                                                                        '/format/fontColor',
                                                                                                                    schemaPath: '#/properties/conditionalFormat/items/properties/format/properties/fontColor/minLength',
                                                                                                                    keyword: 'minLength',
                                                                                                                    params: { limit: 1 },
                                                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                    else {
                                                                                                        validate177.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath +
                                                                                                                    '/conditionalFormat/' +
                                                                                                                    i0 +
                                                                                                                    '/format/fontColor',
                                                                                                                schemaPath: '#/properties/conditionalFormat/items/properties/format/properties/fontColor/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'string' },
                                                                                                                message: 'must be string'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                var valid9 = _errs66 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid9 = true;
                                                                                            }
                                                                                            if (valid9) {
                                                                                                if (data20.bold !== undefined) {
                                                                                                    let data23 = data20.bold;
                                                                                                    const _errs68 = errors;
                                                                                                    if (errors === _errs68) {
                                                                                                        if (typeof data23 == 'number') {
                                                                                                            if (data23 < 0 || isNaN(data23)) {
                                                                                                                validate177.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath +
                                                                                                                            '/conditionalFormat/' +
                                                                                                                            i0 +
                                                                                                                            '/format/bold',
                                                                                                                        schemaPath: '#/properties/conditionalFormat/items/properties/format/properties/bold/minimum',
                                                                                                                        keyword: 'minimum',
                                                                                                                        params: { comparison: '>=', limit: 0 },
                                                                                                                        message: 'must be >= 0'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                        }
                                                                                                        else {
                                                                                                            validate177.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/conditionalFormat/' + i0 + '/format/bold',
                                                                                                                    schemaPath: '#/properties/conditionalFormat/items/properties/format/properties/bold/type',
                                                                                                                    keyword: 'type',
                                                                                                                    params: { type: 'number' },
                                                                                                                    message: 'must be number'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                    var valid9 = _errs68 === errors;
                                                                                                }
                                                                                                else {
                                                                                                    var valid9 = true;
                                                                                                }
                                                                                                if (valid9) {
                                                                                                    if (data20.italics !== undefined) {
                                                                                                        const _errs70 = errors;
                                                                                                        if (typeof data20.italics !== 'boolean') {
                                                                                                            validate177.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath +
                                                                                                                        '/conditionalFormat/' +
                                                                                                                        i0 +
                                                                                                                        '/format/italics',
                                                                                                                    schemaPath: '#/properties/conditionalFormat/items/properties/format/properties/italics/type',
                                                                                                                    keyword: 'type',
                                                                                                                    params: { type: 'boolean' },
                                                                                                                    message: 'must be boolean'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                        var valid9 = _errs70 === errors;
                                                                                                    }
                                                                                                    else {
                                                                                                        var valid9 = true;
                                                                                                    }
                                                                                                    if (valid9) {
                                                                                                        if (data20.underline !== undefined) {
                                                                                                            const _errs72 = errors;
                                                                                                            if (typeof data20.underline !== 'boolean') {
                                                                                                                validate177.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath +
                                                                                                                            '/conditionalFormat/' +
                                                                                                                            i0 +
                                                                                                                            '/format/underline',
                                                                                                                        schemaPath: '#/properties/conditionalFormat/items/properties/format/properties/underline/type',
                                                                                                                        keyword: 'type',
                                                                                                                        params: { type: 'boolean' },
                                                                                                                        message: 'must be boolean'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                            var valid9 = _errs72 === errors;
                                                                                                        }
                                                                                                        else {
                                                                                                            var valid9 = true;
                                                                                                        }
                                                                                                        if (valid9) {
                                                                                                            if (data20.fontSize !== undefined) {
                                                                                                                let data26 = data20.fontSize;
                                                                                                                const _errs74 = errors;
                                                                                                                if (errors === _errs74) {
                                                                                                                    if (typeof data26 == 'number') {
                                                                                                                        if (data26 < 0 || isNaN(data26)) {
                                                                                                                            validate177.errors = [
                                                                                                                                {
                                                                                                                                    instancePath: instancePath +
                                                                                                                                        '/conditionalFormat/' +
                                                                                                                                        i0 +
                                                                                                                                        '/format/fontSize',
                                                                                                                                    schemaPath: '#/properties/conditionalFormat/items/properties/format/properties/fontSize/minimum',
                                                                                                                                    keyword: 'minimum',
                                                                                                                                    params: { comparison: '>=', limit: 0 },
                                                                                                                                    message: 'must be >= 0'
                                                                                                                                }
                                                                                                                            ];
                                                                                                                            return false;
                                                                                                                        }
                                                                                                                    }
                                                                                                                    else {
                                                                                                                        validate177.errors = [
                                                                                                                            {
                                                                                                                                instancePath: instancePath +
                                                                                                                                    '/conditionalFormat/' +
                                                                                                                                    i0 +
                                                                                                                                    '/format/fontSize',
                                                                                                                                schemaPath: '#/properties/conditionalFormat/items/properties/format/properties/fontSize/type',
                                                                                                                                keyword: 'type',
                                                                                                                                params: { type: 'number' },
                                                                                                                                message: 'must be number'
                                                                                                                            }
                                                                                                                        ];
                                                                                                                        return false;
                                                                                                                    }
                                                                                                                }
                                                                                                                var valid9 = _errs74 === errors;
                                                                                                            }
                                                                                                            else {
                                                                                                                var valid9 = true;
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate177.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/conditionalFormat/' + i0 + '/format',
                                                                                                schemaPath: '#/properties/conditionalFormat/items/properties/format/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'object' },
                                                                                                message: 'must be object'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid7 = _errs55 === errors;
                                                                            }
                                                                            else {
                                                                                var valid7 = true;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate177.errors = [
                                                            {
                                                                instancePath: instancePath + '/conditionalFormat/' + i0,
                                                                schemaPath: '#/properties/conditionalFormat/items/type',
                                                                keyword: 'type',
                                                                params: { type: 'object' },
                                                                message: 'must be object'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid5 = _errs40 === errors;
                                                if (!valid5) {
                                                    break;
                                                }
                                            }
                                        }
                                        else {
                                            validate177.errors = [
                                                {
                                                    instancePath: instancePath + '/conditionalFormat',
                                                    schemaPath: '#/properties/conditionalFormat/type',
                                                    keyword: 'type',
                                                    params: { type: 'array' },
                                                    message: 'must be array'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs38 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.dateFormat !== undefined) {
                                        let data27 = data.dateFormat;
                                        const _errs76 = errors;
                                        if (typeof data27 !== 'string') {
                                            validate177.errors = [
                                                {
                                                    instancePath: instancePath + '/dateFormat',
                                                    schemaPath: '#/properties/dateFormat/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (!(data27 === 'fullDateAndTime' ||
                                            data27 === 'longDate' ||
                                            data27 === 'shortDate' ||
                                            data27 === 'time' ||
                                            data27 === 'shortMonth' ||
                                            data27 === 'none')) {
                                            validate177.errors = [
                                                {
                                                    instancePath: instancePath + '/dateFormat',
                                                    schemaPath: '#/properties/dateFormat/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema190.properties.dateFormat.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs76 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate177.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate177.errors = vErrors;
    return errors === 0;
}
export const tableVisualParamsSchemaValidation = validate178;
const schema191 = {
    $id: 'urn:wisepipe-common-computation:TableVisualParams',
    type: 'object',
    properties: {
        columns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-computation:TableColumn' },
            minItems: 1,
            uniqueItemProperties: ['name']
        }
    },
    required: ['columns']
};
const func491 = ajvEqual;
function validate178(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:TableVisualParams" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.columns === undefined && (missing0 = 'columns')) {
                validate178.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data0 = data.columns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length < 1) {
                                validate178.errors = [
                                    {
                                        instancePath: instancePath + '/columns',
                                        schemaPath: '#/properties/columns/minItems',
                                        keyword: 'minItems',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                var valid1 = true;
                                const len0 = data0.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data1 = data0[i0];
                                    const _errs3 = errors;
                                    const _errs4 = errors;
                                    if (errors === _errs4) {
                                        if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                            let missing1;
                                            if (data1.name === undefined && (missing1 = 'name')) {
                                                validate178.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns/' + i0,
                                                        schemaPath: 'urn:wisepipe-common-computation:TableColumn/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing1 },
                                                        message: "must have required property '" + missing1 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data1.name !== undefined) {
                                                    let data2 = data1.name;
                                                    const _errs6 = errors;
                                                    if (errors === _errs6) {
                                                        if (typeof data2 === 'string') {
                                                            if (func2(data2) < 1) {
                                                                validate178.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/columns/' + i0 + '/name',
                                                                        schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/name/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 1 },
                                                                        message: 'must NOT have fewer than 1 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate178.errors = [
                                                                {
                                                                    instancePath: instancePath + '/columns/' + i0 + '/name',
                                                                    schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/name/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid3 = _errs6 === errors;
                                                }
                                                else {
                                                    var valid3 = true;
                                                }
                                                if (valid3) {
                                                    if (data1.width !== undefined) {
                                                        let data3 = data1.width;
                                                        const _errs8 = errors;
                                                        if (errors === _errs8) {
                                                            if (typeof data3 == 'number') {
                                                                if (data3 < 0 || isNaN(data3)) {
                                                                    validate178.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/columns/' + i0 + '/width',
                                                                            schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/width/minimum',
                                                                            keyword: 'minimum',
                                                                            params: { comparison: '>=', limit: 0 },
                                                                            message: 'must be >= 0'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate178.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/columns/' + i0 + '/width',
                                                                        schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/width/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'number' },
                                                                        message: 'must be number'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid3 = _errs8 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                    if (valid3) {
                                                        if (data1.numericFormat !== undefined) {
                                                            let data4 = data1.numericFormat;
                                                            const _errs10 = errors;
                                                            const _errs12 = errors;
                                                            let valid4 = false;
                                                            const _errs13 = errors;
                                                            if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                                                                let missing2;
                                                                if (data4.type === undefined && (missing2 = 'type')) {
                                                                    const err0 = {
                                                                        instancePath: instancePath + '/columns/' + i0 + '/numericFormat',
                                                                        schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/numericFormat/anyOf/0/required',
                                                                        keyword: 'required',
                                                                        params: { missingProperty: missing2 },
                                                                        message: "must have required property '" + missing2 + "'"
                                                                    };
                                                                    if (vErrors === null) {
                                                                        vErrors = [err0];
                                                                    }
                                                                    else {
                                                                        vErrors.push(err0);
                                                                    }
                                                                    errors++;
                                                                }
                                                            }
                                                            var _valid0 = _errs13 === errors;
                                                            valid4 = valid4 || _valid0;
                                                            if (!valid4) {
                                                                const _errs14 = errors;
                                                                if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                                                                    let missing3;
                                                                    if (data4.decimals === undefined && (missing3 = 'decimals')) {
                                                                        const err1 = {
                                                                            instancePath: instancePath + '/columns/' + i0 + '/numericFormat',
                                                                            schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/numericFormat/anyOf/1/required',
                                                                            keyword: 'required',
                                                                            params: { missingProperty: missing3 },
                                                                            message: "must have required property '" + missing3 + "'"
                                                                        };
                                                                        if (vErrors === null) {
                                                                            vErrors = [err1];
                                                                        }
                                                                        else {
                                                                            vErrors.push(err1);
                                                                        }
                                                                        errors++;
                                                                    }
                                                                }
                                                                var _valid0 = _errs14 === errors;
                                                                valid4 = valid4 || _valid0;
                                                                if (!valid4) {
                                                                    const _errs15 = errors;
                                                                    if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                                                                        let missing4;
                                                                        if (data4.thousandSeparator === undefined && (missing4 = 'thousandSeparator')) {
                                                                            const err2 = {
                                                                                instancePath: instancePath + '/columns/' + i0 + '/numericFormat',
                                                                                schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/numericFormat/anyOf/2/required',
                                                                                keyword: 'required',
                                                                                params: { missingProperty: missing4 },
                                                                                message: "must have required property '" + missing4 + "'"
                                                                            };
                                                                            if (vErrors === null) {
                                                                                vErrors = [err2];
                                                                            }
                                                                            else {
                                                                                vErrors.push(err2);
                                                                            }
                                                                            errors++;
                                                                        }
                                                                    }
                                                                    var _valid0 = _errs15 === errors;
                                                                    valid4 = valid4 || _valid0;
                                                                }
                                                            }
                                                            if (!valid4) {
                                                                const err3 = {
                                                                    instancePath: instancePath + '/columns/' + i0 + '/numericFormat',
                                                                    schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/numericFormat/anyOf',
                                                                    keyword: 'anyOf',
                                                                    params: {},
                                                                    message: 'must match a schema in anyOf'
                                                                };
                                                                if (vErrors === null) {
                                                                    vErrors = [err3];
                                                                }
                                                                else {
                                                                    vErrors.push(err3);
                                                                }
                                                                errors++;
                                                                validate178.errors = vErrors;
                                                                return false;
                                                            }
                                                            else {
                                                                errors = _errs12;
                                                                if (vErrors !== null) {
                                                                    if (_errs12) {
                                                                        vErrors.length = _errs12;
                                                                    }
                                                                    else {
                                                                        vErrors = null;
                                                                    }
                                                                }
                                                            }
                                                            if (errors === _errs10) {
                                                                if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                                                                    if (data4.type !== undefined) {
                                                                        let data5 = data4.type;
                                                                        const _errs16 = errors;
                                                                        if (typeof data5 !== 'string') {
                                                                            validate178.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/columns/' + i0 + '/numericFormat/type',
                                                                                    schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/numericFormat/properties/type/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        if (!(data5 === 'percent' || data5 === 'dollar')) {
                                                                            validate178.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/columns/' + i0 + '/numericFormat/type',
                                                                                    schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/numericFormat/properties/type/enum',
                                                                                    keyword: 'enum',
                                                                                    params: {
                                                                                        allowedValues: schema190.properties.numericFormat.properties.type.enum
                                                                                    },
                                                                                    message: 'must be equal to one of the allowed values'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        var valid5 = _errs16 === errors;
                                                                    }
                                                                    else {
                                                                        var valid5 = true;
                                                                    }
                                                                    if (valid5) {
                                                                        if (data4.decimals !== undefined) {
                                                                            let data6 = data4.decimals;
                                                                            const _errs18 = errors;
                                                                            if (errors === _errs18) {
                                                                                if (typeof data6 == 'number') {
                                                                                    if (data6 > 14 || isNaN(data6)) {
                                                                                        validate178.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/columns/' + i0 + '/numericFormat/decimals',
                                                                                                schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/numericFormat/properties/decimals/maximum',
                                                                                                keyword: 'maximum',
                                                                                                params: { comparison: '<=', limit: 14 },
                                                                                                message: 'must be <= 14'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    else {
                                                                                        if (data6 < 0 || isNaN(data6)) {
                                                                                            validate178.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/columns/' + i0 + '/numericFormat/decimals',
                                                                                                    schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/numericFormat/properties/decimals/minimum',
                                                                                                    keyword: 'minimum',
                                                                                                    params: { comparison: '>=', limit: 0 },
                                                                                                    message: 'must be >= 0'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate178.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/columns/' + i0 + '/numericFormat/decimals',
                                                                                            schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/numericFormat/properties/decimals/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'number' },
                                                                                            message: 'must be number'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid5 = _errs18 === errors;
                                                                        }
                                                                        else {
                                                                            var valid5 = true;
                                                                        }
                                                                        if (valid5) {
                                                                            if (data4.thousandSeparator !== undefined) {
                                                                                const _errs20 = errors;
                                                                                if (typeof data4.thousandSeparator !== 'boolean') {
                                                                                    validate178.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/columns/' + i0 + '/numericFormat/thousandSeparator',
                                                                                            schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/numericFormat/properties/thousandSeparator/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'boolean' },
                                                                                            message: 'must be boolean'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                var valid5 = _errs20 === errors;
                                                                            }
                                                                            else {
                                                                                var valid5 = true;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate178.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/columns/' + i0 + '/numericFormat',
                                                                            schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/numericFormat/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'object' },
                                                                            message: 'must be object'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid3 = _errs10 === errors;
                                                        }
                                                        else {
                                                            var valid3 = true;
                                                        }
                                                        if (valid3) {
                                                            if (data1.format !== undefined) {
                                                                let data8 = data1.format;
                                                                const _errs22 = errors;
                                                                const _errs24 = errors;
                                                                let valid6 = false;
                                                                const _errs25 = errors;
                                                                if (data8 && typeof data8 == 'object' && !Array.isArray(data8)) {
                                                                    let missing5;
                                                                    if (data8.backgroundColor === undefined && (missing5 = 'backgroundColor')) {
                                                                        const err4 = {
                                                                            instancePath: instancePath + '/columns/' + i0 + '/format',
                                                                            schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/format/anyOf/0/required',
                                                                            keyword: 'required',
                                                                            params: { missingProperty: missing5 },
                                                                            message: "must have required property '" + missing5 + "'"
                                                                        };
                                                                        if (vErrors === null) {
                                                                            vErrors = [err4];
                                                                        }
                                                                        else {
                                                                            vErrors.push(err4);
                                                                        }
                                                                        errors++;
                                                                    }
                                                                }
                                                                var _valid1 = _errs25 === errors;
                                                                valid6 = valid6 || _valid1;
                                                                if (!valid6) {
                                                                    const _errs26 = errors;
                                                                    if (data8 && typeof data8 == 'object' && !Array.isArray(data8)) {
                                                                        let missing6;
                                                                        if (data8.fontColor === undefined && (missing6 = 'fontColor')) {
                                                                            const err5 = {
                                                                                instancePath: instancePath + '/columns/' + i0 + '/format',
                                                                                schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/format/anyOf/1/required',
                                                                                keyword: 'required',
                                                                                params: { missingProperty: missing6 },
                                                                                message: "must have required property '" + missing6 + "'"
                                                                            };
                                                                            if (vErrors === null) {
                                                                                vErrors = [err5];
                                                                            }
                                                                            else {
                                                                                vErrors.push(err5);
                                                                            }
                                                                            errors++;
                                                                        }
                                                                    }
                                                                    var _valid1 = _errs26 === errors;
                                                                    valid6 = valid6 || _valid1;
                                                                    if (!valid6) {
                                                                        const _errs27 = errors;
                                                                        if (data8 && typeof data8 == 'object' && !Array.isArray(data8)) {
                                                                            let missing7;
                                                                            if (data8.bold === undefined && (missing7 = 'bold')) {
                                                                                const err6 = {
                                                                                    instancePath: instancePath + '/columns/' + i0 + '/format',
                                                                                    schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/format/anyOf/2/required',
                                                                                    keyword: 'required',
                                                                                    params: { missingProperty: missing7 },
                                                                                    message: "must have required property '" + missing7 + "'"
                                                                                };
                                                                                if (vErrors === null) {
                                                                                    vErrors = [err6];
                                                                                }
                                                                                else {
                                                                                    vErrors.push(err6);
                                                                                }
                                                                                errors++;
                                                                            }
                                                                        }
                                                                        var _valid1 = _errs27 === errors;
                                                                        valid6 = valid6 || _valid1;
                                                                        if (!valid6) {
                                                                            const _errs28 = errors;
                                                                            if (data8 && typeof data8 == 'object' && !Array.isArray(data8)) {
                                                                                let missing8;
                                                                                if (data8.italics === undefined && (missing8 = 'italics')) {
                                                                                    const err7 = {
                                                                                        instancePath: instancePath + '/columns/' + i0 + '/format',
                                                                                        schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/format/anyOf/3/required',
                                                                                        keyword: 'required',
                                                                                        params: { missingProperty: missing8 },
                                                                                        message: "must have required property '" + missing8 + "'"
                                                                                    };
                                                                                    if (vErrors === null) {
                                                                                        vErrors = [err7];
                                                                                    }
                                                                                    else {
                                                                                        vErrors.push(err7);
                                                                                    }
                                                                                    errors++;
                                                                                }
                                                                            }
                                                                            var _valid1 = _errs28 === errors;
                                                                            valid6 = valid6 || _valid1;
                                                                            if (!valid6) {
                                                                                const _errs29 = errors;
                                                                                if (data8 && typeof data8 == 'object' && !Array.isArray(data8)) {
                                                                                    let missing9;
                                                                                    if (data8.underline === undefined && (missing9 = 'underline')) {
                                                                                        const err8 = {
                                                                                            instancePath: instancePath + '/columns/' + i0 + '/format',
                                                                                            schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/format/anyOf/4/required',
                                                                                            keyword: 'required',
                                                                                            params: { missingProperty: missing9 },
                                                                                            message: "must have required property '" + missing9 + "'"
                                                                                        };
                                                                                        if (vErrors === null) {
                                                                                            vErrors = [err8];
                                                                                        }
                                                                                        else {
                                                                                            vErrors.push(err8);
                                                                                        }
                                                                                        errors++;
                                                                                    }
                                                                                }
                                                                                var _valid1 = _errs29 === errors;
                                                                                valid6 = valid6 || _valid1;
                                                                                if (!valid6) {
                                                                                    const _errs30 = errors;
                                                                                    if (data8 && typeof data8 == 'object' && !Array.isArray(data8)) {
                                                                                        let missing10;
                                                                                        if (data8.fontSize === undefined && (missing10 = 'fontSize')) {
                                                                                            const err9 = {
                                                                                                instancePath: instancePath + '/columns/' + i0 + '/format',
                                                                                                schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/format/anyOf/5/required',
                                                                                                keyword: 'required',
                                                                                                params: { missingProperty: missing10 },
                                                                                                message: "must have required property '" + missing10 + "'"
                                                                                            };
                                                                                            if (vErrors === null) {
                                                                                                vErrors = [err9];
                                                                                            }
                                                                                            else {
                                                                                                vErrors.push(err9);
                                                                                            }
                                                                                            errors++;
                                                                                        }
                                                                                    }
                                                                                    var _valid1 = _errs30 === errors;
                                                                                    valid6 = valid6 || _valid1;
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                                if (!valid6) {
                                                                    const err10 = {
                                                                        instancePath: instancePath + '/columns/' + i0 + '/format',
                                                                        schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/format/anyOf',
                                                                        keyword: 'anyOf',
                                                                        params: {},
                                                                        message: 'must match a schema in anyOf'
                                                                    };
                                                                    if (vErrors === null) {
                                                                        vErrors = [err10];
                                                                    }
                                                                    else {
                                                                        vErrors.push(err10);
                                                                    }
                                                                    errors++;
                                                                    validate178.errors = vErrors;
                                                                    return false;
                                                                }
                                                                else {
                                                                    errors = _errs24;
                                                                    if (vErrors !== null) {
                                                                        if (_errs24) {
                                                                            vErrors.length = _errs24;
                                                                        }
                                                                        else {
                                                                            vErrors = null;
                                                                        }
                                                                    }
                                                                }
                                                                if (errors === _errs22) {
                                                                    if (data8 && typeof data8 == 'object' && !Array.isArray(data8)) {
                                                                        if (data8.backgroundColor !== undefined) {
                                                                            let data9 = data8.backgroundColor;
                                                                            const _errs31 = errors;
                                                                            if (errors === _errs31) {
                                                                                if (typeof data9 === 'string') {
                                                                                    if (func2(data9) < 1) {
                                                                                        validate178.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/columns/' + i0 + '/format/backgroundColor',
                                                                                                schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/format/properties/backgroundColor/minLength',
                                                                                                keyword: 'minLength',
                                                                                                params: { limit: 1 },
                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate178.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/columns/' + i0 + '/format/backgroundColor',
                                                                                            schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/format/properties/backgroundColor/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid7 = _errs31 === errors;
                                                                        }
                                                                        else {
                                                                            var valid7 = true;
                                                                        }
                                                                        if (valid7) {
                                                                            if (data8.fontColor !== undefined) {
                                                                                let data10 = data8.fontColor;
                                                                                const _errs33 = errors;
                                                                                if (errors === _errs33) {
                                                                                    if (typeof data10 === 'string') {
                                                                                        if (func2(data10) < 1) {
                                                                                            validate178.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/columns/' + i0 + '/format/fontColor',
                                                                                                    schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/format/properties/fontColor/minLength',
                                                                                                    keyword: 'minLength',
                                                                                                    params: { limit: 1 },
                                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate178.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/columns/' + i0 + '/format/fontColor',
                                                                                                schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/format/properties/fontColor/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid7 = _errs33 === errors;
                                                                            }
                                                                            else {
                                                                                var valid7 = true;
                                                                            }
                                                                            if (valid7) {
                                                                                if (data8.bold !== undefined) {
                                                                                    let data11 = data8.bold;
                                                                                    const _errs35 = errors;
                                                                                    if (errors === _errs35) {
                                                                                        if (typeof data11 == 'number') {
                                                                                            if (data11 < 0 || isNaN(data11)) {
                                                                                                validate178.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/columns/' + i0 + '/format/bold',
                                                                                                        schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/format/properties/bold/minimum',
                                                                                                        keyword: 'minimum',
                                                                                                        params: { comparison: '>=', limit: 0 },
                                                                                                        message: 'must be >= 0'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        else {
                                                                                            validate178.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/columns/' + i0 + '/format/bold',
                                                                                                    schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/format/properties/bold/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'number' },
                                                                                                    message: 'must be number'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    var valid7 = _errs35 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid7 = true;
                                                                                }
                                                                                if (valid7) {
                                                                                    if (data8.italics !== undefined) {
                                                                                        const _errs37 = errors;
                                                                                        if (typeof data8.italics !== 'boolean') {
                                                                                            validate178.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/columns/' + i0 + '/format/italics',
                                                                                                    schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/format/properties/italics/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'boolean' },
                                                                                                    message: 'must be boolean'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        var valid7 = _errs37 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid7 = true;
                                                                                    }
                                                                                    if (valid7) {
                                                                                        if (data8.underline !== undefined) {
                                                                                            const _errs39 = errors;
                                                                                            if (typeof data8.underline !== 'boolean') {
                                                                                                validate178.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/columns/' + i0 + '/format/underline',
                                                                                                        schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/format/properties/underline/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'boolean' },
                                                                                                        message: 'must be boolean'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                            var valid7 = _errs39 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid7 = true;
                                                                                        }
                                                                                        if (valid7) {
                                                                                            if (data8.fontSize !== undefined) {
                                                                                                let data14 = data8.fontSize;
                                                                                                const _errs41 = errors;
                                                                                                if (errors === _errs41) {
                                                                                                    if (typeof data14 == 'number') {
                                                                                                        if (data14 < 0 || isNaN(data14)) {
                                                                                                            validate178.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/columns/' + i0 + '/format/fontSize',
                                                                                                                    schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/format/properties/fontSize/minimum',
                                                                                                                    keyword: 'minimum',
                                                                                                                    params: { comparison: '>=', limit: 0 },
                                                                                                                    message: 'must be >= 0'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                    else {
                                                                                                        validate178.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/columns/' + i0 + '/format/fontSize',
                                                                                                                schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/format/properties/fontSize/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'number' },
                                                                                                                message: 'must be number'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                var valid7 = _errs41 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid7 = true;
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate178.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/columns/' + i0 + '/format',
                                                                                schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/format/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'object' },
                                                                                message: 'must be object'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid3 = _errs22 === errors;
                                                            }
                                                            else {
                                                                var valid3 = true;
                                                            }
                                                            if (valid3) {
                                                                if (data1.conditionalFormat !== undefined) {
                                                                    let data15 = data1.conditionalFormat;
                                                                    const _errs43 = errors;
                                                                    if (errors === _errs43) {
                                                                        if (Array.isArray(data15)) {
                                                                            var valid8 = true;
                                                                            const len1 = data15.length;
                                                                            for (let i1 = 0; i1 < len1; i1++) {
                                                                                let data16 = data15[i1];
                                                                                const _errs45 = errors;
                                                                                const _errs47 = errors;
                                                                                let valid9 = false;
                                                                                const _errs48 = errors;
                                                                                if (data16 && typeof data16 == 'object' && !Array.isArray(data16)) {
                                                                                    let missing11;
                                                                                    if (data16.symbol === undefined && (missing11 = 'symbol')) {
                                                                                        const err11 = {
                                                                                            instancePath: instancePath + '/columns/' + i0 + '/conditionalFormat/' + i1,
                                                                                            schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/anyOf/0/required',
                                                                                            keyword: 'required',
                                                                                            params: { missingProperty: missing11 },
                                                                                            message: "must have required property '" + missing11 + "'"
                                                                                        };
                                                                                        if (vErrors === null) {
                                                                                            vErrors = [err11];
                                                                                        }
                                                                                        else {
                                                                                            vErrors.push(err11);
                                                                                        }
                                                                                        errors++;
                                                                                    }
                                                                                }
                                                                                var _valid2 = _errs48 === errors;
                                                                                valid9 = valid9 || _valid2;
                                                                                if (!valid9) {
                                                                                    const _errs49 = errors;
                                                                                    if (data16 && typeof data16 == 'object' && !Array.isArray(data16)) {
                                                                                        let missing12;
                                                                                        if (data16.value === undefined && (missing12 = 'value')) {
                                                                                            const err12 = {
                                                                                                instancePath: instancePath + '/columns/' + i0 + '/conditionalFormat/' + i1,
                                                                                                schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/anyOf/1/required',
                                                                                                keyword: 'required',
                                                                                                params: { missingProperty: missing12 },
                                                                                                message: "must have required property '" + missing12 + "'"
                                                                                            };
                                                                                            if (vErrors === null) {
                                                                                                vErrors = [err12];
                                                                                            }
                                                                                            else {
                                                                                                vErrors.push(err12);
                                                                                            }
                                                                                            errors++;
                                                                                        }
                                                                                    }
                                                                                    var _valid2 = _errs49 === errors;
                                                                                    valid9 = valid9 || _valid2;
                                                                                }
                                                                                if (!valid9) {
                                                                                    const err13 = {
                                                                                        instancePath: instancePath + '/columns/' + i0 + '/conditionalFormat/' + i1,
                                                                                        schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/anyOf',
                                                                                        keyword: 'anyOf',
                                                                                        params: {},
                                                                                        message: 'must match a schema in anyOf'
                                                                                    };
                                                                                    if (vErrors === null) {
                                                                                        vErrors = [err13];
                                                                                    }
                                                                                    else {
                                                                                        vErrors.push(err13);
                                                                                    }
                                                                                    errors++;
                                                                                    validate178.errors = vErrors;
                                                                                    return false;
                                                                                }
                                                                                else {
                                                                                    errors = _errs47;
                                                                                    if (vErrors !== null) {
                                                                                        if (_errs47) {
                                                                                            vErrors.length = _errs47;
                                                                                        }
                                                                                        else {
                                                                                            vErrors = null;
                                                                                        }
                                                                                    }
                                                                                }
                                                                                if (errors === _errs45) {
                                                                                    if (data16 && typeof data16 == 'object' && !Array.isArray(data16)) {
                                                                                        if (data16.symbol !== undefined) {
                                                                                            let data17 = data16.symbol;
                                                                                            const _errs50 = errors;
                                                                                            if (errors === _errs50) {
                                                                                                if (typeof data17 === 'string') {
                                                                                                    if (func2(data17) < 1) {
                                                                                                        validate178.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath +
                                                                                                                    '/columns/' +
                                                                                                                    i0 +
                                                                                                                    '/conditionalFormat/' +
                                                                                                                    i1 +
                                                                                                                    '/symbol',
                                                                                                                schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/properties/symbol/minLength',
                                                                                                                keyword: 'minLength',
                                                                                                                params: { limit: 1 },
                                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    validate178.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath +
                                                                                                                '/columns/' +
                                                                                                                i0 +
                                                                                                                '/conditionalFormat/' +
                                                                                                                i1 +
                                                                                                                '/symbol',
                                                                                                            schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/properties/symbol/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'string' },
                                                                                                            message: 'must be string'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            var valid10 = _errs50 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid10 = true;
                                                                                        }
                                                                                        if (valid10) {
                                                                                            if (data16.value !== undefined) {
                                                                                                const _errs52 = errors;
                                                                                                if (!(typeof data16.value == 'number')) {
                                                                                                    validate178.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath +
                                                                                                                '/columns/' +
                                                                                                                i0 +
                                                                                                                '/conditionalFormat/' +
                                                                                                                i1 +
                                                                                                                '/value',
                                                                                                            schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/properties/value/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'number' },
                                                                                                            message: 'must be number'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                                var valid10 = _errs52 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid10 = true;
                                                                                            }
                                                                                            if (valid10) {
                                                                                                if (data16.logic !== undefined) {
                                                                                                    const _errs54 = errors;
                                                                                                    if (typeof data16.logic !== 'string') {
                                                                                                        validate178.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath +
                                                                                                                    '/columns/' +
                                                                                                                    i0 +
                                                                                                                    '/conditionalFormat/' +
                                                                                                                    i1 +
                                                                                                                    '/logic',
                                                                                                                schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/properties/logic/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'string' },
                                                                                                                message: 'must be string'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    var valid10 = _errs54 === errors;
                                                                                                }
                                                                                                else {
                                                                                                    var valid10 = true;
                                                                                                }
                                                                                                if (valid10) {
                                                                                                    if (data16.logicSymbol !== undefined) {
                                                                                                        let data20 = data16.logicSymbol;
                                                                                                        const _errs56 = errors;
                                                                                                        if (errors === _errs56) {
                                                                                                            if (typeof data20 === 'string') {
                                                                                                                if (func2(data20) < 0) {
                                                                                                                    validate178.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath +
                                                                                                                                '/columns/' +
                                                                                                                                i0 +
                                                                                                                                '/conditionalFormat/' +
                                                                                                                                i1 +
                                                                                                                                '/logicSymbol',
                                                                                                                            schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/properties/logicSymbol/minLength',
                                                                                                                            keyword: 'minLength',
                                                                                                                            params: { limit: 0 },
                                                                                                                            message: 'must NOT have fewer than 0 characters'
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                            }
                                                                                                            else {
                                                                                                                validate178.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath +
                                                                                                                            '/columns/' +
                                                                                                                            i0 +
                                                                                                                            '/conditionalFormat/' +
                                                                                                                            i1 +
                                                                                                                            '/logicSymbol',
                                                                                                                        schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/properties/logicSymbol/type',
                                                                                                                        keyword: 'type',
                                                                                                                        params: { type: 'string' },
                                                                                                                        message: 'must be string'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                        }
                                                                                                        var valid10 = _errs56 === errors;
                                                                                                    }
                                                                                                    else {
                                                                                                        var valid10 = true;
                                                                                                    }
                                                                                                    if (valid10) {
                                                                                                        if (data16.logicValue !== undefined) {
                                                                                                            const _errs58 = errors;
                                                                                                            if (!(typeof data16.logicValue == 'number')) {
                                                                                                                validate178.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath +
                                                                                                                            '/columns/' +
                                                                                                                            i0 +
                                                                                                                            '/conditionalFormat/' +
                                                                                                                            i1 +
                                                                                                                            '/logicValue',
                                                                                                                        schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/properties/logicValue/type',
                                                                                                                        keyword: 'type',
                                                                                                                        params: { type: 'number' },
                                                                                                                        message: 'must be number'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                            var valid10 = _errs58 === errors;
                                                                                                        }
                                                                                                        else {
                                                                                                            var valid10 = true;
                                                                                                        }
                                                                                                        if (valid10) {
                                                                                                            if (data16.format !== undefined) {
                                                                                                                let data22 = data16.format;
                                                                                                                const _errs60 = errors;
                                                                                                                const _errs62 = errors;
                                                                                                                let valid11 = false;
                                                                                                                const _errs63 = errors;
                                                                                                                if (data22 &&
                                                                                                                    typeof data22 == 'object' &&
                                                                                                                    !Array.isArray(data22)) {
                                                                                                                    let missing13;
                                                                                                                    if (data22.backgroundColor === undefined &&
                                                                                                                        (missing13 = 'backgroundColor')) {
                                                                                                                        const err14 = {
                                                                                                                            instancePath: instancePath +
                                                                                                                                '/columns/' +
                                                                                                                                i0 +
                                                                                                                                '/conditionalFormat/' +
                                                                                                                                i1 +
                                                                                                                                '/format',
                                                                                                                            schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/properties/format/anyOf/0/required',
                                                                                                                            keyword: 'required',
                                                                                                                            params: { missingProperty: missing13 },
                                                                                                                            message: "must have required property '" + missing13 + "'"
                                                                                                                        };
                                                                                                                        if (vErrors === null) {
                                                                                                                            vErrors = [err14];
                                                                                                                        }
                                                                                                                        else {
                                                                                                                            vErrors.push(err14);
                                                                                                                        }
                                                                                                                        errors++;
                                                                                                                    }
                                                                                                                }
                                                                                                                var _valid3 = _errs63 === errors;
                                                                                                                valid11 = valid11 || _valid3;
                                                                                                                if (!valid11) {
                                                                                                                    const _errs64 = errors;
                                                                                                                    if (data22 &&
                                                                                                                        typeof data22 == 'object' &&
                                                                                                                        !Array.isArray(data22)) {
                                                                                                                        let missing14;
                                                                                                                        if (data22.fontColor === undefined &&
                                                                                                                            (missing14 = 'fontColor')) {
                                                                                                                            const err15 = {
                                                                                                                                instancePath: instancePath +
                                                                                                                                    '/columns/' +
                                                                                                                                    i0 +
                                                                                                                                    '/conditionalFormat/' +
                                                                                                                                    i1 +
                                                                                                                                    '/format',
                                                                                                                                schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/properties/format/anyOf/1/required',
                                                                                                                                keyword: 'required',
                                                                                                                                params: { missingProperty: missing14 },
                                                                                                                                message: "must have required property '" + missing14 + "'"
                                                                                                                            };
                                                                                                                            if (vErrors === null) {
                                                                                                                                vErrors = [err15];
                                                                                                                            }
                                                                                                                            else {
                                                                                                                                vErrors.push(err15);
                                                                                                                            }
                                                                                                                            errors++;
                                                                                                                        }
                                                                                                                    }
                                                                                                                    var _valid3 = _errs64 === errors;
                                                                                                                    valid11 = valid11 || _valid3;
                                                                                                                    if (!valid11) {
                                                                                                                        const _errs65 = errors;
                                                                                                                        if (data22 &&
                                                                                                                            typeof data22 == 'object' &&
                                                                                                                            !Array.isArray(data22)) {
                                                                                                                            let missing15;
                                                                                                                            if (data22.bold === undefined && (missing15 = 'bold')) {
                                                                                                                                const err16 = {
                                                                                                                                    instancePath: instancePath +
                                                                                                                                        '/columns/' +
                                                                                                                                        i0 +
                                                                                                                                        '/conditionalFormat/' +
                                                                                                                                        i1 +
                                                                                                                                        '/format',
                                                                                                                                    schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/properties/format/anyOf/2/required',
                                                                                                                                    keyword: 'required',
                                                                                                                                    params: { missingProperty: missing15 },
                                                                                                                                    message: "must have required property '" + missing15 + "'"
                                                                                                                                };
                                                                                                                                if (vErrors === null) {
                                                                                                                                    vErrors = [err16];
                                                                                                                                }
                                                                                                                                else {
                                                                                                                                    vErrors.push(err16);
                                                                                                                                }
                                                                                                                                errors++;
                                                                                                                            }
                                                                                                                        }
                                                                                                                        var _valid3 = _errs65 === errors;
                                                                                                                        valid11 = valid11 || _valid3;
                                                                                                                        if (!valid11) {
                                                                                                                            const _errs66 = errors;
                                                                                                                            if (data22 &&
                                                                                                                                typeof data22 == 'object' &&
                                                                                                                                !Array.isArray(data22)) {
                                                                                                                                let missing16;
                                                                                                                                if (data22.italics === undefined &&
                                                                                                                                    (missing16 = 'italics')) {
                                                                                                                                    const err17 = {
                                                                                                                                        instancePath: instancePath +
                                                                                                                                            '/columns/' +
                                                                                                                                            i0 +
                                                                                                                                            '/conditionalFormat/' +
                                                                                                                                            i1 +
                                                                                                                                            '/format',
                                                                                                                                        schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/properties/format/anyOf/3/required',
                                                                                                                                        keyword: 'required',
                                                                                                                                        params: { missingProperty: missing16 },
                                                                                                                                        message: "must have required property '" + missing16 + "'"
                                                                                                                                    };
                                                                                                                                    if (vErrors === null) {
                                                                                                                                        vErrors = [err17];
                                                                                                                                    }
                                                                                                                                    else {
                                                                                                                                        vErrors.push(err17);
                                                                                                                                    }
                                                                                                                                    errors++;
                                                                                                                                }
                                                                                                                            }
                                                                                                                            var _valid3 = _errs66 === errors;
                                                                                                                            valid11 = valid11 || _valid3;
                                                                                                                            if (!valid11) {
                                                                                                                                const _errs67 = errors;
                                                                                                                                if (data22 &&
                                                                                                                                    typeof data22 == 'object' &&
                                                                                                                                    !Array.isArray(data22)) {
                                                                                                                                    let missing17;
                                                                                                                                    if (data22.underline === undefined &&
                                                                                                                                        (missing17 = 'underline')) {
                                                                                                                                        const err18 = {
                                                                                                                                            instancePath: instancePath +
                                                                                                                                                '/columns/' +
                                                                                                                                                i0 +
                                                                                                                                                '/conditionalFormat/' +
                                                                                                                                                i1 +
                                                                                                                                                '/format',
                                                                                                                                            schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/properties/format/anyOf/4/required',
                                                                                                                                            keyword: 'required',
                                                                                                                                            params: { missingProperty: missing17 },
                                                                                                                                            message: "must have required property '" +
                                                                                                                                                missing17 +
                                                                                                                                                "'"
                                                                                                                                        };
                                                                                                                                        if (vErrors === null) {
                                                                                                                                            vErrors = [err18];
                                                                                                                                        }
                                                                                                                                        else {
                                                                                                                                            vErrors.push(err18);
                                                                                                                                        }
                                                                                                                                        errors++;
                                                                                                                                    }
                                                                                                                                }
                                                                                                                                var _valid3 = _errs67 === errors;
                                                                                                                                valid11 = valid11 || _valid3;
                                                                                                                                if (!valid11) {
                                                                                                                                    const _errs68 = errors;
                                                                                                                                    if (data22 &&
                                                                                                                                        typeof data22 == 'object' &&
                                                                                                                                        !Array.isArray(data22)) {
                                                                                                                                        let missing18;
                                                                                                                                        if (data22.fontSize === undefined &&
                                                                                                                                            (missing18 = 'fontSize')) {
                                                                                                                                            const err19 = {
                                                                                                                                                instancePath: instancePath +
                                                                                                                                                    '/columns/' +
                                                                                                                                                    i0 +
                                                                                                                                                    '/conditionalFormat/' +
                                                                                                                                                    i1 +
                                                                                                                                                    '/format',
                                                                                                                                                schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/properties/format/anyOf/5/required',
                                                                                                                                                keyword: 'required',
                                                                                                                                                params: { missingProperty: missing18 },
                                                                                                                                                message: "must have required property '" +
                                                                                                                                                    missing18 +
                                                                                                                                                    "'"
                                                                                                                                            };
                                                                                                                                            if (vErrors === null) {
                                                                                                                                                vErrors = [err19];
                                                                                                                                            }
                                                                                                                                            else {
                                                                                                                                                vErrors.push(err19);
                                                                                                                                            }
                                                                                                                                            errors++;
                                                                                                                                        }
                                                                                                                                    }
                                                                                                                                    var _valid3 = _errs68 === errors;
                                                                                                                                    valid11 = valid11 || _valid3;
                                                                                                                                }
                                                                                                                            }
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                                if (!valid11) {
                                                                                                                    const err20 = {
                                                                                                                        instancePath: instancePath +
                                                                                                                            '/columns/' +
                                                                                                                            i0 +
                                                                                                                            '/conditionalFormat/' +
                                                                                                                            i1 +
                                                                                                                            '/format',
                                                                                                                        schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/properties/format/anyOf',
                                                                                                                        keyword: 'anyOf',
                                                                                                                        params: {},
                                                                                                                        message: 'must match a schema in anyOf'
                                                                                                                    };
                                                                                                                    if (vErrors === null) {
                                                                                                                        vErrors = [err20];
                                                                                                                    }
                                                                                                                    else {
                                                                                                                        vErrors.push(err20);
                                                                                                                    }
                                                                                                                    errors++;
                                                                                                                    validate178.errors = vErrors;
                                                                                                                    return false;
                                                                                                                }
                                                                                                                else {
                                                                                                                    errors = _errs62;
                                                                                                                    if (vErrors !== null) {
                                                                                                                        if (_errs62) {
                                                                                                                            vErrors.length = _errs62;
                                                                                                                        }
                                                                                                                        else {
                                                                                                                            vErrors = null;
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                                if (errors === _errs60) {
                                                                                                                    if (data22 &&
                                                                                                                        typeof data22 == 'object' &&
                                                                                                                        !Array.isArray(data22)) {
                                                                                                                        if (data22.backgroundColor !== undefined) {
                                                                                                                            let data23 = data22.backgroundColor;
                                                                                                                            const _errs69 = errors;
                                                                                                                            if (errors === _errs69) {
                                                                                                                                if (typeof data23 === 'string') {
                                                                                                                                    if (func2(data23) < 1) {
                                                                                                                                        validate178.errors = [
                                                                                                                                            {
                                                                                                                                                instancePath: instancePath +
                                                                                                                                                    '/columns/' +
                                                                                                                                                    i0 +
                                                                                                                                                    '/conditionalFormat/' +
                                                                                                                                                    i1 +
                                                                                                                                                    '/format/backgroundColor',
                                                                                                                                                schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/properties/format/properties/backgroundColor/minLength',
                                                                                                                                                keyword: 'minLength',
                                                                                                                                                params: { limit: 1 },
                                                                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                                                                            }
                                                                                                                                        ];
                                                                                                                                        return false;
                                                                                                                                    }
                                                                                                                                }
                                                                                                                                else {
                                                                                                                                    validate178.errors = [
                                                                                                                                        {
                                                                                                                                            instancePath: instancePath +
                                                                                                                                                '/columns/' +
                                                                                                                                                i0 +
                                                                                                                                                '/conditionalFormat/' +
                                                                                                                                                i1 +
                                                                                                                                                '/format/backgroundColor',
                                                                                                                                            schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/properties/format/properties/backgroundColor/type',
                                                                                                                                            keyword: 'type',
                                                                                                                                            params: { type: 'string' },
                                                                                                                                            message: 'must be string'
                                                                                                                                        }
                                                                                                                                    ];
                                                                                                                                    return false;
                                                                                                                                }
                                                                                                                            }
                                                                                                                            var valid12 = _errs69 === errors;
                                                                                                                        }
                                                                                                                        else {
                                                                                                                            var valid12 = true;
                                                                                                                        }
                                                                                                                        if (valid12) {
                                                                                                                            if (data22.fontColor !== undefined) {
                                                                                                                                let data24 = data22.fontColor;
                                                                                                                                const _errs71 = errors;
                                                                                                                                if (errors === _errs71) {
                                                                                                                                    if (typeof data24 === 'string') {
                                                                                                                                        if (func2(data24) < 1) {
                                                                                                                                            validate178.errors = [
                                                                                                                                                {
                                                                                                                                                    instancePath: instancePath +
                                                                                                                                                        '/columns/' +
                                                                                                                                                        i0 +
                                                                                                                                                        '/conditionalFormat/' +
                                                                                                                                                        i1 +
                                                                                                                                                        '/format/fontColor',
                                                                                                                                                    schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/properties/format/properties/fontColor/minLength',
                                                                                                                                                    keyword: 'minLength',
                                                                                                                                                    params: { limit: 1 },
                                                                                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                                                                                }
                                                                                                                                            ];
                                                                                                                                            return false;
                                                                                                                                        }
                                                                                                                                    }
                                                                                                                                    else {
                                                                                                                                        validate178.errors = [
                                                                                                                                            {
                                                                                                                                                instancePath: instancePath +
                                                                                                                                                    '/columns/' +
                                                                                                                                                    i0 +
                                                                                                                                                    '/conditionalFormat/' +
                                                                                                                                                    i1 +
                                                                                                                                                    '/format/fontColor',
                                                                                                                                                schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/properties/format/properties/fontColor/type',
                                                                                                                                                keyword: 'type',
                                                                                                                                                params: { type: 'string' },
                                                                                                                                                message: 'must be string'
                                                                                                                                            }
                                                                                                                                        ];
                                                                                                                                        return false;
                                                                                                                                    }
                                                                                                                                }
                                                                                                                                var valid12 = _errs71 === errors;
                                                                                                                            }
                                                                                                                            else {
                                                                                                                                var valid12 = true;
                                                                                                                            }
                                                                                                                            if (valid12) {
                                                                                                                                if (data22.bold !== undefined) {
                                                                                                                                    let data25 = data22.bold;
                                                                                                                                    const _errs73 = errors;
                                                                                                                                    if (errors === _errs73) {
                                                                                                                                        if (typeof data25 == 'number') {
                                                                                                                                            if (data25 < 0 || isNaN(data25)) {
                                                                                                                                                validate178.errors = [
                                                                                                                                                    {
                                                                                                                                                        instancePath: instancePath +
                                                                                                                                                            '/columns/' +
                                                                                                                                                            i0 +
                                                                                                                                                            '/conditionalFormat/' +
                                                                                                                                                            i1 +
                                                                                                                                                            '/format/bold',
                                                                                                                                                        schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/properties/format/properties/bold/minimum',
                                                                                                                                                        keyword: 'minimum',
                                                                                                                                                        params: { comparison: '>=', limit: 0 },
                                                                                                                                                        message: 'must be >= 0'
                                                                                                                                                    }
                                                                                                                                                ];
                                                                                                                                                return false;
                                                                                                                                            }
                                                                                                                                        }
                                                                                                                                        else {
                                                                                                                                            validate178.errors = [
                                                                                                                                                {
                                                                                                                                                    instancePath: instancePath +
                                                                                                                                                        '/columns/' +
                                                                                                                                                        i0 +
                                                                                                                                                        '/conditionalFormat/' +
                                                                                                                                                        i1 +
                                                                                                                                                        '/format/bold',
                                                                                                                                                    schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/properties/format/properties/bold/type',
                                                                                                                                                    keyword: 'type',
                                                                                                                                                    params: { type: 'number' },
                                                                                                                                                    message: 'must be number'
                                                                                                                                                }
                                                                                                                                            ];
                                                                                                                                            return false;
                                                                                                                                        }
                                                                                                                                    }
                                                                                                                                    var valid12 = _errs73 === errors;
                                                                                                                                }
                                                                                                                                else {
                                                                                                                                    var valid12 = true;
                                                                                                                                }
                                                                                                                                if (valid12) {
                                                                                                                                    if (data22.italics !== undefined) {
                                                                                                                                        const _errs75 = errors;
                                                                                                                                        if (typeof data22.italics !== 'boolean') {
                                                                                                                                            validate178.errors = [
                                                                                                                                                {
                                                                                                                                                    instancePath: instancePath +
                                                                                                                                                        '/columns/' +
                                                                                                                                                        i0 +
                                                                                                                                                        '/conditionalFormat/' +
                                                                                                                                                        i1 +
                                                                                                                                                        '/format/italics',
                                                                                                                                                    schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/properties/format/properties/italics/type',
                                                                                                                                                    keyword: 'type',
                                                                                                                                                    params: { type: 'boolean' },
                                                                                                                                                    message: 'must be boolean'
                                                                                                                                                }
                                                                                                                                            ];
                                                                                                                                            return false;
                                                                                                                                        }
                                                                                                                                        var valid12 = _errs75 === errors;
                                                                                                                                    }
                                                                                                                                    else {
                                                                                                                                        var valid12 = true;
                                                                                                                                    }
                                                                                                                                    if (valid12) {
                                                                                                                                        if (data22.underline !== undefined) {
                                                                                                                                            const _errs77 = errors;
                                                                                                                                            if (typeof data22.underline !== 'boolean') {
                                                                                                                                                validate178.errors = [
                                                                                                                                                    {
                                                                                                                                                        instancePath: instancePath +
                                                                                                                                                            '/columns/' +
                                                                                                                                                            i0 +
                                                                                                                                                            '/conditionalFormat/' +
                                                                                                                                                            i1 +
                                                                                                                                                            '/format/underline',
                                                                                                                                                        schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/properties/format/properties/underline/type',
                                                                                                                                                        keyword: 'type',
                                                                                                                                                        params: { type: 'boolean' },
                                                                                                                                                        message: 'must be boolean'
                                                                                                                                                    }
                                                                                                                                                ];
                                                                                                                                                return false;
                                                                                                                                            }
                                                                                                                                            var valid12 = _errs77 === errors;
                                                                                                                                        }
                                                                                                                                        else {
                                                                                                                                            var valid12 = true;
                                                                                                                                        }
                                                                                                                                        if (valid12) {
                                                                                                                                            if (data22.fontSize !== undefined) {
                                                                                                                                                let data28 = data22.fontSize;
                                                                                                                                                const _errs79 = errors;
                                                                                                                                                if (errors === _errs79) {
                                                                                                                                                    if (typeof data28 == 'number') {
                                                                                                                                                        if (data28 < 0 || isNaN(data28)) {
                                                                                                                                                            validate178.errors = [
                                                                                                                                                                {
                                                                                                                                                                    instancePath: instancePath +
                                                                                                                                                                        '/columns/' +
                                                                                                                                                                        i0 +
                                                                                                                                                                        '/conditionalFormat/' +
                                                                                                                                                                        i1 +
                                                                                                                                                                        '/format/fontSize',
                                                                                                                                                                    schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/properties/format/properties/fontSize/minimum',
                                                                                                                                                                    keyword: 'minimum',
                                                                                                                                                                    params: {
                                                                                                                                                                        comparison: '>=',
                                                                                                                                                                        limit: 0
                                                                                                                                                                    },
                                                                                                                                                                    message: 'must be >= 0'
                                                                                                                                                                }
                                                                                                                                                            ];
                                                                                                                                                            return false;
                                                                                                                                                        }
                                                                                                                                                    }
                                                                                                                                                    else {
                                                                                                                                                        validate178.errors = [
                                                                                                                                                            {
                                                                                                                                                                instancePath: instancePath +
                                                                                                                                                                    '/columns/' +
                                                                                                                                                                    i0 +
                                                                                                                                                                    '/conditionalFormat/' +
                                                                                                                                                                    i1 +
                                                                                                                                                                    '/format/fontSize',
                                                                                                                                                                schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/properties/format/properties/fontSize/type',
                                                                                                                                                                keyword: 'type',
                                                                                                                                                                params: { type: 'number' },
                                                                                                                                                                message: 'must be number'
                                                                                                                                                            }
                                                                                                                                                        ];
                                                                                                                                                        return false;
                                                                                                                                                    }
                                                                                                                                                }
                                                                                                                                                var valid12 = _errs79 === errors;
                                                                                                                                            }
                                                                                                                                            else {
                                                                                                                                                var valid12 = true;
                                                                                                                                            }
                                                                                                                                        }
                                                                                                                                    }
                                                                                                                                }
                                                                                                                            }
                                                                                                                        }
                                                                                                                    }
                                                                                                                    else {
                                                                                                                        validate178.errors = [
                                                                                                                            {
                                                                                                                                instancePath: instancePath +
                                                                                                                                    '/columns/' +
                                                                                                                                    i0 +
                                                                                                                                    '/conditionalFormat/' +
                                                                                                                                    i1 +
                                                                                                                                    '/format',
                                                                                                                                schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/properties/format/type',
                                                                                                                                keyword: 'type',
                                                                                                                                params: { type: 'object' },
                                                                                                                                message: 'must be object'
                                                                                                                            }
                                                                                                                        ];
                                                                                                                        return false;
                                                                                                                    }
                                                                                                                }
                                                                                                                var valid10 = _errs60 === errors;
                                                                                                            }
                                                                                                            else {
                                                                                                                var valid10 = true;
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate178.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/columns/' + i0 + '/conditionalFormat/' + i1,
                                                                                                schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/items/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'object' },
                                                                                                message: 'must be object'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid8 = _errs45 === errors;
                                                                                if (!valid8) {
                                                                                    break;
                                                                                }
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate178.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/columns/' + i0 + '/conditionalFormat',
                                                                                    schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/conditionalFormat/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'array' },
                                                                                    message: 'must be array'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid3 = _errs43 === errors;
                                                                }
                                                                else {
                                                                    var valid3 = true;
                                                                }
                                                                if (valid3) {
                                                                    if (data1.dateFormat !== undefined) {
                                                                        let data29 = data1.dateFormat;
                                                                        const _errs81 = errors;
                                                                        if (typeof data29 !== 'string') {
                                                                            validate178.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/columns/' + i0 + '/dateFormat',
                                                                                    schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/dateFormat/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        if (!(data29 === 'fullDateAndTime' ||
                                                                            data29 === 'longDate' ||
                                                                            data29 === 'shortDate' ||
                                                                            data29 === 'time' ||
                                                                            data29 === 'shortMonth' ||
                                                                            data29 === 'none')) {
                                                                            validate178.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/columns/' + i0 + '/dateFormat',
                                                                                    schemaPath: 'urn:wisepipe-common-computation:TableColumn/properties/dateFormat/enum',
                                                                                    keyword: 'enum',
                                                                                    params: { allowedValues: schema190.properties.dateFormat.enum },
                                                                                    message: 'must be equal to one of the allowed values'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        var valid3 = _errs81 === errors;
                                                                    }
                                                                    else {
                                                                        var valid3 = true;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate178.errors = [
                                                {
                                                    instancePath: instancePath + '/columns/' + i0,
                                                    schemaPath: 'urn:wisepipe-common-computation:TableColumn/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs3 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    const keys0 = schema191.properties.columns.uniqueItemProperties;
                                    let k0;
                                    let i2 = data0.length;
                                    let j0;
                                    if (i2 > 1) {
                                        outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                            let key0 = keys0[k0];
                                            for (i2 = data0.length; i2--;) {
                                                let x0 = data0[i2];
                                                if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                    continue;
                                                }
                                                for (j0 = i2; j0--;) {
                                                    let y0 = data0[j0];
                                                    if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func491(x0[key0], y0[key0])) {
                                                        validate178.errors = [
                                                            {
                                                                instancePath: instancePath + '/columns',
                                                                schemaPath: '#/properties/columns/uniqueItemProperties',
                                                                keyword: 'uniqueItemProperties',
                                                                params: {},
                                                                message: 'must pass "uniqueItemProperties" keyword validation'
                                                            }
                                                        ];
                                                        return false;
                                                        break outer0;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate178.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate178.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate178.errors = vErrors;
    return errors === 0;
}
export const textColumnInfoSchemaValidation = validate179;
const schema193 = {
    $id: 'urn:wisepipe-common-computation:TextColumnInfo',
    type: 'object',
    properties: {
        missing: { type: 'number' },
        unique: { type: 'number' },
        topValues: { type: 'array', items: { $ref: 'urn:wisepipe-common-computation:ValueCountPair' } }
    },
    required: ['missing']
};
function validate179(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:TextColumnInfo" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.missing === undefined && (missing0 = 'missing')) {
                validate179.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.missing !== undefined) {
                    const _errs1 = errors;
                    if (!(typeof data.missing == 'number')) {
                        validate179.errors = [
                            {
                                instancePath: instancePath + '/missing',
                                schemaPath: '#/properties/missing/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.unique !== undefined) {
                        const _errs3 = errors;
                        if (!(typeof data.unique == 'number')) {
                            validate179.errors = [
                                {
                                    instancePath: instancePath + '/unique',
                                    schemaPath: '#/properties/unique/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.topValues !== undefined) {
                            let data2 = data.topValues;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (Array.isArray(data2)) {
                                    var valid1 = true;
                                    const len0 = data2.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data3 = data2[i0];
                                        const _errs7 = errors;
                                        const _errs8 = errors;
                                        if (errors === _errs8) {
                                            if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                                                let missing1;
                                                if ((data3.value === undefined && (missing1 = 'value')) ||
                                                    (data3.count === undefined && (missing1 = 'count'))) {
                                                    validate179.errors = [
                                                        {
                                                            instancePath: instancePath + '/topValues/' + i0,
                                                            schemaPath: 'urn:wisepipe-common-computation:ValueCountPair/required',
                                                            keyword: 'required',
                                                            params: { missingProperty: missing1 },
                                                            message: "must have required property '" + missing1 + "'"
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (data3.value !== undefined) {
                                                        let data4 = data3.value;
                                                        const _errs10 = errors;
                                                        const _errs11 = errors;
                                                        let valid4 = false;
                                                        let passing0 = null;
                                                        const _errs12 = errors;
                                                        if (typeof data4 !== 'string') {
                                                            const err0 = {
                                                                instancePath: instancePath + '/topValues/' + i0 + '/value',
                                                                schemaPath: 'urn:wisepipe-common-computation:ValueCountPair/properties/value/oneOf/0/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err0];
                                                            }
                                                            else {
                                                                vErrors.push(err0);
                                                            }
                                                            errors++;
                                                        }
                                                        var _valid0 = _errs12 === errors;
                                                        if (_valid0) {
                                                            valid4 = true;
                                                            passing0 = 0;
                                                        }
                                                        const _errs14 = errors;
                                                        if (typeof data4 !== 'boolean') {
                                                            const err1 = {
                                                                instancePath: instancePath + '/topValues/' + i0 + '/value',
                                                                schemaPath: 'urn:wisepipe-common-computation:ValueCountPair/properties/value/oneOf/1/type',
                                                                keyword: 'type',
                                                                params: { type: 'boolean' },
                                                                message: 'must be boolean'
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err1];
                                                            }
                                                            else {
                                                                vErrors.push(err1);
                                                            }
                                                            errors++;
                                                        }
                                                        var _valid0 = _errs14 === errors;
                                                        if (_valid0 && valid4) {
                                                            valid4 = false;
                                                            passing0 = [passing0, 1];
                                                        }
                                                        else {
                                                            if (_valid0) {
                                                                valid4 = true;
                                                                passing0 = 1;
                                                            }
                                                        }
                                                        if (!valid4) {
                                                            const err2 = {
                                                                instancePath: instancePath + '/topValues/' + i0 + '/value',
                                                                schemaPath: 'urn:wisepipe-common-computation:ValueCountPair/properties/value/oneOf',
                                                                keyword: 'oneOf',
                                                                params: { passingSchemas: passing0 },
                                                                message: 'must match exactly one schema in oneOf'
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err2];
                                                            }
                                                            else {
                                                                vErrors.push(err2);
                                                            }
                                                            errors++;
                                                            validate179.errors = vErrors;
                                                            return false;
                                                        }
                                                        else {
                                                            errors = _errs11;
                                                            if (vErrors !== null) {
                                                                if (_errs11) {
                                                                    vErrors.length = _errs11;
                                                                }
                                                                else {
                                                                    vErrors = null;
                                                                }
                                                            }
                                                        }
                                                        var valid3 = _errs10 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                    if (valid3) {
                                                        if (data3.count !== undefined) {
                                                            const _errs16 = errors;
                                                            if (!(typeof data3.count == 'number')) {
                                                                validate179.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/topValues/' + i0 + '/count',
                                                                        schemaPath: 'urn:wisepipe-common-computation:ValueCountPair/properties/count/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'number' },
                                                                        message: 'must be number'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid3 = _errs16 === errors;
                                                        }
                                                        else {
                                                            var valid3 = true;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate179.errors = [
                                                    {
                                                        instancePath: instancePath + '/topValues/' + i0,
                                                        schemaPath: 'urn:wisepipe-common-computation:ValueCountPair/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid1 = _errs7 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate179.errors = [
                                        {
                                            instancePath: instancePath + '/topValues',
                                            schemaPath: '#/properties/topValues/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate179.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate179.errors = vErrors;
    return errors === 0;
}
export const transientConfigSchemaValidation = validate143;
export const transientDataConfigSchemaValidation = validate144;
export const transientPipeCalcOutputSchemaValidation = validate180;
const schema195 = {
    $id: 'urn:wisepipe-common-computation:TransientPipeCalcOutput',
    type: 'object',
    properties: {
        elementID: { type: 'string', uid: 10 },
        outputName: { type: 'string', minLength: 1 },
        s3loc: { $ref: 'urn:wisepipe-common:S3File' },
        transientPipeExport: { $ref: 'urn:wisepipe-common-export:TransientPipeExport' }
    },
    required: ['elementID', 's3loc', 'outputName', 'transientPipeExport']
};
const func492 = ucs2length;
const func493 = base64urlToBuffer;
const func494 = base64urlEncode;
const func495 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func499 = ucs2length;
const func500 = base64urlToBuffer;
const func501 = base64urlEncode;
const func502 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate180(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:TransientPipeCalcOutput" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.elementID === undefined && (missing0 = 'elementID')) ||
                (data.s3loc === undefined && (missing0 = 's3loc')) ||
                (data.outputName === undefined && (missing0 = 'outputName')) ||
                (data.transientPipeExport === undefined && (missing0 = 'transientPipeExport'))) {
                validate180.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.elementID !== undefined) {
                    let data0 = data.elementID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func492(data0) < b64min0 || func492(data0) > b64max0) {
                                validate180.errors = [
                                    {
                                        instancePath: instancePath + '/elementID',
                                        schemaPath: '#/properties/elementID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func492(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func492(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func493(data0);
                                if (decoded0.length !== 10) {
                                    validate180.errors = [
                                        {
                                            instancePath: instancePath + '/elementID',
                                            schemaPath: '#/properties/elementID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func494(decoded0);
                                    if (func495(encoded0) !== func495(data0)) {
                                        validate180.errors = [
                                            {
                                                instancePath: instancePath + '/elementID',
                                                schemaPath: '#/properties/elementID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate180.errors = [
                                {
                                    instancePath: instancePath + '/elementID',
                                    schemaPath: '#/properties/elementID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.outputName !== undefined) {
                        let data1 = data.outputName;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate180.errors = [
                                        {
                                            instancePath: instancePath + '/outputName',
                                            schemaPath: '#/properties/outputName/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate180.errors = [
                                    {
                                        instancePath: instancePath + '/outputName',
                                        schemaPath: '#/properties/outputName/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.s3loc !== undefined) {
                            let data2 = data.s3loc;
                            const _errs5 = errors;
                            const _errs6 = errors;
                            if (errors === _errs6) {
                                if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                    let missing1;
                                    if ((data2.bucket === undefined && (missing1 = 'bucket')) ||
                                        (data2.key === undefined && (missing1 = 'key'))) {
                                        validate180.errors = [
                                            {
                                                instancePath: instancePath + '/s3loc',
                                                schemaPath: 'urn:wisepipe-common:S3File/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing1 },
                                                message: "must have required property '" + missing1 + "'"
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (data2.bucket !== undefined) {
                                            let data3 = data2.bucket;
                                            const _errs8 = errors;
                                            if (errors === _errs8) {
                                                if (typeof data3 === 'string') {
                                                    if (func2(data3) < 1) {
                                                        validate180.errors = [
                                                            {
                                                                instancePath: instancePath + '/s3loc/bucket',
                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate180.errors = [
                                                        {
                                                            instancePath: instancePath + '/s3loc/bucket',
                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid3 = _errs8 === errors;
                                        }
                                        else {
                                            var valid3 = true;
                                        }
                                        if (valid3) {
                                            if (data2.key !== undefined) {
                                                let data4 = data2.key;
                                                const _errs10 = errors;
                                                if (errors === _errs10) {
                                                    if (typeof data4 === 'string') {
                                                        if (func2(data4) < 1) {
                                                            validate180.errors = [
                                                                {
                                                                    instancePath: instancePath + '/s3loc/key',
                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate180.errors = [
                                                            {
                                                                instancePath: instancePath + '/s3loc/key',
                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid3 = _errs10 === errors;
                                            }
                                            else {
                                                var valid3 = true;
                                            }
                                            if (valid3) {
                                                if (data2.uploadID !== undefined) {
                                                    let data5 = data2.uploadID;
                                                    const _errs12 = errors;
                                                    if (errors === _errs12) {
                                                        if (typeof data5 === 'string') {
                                                            const b64min1 = Math.ceil((4 * 9) / 3);
                                                            const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                                            if (func499(data5) < b64min1 || func499(data5) > b64max1) {
                                                                validate180.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/s3loc/uploadID',
                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                        keyword: 'uid',
                                                                        params: {
                                                                            error: 'encoded',
                                                                            b64min: b64min1,
                                                                            b64max: b64max1,
                                                                            length: func499(data5)
                                                                        },
                                                                        message: 'length must be between ' +
                                                                            b64min1 +
                                                                            ' and ' +
                                                                            b64max1 +
                                                                            ', but is ' +
                                                                            func499(data5)
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                const decoded1 = func500(data5);
                                                                if (decoded1.length !== 9) {
                                                                    validate180.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/s3loc/uploadID',
                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                            keyword: 'uid',
                                                                            params: { error: 'decoded' },
                                                                            message: 'must decode to 9 bytes'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    const encoded1 = func501(decoded1);
                                                                    if (func502(encoded1) !== func502(data5)) {
                                                                        validate180.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/s3loc/uploadID',
                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                keyword: 'uid',
                                                                                params: { error: 'ambiguous' },
                                                                                message: 'encoding is ambiguous'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate180.errors = [
                                                                {
                                                                    instancePath: instancePath + '/s3loc/uploadID',
                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid3 = _errs12 === errors;
                                                }
                                                else {
                                                    var valid3 = true;
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate180.errors = [
                                        {
                                            instancePath: instancePath + '/s3loc',
                                            schemaPath: 'urn:wisepipe-common:S3File/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.transientPipeExport !== undefined) {
                                const _errs14 = errors;
                                if (!validate148(data.transientPipeExport, {
                                    instancePath: instancePath + '/transientPipeExport',
                                    parentData: data,
                                    parentDataProperty: 'transientPipeExport',
                                    rootData
                                })) {
                                    vErrors = vErrors === null ? validate148.errors : vErrors.concat(validate148.errors);
                                    errors = vErrors.length;
                                }
                                var valid0 = _errs14 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate180.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate180.errors = vErrors;
    return errors === 0;
}
export const transientPipeCalculationRequestSchemaValidation = validate182;
const schema197 = {
    $id: 'urn:wisepipe-common-computation:TransientPipeCalculationRequest',
    type: 'object',
    properties: {
        elements: { type: 'array', items: { $ref: 'urn:wisepipe-common-pipe:GraphElement' } },
        engineMode: { type: 'string', enum: ['standard', 'big'] },
        transientConfig: { $ref: 'urn:wisepipe-common-computation:TransientConfig' },
        runConfig: { type: 'object', additionalProperties: { $ref: 'urn:wisepipe-common-computation:RunConfig' } }
    },
    required: ['elements', 'engineMode', 'transientConfig']
};
const func503 = ucs2length;
const func504 = base64urlToBuffer;
const func505 = base64urlEncode;
const func506 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate182(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:TransientPipeCalculationRequest" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.elements === undefined && (missing0 = 'elements')) ||
                (data.engineMode === undefined && (missing0 = 'engineMode')) ||
                (data.transientConfig === undefined && (missing0 = 'transientConfig'))) {
                validate182.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.elements !== undefined) {
                    let data0 = data.elements;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                let data1 = data0[i0];
                                const _errs3 = errors;
                                const _errs4 = errors;
                                if (errors === _errs4) {
                                    if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                        let missing1;
                                        if ((data1.elementID === undefined && (missing1 = 'elementID')) ||
                                            (data1.elementType === undefined && (missing1 = 'elementType'))) {
                                            validate182.errors = [
                                                {
                                                    instancePath: instancePath + '/elements/' + i0,
                                                    schemaPath: 'urn:wisepipe-common-pipe:GraphElement/required',
                                                    keyword: 'required',
                                                    params: { missingProperty: missing1 },
                                                    message: "must have required property '" + missing1 + "'"
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (data1.elementID !== undefined) {
                                                let data2 = data1.elementID;
                                                const _errs6 = errors;
                                                if (errors === _errs6) {
                                                    if (typeof data2 === 'string') {
                                                        const b64min0 = Math.ceil((4 * 10) / 3);
                                                        const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                                                        if (func503(data2) < b64min0 || func503(data2) > b64max0) {
                                                            validate182.errors = [
                                                                {
                                                                    instancePath: instancePath + '/elements/' + i0 + '/elementID',
                                                                    schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/elementID/uid',
                                                                    keyword: 'uid',
                                                                    params: {
                                                                        error: 'encoded',
                                                                        b64min: b64min0,
                                                                        b64max: b64max0,
                                                                        length: func503(data2)
                                                                    },
                                                                    message: 'length must be between ' +
                                                                        b64min0 +
                                                                        ' and ' +
                                                                        b64max0 +
                                                                        ', but is ' +
                                                                        func503(data2)
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            const decoded0 = func504(data2);
                                                            if (decoded0.length !== 10) {
                                                                validate182.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/elements/' + i0 + '/elementID',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/elementID/uid',
                                                                        keyword: 'uid',
                                                                        params: { error: 'decoded' },
                                                                        message: 'must decode to 10 bytes'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                const encoded0 = func505(decoded0);
                                                                if (func506(encoded0) !== func506(data2)) {
                                                                    validate182.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/elements/' + i0 + '/elementID',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/elementID/uid',
                                                                            keyword: 'uid',
                                                                            params: { error: 'ambiguous' },
                                                                            message: 'encoding is ambiguous'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate182.errors = [
                                                            {
                                                                instancePath: instancePath + '/elements/' + i0 + '/elementID',
                                                                schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/elementID/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid3 = _errs6 === errors;
                                            }
                                            else {
                                                var valid3 = true;
                                            }
                                            if (valid3) {
                                                if (data1.elementType !== undefined) {
                                                    let data3 = data1.elementType;
                                                    const _errs8 = errors;
                                                    if (errors === _errs8) {
                                                        if (typeof data3 === 'string') {
                                                            if (!pattern2.test(data3)) {
                                                                validate182.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/elements/' + i0 + '/elementType',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/elementType/pattern',
                                                                        keyword: 'pattern',
                                                                        params: { pattern: 'edge|node|group' },
                                                                        message: 'must match pattern "' + 'edge|node|group' + '"'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate182.errors = [
                                                                {
                                                                    instancePath: instancePath + '/elements/' + i0 + '/elementType',
                                                                    schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/elementType/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid3 = _errs8 === errors;
                                                }
                                                else {
                                                    var valid3 = true;
                                                }
                                                if (valid3) {
                                                    if (data1.lastModified !== undefined) {
                                                        let data4 = data1.lastModified;
                                                        const _errs10 = errors;
                                                        if (errors === _errs10) {
                                                            if (errors === _errs10) {
                                                                if (typeof data4 === 'string') {
                                                                    if (!formats0.validate(data4)) {
                                                                        validate182.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/elements/' + i0 + '/lastModified',
                                                                                schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/lastModified/format',
                                                                                keyword: 'format',
                                                                                params: { format: 'date-time' },
                                                                                message: 'must match format "' + 'date-time' + '"'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate182.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/elements/' + i0 + '/lastModified',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/lastModified/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                        var valid3 = _errs10 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                    if (valid3) {
                                                        if (data1.uniqueChangeID !== undefined) {
                                                            const _errs12 = errors;
                                                            if (typeof data1.uniqueChangeID !== 'string') {
                                                                validate182.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/elements/' + i0 + '/uniqueChangeID',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/uniqueChangeID/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid3 = _errs12 === errors;
                                                        }
                                                        else {
                                                            var valid3 = true;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate182.errors = [
                                            {
                                                instancePath: instancePath + '/elements/' + i0,
                                                schemaPath: 'urn:wisepipe-common-pipe:GraphElement/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                        }
                        else {
                            validate182.errors = [
                                {
                                    instancePath: instancePath + '/elements',
                                    schemaPath: '#/properties/elements/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.engineMode !== undefined) {
                        let data6 = data.engineMode;
                        const _errs14 = errors;
                        if (typeof data6 !== 'string') {
                            validate182.errors = [
                                {
                                    instancePath: instancePath + '/engineMode',
                                    schemaPath: '#/properties/engineMode/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data6 === 'standard' || data6 === 'big')) {
                            validate182.errors = [
                                {
                                    instancePath: instancePath + '/engineMode',
                                    schemaPath: '#/properties/engineMode/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema197.properties.engineMode.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs14 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.transientConfig !== undefined) {
                            const _errs16 = errors;
                            if (!validate143(data.transientConfig, {
                                instancePath: instancePath + '/transientConfig',
                                parentData: data,
                                parentDataProperty: 'transientConfig',
                                rootData
                            })) {
                                vErrors = vErrors === null ? validate143.errors : vErrors.concat(validate143.errors);
                                errors = vErrors.length;
                            }
                            var valid0 = _errs16 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.runConfig !== undefined) {
                                let data8 = data.runConfig;
                                const _errs17 = errors;
                                if (errors === _errs17) {
                                    if (data8 && typeof data8 == 'object' && !Array.isArray(data8)) {
                                        for (const key0 in data8) {
                                            let data9 = data8[key0];
                                            const _errs20 = errors;
                                            const _errs21 = errors;
                                            if (errors === _errs21) {
                                                if (data9 && typeof data9 == 'object' && !Array.isArray(data9)) {
                                                    let missing2;
                                                    if (data9.type === undefined && (missing2 = 'type')) {
                                                        validate182.errors = [
                                                            {
                                                                instancePath: instancePath + '/runConfig/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                schemaPath: 'urn:wisepipe-common-computation:RunConfig/required',
                                                                keyword: 'required',
                                                                params: { missingProperty: missing2 },
                                                                message: "must have required property '" + missing2 + "'"
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        if (data9.type !== undefined) {
                                                            let data10 = data9.type;
                                                            if (typeof data10 !== 'string') {
                                                                validate182.errors = [
                                                                    {
                                                                        instancePath: instancePath +
                                                                            '/runConfig/' +
                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                            '/type',
                                                                        schemaPath: 'urn:wisepipe-common-computation:RunConfig/properties/type/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            if (!(data10 === 'file' ||
                                                                data10 === 'cloud' ||
                                                                data10 === 'demand_forecast' ||
                                                                data10 === 'sample_customers' ||
                                                                data10 === 'pipe' ||
                                                                data10 === 'multi_port_pipe' ||
                                                                data10 === 'adapt' ||
                                                                data10 === 'aggregate' ||
                                                                data10 === 'aggregate_v2' ||
                                                                data10 === 'amortization' ||
                                                                data10 === 'binning' ||
                                                                data10 === 'category_encoder' ||
                                                                data10 === 'case' ||
                                                                data10 === 'change_case' ||
                                                                data10 === 'change_type' ||
                                                                data10 === 'clean_character' ||
                                                                data10 === 'combination_matcher' ||
                                                                data10 === 'conditional' ||
                                                                data10 === 'confusion_matrix' ||
                                                                data10 === 'date_add' ||
                                                                data10 === 'date_diff' ||
                                                                data10 === 'date_part' ||
                                                                data10 === 'date_aggregate' ||
                                                                data10 === 'date_format' ||
                                                                data10 === 'distinct' ||
                                                                data10 === 'drop' ||
                                                                data10 === 'export' ||
                                                                data10 === 'extract' ||
                                                                data10 === 'fill' ||
                                                                data10 === 'filter' ||
                                                                data10 === 'formula' ||
                                                                data10 === 'multi_formula' ||
                                                                data10 === 'fuzzy_matcher' ||
                                                                data10 === 'join' ||
                                                                data10 === 'join_v2' ||
                                                                data10 === 'lag' ||
                                                                data10 === 'limit' ||
                                                                data10 === 'merge_columns' ||
                                                                data10 === 'min_max_scaler' ||
                                                                data10 === 'monte_carlo' ||
                                                                data10 === 'most_common' ||
                                                                data10 === 'one_hot_encoder' ||
                                                                data10 === 'oversample' ||
                                                                data10 === 'predict_gender' ||
                                                                data10 === 'quantile' ||
                                                                data10 === 'random_number_generator' ||
                                                                data10 === 'rank' ||
                                                                data10 === 'record_id' ||
                                                                data10 === 'remove_outliers' ||
                                                                data10 === 'remove_empty' ||
                                                                data10 === 'rename' ||
                                                                data10 === 'reorder' ||
                                                                data10 === 'repeat' ||
                                                                data10 === 'replace' ||
                                                                data10 === 'multi_replace' ||
                                                                data10 === 'reshape' ||
                                                                data10 === 'reshape_v2' ||
                                                                data10 === 'running_average' ||
                                                                data10 === 'running_total' ||
                                                                data10 === 'sample' ||
                                                                data10 === 'segmentation' ||
                                                                data10 === 'select' ||
                                                                data10 === 'select_word' ||
                                                                data10 === 'smart_matcher' ||
                                                                data10 === 'snapshot' ||
                                                                data10 === 'sort' ||
                                                                data10 === 'split' ||
                                                                data10 === 'standard_scaler' ||
                                                                data10 === 'text_grade_level' ||
                                                                data10 === 'text_between' ||
                                                                data10 === 'text_length' ||
                                                                data10 === 'text_part' ||
                                                                data10 === 'text_sentiment' ||
                                                                data10 === 'trim' ||
                                                                data10 === 'trim_tags' ||
                                                                data10 === 'undersample' ||
                                                                data10 === 'union' ||
                                                                data10 === 'multi_union' ||
                                                                data10 === 'weighted_average' ||
                                                                data10 === 'classifier' ||
                                                                data10 === 'cat_boost_classifier' ||
                                                                data10 === 'decision_tree_train' ||
                                                                data10 === 'gbt_train' ||
                                                                data10 === 'k_neighbors_classifier' ||
                                                                data10 === 'lgbm_classifier' ||
                                                                data10 === 'logistic_regression_train' ||
                                                                data10 === 'naive_bayes_train' ||
                                                                data10 === 'random_forest_train' ||
                                                                data10 === 'svm_train' ||
                                                                data10 === 'xgb_classifier' ||
                                                                data10 === 'regressor' ||
                                                                data10 === 'decision_tree_regressor' ||
                                                                data10 === 'gbt_regressor' ||
                                                                data10 === 'k_neighbors_regressor' ||
                                                                data10 === 'lgbm_regressor' ||
                                                                data10 === 'linear_regression_train' ||
                                                                data10 === 'mlp_regressor' ||
                                                                data10 === 'random_forest_regressor' ||
                                                                data10 === 'xgb_regressor' ||
                                                                data10 === 'cat_boost_regressor' ||
                                                                data10 === 'forecast' ||
                                                                data10 === 'arima_forecast' ||
                                                                data10 === 'auto_regressive_forecast' ||
                                                                data10 === 'exp_smoothing_forecast' ||
                                                                data10 === 'linear_regression_forecast' ||
                                                                data10 === 'moving_average_forecast' ||
                                                                data10 === 'prophet_forecast' ||
                                                                data10 === 'seasonal_arima_forecast' ||
                                                                data10 === 'simple_exp_smoothing_forecast' ||
                                                                data10 === 'vector_auto_regressive_forecast' ||
                                                                data10 === 'weighted_moving_average_forecast' ||
                                                                data10 === 'cnn_text_classifier' ||
                                                                data10 === 'bow_text_classifier' ||
                                                                data10 === 'ensemble_text_classifier' ||
                                                                data10 === 'text_classifier' ||
                                                                data10 === 'word_frequency' ||
                                                                data10 === 'outlier' ||
                                                                data10 === 'abod_outlier' ||
                                                                data10 === 'cblof_outlier' ||
                                                                data10 === 'cof_outlier' ||
                                                                data10 === 'hbos_outlier' ||
                                                                data10 === 'iqr_outlier' ||
                                                                data10 === 'isolation_forest_outlier' ||
                                                                data10 === 'k_neighbors_outlier' ||
                                                                data10 === 'multi_objective_gaal_outlier' ||
                                                                data10 === 'one_class_svm_outlier' ||
                                                                data10 === 'pca_outlier' ||
                                                                data10 === 'single_objective_gaal_outlier' ||
                                                                data10 === 'subspace_outlier' ||
                                                                data10 === 'z_score_outlier' ||
                                                                data10 === 'assignment_optimization' ||
                                                                data10 === 'predictor' ||
                                                                data10 === 'us_income' ||
                                                                data10 === 'us_population' ||
                                                                data10 === 'weather' ||
                                                                data10 === 'hierarchy' ||
                                                                data10 === 'hierarchy_v2' ||
                                                                data10 === 'hierarchy_validator' ||
                                                                data10 === 'hierarchy_validator_v2' ||
                                                                data10 === 'lookup' ||
                                                                data10 === 'split_columns' ||
                                                                data10 === 'period_mapper' ||
                                                                data10 === 'rule_mapper' ||
                                                                data10 === 'rule_mapper_v2' ||
                                                                data10 === 'incentives_export' ||
                                                                data10 === 'incentives_import' ||
                                                                data10 === 'incentives_table' ||
                                                                data10 === 'incentives_period' ||
                                                                data10 === 'user_defined_calc' ||
                                                                data10 === 'sort_calc' ||
                                                                data10 === 'time_shift_calc' ||
                                                                data10 === 'category_calc' ||
                                                                data10 === 'true_up' ||
                                                                data10 === 'period_add' ||
                                                                data10 === 'period_diff' ||
                                                                data10 === 'expand_picklist' ||
                                                                data10 === 'period_accumulation' ||
                                                                data10 === 'reusable_logic_input' ||
                                                                data10 === 'reusable_logic_output' ||
                                                                data10 === 'reusable_logic' ||
                                                                data10 === 'none')) {
                                                                validate182.errors = [
                                                                    {
                                                                        instancePath: instancePath +
                                                                            '/runConfig/' +
                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                            '/type',
                                                                        schemaPath: 'urn:wisepipe-common-computation:RunConfig/properties/type/enum',
                                                                        keyword: 'enum',
                                                                        params: { allowedValues: schema148.properties.type.enum },
                                                                        message: 'must be equal to one of the allowed values'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate182.errors = [
                                                        {
                                                            instancePath: instancePath + '/runConfig/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                            schemaPath: 'urn:wisepipe-common-computation:RunConfig/type',
                                                            keyword: 'type',
                                                            params: { type: 'object' },
                                                            message: 'must be object'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid5 = _errs20 === errors;
                                            if (!valid5) {
                                                break;
                                            }
                                        }
                                    }
                                    else {
                                        validate182.errors = [
                                            {
                                                instancePath: instancePath + '/runConfig',
                                                schemaPath: '#/properties/runConfig/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs17 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate182.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate182.errors = vErrors;
    return errors === 0;
}
export const transientPipeCalculationSchemaValidation = validate184;
const schema200 = {
    $id: 'urn:wisepipe-common-computation:TransientPipeCalculation',
    type: 'object',
    properties: {
        taskID: { type: 'string', minLength: 1 },
        exportFileMap: {
            type: 'object',
            additionalProperties: { type: 'array', items: { $ref: 'urn:wisepipe-common:S3File' } }
        }
    },
    required: ['taskID']
};
const func510 = ucs2length;
const func511 = base64urlToBuffer;
const func512 = base64urlEncode;
const func513 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate184(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:TransientPipeCalculation" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.taskID === undefined && (missing0 = 'taskID')) {
                validate184.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.taskID !== undefined) {
                    let data0 = data.taskID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate184.errors = [
                                    {
                                        instancePath: instancePath + '/taskID',
                                        schemaPath: '#/properties/taskID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate184.errors = [
                                {
                                    instancePath: instancePath + '/taskID',
                                    schemaPath: '#/properties/taskID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.exportFileMap !== undefined) {
                        let data1 = data.exportFileMap;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                for (const key0 in data1) {
                                    let data2 = data1[key0];
                                    const _errs6 = errors;
                                    if (errors === _errs6) {
                                        if (Array.isArray(data2)) {
                                            var valid2 = true;
                                            const len0 = data2.length;
                                            for (let i0 = 0; i0 < len0; i0++) {
                                                let data3 = data2[i0];
                                                const _errs8 = errors;
                                                const _errs9 = errors;
                                                if (errors === _errs9) {
                                                    if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                                                        let missing1;
                                                        if ((data3.bucket === undefined && (missing1 = 'bucket')) ||
                                                            (data3.key === undefined && (missing1 = 'key'))) {
                                                            validate184.errors = [
                                                                {
                                                                    instancePath: instancePath +
                                                                        '/exportFileMap/' +
                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                        '/' +
                                                                        i0,
                                                                    schemaPath: 'urn:wisepipe-common:S3File/required',
                                                                    keyword: 'required',
                                                                    params: { missingProperty: missing1 },
                                                                    message: "must have required property '" + missing1 + "'"
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            if (data3.bucket !== undefined) {
                                                                let data4 = data3.bucket;
                                                                const _errs11 = errors;
                                                                if (errors === _errs11) {
                                                                    if (typeof data4 === 'string') {
                                                                        if (func2(data4) < 1) {
                                                                            validate184.errors = [
                                                                                {
                                                                                    instancePath: instancePath +
                                                                                        '/exportFileMap/' +
                                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                        '/' +
                                                                                        i0 +
                                                                                        '/bucket',
                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                                    keyword: 'minLength',
                                                                                    params: { limit: 1 },
                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate184.errors = [
                                                                            {
                                                                                instancePath: instancePath +
                                                                                    '/exportFileMap/' +
                                                                                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                    '/' +
                                                                                    i0 +
                                                                                    '/bucket',
                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid4 = _errs11 === errors;
                                                            }
                                                            else {
                                                                var valid4 = true;
                                                            }
                                                            if (valid4) {
                                                                if (data3.key !== undefined) {
                                                                    let data5 = data3.key;
                                                                    const _errs13 = errors;
                                                                    if (errors === _errs13) {
                                                                        if (typeof data5 === 'string') {
                                                                            if (func2(data5) < 1) {
                                                                                validate184.errors = [
                                                                                    {
                                                                                        instancePath: instancePath +
                                                                                            '/exportFileMap/' +
                                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                            '/' +
                                                                                            i0 +
                                                                                            '/key',
                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                                        keyword: 'minLength',
                                                                                        params: { limit: 1 },
                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate184.errors = [
                                                                                {
                                                                                    instancePath: instancePath +
                                                                                        '/exportFileMap/' +
                                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                        '/' +
                                                                                        i0 +
                                                                                        '/key',
                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid4 = _errs13 === errors;
                                                                }
                                                                else {
                                                                    var valid4 = true;
                                                                }
                                                                if (valid4) {
                                                                    if (data3.uploadID !== undefined) {
                                                                        let data6 = data3.uploadID;
                                                                        const _errs15 = errors;
                                                                        if (errors === _errs15) {
                                                                            if (typeof data6 === 'string') {
                                                                                const b64min0 = Math.ceil((4 * 9) / 3);
                                                                                const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                                                                if (func510(data6) < b64min0 || func510(data6) > b64max0) {
                                                                                    validate184.errors = [
                                                                                        {
                                                                                            instancePath: instancePath +
                                                                                                '/exportFileMap/' +
                                                                                                key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                '/' +
                                                                                                i0 +
                                                                                                '/uploadID',
                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                            keyword: 'uid',
                                                                                            params: {
                                                                                                error: 'encoded',
                                                                                                b64min: b64min0,
                                                                                                b64max: b64max0,
                                                                                                length: func510(data6)
                                                                                            },
                                                                                            message: 'length must be between ' +
                                                                                                b64min0 +
                                                                                                ' and ' +
                                                                                                b64max0 +
                                                                                                ', but is ' +
                                                                                                func510(data6)
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                else {
                                                                                    const decoded0 = func511(data6);
                                                                                    if (decoded0.length !== 9) {
                                                                                        validate184.errors = [
                                                                                            {
                                                                                                instancePath: instancePath +
                                                                                                    '/exportFileMap/' +
                                                                                                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                    '/' +
                                                                                                    i0 +
                                                                                                    '/uploadID',
                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                keyword: 'uid',
                                                                                                params: { error: 'decoded' },
                                                                                                message: 'must decode to 9 bytes'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    else {
                                                                                        const encoded0 = func512(decoded0);
                                                                                        if (func513(encoded0) !== func513(data6)) {
                                                                                            validate184.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath +
                                                                                                        '/exportFileMap/' +
                                                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                        '/' +
                                                                                                        i0 +
                                                                                                        '/uploadID',
                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                    keyword: 'uid',
                                                                                                    params: { error: 'ambiguous' },
                                                                                                    message: 'encoding is ambiguous'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate184.errors = [
                                                                                    {
                                                                                        instancePath: instancePath +
                                                                                            '/exportFileMap/' +
                                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                            '/' +
                                                                                            i0 +
                                                                                            '/uploadID',
                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid4 = _errs15 === errors;
                                                                    }
                                                                    else {
                                                                        var valid4 = true;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate184.errors = [
                                                            {
                                                                instancePath: instancePath +
                                                                    '/exportFileMap/' +
                                                                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                    '/' +
                                                                    i0,
                                                                schemaPath: 'urn:wisepipe-common:S3File/type',
                                                                keyword: 'type',
                                                                params: { type: 'object' },
                                                                message: 'must be object'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid2 = _errs8 === errors;
                                                if (!valid2) {
                                                    break;
                                                }
                                            }
                                        }
                                        else {
                                            validate184.errors = [
                                                {
                                                    instancePath: instancePath + '/exportFileMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                    schemaPath: '#/properties/exportFileMap/additionalProperties/type',
                                                    keyword: 'type',
                                                    params: { type: 'array' },
                                                    message: 'must be array'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs6 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate184.errors = [
                                    {
                                        instancePath: instancePath + '/exportFileMap',
                                        schemaPath: '#/properties/exportFileMap/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate184.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate184.errors = vErrors;
    return errors === 0;
}
export const transientPipeExportSchemaValidation = validate148;
export const unitTestColumnOverrideSchemaValidation = validate185;
const schema202 = {
    $id: 'urn:wisepipe-common-pipe:UnitTestColumnOverride',
    type: 'object',
    properties: {
        originalColName: { type: 'string', minLength: 1 },
        unitTestDataColName: { type: 'string', minLength: 1 }
    },
    required: ['originalColName', 'unitTestDataColName']
};
function validate185(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:UnitTestColumnOverride" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.originalColName === undefined && (missing0 = 'originalColName')) ||
                (data.unitTestDataColName === undefined && (missing0 = 'unitTestDataColName'))) {
                validate185.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.originalColName !== undefined) {
                    let data0 = data.originalColName;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate185.errors = [
                                    {
                                        instancePath: instancePath + '/originalColName',
                                        schemaPath: '#/properties/originalColName/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate185.errors = [
                                {
                                    instancePath: instancePath + '/originalColName',
                                    schemaPath: '#/properties/originalColName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.unitTestDataColName !== undefined) {
                        let data1 = data.unitTestDataColName;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate185.errors = [
                                        {
                                            instancePath: instancePath + '/unitTestDataColName',
                                            schemaPath: '#/properties/unitTestDataColName/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate185.errors = [
                                    {
                                        instancePath: instancePath + '/unitTestDataColName',
                                        schemaPath: '#/properties/unitTestDataColName/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate185.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate185.errors = vErrors;
    return errors === 0;
}
export const unitTestDataOverrideSchemaValidation = validate186;
const schema203 = {
    $id: 'urn:wisepipe-common-pipe:UnitTestDataOverride',
    type: 'object',
    properties: {
        overrideType: { type: 'string', enum: ['originalEmpty', 'unitTestData'] },
        unitTestDataSourceID: { type: 'string' },
        columnOverrides: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:UnitTestColumnOverride' },
            uniqueItemProperties: ['originalColName']
        }
    },
    required: ['overrideType'],
    if: { properties: { overrideType: { const: 'unitTestData' } } },
    then: { required: ['unitTestDataSourceID'] }
};
const func518 = ajvEqual;
function validate186(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:UnitTestDataOverride" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.overrideType !== undefined) {
            if ('unitTestData' !== data.overrideType) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.unitTestDataSourceID === undefined && (missing0 = 'unitTestDataSourceID')) {
                validate186.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err1 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate186.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if (data.overrideType === undefined && (missing1 = 'overrideType')) {
                validate186.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.overrideType !== undefined) {
                    let data1 = data.overrideType;
                    const _errs5 = errors;
                    if (typeof data1 !== 'string') {
                        validate186.errors = [
                            {
                                instancePath: instancePath + '/overrideType',
                                schemaPath: '#/properties/overrideType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data1 === 'originalEmpty' || data1 === 'unitTestData')) {
                        validate186.errors = [
                            {
                                instancePath: instancePath + '/overrideType',
                                schemaPath: '#/properties/overrideType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema203.properties.overrideType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid2 = _errs5 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.unitTestDataSourceID !== undefined) {
                        const _errs7 = errors;
                        if (typeof data.unitTestDataSourceID !== 'string') {
                            validate186.errors = [
                                {
                                    instancePath: instancePath + '/unitTestDataSourceID',
                                    schemaPath: '#/properties/unitTestDataSourceID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid2 = _errs7 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.columnOverrides !== undefined) {
                            let data3 = data.columnOverrides;
                            const _errs9 = errors;
                            if (errors === _errs9) {
                                if (Array.isArray(data3)) {
                                    var valid3 = true;
                                    const len0 = data3.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data4 = data3[i0];
                                        const _errs11 = errors;
                                        const _errs12 = errors;
                                        if (errors === _errs12) {
                                            if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                                                let missing2;
                                                if ((data4.originalColName === undefined && (missing2 = 'originalColName')) ||
                                                    (data4.unitTestDataColName === undefined && (missing2 = 'unitTestDataColName'))) {
                                                    validate186.errors = [
                                                        {
                                                            instancePath: instancePath + '/columnOverrides/' + i0,
                                                            schemaPath: 'urn:wisepipe-common-pipe:UnitTestColumnOverride/required',
                                                            keyword: 'required',
                                                            params: { missingProperty: missing2 },
                                                            message: "must have required property '" + missing2 + "'"
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (data4.originalColName !== undefined) {
                                                        let data5 = data4.originalColName;
                                                        const _errs14 = errors;
                                                        if (errors === _errs14) {
                                                            if (typeof data5 === 'string') {
                                                                if (func2(data5) < 1) {
                                                                    validate186.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/columnOverrides/' + i0 + '/originalColName',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:UnitTestColumnOverride/properties/originalColName/minLength',
                                                                            keyword: 'minLength',
                                                                            params: { limit: 1 },
                                                                            message: 'must NOT have fewer than 1 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate186.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/columnOverrides/' + i0 + '/originalColName',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:UnitTestColumnOverride/properties/originalColName/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid5 = _errs14 === errors;
                                                    }
                                                    else {
                                                        var valid5 = true;
                                                    }
                                                    if (valid5) {
                                                        if (data4.unitTestDataColName !== undefined) {
                                                            let data6 = data4.unitTestDataColName;
                                                            const _errs16 = errors;
                                                            if (errors === _errs16) {
                                                                if (typeof data6 === 'string') {
                                                                    if (func2(data6) < 1) {
                                                                        validate186.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/columnOverrides/' + i0 + '/unitTestDataColName',
                                                                                schemaPath: 'urn:wisepipe-common-pipe:UnitTestColumnOverride/properties/unitTestDataColName/minLength',
                                                                                keyword: 'minLength',
                                                                                params: { limit: 1 },
                                                                                message: 'must NOT have fewer than 1 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate186.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/columnOverrides/' + i0 + '/unitTestDataColName',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:UnitTestColumnOverride/properties/unitTestDataColName/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid5 = _errs16 === errors;
                                                        }
                                                        else {
                                                            var valid5 = true;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate186.errors = [
                                                    {
                                                        instancePath: instancePath + '/columnOverrides/' + i0,
                                                        schemaPath: 'urn:wisepipe-common-pipe:UnitTestColumnOverride/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid3 = _errs11 === errors;
                                        if (!valid3) {
                                            break;
                                        }
                                    }
                                    if (valid3) {
                                        const keys0 = schema203.properties.columnOverrides.uniqueItemProperties;
                                        let k0;
                                        let i1 = data3.length;
                                        let j0;
                                        if (i1 > 1) {
                                            outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                                let key0 = keys0[k0];
                                                for (i1 = data3.length; i1--;) {
                                                    let x0 = data3[i1];
                                                    if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                        continue;
                                                    }
                                                    for (j0 = i1; j0--;) {
                                                        let y0 = data3[j0];
                                                        if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func518(x0[key0], y0[key0])) {
                                                            validate186.errors = [
                                                                {
                                                                    instancePath: instancePath + '/columnOverrides',
                                                                    schemaPath: '#/properties/columnOverrides/uniqueItemProperties',
                                                                    keyword: 'uniqueItemProperties',
                                                                    params: {},
                                                                    message: 'must pass "uniqueItemProperties" keyword validation'
                                                                }
                                                            ];
                                                            return false;
                                                            break outer0;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate186.errors = [
                                        {
                                            instancePath: instancePath + '/columnOverrides',
                                            schemaPath: '#/properties/columnOverrides/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid2 = _errs9 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                    }
                }
            }
        }
        else {
            validate186.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate186.errors = vErrors;
    return errors === 0;
}
export const unitTestInputSchemaValidation = validate187;
const schema205 = {
    $id: 'urn:wisepipe-common-computation:UnitTestInput',
    type: 'object',
    properties: { task: { $ref: 'urn:wisepipe-common-computation:UnitTestTask' } },
    required: ['task']
};
const schema206 = {
    $id: 'urn:wisepipe-common-computation:UnitTestTask',
    type: 'object',
    properties: {
        taskID: { type: 'string', minLength: 1 },
        userID: { type: 'string', format: 'uuid' },
        userName: { type: 'string' },
        userEmail: { type: 'string' },
        orgID: { type: 'string', format: 'uuid' },
        orgPlan: { type: 'string', enum: ['Social', 'Enterprise', 'Integration', 'Temp', 'Starter', 'Professional'] },
        unitTest: { $ref: 'urn:wisepipe-common-computation:UnitTest' },
        updateSnapshot: { type: 'boolean' }
    },
    required: ['taskID', 'orgID', 'userID']
};
const schema207 = {
    $id: 'urn:wisepipe-common-computation:UnitTest',
    type: 'object',
    properties: {
        unitTestID: { type: 'string', uid: 9 },
        name: { type: 'string', minLength: 1, maxLength: 100 },
        description: { type: 'string', minLength: 1, maxLength: 1000 },
        isAIGenerated: { type: 'boolean' },
        pipeID: { type: 'string', uid: 10 },
        elementID: { type: 'string', uid: 10 },
        port: { type: 'string', minLength: 1 },
        createdAt: { type: 'string', format: 'date-time' },
        createdBy: { type: 'string', format: 'uuid' },
        lastModifiedAt: { type: 'string', format: 'date-time' },
        lastModifiedBy: { type: 'string', format: 'uuid' },
        dataMap: { type: 'object', additionalProperties: { $ref: 'urn:wisepipe-common-pipe:UnitTestDataOverride' } },
        snapshotLastUpdatedBy: { type: 'string', format: 'uuid' },
        snapshotLastUpdatedAt: { type: 'string', format: 'date-time' },
        result: { $ref: 'urn:wisepipe-common-computation:UnitTestRun' }
    },
    required: ['unitTestID', 'name', 'pipeID', 'elementID', 'port', 'createdAt', 'createdBy'],
    allOf: [
        {
            if: { oneOf: [{ required: ['lastModifiedAt'] }, { required: ['lastModifiedBy'] }] },
            then: { required: ['lastModifiedAt', 'lastModifiedBy'] }
        },
        {
            if: { oneOf: [{ required: ['snapshotLastUpdatedBy'] }, { required: ['snapshotLastUpdatedAt'] }] },
            then: { required: ['snapshotLastUpdatedBy', 'snapshotLastUpdatedAt'] }
        }
    ]
};
const schema208 = {
    $id: 'urn:wisepipe-common-computation:UnitTestRun',
    type: 'object',
    properties: {
        unitTestID: { type: 'string', uid: 9 },
        status: { type: 'string', enum: ['passed', 'failed', 'error', 'running', 'noSnapshotFound'] },
        lastRunBy: { type: 'string', format: 'uuid' },
        lastRunAt: { type: 'string', format: 'date-time' },
        taskID: { type: 'string', minLength: 1 },
        error: { type: 'object' }
    },
    required: ['unitTestID', 'status'],
    if: { not: { properties: { status: { const: 'running' } } } },
    then: { required: ['lastRunBy', 'lastRunAt'] }
};
const func520 = ucs2length;
const func521 = base64urlToBuffer;
const func522 = base64urlEncode;
const func523 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func528 = ucs2length;
const func529 = base64urlToBuffer;
const func530 = base64urlEncode;
const func531 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func532 = ucs2length;
const func533 = base64urlToBuffer;
const func534 = base64urlEncode;
const func535 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func537 = ucs2length;
const func538 = base64urlToBuffer;
const func539 = base64urlEncode;
const func540 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate189(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:UnitTest" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    const _errs2 = errors;
    let valid1 = true;
    const _errs3 = errors;
    const _errs4 = errors;
    let valid2 = false;
    let passing0 = null;
    const _errs5 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if (data.lastModifiedAt === undefined && (missing0 = 'lastModifiedAt')) {
            const err0 = {};
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
    }
    var _valid1 = _errs5 === errors;
    if (_valid1) {
        valid2 = true;
        passing0 = 0;
    }
    const _errs6 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing1;
        if (data.lastModifiedBy === undefined && (missing1 = 'lastModifiedBy')) {
            const err1 = {};
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
    }
    var _valid1 = _errs6 === errors;
    if (_valid1 && valid2) {
        valid2 = false;
        passing0 = [passing0, 1];
    }
    else {
        if (_valid1) {
            valid2 = true;
            passing0 = 1;
        }
    }
    if (!valid2) {
        const err2 = {};
        if (vErrors === null) {
            vErrors = [err2];
        }
        else {
            vErrors.push(err2);
        }
        errors++;
    }
    else {
        errors = _errs4;
        if (vErrors !== null) {
            if (_errs4) {
                vErrors.length = _errs4;
            }
            else {
                vErrors = null;
            }
        }
    }
    var _valid0 = _errs3 === errors;
    errors = _errs2;
    if (vErrors !== null) {
        if (_errs2) {
            vErrors.length = _errs2;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs7 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if ((data.lastModifiedAt === undefined && (missing2 = 'lastModifiedAt')) ||
                (data.lastModifiedBy === undefined && (missing2 = 'lastModifiedBy'))) {
                validate189.errors = [
                    {
                        instancePath,
                        schemaPath: '#/allOf/0/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing2 },
                        message: "must have required property '" + missing2 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs7 === errors;
        valid1 = _valid0;
    }
    if (!valid1) {
        const err3 = {
            instancePath,
            schemaPath: '#/allOf/0/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err3];
        }
        else {
            vErrors.push(err3);
        }
        errors++;
        validate189.errors = vErrors;
        return false;
    }
    var valid0 = _errs1 === errors;
    if (valid0) {
        const _errs8 = errors;
        const _errs9 = errors;
        let valid3 = true;
        const _errs10 = errors;
        const _errs11 = errors;
        let valid4 = false;
        let passing1 = null;
        const _errs12 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing3;
            if (data.snapshotLastUpdatedBy === undefined && (missing3 = 'snapshotLastUpdatedBy')) {
                const err4 = {};
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
        }
        var _valid3 = _errs12 === errors;
        if (_valid3) {
            valid4 = true;
            passing1 = 0;
        }
        const _errs13 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing4;
            if (data.snapshotLastUpdatedAt === undefined && (missing4 = 'snapshotLastUpdatedAt')) {
                const err5 = {};
                if (vErrors === null) {
                    vErrors = [err5];
                }
                else {
                    vErrors.push(err5);
                }
                errors++;
            }
        }
        var _valid3 = _errs13 === errors;
        if (_valid3 && valid4) {
            valid4 = false;
            passing1 = [passing1, 1];
        }
        else {
            if (_valid3) {
                valid4 = true;
                passing1 = 1;
            }
        }
        if (!valid4) {
            const err6 = {};
            if (vErrors === null) {
                vErrors = [err6];
            }
            else {
                vErrors.push(err6);
            }
            errors++;
        }
        else {
            errors = _errs11;
            if (vErrors !== null) {
                if (_errs11) {
                    vErrors.length = _errs11;
                }
                else {
                    vErrors = null;
                }
            }
        }
        var _valid2 = _errs10 === errors;
        errors = _errs9;
        if (vErrors !== null) {
            if (_errs9) {
                vErrors.length = _errs9;
            }
            else {
                vErrors = null;
            }
        }
        if (_valid2) {
            const _errs14 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing5;
                if ((data.snapshotLastUpdatedBy === undefined && (missing5 = 'snapshotLastUpdatedBy')) ||
                    (data.snapshotLastUpdatedAt === undefined && (missing5 = 'snapshotLastUpdatedAt'))) {
                    validate189.errors = [
                        {
                            instancePath,
                            schemaPath: '#/allOf/1/then/required',
                            keyword: 'required',
                            params: { missingProperty: missing5 },
                            message: "must have required property '" + missing5 + "'"
                        }
                    ];
                    return false;
                }
            }
            var _valid2 = _errs14 === errors;
            valid3 = _valid2;
        }
        if (!valid3) {
            const err7 = {
                instancePath,
                schemaPath: '#/allOf/1/if',
                keyword: 'if',
                params: { failingKeyword: 'then' },
                message: 'must match "then" schema'
            };
            if (vErrors === null) {
                vErrors = [err7];
            }
            else {
                vErrors.push(err7);
            }
            errors++;
            validate189.errors = vErrors;
            return false;
        }
        var valid0 = _errs8 === errors;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing6;
            if ((data.unitTestID === undefined && (missing6 = 'unitTestID')) ||
                (data.name === undefined && (missing6 = 'name')) ||
                (data.pipeID === undefined && (missing6 = 'pipeID')) ||
                (data.elementID === undefined && (missing6 = 'elementID')) ||
                (data.port === undefined && (missing6 = 'port')) ||
                (data.createdAt === undefined && (missing6 = 'createdAt')) ||
                (data.createdBy === undefined && (missing6 = 'createdBy'))) {
                validate189.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing6 },
                        message: "must have required property '" + missing6 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.unitTestID !== undefined) {
                    let data0 = data.unitTestID;
                    const _errs15 = errors;
                    if (errors === _errs15) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 9) / 3);
                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                            if (func520(data0) < b64min0 || func520(data0) > b64max0) {
                                validate189.errors = [
                                    {
                                        instancePath: instancePath + '/unitTestID',
                                        schemaPath: '#/properties/unitTestID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func520(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func520(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func521(data0);
                                if (decoded0.length !== 9) {
                                    validate189.errors = [
                                        {
                                            instancePath: instancePath + '/unitTestID',
                                            schemaPath: '#/properties/unitTestID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 9 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func522(decoded0);
                                    if (func523(encoded0) !== func523(data0)) {
                                        validate189.errors = [
                                            {
                                                instancePath: instancePath + '/unitTestID',
                                                schemaPath: '#/properties/unitTestID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate189.errors = [
                                {
                                    instancePath: instancePath + '/unitTestID',
                                    schemaPath: '#/properties/unitTestID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid5 = _errs15 === errors;
                }
                else {
                    var valid5 = true;
                }
                if (valid5) {
                    if (data.name !== undefined) {
                        let data1 = data.name;
                        const _errs17 = errors;
                        if (errors === _errs17) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 100) {
                                    validate189.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 100 },
                                            message: 'must NOT have more than 100 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate189.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate189.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid5 = _errs17 === errors;
                    }
                    else {
                        var valid5 = true;
                    }
                    if (valid5) {
                        if (data.description !== undefined) {
                            let data2 = data.description;
                            const _errs19 = errors;
                            if (errors === _errs19) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) > 1000) {
                                        validate189.errors = [
                                            {
                                                instancePath: instancePath + '/description',
                                                schemaPath: '#/properties/description/maxLength',
                                                keyword: 'maxLength',
                                                params: { limit: 1000 },
                                                message: 'must NOT have more than 1000 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (func2(data2) < 1) {
                                            validate189.errors = [
                                                {
                                                    instancePath: instancePath + '/description',
                                                    schemaPath: '#/properties/description/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                else {
                                    validate189.errors = [
                                        {
                                            instancePath: instancePath + '/description',
                                            schemaPath: '#/properties/description/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid5 = _errs19 === errors;
                        }
                        else {
                            var valid5 = true;
                        }
                        if (valid5) {
                            if (data.isAIGenerated !== undefined) {
                                const _errs21 = errors;
                                if (typeof data.isAIGenerated !== 'boolean') {
                                    validate189.errors = [
                                        {
                                            instancePath: instancePath + '/isAIGenerated',
                                            schemaPath: '#/properties/isAIGenerated/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean'
                                        }
                                    ];
                                    return false;
                                }
                                var valid5 = _errs21 === errors;
                            }
                            else {
                                var valid5 = true;
                            }
                            if (valid5) {
                                if (data.pipeID !== undefined) {
                                    let data4 = data.pipeID;
                                    const _errs23 = errors;
                                    if (errors === _errs23) {
                                        if (typeof data4 === 'string') {
                                            const b64min1 = Math.ceil((4 * 10) / 3);
                                            const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                            if (func528(data4) < b64min1 || func528(data4) > b64max1) {
                                                validate189.errors = [
                                                    {
                                                        instancePath: instancePath + '/pipeID',
                                                        schemaPath: '#/properties/pipeID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func528(data4) },
                                                        message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func528(data4)
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const decoded1 = func529(data4);
                                                if (decoded1.length !== 10) {
                                                    validate189.errors = [
                                                        {
                                                            instancePath: instancePath + '/pipeID',
                                                            schemaPath: '#/properties/pipeID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'decoded' },
                                                            message: 'must decode to 10 bytes'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    const encoded1 = func530(decoded1);
                                                    if (func531(encoded1) !== func531(data4)) {
                                                        validate189.errors = [
                                                            {
                                                                instancePath: instancePath + '/pipeID',
                                                                schemaPath: '#/properties/pipeID/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'ambiguous' },
                                                                message: 'encoding is ambiguous'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate189.errors = [
                                                {
                                                    instancePath: instancePath + '/pipeID',
                                                    schemaPath: '#/properties/pipeID/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid5 = _errs23 === errors;
                                }
                                else {
                                    var valid5 = true;
                                }
                                if (valid5) {
                                    if (data.elementID !== undefined) {
                                        let data5 = data.elementID;
                                        const _errs25 = errors;
                                        if (errors === _errs25) {
                                            if (typeof data5 === 'string') {
                                                const b64min2 = Math.ceil((4 * 10) / 3);
                                                const b64max2 = Math.ceil((4 * 10) / 3) + 3;
                                                if (func532(data5) < b64min2 || func532(data5) > b64max2) {
                                                    validate189.errors = [
                                                        {
                                                            instancePath: instancePath + '/elementID',
                                                            schemaPath: '#/properties/elementID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'encoded', b64min: b64min2, b64max: b64max2, length: func532(data5) },
                                                            message: 'length must be between ' + b64min2 + ' and ' + b64max2 + ', but is ' + func532(data5)
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    const decoded2 = func533(data5);
                                                    if (decoded2.length !== 10) {
                                                        validate189.errors = [
                                                            {
                                                                instancePath: instancePath + '/elementID',
                                                                schemaPath: '#/properties/elementID/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'decoded' },
                                                                message: 'must decode to 10 bytes'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        const encoded2 = func534(decoded2);
                                                        if (func535(encoded2) !== func535(data5)) {
                                                            validate189.errors = [
                                                                {
                                                                    instancePath: instancePath + '/elementID',
                                                                    schemaPath: '#/properties/elementID/uid',
                                                                    keyword: 'uid',
                                                                    params: { error: 'ambiguous' },
                                                                    message: 'encoding is ambiguous'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate189.errors = [
                                                    {
                                                        instancePath: instancePath + '/elementID',
                                                        schemaPath: '#/properties/elementID/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid5 = _errs25 === errors;
                                    }
                                    else {
                                        var valid5 = true;
                                    }
                                    if (valid5) {
                                        if (data.port !== undefined) {
                                            let data6 = data.port;
                                            const _errs27 = errors;
                                            if (errors === _errs27) {
                                                if (typeof data6 === 'string') {
                                                    if (func2(data6) < 1) {
                                                        validate189.errors = [
                                                            {
                                                                instancePath: instancePath + '/port',
                                                                schemaPath: '#/properties/port/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate189.errors = [
                                                        {
                                                            instancePath: instancePath + '/port',
                                                            schemaPath: '#/properties/port/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid5 = _errs27 === errors;
                                        }
                                        else {
                                            var valid5 = true;
                                        }
                                        if (valid5) {
                                            if (data.createdAt !== undefined) {
                                                let data7 = data.createdAt;
                                                const _errs29 = errors;
                                                if (errors === _errs29) {
                                                    if (errors === _errs29) {
                                                        if (typeof data7 === 'string') {
                                                            if (!formats0.validate(data7)) {
                                                                validate189.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/createdAt',
                                                                        schemaPath: '#/properties/createdAt/format',
                                                                        keyword: 'format',
                                                                        params: { format: 'date-time' },
                                                                        message: 'must match format "' + 'date-time' + '"'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate189.errors = [
                                                                {
                                                                    instancePath: instancePath + '/createdAt',
                                                                    schemaPath: '#/properties/createdAt/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                                var valid5 = _errs29 === errors;
                                            }
                                            else {
                                                var valid5 = true;
                                            }
                                            if (valid5) {
                                                if (data.createdBy !== undefined) {
                                                    let data8 = data.createdBy;
                                                    const _errs31 = errors;
                                                    if (errors === _errs31) {
                                                        if (errors === _errs31) {
                                                            if (typeof data8 === 'string') {
                                                                if (!formats6.test(data8)) {
                                                                    validate189.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/createdBy',
                                                                            schemaPath: '#/properties/createdBy/format',
                                                                            keyword: 'format',
                                                                            params: { format: 'uuid' },
                                                                            message: 'must match format "' + 'uuid' + '"'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate189.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/createdBy',
                                                                        schemaPath: '#/properties/createdBy/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                    }
                                                    var valid5 = _errs31 === errors;
                                                }
                                                else {
                                                    var valid5 = true;
                                                }
                                                if (valid5) {
                                                    if (data.lastModifiedAt !== undefined) {
                                                        let data9 = data.lastModifiedAt;
                                                        const _errs33 = errors;
                                                        if (errors === _errs33) {
                                                            if (errors === _errs33) {
                                                                if (typeof data9 === 'string') {
                                                                    if (!formats0.validate(data9)) {
                                                                        validate189.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/lastModifiedAt',
                                                                                schemaPath: '#/properties/lastModifiedAt/format',
                                                                                keyword: 'format',
                                                                                params: { format: 'date-time' },
                                                                                message: 'must match format "' + 'date-time' + '"'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate189.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/lastModifiedAt',
                                                                            schemaPath: '#/properties/lastModifiedAt/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                        var valid5 = _errs33 === errors;
                                                    }
                                                    else {
                                                        var valid5 = true;
                                                    }
                                                    if (valid5) {
                                                        if (data.lastModifiedBy !== undefined) {
                                                            let data10 = data.lastModifiedBy;
                                                            const _errs35 = errors;
                                                            if (errors === _errs35) {
                                                                if (errors === _errs35) {
                                                                    if (typeof data10 === 'string') {
                                                                        if (!formats6.test(data10)) {
                                                                            validate189.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/lastModifiedBy',
                                                                                    schemaPath: '#/properties/lastModifiedBy/format',
                                                                                    keyword: 'format',
                                                                                    params: { format: 'uuid' },
                                                                                    message: 'must match format "' + 'uuid' + '"'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate189.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/lastModifiedBy',
                                                                                schemaPath: '#/properties/lastModifiedBy/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                            var valid5 = _errs35 === errors;
                                                        }
                                                        else {
                                                            var valid5 = true;
                                                        }
                                                        if (valid5) {
                                                            if (data.dataMap !== undefined) {
                                                                let data11 = data.dataMap;
                                                                const _errs37 = errors;
                                                                if (errors === _errs37) {
                                                                    if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                                                        for (const key0 in data11) {
                                                                            const _errs40 = errors;
                                                                            if (!validate186(data11[key0], {
                                                                                instancePath: instancePath + '/dataMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                                parentData: data11,
                                                                                parentDataProperty: key0,
                                                                                rootData
                                                                            })) {
                                                                                vErrors =
                                                                                    vErrors === null ? validate186.errors : vErrors.concat(validate186.errors);
                                                                                errors = vErrors.length;
                                                                            }
                                                                            var valid9 = _errs40 === errors;
                                                                            if (!valid9) {
                                                                                break;
                                                                            }
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate189.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/dataMap',
                                                                                schemaPath: '#/properties/dataMap/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'object' },
                                                                                message: 'must be object'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid5 = _errs37 === errors;
                                                            }
                                                            else {
                                                                var valid5 = true;
                                                            }
                                                            if (valid5) {
                                                                if (data.snapshotLastUpdatedBy !== undefined) {
                                                                    let data13 = data.snapshotLastUpdatedBy;
                                                                    const _errs41 = errors;
                                                                    if (errors === _errs41) {
                                                                        if (errors === _errs41) {
                                                                            if (typeof data13 === 'string') {
                                                                                if (!formats6.test(data13)) {
                                                                                    validate189.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/snapshotLastUpdatedBy',
                                                                                            schemaPath: '#/properties/snapshotLastUpdatedBy/format',
                                                                                            keyword: 'format',
                                                                                            params: { format: 'uuid' },
                                                                                            message: 'must match format "' + 'uuid' + '"'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate189.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/snapshotLastUpdatedBy',
                                                                                        schemaPath: '#/properties/snapshotLastUpdatedBy/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                    }
                                                                    var valid5 = _errs41 === errors;
                                                                }
                                                                else {
                                                                    var valid5 = true;
                                                                }
                                                                if (valid5) {
                                                                    if (data.snapshotLastUpdatedAt !== undefined) {
                                                                        let data14 = data.snapshotLastUpdatedAt;
                                                                        const _errs43 = errors;
                                                                        if (errors === _errs43) {
                                                                            if (errors === _errs43) {
                                                                                if (typeof data14 === 'string') {
                                                                                    if (!formats0.validate(data14)) {
                                                                                        validate189.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/snapshotLastUpdatedAt',
                                                                                                schemaPath: '#/properties/snapshotLastUpdatedAt/format',
                                                                                                keyword: 'format',
                                                                                                params: { format: 'date-time' },
                                                                                                message: 'must match format "' + 'date-time' + '"'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate189.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/snapshotLastUpdatedAt',
                                                                                            schemaPath: '#/properties/snapshotLastUpdatedAt/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                        }
                                                                        var valid5 = _errs43 === errors;
                                                                    }
                                                                    else {
                                                                        var valid5 = true;
                                                                    }
                                                                    if (valid5) {
                                                                        if (data.result !== undefined) {
                                                                            let data15 = data.result;
                                                                            const _errs45 = errors;
                                                                            const _errs46 = errors;
                                                                            const _errs48 = errors;
                                                                            let valid11 = true;
                                                                            const _errs49 = errors;
                                                                            const _errs50 = errors;
                                                                            const _errs51 = errors;
                                                                            if (data15 && typeof data15 == 'object' && !Array.isArray(data15)) {
                                                                                if (data15.status !== undefined) {
                                                                                    if ('running' !== data15.status) {
                                                                                        const err8 = {};
                                                                                        if (vErrors === null) {
                                                                                            vErrors = [err8];
                                                                                        }
                                                                                        else {
                                                                                            vErrors.push(err8);
                                                                                        }
                                                                                        errors++;
                                                                                    }
                                                                                }
                                                                            }
                                                                            var valid12 = _errs51 === errors;
                                                                            if (valid12) {
                                                                                const err9 = {};
                                                                                if (vErrors === null) {
                                                                                    vErrors = [err9];
                                                                                }
                                                                                else {
                                                                                    vErrors.push(err9);
                                                                                }
                                                                                errors++;
                                                                            }
                                                                            else {
                                                                                errors = _errs50;
                                                                                if (vErrors !== null) {
                                                                                    if (_errs50) {
                                                                                        vErrors.length = _errs50;
                                                                                    }
                                                                                    else {
                                                                                        vErrors = null;
                                                                                    }
                                                                                }
                                                                            }
                                                                            var _valid4 = _errs49 === errors;
                                                                            errors = _errs48;
                                                                            if (vErrors !== null) {
                                                                                if (_errs48) {
                                                                                    vErrors.length = _errs48;
                                                                                }
                                                                                else {
                                                                                    vErrors = null;
                                                                                }
                                                                            }
                                                                            if (_valid4) {
                                                                                const _errs53 = errors;
                                                                                if (data15 && typeof data15 == 'object' && !Array.isArray(data15)) {
                                                                                    let missing7;
                                                                                    if ((data15.lastRunBy === undefined && (missing7 = 'lastRunBy')) ||
                                                                                        (data15.lastRunAt === undefined && (missing7 = 'lastRunAt'))) {
                                                                                        validate189.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/result',
                                                                                                schemaPath: 'urn:wisepipe-common-computation:UnitTestRun/then/required',
                                                                                                keyword: 'required',
                                                                                                params: { missingProperty: missing7 },
                                                                                                message: "must have required property '" + missing7 + "'"
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var _valid4 = _errs53 === errors;
                                                                                valid11 = _valid4;
                                                                            }
                                                                            if (!valid11) {
                                                                                const err10 = {
                                                                                    instancePath: instancePath + '/result',
                                                                                    schemaPath: 'urn:wisepipe-common-computation:UnitTestRun/if',
                                                                                    keyword: 'if',
                                                                                    params: { failingKeyword: 'then' },
                                                                                    message: 'must match "then" schema'
                                                                                };
                                                                                if (vErrors === null) {
                                                                                    vErrors = [err10];
                                                                                }
                                                                                else {
                                                                                    vErrors.push(err10);
                                                                                }
                                                                                errors++;
                                                                                validate189.errors = vErrors;
                                                                                return false;
                                                                            }
                                                                            if (errors === _errs46) {
                                                                                if (data15 && typeof data15 == 'object' && !Array.isArray(data15)) {
                                                                                    let missing8;
                                                                                    if ((data15.unitTestID === undefined && (missing8 = 'unitTestID')) ||
                                                                                        (data15.status === undefined && (missing8 = 'status'))) {
                                                                                        validate189.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/result',
                                                                                                schemaPath: 'urn:wisepipe-common-computation:UnitTestRun/required',
                                                                                                keyword: 'required',
                                                                                                params: { missingProperty: missing8 },
                                                                                                message: "must have required property '" + missing8 + "'"
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    else {
                                                                                        if (data15.unitTestID !== undefined) {
                                                                                            let data17 = data15.unitTestID;
                                                                                            const _errs54 = errors;
                                                                                            if (errors === _errs54) {
                                                                                                if (typeof data17 === 'string') {
                                                                                                    const b64min3 = Math.ceil((4 * 9) / 3);
                                                                                                    const b64max3 = Math.ceil((4 * 9) / 3) + 3;
                                                                                                    if (func537(data17) < b64min3 || func537(data17) > b64max3) {
                                                                                                        validate189.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/result/unitTestID',
                                                                                                                schemaPath: 'urn:wisepipe-common-computation:UnitTestRun/properties/unitTestID/uid',
                                                                                                                keyword: 'uid',
                                                                                                                params: {
                                                                                                                    error: 'encoded',
                                                                                                                    b64min: b64min3,
                                                                                                                    b64max: b64max3,
                                                                                                                    length: func537(data17)
                                                                                                                },
                                                                                                                message: 'length must be between ' +
                                                                                                                    b64min3 +
                                                                                                                    ' and ' +
                                                                                                                    b64max3 +
                                                                                                                    ', but is ' +
                                                                                                                    func537(data17)
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    else {
                                                                                                        const decoded3 = func538(data17);
                                                                                                        if (decoded3.length !== 9) {
                                                                                                            validate189.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/result/unitTestID',
                                                                                                                    schemaPath: 'urn:wisepipe-common-computation:UnitTestRun/properties/unitTestID/uid',
                                                                                                                    keyword: 'uid',
                                                                                                                    params: { error: 'decoded' },
                                                                                                                    message: 'must decode to 9 bytes'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                        else {
                                                                                                            const encoded3 = func539(decoded3);
                                                                                                            if (func540(encoded3) !== func540(data17)) {
                                                                                                                validate189.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/result/unitTestID',
                                                                                                                        schemaPath: 'urn:wisepipe-common-computation:UnitTestRun/properties/unitTestID/uid',
                                                                                                                        keyword: 'uid',
                                                                                                                        params: { error: 'ambiguous' },
                                                                                                                        message: 'encoding is ambiguous'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    validate189.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/result/unitTestID',
                                                                                                            schemaPath: 'urn:wisepipe-common-computation:UnitTestRun/properties/unitTestID/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'string' },
                                                                                                            message: 'must be string'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            var valid14 = _errs54 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid14 = true;
                                                                                        }
                                                                                        if (valid14) {
                                                                                            if (data15.status !== undefined) {
                                                                                                let data18 = data15.status;
                                                                                                const _errs56 = errors;
                                                                                                if (typeof data18 !== 'string') {
                                                                                                    validate189.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/result/status',
                                                                                                            schemaPath: 'urn:wisepipe-common-computation:UnitTestRun/properties/status/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'string' },
                                                                                                            message: 'must be string'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                                if (!(data18 === 'passed' ||
                                                                                                    data18 === 'failed' ||
                                                                                                    data18 === 'error' ||
                                                                                                    data18 === 'running' ||
                                                                                                    data18 === 'noSnapshotFound')) {
                                                                                                    validate189.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/result/status',
                                                                                                            schemaPath: 'urn:wisepipe-common-computation:UnitTestRun/properties/status/enum',
                                                                                                            keyword: 'enum',
                                                                                                            params: { allowedValues: schema208.properties.status.enum },
                                                                                                            message: 'must be equal to one of the allowed values'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                                var valid14 = _errs56 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid14 = true;
                                                                                            }
                                                                                            if (valid14) {
                                                                                                if (data15.lastRunBy !== undefined) {
                                                                                                    let data19 = data15.lastRunBy;
                                                                                                    const _errs58 = errors;
                                                                                                    if (errors === _errs58) {
                                                                                                        if (errors === _errs58) {
                                                                                                            if (typeof data19 === 'string') {
                                                                                                                if (!formats6.test(data19)) {
                                                                                                                    validate189.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath + '/result/lastRunBy',
                                                                                                                            schemaPath: 'urn:wisepipe-common-computation:UnitTestRun/properties/lastRunBy/format',
                                                                                                                            keyword: 'format',
                                                                                                                            params: { format: 'uuid' },
                                                                                                                            message: 'must match format "' + 'uuid' + '"'
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                            }
                                                                                                            else {
                                                                                                                validate189.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/result/lastRunBy',
                                                                                                                        schemaPath: 'urn:wisepipe-common-computation:UnitTestRun/properties/lastRunBy/type',
                                                                                                                        keyword: 'type',
                                                                                                                        params: { type: 'string' },
                                                                                                                        message: 'must be string'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                    var valid14 = _errs58 === errors;
                                                                                                }
                                                                                                else {
                                                                                                    var valid14 = true;
                                                                                                }
                                                                                                if (valid14) {
                                                                                                    if (data15.lastRunAt !== undefined) {
                                                                                                        let data20 = data15.lastRunAt;
                                                                                                        const _errs60 = errors;
                                                                                                        if (errors === _errs60) {
                                                                                                            if (errors === _errs60) {
                                                                                                                if (typeof data20 === 'string') {
                                                                                                                    if (!formats0.validate(data20)) {
                                                                                                                        validate189.errors = [
                                                                                                                            {
                                                                                                                                instancePath: instancePath + '/result/lastRunAt',
                                                                                                                                schemaPath: 'urn:wisepipe-common-computation:UnitTestRun/properties/lastRunAt/format',
                                                                                                                                keyword: 'format',
                                                                                                                                params: { format: 'date-time' },
                                                                                                                                message: 'must match format "' + 'date-time' + '"'
                                                                                                                            }
                                                                                                                        ];
                                                                                                                        return false;
                                                                                                                    }
                                                                                                                }
                                                                                                                else {
                                                                                                                    validate189.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath + '/result/lastRunAt',
                                                                                                                            schemaPath: 'urn:wisepipe-common-computation:UnitTestRun/properties/lastRunAt/type',
                                                                                                                            keyword: 'type',
                                                                                                                            params: { type: 'string' },
                                                                                                                            message: 'must be string'
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                        var valid14 = _errs60 === errors;
                                                                                                    }
                                                                                                    else {
                                                                                                        var valid14 = true;
                                                                                                    }
                                                                                                    if (valid14) {
                                                                                                        if (data15.taskID !== undefined) {
                                                                                                            let data21 = data15.taskID;
                                                                                                            const _errs62 = errors;
                                                                                                            if (errors === _errs62) {
                                                                                                                if (typeof data21 === 'string') {
                                                                                                                    if (func2(data21) < 1) {
                                                                                                                        validate189.errors = [
                                                                                                                            {
                                                                                                                                instancePath: instancePath + '/result/taskID',
                                                                                                                                schemaPath: 'urn:wisepipe-common-computation:UnitTestRun/properties/taskID/minLength',
                                                                                                                                keyword: 'minLength',
                                                                                                                                params: { limit: 1 },
                                                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                                                            }
                                                                                                                        ];
                                                                                                                        return false;
                                                                                                                    }
                                                                                                                }
                                                                                                                else {
                                                                                                                    validate189.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath + '/result/taskID',
                                                                                                                            schemaPath: 'urn:wisepipe-common-computation:UnitTestRun/properties/taskID/type',
                                                                                                                            keyword: 'type',
                                                                                                                            params: { type: 'string' },
                                                                                                                            message: 'must be string'
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                            }
                                                                                                            var valid14 = _errs62 === errors;
                                                                                                        }
                                                                                                        else {
                                                                                                            var valid14 = true;
                                                                                                        }
                                                                                                        if (valid14) {
                                                                                                            if (data15.error !== undefined) {
                                                                                                                let data22 = data15.error;
                                                                                                                const _errs64 = errors;
                                                                                                                if (!(data22 &&
                                                                                                                    typeof data22 == 'object' &&
                                                                                                                    !Array.isArray(data22))) {
                                                                                                                    validate189.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath + '/result/error',
                                                                                                                            schemaPath: 'urn:wisepipe-common-computation:UnitTestRun/properties/error/type',
                                                                                                                            keyword: 'type',
                                                                                                                            params: { type: 'object' },
                                                                                                                            message: 'must be object'
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                                var valid14 = _errs64 === errors;
                                                                                                            }
                                                                                                            else {
                                                                                                                var valid14 = true;
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate189.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/result',
                                                                                            schemaPath: 'urn:wisepipe-common-computation:UnitTestRun/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'object' },
                                                                                            message: 'must be object'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid5 = _errs45 === errors;
                                                                        }
                                                                        else {
                                                                            var valid5 = true;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate189.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate189.errors = vErrors;
    return errors === 0;
}
function validate188(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:UnitTestTask" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.taskID === undefined && (missing0 = 'taskID')) ||
                (data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.userID === undefined && (missing0 = 'userID'))) {
                validate188.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.taskID !== undefined) {
                    let data0 = data.taskID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate188.errors = [
                                    {
                                        instancePath: instancePath + '/taskID',
                                        schemaPath: '#/properties/taskID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate188.errors = [
                                {
                                    instancePath: instancePath + '/taskID',
                                    schemaPath: '#/properties/taskID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.userID !== undefined) {
                        let data1 = data.userID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats6.test(data1)) {
                                        validate188.errors = [
                                            {
                                                instancePath: instancePath + '/userID',
                                                schemaPath: '#/properties/userID/format',
                                                keyword: 'format',
                                                params: { format: 'uuid' },
                                                message: 'must match format "' + 'uuid' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate188.errors = [
                                        {
                                            instancePath: instancePath + '/userID',
                                            schemaPath: '#/properties/userID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.userName !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.userName !== 'string') {
                                validate188.errors = [
                                    {
                                        instancePath: instancePath + '/userName',
                                        schemaPath: '#/properties/userName/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.userEmail !== undefined) {
                                const _errs7 = errors;
                                if (typeof data.userEmail !== 'string') {
                                    validate188.errors = [
                                        {
                                            instancePath: instancePath + '/userEmail',
                                            schemaPath: '#/properties/userEmail/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.orgID !== undefined) {
                                    let data4 = data.orgID;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (errors === _errs9) {
                                            if (typeof data4 === 'string') {
                                                if (!formats6.test(data4)) {
                                                    validate188.errors = [
                                                        {
                                                            instancePath: instancePath + '/orgID',
                                                            schemaPath: '#/properties/orgID/format',
                                                            keyword: 'format',
                                                            params: { format: 'uuid' },
                                                            message: 'must match format "' + 'uuid' + '"'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate188.errors = [
                                                    {
                                                        instancePath: instancePath + '/orgID',
                                                        schemaPath: '#/properties/orgID/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.orgPlan !== undefined) {
                                        let data5 = data.orgPlan;
                                        const _errs11 = errors;
                                        if (typeof data5 !== 'string') {
                                            validate188.errors = [
                                                {
                                                    instancePath: instancePath + '/orgPlan',
                                                    schemaPath: '#/properties/orgPlan/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (!(data5 === 'Social' ||
                                            data5 === 'Enterprise' ||
                                            data5 === 'Integration' ||
                                            data5 === 'Temp' ||
                                            data5 === 'Starter' ||
                                            data5 === 'Professional')) {
                                            validate188.errors = [
                                                {
                                                    instancePath: instancePath + '/orgPlan',
                                                    schemaPath: '#/properties/orgPlan/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema206.properties.orgPlan.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.unitTest !== undefined) {
                                            const _errs13 = errors;
                                            if (!validate189(data.unitTest, {
                                                instancePath: instancePath + '/unitTest',
                                                parentData: data,
                                                parentDataProperty: 'unitTest',
                                                rootData
                                            })) {
                                                vErrors = vErrors === null ? validate189.errors : vErrors.concat(validate189.errors);
                                                errors = vErrors.length;
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.updateSnapshot !== undefined) {
                                                const _errs14 = errors;
                                                if (typeof data.updateSnapshot !== 'boolean') {
                                                    validate188.errors = [
                                                        {
                                                            instancePath: instancePath + '/updateSnapshot',
                                                            schemaPath: '#/properties/updateSnapshot/type',
                                                            keyword: 'type',
                                                            params: { type: 'boolean' },
                                                            message: 'must be boolean'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid0 = _errs14 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate188.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate188.errors = vErrors;
    return errors === 0;
}
function validate187(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:UnitTestInput" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.task === undefined && (missing0 = 'task')) {
                validate187.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.task !== undefined) {
                    if (!validate188(data.task, {
                        instancePath: instancePath + '/task',
                        parentData: data,
                        parentDataProperty: 'task',
                        rootData
                    })) {
                        vErrors = vErrors === null ? validate188.errors : vErrors.concat(validate188.errors);
                        errors = vErrors.length;
                    }
                }
            }
        }
        else {
            validate187.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate187.errors = vErrors;
    return errors === 0;
}
export const unitTestPreviewRequestSchemaValidation = validate193;
const schema209 = {
    $id: 'urn:wisepipe-common-computation:UnitTestPreviewRequest',
    type: 'object',
    properties: {
        elementID: { type: 'string', uid: 10 },
        port: { type: 'string', minLength: 1 },
        unitTestID: { type: 'string', uid: 9 }
    },
    required: ['elementID', 'unitTestID', 'port']
};
const func542 = ucs2length;
const func543 = base64urlToBuffer;
const func544 = base64urlEncode;
const func545 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func547 = ucs2length;
const func548 = base64urlToBuffer;
const func549 = base64urlEncode;
const func550 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate193(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:UnitTestPreviewRequest" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.elementID === undefined && (missing0 = 'elementID')) ||
                (data.unitTestID === undefined && (missing0 = 'unitTestID')) ||
                (data.port === undefined && (missing0 = 'port'))) {
                validate193.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.elementID !== undefined) {
                    let data0 = data.elementID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func542(data0) < b64min0 || func542(data0) > b64max0) {
                                validate193.errors = [
                                    {
                                        instancePath: instancePath + '/elementID',
                                        schemaPath: '#/properties/elementID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func542(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func542(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func543(data0);
                                if (decoded0.length !== 10) {
                                    validate193.errors = [
                                        {
                                            instancePath: instancePath + '/elementID',
                                            schemaPath: '#/properties/elementID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func544(decoded0);
                                    if (func545(encoded0) !== func545(data0)) {
                                        validate193.errors = [
                                            {
                                                instancePath: instancePath + '/elementID',
                                                schemaPath: '#/properties/elementID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate193.errors = [
                                {
                                    instancePath: instancePath + '/elementID',
                                    schemaPath: '#/properties/elementID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.port !== undefined) {
                        let data1 = data.port;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate193.errors = [
                                        {
                                            instancePath: instancePath + '/port',
                                            schemaPath: '#/properties/port/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate193.errors = [
                                    {
                                        instancePath: instancePath + '/port',
                                        schemaPath: '#/properties/port/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.unitTestID !== undefined) {
                            let data2 = data.unitTestID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    const b64min1 = Math.ceil((4 * 9) / 3);
                                    const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                    if (func547(data2) < b64min1 || func547(data2) > b64max1) {
                                        validate193.errors = [
                                            {
                                                instancePath: instancePath + '/unitTestID',
                                                schemaPath: '#/properties/unitTestID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func547(data2) },
                                                message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func547(data2)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded1 = func548(data2);
                                        if (decoded1.length !== 9) {
                                            validate193.errors = [
                                                {
                                                    instancePath: instancePath + '/unitTestID',
                                                    schemaPath: '#/properties/unitTestID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 9 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded1 = func549(decoded1);
                                            if (func550(encoded1) !== func550(data2)) {
                                                validate193.errors = [
                                                    {
                                                        instancePath: instancePath + '/unitTestID',
                                                        schemaPath: '#/properties/unitTestID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate193.errors = [
                                        {
                                            instancePath: instancePath + '/unitTestID',
                                            schemaPath: '#/properties/unitTestID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate193.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate193.errors = vErrors;
    return errors === 0;
}
export const unitTestRequestSchemaValidation = validate194;
const schema210 = {
    $id: 'urn:wisepipe-common-computation:UnitTestRequest',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1, maxLength: 100 },
        description: { type: 'string', minLength: 1, maxLength: 1000 },
        pipeID: { type: 'string', uid: 10 },
        elementID: { type: 'string', uid: 10 },
        port: { type: 'string', minLength: 1 },
        dataMap: { type: 'object', additionalProperties: { $ref: 'urn:wisepipe-common-pipe:UnitTestDataOverride' } },
        isAIGenerated: { type: 'boolean' }
    },
    required: ['name', 'pipeID', 'elementID', 'port']
};
const func555 = ucs2length;
const func556 = base64urlToBuffer;
const func557 = base64urlEncode;
const func558 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func559 = ucs2length;
const func560 = base64urlToBuffer;
const func561 = base64urlEncode;
const func562 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate194(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:UnitTestRequest" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.name === undefined && (missing0 = 'name')) ||
                (data.pipeID === undefined && (missing0 = 'pipeID')) ||
                (data.elementID === undefined && (missing0 = 'elementID')) ||
                (data.port === undefined && (missing0 = 'port'))) {
                validate194.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data0 = data.name;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 100) {
                                validate194.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 100 },
                                        message: 'must NOT have more than 100 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate194.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate194.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.description !== undefined) {
                        let data1 = data.description;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 1000) {
                                    validate194.errors = [
                                        {
                                            instancePath: instancePath + '/description',
                                            schemaPath: '#/properties/description/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 1000 },
                                            message: 'must NOT have more than 1000 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate194.errors = [
                                            {
                                                instancePath: instancePath + '/description',
                                                schemaPath: '#/properties/description/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate194.errors = [
                                    {
                                        instancePath: instancePath + '/description',
                                        schemaPath: '#/properties/description/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.pipeID !== undefined) {
                            let data2 = data.pipeID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    const b64min0 = Math.ceil((4 * 10) / 3);
                                    const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                                    if (func555(data2) < b64min0 || func555(data2) > b64max0) {
                                        validate194.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func555(data2) },
                                                message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func555(data2)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded0 = func556(data2);
                                        if (decoded0.length !== 10) {
                                            validate194.errors = [
                                                {
                                                    instancePath: instancePath + '/pipeID',
                                                    schemaPath: '#/properties/pipeID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 10 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded0 = func557(decoded0);
                                            if (func558(encoded0) !== func558(data2)) {
                                                validate194.errors = [
                                                    {
                                                        instancePath: instancePath + '/pipeID',
                                                        schemaPath: '#/properties/pipeID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate194.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.elementID !== undefined) {
                                let data3 = data.elementID;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        const b64min1 = Math.ceil((4 * 10) / 3);
                                        const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                        if (func559(data3) < b64min1 || func559(data3) > b64max1) {
                                            validate194.errors = [
                                                {
                                                    instancePath: instancePath + '/elementID',
                                                    schemaPath: '#/properties/elementID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func559(data3) },
                                                    message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func559(data3)
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const decoded1 = func560(data3);
                                            if (decoded1.length !== 10) {
                                                validate194.errors = [
                                                    {
                                                        instancePath: instancePath + '/elementID',
                                                        schemaPath: '#/properties/elementID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'decoded' },
                                                        message: 'must decode to 10 bytes'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const encoded1 = func561(decoded1);
                                                if (func562(encoded1) !== func562(data3)) {
                                                    validate194.errors = [
                                                        {
                                                            instancePath: instancePath + '/elementID',
                                                            schemaPath: '#/properties/elementID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'ambiguous' },
                                                            message: 'encoding is ambiguous'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate194.errors = [
                                            {
                                                instancePath: instancePath + '/elementID',
                                                schemaPath: '#/properties/elementID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.port !== undefined) {
                                    let data4 = data.port;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (typeof data4 === 'string') {
                                            if (func2(data4) < 1) {
                                                validate194.errors = [
                                                    {
                                                        instancePath: instancePath + '/port',
                                                        schemaPath: '#/properties/port/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate194.errors = [
                                                {
                                                    instancePath: instancePath + '/port',
                                                    schemaPath: '#/properties/port/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.dataMap !== undefined) {
                                        let data5 = data.dataMap;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                                for (const key0 in data5) {
                                                    const _errs14 = errors;
                                                    if (!validate186(data5[key0], {
                                                        instancePath: instancePath + '/dataMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                        parentData: data5,
                                                        parentDataProperty: key0,
                                                        rootData
                                                    })) {
                                                        vErrors = vErrors === null ? validate186.errors : vErrors.concat(validate186.errors);
                                                        errors = vErrors.length;
                                                    }
                                                    var valid3 = _errs14 === errors;
                                                    if (!valid3) {
                                                        break;
                                                    }
                                                }
                                            }
                                            else {
                                                validate194.errors = [
                                                    {
                                                        instancePath: instancePath + '/dataMap',
                                                        schemaPath: '#/properties/dataMap/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.isAIGenerated !== undefined) {
                                            const _errs15 = errors;
                                            if (typeof data.isAIGenerated !== 'boolean') {
                                                validate194.errors = [
                                                    {
                                                        instancePath: instancePath + '/isAIGenerated',
                                                        schemaPath: '#/properties/isAIGenerated/type',
                                                        keyword: 'type',
                                                        params: { type: 'boolean' },
                                                        message: 'must be boolean'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs15 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate194.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate194.errors = vErrors;
    return errors === 0;
}
export const unitTestResultColumnSchemaValidation = validate196;
const schema211 = {
    $id: 'urn:wisepipe-common-computation:UnitTestResultColumn',
    type: 'object',
    properties: {
        status: { type: 'string', enum: ['new', 'deleted', 'unchanged'] },
        column: { $ref: 'urn:wisepipe-common-data:Column' }
    },
    required: ['status', 'column']
};
function validate196(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:UnitTestResultColumn" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.status === undefined && (missing0 = 'status')) ||
                (data.column === undefined && (missing0 = 'column'))) {
                validate196.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.status !== undefined) {
                    let data0 = data.status;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate196.errors = [
                            {
                                instancePath: instancePath + '/status',
                                schemaPath: '#/properties/status/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'new' || data0 === 'deleted' || data0 === 'unchanged')) {
                        validate196.errors = [
                            {
                                instancePath: instancePath + '/status',
                                schemaPath: '#/properties/status/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema211.properties.status.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.column !== undefined) {
                        const _errs3 = errors;
                        if (!validate45(data.column, {
                            instancePath: instancePath + '/column',
                            parentData: data,
                            parentDataProperty: 'column',
                            rootData
                        })) {
                            vErrors = vErrors === null ? validate45.errors : vErrors.concat(validate45.errors);
                            errors = vErrors.length;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate196.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate196.errors = vErrors;
    return errors === 0;
}
export const unitTestResultRowSchemaValidation = validate198;
const schema212 = {
    $id: 'urn:wisepipe-common-computation:UnitTestResultRow',
    type: 'object',
    properties: {
        status: { type: 'string', enum: ['new', 'deleted', 'modified', 'unchanged'] },
        row: {
            type: 'array',
            items: {
                anyOf: [
                    { type: ['boolean', 'string', 'number', 'null'] },
                    {
                        type: 'object',
                        properties: {
                            before: { type: ['boolean', 'string', 'number', 'null'] },
                            after: { type: ['boolean', 'string', 'number', 'null'] }
                        }
                    }
                ]
            }
        }
    },
    required: ['status', 'row']
};
function validate198(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:UnitTestResultRow" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.status === undefined && (missing0 = 'status')) || (data.row === undefined && (missing0 = 'row'))) {
                validate198.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.status !== undefined) {
                    let data0 = data.status;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate198.errors = [
                            {
                                instancePath: instancePath + '/status',
                                schemaPath: '#/properties/status/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'new' || data0 === 'deleted' || data0 === 'modified' || data0 === 'unchanged')) {
                        validate198.errors = [
                            {
                                instancePath: instancePath + '/status',
                                schemaPath: '#/properties/status/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema212.properties.status.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.row !== undefined) {
                        let data1 = data.row;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                var valid1 = true;
                                const len0 = data1.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data2 = data1[i0];
                                    const _errs5 = errors;
                                    const _errs6 = errors;
                                    let valid2 = false;
                                    const _errs7 = errors;
                                    if (typeof data2 !== 'boolean' &&
                                        typeof data2 !== 'string' &&
                                        !(typeof data2 == 'number') &&
                                        data2 !== null) {
                                        const err0 = {
                                            instancePath: instancePath + '/row/' + i0,
                                            schemaPath: '#/properties/row/items/anyOf/0/type',
                                            keyword: 'type',
                                            params: { type: schema212.properties.row.items.anyOf[0].type },
                                            message: 'must be boolean,string,number,null'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err0];
                                        }
                                        else {
                                            vErrors.push(err0);
                                        }
                                        errors++;
                                    }
                                    var _valid0 = _errs7 === errors;
                                    valid2 = valid2 || _valid0;
                                    if (!valid2) {
                                        const _errs9 = errors;
                                        if (errors === _errs9) {
                                            if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                                if (data2.before !== undefined) {
                                                    let data3 = data2.before;
                                                    const _errs11 = errors;
                                                    if (typeof data3 !== 'boolean' &&
                                                        typeof data3 !== 'string' &&
                                                        !(typeof data3 == 'number') &&
                                                        data3 !== null) {
                                                        const err1 = {
                                                            instancePath: instancePath + '/row/' + i0 + '/before',
                                                            schemaPath: '#/properties/row/items/anyOf/1/properties/before/type',
                                                            keyword: 'type',
                                                            params: { type: schema212.properties.row.items.anyOf[1].properties.before.type },
                                                            message: 'must be boolean,string,number,null'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err1];
                                                        }
                                                        else {
                                                            vErrors.push(err1);
                                                        }
                                                        errors++;
                                                    }
                                                    var valid3 = _errs11 === errors;
                                                }
                                                else {
                                                    var valid3 = true;
                                                }
                                                if (valid3) {
                                                    if (data2.after !== undefined) {
                                                        let data4 = data2.after;
                                                        const _errs13 = errors;
                                                        if (typeof data4 !== 'boolean' &&
                                                            typeof data4 !== 'string' &&
                                                            !(typeof data4 == 'number') &&
                                                            data4 !== null) {
                                                            const err2 = {
                                                                instancePath: instancePath + '/row/' + i0 + '/after',
                                                                schemaPath: '#/properties/row/items/anyOf/1/properties/after/type',
                                                                keyword: 'type',
                                                                params: { type: schema212.properties.row.items.anyOf[1].properties.after.type },
                                                                message: 'must be boolean,string,number,null'
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err2];
                                                            }
                                                            else {
                                                                vErrors.push(err2);
                                                            }
                                                            errors++;
                                                        }
                                                        var valid3 = _errs13 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                }
                                            }
                                            else {
                                                const err3 = {
                                                    instancePath: instancePath + '/row/' + i0,
                                                    schemaPath: '#/properties/row/items/anyOf/1/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err3];
                                                }
                                                else {
                                                    vErrors.push(err3);
                                                }
                                                errors++;
                                            }
                                        }
                                        var _valid0 = _errs9 === errors;
                                        valid2 = valid2 || _valid0;
                                    }
                                    if (!valid2) {
                                        const err4 = {
                                            instancePath: instancePath + '/row/' + i0,
                                            schemaPath: '#/properties/row/items/anyOf',
                                            keyword: 'anyOf',
                                            params: {},
                                            message: 'must match a schema in anyOf'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err4];
                                        }
                                        else {
                                            vErrors.push(err4);
                                        }
                                        errors++;
                                        validate198.errors = vErrors;
                                        return false;
                                    }
                                    else {
                                        errors = _errs6;
                                        if (vErrors !== null) {
                                            if (_errs6) {
                                                vErrors.length = _errs6;
                                            }
                                            else {
                                                vErrors = null;
                                            }
                                        }
                                    }
                                    var valid1 = _errs5 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate198.errors = [
                                    {
                                        instancePath: instancePath + '/row',
                                        schemaPath: '#/properties/row/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate198.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate198.errors = vErrors;
    return errors === 0;
}
export const unitTestRowViewerResultSchemaValidation = validate199;
const schema213 = {
    $id: 'urn:wisepipe-common-computation:UnitTestRowViewerResult',
    type: 'object',
    properties: {
        unitTestID: { type: 'string', uid: 9 },
        status: { type: 'string', enum: ['passed', 'failed', 'error', 'running', 'noSnapshotFound'] }
    },
    required: ['unitTestID', 'status'],
    allOf: [
        {
            if: { properties: { status: { const: 'noSnapshotFound' } } },
            then: {
                properties: {
                    columns: { type: 'array', items: { $ref: 'urn:wisepipe-common-data:Column' } },
                    rows: { type: 'array', items: { type: 'array', items: { type: ['boolean', 'string', 'number', 'null'] } } }
                },
                required: ['columns', 'rows']
            }
        },
        {
            if: { properties: { status: { oneOf: [{ const: 'passed' }, { const: 'failed' }] } } },
            then: {
                properties: {
                    columns: { type: 'array', items: { $ref: 'urn:wisepipe-common-computation:UnitTestResultColumn' } },
                    rows: { type: 'array', items: { $ref: 'urn:wisepipe-common-computation:UnitTestResultRow' } }
                },
                required: ['columns', 'rows']
            }
        },
        {
            if: { properties: { status: { const: 'running' } } },
            then: {
                properties: {
                    progress: { type: 'number', minimum: 0, maximum: 1 },
                    continuationToken: { type: 'string', uid: 9 }
                },
                required: ['progress', 'continuationToken']
            }
        }
    ]
};
const func564 = ucs2length;
const func565 = base64urlToBuffer;
const func566 = base64urlEncode;
const func567 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func568 = ucs2length;
const func569 = base64urlToBuffer;
const func570 = base64urlEncode;
const func571 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate199(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:UnitTestRowViewerResult" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    const _errs2 = errors;
    let valid1 = true;
    const _errs3 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.status !== undefined) {
            if ('noSnapshotFound' !== data.status) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs3 === errors;
    errors = _errs2;
    if (vErrors !== null) {
        if (_errs2) {
            vErrors.length = _errs2;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.columns === undefined && (missing0 = 'columns')) || (data.rows === undefined && (missing0 = 'rows'))) {
                validate199.errors = [
                    {
                        instancePath,
                        schemaPath: '#/allOf/0/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data1 = data.columns;
                    const _errs6 = errors;
                    if (errors === _errs6) {
                        if (Array.isArray(data1)) {
                            var valid4 = true;
                            const len0 = data1.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                const _errs8 = errors;
                                if (!validate45(data1[i0], {
                                    instancePath: instancePath + '/columns/' + i0,
                                    parentData: data1,
                                    parentDataProperty: i0,
                                    rootData
                                })) {
                                    vErrors = vErrors === null ? validate45.errors : vErrors.concat(validate45.errors);
                                    errors = vErrors.length;
                                }
                                var valid4 = _errs8 === errors;
                                if (!valid4) {
                                    break;
                                }
                            }
                        }
                        else {
                            validate199.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/allOf/0/then/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid3 = _errs6 === errors;
                }
                else {
                    var valid3 = true;
                }
                if (valid3) {
                    if (data.rows !== undefined) {
                        let data3 = data.rows;
                        const _errs9 = errors;
                        if (errors === _errs9) {
                            if (Array.isArray(data3)) {
                                var valid5 = true;
                                const len1 = data3.length;
                                for (let i1 = 0; i1 < len1; i1++) {
                                    let data4 = data3[i1];
                                    const _errs11 = errors;
                                    if (errors === _errs11) {
                                        if (Array.isArray(data4)) {
                                            var valid6 = true;
                                            const len2 = data4.length;
                                            for (let i2 = 0; i2 < len2; i2++) {
                                                let data5 = data4[i2];
                                                const _errs13 = errors;
                                                if (typeof data5 !== 'boolean' &&
                                                    typeof data5 !== 'string' &&
                                                    !(typeof data5 == 'number') &&
                                                    data5 !== null) {
                                                    validate199.errors = [
                                                        {
                                                            instancePath: instancePath + '/rows/' + i1 + '/' + i2,
                                                            schemaPath: '#/allOf/0/then/properties/rows/items/items/type',
                                                            keyword: 'type',
                                                            params: { type: schema213.allOf[0].then.properties.rows.items.items.type },
                                                            message: 'must be boolean,string,number,null'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid6 = _errs13 === errors;
                                                if (!valid6) {
                                                    break;
                                                }
                                            }
                                        }
                                        else {
                                            validate199.errors = [
                                                {
                                                    instancePath: instancePath + '/rows/' + i1,
                                                    schemaPath: '#/allOf/0/then/properties/rows/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'array' },
                                                    message: 'must be array'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid5 = _errs11 === errors;
                                    if (!valid5) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate199.errors = [
                                    {
                                        instancePath: instancePath + '/rows',
                                        schemaPath: '#/allOf/0/then/properties/rows/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid3 = _errs9 === errors;
                    }
                    else {
                        var valid3 = true;
                    }
                }
            }
        }
        var _valid0 = _errs5 === errors;
        valid1 = _valid0;
    }
    if (!valid1) {
        const err1 = {
            instancePath,
            schemaPath: '#/allOf/0/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate199.errors = vErrors;
        return false;
    }
    var valid0 = _errs1 === errors;
    if (valid0) {
        const _errs15 = errors;
        const _errs16 = errors;
        let valid7 = true;
        const _errs17 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.status !== undefined) {
                let data6 = data.status;
                const _errs19 = errors;
                let valid9 = false;
                let passing0 = null;
                const _errs20 = errors;
                if ('passed' !== data6) {
                    const err2 = {};
                    if (vErrors === null) {
                        vErrors = [err2];
                    }
                    else {
                        vErrors.push(err2);
                    }
                    errors++;
                }
                var _valid2 = _errs20 === errors;
                if (_valid2) {
                    valid9 = true;
                    passing0 = 0;
                }
                const _errs21 = errors;
                if ('failed' !== data6) {
                    const err3 = {};
                    if (vErrors === null) {
                        vErrors = [err3];
                    }
                    else {
                        vErrors.push(err3);
                    }
                    errors++;
                }
                var _valid2 = _errs21 === errors;
                if (_valid2 && valid9) {
                    valid9 = false;
                    passing0 = [passing0, 1];
                }
                else {
                    if (_valid2) {
                        valid9 = true;
                        passing0 = 1;
                    }
                }
                if (!valid9) {
                    const err4 = {};
                    if (vErrors === null) {
                        vErrors = [err4];
                    }
                    else {
                        vErrors.push(err4);
                    }
                    errors++;
                }
                else {
                    errors = _errs19;
                    if (vErrors !== null) {
                        if (_errs19) {
                            vErrors.length = _errs19;
                        }
                        else {
                            vErrors = null;
                        }
                    }
                }
            }
        }
        var _valid1 = _errs17 === errors;
        errors = _errs16;
        if (vErrors !== null) {
            if (_errs16) {
                vErrors.length = _errs16;
            }
            else {
                vErrors = null;
            }
        }
        if (_valid1) {
            const _errs22 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing1;
                if ((data.columns === undefined && (missing1 = 'columns')) ||
                    (data.rows === undefined && (missing1 = 'rows'))) {
                    validate199.errors = [
                        {
                            instancePath,
                            schemaPath: '#/allOf/1/then/required',
                            keyword: 'required',
                            params: { missingProperty: missing1 },
                            message: "must have required property '" + missing1 + "'"
                        }
                    ];
                    return false;
                }
                else {
                    if (data.columns !== undefined) {
                        let data7 = data.columns;
                        const _errs23 = errors;
                        if (errors === _errs23) {
                            if (Array.isArray(data7)) {
                                var valid11 = true;
                                const len3 = data7.length;
                                for (let i3 = 0; i3 < len3; i3++) {
                                    const _errs25 = errors;
                                    if (!validate196(data7[i3], {
                                        instancePath: instancePath + '/columns/' + i3,
                                        parentData: data7,
                                        parentDataProperty: i3,
                                        rootData
                                    })) {
                                        vErrors = vErrors === null ? validate196.errors : vErrors.concat(validate196.errors);
                                        errors = vErrors.length;
                                    }
                                    var valid11 = _errs25 === errors;
                                    if (!valid11) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate199.errors = [
                                    {
                                        instancePath: instancePath + '/columns',
                                        schemaPath: '#/allOf/1/then/properties/columns/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid10 = _errs23 === errors;
                    }
                    else {
                        var valid10 = true;
                    }
                    if (valid10) {
                        if (data.rows !== undefined) {
                            let data9 = data.rows;
                            const _errs26 = errors;
                            if (errors === _errs26) {
                                if (Array.isArray(data9)) {
                                    var valid12 = true;
                                    const len4 = data9.length;
                                    for (let i4 = 0; i4 < len4; i4++) {
                                        let data10 = data9[i4];
                                        const _errs28 = errors;
                                        const _errs29 = errors;
                                        if (errors === _errs29) {
                                            if (data10 && typeof data10 == 'object' && !Array.isArray(data10)) {
                                                let missing2;
                                                if ((data10.status === undefined && (missing2 = 'status')) ||
                                                    (data10.row === undefined && (missing2 = 'row'))) {
                                                    validate199.errors = [
                                                        {
                                                            instancePath: instancePath + '/rows/' + i4,
                                                            schemaPath: 'urn:wisepipe-common-computation:UnitTestResultRow/required',
                                                            keyword: 'required',
                                                            params: { missingProperty: missing2 },
                                                            message: "must have required property '" + missing2 + "'"
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (data10.status !== undefined) {
                                                        let data11 = data10.status;
                                                        const _errs31 = errors;
                                                        if (typeof data11 !== 'string') {
                                                            validate199.errors = [
                                                                {
                                                                    instancePath: instancePath + '/rows/' + i4 + '/status',
                                                                    schemaPath: 'urn:wisepipe-common-computation:UnitTestResultRow/properties/status/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        if (!(data11 === 'new' ||
                                                            data11 === 'deleted' ||
                                                            data11 === 'modified' ||
                                                            data11 === 'unchanged')) {
                                                            validate199.errors = [
                                                                {
                                                                    instancePath: instancePath + '/rows/' + i4 + '/status',
                                                                    schemaPath: 'urn:wisepipe-common-computation:UnitTestResultRow/properties/status/enum',
                                                                    keyword: 'enum',
                                                                    params: { allowedValues: schema212.properties.status.enum },
                                                                    message: 'must be equal to one of the allowed values'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid14 = _errs31 === errors;
                                                    }
                                                    else {
                                                        var valid14 = true;
                                                    }
                                                    if (valid14) {
                                                        if (data10.row !== undefined) {
                                                            let data12 = data10.row;
                                                            const _errs33 = errors;
                                                            if (errors === _errs33) {
                                                                if (Array.isArray(data12)) {
                                                                    var valid15 = true;
                                                                    const len5 = data12.length;
                                                                    for (let i5 = 0; i5 < len5; i5++) {
                                                                        let data13 = data12[i5];
                                                                        const _errs35 = errors;
                                                                        const _errs36 = errors;
                                                                        let valid16 = false;
                                                                        const _errs37 = errors;
                                                                        if (typeof data13 !== 'boolean' &&
                                                                            typeof data13 !== 'string' &&
                                                                            !(typeof data13 == 'number') &&
                                                                            data13 !== null) {
                                                                            const err5 = {
                                                                                instancePath: instancePath + '/rows/' + i4 + '/row/' + i5,
                                                                                schemaPath: 'urn:wisepipe-common-computation:UnitTestResultRow/properties/row/items/anyOf/0/type',
                                                                                keyword: 'type',
                                                                                params: { type: schema212.properties.row.items.anyOf[0].type },
                                                                                message: 'must be boolean,string,number,null'
                                                                            };
                                                                            if (vErrors === null) {
                                                                                vErrors = [err5];
                                                                            }
                                                                            else {
                                                                                vErrors.push(err5);
                                                                            }
                                                                            errors++;
                                                                        }
                                                                        var _valid3 = _errs37 === errors;
                                                                        valid16 = valid16 || _valid3;
                                                                        if (!valid16) {
                                                                            const _errs39 = errors;
                                                                            if (errors === _errs39) {
                                                                                if (data13 && typeof data13 == 'object' && !Array.isArray(data13)) {
                                                                                    if (data13.before !== undefined) {
                                                                                        let data14 = data13.before;
                                                                                        const _errs41 = errors;
                                                                                        if (typeof data14 !== 'boolean' &&
                                                                                            typeof data14 !== 'string' &&
                                                                                            !(typeof data14 == 'number') &&
                                                                                            data14 !== null) {
                                                                                            const err6 = {
                                                                                                instancePath: instancePath + '/rows/' + i4 + '/row/' + i5 + '/before',
                                                                                                schemaPath: 'urn:wisepipe-common-computation:UnitTestResultRow/properties/row/items/anyOf/1/properties/before/type',
                                                                                                keyword: 'type',
                                                                                                params: {
                                                                                                    type: schema212.properties.row.items.anyOf[1].properties.before.type
                                                                                                },
                                                                                                message: 'must be boolean,string,number,null'
                                                                                            };
                                                                                            if (vErrors === null) {
                                                                                                vErrors = [err6];
                                                                                            }
                                                                                            else {
                                                                                                vErrors.push(err6);
                                                                                            }
                                                                                            errors++;
                                                                                        }
                                                                                        var valid17 = _errs41 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid17 = true;
                                                                                    }
                                                                                    if (valid17) {
                                                                                        if (data13.after !== undefined) {
                                                                                            let data15 = data13.after;
                                                                                            const _errs43 = errors;
                                                                                            if (typeof data15 !== 'boolean' &&
                                                                                                typeof data15 !== 'string' &&
                                                                                                !(typeof data15 == 'number') &&
                                                                                                data15 !== null) {
                                                                                                const err7 = {
                                                                                                    instancePath: instancePath + '/rows/' + i4 + '/row/' + i5 + '/after',
                                                                                                    schemaPath: 'urn:wisepipe-common-computation:UnitTestResultRow/properties/row/items/anyOf/1/properties/after/type',
                                                                                                    keyword: 'type',
                                                                                                    params: {
                                                                                                        type: schema212.properties.row.items.anyOf[1].properties.after.type
                                                                                                    },
                                                                                                    message: 'must be boolean,string,number,null'
                                                                                                };
                                                                                                if (vErrors === null) {
                                                                                                    vErrors = [err7];
                                                                                                }
                                                                                                else {
                                                                                                    vErrors.push(err7);
                                                                                                }
                                                                                                errors++;
                                                                                            }
                                                                                            var valid17 = _errs43 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid17 = true;
                                                                                        }
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    const err8 = {
                                                                                        instancePath: instancePath + '/rows/' + i4 + '/row/' + i5,
                                                                                        schemaPath: 'urn:wisepipe-common-computation:UnitTestResultRow/properties/row/items/anyOf/1/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'object' },
                                                                                        message: 'must be object'
                                                                                    };
                                                                                    if (vErrors === null) {
                                                                                        vErrors = [err8];
                                                                                    }
                                                                                    else {
                                                                                        vErrors.push(err8);
                                                                                    }
                                                                                    errors++;
                                                                                }
                                                                            }
                                                                            var _valid3 = _errs39 === errors;
                                                                            valid16 = valid16 || _valid3;
                                                                        }
                                                                        if (!valid16) {
                                                                            const err9 = {
                                                                                instancePath: instancePath + '/rows/' + i4 + '/row/' + i5,
                                                                                schemaPath: 'urn:wisepipe-common-computation:UnitTestResultRow/properties/row/items/anyOf',
                                                                                keyword: 'anyOf',
                                                                                params: {},
                                                                                message: 'must match a schema in anyOf'
                                                                            };
                                                                            if (vErrors === null) {
                                                                                vErrors = [err9];
                                                                            }
                                                                            else {
                                                                                vErrors.push(err9);
                                                                            }
                                                                            errors++;
                                                                            validate199.errors = vErrors;
                                                                            return false;
                                                                        }
                                                                        else {
                                                                            errors = _errs36;
                                                                            if (vErrors !== null) {
                                                                                if (_errs36) {
                                                                                    vErrors.length = _errs36;
                                                                                }
                                                                                else {
                                                                                    vErrors = null;
                                                                                }
                                                                            }
                                                                        }
                                                                        var valid15 = _errs35 === errors;
                                                                        if (!valid15) {
                                                                            break;
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate199.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/rows/' + i4 + '/row',
                                                                            schemaPath: 'urn:wisepipe-common-computation:UnitTestResultRow/properties/row/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'array' },
                                                                            message: 'must be array'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid14 = _errs33 === errors;
                                                        }
                                                        else {
                                                            var valid14 = true;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate199.errors = [
                                                    {
                                                        instancePath: instancePath + '/rows/' + i4,
                                                        schemaPath: 'urn:wisepipe-common-computation:UnitTestResultRow/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid12 = _errs28 === errors;
                                        if (!valid12) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate199.errors = [
                                        {
                                            instancePath: instancePath + '/rows',
                                            schemaPath: '#/allOf/1/then/properties/rows/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid10 = _errs26 === errors;
                        }
                        else {
                            var valid10 = true;
                        }
                    }
                }
            }
            var _valid1 = _errs22 === errors;
            valid7 = _valid1;
        }
        if (!valid7) {
            const err10 = {
                instancePath,
                schemaPath: '#/allOf/1/if',
                keyword: 'if',
                params: { failingKeyword: 'then' },
                message: 'must match "then" schema'
            };
            if (vErrors === null) {
                vErrors = [err10];
            }
            else {
                vErrors.push(err10);
            }
            errors++;
            validate199.errors = vErrors;
            return false;
        }
        var valid0 = _errs15 === errors;
        if (valid0) {
            const _errs45 = errors;
            const _errs46 = errors;
            let valid18 = true;
            const _errs47 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                if (data.status !== undefined) {
                    if ('running' !== data.status) {
                        const err11 = {};
                        if (vErrors === null) {
                            vErrors = [err11];
                        }
                        else {
                            vErrors.push(err11);
                        }
                        errors++;
                    }
                }
            }
            var _valid4 = _errs47 === errors;
            errors = _errs46;
            if (vErrors !== null) {
                if (_errs46) {
                    vErrors.length = _errs46;
                }
                else {
                    vErrors = null;
                }
            }
            if (_valid4) {
                const _errs49 = errors;
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    let missing3;
                    if ((data.progress === undefined && (missing3 = 'progress')) ||
                        (data.continuationToken === undefined && (missing3 = 'continuationToken'))) {
                        validate199.errors = [
                            {
                                instancePath,
                                schemaPath: '#/allOf/2/then/required',
                                keyword: 'required',
                                params: { missingProperty: missing3 },
                                message: "must have required property '" + missing3 + "'"
                            }
                        ];
                        return false;
                    }
                    else {
                        if (data.progress !== undefined) {
                            let data17 = data.progress;
                            const _errs50 = errors;
                            if (errors === _errs50) {
                                if (typeof data17 == 'number') {
                                    if (data17 > 1 || isNaN(data17)) {
                                        validate199.errors = [
                                            {
                                                instancePath: instancePath + '/progress',
                                                schemaPath: '#/allOf/2/then/properties/progress/maximum',
                                                keyword: 'maximum',
                                                params: { comparison: '<=', limit: 1 },
                                                message: 'must be <= 1'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (data17 < 0 || isNaN(data17)) {
                                            validate199.errors = [
                                                {
                                                    instancePath: instancePath + '/progress',
                                                    schemaPath: '#/allOf/2/then/properties/progress/minimum',
                                                    keyword: 'minimum',
                                                    params: { comparison: '>=', limit: 0 },
                                                    message: 'must be >= 0'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                else {
                                    validate199.errors = [
                                        {
                                            instancePath: instancePath + '/progress',
                                            schemaPath: '#/allOf/2/then/properties/progress/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid20 = _errs50 === errors;
                        }
                        else {
                            var valid20 = true;
                        }
                        if (valid20) {
                            if (data.continuationToken !== undefined) {
                                let data18 = data.continuationToken;
                                const _errs52 = errors;
                                if (errors === _errs52) {
                                    if (typeof data18 === 'string') {
                                        const b64min0 = Math.ceil((4 * 9) / 3);
                                        const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                        if (func564(data18) < b64min0 || func564(data18) > b64max0) {
                                            validate199.errors = [
                                                {
                                                    instancePath: instancePath + '/continuationToken',
                                                    schemaPath: '#/allOf/2/then/properties/continuationToken/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func564(data18) },
                                                    message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func564(data18)
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const decoded0 = func565(data18);
                                            if (decoded0.length !== 9) {
                                                validate199.errors = [
                                                    {
                                                        instancePath: instancePath + '/continuationToken',
                                                        schemaPath: '#/allOf/2/then/properties/continuationToken/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'decoded' },
                                                        message: 'must decode to 9 bytes'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const encoded0 = func566(decoded0);
                                                if (func567(encoded0) !== func567(data18)) {
                                                    validate199.errors = [
                                                        {
                                                            instancePath: instancePath + '/continuationToken',
                                                            schemaPath: '#/allOf/2/then/properties/continuationToken/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'ambiguous' },
                                                            message: 'encoding is ambiguous'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate199.errors = [
                                            {
                                                instancePath: instancePath + '/continuationToken',
                                                schemaPath: '#/allOf/2/then/properties/continuationToken/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid20 = _errs52 === errors;
                            }
                            else {
                                var valid20 = true;
                            }
                        }
                    }
                }
                var _valid4 = _errs49 === errors;
                valid18 = _valid4;
            }
            if (!valid18) {
                const err12 = {
                    instancePath,
                    schemaPath: '#/allOf/2/if',
                    keyword: 'if',
                    params: { failingKeyword: 'then' },
                    message: 'must match "then" schema'
                };
                if (vErrors === null) {
                    vErrors = [err12];
                }
                else {
                    vErrors.push(err12);
                }
                errors++;
                validate199.errors = vErrors;
                return false;
            }
            var valid0 = _errs45 === errors;
        }
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing4;
            if ((data.unitTestID === undefined && (missing4 = 'unitTestID')) ||
                (data.status === undefined && (missing4 = 'status'))) {
                validate199.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing4 },
                        message: "must have required property '" + missing4 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.unitTestID !== undefined) {
                    let data19 = data.unitTestID;
                    const _errs54 = errors;
                    if (errors === _errs54) {
                        if (typeof data19 === 'string') {
                            const b64min1 = Math.ceil((4 * 9) / 3);
                            const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                            if (func568(data19) < b64min1 || func568(data19) > b64max1) {
                                validate199.errors = [
                                    {
                                        instancePath: instancePath + '/unitTestID',
                                        schemaPath: '#/properties/unitTestID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func568(data19) },
                                        message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func568(data19)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded1 = func569(data19);
                                if (decoded1.length !== 9) {
                                    validate199.errors = [
                                        {
                                            instancePath: instancePath + '/unitTestID',
                                            schemaPath: '#/properties/unitTestID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 9 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded1 = func570(decoded1);
                                    if (func571(encoded1) !== func571(data19)) {
                                        validate199.errors = [
                                            {
                                                instancePath: instancePath + '/unitTestID',
                                                schemaPath: '#/properties/unitTestID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate199.errors = [
                                {
                                    instancePath: instancePath + '/unitTestID',
                                    schemaPath: '#/properties/unitTestID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid22 = _errs54 === errors;
                }
                else {
                    var valid22 = true;
                }
                if (valid22) {
                    if (data.status !== undefined) {
                        let data20 = data.status;
                        const _errs56 = errors;
                        if (typeof data20 !== 'string') {
                            validate199.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data20 === 'passed' ||
                            data20 === 'failed' ||
                            data20 === 'error' ||
                            data20 === 'running' ||
                            data20 === 'noSnapshotFound')) {
                            validate199.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema213.properties.status.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid22 = _errs56 === errors;
                    }
                    else {
                        var valid22 = true;
                    }
                }
            }
        }
        else {
            validate199.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate199.errors = vErrors;
    return errors === 0;
}
export const unitTestRunResponseSchemaValidation = validate202;
const schema215 = {
    $id: 'urn:wisepipe-common-computation:UnitTestRunResponse',
    type: 'object',
    properties: {
        unitTestID: { type: 'string', uid: 9 },
        status: { type: 'string', enum: ['passed', 'failed', 'error', 'running', 'noSnapshotFound'] },
        taskID: { type: 'string', minLength: 1 },
        errorCode: {
            type: 'string',
            enum: [
                'unitTest.notFound',
                'unitTest.concurrentExecution',
                'unitTest.tooManyRows',
                'unitTest.invalidConfig',
                'unitTest.invalidPipe',
                'unitTest.dataNotFound',
                'unitTest.unknown'
            ]
        }
    },
    required: ['unitTestID', 'status'],
    allOf: [
        { if: { properties: { status: { const: 'error' } } }, then: { required: ['errorCode'] } },
        { if: { properties: { status: { const: 'running' } } }, then: { required: ['taskID'] } }
    ]
};
const func572 = ucs2length;
const func573 = base64urlToBuffer;
const func574 = base64urlEncode;
const func575 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate202(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:UnitTestRunResponse" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    const _errs2 = errors;
    let valid1 = true;
    const _errs3 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.status !== undefined) {
            if ('error' !== data.status) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs3 === errors;
    errors = _errs2;
    if (vErrors !== null) {
        if (_errs2) {
            vErrors.length = _errs2;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.errorCode === undefined && (missing0 = 'errorCode')) {
                validate202.errors = [
                    {
                        instancePath,
                        schemaPath: '#/allOf/0/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs5 === errors;
        valid1 = _valid0;
    }
    if (!valid1) {
        const err1 = {
            instancePath,
            schemaPath: '#/allOf/0/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate202.errors = vErrors;
        return false;
    }
    var valid0 = _errs1 === errors;
    if (valid0) {
        const _errs6 = errors;
        const _errs7 = errors;
        let valid3 = true;
        const _errs8 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.status !== undefined) {
                if ('running' !== data.status) {
                    const err2 = {};
                    if (vErrors === null) {
                        vErrors = [err2];
                    }
                    else {
                        vErrors.push(err2);
                    }
                    errors++;
                }
            }
        }
        var _valid1 = _errs8 === errors;
        errors = _errs7;
        if (vErrors !== null) {
            if (_errs7) {
                vErrors.length = _errs7;
            }
            else {
                vErrors = null;
            }
        }
        if (_valid1) {
            const _errs10 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing1;
                if (data.taskID === undefined && (missing1 = 'taskID')) {
                    validate202.errors = [
                        {
                            instancePath,
                            schemaPath: '#/allOf/1/then/required',
                            keyword: 'required',
                            params: { missingProperty: missing1 },
                            message: "must have required property '" + missing1 + "'"
                        }
                    ];
                    return false;
                }
            }
            var _valid1 = _errs10 === errors;
            valid3 = _valid1;
        }
        if (!valid3) {
            const err3 = {
                instancePath,
                schemaPath: '#/allOf/1/if',
                keyword: 'if',
                params: { failingKeyword: 'then' },
                message: 'must match "then" schema'
            };
            if (vErrors === null) {
                vErrors = [err3];
            }
            else {
                vErrors.push(err3);
            }
            errors++;
            validate202.errors = vErrors;
            return false;
        }
        var valid0 = _errs6 === errors;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if ((data.unitTestID === undefined && (missing2 = 'unitTestID')) ||
                (data.status === undefined && (missing2 = 'status'))) {
                validate202.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing2 },
                        message: "must have required property '" + missing2 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.unitTestID !== undefined) {
                    let data2 = data.unitTestID;
                    const _errs11 = errors;
                    if (errors === _errs11) {
                        if (typeof data2 === 'string') {
                            const b64min0 = Math.ceil((4 * 9) / 3);
                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                            if (func572(data2) < b64min0 || func572(data2) > b64max0) {
                                validate202.errors = [
                                    {
                                        instancePath: instancePath + '/unitTestID',
                                        schemaPath: '#/properties/unitTestID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func572(data2) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func572(data2)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func573(data2);
                                if (decoded0.length !== 9) {
                                    validate202.errors = [
                                        {
                                            instancePath: instancePath + '/unitTestID',
                                            schemaPath: '#/properties/unitTestID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 9 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func574(decoded0);
                                    if (func575(encoded0) !== func575(data2)) {
                                        validate202.errors = [
                                            {
                                                instancePath: instancePath + '/unitTestID',
                                                schemaPath: '#/properties/unitTestID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate202.errors = [
                                {
                                    instancePath: instancePath + '/unitTestID',
                                    schemaPath: '#/properties/unitTestID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid5 = _errs11 === errors;
                }
                else {
                    var valid5 = true;
                }
                if (valid5) {
                    if (data.status !== undefined) {
                        let data3 = data.status;
                        const _errs13 = errors;
                        if (typeof data3 !== 'string') {
                            validate202.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data3 === 'passed' ||
                            data3 === 'failed' ||
                            data3 === 'error' ||
                            data3 === 'running' ||
                            data3 === 'noSnapshotFound')) {
                            validate202.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema215.properties.status.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid5 = _errs13 === errors;
                    }
                    else {
                        var valid5 = true;
                    }
                    if (valid5) {
                        if (data.taskID !== undefined) {
                            let data4 = data.taskID;
                            const _errs15 = errors;
                            if (errors === _errs15) {
                                if (typeof data4 === 'string') {
                                    if (func2(data4) < 1) {
                                        validate202.errors = [
                                            {
                                                instancePath: instancePath + '/taskID',
                                                schemaPath: '#/properties/taskID/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate202.errors = [
                                        {
                                            instancePath: instancePath + '/taskID',
                                            schemaPath: '#/properties/taskID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid5 = _errs15 === errors;
                        }
                        else {
                            var valid5 = true;
                        }
                        if (valid5) {
                            if (data.errorCode !== undefined) {
                                let data5 = data.errorCode;
                                const _errs17 = errors;
                                if (typeof data5 !== 'string') {
                                    validate202.errors = [
                                        {
                                            instancePath: instancePath + '/errorCode',
                                            schemaPath: '#/properties/errorCode/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data5 === 'unitTest.notFound' ||
                                    data5 === 'unitTest.concurrentExecution' ||
                                    data5 === 'unitTest.tooManyRows' ||
                                    data5 === 'unitTest.invalidConfig' ||
                                    data5 === 'unitTest.invalidPipe' ||
                                    data5 === 'unitTest.dataNotFound' ||
                                    data5 === 'unitTest.unknown')) {
                                    validate202.errors = [
                                        {
                                            instancePath: instancePath + '/errorCode',
                                            schemaPath: '#/properties/errorCode/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema215.properties.errorCode.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid5 = _errs17 === errors;
                            }
                            else {
                                var valid5 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate202.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate202.errors = vErrors;
    return errors === 0;
}
export const unitTestRunSchemaValidation = validate203;
const func577 = ucs2length;
const func578 = base64urlToBuffer;
const func579 = base64urlEncode;
const func580 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate203(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:UnitTestRun" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    const _errs3 = errors;
    const _errs4 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.status !== undefined) {
            if ('running' !== data.status) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var valid1 = _errs4 === errors;
    if (valid1) {
        const err1 = {};
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    else {
        errors = _errs3;
        if (vErrors !== null) {
            if (_errs3) {
                vErrors.length = _errs3;
            }
            else {
                vErrors = null;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs6 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.lastRunBy === undefined && (missing0 = 'lastRunBy')) ||
                (data.lastRunAt === undefined && (missing0 = 'lastRunAt'))) {
                validate203.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs6 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err2 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err2];
        }
        else {
            vErrors.push(err2);
        }
        errors++;
        validate203.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.unitTestID === undefined && (missing1 = 'unitTestID')) ||
                (data.status === undefined && (missing1 = 'status'))) {
                validate203.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.unitTestID !== undefined) {
                    let data1 = data.unitTestID;
                    const _errs7 = errors;
                    if (errors === _errs7) {
                        if (typeof data1 === 'string') {
                            const b64min0 = Math.ceil((4 * 9) / 3);
                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                            if (func577(data1) < b64min0 || func577(data1) > b64max0) {
                                validate203.errors = [
                                    {
                                        instancePath: instancePath + '/unitTestID',
                                        schemaPath: '#/properties/unitTestID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func577(data1) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func577(data1)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func578(data1);
                                if (decoded0.length !== 9) {
                                    validate203.errors = [
                                        {
                                            instancePath: instancePath + '/unitTestID',
                                            schemaPath: '#/properties/unitTestID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 9 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func579(decoded0);
                                    if (func580(encoded0) !== func580(data1)) {
                                        validate203.errors = [
                                            {
                                                instancePath: instancePath + '/unitTestID',
                                                schemaPath: '#/properties/unitTestID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate203.errors = [
                                {
                                    instancePath: instancePath + '/unitTestID',
                                    schemaPath: '#/properties/unitTestID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid3 = _errs7 === errors;
                }
                else {
                    var valid3 = true;
                }
                if (valid3) {
                    if (data.status !== undefined) {
                        let data2 = data.status;
                        const _errs9 = errors;
                        if (typeof data2 !== 'string') {
                            validate203.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data2 === 'passed' ||
                            data2 === 'failed' ||
                            data2 === 'error' ||
                            data2 === 'running' ||
                            data2 === 'noSnapshotFound')) {
                            validate203.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema208.properties.status.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid3 = _errs9 === errors;
                    }
                    else {
                        var valid3 = true;
                    }
                    if (valid3) {
                        if (data.lastRunBy !== undefined) {
                            let data3 = data.lastRunBy;
                            const _errs11 = errors;
                            if (errors === _errs11) {
                                if (errors === _errs11) {
                                    if (typeof data3 === 'string') {
                                        if (!formats6.test(data3)) {
                                            validate203.errors = [
                                                {
                                                    instancePath: instancePath + '/lastRunBy',
                                                    schemaPath: '#/properties/lastRunBy/format',
                                                    keyword: 'format',
                                                    params: { format: 'uuid' },
                                                    message: 'must match format "' + 'uuid' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate203.errors = [
                                            {
                                                instancePath: instancePath + '/lastRunBy',
                                                schemaPath: '#/properties/lastRunBy/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid3 = _errs11 === errors;
                        }
                        else {
                            var valid3 = true;
                        }
                        if (valid3) {
                            if (data.lastRunAt !== undefined) {
                                let data4 = data.lastRunAt;
                                const _errs13 = errors;
                                if (errors === _errs13) {
                                    if (errors === _errs13) {
                                        if (typeof data4 === 'string') {
                                            if (!formats0.validate(data4)) {
                                                validate203.errors = [
                                                    {
                                                        instancePath: instancePath + '/lastRunAt',
                                                        schemaPath: '#/properties/lastRunAt/format',
                                                        keyword: 'format',
                                                        params: { format: 'date-time' },
                                                        message: 'must match format "' + 'date-time' + '"'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate203.errors = [
                                                {
                                                    instancePath: instancePath + '/lastRunAt',
                                                    schemaPath: '#/properties/lastRunAt/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid3 = _errs13 === errors;
                            }
                            else {
                                var valid3 = true;
                            }
                            if (valid3) {
                                if (data.taskID !== undefined) {
                                    let data5 = data.taskID;
                                    const _errs15 = errors;
                                    if (errors === _errs15) {
                                        if (typeof data5 === 'string') {
                                            if (func2(data5) < 1) {
                                                validate203.errors = [
                                                    {
                                                        instancePath: instancePath + '/taskID',
                                                        schemaPath: '#/properties/taskID/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate203.errors = [
                                                {
                                                    instancePath: instancePath + '/taskID',
                                                    schemaPath: '#/properties/taskID/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid3 = _errs15 === errors;
                                }
                                else {
                                    var valid3 = true;
                                }
                                if (valid3) {
                                    if (data.error !== undefined) {
                                        let data6 = data.error;
                                        const _errs17 = errors;
                                        if (!(data6 && typeof data6 == 'object' && !Array.isArray(data6))) {
                                            validate203.errors = [
                                                {
                                                    instancePath: instancePath + '/error',
                                                    schemaPath: '#/properties/error/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid3 = _errs17 === errors;
                                    }
                                    else {
                                        var valid3 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate203.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate203.errors = vErrors;
    return errors === 0;
}
export const unitTestSchemaValidation = validate189;
export const unitTestTaskSchemaValidation = validate188;
export const unitTestUpdateRequestSchemaValidation = validate204;
const schema217 = {
    $id: 'urn:wisepipe-common-computation:UnitTestUpdateRequest',
    type: 'object',
    properties: {
        unitTestID: { type: 'string', uid: 9 },
        name: { type: 'string', minLength: 1, maxLength: 100 },
        description: { type: 'string', minLength: 1, maxLength: 1000 },
        dataMap: { type: 'object', additionalProperties: { $ref: 'urn:wisepipe-common-pipe:UnitTestDataOverride' } },
        isAIGenerated: { type: 'boolean' }
    },
    required: ['unitTestID']
};
const func582 = ucs2length;
const func583 = base64urlToBuffer;
const func584 = base64urlEncode;
const func585 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate204(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:UnitTestUpdateRequest" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.unitTestID === undefined && (missing0 = 'unitTestID')) {
                validate204.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.unitTestID !== undefined) {
                    let data0 = data.unitTestID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 9) / 3);
                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                            if (func582(data0) < b64min0 || func582(data0) > b64max0) {
                                validate204.errors = [
                                    {
                                        instancePath: instancePath + '/unitTestID',
                                        schemaPath: '#/properties/unitTestID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func582(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func582(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func583(data0);
                                if (decoded0.length !== 9) {
                                    validate204.errors = [
                                        {
                                            instancePath: instancePath + '/unitTestID',
                                            schemaPath: '#/properties/unitTestID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 9 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func584(decoded0);
                                    if (func585(encoded0) !== func585(data0)) {
                                        validate204.errors = [
                                            {
                                                instancePath: instancePath + '/unitTestID',
                                                schemaPath: '#/properties/unitTestID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate204.errors = [
                                {
                                    instancePath: instancePath + '/unitTestID',
                                    schemaPath: '#/properties/unitTestID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.name !== undefined) {
                        let data1 = data.name;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 100) {
                                    validate204.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 100 },
                                            message: 'must NOT have more than 100 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate204.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate204.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.description !== undefined) {
                            let data2 = data.description;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) > 1000) {
                                        validate204.errors = [
                                            {
                                                instancePath: instancePath + '/description',
                                                schemaPath: '#/properties/description/maxLength',
                                                keyword: 'maxLength',
                                                params: { limit: 1000 },
                                                message: 'must NOT have more than 1000 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (func2(data2) < 1) {
                                            validate204.errors = [
                                                {
                                                    instancePath: instancePath + '/description',
                                                    schemaPath: '#/properties/description/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                else {
                                    validate204.errors = [
                                        {
                                            instancePath: instancePath + '/description',
                                            schemaPath: '#/properties/description/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.dataMap !== undefined) {
                                let data3 = data.dataMap;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                                        for (const key0 in data3) {
                                            const _errs10 = errors;
                                            if (!validate186(data3[key0], {
                                                instancePath: instancePath + '/dataMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                parentData: data3,
                                                parentDataProperty: key0,
                                                rootData
                                            })) {
                                                vErrors = vErrors === null ? validate186.errors : vErrors.concat(validate186.errors);
                                                errors = vErrors.length;
                                            }
                                            var valid2 = _errs10 === errors;
                                            if (!valid2) {
                                                break;
                                            }
                                        }
                                    }
                                    else {
                                        validate204.errors = [
                                            {
                                                instancePath: instancePath + '/dataMap',
                                                schemaPath: '#/properties/dataMap/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.isAIGenerated !== undefined) {
                                    const _errs11 = errors;
                                    if (typeof data.isAIGenerated !== 'boolean') {
                                        validate204.errors = [
                                            {
                                                instancePath: instancePath + '/isAIGenerated',
                                                schemaPath: '#/properties/isAIGenerated/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs11 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate204.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate204.errors = vErrors;
    return errors === 0;
}
export const valueCountPairSchemaValidation = validate206;
function validate206(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:ValueCountPair" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.value === undefined && (missing0 = 'value')) || (data.count === undefined && (missing0 = 'count'))) {
                validate206.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.value !== undefined) {
                    let data0 = data.value;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    let valid1 = false;
                    let passing0 = null;
                    const _errs3 = errors;
                    if (typeof data0 !== 'string') {
                        const err0 = {
                            instancePath: instancePath + '/value',
                            schemaPath: '#/properties/value/oneOf/0/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string'
                        };
                        if (vErrors === null) {
                            vErrors = [err0];
                        }
                        else {
                            vErrors.push(err0);
                        }
                        errors++;
                    }
                    var _valid0 = _errs3 === errors;
                    if (_valid0) {
                        valid1 = true;
                        passing0 = 0;
                    }
                    const _errs5 = errors;
                    if (typeof data0 !== 'boolean') {
                        const err1 = {
                            instancePath: instancePath + '/value',
                            schemaPath: '#/properties/value/oneOf/1/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean'
                        };
                        if (vErrors === null) {
                            vErrors = [err1];
                        }
                        else {
                            vErrors.push(err1);
                        }
                        errors++;
                    }
                    var _valid0 = _errs5 === errors;
                    if (_valid0 && valid1) {
                        valid1 = false;
                        passing0 = [passing0, 1];
                    }
                    else {
                        if (_valid0) {
                            valid1 = true;
                            passing0 = 1;
                        }
                    }
                    if (!valid1) {
                        const err2 = {
                            instancePath: instancePath + '/value',
                            schemaPath: '#/properties/value/oneOf',
                            keyword: 'oneOf',
                            params: { passingSchemas: passing0 },
                            message: 'must match exactly one schema in oneOf'
                        };
                        if (vErrors === null) {
                            vErrors = [err2];
                        }
                        else {
                            vErrors.push(err2);
                        }
                        errors++;
                        validate206.errors = vErrors;
                        return false;
                    }
                    else {
                        errors = _errs2;
                        if (vErrors !== null) {
                            if (_errs2) {
                                vErrors.length = _errs2;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.count !== undefined) {
                        const _errs7 = errors;
                        if (!(typeof data.count == 'number')) {
                            validate206.errors = [
                                {
                                    instancePath: instancePath + '/count',
                                    schemaPath: '#/properties/count/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs7 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate206.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate206.errors = vErrors;
    return errors === 0;
}
export const visualColumnSchemaValidation = validate207;
const schema219 = {
    $id: 'urn:wisepipe-common-computation:VisualColumn',
    type: 'object',
    properties: {
        source: { type: 'string', minLength: 1 },
        alias: { type: 'string', minLength: 1 },
        aggOp: {
            type: 'string',
            enum: ['MAX', 'MIN', 'COUNT', 'SUM', 'AVG', 'OR', 'AND', 'MEDIAN', 'DIFF', 'PCT', 'SHIFT', 'STDEV']
        },
        decimals: { type: 'number', minimum: 0, maximum: 14 },
        numBins: { type: 'number', maximum: 100 }
    },
    required: ['source', 'alias']
};
function validate207(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-computation:VisualColumn" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.source === undefined && (missing0 = 'source')) || (data.alias === undefined && (missing0 = 'alias'))) {
                validate207.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.source !== undefined) {
                    let data0 = data.source;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate207.errors = [
                                    {
                                        instancePath: instancePath + '/source',
                                        schemaPath: '#/properties/source/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate207.errors = [
                                {
                                    instancePath: instancePath + '/source',
                                    schemaPath: '#/properties/source/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.alias !== undefined) {
                        let data1 = data.alias;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate207.errors = [
                                        {
                                            instancePath: instancePath + '/alias',
                                            schemaPath: '#/properties/alias/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate207.errors = [
                                    {
                                        instancePath: instancePath + '/alias',
                                        schemaPath: '#/properties/alias/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.aggOp !== undefined) {
                            let data2 = data.aggOp;
                            const _errs5 = errors;
                            if (typeof data2 !== 'string') {
                                validate207.errors = [
                                    {
                                        instancePath: instancePath + '/aggOp',
                                        schemaPath: '#/properties/aggOp/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data2 === 'MAX' ||
                                data2 === 'MIN' ||
                                data2 === 'COUNT' ||
                                data2 === 'SUM' ||
                                data2 === 'AVG' ||
                                data2 === 'OR' ||
                                data2 === 'AND' ||
                                data2 === 'MEDIAN' ||
                                data2 === 'DIFF' ||
                                data2 === 'PCT' ||
                                data2 === 'SHIFT' ||
                                data2 === 'STDEV')) {
                                validate207.errors = [
                                    {
                                        instancePath: instancePath + '/aggOp',
                                        schemaPath: '#/properties/aggOp/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema219.properties.aggOp.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.decimals !== undefined) {
                                let data3 = data.decimals;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 == 'number') {
                                        if (data3 > 14 || isNaN(data3)) {
                                            validate207.errors = [
                                                {
                                                    instancePath: instancePath + '/decimals',
                                                    schemaPath: '#/properties/decimals/maximum',
                                                    keyword: 'maximum',
                                                    params: { comparison: '<=', limit: 14 },
                                                    message: 'must be <= 14'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (data3 < 0 || isNaN(data3)) {
                                                validate207.errors = [
                                                    {
                                                        instancePath: instancePath + '/decimals',
                                                        schemaPath: '#/properties/decimals/minimum',
                                                        keyword: 'minimum',
                                                        params: { comparison: '>=', limit: 0 },
                                                        message: 'must be >= 0'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    else {
                                        validate207.errors = [
                                            {
                                                instancePath: instancePath + '/decimals',
                                                schemaPath: '#/properties/decimals/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.numBins !== undefined) {
                                    let data4 = data.numBins;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (typeof data4 == 'number') {
                                            if (data4 > 100 || isNaN(data4)) {
                                                validate207.errors = [
                                                    {
                                                        instancePath: instancePath + '/numBins',
                                                        schemaPath: '#/properties/numBins/maximum',
                                                        keyword: 'maximum',
                                                        params: { comparison: '<=', limit: 100 },
                                                        message: 'must be <= 100'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate207.errors = [
                                                {
                                                    instancePath: instancePath + '/numBins',
                                                    schemaPath: '#/properties/numBins/type',
                                                    keyword: 'type',
                                                    params: { type: 'number' },
                                                    message: 'must be number'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate207.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate207.errors = vErrors;
    return errors === 0;
}
export const visualParamsSchemaValidation = validate162;
//# sourceMappingURL=validations.generated.js.map